angular.module('c', [
    'ui.router',
    'ui.mask',

    'elif',

    // 'angular-loading-bar',
    //'ui.select',
    'ngSanitize',
    'ngTable',
    'ngLocale',
    'toaster',
    'dialogs.main',
    'pascalprecht.translate',
    'dialogs.default-translations',

    'sticky',

    //'ui.tree',
    'ui.slimscroll',
    'ui.checkbox',
    'ngAnimate',
    'rzModule',
    'angular-clipboard',
    'angularPromiseButtons',

    'monospaced.qrcode',
    'angular-click-outside',
    'monospaced.elastic',
    'mgo-angular-wizard',

    'ui.bootstrap',
    /*'ui.bootstrap.datetimepicker',*/
    'mwl.calendar',
    'toggle-switch',
    'FBAngular',
    'ngFileUpload',
    'btford.socket-io',
    'angularMoment',

    //'angular-img-cropper',
    'ipCookie',
    'colorpicker.module',

    'dndLists',
    'oc.lazyLoad',

    'ng.deviceDetector',
    'ckeditor',
    'uiCropper',

    'c.d',
    'c.c',
    'c.s'
    //'ui.utils',
]);

angular.module('c.d', []);

angular.module('c.c', []);

angular.module('c.s', ['ngResource', 'ngStorage', 'fileSaver']);


angular.module("ngLocale", [], ["$provide", function ($provide) {
    var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
    $provide.value("$locale", {
        "DATETIME_FORMATS": {
            "AMPMS": [
                "\u4e0a\u5348",
                "\u4e0b\u5348"
            ],
            "DAY": [
                "\u661f\u671f\u65e5",
                "\u661f\u671f\u4e00",
                "\u661f\u671f\u4e8c",
                "\u661f\u671f\u4e09",
                "\u661f\u671f\u56db",
                "\u661f\u671f\u4e94",
                "\u661f\u671f\u516d"
            ],
            "ERANAMES": [
                "\u516c\u5143\u524d",
                "\u516c\u5143"
            ],
            "ERAS": [
                "\u516c\u5143\u524d",
                "\u516c\u5143"
            ],
            "FIRSTDAYOFWEEK": 6,
            "MONTH": [
                "\u4e00\u6708",
                "\u4e8c\u6708",
                "\u4e09\u6708",
                "\u56db\u6708",
                "\u4e94\u6708",
                "\u516d\u6708",
                "\u4e03\u6708",
                "\u516b\u6708",
                "\u4e5d\u6708",
                "\u5341\u6708",
                "\u5341\u4e00\u6708",
                "\u5341\u4e8c\u6708"
            ],
            "SHORTDAY": [
                "\u5468\u65e5",
                "\u5468\u4e00",
                "\u5468\u4e8c",
                "\u5468\u4e09",
                "\u5468\u56db",
                "\u5468\u4e94",
                "\u5468\u516d"
            ],
            "SHORTMONTH": [
                "1\u6708",
                "2\u6708",
                "3\u6708",
                "4\u6708",
                "5\u6708",
                "6\u6708",
                "7\u6708",
                "8\u6708",
                "9\u6708",
                "10\u6708",
                "11\u6708",
                "12\u6708"
            ],
            "WEEKENDRANGE": [
                5,
                6
            ],
            "fullDate": "y\u5e74M\u6708d\u65e5EEEE",
            "longDate": "y\u5e74M\u6708d\u65e5",
            "medium": "y\u5e74M\u6708d\u65e5 ah:mm:ss",
            "mediumDate": "y\u5e74M\u6708d\u65e5",
            "mediumTime": "ah:mm:ss",
            "short": "yy/M/d ah:mm",
            "shortDate": "yy/M/d",
            "shortTime": "ah:mm"
        },
        "NUMBER_FORMATS": {
            "CURRENCY_SYM": "\u00a5",
            "DECIMAL_SEP": ".",
            "GROUP_SEP": ",",
            "PATTERNS": [
                {
                    "gSize": 3,
                    "lgSize": 3,
                    "maxFrac": 3,
                    "minFrac": 0,
                    "minInt": 1,
                    "negPre": "-",
                    "negSuf": "",
                    "posPre": "",
                    "posSuf": ""
                },
                {
                    "gSize": 3,
                    "lgSize": 3,
                    "maxFrac": 2,
                    "minFrac": 2,
                    "minInt": 1,
                    "negPre": "\u00a4\u00a0-",
                    "negSuf": "",
                    "posPre": "\u00a4\u00a0",
                    "posSuf": ""
                }
            ]
        },
        "id": "zh-cn",
        "pluralCat": function (n, opt_precision) {
            return PLURAL_CATEGORY.OTHER;
        }
    });
}]);
// moment.js locale configuration
// locale : chinese (zh-cn)
// author : suupic : https://github.com/suupic
// author : Zeno Zeng : https://github.com/zenozeng

(function (factory) {
    if (typeof define === 'function' && define.amd) {
        define(['moment'], factory); // AMD
    } else if (typeof exports === 'object') {
        module.exports = factory(require('../moment')); // Node
    } else {
        factory((typeof global !== 'undefined' ? global : this).moment); // node or other global
    }
}(function (moment) {
    return moment.defineLocale('zh-cn', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'Ah点mm',
            LTS : 'Ah点m分s秒',
            L : 'YYYY-MM-DD',
            LL : 'YYYY年MMMD日',
            LLL : 'YYYY年MMMD日LT',
            LLLL : 'YYYY年MMMD日ddddLT',
            l : 'YYYY-MM-DD',
            ll : 'YYYY年MMMD日',
            lll : 'YYYY年MMMD日LT',
            llll : 'YYYY年MMMD日ddddLT'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' ||
                    meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : function () {
                return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
            },
            nextDay : function () {
                return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
            },
            lastDay : function () {
                return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
            },
            nextWeek : function () {
                var startOfWeek, prefix;
                startOfWeek = moment().startOf('week');
                prefix = this.unix() - startOfWeek.unix() >= 7 * 24 * 3600 ? '[下]' : '[本]';
                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
            },
            lastWeek : function () {
                var startOfWeek, prefix;
                startOfWeek = moment().startOf('week');
                prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
            },
            sameElse : 'LL'
        },
        ordinalParse: /\d{1,2}(日|月|周)/,
        ordinal : function (number, period) {
            switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            case 'M':
                return number + '月';
            case 'w':
            case 'W':
                return number + '周';
            default:
                return number;
            }
        },
        relativeTime : {
            future : '%s内',
            past : '%s前',
            s : '几秒',
            m : '1分钟',
            mm : '%d分钟',
            h : '1小时',
            hh : '%d小时',
            d : '1天',
            dd : '%d天',
            M : '1个月',
            MM : '%d个月',
            y : '1年',
            yy : '%d年'
        },
        week : {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));

(function () {
    'use strict';

    angular.module('c').config(config);

    /** @ngInject */
    function config(calendarConfig) {
        calendarConfig.dateFormatter = 'moment'; //use either moment or angular to format dates on the calendar. Default angular. Setting this will override any date formats you have already set.

        calendarConfig.allDateFormats.moment.date.hour = 'HH:mm'; //this will configure times on the day view to display in 24 hour format rather than the default of 12 hour
        calendarConfig.allDateFormats.moment.date.datetime = 'MMM D日, h:mm a'; //this will configure times on the day view to display in 24 hour format rather than the default of 12 hour

        calendarConfig.allDateFormats.moment.title.week = '{year}年 {week}周'; //this will configure the day view title to be shorter
        calendarConfig.allDateFormats.moment.title.day = 'dddd MMMM D号'; //this will configure the day view title to be shorter
        calendarConfig.allDateFormats.moment.title.month = 'YYYY年 MMMM'; //this will configure the day view title to be shorter
        calendarConfig.allDateFormats.moment.title.year = 'YYYY年'; //this will configure the day view title to be shorter

        calendarConfig.showTimesOnWeekView = false;

        calendarConfig.i18nStrings.weekNumber = '{week}周'; //This will set the week number hover label on the month view

    }

})();

(function () {
    'use strict';

    angular.module('c').config(dialogConfig);

    /** @ngInject */
    function dialogConfig(dialogsProvider, $translateProvider) {
        dialogsProvider.useBackdrop('static');
        dialogsProvider.useEscClose(true);
        dialogsProvider.useCopy(false);
        dialogsProvider.setSize('sm');
        dialogsProvider.useAnimation();

        $translateProvider.preferredLanguage('zh-CN');
    }

})();

(function () {
    'use strict';

    angular.module('c').config(lazyLoadConfig);

    /** @ngInject */
    function lazyLoadConfig($ocLazyLoadProvider) {
        var l = '/ocLazyLoad/';
        var m = [
            //0               1       2        3          4         5        6
            'ngHandsontable', 'pdf', 'video', 'uiSelect', 'qrCode', 'chart', 'lunarCalendar'
        ];
        $ocLazyLoadProvider.config({
            modules: [
                {
                    name: m[0],
                    files: [
                        l + m[0] + '/handsontable.full.min.js',
                        l + m[0] + '/handsontable.full.min.css',
                        l + m[0] + '/ngHandsontable.min.js'
                    ],
                    serie: true
                },
                {
                    name: m[1],
                    files: [
                        // l + m[1] + '/compatibility.js',
                        // l + m[1] + '/pdf.js',
                        // l + m[1] + '/angular-pdf.min.js'
                        l + m[1] + '/pdf.sandbox.js',
                        l + m[1] + '/pdf.worker.js',
                        l + m[1] + '/pdf.js',
                        l + m[1] + '/angular-pdf.min.js'
                    ],
                    serie: true
                },
                {
                    name: m[2],
                    files: [
                        l + m[2] + '/vg-overlay-play.min.js',
                        l + m[2] + '/vg-controls.min.js',
                        l + m[2] + '/vg-buffering.min.js',
                        l + m[2] + '/videogular.min.js'
                    ],
                    serie: true
                },
                {
                    name: m[3],
                    files: [
                        l + m[3] + '/select.min.css',
                        l + m[3] + '/select.min.js'
                    ],
                    serie: true
                },
                {
                    name: m[4],
                    files: [
                        l + m[4] + '/qrCode.min.js',
                        l + m[4] + '/angular-qrcode.min.js'
                    ],
                    serie: true
                },
                {
                    name: m[5],
                    files: [
                        l + m[5] + '/chart.min.js',
                        l + m[5] + '/chartjs-plugin-piechart-outlabels.min.js',
                        l + m[5] + '/angular-chart.min.js'
                    ],
                    serie: true
                },
                {
                    name: m[6],
                    files: [
                        l + m[6] + '/lunarCalendar.min.js',
                    ],
                    serie: true
                }
            ]
        });
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .config(otherCfg)
        .run(otherRunner);
    /** @ngInject */
    function otherCfg($provide, $httpProvider, $compileProvider, $localStorageProvider) {
        // Improving Angular performance with 1 line of code
        // https://blog.upstate.agency/improving-angular-performance-with-1-line-of-code-a1fb814a6476
        $compileProvider.debugInfoEnabled(false);

        $provide.constant('$compileProvider', $compileProvider);

        $httpProvider.useApplyAsync(true);

        $localStorageProvider.setKeyPrefix('sjoa');
    }

    /** @ngInject */
    function otherRunner($anchorScroll, amMoment) {
        $anchorScroll.yOffset = 128;
        amMoment.changeLocale('zh-cn');
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .config(['$urlRouterProvider', modWhenRouter])
        .config(['$stateProvider', '$urlRouterProvider', '$httpProvider', MainRouter])
        .run(stateChangeCfg);


    /**
     * ui-router bug
     * http://stackoverflow.com/questions/23658846/angular-ui-router-urlrouterprovider-when-not-working-anymore
     */
    function modWhenRouter($urlRouterProvider) {
        //$urlRouterProvider.when('/app/pc/stock', '/app/pc/stock/rooms');
        //$urlRouterProvider.when('/app/pc/remind', '/app/pc/remind/rooms');
    }

    function MainRouter($stateProvider, $urlRouterProvider, $httpProvider) {
        $urlRouterProvider.deferIntercept();

        $urlRouterProvider.otherwise('/app/home');

        $stateProvider
            //主页
            .state('app', {
                url: '/app',
                templateUrl: 'templates/cache/main.html',
                resolve: {
                    window: ['$window', function ($window) {
                        return $window;
                    }],
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['uiSelect']);
                    }]
                },
                controller: 'MainCtrl',
                //目前能实现注销后路由状态重载的办法，但会引起页面刷新（bad!）
                //2016-7-15,以上方法在手机浏览器和苹果浏览器上会引起注销异常，现在弃用
                //关注：https://github.com/angular-ui/ui-router/issues/1095
                onExit: function (window) {
                    "ngInject";
                    //window.location.reload();
                },
                data: {
                    requireLogin: true
                }
            })
            .state('app.home', {
                url: '/home?pendingDlgOpen',
                templateUrl: 'templates/cache/home.html',
                controller: 'HomeCtrl',
                controllerAs: 'home'
            })
            //登录
            .state('login', {
                templateUrl: 'pages/login.html',
                url: '/login?registerDlgOpen',
                params: {data: {}},
                controller: 'LoginCtrl',
                data: {
                    requireLogin: false
                }
            })
            .state('blank', {
                templateUrl: 'pages/blank.html',
                url: '/blank',
                data: {
                    requireLogin: false
                },
                //仍然保留此页面的目的是论坛注销时会重定向到这里，为了实现论坛和主站的同步注销
                onEnter: function ($timeout, Auth) {
                    "ngInject";
                    $timeout(function () {
                        Auth.deleteToken();
                        var url = "http://" + window.location.host + "/#/login";
                        window.location.href = url;
                    }, 360);
                }
            })
            .state('temp', {
                templateUrl: 'pages/blank.html',
                url: '/blank',
                data: {requireLogin: false}
            })
            .state('get_wechat_token', {
                url: "/get_wechat_token?code",
                controller: "WechatAuthCtrl",
                data: {requireLogin: false}
            })
            .state('hga_index', {
                templateUrl: 'pages/hgaIndex.html',
                url: '/hga_index?code',
                controller: 'HgaIndexCtrl',
                data: {
                    requireLogin: false
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load('/ocLazyLoad/mod/hga.js');
                    }]
                }
            })
            .state('swimming_businness', {
                templateUrl: 'pages/swimmingFitness/businessManage.html',
                url: '/swimming_businness',
                controller: 'SwimmingFitnessBusinessCtrl',
                data: {
                    requireLogin: true
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load('/ocLazyLoad/mod/swimmingFitness.js');
                    }]
                }
            })
            .state('outside_questionnaire_survey', {
                url: '/outside_questionnaire_survey?nickname&openId&surveyId',
                templateUrl: ' pages/dlg/q/outsideQuestionnaireSurvey.html',
                controller: "OutsideQuestionnaireSurveyCtrl",
                controllerAs: "vm",
                data: {
                    requireLogin: false
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['/ocLazyLoad/mod/q.js', '/ocLazyLoad/mod/q.css']);
                    }]
                }
            });
        ;

        angular.forEach(previewRoutes, function (b) {
            var pa = {
                templateUrl: "/pages/preview/" + b[1],
                url: "/" + b[2],
                data: {
                    requireLogin: true
                }
            };
            $stateProvider.state(b[0], pa);
        });

        angular.forEach(routes, function (r) {
            var pa = {
                url: "/" + r[1] + '?tab&wxnpId&wxnpType',
                reloadOnSearch: false,
                controller: r[3],
                params: {data: {}},
                perm: r[4],
                onExit: function () {
                    for (var i in CKEDITOR.instances) {
                        var editor = CKEDITOR.instances[i];
                        if (editor) editor.destroy();
                    }
                }
            };
            if (r[2].charAt(0) == '<') {
                pa.template = '<ui-view></ui-view>';
            } else {
                pa.templateUrl = "pages/" + r[2];
            }
            if (r[5]) {
                pa.resolve = {
                    loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load(r[5]);
                    }]
                };
            }
            if (r[6]) {
                angular.forEach(r[6], function (c) {
                    $stateProvider.state("app." + r[0] + "." + c[0], {
                        url: "/" + c[1],
                        templateUrl: "pages/" + c[2]
                    });
                });
            }
            $stateProvider.state("app." + r[0], pa);
        });

        $httpProvider.interceptors.push(apiInterceptorFn);

    }

    var pendingRequests = [];
    var previousState, previousToParams;

    /** @ngInject */
    function apiInterceptorFn($timeout, $q, $injector, $window, Auth, WxHelper) {
        var $state;
        var dialogs;
        var $http;
        var CODE = Auth.CODE;
        $timeout(function () {
            $state = $injector.get('$state');
            dialogs = $injector.get('dialogs');
            $http = $injector.get('$http');
        });

        return {
            'request': function (config) {
                config.headers = config.headers || {};
                if (Auth.hasToken()) {
                    config.headers.Authorization = 'Bearer ' + Auth.getToken();
                }
                return config;
            },
            'responseError': function (response) {
                if (response.status === 401) {
                    var code = getCode(response.data);
                    if (code === CODE.TOKEN_DEAD || code === CODE.INVALID) {
                        logout(code === CODE.TOKEN_DEAD);
                    }
                    if (code !== CODE.TOKEN_EXPIRED) return $q.reject(response);

                    if (pendingRequests.length === 0) {
                        $timeout(function () {
                            Auth.refreshToken().then(function (resp) {
                                var token = resp.data;
                                Auth.setToken(token);
                                var newAuth = 'Bearer ' + Auth.getToken();
                                angular.forEach(pendingRequests, function (req) {
                                    req.config.headers.Authorization = newAuth;
                                    req.resolve($http(req.config));
                                });
                            }, function (err) {
                                angular.forEach(pendingRequests, function (req) {
                                    req.reject();
                                });
                                logout(err.data.code === CODE.TOKEN_DEAD);
                            }).finally(function () {
                                pendingRequests = [];
                            });
                        }, 1000);
                    }

                    return $q(function (resolve, reject) {
                        pendingRequests.push({config: response.config, resolve: resolve, reject: reject})
                    });

                }
                return $q.reject(response);
            }
        };

        function logout(tokenDead) {
            if (Auth.hasToken()) {
                Auth.deleteToken();
                if (tokenDead) {
                    var isWx = WxHelper.isWechatBrowser();
                    dialogs.notify('信标已过期', '安全信标已过期，' +
                        (isWx ? '系统将通过微信绑定账号重新登录.' : '您需要重新登录！'))
                        .result.then(function () {
                        if (isWx) {
                            var toUrl;
                            if (previousState) { //
                                toUrl = WxHelper.getWechatAuthorizeUrl(previousState, previousToParams);
                            } else {
                                toUrl = WxHelper.getWechatAuthorizeUrl();
                            }
                            $window.location.href = toUrl;  // 获取微信认证地址
                        } else {
                            $state.go('login');
                        }
                    });
                } else {
                    $state.go('login');
                }
            }
        }

        function getCode(body) {
            // 针对文件上传时，响应数据类型为ArrayBuffer的情况
            if (body instanceof ArrayBuffer) {
                var str = String.fromCharCode.apply(null, new Uint8Array(body));
                body = JSON.parse(str)
            }
            return parseInt(body.code)
        }
    }

    /** @ngInject */
    function stateChangeCfg($rootScope, $state, $window, $uibModalStack, WxHelper, $urlRouter, Auth, Dlg, Sidebar) {
        // $urlRouter sync() 貌似只能用在 $locationChangeSuccess 事件
        $rootScope.$on('$stateChangeStart', changeStart);
        $rootScope.$on('$stateChangeSuccess', changeSuccess);

        $urlRouter.listen();

        function changeStart(event, toState, toParams) {
            var requireLogin = toState.data.requireLogin;
            var isLoggedIn = Auth.hasToken();

            previousState = toState;
            previousToParams = toParams;
            if (!requireLogin) { // 无需登录，则直接访问该路由
                // alert('无需登录，则直接访问该路由');
                return;
            }

            if (!isLoggedIn) {  // 未登录，则尝试利用微信登录或跳到登录页面
                event.preventDefault();
                if (WxHelper.isWechatBrowser()) {  // 尝试通过微信认证方式登录
                    // alert('未登录，尝试通过微信');
                    $window.location.href = WxHelper.getWechatAuthorizeUrl(toState, toParams);
                } else {
                    // alert('未登录，跳到login');
                    $state.go('login');
                }
                return;
            }

            // 还未获取用户菜单项表示的权限列表，则尝试获取
            if (!Sidebar.hasMenuItems()) {
                event.preventDefault();
                // alert('还未获取用户菜单项表示的权限列表，则尝试获取, toState: ' + toState.name);
                Sidebar.getMenuItems(function () {
                    $state.go(toState, toParams)
                });
                return;
            }

            // alert('检查是否拥有对应权限, toState: ' + toState.name);
            if (toState.can === false) {
                event.preventDefault();
                Dlg.notify("您没有访问该页面的权限，请求被中止了").then(function () {
                    $state.go('login');
                });
            }
        }

        function changeSuccess(event, state) {
            // previousState = null;
            // previousToParams = null;

            if (state.name) {
                $uibModalStack.dismissAll();
                if (window.innerWidth < 768) Sidebar.updateState(Sidebar.STATE.HIDDEN);
                window.scrollTo(0, 0);

                var index = $state.current.index;
                if (angular.isDefined(index)) $rootScope.collapseVar = index;
            }
        }
    }

    var previewRoutes = [
        ["email", "email.html", "emails/:id"],
        ["article", "article.html", "articles/:type/:id"],
        ["meeting", "meeting.html", "meetings/:id"],
        ["mission", "mission.html", "missions/:id"],
        ["report", "report.html", "reports/:id"],
        ["covid", "covid.html", "covids/:id"]
    ];

    var routes = [
        ["user_profile", "user/profile", "user/profile.html", "ProfileCtrl", 1000],
        ["coop_email", "coop/email", "user/email.html", null, 1021],
        ["coop_bulletin", "coop/bulletin", "user/bulletin.html", null, 1022],
        ["coop_news", "coop/news", "user/news.html", null, 1023],
        ["coop_file_cabinet", "coop/file_cabinet", "user/file_cabinet.html", null, 1024],
        ["coop_meeting", "coop/meeting", "user/meeting.html", "UserMeetingCtrl", 1025],
        ["coop_covid", "coop/covid", "coop/covid.html", null, 1026],
        ["user_dept_record", "user/dept_record", "user/dept_record.html", "DeptRecordCtrl", 1001],
        ["coop_party_special", "coop/party_special", "coop/party_special.html", null, 1005],
        ["user_car_apply", "user/car_apply", "user/carApply.html", null, 1008],

        ['user_car_cost', 'user/car_cost', 'user/carCost.html', null, 10029],
        ['user_car_illegal', 'user/car_illegal', 'user/carIllegal.html', null, 10030],
        ["user_duty", "user/duty", "user/duty.html", null, 1003],
        // ["clinc_search", "user/clinc_search", "user/clinc_search.html", null, 1005],
        ["user_ss", "user/ss", "user/ss.html", null, 1009],
        ["user_contact_group", "user/contact_group", "user/contact_group.html", "ContactGroupCtrl", 1006],
        ["user_contacts", "user/contacts", "user/contacts.html", null, 1007],
        ["user_edu", "user/edu", "user/edu.html", null, 1011, ['pdf', 'video']],
        ["user_practice", "user/practice", "user/practice.html", "PracticeWorkController", 1012],
        ["user_my_checkup", "user/my_checkup", "user/my_checkup.html", null, 1013],
        ["user_help", "user/help", "user/help.html", "UserHelpCtrl", 1020],

        ["know_map", "know/map", "know/map.html", null, 701],
        // ["know_phone", "know/phone", "know/phone.html", null, 702],
        ["know_user_info", "know/user_info", "know/userInfo.html", null, 703],
        ["know_work", "know/work", "know/work.html", null, 704],
        // ["know_common_phone", "know/common_phone", "know/commonPhone.html", null, 705],
        ["know_park", "know/park", "know/park.html", null, 706],

        ["coop_sms", "coop/sms", "user/sms.html", "SmsCtrl", 10002],
        ["coop_op_notice", "coop/op_notice", "user/op_notice.html", "UserOPNoticeCtrl", 10007],
        ["coop_doc", "coop/doc", "coop/doc.html", null, 10009],
        ["coop_leave", "coop/leave", "coop/leave.html", null, 1002],
        // ["coop_meeting_topic", "coop/meeting_topic", "user/meeting_topic.html", "MeetingTopicCtrl", 10010],
        ["coop_q", "coop/q", "user/q.html", null, 10011],
        ["coop_file", "coop/file", "user/fileCirculate.html", null, 10012],
        ["coop_rule", "coop/rule", "coop/rule.html", null, 10013, ['pdf']],
        ["coop_law", "coop/law", "user/law.html", null, 10023, ['pdf']],
        ["coop_mission", "coop/mission", "coop/mission.html", null, 10014],
        // ["user_wage", "user/wage", "user/wage.html", "UserWageCtrl", 10015, ["ngHandsontable"]],
        // ["user_meal", "user/meal", "user/meal.html", "UserMealCtrl", 10016],
        ["coop_contract", "coop/contract", "user/contract.html", null, 10017, ['pdf']],
        // ["coop_clinc", "coop/clinc", "user/clinc.html", null, 10018],
        ["coop_qualification", "coop/qualification", "user/qualification.html", null, 10019],
        ["coop_authorization", "coop/authorization", "user/authorization.html", null, 10024],
        ["coop_hga", "coop/hga", "user/hga.html", null, 10027],
        ["coop_data_collection", "coop/data_collection", "coop/data_collection.html", null, 10028],
        ["coop_meeting_statistics", "coop/meeting_statistics", "hospital_office/msManage.html", null, 10031],
        ["coop_attendance_report", "coop/attendance_report", "coop/attendanceReport.html", null, 10032],
        ["coop_data_service", "coop/data_service", "user/dataService.html", "DataServiceCtrl", 10033],
        ["coop_equipment_application", "coop/equipment_application", "coop/equipment_application.html", null, 10034],

        // ["coop_adverse", "coop/adverse", "coop/adverse.html", null, 10026, ['chart']],
        // ["coop_party_fee", "coop/party_fee", "coop/party_fee.html", null, 10027],

        ["coop_leave_dept_query", "coop/leave_dept_query", "coop/leaveDeptQuery.html", null, 10021],
        ["coop_leave_query", "coop/leave_query", "coop/leaveQuery.html", null, 10020],

        ["query_equipment_doc", "query/equipment_doc", "query/equipmentDoc.html", null, 10022, ['pdf']],
        ["coop_ap_search", "coop/aq_search", "user/aq_search.html", null, 10025],
        ["coop_energy", "coop/energy", "coop/energy.html", null, 10026],

        //游泳健身
        ["swimming_fitness_sys_manage", "swimming_fitness/sys_manage", "swimmingFitness/sysManage.html", null, 12002],

        //资产管理
        // ["asset_scrap", "asset/scrap", "asset/scrap.html", null, 13001],
        ["asset_basic", "asset/basic", "asset/basic.html", null, 13002],

        // ["coop_material", "coop/material", "user/material.html", "UserMaterialCtrl", 10006],
        // ["coop_consumable", "coop/consumable", "user/consumable.html", null, 10020],
        // ["coop_consumable_apply", "coop/consumable_apply", "user/consumable_apply.html", null, 16001],
        // ["coop_patrol_record", "coop/patrol_record", "user/patrol_record.html", null, 16002],
        // ["coop_room_repair", "coop/room_repair", "user/room_repair.html", null, 16003],
        // ["coop_equipment_apply", "coop/equipment_apply", "user/equipment_apply.html", null, 16004],
        // ["coop_equipment_repair", "coop/equipment_repair", "user/equipment_repair.html", null, 16005, ['video']],

        ["duty_scheduler", "duty/scheduler", "duty/scheduler.html", null, 5005],
        ["duty_shift", "duty/shift", "duty/shift.html", null, 5006],
        ["duty_group_member", "duty/group_member", "duty/group_member.html", null, 5007],
        ["duty_fee_declare", "duty/fee_declare", "duty/fee_declare.html", null, 5008],

        // ["dept_leave", "dept_leader/leave", "dept_leader/leave.html", null, 3000],
        ["dept_attendance_report", "dept_leader/attendance_report", "dept_leader/attendanceReport.html", null, 3019],
        ["dept_doc", "dept_leader/doc", "dept_leader/doc.html", null, 3030],
        // ["dept_meeting_topic", "dept_leader/meeting_topic", "dept_leader/meeting_topic.html", "DeptMeetingTopicCtrl", 3005],
        ["dept_car", "dept_leader/car", "dept_leader/car.html", null, 30104],
        ["dept_ss", "dept_leader/ss", "dept_leader/ss.html", null, 3007],
        // ["dept_attendance", "dept_leader/attendance", "dept_leader/attendance.html", "DeptAttendanceCtrl", 3002],
        ["dept_phones", "dept_leader/phones", "dept_leader/phones.html", "DeptPhonesCtrl", 3010],
        ["dept_member", "dept_leader/members", "dept_leader/members.html", null, 3020],
        ["dept_agent", "dept_leader/agent", "dept_leader/agent.html", null, 3021],
        ["dept_file", "dept_leader/dept_file", "dept_leader/dept_file.html", null, 3012],
        // ["dept_wage", "dept_leader/dept_wage", "dept_leader/dept_wage.html", "DeptWageCtrl", 3003, ["ngHandsontable"]],
        ["dept_rule", "dept_leader/rule", "dept_leader/rule.html", null, 3008, ['pdf']],
        ["dept_edu", "dept_leader/edu", "dept_leader/edu.html", null, 3011, ['pdf', 'video']],
        ["dept_mission", "dept_leader/mission", "dept_leader/mission.html", null, 3013],
        ["dept_practice", "dept_leader/practice", "dept_leader/practice.html", "DeptPracticeCtrl", 3014],
        ["dept_round", "dept_leader/round", "dept_leader/round.html", null, 3015],
        ["dept_data_collection", "dept_leader/data_collection", "dept_leader/data_collection.html", null, 3016],
        ["dept_statistic", "dept_leader/statistic", "dept_leader/statistic.html", null, 3017],


        ["dept_notice_approval", "dept_approval/notice_approval", "dept_leader/notice_approval.html", null, 30101],
        ["dept_meeting_approval", "dept_approval/meeting_approval", "dept_leader/meeting_approval.html", "MeetingApprovalCtrl", 30102],
        ["dept_q", "dept_approval/q", "dept_leader/q.html", null, 30103],
        ["dept_news", "dept_approval/news", "dept_leader/news.html", null, 30105],
        ["dept_covid", "dept_approval/covid", "dept_leader/covid.html", null, 30107],

        // ["dept_consumable", "dept_leader/consumable", "dept_leader/consumable.html", null, 3018],
        // ["dept_room", "dept_leader/room", "dept_leader/room.html", null, 3019],

        // ["room_repairer", "room_repairer/manage", "room_repairer/manage.html", null, 27001],

        // ["room_repairer_root_manage", "room_repairer_root/manage", "room_repairer_root/manage.html", null, 28001],
        // ["room_repairer_root_repairing", "room_repairer_root/repairing", "room_repairer_root/repairing.html", null, 28002],
        // ["room_repairer_root_approval", "room_repairer_root/approval", "room_repairer_root/approval.html", null, 28003],
        // ["room_repairer_root_out", "room_repairer_root/out", "room_repairer_root/out.html", null, 28004],
        // ["room_repairer_root_finish", "room_repairer_root/finish", "room_repairer_root/finish.html", null, 28005],

        // ["dept_csmb_in", "dept_csmb/in", "dept_csmb/in.html", null, 15001],
        // ["dept_csmb_query", "dept_csmb/query", "dept_csmb/query.html", null, 15002],
        // ["dept_csmb_inventory", "dept_csmb/inventory", "dept_csmb/inventory.html", null, 15003],
        // ["dept_csmb_remind", "dept_csmb/remind", "dept_csmb/remind.html", null, 15004],
        // ["dept_csmb_return", "dept_csmb/return", "dept_csmb/return.html", null, 15005],
        // ["dept_csmb_application", "dept_csmb/application", "dept_csmb/application.html", null, 15006],
        // ["dept_csmb_use", "dept_csmb/use", "dept_csmb/use.html", null, 15007],
        // ["dept_room_repair", "dept_room/repair", "dept_room/repair.html", null, 15008],
        // ["dept_equipment_in", "dept_equipment/in", "dept_equipment/in.html", null, 15009],
        // ["dept_equipment_m_fee", "dept_equipment/m_fee", "dept_equipment/m_fee.html", null, 15010],
        // ["dept_equipment_inventory", "dept_equipment/inventory", "dept_equipment/inventory.html", null, 15011],
        // ["dept_equipment_manage", "dept_equipment/manage", "dept_equipment/manage.html", null, 15012],
        // ["dept_equipment_repair", "dept_equipment/repair", "dept_equipment/repair.html", null, 15013],
        // ["dept_equipment_analysis", "dept_equipment/analysis", "dept_equipment/analysis.html", null, 15014],
        // ["dept_equipment_admin", "dept_equipment/admin", "dept_equipment/admin.html", null, 15015],

        ["nurse_seniority_approval", "nurse_leader/seniority_approval", "nurse_leader/seniority_approval.html", "NurseSeniorityApprovalCtrl", 3101],
        ["nurse_level_manage", "nurse_leader/level_manage", "nurse_leader/seniority_level_manage.html", null, 3102],
        // ["nurse_duty_group_member", "nurse_leader/group_member", "sys/duty_group.html", null, 3103],

        ["hospital_leave", "hospital_leader/leave", "hospital_leader/leave.html", null, 3200],
        ["hospital_notice_approval", "hospital_leader/notice_approval", "hospital_leader/notice_approval.html", null, 3201],
        // ["hospital_news", "hospital_leader/news", "hospital_leader/news.html", null, 3210],
        ["hospital_meeting_approval", "hospital_leader/meeting_approval", "hospital_leader/meeting_approval.html", "MeetingApprovalCtrl", 3202],
        // ["hospital_meeting_topic", "hospital_leader/meeting_topic", "hospital_leader/meeting_topic.html", "DeptMeetingTopicCtrl", 3203],
        // ["hospital_public_topic", "hospital_leader/public_topic", "hospital_leader/public_topic.html", "HospitalPublicTopicCtrl", 3204],
        // ["hospital_q", "hospital_leader/q", "hospital_leader/q.html", null, 3206],
        ["hospital_ss", "hospital_leader/ss", "hospital_leader/ss.html", null, 3207],
        ["hospital_rule", "hospital_leader/rule", "hospital_leader/rule.html", null, 3208, ['pdf']],
        ["hospital_mission", "hospital_leader/mission", "hospital_leader/mission.html", null, 3209],
        ["hospital_contract", "hospital_leader/contract", "hospital_leader/contract.html", null, 3211, ['pdf']],
        // ["hospital_consumable", "hospital_leader/consumable", "hospital_leader/consumable.html", null, 3212],
        ["hospital_hga", "hospital_leader/hga", "hospital_leader/hga.html", null, 3213],
        ["hospital_covid", "hospital_leader/covid", "hospital_leader/covid.html", null, 3215],
        // ["hospital_user_reg", "hospital_leader/user_reg", "hospital_leader/user_reg.html", null, 3214],

        ["main_leave", "main_leader/leave", "main_leader/leave.html", null, 3301],
        // ["main_leave_recipient", "main_leader/main_leave_recipient", "main_leader/leave_recipient.html", null, 3302],
        // ["main_meeting_topic", "main_leader/meeting_topic", "main_leader/meeting_topic.html", 'MeetingTopicMainCtrl', 3303],
        ["main_mission", "main_leader/mission", "main_leader/mission.html", null, 3304],
        ["main_users_info", "main_leader/users_info", "main_leader/user_info.html", null, 3305],
        ["main_all_doc", "main_leader/all_doc", "hospital_office/doc.html", null, 3307],
        // ["main_user_reg", "main_leader/user_reg", "hospital_office/user_reg.html", null, 3308],
        // ["main_consumable", "main_leader/consumable", "main_leader/consumable.html", null, 3306],

        ["party_work_signed", "party_work/signed", "party_work/signed.html", null, 16101],
        ["party_work_tozr", "party_work/tozr", "party_work/tozr.html", null, 16102],
        // ["party_work_news", "party_work/news", "party_work/news.html", null, 16103],
        ["party_work_news", "party_work/news", "hospital_office/news.html", null, 16103],
        ["party_work_party_special", "party_work/party_special", "party_work/party_special_manage.html", null, 16104],
        ["dept_group_manage", "party_work/dept_group_manage", "party_work/dept_group_manage.html", null, 16105],
        ["party_work_leave", "party_work/leave", "party_work/leave.html", null, 16106],
        ["party_work_user", "party_work/user", "party_work/user.html", null, 16107],
        ["party_work_member", "party_work/member", "party_work/member.html", null, 16108],
        ["party_work_file_circulate", "party_work/file_circulate", "party_work/fileCirculate.html", null, 16109],
        ["party_manage", "party_work/party_manage", "hospital_office/bulletin_manage.html", null, 16110],


        ["news_manage", "hospital_office/news", "hospital_office/news.html", null, 4001],
        ["bulletin_manage", "hospital_office/bulletin_manage", "hospital_office/bulletin_manage.html", null, 4002],
        ["party_doc", "hospital_office/doc", "hospital_office/doc.html", null, 4018],
        ["hospital_office_dept_phone", "hospital_office/dept_phone", "hospital_office/dept_phone.html", null, 4019],
        ["hospital_office_common_phone", "hospital_office/common_phone", "hospital_office/common_phone.html", null, 4020],
        ["file_manage", "hospital_office/file_manage", "hospital_office/file_manage.html", null, 4003],
        ["work_arrange", "hospital_office/work_arrange", "hospital_office/workArrange.html", null, 4004],
        // ["airfare_manage", "hospital_office/airfare_manage", "hospital_office/airfare_manage.html", "AirfareManageCtrl", 4012],
        ["meeting_manage", "hospital_office/meeting_manage", "hospital_office/meeting_manage.html", "MeetingManageCtrl", 4005],
        // ["meeting_topic_manage", "hospital_office/meeting_topic_manage", "hospital_office/meeting_topic_manage.html", "MeetingTopicManageCtrl", 4007],
        ["file_circulate", "hospital_office/file_circulate", "hospital_office/fileCirculate.html", null, 4008],
        ["satisfaction_survey", "hospital_office/ss", "hospital_office/ss.html", null, 4010],
        ["contract_manage", "hospital_office/contract_manage", "hospital_office/manage.html", null, 4013],
        ["hospital_user_badge", "hospital_office/user_badge", "hospital_office/user_badge.html", null, 4015],
        ["hospital_contact_group", "hospital_office/contact_group", "hospital_office/contact_group.html", "PersonnelContactGroupCtrl", 4016],
        ["hospital_office_covid", "hospital_office/covid", "hospital_office/covid.html", null, 4017],
        ["hospital_office_qualification", "hospital_office/qualification", "hospital_office/qualification.html", null, 4021],
        ["rule_manage", "hospital_office/rule_manage", "hospital_office/rule_manage.html", null, 4009, ['pdf']],
        //["car_manage", "hospital_office/cars_manage", "hospital_office/cars_manage.html", "CarManageCtrl", 35],//????

        ["car_pending", "car_manage/pending", "car_manage/pending.html", null, 3501],
        ["car_warranty", "car_manage/warranty", "car_manage/warranty.html", null, 3502],
        ["car_scheduler", "car_manage/scheduler", "car_manage/scheduler.html", null, 3503],
        ["car_direct", "car_manage/direct", "car_manage/direct.html", null, 3504],
        ["car_record", "car_manage/record", "car_manage/record.html", null, 3505],
        ["car_emergency_direct", "car_manage/emergency_direct", "car_manage/emergencyDirect.html", null, 3506],
        ["cm_car_illegal", "car_manage/car_illegal", "car_manage/carIllegal.html", null, 3509],
        ["cm_pay_manage", "car_manage/car_pay_manage", "car_manage/payManage.html", null, 3512],
        ["cm_car_oil", "car_manage/car_oil", "car_manage/carOil.html", null, 3510, ['chart']],
        ["car_as_manage", "car_manage/as_manage", "car_manage/aSManage.html", null, 3508],
        ["car_handler", "car_manage/handler", "car_manage/handler.html", null, 3511],

        ["personnel_user_info", "personnel/user_info", "personnel/user_info.html", null, 2000],
        ["personnel_dept_member", "personnel/dept_member", "personnel/dept_member.html", "DeptMemberCtrl", 2001],
        ["personnel_user_leave", "personnel/user_leave", "personnel/user_leave.html", "UserLeaveCtrl", 2002],
        ["personnel_user_reg", "personnel/user_reg", "personnel/user_reg.html", null, 2003],
        ["personnel_all_user", "personnel/all_user", "personnel/all_user.html", null, 2006],
        ["personnel_seniority", "personnel/seniority", "personnel/seniority.html", "SeniorityCtrl", 2015],
        ["personnel_duty_fee_approval", "personnel/duty_fee_approval", "personnel/feeApproval.html", null, 2004],
        // ["personnel_attendance", "personnel/attendance", "personnel/attendance.html", "PersonnelAttendanceCtrl", 2005],
        ["personnel_leave", "personnel/leave", "personnel/leave.html", null, 2011],
        ["personnel_holiday", "personnel/holiday", "personnel/holiday.html", null, 2012],
        // ["personnel_leave_makeup", "personnel/leave_makeup", "personnel/leave_makeup.html", "PersonnelLeaveMakeupCtrl", 2013],
        // ["personnel_wage", "personnel/wage", "personnel/wage.html", "PersonnelWageCtrl", 2020, ["ngHandsontable"]],
        ["personnel_attendance_approval", "personnel/attendance_approval", "personnel/attendanceApproval.html", null, 2019],
        ["personnel_round", "personnel/round", "personnel/round.html", null, 2021],
        // ["personnel_meal", "personnel/meal", "personnel/meal.html", "PersonnelMealCtrl", 2028],
        ["personnel_qualification", "personnel/qualification", "personnel/qualification.html", null, 2029],
        ["personnel_qa", "personnel/qa", "personnel/qualification_authority.html", null, 2030],
        ["personnel_retired_worker", "personnel/retired_worker", "personnel/retired_worker.html", null, 2031],
        ["personnel_annual_leave_manage", "personnel/annual_leave_manage", "personnel/annual_leave_manage.html", null, 2032],
        ["personnel_statistic", "personnel/statistic", "personnel/statistic.html", null, 2033],
        ["personnel_edu", "personnel/edu", "personnel/edu.html", null, 2034],


        // ["finance_duty_fee_approval", "finance/duty_fee_approval", "finance/finance_fee_approval.html", "FinanceDutyFeeApprovalCtrl", 2304],
        // ["finance_duty_paid_detail", "finance/duty_paid_detail", "finance/duty_paid_detail.html", "FinanceDutyPaidDetailCtrl", 2305],
        // ["finance_cash_balance", "finance/cash_balance", "finance/cash_balance.html", "CashBalanceCtrl", 2307],
        // ["finance_attendance", "finance/attendance", "finance/attendance.html", "FinanceAttendanceCtrl", 2306],
        // ["finance_wage", "finance/wage", "finance/wage.html", "FinanceWageCtrl", 2320, ["ngHandsontable"]],
        ["finance_subsidy_paid", "finance/subsidy", "finance/subsidyPaid.html", null, 2309],
        ["finance_round_search", "finance/round", "finance/round.html", null, 2310],
        // ["finance_pending_airfare", "finance/pending_airfare", "finance/airfare.html", "FinanceAirfareCtrl", 2311],
        // ["finance_price_control", "finance/price_control", "finance/price_control.html", null, 2312],
        // ["finance_adverse", "finance/adverse", "finance/adverse.html", null, 2326],
        // ["finance_party_fee", "finance/party_fee", "finance/party_fee.html", null, 2327],

        ["medical_seniority", "medical/seniority", "medical/seniority.html", "SeniorityCtrl", 2115],
        ["medical_leave", "medical/leave", "medical/leave.html", null, 2100],
        // ["medical_leave_recipient", "medical/leave_recipient", "medical/leave_recipient.html", null, 2105],
        // ["medical_duty_fee_approval", "medical/duty_fee_approval", "medical/duty_fee_approval.html", "MedicalDutyFeeApprovalCtrl", 2104],
        ["medical_rule", "medical/rule", "medical/rule.html", null, 2106, ['pdf']],
        // ["medical_special_patient", "medical/special_patient", "medical/special_patient.html", null, 2107],
        ["medical_special_reg", "medical/reg", "medical/user_reg.html", null, 2108],

        ["nursing_info", "nursing/info", "nursing/userInfo.html", null, 2201],
        ["nursing_leave", "nursing/leave", "nursing/leave.html", null, 2200],
        // ["nursing_leave_recipient", "nursing/leave_recipient", "nursing/leave_recipient.html", null, 2201],
        // ["nursing_duty_fee_approval", "nursing/duty_fee_approval", "nursing/duty_fee_approval.html", "NursingDutyFeeApprovalCtrl", 2204],
        ["nursing_seniority", "nursing/seniority", "nursing/seniority.html", null, 2205],
        ["nursing_edu", "nursing/edu", "nursing/edu.html", null, 2211, ['pdf', 'video']],
        ["nursing_practice", "nursing/practice", "nursing/practice.html", "NursePracticeCtrl", 2212],
        ["nursing_round", "nursing/round", "nursing/round.html", null, 2213],
        ["nursing_reg", "nursing/reg", "nursing/user_reg.html", null, 2214],
        ["nursing_duty_group_member", "nursing/group_member", "sys/duty_group.html", null, 2215],

        // ["security_parking_lot", "security/parking_lot", "security/parking_lot.html", "ParkingLotCtrl", 6001],
        // ["security_parking_rent", "security/parking_rent", "security/parking_rent.html", "ParkingRentCtrl", 6002],
        // ["security_rush_park", "security/rush_park", "security/rush_park.html", "RushParkCtrl", 6003],
        // ["security_cash", "security/cash", "security/cash.html", "SecurityCashCtrl", 6004],

        // ["general_house_manage", "general/house_manage", "general/house_manage.html", "HouseManageCtrl", 6101],
        // ["general_house_rent", "general/house_rent", "general/house_rent.html", "HouseRentCtrl", 6102],
        // ["general_wae_fee", "general/wae_fee", "general/wae_fee.html", "WaeFeeCtrl", 6103],
        // ["general_meal", "general/meal", "general/meal.html", "WaeMealCtrl", 6128],
        // ["general_cash", "general/cash", "general/cash.html", "GeneralCashCtrl", 6129],
        // ["general_room", "general/room", "general/room.html", null, 6130],
        // ["general_room_cost", "general/room_cost", "general/room_cost.html", null, 6131],

        // ["adverse_manage", "adverse/manage", "adverse/manage.html", null, 7601],
        // ["adverse_statistic", "adverse/statistic", "adverse/statistic.html", null, 7602, ['chart']],
        // ["adverse_check", "adverse/check", "adverse/check.html", null, 7603],
        // ["adverse_handler", "adverse/handler", "adverse/handler.html", null, 7604],

        // ["equipment_administrative_material", "equipment/administrative_material", "equipment/administrative_material.html", "AdministrativeMaterialCtrl", 2405],
        // ["equipment_medical_material", "equipment/medical_material", "equipment/medical_material.html", "MedicalMaterialCtrl", 2406],
        // ["equipment_or_material", "equipment/or_material", "equipment/or_material.html", "ORMaterialCtrl", 2407],
        // ["equipment_scrap", "equipment/scrap", "equipment/scrap.html", null, 2408],
        // ["equipment_inventory", "equipment/inventory", "equipment/inventory.html", null, 2409],
        // ["equipment_allocate", "equipment/allocate", "equipment/allocate.html", null, 2410],
        // ["equipment_admin", "equipment/admin", "equipment/admin.html", null, 2411],
        // ["equipment_manual", "equipment/manual", "equipment/manual.html", null, 2412, ['pdf']],
        // ["equipment_vendor_q", "equipment/vendor_q", "vendor/vendor_q.html", null, 2413],
        // ["equipment_csmb_price", "equipment/csmb_price", "equipment/csmb_price.html", null, 2414],

        // ["hospital_equipment_repair", "hospital_equipment/repair", "hospital_equipment/repair.html", null, 19001],
        // ["hospital_equipment_scrap", "hospital_equipment/scrap", "hospital_equipment/scrap.html", null, 19002],
        // ["hospital_equipment_inventory", "hospital_equipment/inventory", "hospital_equipment/inventory.html", null, 19003],
        // ["hospital_equipment_equipment", "hospital_equipment/equipment", "hospital_equipment/equipment.html", null, 19004],
        // ["hospital_equipment_manage", "hospital_equipment/manage", "hospital_equipment/manage.html", null, 19005],

        // ["supply_material", "supply/material", "supply/material.html", "SupplyMaterialCtrl", 2505],
        // ["supply_disinfect", "supply/disinfect", "supply/disinfect.html", null, 2506],

        ["equipment_doc", "equipment/equipment_doc", "equipment/equipmentDoc.html", null, 7700, ['pdf']],

        ["op_recipient", "or/op_recipient", "or/op_recipient.html", "OPRecipientCtrl", 2600],
        ["op_handle", "or/op_handle", "or/op_handle.html", "OPHandleCtrl", 2601],
        ["op_shifts", "or/op_shifts", "or/op_shifts.html", "OPShiftsCtrl", 2602],
        // ["op_meal", "or/op_meal", "or/op_meal.html", "OPMealCtrl", 2603],

        ["ir_shifts", "ir/op_shifts", "ir/op_shifts.html", "IRShiftsCtrl", 2702],

        ["out_p_shifts", "out_p/p", "out_p/p_shifts.html", "OutPShiftsCtrl", 5101],

        ["edu_edu", "edu/edu", "edu/edu.html", null, 2811, ['pdf', 'video']],
        ["edu_practice", "edu/practice", "edu/practice.html", "EduPracticeCtrl", 2812],
        ["edu_law", "edu/law", "edu/law.html", "LawManageCtrl", 2813, ['pdf']],

        ["edu_hospital", "edu/hospital", "edu/hospital.html", null, 3701],

        // ["clinc_query", "clinc/query", "clinc/query.html", null, 7001],
        // ["clinc_approval", "clinc/approval", "clinc/approval.html", null, 7002],
        // ["clinc_fixed", "clinc/fixed", "clinc/fixed.html", null, 7004],
        // ["clinc_temp", "clinc/temp", "clinc/temp.html", null, 7003],
        // ["clinc_ap", "clinc/ap", "clinc/ap.html", null, 7005],
        // ["patient_manage", "clinc/manage", "clinc/manage.html", null, 7006],
        // ["black_list", "clinc/black_list", "black_list/black_list.html", null, 7007],

        // ["ap_manage_ap", "manage/ap", "manage/ap.html", null, 7101],
        // ["ap_manage_scene", "manage/scene", "manage/scene.html", null, 7102],
        // ["ap_manage_pay", "manage/pay", "manage/pay.html", null, 7103],
        // ["ap_manage_phone", "manage/phone", "manage/phone.html", null, 7104],
        // ["ap_manage_emergency", "manage/emergency", "manage/emergency.html", null, 7105],

        // ["doctor_appointment", "doctor/appointment", "doctor/appointment.html", null, 7201],
        // ["doctor_search", "doctor/search", "doctor/search.html", null, 7202],

        // ["ap_bill_cash", "bill/cash", "bill/cash.html", null, 7301],
        // ["ap_bill_cash_wx", "bill/cash_wx", "bill/cash_wx.html", null, 7302],

        // ["store_spot", "store/spot", "store/spot.html", "StoreSpotCtrl", 8001],
        // ["store_delivery", "store/delivery", "store/delivery.html", "StoreDeliveryCtrl", 8002],
        // ["store_wm", "store/wm", "store/wm.html", "StoreWmCtrl", 8003],
        // ["store_goods", "store/goods", "store/goods.html", "StoreGoodsCtrl", 8004],

        // ["store_ph", "store/ph", "store/ph.html", "StorePhCtrl", 8101],

        // ["repair_confirm", "repair/confirm", "repair/confirm.html", null, 18001],

        ["hga_catalog", "hga/catalog", "hga/catalog.html", null, 20001],
        ["hga_list", "hga/list", "hga/list.html", null, 20002],
        ["hga_self", "hga/self", "hga/self.html", null, 20003],
        ["hga_monitor", "hga/monitor", "hga/monitor.html", null, 20004],
        ["hga_file", "hga/file", "hga/file.html", null, 20005],
        ["hga_bulletin", "hga/bulletin", "hga/bulletin.html", null, 20006],

        ["hga_manage", "hga_admin/manage", "hga_admin/manage.html", null, 21001],

        // ["mi_manage_record", "mi_manage/record", "mi_manage/record.html", null, 22001],
        // ["mi_manage_confirm", "mi_manage/confirm", "mi_manage/confirm.html", null, 22002],

        // ["family_doctor_patient", "family_doctor/patient", "family_doctor/patient.html", null, 23001],
        // ["family_doctor_project", "family_doctor/project", "family_doctor/project.html", null, 23002],

        // ["cash_prepaid_advance", "cash_prepaid/advance", "cash_prepaid/advance.html", null, 26001],
        // ["cash_prepaid_records", "cash_prepaid/records", "cash_prepaid/records.html", null, 26003],

        // ["fdm_project", "fdm/project", "family_doctor_manage/project.html", null, 24001],
        // ["fdm_package", "fdm/package", "family_doctor_manage/package.html", null, 24002],
        // ["fdm_doctor_manage", "fdm/doctor_manage", "family_doctor_manage/doctor.html", null, 24003],

        //["distribution_task", "consumable/distribution_task", "distribution/task.html", null, 9101],
        // ["distribution_distributor", "consumable/distribution_distributor", "distribution/distributor.html", null, 9102],

        // ["vendor_profile", "vendor/profile", "vendor/profile.html", null, 11001],
        // ["vendor_qualification", "vendor/qualification", "vendor/qualification.html", null, 11002],
        // ["vendor_rename", "vendor/rename", "vendor/rename.html", null, 11003],

        // ["storeroom_query", "storeroom/query", "storeroom/query.html", null, 12001],
        // ["storeroom_inventory", "storeroom/inventory", "storeroom/inventory.html", null, 12002],
        // ["storeroom_purchase", "storeroom/purchase", "storeroom/purchase.html", null, 12003],
        // ["storeroom_in", "storeroom/in", "storeroom/in.html", null, 12005],
        // ["storeroom_out", "storeroom/out", "storeroom/out.html", null, 12006],
        // ["storeroom_remind", "storeroom/remind", "storeroom/remind.html", null, 12007],
        // ["storeroom_return", "storeroom/return", "storeroom/return.html", null, 12008],
        //["storeroom_straight", "storeroom/straight", "storeroom/straight.html", null, 12009],
        //["storeroom_allocate", "storeroom/allocate", "storeroom/allocate.html", null, 12010, ['qrCode']],
        // ["storeroom_dept", "storeroom/dept", "storeroom/dept.html", null, 12004],
        // ["storeroom_dept_return", "storeroom/dept_return", "storeroom/dept_return.html", null, 12011],

        // ["dr_medical_info", "dr/medical_info", "dr/medical_info.html", "DRMedicalInfoCtrl", 2902],
        // ["dr_car_direct", "dr/car_direct", "car_manage/120_direct.html", "120DirectCtrl", 2904],  //最好不要数字开头

        ["blood_storage", "blood_bank/blood_storage", "blood_bank/blood_storage.html", "BloodStorageCtrl", 5201],

        ["energy_set", "energy/set", "energy/set.html", null, 22001],
        ["energy_confirm", "energy/confirm", "energy/confirm.html", null, 22002],
        ["energy_data", "energy_input/data", "energy_input/data.html", null, 22101],

        ["staff_health_checkup", "staff_health/checkup", "staff_health/checkup.html", null, 22201],
        // ["staff_health_expose", "staff_health/expose", "staff_health/expose.html", null, 22202],

        // ["consumable_category", "consumable/category", "consumable/category.html", null, 13001],
        // ["csmb_qualification_application", "consumable/qualification", "consumable/qualification.html", null, 13002],

        // ["pc_stock", "pc/stock", "<ui-view></ui-view>", null, 14000, null, [
        //     ['rooms', 'rooms', 'pc/stock/rooms.html'],
        //     ['room_stock', 'rooms/:id', 'pc/stock/room_stock.html']
        // ]],
        // ["pc_remind", "pc/remind", "<ui-view></ui-view>", null, 14002, null, [
        //     ['rooms', 'rooms', 'pc/remind/rooms.html'],
        //     ['consumables', 'rooms/:id', 'pc/remind/consumables_remind.html']
        // ]],
        // ["pc_purchase", "pc/purchase", "pc/purchase.html", null, 14001],
        // ["pc_csmb_price", "pc/csmb_price", "pc/csmb_price.html", null, 14004],
        //["pc_allocate", "pc/allocate", "pc/allocate.html", null, 14003],

        // ["mi_csmb_manage", "mi/csmb_manage", "mi/csmb_manage.html", null, 17001],
        // ["mi_clinc_special", "mi/clinc_special", "mi/clinc_special.html", null, 17002],

        // ["cadre_health_vip", "cadre_health/vip", "cadre_health/vip.html", null, 29001],

        ["test", "sys/test", "sys/test/index.html", null, 9991],
        ["sys_basic", "sys/basic", "sys/basic.html", null, 9000],
        ["sys_coop", "sys/coop", "sys/coop.html", null, 9007],
        ["sys_statistic", "sys/statistic", "sys/statistic.html", null, 9017],
        ["sys_sign", "sys/sign", "sys/sign.html", "SignCtrl", 9010],
        ["sys_dept", "sys/dept", "sys/dept.html", null, 9003],
        ["sys_car", "sys/car", "sys/car.html", null, 9004],
        ["sys_duty_group", "sys/duty_group", "sys/duty_group.html", null, 9005],
        // ["sys_wage", "sys/wage", "sys/wage.html", "WageCtrl", 9008],
        // ["sys_meal", "sys/meal", "sys/meal.html", "MealCtrl", 9018],
        ["sys_meeting", "sys/meeting", "sys/meeting.html", "MeetingCtrl", 9009],
        ["sys_qualification", "sys/qualification", "sys/qualification.html", null, 9012],
        // ["sys_material_manage", "sys/material", "sys/material.html", "MaterialManageCtrl", 9013],
        // ["sys_mi_manage", "sys/mi_manage", "sys/mi_manage.html", null, 9014],
        // ["sys_at_manage", "sys/at_manage", "sys/at_manage.html", null, 9015],
        // ["sys_fd_manage", "sys/fd_manage", "sys/fd_manage.html", null, 9016],
        // ["sys_adverse", "sys/adverse", "sys/adverse.html", null, 9026],

        ["sys_authority", "sys/authority", "sys/authority.html", "AuthorityCtrl", 9001],
        ["sys_help", "sys/help", "sys/help.html", "HelpCtrl", 9020],
        ["sys_app_cfg", "sys/app_cfg", "sys/app_cfg.html", "appCfgCtrl", 9002],
        ["sys_equipment_category", "sys/equipment_category", "sys/equipment_category.html", null, 9021],
    ];

})();

(function () {
    'use strict';

    angular.module('c')
        .factory('mySocket', socketFactory)
        .run(runSocket)
    ;

    /** @ngInject */
    function runSocket(mySocket) {
    }

    /** @ngInject */
    function socketFactory(socketFactory) {
        // var protocol = window.location.protocol;
        var myIoSocket = io.connect("//" + window.location.hostname + ':3110');

        var mySocket = socketFactory({
            ioSocket: myIoSocket
        });

        mySocket.forward([
            "sjoa:mail.read",
            "sjoa:mail.send",
            "sjoa:mail.withdraw",

            "sjoa:bulletin.send",
            "sjoa:file.release",
            "sjoa:meeting.send",
            "sjoa:meeting.read",
            "sjoa:mission.send",
            "sjoa:news.send",
            "sjoa:rule.send",
            "sjoa:selfAssessment.automatic",
            "sjoa:qualification.export",

            "sjoa:task",

            "sjoa:file.zipDownload",

            "sjoa:wx.swimmingFitness",

            //"sjoa:question.send",
            "sjoa:wechat.orderPay",
            "sjoa:takeOut.send",
            "sjoa:workingMeal.handle",
            "sjoa:workingMeal.send",
            "sjoa:appointment.notify",
        ]);

        return mySocket;
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .config(['uiMask.ConfigProvider', uiMaskConfig])
        .config(uibConfig)
    ;

    /** @ngInject */
    function uiMaskConfig(uiMaskConfigProvider) {
        uiMaskConfigProvider.clearOnBlur(false);
    }

    /** @ngInject */
    function uibConfig(uibDatepickerConfig, uibDatepickerPopupConfig, $uibTooltipProvider) {
        uibDatepickerConfig.startingDay = 1;

        uibDatepickerPopupConfig.currentText = "今天";
        uibDatepickerPopupConfig.clearText = "清除";
        uibDatepickerPopupConfig.closeText = "关闭";

        $uibTooltipProvider.options({
            appendToBody: true
        });
    }

})();

angular.module('c.s')
    .constant('C', {
        P: "socket:sjoa:",

        V: "pages/dlg/",
        T: "templates/",


        STAGE1: {
            /**
             * 科审：0
             */
            DEPT_APPROVAL: 0,
            /**
             * 院审：1
             */
            HOSPITAL_APPROVAL: 1,
            /**
             * 科退：2
             */
            DEPT_BACK: 2,
            /**
             * 院退：3
             */
            HOSPITAL_BACK: 3,
            /**
             * 发布：4
             */
            PUBLIC: 4,
            OVER: 5
        },
        STAGE2: {
            /**
             * 审核中：0
             */
            APPROVAL: 0,
            /**
             * 退回：1
             */
            BACK: 1,
            /**
             * 发布：2
             */
            PUBLIC: 2
        },
        STAGE3: {
            /**
             * 审核中：0
             */
            APPROVAL: 0,
            /**
             * 发布：1
             */
            PUBLIC: 1,
            /**
             * 退回：2
             */
            BACK: 2
        },

        STAGE4: {
            /**
             * 科审：1
             */
            DEPT_APPROVAL: 1,
            /**
             * 院审：2
             */
            HOSPITAL_APPROVAL: 2,
            /**
             * 不讨论：3
             */
            NOT_DISCUSS: 3,
            /**
             * 待讨论：4
             */
            TO_BE_DISCUSSED: 4,
            /**
             * 已讨论：5
             */
            ALREADY_DISCUSSED: 5,
            /**
             * 会签：6
             */
            COUNTERSIGN: 6
        },
        STAGE5: {
            /**
             * 科审：0
             */
            DEPT_APPROVAL: 0,
            /**
             * 院审：1
             */
            HOSPITAL_APPROVAL: 1,
            //个人整改意见
            USER_APPROVAL: 5,
            /**
             * 院长办公室审核：6
             */
            PARTY_APPROVAL: 6,
            /**
             * 接受：7
             */
            ACCEPT: 7,
            /**
             * 拒绝：8
             */
            REJECT: 8,
            /**
             * 退回意见人：9
             */
            BACK: 9
        },
        STAGE6: {
            /**
             * 科审：1
             */
            DEPT_APPROVAL: 1,
            /**
             * 院审：2
             */
            HOSPITAL_APPROVAL: 2,
            /**
             * 会签：4
             */
            COUNTERSIGN: 4,
            /**
             * 待讨论：5
             */
            TO_BE_DISCUSSED: 5,
            /**
             * 发布：6
             */
            PUBLIC: 6,
            /**
             * 停用：7
             */
            DISABLE: 7
        },
        STAGE7: {
            /**
             * 套红头审批中：2
             */
            RED_HEAD_APPROVAL: 2,
            /**
             * 套红头第一步审批人已通过：3
             */
            RED_HEAD_HOSPITAL_APPROVED: 3
        },

        APPROVAL_TYPE: {
            LEAVE: 1,
            BULLETIN: 2,
            NEWS: 3,
            FILE: 4
        },

        EDU: {
            Q: {
                TYPE: {
                    SINGLE: '1',
                    MULTI: '2'
                }
            },
            FOR: {
                DOCTOR: 1,
                NURSE: 2,
                ALL: 3
            },
            P: {
                TYPE: {
                    NORMAL: '1',
                    PACKAGE: '2',
                    PART: '3'
                },
                R_BY: {
                    /**
                     *
                     */
                    DEPT: '1',
                    EDU: '2',
                    NURSE: '3'
                }
            }
            ,
            T: {
                SHOW: {
                    FOR: {
                        PAPER: '1',
                        FILL: '2',
                        ANSWER_SHEET: '3',
                        STATISTIC: '4'
                    }
                }
            }
        },

        Q: {
            QUESTION: {
                TYPE: {
                    SINGLE: '1',
                    MULTI: '2',
                    TEXT: '3'
                }
            },
            TYPE: {
                NORMAL: '1',
                DEPT: '6',
                USER: '7',
                LEADER: '8'
            }
        },

        Q_SURVEY: {
            TYPE: {
                DEPT: '1',
                HOSPITAL: '2'
            },
            CLOSE: {
                WHEN_EXPIRED: '1',
                WHEN_FINISH: '2',
                WHEN_MANUAL: '3'
            },
            RR: {
                REAL_TIME: '1',
                WHEN_FINISH: '2',
                MANUAL: '3'
            },
            SHOW: {
                FOR: {
                    QUESTIONNAIRE: '1',
                    FILL: '2',
                    ANSWER_SHEET: '3',
                    STATISTIC: '4',
                    APPROVAL: '5'
                }
            }
        },

        Q_OPINION: {
            PRIVACY: {
                NONE: '1',
                RESPONDENT: '2',
                ALL: '3'
            }
        },

        OPT: {
            USER: {
                INDEX: {
                    DEPT_MEMBER_OPTIONS: '3'
                }
            },
            SCHEDULE: {
                INDEX: {
                    SCHEDULES: 1,
                    G_S_BY_ROLLING_DAYS: 2,
                    GROUP_MEMBERS_SCHEDULES: 3,
                    DUTY_MEMBERS: 4,
                    G_S_BY_LAST_WEEK: 5
                }
            },
            DOC: {
                INDEX: {
                    USER_APPLIED: 1,
                    USER_HANDLED: 2,
                    DEPT_DOCS: 3,
                    PARTY_DOCS: 4,
                    APPROVAL_LIST: 10,
                    RED: 5
                },
                EDIT: {
                    SAVE: 3, //保存公文，同时作为后台opt
                    HANDLE: 4, //处理公文
                    COMMENT: 5 //处理公文
                }
            },
            DOC_TYPE: {
                INDEX: {
                    MANAGE: 1,
                    OPTIONS: 2,
                    SIMPLE_OPTIONS: 2
                },
                SHOW: {
                    BODY: 2
                }
            },

            MEETING_TOPIC: {
                INDEX: {
                    USER_APPLIED: 1,
                    DEPT_APPROVAL: 2,
                    HOSPITAL_APPROVAL: 3,
                    DEPT_SEARCH: 4,
                    HOSPITAL_APPROVALED: 5,
                    HOSPITAL_SEARCH: 6,
                    TO_BE_DISCUSSED_MANAGE: 7,
                    MAIN_BACK_TO_ADD: 8,
                    MAIN_NOT_DISCUSS: 9,
                    MAIN_ALREADY_DISCUSSED: 10,
                    MAIN_COUNTERSIGN: 11,
                    MAIN_SEAL_UP: 12,
                    APPROVAL_LIST: 20
                },
                EDIT: {
                    SAVE: 1,
                    PASS: 2,
                    BACK: 3,
                    BACK_TO_ADD: 4,
                    HANDLE: 5,
                    SEAL_UP: 6
                }
            },
            DEPT: {
                INDEX: {
                    //所有科室选项
                    DEPTS_OPTIONS: 4,
                    //当前登录用户所属科室列表，用于下拉列表选项
                    USER_DEPTS_OPTIONS: 5,
                    //当前登录用户所负责科室列表，用于下拉列表选项
                    DEPTS_LED_BY: 6,
                    //当前登录用户所属科室列表，用于下拉列表选项,分管院领导可选所管科室
                    USER_DEPTS_OPTIONS2: 12,
                    //查询用户所属科室列表，用于下拉列表选项
                    USER_DEPTS_OPTIONS3: 13,
                    //分管院领导已审核制度的科室列表
                    DEPTS_LED_BY2: 15,
                    //科室物资管理员管理的科室列表
                    DEPTS_CSMB_OPTIONS: 16
                }
            },
            EDU: {
                TEST: {
                    INDEX: {
                        DEPT: 1,
                        NURSE: 2,
                        EDU: 3
                    },
                    SHOW: {
                        SIMPLE: 1,
                        STATISTICS: 2,
                        PKG_STATISTICS: 3,
                        MAKEUP: 4,
                        REMAINING: 5
                    }
                },
                P: {
                    INDEX: {
                        DEPT_P: 1,
                        DEPT_P_OPTIONS: 2,
                        PARTS: 3,
                        NURSE: 7,
                        EDU: 8
                    },
                    EDIT: {
                        SAVE: 3,
                        STOP: 4
                    }
                },
                Q: {
                    INDEX: {
                        USER_Q: 1,
                        NURSING_Q: 2,
                        EDU_Q: 3,
                        ITEM_BANK: 4
                    },
                    EDIT: {
                        APPROVAL: 1,
                        SAVE: 3,
                        STOP: 4
                    }
                },
                C: {
                    INDEX: {
                        USER: 1,
                        DEPT: 2,
                        NURSE: 3,
                        EDU: 4
                    }
                }
            },

            Q: {
                INDEX: {
                    USER_Q: 1,
                    USER_Q_OPTIONS: 2,
                    PARTY_Q: 3,
                    PARTY_Q_OPTIONS: 4
                },
                EDIT: {
                    SAVE: 3,
                    STOP: 4
                },
                EDIT1: 1,
                EDIT2: 2,
                RELEASE: 3,
                SUBMIT: 5
            },
            Q_SURVEY: {
                INDEX: {
                    USER_Q_SURVEY: 1,
                    DEPT_APPROVAL: 2,
                    HOSPITAL_APPROVAL: 3,
                    PARTY_Q_SURVEY: 4,
                    DEPT_RESULT: 5,
                    DEPT_RESULT4HOSPITAL: 6,
                    RESULT_OPTIONS: 7,
                    OPTION_NOTES: 8,
                    USER_RESULT: 9,
                    APPROVAL_LIST: 10,
                    USER_SS: 11
                },
                SHOW: {
                    SIMPLE: 1,
                    STATISTICS: 2,
                    APPROVAL: 3
                },
                EDIT: {
                    APPROVAL: 1,
                    MANUAL_CLOSE: 2,
                    MANUAL_RR: 3
                },
                APPROVAL: '1'
            },
            Q_ANSWER_SHEET: {
                INDEX: {
                    USER_Q_SHEET: 1,
                    APPROVAL_LIST: 10
                },
                EDIT: {
                    FILL: 1
                }
            },
            Q_OPINION: {
                INDEX: {
                    DEPT_APPROVAL: 2,
                    HOSPITAL_APPROVAL: 3,
                    PARTY_APPROVAL: 4,
                    USER_APPROVAL: 5,
                    USER_OPINION: 6,
                    APPROVAL_LIST: 10
                },
                EDIT: {
                    APPROVAL: 1,
                    CHANGE_DEPT: 2,
                    ADD: 3    //补充意见
                }
            },
            FILE: {
                INDEX: {
                    HOSPITAL_OFFICE_FILING: 1,
                    USER_UNREAD: 2,
                    USER_READ: 3,
                    HOSPITAL_OFFICE_SEAL_UP: 4,
                    IS_READING_PRINT: 5,
                    ALREADY_READ_PRINT: 6,
                    SEAL_UP_PRINT: 7,
                    USER_FILING: 8,
                    FILING_PRINT: 9,
                    USER_APPLIED: 10
                },
                EDIT: {
                    SEAL_UP: 1,
                    READ: 2,
                    CIRCULATE: 3,
                    FILING: 4
                }
            },
            SYS_WAGE: {
                INDEX: {
                    ALL_WAGES: 1,
                    STATUS_WAGES: 2
                }
            },
            PERSONNEL_WAGE: {
                INDEX: {
                    ALL_USERS: 1,
                    USER_WAGES: 2
                }
            },
            USER_TEMP_WAGE: {
                INDEX: {
                    ALL_WAGES: 1
                }
            },
            IN_SERIES_WAGE_REPORT: {
                INDEX: {
                    USER_WAGES: 1
                }
            },
            RULE_TYPE: {
                INDEX: {
                    DEPT_MANAGE: 1,
                    HOSPITAL_MANAGE: 2,
                    OPTIONS: 3,
                    NAME_EXCHANGE: 4,
                    CLASS_EXCHANGE: 5
                }
            },
            RULE: {
                INDEX: {
                    USER_APPLIED: 1,
                    USER_HOSPITAL_SEARCH: 2,
                    DEPT_SEARCH: 3,
                    HOSPITAL_APPROVED: 6,
                    HOSPITAL_OFFICE_MANAGE: 7,
                    USER_DEPT_SEARCH: 8,
                    RED_HEAD_SEARCH: 9,
                    RED_HEAD_APPROVAL_LIST: 10,
                    MEDICAL: 11,
                    TYPE_MANAGE: 20,
                    APPROVAL_LIST: 30,
                    FINALLY_SEARCH: 31,
                },
                EDIT: {
                    SAVE: 1,
                    EXCHANGE: 2,
                    PASS: 3,
                    HANDLE: 4,
                    DEPT_HANDLE: 5,
                    HOSPITAL_HANDLE: 6,
                    CLASS_EXCHANGE: 7,
                    RED_HEAD_MANAGE: 8,
                    RED_HEAD_PASS: 9,
                    RED_HEAD_BACK: 10,
                    BACK: 11
                }
            }
        },

        URL: {
            CHROME: {
                windows: 'download/android/chrome.exe',
                android: 'download/android/chrome.apk'
                //mac: 'http://sw.bos.baidu.com/sw-search-sp/software/441142fc7c4/googlechrome_mac_50.0.2661.102.dmg',
                //ios: 'http://itunes.apple.com/cn/app/id535886823?mt=8'
            },


            //BASE: 'http://' + window.location.host,
            // WX_BIND: '/api/wx/bind',

            FORUM_SSO: '/bbs/sso',
            FORUM_API: '/bbs',

            TASK_HAS: '/api/v1/task_has',
            TASK_ALL: '/api/v1/task_all',

            SMS_SEND: '/api/v1/sms/send',
            SMS_RM: '/api/v1/sms/remove',
            SMS_HISTORY: '/api/v1/sms/history',

            IMG_UPLOAD: '/api/v1/file/images/upload',

            OP_UPLOAD: '/api/v1/operation_permits/upload',
            OP_DOWNLOAD: '/api/v1/operation_permits/download',
            OR_SCHEDULE_UPLOAD: '/api/v1/or_schedules/upload',
            OR_SCHEDULE_DOWNLOAD: '/api/v1/or_schedules/download',

            IR_SCHEDULE_UPLOAD: '/api/v1/ir_schedules/upload',
            IR_SCHEDULE_DOWNLOAD: '/api/v1/ir_schedules/download',

            OUT_P_SCHEDULE_UPLOAD: '/api/v1/out_p_schedules/upload',
            OUT_P_SCHEDULE_DOWNLOAD: '/api/v1/out_p_schedules/download',

            MEDICAL_INFO_UPLOAD: '/api/v1/medical_info/upload',
            MEDICAL_INFO_DOWNLOAD: '/api/v1/medical_info/download',

            BLOOD_STORAGE_UPLOAD: '/api/v1/blood_storage/upload',
            BLOOD_STORAGE_DOWNLOAD: '/api/v1/blood_storage/download',

            MEETING_EXPORT: '/api/v1/meetings/export',
            DEPT_DOCS_DOWNLOAD: '/api/v1/docs/export',
            SCHEDULES_DOWNLOAD: '/api/v1/schedules/export',
            MAIL_UPLOAD: '/api/v1/emails/upload',
            MAIL_DOWNLOAD: '/api/v1/emails/download',
            BULLETIN_UPLOAD: '/api/v1/bulletin/bulletin/upload',
            BULLETIN_DOWNLOAD: '/api/v1/bulletin/bulletin/download',
            ATTENDANCE_EXPORT: '/api/v1/attendance_reports/export',
            Q_OPINION_EXPORT: '/api/v1/q/q_opinions/export',
            DUTY_PAID_EXPORT: '/api/v1/paid_details/export',

            FILE_CABINET_UPLOAD: '/api/v1/file_cabinet/upload',
            FILE_CABINET_DOWNLOAD: '/api/v1/file_cabinet/download',

            LEAVE_ATTACHMENT_UPLOAD: '/api/v1/leave_attachment/upload',
            LEAVE_ATTACHMENT_DOWNLOAD: '/api/v1/leave_attachment/download',
            LEAVES_DOWNLOAD: '/api/v1/ask_for_leaves/export',

            NEWS_UPLOAD: '/api/v1/news/news/upload',
            NEWS_DOWNLOAD: '/api/v1/news/news/download',

            DOC_UPLOAD: '/api/v1/docs/upload',
            DOC_DOWNLOAD: '/api/v1/docs/download',

            DOC_TYPE_UPLOAD: '/api/v1/doc_types/upload',
            DOC_TYPE_DOWNLOAD: '/api/v1/doc_types/download',

            TOPIC_UPLOAD: '/api/v1/meeting_topics/upload',
            TOPIC_DOWNLOAD: '/api/v1/meeting_topics/download',

            MEETING_UPLOAD: '/api/v1/meetings/upload',
            MEETING_DOWNLOAD: '/api/v1/meetings/download',

            MISSION_UPLOAD: '/api/v1/mission/missions/upload',
            MISSION_DOWNLOAD: '/api/v1/mission/missions/download',
            MISSION_EXPORT: '/api/v1/mission/missions/export',

            REGULAR_MISSION_UPLOAD: '/api/v1/mission/regular_missions/upload',
            REGULAR_MISSION_DOWNLOAD: '/api/v1/mission/regular_missions/download',

            MISSION_REPORT_UPLOAD: '/api/v1/mission/mission_reports/upload',
            MISSION_REPORT_DOWNLOAD: '/api/v1/mission/mission_reports/download',

            QUALIFICATION_REPORT_UPLOAD: '/api/v1/qualifications/upload',
            QUALIFICATION_REPORT_DOWNLOAD: '/api/v1/qualifications/download',

            AUTHORIZATION_REPORT_UPLOAD: '/api/v1/authorizations/upload',
            AUTHORIZATION_REPORT_DOWNLOAD: '/api/v1/authorizations/download',
            AUTHORIZATION_REPORT_EXPORT: '/api/v1/authorizations/export',

            OFFICIAL_OVERVIEW_UPLOAD: '/api/v1/official_overview/upload',
            OFFICIAL_OVERVIEW_DOWNLOAD: '/api/v1/official_overview/download',

            FILE_UPLOAD: '/api/v1/files/upload',
            FILE_DOWNLOAD: '/api/v1/files/download',
            ORDER_IMG_UPLOAD: '/api/v1/orders/upload',
            ORDER_IMG_DOWNLOAD: '/api/v1/orders/download',

            FILE_READER_UPLOAD: '/api/v1/file_readers/upload',
            FILE_READER_DOWNLOAD: '/api/v1/file_readers/download',

            E_QUESTION_DOWNLOAD: '/api/v1/edu_questions/download',

            E_COURSE_UPLOAD: '/api/v1/edu_courses/upload',
            E_COURSE_DOWNLOAD: '/api/v1/edu_courses/download',
            E_UC_DOWNLOAD: '/api/v1/edu_user_courses/export',
            E_SC_DOWNLOAD: '/api/v1/edu_user_courses/signExport',

            RULE_ATTACH_UPLOAD: '/api/v1/rules/upload',
            RULE_ATTACH_DOWNLOAD: '/api/v1/rules/download',

            Q_SURVEY_DOWNLOAD: '/api/v1/q/questionnaire_surveys/export',
            E_TEST_DOWNLOAD: '/api/v1/edu_tests/export',

            CARS_DOWNLOAD: '/api/v1/car_applications/export',
            AIRFARE_DOWNLOAD: '/api/v1/airfares/export',

            FILES_EXPORT: '/api/v1/files/export',

            RWAGE_DOWNLOAD: '/api/v1/wage_reports/export',
            ROUND_DOWNLOAD: '/api/v1/rounds/export',

            RUSH_PARK_DOWNLOAD: '/api/v1/rush_parks/export',
            PARKING_RENT_DOWNLOAD: '/api/v1/user_parking/export',

            WORKING_MEALS_DOWNLOAD: '/api/v1/working_meals/export',
            TAKE_OUT_DOWNLOAD: '/api/v1/take_out/export',
            PURCHASE_HISTORY_DOWNLOAD: '/api/v1/purchase_history/export',

            CONTRACT_UPLOAD: '/api/v1/contract/contracts/upload',
            CONTRACT_UPLOAD1: '/api/v1/contract/contracts/upload1',
            CONTRACT_DOWNLOAD: '/api/v1/contract/contracts/download',

            MANUAL_UPLOAD: '/api/v1/manual/e_manuals/upload',

            LAW_UPLOAD: '/api/v1/laws/upload',
            LAW_DOWNLOAD: '/api/v1/laws/download',

            VENDOR_UPLOAD: '/api/vendor/vendors/upload',
            VENDOR_DOWNLOAD: '/api/vendor/vendors/download',

            RULE_EXPORT: '/api/v1/rules/export',

            CONTRACT_EXPORT: 'api/v1/contract/contracts/export',

            /**
             * 门诊订单导出
             */
            CLINC_AP_EXPORT: '/api/home/appointments/export',
            CLINC_AP_STATISTIC: '/api/home/appointments/statistic',
            CLINC_EMAP_STATISTIC: '/api/home/emergency_appointments/export',

            CLINC_EXPORT: '/api/home/clinc/export',

            CLINC_STOP_EXPORT: '/api/home/replace_clinc/export',
            CLINC_STOP_STATISTIC: '/api/home/clinc_stop_reasons/statistic',

            /**
             * 证书订单导出
             */
            QUALIFICATION_EXPORT: '/api/v1/qualifications/export',
            QUALIFICATION_STATISTIC: '/api/v1/qualifications/statistic',

            /**
             * 报修单图片上传
             */
            ROOM_REPAIR_IMAGES: '/api/v1/room/room_repair_record/images/upload',
            /**
             * 报修单语音上传
             */
            ROOM_REPAIR_VOICES: '/api/v1/room/room_repair_record/voices/upload',
            /**
             * 以后附件上传统一用这个
             */
            UPLOAD_ATTACHMENT: '/api/v1/file/attachments/upload_single',

            HOUSE_WAE_EXPORT: '/api/v1/house_wae/export'

        }


    });


(function () {
    'use strict';

    angular.module('c')
        .constant('serviceConfObj', {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        });
})();

angular.module('c')
    .filter('bytes', function() {
    return function(bytes) {
        if (isNaN(parseFloat(bytes)) || !isFinite(bytes) || bytes == 0) return '0';
        var units = {1: 'KB', 2: 'MB', 3: 'GB', 4: 'TB'},
            measure, floor, precision;
        if (bytes > 1099511627775) {
            measure = 4;
        } else if (bytes > 1048575999 && bytes <= 1099511627775) {
            measure = 3;
        } else if (bytes > 1024000 && bytes <= 1048575999) {
            measure = 2;
        } else if (bytes <= 1024000) {
            measure = 1;
        }
        floor = Math.floor(bytes / Math.pow(1024, measure)).toString().length;
        if (floor > 3) {
            precision = 0
        } else {
            precision = 3 - floor;
        }
        return (bytes / Math.pow(1024, measure)).toFixed(precision) + units[measure];
    }
});

/**
 * 将从laravel服务器传过来的时间格式转换成javascript的格式，在送入内建过滤器date处理
 */
angular.module('c')
    .filter('date2', function ($filter) {
        return function (text, format) {
            if (text != null && text != '') {
                var tempdate = new Date(text.replace(/-/g, "/"));
                return $filter('date')(tempdate, format);
            }
            return text;
        }
    });
angular.module('c')
    .filter('dateInRange', function (uibDateParser) {
        return function (data, params) {
            var result = [];
            angular.forEach(data, function (item) {
                var needPush = true;
                for (key in params) {
                    var date = item[key];
                    date = uibDateParser.parse(date, 'yyyy-MM-dd');
                    var dateRange = params[key];
                    if ((dateRange.startDate != null && date < dateRange.startDate)
                        || (dateRange.endDate != null && date > dateRange.endDate)) {
                        needPush = false;
                        break;
                    }
                }
                if (needPush) {
                    result.push(item);
                }
            });
            return result;
        }
    });

(function () {
    'use strict';

    angular.module('c')
        .filter('defValIfNone', defValIfNone);

    /** @ngInject */
    function defValIfNone() {
        return function (input, val) {
            if (!input) {
                if (angular.isUndefined(val)) {
                    if (input === 0) {
                        val = '无';
                    } else {
                        val = '其他';
                    }
                }
                return val;
            }
            return input;
        }
    }

})();

angular.module('c')
    .filter('exceptItem', function (F) {
        return function (items, exclude) {
            if (exclude && exclude.length > 0) {
                var ret = [];
                angular.forEach(items, function (item) {
                    var i = F.indexOfKey(item, exclude);
                    if (F.indexOfKey(item.id, exclude) == -1) {
                        ret.push(item);
                    }
                });
            } else {
                ret = items;
            }
            return ret;
        }
    });
angular.module('c')
    .filter('numInRange', function () {
        return function (data, params) {
            var result = [];
            angular.forEach(data, function (item) {
                var needPush = true;
                for (var key in params) {
                    var num = item[key];
                    var numRange = params[key];
                    var start = -Number.MAX_VALUE, end = Number.MAX_VALUE;
                    if (numRange.start != null && numRange.start != '') {
                        start = parseInt(numRange.start);
                    }
                    if (numRange.end != null && numRange.end != '') {
                        end = parseInt(numRange.end);
                    }
                    if (num < start || num > end) {
                        needPush = false;
                        break;
                    }
                }
                if (needPush) {
                    result.push(item);
                }
            });
            return result;
        }
    });
(function () {
    'use strict';

    angular.module('c')
        .filter('strLimit', strLimit);

    /** @ngInject */
    function strLimit($filter) {
        return function (input, limit) {
            if (!input) return;
            if (angular.isUndefined(limit)) limit = 20;
            if (input.length <= limit) {
                return input;
            }

            return $filter('limitTo')(input, limit) + '...';
        }
    }

})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s').factory('Api', apiService);

    /** @ngInject */
    function apiService($ocLazyLoad, $compileProvider, toaster, ArrayHelper, Dlg) {
        var service = {

            setStop: setStop,
            /**
             * @deprecated 请用Dlg.delTableItem 替代
             */
            delTableItem: Dlg.delTableItem,
            /**
             * @deprecated 请用Dlg.addEdit 替代
             */
            addEdit: Dlg.addEdit,

            setDisable: setDisable,

            respMsg: respMsg,

            /**
             * @deprecated use Dlg.w instead
             */
            w: Dlg.w,
            /**
             * @deprecated use Dlg.e instead
             */
            e: Dlg.e,
            /**
             * @deprecated use Dlg.s instead
             */
            s: Dlg.s,
            /**
             * @deprecated use Dlg.i instead
             */
            i: Dlg.i,

            /**
             * @deprecated 请用Dlg.exportDR替代
             */
            exportDR: Dlg.exportDR,
            /**
             * @deprecated 请用Dlg.comment替代
             */
            comment: Dlg.comment,

            EDIT: {
                SAVE: 1,
                STOP: 2
            },

            param2Url: param2Url,

            //身份证检查和手机号码检查
            checkId: checkId,
            checkPhone: checkPhone,

            loadQuestionOpt: loadQuestionOpt,

            //数值转化
            numConversion: numConversion,

            loadMod: loadMod
        };

        return service;


        function loadMod(mod, fn) {
            var debugEnabled = $compileProvider.debugInfoEnabled();
            if (debugEnabled) {
                fn();
            } else {
                $ocLazyLoad.load(['/ocLazyLoad/mod/' + mod + '.js',
                    '/ocLazyLoad/mod/' + mod + '.css']).then(fn);
            }
        }

        function respMsg(resp) {
            if (resp.result === 0) {
                Dlg.s(resp.msg);
                return true;
            } else {
                Dlg.error(resp.msg);
                return false;
            }
        }

        /**
         * 停用/启用某数据项，
         * @param s 服务
         * @param m 数据项
         */
        function setStop(s, m) {
            s.update({id: m.id}, {opt: service.EDIT.STOP, is_stop: !(m.is_stop == '1')})
                .$promise.then(function (resp) {
                m.is_stop = resp.is_stop;
            });
        }

        /**
         * 利用ApiController新写法时推荐用此方法替代setStop
         * @param s service
         * @param m model
         */
        function setDisable(s, m) {
            s.update({id: m.id}, {op: 'disable', is_stop: !m.is_stop}).$promise.then(function (resp) {
                m.is_stop = !m.is_stop;
            });
        }

        ///////////////////////////////////////

        function param2Url(params) {
            var pairs = {};
            for (var key in params) {
                if (params.hasOwnProperty(key)) {
                    var item = params[key],
                        name = encodeURIComponent(key);
                    if (typeof item === "object") {
                        for (var subkey in item) {
                            if (!angular.isUndefined(item[subkey]) && item[subkey] !== "") {
                                var pname = name + "[" + encodeURIComponent(subkey) + "]";
                                pairs[pname] = item[subkey];
                            }
                        }
                    } else if (!angular.isFunction(item) && !angular.isUndefined(item) && item !== "") {
                        pairs[name] = encodeURIComponent(item);
                    }
                }
            }
            return pairs;
        }

        /////////////////////////////////////

        function checkPhone(phone) {
            var phoneCheck = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
            return phoneCheck.test(phone);
        }

        function checkId(pId) {
            //检查身份证号码
            pId = pId.toUpperCase();
            var arrVerifyCode = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
            var Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
            if (pId.length != 15 && pId.length != 18) return false;
            var Ai = pId.length == 18 ? pId.substring(0, 17) : pId.slice(0, 6) + "19" + pId.slice(6, 16);
            if (!/^\d+$/.test(Ai)) return false;
            var yyyy = Ai.slice(6, 10), mm = Ai.slice(10, 12) - 1, dd = Ai.slice(12, 14);
            var d = new Date(yyyy, mm, dd), now = new Date();
            var nowdate = now.getFullYear();
            var year = d.getFullYear(), mon = d.getMonth(), day = d.getDate();
            if (year != yyyy || mon != mm || day != dd || d > now || year < 1800) return false;
            if (nowdate - year < 14) return false;
            for (var i = 0, ret = 0; i < 17; i++) ret += Ai.charAt(i) * Wi[i];
            Ai += arrVerifyCode[ret %= 11];
            return pId.length == 18 && pId == Ai;
        }

        function numConversion(m, array) {
            angular.forEach(array, function (str) {
                m[str] = !m[str] || m[str] === '0' ? '未填' : m[str]
            });
        }


        ///////////////////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////////////////
        function loadQuestionOpt(vm) {
            vm.upOption = upOption;
            vm.downOption = downOption;
            vm.rmOption = rmOption;
            vm.addOption = addOption;
            vm.optionOnFocus = optionOnFocus;
            vm.correctOptionDesc = correctOptionDesc;
            vm.isMultiSelect = isMultiSelect;
            vm.checkMaxOptions = checkMaxOptions;
        }

        function upOption(question, index) {
            ArrayHelper.swap(question.options, index, index - 1);
        }

        function downOption(question, index) {
            ArrayHelper.swap(question.options, index, index + 1);
        }

        function rmOption(question, index) {
            if (question.options.length === 1) {
                toaster.warning('每个问题至少一个选项!');
            } else {
                question.options.splice(index, 1);
            }
        }

        function addOption(question) {
            question.options.push({
                desc: '选项' + (question.options.length + 1),
            });
        }

        function optionOnFocus(option, $index, $event) {
            if (option.desc === '选项' + $index) {
                $event.target.select();
            }
        }

        function correctOptionDesc(option, index) {
            if (!option.desc.length) {
                option.desc = '选项' + index;
            }
        }

        function isMultiSelect(question) {
            return question.type === 2;
        }

        function checkMaxOptions(question) {
            if (question.type === 2 && question.max_options) {
                if (question.max_options < 1) {
                    toaster.warning('最多可选不能小于2!');
                    question.max_options = '';
                } else if (question.max_options > question.options.length) {
                    toaster.warning('最多可选不能大于选项数!');
                    question.max_options = '';
                }
            }
            return true;
        }

    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s').factory('ArrayHelper', ArrayHelper);

    /** @ngInject */
    function ArrayHelper($timeout, $injector) {
        var service = {
            inArray: inArray,
            indexOf: inArray,
            except: except,
            getItem: getItem,
            indexOfKey: indexOfKey,
            findItem: findItem,
            getItems: getItems,
            listKey: listKey,
            get: get,
            swap: swap,
            mergeObj: mergeObj,
            bitwise2array: bitwise2array,
            array2bitwise: array2bitwise,
            shuffle: shuffle,
            map: map,
            memset: memset,
            filter: filter,
        };

        var l = null;
        $timeout(function () {
            var $http = $injector.get('$http');
            $http.get('json/options.json').success(function (resp) {
                l = resp;
            });
        });

        return service;


        function get(key) {
            return l[key];
        }

        function map(arr, mapFn) {
            var mapArr = [];
            angular.forEach(arr, function (item) {
                mapArr.push(mapFn(item));
            });
            return mapArr;
        }

        function filter(arr, filterFn) {
            var filterArr = [];
            angular.forEach(arr, function (item) {
                if (filterFn(item)) filterArr.push(item);
            });
            return filterArr;
        }

        function memset(arr, val, start, len) {
            if (angular.isUndefined(start)) start = 0;
            if (angular.isUndefined(len)) len = arr.length;

            for (var i = 0; i < len; i++) {
                arr[start + i] = val;
            }
        }

        /**
         * 打乱数组顺序
         * @param a
         */
        function shuffle(a) {
            var j, x, i;
            for (i = a.length; i; i--) {
                j = Math.floor(Math.random() * i);
                x = a[i - 1];
                a[i - 1] = a[j];
                a[j] = x;
            }
        }

        /**
         * 合并对象
         * @param o1
         * @param o2
         * @returns {*}
         */
        function mergeObj(o1, o2) {
            for (var key in o2) {
                o1[key] = o2[key]
            }
            return o1;
        }

        function array2bitwise(a) {
            var b = 0;
            for (var i = 0; i < a.length; i++) {
                if (a[i]) {
                    b |= (1 << i);
                }
            }
            return b;
        }

        /**
         * 位图转数组
         * @param b
         * @param n
         * @returns {Array}
         */
        function bitwise2array(b, n) {
            var a = [];
            for (var i = 0; i < n; i++) {
                a[i] = (b & 1) === 1;
                b >>= 1;
            }
            return a;
        }

        function swap(arr, indexA, indexB) {
            var temp = arr[indexA];
            arr[indexA] = arr[indexB];
            arr[indexB] = temp;
        }

        function inArray(val, arr) {
            var i = arr.length;
            while (i--) {
                if (angular.equals(val, arr[i])) return i;
            }
            return -1
        }

        function listKey(items, key) {
            if (typeof(key) === 'undefined') {
                key = 'id';
            }
            var i = -1;
            var result = [];
            while (++i < items.length) {
                result.push(items[i][key]);
            }
            return result;
        }

        function getItems(value, items, key) {
            if (typeof(key) === 'undefined') {
                key = 'id';
            }
            var i = -1;
            var result = [];
            while (++i < items.length) {
                if (items[i][key] == value) {
                    result.push(items[i]);
                }
            }
            return result;
        }

        function findItem(value, items) {
            var i = -1;
            while (++i < items.length) {
                if (items[i] == value)
                    return i;
            }
            return -1;
        }

        function except(exceptId, items) {
            var itemsExp = [];
            angular.forEach(items, function (item) {
                if (exceptId != item.id) {
                    itemsExp.push(item);
                }
            });
            return itemsExp;
        }

        function getItem(value, items, key) {
            if (typeof(key) === 'undefined') {
                key = 'id';
            }
            var i = -1;
            while (++i < items.length) {
                if (items[i][key] == value)
                    return items[i];
            }
            return null;
        }

        function indexOfKey(value, items, key) {
            if (typeof(key) === 'undefined') {
                key = 'id';
            }
            var i = -1;
            while (++i < items.length) {
                if (items[i][key] == value)
                    return i;
            }
            return -1;
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s').factory('Auth', Auth);

    /** @ngInject */
    function Auth($timeout, $injector, $localStorage, $sessionStorage) {
        var storage;
        var service = {
            CODE: {
                TOKEN_INVALID: 1,
                TOKEN_EXPIRED: 2,
                TOKEN_DEAD: 3,
                LOGIN: 4
            },

            setAccount: setAccount,
            getAccount: getAccount,
            getAutoLogin: getAutoLogin,
            setAutoLogin: setAutoLogin,
            getVisitCnt: getVisitCnt,
            setVisitCnt: setVisitCnt,
            setToken: setToken,
            getToken: getToken,
            hasToken: hasToken,
            deleteToken: deleteToken,
            register: register,
            login: login,
            logout: logout,
            refreshToken: refreshToken
            // getWechatAuthorizeUrl: getWechatAuthorizeUrl,
            // getWechatToken: getWechatToken,
            /**
             * 判断是否为微信浏览器
             * @returns {boolean}
             */
        };

        var $http;

        init();

        return service;


        function init() {
            storage = getAutoLogin() ? $localStorage : $sessionStorage;
        }

        function getHttp() {
            return $http ? $http : $injector.get('$http');
        }

        function logout(success) {
            getHttp().post('/auth/token/revoke').finally(function () {
                deleteToken();
                success();
            });
        }

        function refreshToken() {
            return getHttp().post('/auth/token/refresh')
        }

        function login(data, successFn, errorFn) {
            getHttp().post('/auth/token/issue', data).success(function (resp) {
                setAutoLogin(data.autoLogin);
                setToken(resp.token);
                setAccount(resp.account);
                if (successFn) {
                    successFn(resp);
                }
            }).error(function (resp) {
                if (errorFn) {
                    errorFn(resp);
                }
            });
        }

        function getAutoLogin() {
            return !!$localStorage.autoLogin;
        }

        function setAutoLogin(autoLogin) {
            $localStorage.$reset();
            autoLogin = !!autoLogin;
            $localStorage.autoLogin = autoLogin;
            storage = autoLogin ? $localStorage : $sessionStorage;
        }

        function register(data, success, error) {
            $http.post('/auth/register', data).success(success).error(error);
        }

        function deleteToken(excludeAccount) {
            delete storage.token;
            if (!excludeAccount) delete storage.account;
        }

        function hasToken() {
            return storage.token;
        }

        function getToken() {
            return storage.token;
        }

        function setToken(token) {
            storage.token = token;
        }

        function getVisitCnt() {
            if (storage.loginCnt) {
                return {loginCnt: storage.loginCnt, apiCnt: storage.apiCnt};
            }
            return undefined;
        }

        function setVisitCnt(loginCnt, apiCnt) {
            storage.loginCnt = loginCnt;
            storage.apiCnt = apiCnt;
        }

        function getAccount() {
            return storage.account || {};
        }

        function setAccount(account) {
            storage.account = account;
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s').factory('Checker', Checker);

    /** @ngInject */
    function Checker() {
        var service = {
            checkIp: checkIp
        };

        return service;


        function checkIp(ip) {
            var exp = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
            return ip.match(exp);
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s').factory('DateHelper', DateHelper);

    /** @ngInject */
    function DateHelper($filter, uibDateParser, $ocLazyLoad) {
        var service = {
            date2Str: date2Str,
            datetime2Str: datetime2Str,
            str2Date: str2Date,
            str2Datetime: str2Datetime,
            getDaysInMonth: getDaysInMonth,
            diffInDays: diffInDays,
            diffInHours: diffInHours,
            diffInMinutes: diffInMinutes,
            sec2MinSec: sec2MinSec,
            isSameDay: isSameDay,
            toLocalTime: toLocalTime,
            linarCalendar: linarCalendar,

            // todo: 设计一个统一接口, 获取常用特定日期
            getFirstDayOfLastMonth: getFirstDayOfLastMonth
        };

        return service;

        function getFirstDayOfLastMonth() {
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth();
            if (month === 0) {
                month = 12;
                year = year - 1;
            }
            return new Date(year, month - 1, 1, 0, 0, 0);
        }


        function sec2MinSec(sec) {
            var r = '';
            var m = Math.floor(sec / 60);
            if (m > 0) {
                r += m + '分';
            }
            var s = sec % 60;
            if (s > 0) {
                r += s + '秒';
            }
            return r;
        }

        function toLocalTime(utcTime) {
            var u = new Date(utcTime);
            var l = u.getTime() - (u.getTimezoneOffset() * 60000);
            l = new Date(l);
            return l;

        }

        function isSameDay(d1, d2) {
            return d1.getFullYear() === d2.getFullYear()
                && d1.getMonth() === d2.getMonth()
                && d1.getDate() === d2.getDate();
        }

        function diffInMinutes(start, end) {
            return Math.floor((end - start) / (1000 * 60));
        }

        function diffInHours(start, end) {
            return Math.floor((end - start) / (1000 * 60 * 60));
        }

        function diffInDays(start, end) {
            return Math.round((end - start) / (1000 * 60 * 60 * 24));
        }

        function getDaysInMonth(m, y) {
            return /8|3|5|10/.test(--m) ? 30 : m == 1 ? (!(y % 4) && y % 100) || !(y % 400) ? 29 : 28 : 31;
        }

        function date2Str(date, format) {
            if (angular.isUndefined(format)) format = 'yyyy-MM-dd';
            return $filter('date')(date, format);
        }

        function datetime2Str(datetime, format) {
            if (angular.isUndefined(format)) format = 'yyyy-MM-dd HH:mm';
            return $filter('date')(datetime, format);
        }

        function str2Date(str, format) {
            if (angular.isUndefined(format)) format = 'yyyy-MM-dd';
            return uibDateParser.parse(str, format);
        }

        function str2Datetime(str, format) {
            if (angular.isUndefined(format)) format = 'yyyy-MM-dd HH:mm';
            return uibDateParser.parse(str, format);
        }

        function linarCalendar(vm, lunarWeekdays, curr) {
            $ocLazyLoad.load(['lunarCalendar']).then(function () {
                vm.lunarCalendars = [];
                for (var i = 0; i < 7; i++) {
                    if (i == 0) {
                        var first = curr.getDate() - curr.getDay() + 1;
                        lunarWeekdays[i] = new Date(curr.setDate(first));
                    } else {
                        var prev = lunarWeekdays[i - 1];
                        var now = new Date(prev);
                        now.setDate(now.getDate() + 1);
                        lunarWeekdays[i] = now;
                    }
                    var d = lunarWeekdays[i];
                    var c = lunarCalendar.solar2lunar(d.getFullYear(), (d.getMonth() + 1), d.getDate());
                    var cStr = c.IMonthCn + ' ' + c.IDayCn;
                    vm.lunarCalendars.push(cStr);
                }
            });
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s').factory('Dlg', Dlg);

    /** @ngInject */
    function Dlg($q, FormHelper, dialogs, toaster) {
        var service = {
            show: ds,
            notify: dn,
            error: de,
            confirm: dc,

            w: w,
            e: e,
            s: s,
            i: i,

            //
            msg: msg,
            formError: formError,
            delTableItem: delTableItem,
            addEdit: addEdit,
            addEditOk: addEditOk,

            /**
             * @param pa 可填以下参数
             * title: 标题,
             * label: 文本标签, 默认: '理由说明',
             * icon:  font awesome图标, 默认: 'edit',
             * withRate: 是否打星, 默认: 否,
             * notRequired: 文本是否必填, 默认: 否
             * @param fn 回调函数, 参数option:
             * rate: 星级 1-5
             * opinion: 文本内容
             * @returns {*}
             */
            comment: comment,
            exportDR: exportDR,
            setReminder: setReminder,

            loadScrollbar: loadScrollbar,
        };

        return service;


        function addEditOk(vm, service, paFn, args) {
            var m, form, formIdSelector, op;
            if (angular.isDefined(args)) {
                op = args.op;
                /** @namespace args.formId */
                formIdSelector = '#' + (args.formId ? args.formId : 'Form');
                if (args.m) m = args.m;
                if (args.form) form = args.form;
            } else {
                op = 'default';
                formIdSelector = '#Form';
            }
            var closeFn = vm.close;
            if (!m) m = vm.m;
            if (!form) form = vm.Form;

            var defer = $q.defer();
            if (form.$valid) {
                var promise;
                var pa = paFn();
                if (m.id) { //修改
                    promise = service.update({id: m.id, op: op}, pa).$promise;
                } else { //添加
                    if (!pa.op) pa.op = op;
                    promise = service.save(pa).$promise;
                }
                promise.then(function (resp) {
                    if (resp.msg) {
                        s(resp.msg);
                    } else {
                        s('保存成功');
                    }
                    if (args && args.closePa) {
                        var closePa = args.closePa;
                        closeFn(closePa instanceof Function ? closePa(resp) : closePa);
                    } else {
                        closeFn(resp);
                    }
                }, function (error) {
                    var data = error.data;
                    if (data.msg) de(data.msg);
                }).finally(function () {
                    defer.resolve();
                });
            } else {
                FormHelper.handleError(formIdSelector, form);
                defer.reject();
            }
            return defer.promise;
        }

        /**
         * @deprecated 请使用 dlgri 模板
         * 删除表格中的数据项
         * @param s 服务
         * @param id 数据项id
         * @param vm 关联vm
         * @param itemType 数据项类型名称
         * @param itemName 数据项名称
         */
        function delTableItem(s, id, vm, itemType, itemName) {
            dialogs.confirm('删除' + itemType, '确定要删除<strong>' + itemName + '</strong>'
                + itemType + '吗？')
                .result.then(function () {
                s.delete({id: id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            vm.tableReload();
                            toaster.success(resp.msg);
                            break;
                        default:
                            toaster.warning(resp.msg);
                    }
                });
            });
        }

        function addEdit(vm, dlg, dlgCtrl, m, data, dlgSiz, cb) {
            var pa = data ? data : {};
            if (m) pa.id = m.id;
            if (!dlgSiz) dlgSiz = 'md';
            return dialogs.create(dlg, dlgCtrl, pa,
                {size: dlgSiz}, 'vm').result.then(function (resp) {
                vm.tableReload();
                if (cb) cb(resp);
            });
        }

        /**
         * @param pa 可填以下参数
         * title: 标题,
         * label: 文本标签, 默认: '理由说明',
         * icon:  font awesome图标, 默认: 'edit',
         * withRate: 是否打星, 默认: 否,
         * notRequired: 文本是否必填, 默认: 否
         * @param fn 回调函数, 参数option:
         * rate: 星级 1-5
         * opinion: 文本内容
         * @returns {*}
         */
        function comment(pa, fn) {
            return dialogs.create('pages/dialogs/comment/commentDlg.html', 'CommentDlgCtrl', pa, {
                size: 'md'
            }, 'vm').result.then(fn);
        }

        function exportDR(urlOrParams, title, start, end, icon) {
            var params = urlOrParams !== null && typeof urlOrParams === 'object' ?
                urlOrParams : {title: title, url: urlOrParams, icon: icon, start: start, end: end};

            return dialogs.create('pages/dialogs/export/dateRangeDlg.html', 'EDRCtrl',
                params, {size: 'md'}, 'vm');
        }

        function setReminder(service, event, users, title, label) {
            return dialogs.create('pages/dialogs/eventReminderDlg.html', 'eventReminderDlgCtrl',
                {service: service, event: event, title: title, users: users, label: label},
                {size: 'md'}, 'vm');
        }

        function loadScrollbar(vm) {
            if (window.innerWidth < 568) {
                vm.bodyStyle = {
                    'min-height': window.innerHeight - 200,
                    width: window.innerWidth - 40
                };
            } else {
                vm.bodyStyle = {
                    height: 480
                };
            }
        }


        function msg(title, body, hideFn, noSound) {
            toaster.pop({
                title: title, body: body, bodyOutputType: 'trustedHtml', toasterId: 1,
                clickHandler: function (toast, isCloseButton) {
                    if (!isCloseButton && !angular.isUndefined(hideFn)) {
                        hideFn();
                    }
                    return true;
                },
                onShowCallback: function () {
                    if (!noSound) {
                        document.getElementById('msgTone1').play();
                    }
                }
            });
        }

        function formError() {
            toaster.error("有项目填错了亲,请检查表单上的提示哟^-^!");
        }

        function w(msg) {
            toaster.warning(msg);
        }

        function e(msg) {
            toaster.error(msg);
        }

        function s(msg) {
            toaster.success(msg);
        }

        function i(msg) {
            toaster.info(msg);
        }

        /**
         * 显示对话框
         * @param pa： backdrop: true(非模态) false(无背景) 'static'(默认，模态)
         * @returns {*}
         */
        function ds(pa) {
            var options = {};
            if (pa.name) {
                pa.ctrl = pa.name + 'Ctrl';
                if (!pa.template) pa.template = pa.name;
            }
            if (!pa.data) pa.data = {};
            if (!pa.size) options.size = 'md';
            else options.size = pa.size;
            if (pa.backdrop) options.backdrop = pa.backdrop;
            switch (pa.pos) {
                case 'right':  // 目前仅支持right
                    options.windowClass = 'modal-right';
                    options.backdropClass = 'modal-backdrop-light';
            }
            if (pa.size === 'full') options.windowClass += ' modal-full';
            return dialogs.create(pa.template, pa.ctrl, pa.data, options, 'vm').result;
        }

        function dn(msg, title) {
            if (angular.isUndefined(title)) {
                title = "提示";
            }
            return dialogs.notify(title, msg).result;
        }

        function de(msg, title) {
            if (angular.isUndefined(title)) {
                title = "出错了";
            }
            return dialogs.error(title, msg).result;
        }

        function dc(msg, cb, title, error) {
            if (angular.isUndefined(title)) {
                title = "提示";
            }
            return dialogs.confirm(title, msg).result.then(cb, error);
        }


    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s').factory('FileHelper', fileService);

    /** @ngInject */
    function fileService($q, $http, Upload, SaveAs, C, dialogs, toaster) {
        var service = {
            uploadSingle: uploadSingle,
            uploadAttachment: uploadAttachment,
            uploadCroppedImage: uploadCroppedImage,

            isAttachmentsUploaded: isAttachmentsUploaded,
            upload: upload,
            upload1: upload1,

            dnExcel: dnExcel,
            download: download,
            download1: download1,
            getPublicLink: getPublicLink
        };

        return service;

        function getPublicLink(filename) {
            return $http.post('api/v1/file/preview/mk_pub_link', {filename: filename});
        }

        function download(url, data, success, error) {
            $http({
                url: url,
                method: "POST",
                data: data,
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).success(success).error(error);
        }

        function dnExcel(url, params, filename, cb) {
            return $http({
                url: url,
                method: "POST",
                data: params,
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).success(function (resp) {
                var data = [resp];
                var options = {type: 'vnd.ms-excel'};
                SaveAs.download(data, filename, options);
                if (cb) cb();
            });
        }

        /**
         * 上传裁剪后的图片
         * @param image->json, 其中需要填写的属性包括toUrl:上传地址，croppedDataUrl：裁剪后生成的url
         * @returns {*}
         */
        function uploadCroppedImage(image) {
            var defer = $q.defer();

            var file = Upload.dataUrltoBlob(image.croppedDataUrl);

            if (image.inProgress) {
                defer.reject("正在上传，请稍后再试");
            } else {
                if (!file.$error) {
                    image.inProgress = true;
                    Upload.upload({
                        url: image.toUrl, data: {file: file}
                    }).progress(function (evt) {
                        image.progress = parseInt(100.0 * evt.loaded / evt.total);
                    }).success(function (resp) {
                        defer.resolve(resp);
                    }).error(function () {
                        defer.reject("服务器错误");
                    }).finally(function () {
                        image.inProgress = false;
                    });
                } else {
                    defer.reject("图片不能大于20M");
                }
            }
            return defer.promise;
        }

        function uploadAttachment(file, data, e, extra) {
            service.upload(C.URL.UPLOAD_ATTACHMENT, file, data, e, extra);
        }

        function uploadSingle(file, data, e, rename, extra) {
            return service.upload1(C.URL.UPLOAD_ATTACHMENT, file, data, e, rename, extra);
        }

        function mergeObj(o1, o2) {
            for (var key in o2) {
                o1[key] = o2[key]
            }
            return o1;
        }


        /**
         * 对多附件上传的封装
         * @param url
         * @param file
         * @param data
         * @param e
         * @param extra
         */
        function upload(url, file, data, e, extra) {
            if (e && e[0] && e[0].$error === 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }

            if (file === null) return;

            var attachment = {name: file.name, progress: 0};
            data.attachments.push(attachment);
            var pa = {
                url: url, file: file
            };

            if (extra) pa.data = {extra: extra};

            Upload.upload(pa).progress(function (evt) {
                attachment.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        attachment.name = resp.name;
                        attachment.mime = resp.mime;
                        attachment.filename = resp.filename;
                        attachment.size = resp.size;
                        break;
                    case 1:
                        attachment.progress = 101;
                        attachment.errorInfo = '服务器空间不足!';
                        break;
                }
            }).error(function () {
                attachment.progress = 102;
                attachment.errorInfo = '服务器错误!';
            });
        }

        /**
         * @deprecated
         * 用于单个附件上传
         * @param url
         * @param file
         * @param data 附件依附对象，其各字段标准为attach_name（附件名称），mime，filename（服务器路径），size
         * @param e
         * @param rename
         * @param extra 额外参数
         */
        function upload1(url, file, data, e, rename, extra) {
            if (file == null) {
                return;
            }

            if (angular.isUndefined(rename) || !rename) {
                rename = {};
            }
            if (!rename.name) rename.name = 'attach_name';
            if (!rename.mime) rename.mime = 'mime';
            if (!rename.filename) rename.filename = 'filename';
            if (!rename.size) rename.size = 'size';
            if (e && e[0] && e[0].$error == 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }
            data.progress = 0;
            var pa = {file: file, id: data.id, remap: rename};
            if (angular.isDefined(extra) && extra) {
                mergeObj(pa, extra);
            }
            delete data[rename.filename];
            var defer = $q.defer();
            Upload.upload({
                url: url, data: pa
            }).progress(function (evt) {
                data.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        data[rename.name] = resp[rename.name];
                        data[rename.mime] = resp[rename.mime];
                        data[rename.filename] = resp[rename.filename];
                        data[rename.size] = resp[rename.size];
                        defer.resolve(data);
                        break;
                    case 1:
                        data.progress = 101;
                        data.errorInfo = '服务器空间不足!';
                        defer.reject();
                        break;
                }
            }).error(function () {
                defer.reject();
                data.progress = 102;
                data.errorInfo = '服务器错误!';
            });

            return defer.promise;
        }

        /**
         * 检查多附件上传中，所有附件是否都已上传并返回服务器文件路径
         * @param data
         * @param attachmentField
         * @returns {boolean}
         */
        function isAttachmentsUploaded(data, attachmentField) {
            if (angular.isUndefined(attachmentField)) attachmentField = 'attachments';
            for (var i = 0; i < data[attachmentField].length; i++) {
                if (!data[attachmentField][i].filename) {
                    return false;
                }
            }
            return true;
        }

        /**
         * 下载文件
         * @param url 文件资源地址
         * @param data 文件信息数据
         * @param rename 重命名文件信息数据中的字段
         */
        function download1(url, data, rename) {
            if (angular.isUndefined(rename)) {
                rename = {};
            }
            if (!rename.name) rename.name = 'name';
            if (!rename.mime) rename.mime = 'mime';
            if (!rename.filename) rename.filename = 'filename';
            if (!rename.size) rename.size = 'size';
            var params = {name: data[rename.name], filename: data[rename.filename], mime: data[rename.mime]};
            data.downloading = true;
            $http({
                url: url,
                method: "POST",
                data: params,
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).success(function (resp) {
                data.downloading = false;
                SaveAs.download([resp], data[rename.name], {type: data[rename.mime]});
            }).error(function (error) {
                data.downloading = false;
                toaster.error('文件丢失');
            });
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s').factory('FormHelper', FormHelper);

    /** @ngInject */
    function FormHelper($q, $timeout, $location, $anchorScroll, toaster) {
        var service = {
            handleError: handleError,
            handleSubmit: handleSubmit,
            deleteAttachment: deleteAttachment
        };

        return service;


        function deleteAttachment($index, m) {
            m.attachments.splice($index, 1);
        }

        function handleSubmit(vm, cb, args) {
            var form, formIdSelector, skipTip = false;
            if (angular.isDefined(args)) {
                /** @namespace args.formId */
                formIdSelector = '#' + (args.formId ? args.formId : 'Form');
                if (args.form) form = args.form;
                skipTip = !!args.skipTip;
            } else {
                formIdSelector = '#Form';
            }
            if (!form) form = vm.Form;

            var defer = $q.defer();
            if (form.$valid) {
                if (cb) cb(defer);
            } else {
                if (skipTip) {
                    form.$submitted = true;
                } else {
                    service.handleError(formIdSelector, form);
                }
                defer.reject();
            }
            return defer.promise;
        }


        function handleError(formIdSelector, form) {
            $timeout(function () {
                var firstInvalid = angular.element(formIdSelector)[0].querySelector('.ng-invalid');

                if (firstInvalid) {
                    if ($location.hash() !== firstInvalid.id) {
                        $location.hash(firstInvalid.id);
                    }
                    $anchorScroll();
                    firstInvalid.focus();
                }
            });
            toaster.error("有项目填错了亲,请检查表单上的提示哟^-^!");
            form.$submitted = true;
            form.submitted = true;
        }
    }
})();

/**
 * @deprecated 1.模块相关的服务应当放在模块的服务中，而不是这里；
 * 2.不同功能的公共方法应该按功能分类，而不是统一放在这里，
 * 所以F服务从此废弃，不要在往里面放东西了，也尽量不要再用它了。
 */
angular.module('c.s')
    .factory('F', function (ArrayHelper, Table, UIHelper, uibDateParser) {
        return {
            /**
             * @deprecated ArrayHelper.inArray 替代
             */
            inArray: ArrayHelper.inArray,
            /**
             * @deprecated ArrayHelper.indexOf 替代
             */
            indexOf: ArrayHelper.inArray,
            /**
             * @deprecated UIHelper.getIconFromMime 替代
             */
            getIconFromMime: UIHelper.getIconFromMime,
            /**
             * @deprecated Table.getNgTableOpts 替代
             */
            getNgTableOpts: Table.getNgTableOpts,
            /**
             * @deprecated ArrayHelper.except 替代
             */
            except: ArrayHelper.except,
            /**
             * @deprecated 使用Array.getItem替代
             */
            getItem: ArrayHelper.getItem,
            /**
             * @deprecated 使用Array.indexOfKey 替代
             */
            indexOfKey: ArrayHelper.indexOfKey,
            /**
             * @deprecated 使用Array.findItem 替代
             */
            findItem: ArrayHelper.findItem,
            /**
             * @deprecated 使用Array.getItems 替代
             */
            getItems: ArrayHelper.getItems,
            /**
             * @deprecated 使用Array.listKey 替代
             */
            listKey: ArrayHelper.listKey,
            /**
             * @deprecated 使用Array.get 替代
             */
            get: ArrayHelper.get,
            /**
             * @deprecated
             * 通知审批阶段列表
             * @returns {*[]}
             */
            getApprovalStages1: function (appendOverStage) {
                var states = ArrayHelper.get('approval_stages1');
                if (appendOverStage) {
                    var arr = angular.copy(states);
                    arr.push({id: '5', name: '已结束'});
                    return arr;
                }
                return states;
            },
            /**
             * @deprecated 使用 UIHelper.getProgressType 替代
             */
            getProgressType: UIHelper.getProgressType,
            /**
             * @deprecated 使用 UIHelper.loadTabs 替代
             */
            loadTabs: UIHelper.loadTabs,
            /**
             * @deprecated 使用  UIHelper.loadTab 替代
             */
            loadTab: UIHelper.loadTab,
            bitwise2array: ArrayHelper.bitwise2array,
            array2bitwise: ArrayHelper.array2bitwise,
            checkTime: function (dateTime, beginTime, endTime) {
                var bd = uibDateParser.parse(beginTime, 'HH:mm');
                var ed = uibDateParser.parse(endTime, 'HH:mm');
                var nd = uibDateParser.parse(dateTime, 'HH:mm');
                if (bd > ed && nd > bd) {
                    var edNew = ed.getTime() + 24 * 60 * 60 * 1000;
                    ed = new Date(edNew);
                }
                if (bd > ed && nd < ed) {
                    var bdNew = bd.getTime() - 24 * 60 * 60 * 1000;
                    bd = new Date(bdNew);
                }
                return nd > bd && nd < ed;
            },
            toFixed: function (floatNum, decimal) {
                if (angular.isUndefined(decimal)) decimal = 2;
                return parseFloat(floatNum.toFixed(decimal));
            },
            getParent: function getParent(type) {
                if (type.parent) {
                    return getParent(type.parent);
                }
                return type;
            }
        };
    });


/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s').factory('PrintHelper', Print);

    /** @ngInject */
    function Print($timeout, $templateRequest, $sce, SaveAs, $ocLazyLoad) {
        var service = {
            print: print,
            printAsWord: printAsWord,
            STYLE: {
                TEMP2: 'templates/print/table2.html'
            }
        };

        return service;


        function printAsWord(name, styleFile, createBody) {
            if (!!styleFile) {
                var templateUrl = $sce.getTrustedResourceUrl(styleFile, '');
                $templateRequest(templateUrl).then(function (resp) {
                    var printStyle = resp;
                    var html = '<!DOCTYPE html><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"></head><body>';
                    html += createBody();
                    html += '</body></html>';
                    $ocLazyLoad.load('/ocLazyLoad/html2Doc/html-docs.min.js').then(function () {
                        var converted = htmlDocx.asBlob(html + printStyle);
                        SaveAs.download(converted, name + '.docx');
                    });
                });
            } else {
                var html = '<!DOCTYPE html><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"></head><body>';
                html += createBody();
                html += '</body></html>';
                $ocLazyLoad.load('/ocLazyLoad/html2Doc/html-docs.min.js').then(function () {
                    var converted = htmlDocx.asBlob(html);
                    SaveAs.download(converted, name + '.docx');
                });
            }
        }

        /**
         * @param w, 已打开窗口
         * @param styleFileOrCB
         * @param createBody:function, 创建<body>元素内的html并返回
         */
        function print(w, styleFileOrCB, createBody) {
            if (typeof styleFileOrCB === "function") {
                createBody = styleFileOrCB;
                styleFileOrCB = service.STYLE.TEMP2;
            }

            if (styleFileOrCB) {
                var templateUrl = $sce.getTrustedResourceUrl(styleFileOrCB, '');
                $templateRequest(templateUrl).then(function (resp) {
                    var printStyle = resp;
                    var html = '<html><body>';
                    html += createBody();
                    html += '</body></html>';
                    w.document.write(html + printStyle);
                    w.document.close();
                    w.focus();
                    $timeout(function () {
                        w.print();
                        w.close();
                    }, 24);
                });
            } else {
                var html = '<html><body>';
                html += createBody();
                html += '</body></html>';
                w.document.write(html);
                w.document.close();
                w.focus();
                $timeout(function () {
                    w.print();
                    w.close();
                }, 24);
            }
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s').factory('Table', TableHelper);

    /** @ngInject */
    function TableHelper(NgTableParams) {
        return {
            _1_BTN: 48,
            _2_BTN: 78,
            _3_BTN: 108,
            _4_BTN: 140,
            _5_BTN: 172,
            _6_BTN: 208,

            _1_CHAR: 48,
            _2_CHAR: 72,
            _3_CHAR: 96,
            _4_CHAR: 128,
            _5_CHAR: 170,

            loadMultiSelectedFn: loadMultiSelectedFn,
            getTableData: getTableData,
            /**
             * 方便ngTable获取数据
             * @param service 服务名称
             * @param url 参数
             * @param $defer ngTable的参数
             * @param params ngTable的参数
             * @param items 获取的主要数据项，字符串
             * @param cb 回调函数，可选
             */
            query: queryItems,

            /**
             * @deprecated
             * 加载ngTable
             * @param scope
             * @param options 配置选项
             *  *cols: 数据项
             *  *service： 查询的服务名称，params：查询的额外参数，如opt等，*items：返回的主要数据项名称，注意是string类型
             *  optColWidth：操作列宽度，hideOpt：是否隐藏操作列，hideFilter：是否隐藏过滤行，justDataCol：是否只显示数据列
             *  count： 分页显示时初始每页显示数据条数（默认10），sorting：排序方式（默认 {created_at: 'desc'}）， filter: 初始过滤,
             *  counts: 分页页数选择（默认[10, 30, 50]）, dateFilters：日期范围过滤器数组,
             *  primaryParam: 如果指定了该参数并且params参数列表中该参数为空，则返回暂无数据
             * @param cb 回调函数
             */
            loadNgTable: loadNgTable
            ,
            /**
             * 加载ngtable，后台分页
             * @param scope
             * @param options 配置选项
             *  *cols: 数据项
             *  *service： 查询的服务名称，params：查询的额外参数，如opt等，*items：返回的主要数据项名称，注意是string类型
             *  optColWidth：操作列宽度，hideOpt：是否隐藏操作列，hideFilter：是否隐藏过滤行，showSn：是否显示序号列
             *  cbWidth: 多选列表中checkbox列宽度
             *  count： 分页显示时初始每页显示数据条数（默认10），sorting：排序方式（默认 {created_at: 'desc'}）， filter: 初始过滤,
             *  counts: 分页页数选择（默认[10, 30, 50]）
             *  primaryParam: 如果指定了该参数并且params参数列表中该参数为空，则返回暂无数据
             *  primaryFilter: 如果filter中该过滤项为空，则返回暂无数据
             * @param cb 回调函数
             */
            load: loadTable,
            loadItem: loadItem,
            getNgTableOpts: getNgTableOpts
        };

        function loadItem(resp, startSn, cb) {
            angular.forEach(resp.items, function (item, i) {
                item.sn = startSn + i + 1;
                if (cb) cb(item, i);
            });
        }

        function getNgTableOpts(items) {
            var data = [{id: '', title: '-'}];
            angular.forEach(items, function (item) {
                data.push({id: item.id, title: item.name});
            });
            return data;
        }

        function loadMultiSelectedFn(scope) {
            scope.header = {checkAll: false};
            scope.checkOneFn = function (item, items) {
                if (item.is_checked) {
                    scope.header.checkAll = true;
                } else {
                    var allUnchecked = true;
                    for (var i = 0; i < items.length; i++) {
                        if (items[i].is_checked) {
                            allUnchecked = false;
                            break;
                        }
                    }
                    if (allUnchecked) {
                        scope.header.checkAll = false;
                    }
                }
            };
            scope.checkAllFn = function (checkAll, items) {
                if (checkAll) {
                    angular.forEach(items, function (item) {
                        item.is_checked = true;
                    })
                } else {
                    angular.forEach(items, function (item) {
                        item.is_checked = false;
                    })
                }
            };
            return {
                hasChecked: function () {
                    return scope.header.checkAll;
                },
                clearChecked: function (items) {
                    scope.header.checkAll = false;
                    if (!items) items = scope.tableParams.data;
                    angular.forEach(items, function (item) {
                        item.is_checked = false;
                    });
                },
                getCheckedIds: function (items, stage) {
                    var ids = [];
                    if (!items) items = scope.tableParams.data;
                    angular.forEach(items, function (item) {
                        if (item.is_checked && (!stage || (stage && item.stage.id == stage))) {
                            ids.push(item.id);
                        }
                    });
                    return ids;
                },
                getChecked: function (items, stage) {
                    var checked = [];
                    if (!items) items = scope.tableParams.data;
                    angular.forEach(items, function (item) {
                        if (item.is_checked && (!stage || (stage && item.stage.id == stage))) {
                            checked.push(item);
                        }
                    });
                    return checked;
                }
            }
        }

        function getTableData(data, $defer, params, $filter) {
            if ($filter) {
                data = params.filter() ?
                    $filter('filter')(data, params.filter()) :
                    data;
                data = params.sorting() ?
                    $filter('orderBy')(data, params.orderBy()) : data;
            }
            params.total(data.length);
            if (params.page() > Math.ceil(data.length / params.count())) {
                params.$params.page = params.page() - 1;
            }
            if (params.page() == 0) {
                params.$params.page = 1;
            }
            $defer.resolve(data.slice((params.page() - 1) * params.count(),
                params.page() * params.count()));
        }

        function loadTable(scope, options, cb) {
            scope.cols = options.cols;
            angular.forEach(scope.cols, function (col) {
                if (typeof col.show === 'undefined') {
                    col.show = true;
                }
            });
            scope.optColWidth = options.optColWidth;
            scope.hideOpt = options.hideOpt;
            scope.hideFilter = options.hideFilter;
            scope.showSn = options.showSn;
            scope.optInFront = options.optInFront;
            scope.cbWidth = options.cbWidth ? options.cbWidth : 62;
            scope.tableParams = new NgTableParams({
                count: options.count ? options.count : 10, sorting: options.sorting ? options.sorting : {
                    id: 'desc'
                }, filter: options.filter ? options.filter : {}
            }, {
                counts: options.counts ? options.counts : [10, 30, 50],
                getData: function ($defer, params) {
                    if ((options.primaryParam && !options.params[options.primaryParam]) || (
                        options.primaryFilter && !params.filter()[options.primaryFilter]
                    )) {
                        //return $defer.resolve([]);
                    } else {
                        var url = params.url();
                        for (var index in options.params) {
                            url[index] = options.params[index];
                        }
                        return queryItems(options.service, url, $defer, params, null, cb);
                    }
                }
            });

            scope.clearFilters = function () {
                scope.tableParams.filter({});
            };

            scope.tableReload = function () {
                scope.tableParams.reload();
            };

            return {
                options: function () {
                    return options;
                }
            }
        }

        function loadNgTable(scope, options, cb) {
            scope.cols = options.cols;
            angular.forEach(scope.cols, function (col) {
                if (typeof col.show === 'undefined') {
                    col.show = true;
                }
            });
            if (options.dateFilters) {
                scope.dateRangeFilter = {};
                scope.$watch('dateRangeFilter',
                    function () {
                        scope.tableParams.reload();
                    }, true
                );
            }
            scope.optColWidth = options.optColWidth;
            scope.hideOpt = options.hideOpt;
            scope.hideFilter = options.hideFilter;
            scope.justDataCol = options.justDataCol;
            scope.tableParams = new NgTableParams({
                page: 1, count: options.count ? options.count : 10, sorting: options.sorting ? options.sorting : {
                    created_at: 'desc'
                }, filter: options.filter ? options.filter : {}
            }, {
                counts: options.counts ? options.counts : [10, 30, 50], total: 0,
                getData: function ($defer, params) {
                    if (options.primaryParam && !options.params[options.primaryParam]) {
                        $defer.resolve([]);
                    } else {
                        var url = params.url();
                        for (var index in options.params) {
                            url[index] = options.params[index];
                        }
                        if (options.dateFilters != null && options.dateFilters.length > 0) {
                            angular.forEach(options.dateFilters, function (d) {
                                if (scope.dateRangeFilter[d.name] != null) {
                                    var start = d.start;
                                    var end = d.end;
                                    if (!start) start = 'startDate';
                                    if (!end) end = 'endDate';
                                    url[start] = $filter('date')(scope.dateRangeFilter[d.name][start], 'yyyy-MM-dd');
                                    url[end] = $filter('date')(scope.dateRangeFilter[d.name][end], 'yyyy-MM-dd');
                                }
                            });
                        }
                        queryItems(options.service, url, $defer, params, options.items, cb);
                    }
                }
            });

            scope.clearFilters = function () {
                scope.tableParams.filter({});
                if (options.dateFilters) {
                    scope.dateRangeFilter = {};
                }
            };

            scope.clearReload = function () {
                if (angular.equals(scope.tableParams.filter(), {}) &&
                    (!scope.dateRangeFilter || angular.equals(scope.dateRangeFilter, {}))) {
                    scope.tableReload();
                } else {
                    scope.clearFilters();
                }
            };

            scope.tableReload = function () {
                scope.tableParams.reload();
            };

            return {
                options: function () {
                    return options;
                }
            }
        }

        function queryItems(service, url, $defer, params, items, cb) {
            if (items === null) {
                items = 'items';
            }
            service.query(url, function (data) {
                if (data.total > 0 && data[items].length === 0) {
                    params.$params.page = params.page() - 1;
                    params.reload();
                } else {
                    params.total(data.total);
                    if (angular.isDefined(cb)) {
                        cb(data, (params.page() - 1) * params.count());
                    }
                    $defer.resolve(data[items]);
                }
            });
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s')
        .factory('UIHelper', UIHelper)
        .controller('UploadWordImagesDlg', UploadWordImagesDlg)

    ;

    /** @ngInject */
    function UIHelper(ArrayHelper, $rootScope, $location, deviceDetector, OS, Upload, dialogs) {
        var curExtraParam = null;
        var service = {
            getIconFromMime: getIconFromMime,
            getProgressType: getProgressType,
            isTooDark: isTooDark,
            scrollTo: scrollTo,

            tabTo: tabTo,
            loadTabs: loadTabs,
            loadTab: loadTab,
            hasTabExtra: hasTabExtra,
            getTabExtra: getTabExtra,

            onCKReady: onCKReady,
            initCKEditor: initCKEditor
        };

        return service;

        function setResponsive(el) {
            if (el.children && el.children.length > 0) {
                angular.forEach(el.children, function (child) {
                    setResponsive(child);
                });
            } else {
                if (el.name !== 'img') return;
                el.addClass('img-responsive');
            }
        }

        function initCKEditor() {
            // 响应式
            CKEDITOR.on('instanceReady', function (ev) {
                ev.editor.dataProcessor.htmlFilter.addRules({
                    elements: {
                        $: setResponsive
                    }
                });
            });
        }

        function onCKReady(editor) {
            editor = CKEDITOR.instances[editor];
            if (!editor) return;

            //目前只支持桌面
            if (deviceDetector.isDesktop()) {
                editor.on('afterInsertHtml', function (evt) {
                    // 解决从word拷贝图片的问题...
                    var editable = editor.editable();
                    var imgList = editable.find('img').$;
                    var localImgList = {};
                    angular.forEach(imgList, function (img) {
                        if (img.src.match(/^file:\/\//)) {
                            if (ArrayHelper.indexOfKey(img.src, localImgList, 'src') === -1) {
                                var filename = img.src.replace(/^.*(\\|\/|\:)/, '');
                                localImgList[filename] = img;
                            }
                        }
                    });
                    if (Object.keys(localImgList).length > 0) {
                        if (editor.commands.maximize.state === 1) {
                            editor.execCommand('maximize');
                        }

                        var files = [], startIndex = 7, changeSeparator = false;
                        if (deviceDetector.os === OS.WINDOWS) {
                            startIndex = 8;
                            changeSeparator = true;
                        }
                        var names = Object.keys(localImgList);
                        angular.forEach(names, function (name) {
                            var img = localImgList[name];
                            var path = img.src.substr(startIndex);
                            if (changeSeparator) {
                                path = path.replace(/\//g, "\\");
                            }
                            files.push({name: name, path: path});
                        });
                        dialogs.create('templates/upload/word_images_dlg.html', 'UploadWordImagesDlg', {
                            files: files
                        }, {
                            size: 'md'
                        }).result.then(function (result) {
                            var widgets = editor.widgets.instances,
                                curWidget,
                                i;
                            for (i in widgets) {
                                curWidget = widgets[i];
                                if (curWidget.definition.name === 'image') {
                                    var name = curWidget.parts.image.getAttribute('src').replace(/^.*(\\|\/|\:)/, '');
                                    var url = result[name];
                                    if (url) {
                                        curWidget.setData('src', url);
                                    }
                                }
                            }
                            editor.fire('change');
                        });
                    }
                });
            }

            editor.on('fileUploadRequest', function (evt) {
                var loader = evt.data.fileLoader;
                var file = Upload.dataUrltoBlob(loader.data);
                file.name = loader.file.name;
                Upload.upload({
                    url: loader.uploadUrl, data: {file: file}
                }).progress(function (evt) {
                    if (!loader.uploadTotal) loader.uploadTotal = evt.total;
                    loader.uploaded = evt.loaded;
                    loader.update();
                }).success(function (resp) {
                    loader.responseData = resp;
                    if (resp.error && resp.error.message) {
                        loader.message = resp.error.message;
                    }
                    if (resp.result === 1) { // 错误
                        evt.cancel();
                        loader.changeStatus('error');
                    } else {
                        loader.url = resp.url;
                        loader.fileName = resp.fileName;
                        loader.changeStatus('uploaded');
                        editor.fire('change');
                    }
                }).error(function () {
                    loader.changeStatus('error');
                });
                evt.stop();
            });
        }

        // for ui bootstrap 1.3.3
        function loadTabs($scope, $stateParams) {
            var vm = $scope;
            vm.curTab = $stateParams.tab;
            curExtraParam = $stateParams.data.extra;
            vm.tabSelected = tabSelected;

            $scope.$on('tabChange', function (event, pa) {
                var tab = pa.tab;
                curExtraParam = pa.extra;

                // 如果当前标签页正好是审批提醒跳转标签页,则直接发广播,触发刷新;否则改变标签页,通过tabSelected触发刷新
                if (vm.curTab === tab) {
                    $rootScope.$broadcast("reload", {tab: tab, extra: curExtraParam});
                } else {
                    vm.curTab = tab;
                }
            });

            /**
             * 记录选择的标签页，并触发该页面的重新加载事件
             * <strong>注意：这个函数必须应用的标签页上</strong>
             * @param tab
             * @param skipReloadContent 不触发标签内容更新
             */
            function tabSelected(tab, skipReloadContent) {
                $location.search('tab', tab);
                if (!skipReloadContent) {
                    $rootScope.$broadcast("reload", {tab: tab, extra: curExtraParam});
                }
            }
        }

        function loadTab($scope, tab, reloadFn) {
            var vm = $scope;
            $scope.$on("reload", function (event, data) {
                var tabTo = data.tab;
                if (tabTo === tab) {
                    if (reloadFn) {
                        if (reloadFn(data.extra)) curExtraParam = null;
                    } else {
                        vm.tableReload();
                    }
                }
            });
        }

        function hasTabExtra() {
            return curExtraParam !== null && typeof curExtraParam
                !== 'undefined' && !angular.equals(curExtraParam, {});
        }

        function getTabExtra() {
            return curExtraParam;
        }

        function tabTo(tab, extra) {
            $rootScope.$broadcast('tabChange', {tab: tab, extra: extra});
        }

        function scrollTo(toElemId, scrollableBodyId, offset, duration) {
            if (angular.isUndefined(scrollableBodyId)) scrollableBodyId = '.modal-body';
            else scrollableBodyId = '#' + scrollableBodyId;
            if (angular.isUndefined(offset)) offset = 0;
            if (angular.isUndefined(duration)) duration = 200;
            var scrollableBody = angular.element(scrollableBodyId)[0];
            var toElemOffset = angular.isUndefined(toElemId) ? 0 :
                angular.element('#' + toElemId)[0].offsetTop;

            var currentTime = 0;
            var increment = 2;
            var from = scrollableBody.scrollTop;
            var to = toElemOffset - offset;
            var change = to - from;

            function __scrollTo() {
                currentTime += increment;
                scrollableBody.scrollTop = __easeInOutQuad(currentTime, from, change, duration);
                if (currentTime < duration) {
                    setTimeout(__scrollTo, increment)
                }
            }

            __scrollTo();
        }

        // t = current time
        // b = start value
        // c = change in value
        // d = duration
        function __easeInOutQuad(t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        }

        function isTooDark(color, limit) {
            if (angular.isUndefined(limit)) {
                limit = 128;
            }
            var c = color.substring(1);      // strip #
            var rgb = parseInt(c, 16);   // convert rrggbb to decimal
            var r = (rgb >> 16) & 0xff;  // extract red
            var g = (rgb >> 8) & 0xff;  // extract green
            var b = (rgb >> 0) & 0xff;  // extract blue

            var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

            if (luma < limit) {
                return true;
            }
            return false;
        }

        function getIconFromMime(mime) {
            var mime2Ico = ArrayHelper.get('mime2Ico');
            var app2Ico = ArrayHelper.get('app2Ico');

            var len = mime.indexOf('/');
            var type = mime.substr(0, len);

            var ico = mime2Ico[type];
            if (ico == null) {
                var app = mime.substr(len + 1, mime.length);
                ico = app2Ico[app];
                if (ico == null) {
                    ico = 'file-o'
                }
            }
            return ico;
        }

        function getProgressType(index) {
            var progressTypes = ArrayHelper.get('progressTypes');
            return progressTypes[index % progressTypes.length];
        }
    }

    /** @ngInject */
    function UploadWordImagesDlg($scope, $uibModalInstance, clipboard, Upload,
                                 deviceDetector, OS, OS_VERSIONS, C, dialogs, data) {

        var canOpenMultiFile = false;
        //多个文件同时上传受到windows文件打开窗口文件路径输入框可接受字符串长度限制，现在暂时都按照逐一打开文件处理
        //if (deviceDetector.os == OS.WINDOWS) {
        //    canOpenMultiFile = [
        //        OS_VERSIONS.WINDOWS_VISTA,
        //        OS_VERSIONS.WINDOWS_7,
        //        OS_VERSIONS.WINDOWS_8_1,
        //        OS_VERSIONS.WINDOWS_8,
        //        OS_VERSIONS.WINDOWS_10
        //    ].some(function (item) {
        //            return deviceDetector.os_version == item;
        //        });
        //}
        $scope.canOpenMultiFile = canOpenMultiFile;
        var paths = '';
        if (canOpenMultiFile) {
            angular.forEach(data.files, function (file) {
                paths += '"' + file.path + '" ';
            });
        } else {
            $scope.files2Upload = data.files;
        }

        $scope.getDataFromClipboard = function (path) {
            if (path) {
                clipboard.copyText(path);
            } else {
                clipboard.copyText(paths);
            }
        };

        var result = [];
        $scope.uploadFile = function ($file, file, e) {
            if (e && e[0] && e[0].$error === 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }

            if (!$file) return;

            Upload.upload({
                url: C.URL.IMG_UPLOAD, file: $file
            }).progress(function (evt) {
                file.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        file.progress = 0;
                        file.fileName = resp.fileName;
                        result[file.name] = resp.url;
                        break;
                    case 1:
                        file.progress = 101;
                        file.errorInfo = '服务器空间不足!';
                        break;
                }
            }).error(function () {
                file.progress = 102;
                file.errorInfo = '服务器错误!';
            });
        };

        //$scope.uploadFiles = function (files, e) {
        //    $scope.filesUploaded = files;
        //    if (e && e[0] && e[0].$error == 'maxSize') {
        //        dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
        //        return;
        //    }
        //
        //    if (files == null) {
        //        return;
        //    }
        //
        //    var count = 0;
        //    angular.forEach(files, function (file) {
        //        Upload.upload({
        //            url: C.URL.IMG_UPLOAD, file: file
        //        }).progress(function (evt) {
        //            file.progress = parseInt(100.0 * evt.loaded / evt.total);
        //        }).success(function (resp) {
        //            switch (resp.result) {
        //                case 0:
        //                    file.progress = 0;
        //                    result[file.name] = resp.url;
        //                    break;
        //                case 1:
        //                    file.progress = 101;
        //                    file.errorInfo = '服务器空间不足!';
        //                    break;
        //            }
        //            count++;
        //            if (count == files.length) {
        //                $uibModalInstance.close(result);
        //            }
        //        }).error(function () {
        //            file.progress = 102;
        //            file.errorInfo = '服务器错误!';
        //            count++;
        //            if (count == files.length) {
        //                $uibModalInstance.close(result);
        //            }
        //        });
        //    });
        //};

        $scope.ok = function () {
            $uibModalInstance.close(result);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('c.s').factory('WxHelper', WxHelper);

    /** @ngInject */
    function WxHelper($q, $injector, $location) {
        var service = {
            getWechatAuthorizeUrl: getWechatAuthorizeUrl,
            getWechatToken: getWechatToken,
            isWechatBrowser: isWechatBrowser,
            API_AUTH_LOGIN: '/api/wx/get_wechat_token',
            WX_API_ID: 'wxeb110f9f616da715',    // 上锦
            // WX_API_ID: 'wxd5f73f77dc8d5850', // 测试号
            WX_AUTH_REDIRECT_URL: 'https://www.hxsjcd120.com/get_wechat_token',
            // WX_AUTH_REDIRECT_URL: 'http://cbfy.tunnel.qydev.com/get_wechat_token',
            loadWxnp: loadWxnp
        };

        var $http;

        return service;

        function getHttp() {
            return $http ? $http : $injector.get('$http');
        }

        // load wx notice page
        function loadWxnp(cb) {
            var urlParams = $location.search();
            if (urlParams.wxnpId) {
                var id = urlParams.wxnpId;
                var type = urlParams.wxnpType;
                cb(id, type);
                $location.search('wxnpId', null);
                $location.search('wxnpType', null);
            }
        }

        /**
         * 判断是否为微信浏览器
         * @returns {boolean}
         */
        function isWechatBrowser() {
            var ua = navigator.userAgent.toLowerCase();
            return ua.match(/MicroMessenger/i) == "micromessenger";
        }

        function getWechatToken(code, state) {
            var deferred = $q.defer();
            // 构造 url
            var url = service.API_AUTH_LOGIN + "?code=" + code + "&state=" + state;
            // 发送 get
            getHttp().get(url).then(function (data) {
                deferred.resolve(data.data);
            }, function (data) {
                deferred.reject(data);
            });
            return deferred.promise;
        }

        function getWechatAuthorizeUrl(toState, toParams) {
            var appId = service.WX_API_ID,
                // var appId = 'wxc32c627b8b2e7ef3',左迪的测试号
                // input = 'https://www.hxsjcd120.com/get_wechat_token',
                // input = 'http://cbfy.free.ngrok.cc/get_wechat_token',左迪的测试号
                rUrl = service.WX_AUTH_REDIRECT_URL;

            if (toState) {
                rUrl += "?toState=" + toState.name;
                // if (toParams && toParams.tab) rUrl += "&tab=" + toParams.tab;
                if (toParams) rUrl += "&toParams=" + JSON.stringify(toParams);
            }

            rUrl = window.encodeURIComponent(rUrl);

            // var url = 'http://sch.cd120.info/oa/get-weixin-code.html?appid=' + appId + '&redirect_uri='
            //     + rUrl;
            // var url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appId + '&redirect_uri='
            //     + rUrl + '&response_type=code&scope=snsapi_base&state=123#wechat_redirect';
            // var url = 'http://sch.cd120.info/oa/get-weixin-code.html?appid=' + appId + '&redirect_uri='
            //     + rUrl;
            var url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appId + '&redirect_uri='
                + rUrl + '&response_type=code&scope=snsapi_base&state=123#wechat_redirect';
            return url;
        }

    }
})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('attachmentDownloadDlgCtrl', attachmentDownloadDlgCtrl);

    /** @ngInject */
    function attachmentDownloadDlgCtrl($scope, $uibModalInstance, UIHelper, $http, data) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;


        init(data.attachment);


        function init(attachment) {
            attachment.ico = UIHelper.getIconFromMime(attachment.mime);
            attachment.size = parseInt(attachment.size);

            vm.attachment = attachment;

            $http.post('api/v1/file/download/mk_pub_link', {filename: attachment.filename})
                .success(function (resp) {
                    vm.url = resp;
                });
        }
    }

})();



(function () {
    'use strict';

    angular.module('c.c')
        .controller('HgaIndexCtrl', HgaIndexCtrl);

    /** @ngInject */
    function HgaIndexCtrl($scope, $state, $location, $http, UIHelper, HgaAttachment, dialogs, C, FileHelper) {
        var vm = $scope;
        vm.sectionSelected = sectionSelected;
        vm.getAttachment = getAttachment;
        vm.download = download;
        vm.preview = preview;

        var code = $location.search().code;

        // 发送 get
        $http.get('/api/v1/hga/hga_index?code=' + code).then(function (data) {
            if (data.status == 200) {
                vm.m = data.data;
                vm.type = vm.m.type;
                if (vm.m.type != 1) vm.curSection = vm.m.section;
            }
        }, function () {
            $state.go('login');
        });


        function sectionSelected(section) {
            vm.curSection = section;
        }

        function download(attachment) {
            FileHelper.download1(HgaAttachment.urls.DOWNLOAD_ATTACHMENT, attachment);
        }

        function preview(m) {
            dialogs.create(C.V + 'hga/attachment_show_dlg.html', 'HgaAttachmentShowDlgCtrl', {id: m.id}, {size: 'md'});
        }

        function getAttachment(m) {
            m.showDetail = !m.showDetail;
            if (!m.attachments) {
                HgaAttachment.query({opt: 4, /*INDEX_USER_SEARCH*/code: m.code}, function (resp) {
                    var items = resp.items;
                    angular.forEach(items, function (item) {
                        item.ico = UIHelper.getIconFromMime(item.mime);
                        item.size = parseInt(item.size);
                    });
                    m.attachments = items;
                });
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c').controller('HomeCtrl', HomeCtrl)
        .controller('BulletinListCtrl', BulletinListCtrl)
        .controller('NewsListCtrl', NewsListCtrl)
        .controller('FileListCtrl', FileListCtrl)
        .controller('MeetingListCtrl', MeetingListCtrl)
        .controller('CPhoneDlgCtrl', CPhoneDlgCtrl)
        .controller('RuleListCtrl', RuleListCtrl)
        .controller('DiscussionListCtrl', DiscussionListCtrl)
        .controller('PartySpecialListCtrl', PartySpecialListCtrl)
    ;

    /** @ngInject */
    function HomeCtrl($scope, $http, C, ArrayHelper, Auth, Dlg, FileHelper, DateHelper) {
        var vm = this;
        vm.hrm = hrm;
        vm.openPhoneDlg = openPhoneDlg;
        vm.download = download;
        vm.today = DateHelper.date2Str(new Date()); //bulletin-list news-list use
        vm.bulletins = [];
        vm.meetings = [];
        vm.ns = [];
        vm.files = [];
        vm.rules = [];

        init();


        function init() {
            $http.get('api/v1/home').then(function (resp) {
                var data = resp.data;
                // vm.hasMission = data.hasMission;
                vm.bulletins = data.bulletins;
                vm.party_specials = data.party_specials;
                vm.meetings = data.meetings;
                loadMeeting($scope, data.meetings, DateHelper, Auth);
                vm.ns = data.ns;
                vm.files = data.files;
                vm.rules = data.rules;
                vm.blood = getInfoItem(data.blood, true);
                vm.medical = getInfoItem(data.medical, true);
                vm.ors = getInfoItem(data.ors);
                vm.irs = getInfoItem(data.irs);
                vm.outPatient = getInfoItem(data.outPatient);
            });
        }

        function getInfoItem(resp, hideTomorrow) {
            var tomorrow, today;
            if (resp) {

                tomorrow = ArrayHelper.getItem(1, resp);
                today = hideTomorrow ? resp.items[0] : ArrayHelper.getItem(2, resp);
            }
            if (!tomorrow) {
                tomorrow = {id: 1};
            }
            if (!today) {
                today = {id: 2};
            }
            return {tomorrow: tomorrow, today: today};
        }

        function download(m, _url) {
            FileHelper.download1(C.URL[_url], {name: m.name, filename: m.filename, mime: m.mime});
        }

        function hrm() {
            Dlg.show({
                template: C.T + 'leave/hrm_dlg.html',
                ctrl: 'SimpleDlgCtrl',
                data: {},
                size: 'lg'
            });
        }

        function openPhoneDlg() {
            Dlg.show({
                template: C.T + 'misc/common_phone.html',
                ctrl: 'CPhoneDlgCtrl',
                data: {},
                size: 'lg'
            });
        }
    }

    /** @ngInject */
    function BulletinListCtrl($scope, Dlg, C, $http, ArrayHelper) {
        var vm = $scope;
        var home = $scope.home;
        vm.read = read;

        init();


        function init() {
            $scope.$on('bulletin.send', function (event, data) {
                reload();
            });

            $scope.$on('ReadBulletin', function (event, data) {
                var id = data.id;
                var bulletin = ArrayHelper.getItem(id, home.bulletins);
                if (bulletin && bulletin.recipient == null) {
                    bulletin.recipient = true;
                }
            });
        }

        function reload() {
            var pa = Api.param2Url({opt: 1, page: 1, count: 6, sorting: {updated_at: 'desc'}});
            $http.get('api/v1/bulletin/bulletins', {
                params: pa
            }).then(function (resp) {
                home.bulletins = resp.items;
            });
        }

        function read(bulletin) {
            Dlg.show({
                template: C.T + 'article/show_dlg.html',
                ctrl: 'BulletinShowDlgCtrl',
                data: {
                    id: bulletin.id
                },
                size: 'lg'
            });
        }
    }

    /** @ngInject */
    function NewsListCtrl($scope, Dlg, C, $http) {
        var vm = $scope;
        var home = $scope.home;
        vm.read = read;

        init();


        function init() {
            $scope.$on('news.send', function () {
                reload();
            });
        }

        function reload() {
            var pa = Api.param2Url({opt: 1, page: 1, count: 6, sorting: {updated_at: 'desc'}});
            $http.get('api/v1/news/news', {
                params: pa
            }).then(function (resp) {
                home.ns = resp.items;
            });
        }

        function read(n) {
            Dlg.show({
                template: C.T + 'article/show_dlg.html',
                ctrl: 'NewsShowDlgCtrl',
                data: {
                    id: n.id
                },
                size: 'lg'
            });
        }
    }

    /** @ngInject */
    function FileListCtrl($scope, $http, C, Api, FileHelper) {
        var vm = $scope;
        var home = $scope.home;
        vm.download = download;

        init();


        function init() {
            $scope.$on('file.release', function () {
                reload();
            });
        }

        function reload() {
            var pa = Api.param2Url({opt: 1, page: 1, count: 6, sorting: {updated_at: 'desc'}});
            $http.get('api/v1/file_cabinet', {
                params: pa
            }).success(function (data) {
                home.files = data.files;
            });
        }

        function download(m) {
            FileHelper.download1(C.URL.FILE_CABINET_DOWNLOAD, {name: m.name, filename: m.filename, mime: m.mime});
        }
    }

    function loadMeeting(vm, meetings, DateHelper, Auth) {
        var account = Auth.getAccount();
        angular.forEach(meetings, function (meeting) {
            meeting.forLeave = false;
            meeting.forRemind = false;
            meeting.forRCancel = false;
            meeting.isApplicant = false;
            meeting.isModerator = false;
            var start = new Date(),
                end = DateHelper.str2Datetime(meeting.start_time, 'yyyy-MM-dd HH:mm:ss');

            var yesterday = new Date(end - 24 * 60 * 60 * 1000),
                time = DateHelper.date2Str(yesterday) + ' ' + '08:30:00',
                y_start = DateHelper.str2Datetime(time, 'yyyy-MM-dd HH:mm:ss');
            if (meeting.applicant_id == account.id) {
                meeting.isApplicant = true;
            }
            if (DateHelper.diffInHours(start, y_start) >= 1) {
                if (meeting.attendees.length > 0) {
                    if (meeting.attendees[0].reminder_time) {
                        meeting.forRCancel = true;
                    } else {
                        meeting.forDayRemind = true;
                    }
                }
            }

            if (DateHelper.diffInHours(start, end) >= 1) {
                if (meeting.attendees.length > 0) {
                    if (meeting.attendees[0].reminder_time) {
                        meeting.forRCancel = true;
                    } else {
                        meeting.forRemind = true;
                    }
                }
            }

            if (DateHelper.diffInMinutes(start, end) >= 30) {
                if (meeting.attendees.length > 0) {
                    meeting.forLeave = true;
                }
            }

            if (meeting.leavers.length > 0) {
                meeting.forLeave = false;
            }

            if (meeting.moderator_id && meeting.moderator_id == account.id) {
                meeting.isModerator = true;
            }
            meeting.start_time = meeting.start_time.substr(0, 16);
        });
    }

    /** @ngInject */
    function MeetingListCtrl($scope, C, ArrayHelper, DateHelper, Auth, Api, Meeting, Dlg) {
        var vm = $scope;
        var home = $scope.home;
        vm.read = read;

        init();


        function init() {
            $scope.$on('meeting.send', function () {
                reload();
            });

            $scope.$on('MeetingRead', function (event, data) {
                var id = data;
                var meeting = ArrayHelper.getItem(id, home.meetings);
                if (meeting && meeting.recipient == null) {
                    meeting.recipient = true;
                }
            });
        }

        function reload() {
            var pa = Api.param2Url({opt: 6, page: 1, count: 5, sorting: {start_time: 'asc'}});
            Meeting.query(pa, function (data) {
                loadMeeting(vm, data.meetings, DateHelper, Auth);
                home.meetings = data.meetings;
            });
        }

        function read(meeting) {
            Dlg.show({
                template: C.T + 'meeting/show_dlg.html',
                ctrl: 'MeetingShowDlgCtrl',
                data: {
                    id: meeting.id,
                    ForLeave: meeting.forLeave,
                    ForRemind: meeting.forRemind,
                    ForDayRemind: meeting.forDayRemind,
                    ForRCancel: meeting.forRCancel,
                    isApplicant: meeting.isApplicant,
                    isModerator: meeting.isModerator
                },
                size: 'lg'
            }).then(function (params) {
                switch (params.opt) {
                    case 4:
                        leave(meeting);
                        break;
                    case 5:
                        remind(meeting, params.op);
                        break;
                    case 6:
                        remove(meeting);
                        break;
                }
            });
        }


        function leave(meeting) {
            Api.comment({
                title: '会议请假',
                icon: 'sign-out',
                label: '原因'
            }, function (pa) {
                var params = {};
                params['reason'] = pa;
                params['start_time'] = meeting.start_time;
                Meeting.leave({id: meeting.id}, params).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 0:
                                Dlg.s('请假成功');
                                reload();
                                break;
                            case 1:
                                Dlg.w('请在开会前半小时请假!');
                                break;
                        }
                    }, function () {
                        Dlg.e('请假失败了!');
                    }
                )
            });
        }

        function remind(meeting, op) {
            Dlg.confirm('确定要会前' + (op == 1 ? '半小时' : '一天08:30') + '短信提醒吗?', function () {
                Meeting.setReminderTime({id: meeting.id}, {opt: op}).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 0:
                                Dlg.s('设置成功!');
                                reload();
                                break;
                            case 1:
                                Dlg.w('请在开会前一小时设置!');
                                break;
                            case 2:
                                Dlg.w('已统一设置会前半小时提醒!');
                                break;
                            case 3:
                                Dlg.w('请在开会前一天08:30之前设置!');
                                break;
                        }
                    }, function () {
                        Dlg.e('设置失败了!');
                    }
                )
            }, '会前提醒');
        }

        function remove(meeting) {
            Dlg.confirm('确定要取消会前短信提醒吗?', function () {
                Meeting.setReminderTime({id: meeting.id}, {opt: 3}).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 0:
                                Dlg.s('取消成功!');
                                reload();
                                break;
                            case 1:
                                Dlg.w('请在开会前一小时取消!');
                                break;
                        }
                    }, function () {
                        Dlg.e('取消失败了!');
                    }
                )
            }, '取消会前提醒');
        }
    }

    /** @ngInject */
    function CPhoneDlgCtrl($scope, $uibModalInstance, CommonPhone, Table) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;

        init();


        function init() {
            var options = {
                service: CommonPhone,
                params: {opt: 2/*INDEX_ALL*/},
                hideOpt: true,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "phone", title: "电话", filter: {'phone': "text"}},
                    {field: "cornet", title: "小号", filter: {'cornet': "text"}}
                ]
            };
            Table.load(vm, options);
        }

    }

    /** @ngInject */
    function RuleListCtrl($scope, $ocLazyLoad, Dlg, C, Api, Rule) {
        var vm = $scope;
        var home = $scope.home;
        vm.read = read;

        init();


        function init() {
            $scope.$on('rule.send', function () {
                reload();
            });
        }

        function reload() {
            var pa = Api.param2Url({opt: 2, page: 1, count: 6, sorting: {release_time: 'desc'}});
            Rule.query(pa, function (data) {
                home.rules = data.rules;
            });
        }

        function read(rule) {
            $ocLazyLoad.load(['pdf', 'video']).then(function () {
                Dlg.show({
                    template: C.T + 'rule/show_dlg.html',
                    ctrl: 'RuleShowDlgCtrl',
                    data: {
                        id: rule.id
                    },
                    size: 'lg'
                });
            });
        }
    }

    /** @ngInject */
    function DiscussionListCtrl($scope, $timeout, ipCookie, C, DateHelper, Auth, BBS) {
        var vm = $scope;
        vm.goToDiscussion = goToDiscussion;

        init();


        function init() {
            var maxLen = 5;
            BBS.list(function (resp) {
                var aLen = resp.Announcements.length;
                //var dLen = resp.Discussions.length;
                angular.forEach(resp.Announcements, function (a) {
                    a.LastDate = DateHelper.toLocalTime(a.LastDate, 16);
                });
                angular.forEach(resp.Discussions, function (d) {
                    d.LastDate = DateHelper.toLocalTime(d.LastDate, 16);
                });

                vm.announcements = resp.Announcements;
                vm.aLen = aLen > maxLen ? maxLen : aLen;
                vm.discussions = resp.Discussions;
                vm.dLen = aLen > maxLen ? 0 : (maxLen - aLen);
            }, function () {
            });
        }

        function goToDiscussion(d) {
            var token = Auth.getToken();
            ipCookie('token', token/*, {expires: 1, expirationUnit: 'minutes'}*/);
            $timeout(function () {
                var bbs_url = C.URL.FORUM_SSO;
                bbs_url += '?Target=' + d.Url;
                window.location.href = bbs_url;
            }, 360);
        }
    }

    /** @ngInject */
    function PartySpecialListCtrl($scope, Dlg, C, $http, ArrayHelper) {
        var vm = $scope;
        var home = $scope.home;
        vm.read = read;

        init();


        function init() {
        }

        function read(m) {
            Dlg.show({
                template: 'pages/dlg/partySpecial/show_dlg.html',
                ctrl: 'PartySpecialShowDlgCtrl',
                data: {
                    id: m.id
                },
                size: 'lg'
            }).then(function () {
                vm.tableReload();
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('LoginCtrl', LoginCtrl)
        .controller('UserTempRegCtrl', UserTempRegCtrl)
        .controller('LoginUserPhotoDlgCtrl', LoginUserPhotoDlgCtrl)


    ;
    /** @ngInject */
    function LoginCtrl($scope, $stateParams, $state, Dlg, Auth, $http, $interval,
                       $ocLazyLoad, deviceDetector, Sidebar, OS_VERSIONS) {
        var vm = $scope;
        vm.loginForm = loginForm;
        vm.reg = reg;
        // vm.forget = forget;
        vm.openid = $stateParams.data.openid;
        vm.user = {autoLogin: vm.openid ? true : Auth.getAutoLogin()};
        vm.smsLogin = false;
        vm.getSmsPassword = getSmsPassword;
        vm.getSmsBtnText = getSmsBtnText;
        vm.remain = -1;


        init();

        function init() {
            var chromeUrls = {
                windows: '/download/chrome/chrome.exe',
                android: '/download/chrome/chrome.apk',
                linux: '/download/chrome/chrome.deb'
                //mac: 'http://sw.bos.baidu.com/sw-search-sp/software/441142fc7c4/googlechrome_mac_50.0.2661.102.dmg',
                //ios: 'http://itunes.apple.com/cn/app/id535886823?mt=8'
            };
            vm.chromeUrl = chromeUrls[deviceDetector.os];


            if (deviceDetector.browser !== 'chrome') {
                if (deviceDetector.os_version === OS_VERSIONS.WINDOWS_XP) {
                    vm.chromeUrl = '/download/chrome/chromeXp.exe'
                }

                if (vm.chromeUrl) {
                    //Dlg.s(deviceDetector.os);
                    Dlg.notify("您正在" + deviceDetector.os + "系统下访问本站,强烈建议您改用<span class='text-red'>" +
                        "chrome浏览器</span>访问,以保证正常使用所有功能" + " 点击<a class='text-red' href=" +
                        vm.chromeUrl + ">" + "这里</a>下载");
                }
            }

            if ($stateParams.registerDlgOpen) {
                reg();
            }
        }


        function loginForm(user, Form) {
            if (Form.$valid) {
                user.sms_login = vm.smsLogin;
                if (vm.openid) user.openid = vm.openid;
                Auth.login(user, function (resp) {
                    if (Boolean(resp.account.is_swimming_role)) {
                        $state.go('swimming_businness');
                    } else if (Boolean(resp.account.is_logistics_role)) {
                        $state.go('logistics');
                    } else {
                        Sidebar.setupMenuItems(resp.menuItems);
                        if (vm.smsLogin) {
                            $state.go('app.user_profile', {data: {requireChangePasswd: true, id: resp.account.id}});
                        } else {
                            $state.go('app.home');
                        }
                    }
                }, function (error) {
                    Dlg.e(error.msg);
                });
            } else {
                Form.submitted = true;
            }
        }

        function reg() {
            $ocLazyLoad.load(['uiSelect']).then(function () {
                Dlg.show({
                    template: 'UserTempRegDlg',
                    ctrl: 'UserTempRegCtrl',
                    data: {},
                    size: 'lg'
                });
            });

        }

        function getSmsPassword() {
            if (!vm.user.username
                || !vm.user.username.match(/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[389])\d{8}$/)) {
                Dlg.e('手机号格式不正确');
                return
            }
            $http.post("/auth/sms/password", {
                phone: vm.user.username
            }).then(
                function () {
                    vm.remain = 60;
                    var intervalId = $interval(function () {
                        vm.remain--;
                        if (vm.remain === 0) {
                            $interval.cancel(intervalId)
                        }
                    }, 1000)
                }
            ).catch(function (error) {
                    Dlg.e(error.data.message);
                }
            )
        }

        function getSmsBtnText() {
            return vm.remain > 0 ? '重新获取(' + vm.remain + ')'
                : vm.remain === 0 ? '重新获取' : '获取短信动态密码'
        }
    }

    /** @ngInject */
    function UserTempRegCtrl($scope, Dlg, ArrayHelper, User, $http, DateHelper, $q, FormHelper,
                             $uibModalInstance, JobTitle, NewUser) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;
        vm.degreeTypeSelectedFn = degreeTypeSelectedFn;
        vm.plaitSelectedFn = plaitSelectedFn;
        vm.deptTypeFn = deptTypeFn;
        vm.titleGroupFn = titleGroupFn;
        vm.onTypeSelectedFn = onTypeSelectedFn;
        // vm.addUserPhoto = addUserPhoto;
        vm.dayNumChange = dayNumChange;
        vm.reg_stage = true;
        vm.title = '用户注册';
        vm.hide_photo = false;
        vm.titleLeaves = NewUser.getTitleLevel();
        vm.edu_bgs = ArrayHelper.get('edu_bg_list');
        vm.degree_types = ArrayHelper.get('degree_types');
        vm.en_lvs = ArrayHelper.get('eg_lv_list');
        // vm.titles = ArrayHelper.get('titles');
        vm.posts = ArrayHelper.get('posts');
        vm.sexes = ArrayHelper.get('sexes');
        vm.dateOptions = {
            minDate: new Date(1920, 0, 1),
            maxDate: new Date(),
            initDate: new Date()
        };

        vm.plaits = [
            {id: 1, name: '上锦'},
            {id: 2, name: '华西派驻'},
            {id: 3, name: '附二院派驻'},
            {id: 4, name: '院外人员'}
        ];

        vm.census = [
            {id: 1, name: '城镇'},
            {id: 2, name: '农村'}
        ];

        init();

        function init() {
            $q.all([
                $http.get('api/open/user/reg', {params: {op: 'options'}})
            ]).then(function (respArray) {
                vm.depts = respArray[0].data.items.depts;
                vm.types = respArray[0].data.items.types;
                vm.statuses = respArray[0].data.items.statuses;
                vm.standards = respArray[0].data.items.standards;

                vm.titles = respArray[0].data.items.titles;
                var jTypes = JobTitle.getTypes();
                angular.forEach(vm.titles, function (title) {
                    title.type = ArrayHelper.getItem(title.type, jTypes);
                });

                var types = [];
                angular.forEach(respArray[0].data.items.majors, function (type) {
                    types.push(type);
                });
                vm.majors = types;
                //暂时去掉 实习和试用
                //$scope.statuses.splice(2, 2);
                // vm.entry_types = respArray[0].data.items.entry_types;
                vm.nations = respArray[0].data.items.nations;
                vm.political_statuses = respArray[0].data.items.political_statuses;

                // vm.user['type'] = vm.types[0];
                vm.user['title_level'] = vm.titleLeaves[0];
                // vm.user['status'] = vm.statuses[0]; //让用户先选择
                // vm.user['entry_type'] = vm.entry_types[0];
                vm.user['nation'] = vm.nations[0];
                vm.user['political_status'] = vm.political_statuses[0];
                // vm.user['dept'] = vm.depts[0];
                vm.user['standard'] = vm.standards[0];
                // vm.user['annual_days'] = 5;
            });

            vm.user = {is_cadre: false, password: "Sj@123456"};
            vm.user['sex'] = vm.sexes[0];
            vm.user['edu_bg'] = vm.edu_bgs[0];
            vm.user['degree_type'] = vm.degree_types[0];
            vm.degrees = User.getDegrees(vm.user['degree_type'].id);
            vm.user['degree'] = vm.degrees[0];
            vm.user['en_lv'] = vm.en_lvs[0];
            // vm.user['plait'] = vm.plaits[0]; //让用户自己选择
            vm.user['census'] = vm.census[0];
        }

        $scope.$watch('vm.user.id_card', function (newVal, oldVal) {
            var id_card = newVal;
            if (id_card != oldVal && id_card != '' && id_card != null) {
                var native = id_card.substr(0, 6);
                var birthday = id_card.substr(6, 8);
                var sex = vm.sexes[(parseInt(id_card.substr(16, 1)) + 1) % 2];
                vm.user.birthday = DateHelper.str2Date(birthday, 'yyyyMMdd');
                vm.user.sex = sex;
                // if (id_card.length == 18 || id_card.length == 15) {
                //     $http.post('/api/open/user/reg/native_place',
                //         {id_native: native}).success(function (resp) {
                //         switch (resp.result) {
                //             case 0:
                //                 vm.user.native_place = resp.native_place;
                //                 break;
                //             case 1:
                //                 Dlg.w('没有找到和您输入的身份证号对应的籍贯信息，请手动填写籍贯!');
                //                 break;
                //         }
                //     });
                // }
            }
        });

        function degreeTypeSelectedFn(type) {
            vm.degrees = User.getDegrees(type.id);
            vm.user['degree'] = vm.degrees[0];
        }

        function plaitSelectedFn(plait) {
            vm.status = [];
            vm.defaultStatuses = angular.copy(vm.statuses);
            if (plait.id == 1) {
                angular.forEach(vm.defaultStatuses, function (item) {
                    if (ArrayHelper.inArray(item.id, [15, 16, 17]) !== -1) {
                        vm.status.push(item);
                    }
                });
            } else if (plait.id == 2) {
                angular.forEach(vm.defaultStatuses, function (item) {
                    if (ArrayHelper.inArray(item.id, [1, 2, 5, 6, 8, 9, 10, 12, 13, 14, 23]) !== -1) {
                        vm.status.push(item);
                    }
                });
            } else if (plait.id == 3) {
                angular.forEach(vm.defaultStatuses, function (item) {
                    if (ArrayHelper.inArray(item.id, [5, 6, 7, 8, 9, 10]) !== -1) {
                        item.name = '附二院' + item.name;
                        vm.status.push(item);
                    }
                });
            } else if (plait.id == 4) {
                angular.forEach(vm.defaultStatuses, function (item) {
                    if (ArrayHelper.inArray(item.id, [18]) !== -1) {
                        vm.status.push(item);
                    }
                });
            }
        }

        function deptTypeFn(d) {
            return d.type.name;
        }

        function titleGroupFn(t) {
            return t.type.name;
        }

        function onTypeSelectedFn(type, user) {
            if (type.id == 2) {
                user.standard = vm.standards[0];
            }
        }

        // function addUserPhoto(user) {
        //     if (!user.username) {
        //         Dlg.w('请先填写胸牌号');
        //     } else {
        //         Dlg.show({
        //             template: 'pages/user/profile/userPhotoDlg.html',
        //             ctrl: 'LoginUserPhotoDlgCtrl',
        //             data: {id: user.username}
        //         }).then(function (resp) {
        //             user.photo = resp[0];
        //             user.work_photo = resp[1];
        //         });
        //     }
        // }

        function dayNumChange() {
            var valid = isNaN(vm.user.num) ? true : Number.isInteger(vm.user.num * 2);
            vm.Form.num.$setValidity('num', valid);
            vm.Form.num.$setValidity('not_zero', vm.user.num >= 0);
        }

        function ok(user) {
            var defer = $q.defer();
            if (!vm.Form.$valid) {
                FormHelper.handleError('#Form', vm.Form);
                defer.reject();
            } else {
                var pa = {};
                //账户信息
                pa['username'] = user.username;
                if (user.password && user.password.length > 0) {
                    pa['password'] = user.password;
                }

                //基本信息
                pa['name'] = user.name;
                pa['id_card'] = user.id_card;
                pa['census'] = user.census.id;
                pa['sex'] = user.sex.id;
                pa['birthday'] = DateHelper.date2Str(user.birthday);
                pa['nation_id'] = user.nation.id;
                pa['native_place'] = user.native_place;
                pa['car_num1'] = user.car_num1;
                pa['car_num2'] = user.car_num2;
                if (user.political_status) pa['political_status_id'] = user.political_status.id;

                //工作相关
                // pa['photo'] = user.photo;
                // pa['work_photo'] = user.work_photo;
                pa['status_id'] = user.status.id;
                pa['type_id'] = user.type.id;
                pa['plait'] = user.plait.id;
                pa['post_details'] = user.post_details;
                pa['num'] = user.num;
                // if (user.plait.id !== 1) {
                //     pa['annual_days'] = user.annual_days; //年假天数
                // } else {
                //     pa['annual_days'] = null; //年假天数
                // }
                if (user.type.id === 2) pa['standard'] = user.standard.id;

                //  主要科室...
                pa['dept_id'] = user.dept.id;
                pa['is_cadre'] = user.is_cadre;
                // pa['entry_type_id'] = user.entry_type.id;
                pa['entry_time'] = DateHelper.date2Str(user.entry_time);
                pa['party_time'] = DateHelper.date2Str(user.party_time);
                //pa['salary_card'] = user.salary_card;
                pa['started_work'] = DateHelper.date2Str(user.started_work);
                if (user.deal_sign_time) pa['deal_sign_time'] = DateHelper.date2Str(user.deal_sign_time);
                if (user.deal_deadline) pa['deal_deadline'] = DateHelper.date2Str(user.deal_deadline);
                if (user.deal_change_time) pa['deal_change_time'] = DateHelper.date2Str(user.deal_change_time);

                //教育背景
                pa['graduate_school'] = user.graduate_school;
                pa['major'] = user.major;
                pa['edu_bg'] = user.edu_bg.id;
                pa['degree'] = user.degree.name;
                pa['en_lv'] = user.en_lv.id;
                //联系方式
                pa['phone'] = user.phone;
                pa['cornet'] = user.cornet;
                pa['phone2'] = user.phone2;
                pa['office_phone'] = user.office_phone;
                // pa['office_cornet'] = user.office_cornet;
                if (user.email) pa['email'] = user.email;
                pa['qq'] = user.qq;
                pa['address'] = user.address;

                if (user.plait.id == 1) {
                    pa['confirm_state'] = 4;//人事科确认
                } else {
                    pa['confirm_state'] = 3;//科室确认
                }


                // if (user.major_s) {
                //     pa['major_id'] = user.major_s.id;
                // }
                if (user.title) {
                    pa['title_id'] = user.title.id;
                }

                if (user.title_level) pa['title_level'] = user.title_level.id;

                if (user.post) {
                    pa['post'] = user.post.id;
                }
                $http.post('auth/register', pa).success(function () {
                    Dlg.s('申请成功,请等待短信通知!');
                    $uibModalInstance.close();
                }).error(function (error) {
                    Dlg.e('存在同名的账号或者手机，添加失败!');
                });
            }
            defer.resolve();

            return defer.promise;
        }
    }

    /** @ngInject */
    /** @ngInject */
    function LoginUserPhotoDlgCtrl($uibModalInstance, $q, Upload, data, Dlg) {
        var vm = this;
        vm.m = {croppedDataUrl: ''};
        vm.upload = upload;
        vm.cancel = $uibModalInstance.dismiss;

        function upload(m) {
            var defer = $q.defer();

            var croppedFile = Upload.dataUrltoBlob(m.croppedDataUrl);
            croppedFile.name = "avatar.png";

            $q.all([
                Upload.upload({url: '/auth/login' + '/' + data.id + '/photo', data: {file: croppedFile}}),
                Upload.upload({url: '/auth/login' + '/' + data.id + '/work_photo', data: {file: m.imgFile}})
            ]).then(function (respArr) {
                Dlg.s('头像及工作照保存成功');
                $uibModalInstance.close([respArr[0].data.item.photo, respArr[1].data.item.work_photo]);
            }, function (error) {
                Dlg.e(error.data.msg)
            }).finally(function () {
                defer.resolve();
            });

            return defer.promise;
        }
    }

})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('MainCtrl', MainCtrl);

    /** @ngInject */
    function MainCtrl($rootScope, $http, $scope, $state, $timeout, $q, dialogs, Dlg, toaster, C, ArrayHelper, Auth,
                      FileHelper, UIHelper, Email, SaveAs, Sidebar) {
        var account = Auth.getAccount();
        var vm = $scope;

        init();


        function init() {
            $timeout(function () {
                if (!vm.$finishedLoading) {
                    vm.$finishedLoading = true;
                }
            }, 500);

            Sidebar.bindState($scope);

            $scope.$on('state.go', function (event, state) {
                $state.go(state.name, {data: {tab: state.tab}});
            });

            // 等待header初始化完成
            $scope.$on('headerLoaded', function () {
                defer.resolve();
            });

            //initEditor($rootScope);

            var pusherFnList = {
                'task': taskFn,

                'mail.send': mailSendFn,
                'bulletin.send': bulletinSendFn,
                'file.release': fileReleaseFn,
                'meeting.send': meetingSendFn,
                'mission.send': missionSendFn,
                'news.send': newsSendFn,
                'rule.send': ruleSendFn
            };

            angular.forEach(pusherFnList, function (fn, evtName) {
                $scope.$on(C.P + evtName, fn);
            });

            var defer = $q.defer();

            UIHelper.initCKEditor();

            $q.all([
                $http.get('api/v1/main'),
                defer.promise
            ]).then(function (respArray) {
                var resp = respArray[0];
                var data = resp.data;
                var header = $scope.header;
                header.mails = data.mails;
                header.hasTask = data.hasTask;

                account = data.account;

                // 临时，如果有任务，弹出待处理列表
                if (header.hasTask) {
                    $timeout(function () {
                        header.openTaskD = true;
                    }, 500);
                }

                Auth.setAccount(account);
                Auth.setVisitCnt(data.loginCnt, data.apiCnt);
                header.account = vm.account = account;
                checkIfUnConfirmUpdate(account);
            });
        }

        //function initEditor(vm) {
        //    vm.onCKReady = UIHelper.onCKReady;
        //}

        function checkIfUnConfirmUpdate(account) {
            if (account.confirm_state === 0) {
                Dlg.show({
                    template: 'templates/user_edit_dlg.html',
                    ctrl: 'UserEditCtrl',
                    data: {
                        user_id: account.id,
                        user_type: account.type,
                        confirm_state: '1',
                        title: '确认信息'
                    },
                    size: 'lg'
                }).then(function (params) {
                    Dlg.s('用户信息已确认');
                    account.confirm_state = 1; //1表示用户已确认
                    account.photo = params.photo;
                    Auth.setAccount(account);
                    $scope.header.account = $scope.account = account;
                });
            }
        }

        function mailSendFn(event, data) {
            var mail = data.data.mail;
            if (ArrayHelper.inArray(account.id, mail.recipients) >= 0) {
                Dlg.msg('新邮件', "你有一封新邮件《" + mail.subject + "》,点击查阅", function () {
                    dialogs.create(C.V + 'email/show_dlg.html', 'MailShowDlgCtrl', {mail: mail},
                        {size: 'lg'}).result.then(function (params) {
                        switch (params.opt) {
                            case 1:
                                $state.go('app.coop_email', {
                                    data: {
                                        tab: 'write',
                                        event: 'mailReply',
                                        mail: params.mail
                                    }
                                });
                                break;
                            case 2:
                                $state.go('app.coop_email', {
                                    data: {
                                        tab: 'write',
                                        event: 'mailForward',
                                        mail: params.mail
                                    }
                                });
                                break;
                            case 3:
                                Email.rm_from_inbox({mails: [mail.id]}).$promise.then(
                                    function () {
                                        $rootScope.$broadcast('mailDel', mail.id);
                                    },
                                    function () {
                                        toaster.error('邮件删除失败!');
                                    }
                                );
                                break;
                        }
                    });
                });
                $rootScope.$broadcast("mail.send", mail);
            }
        }

        function taskFn(event, data) {
            var task = data.data.task;
            if (ArrayHelper.inArray(account.id, task.approvers) >= 0) {
                $rootScope.$broadcast("newTask", {task: task.task});
            }
        }

        function bulletinSendFn(event, data) {
            var bulletin = data.data.task;
            switch (bulletin.is_pass) {
                case C.STAGE1.DEPT_APPROVAL:
                case C.STAGE1.HOSPITAL_APPROVAL:
                    if (ArrayHelper.inArray(account.id, bulletin.approvers) >= 0) {
                        $rootScope.$broadcast("newTask", {task: bulletin.task});
                    }
                    break;
                case C.STAGE1.PUBLIC:
                    $rootScope.$broadcast("bulletin.send", bulletin);
                    Dlg.msg('新通知', bulletin.dept.name + "发布了新通知《" + bulletin.title + "》,点击查阅", function () {
                        dialogs.create('templates/article/show_dlg.html', 'BulletinShowDlgCtrl', {
                            id: bulletin.id
                        }, {
                            size: 'lg'
                        });
                    });
                    break;
            }
        }

        function newsSendFn(event, data) {
            var news = data.data.task;
            if (news.is_pass == 0 || news.is_pass == 2) {
                if (ArrayHelper.inArray(account.id, news.approvers) >= 0) {
                    $rootScope.$broadcast("newTask", {task: news.task});
                }
            } else if (news.is_pass == 6) {
                $rootScope.$broadcast("news.send", news);
                Dlg.msg('信息公开', news.dept + "发布了信息公开《" + news.title + "》,点击查阅", function () {
                    dialogs.create('templates/article/show_dlg.html', 'NewsShowDlgCtrl', {
                        id: news.id
                    }, {
                        size: 'lg'
                    });
                });
            }
        }

        function meetingSendFn(event, data) {
            var meeting = data.data.task;
            switch (meeting.stage) {
                case C.STAGE1.DEPT_APPROVAL:
                case C.STAGE1.HOSPITAL_APPROVAL:
                    if (ArrayHelper.inArray(account.id, meeting.approvers) >= 0) {
                        $rootScope.$broadcast("newTask", {task: meeting.task});
                    }
                    break;
                case C.STAGE1.PUBLIC:
                    if (ArrayHelper.inArray(account.id, meeting.attendees) >= 0) {
                        $rootScope.$broadcast("meeting.send", meeting);
                        Dlg.msg('新会议', meeting.dept.name + "发布了新会议《" + meeting.name + "》,点击查阅", function () {
                            dialogs.create('templates/meeting/show_dlg.html', 'MeetingShowDlgCtrl', {
                                id: meeting.id
                            }, {
                                size: 'lg'
                            });
                        });
                    }
                    break;
            }
        }

        function missionSendFn(event, data) {
            var mission = data.data.task;
            if (ArrayHelper.inArray(account.id, mission.attendees) >= 0) {
                $rootScope.$broadcast("mission.send", mission);
                Dlg.msg('任务通知', '您加入了任务《' + mission.name + "》,点击查阅", function () {
                    dialogs.create('pages/dlg/mission/temp/show_dlg.html', 'MissionShowDlgCtrl', {
                        id: mission.id
                    }, {
                        size: 'lg'
                    });
                });
            }
        }

        function fileReleaseFn(event, data) {
            var file = data.data.task;
            if (ArrayHelper.inArray(account.id, file.approvers) >= 0) {
                $rootScope.$broadcast("newTask", {task: file.task});
            } else if (file.state == C.STAGE3.PUBLIC &&
                ((file.release_type == 2 && ArrayHelper.inArray(account.id, file.receivers) >= 0) || file.release_type == 3)) {
                $rootScope.$broadcast("file.release", file);
                Dlg.msg('文件发布', file.dept + "发布了文件《" + file.name + "》,点击下载", function () {
                    var params = {filename: file.filename, mime: file.mime};
                    file.downloading = true;
                    FileHelper.download(C.URL.FILE_CABINET_DOWNLOAD, params, function (resp) {
                        file.downloading = false;
                        var data = [resp];
                        var options = {type: file.mime};
                        SaveAs.download(data, file.name, options);
                    }, function (error) {
                        file.downloading = false;
                        //toaster.error('服务端文件丢失,请联系管理员!');
                    });
                });
            }
        }

        function ruleSendFn(event, data) {
            var rule = data.data.task;
            switch (rule.stage) {
                case C.STAGE6.DEPT_APPROVAL:
                case C.STAGE6.HOSPITAL_APPROVAL:
                    if (ArrayHelper.inArray(account.id, rule.approvers) >= 0) {
                        $rootScope.$broadcast("newTask", {task: rule.task});
                    }
                    break;
                case C.STAGE6.PUBLIC:
                    if (rule.class == 1 && ArrayHelper.inArray(account.id, rule.approvers) >= 0) {
                        $rootScope.$broadcast("rule.send", rule);
                        Dlg.msg('新管理手册', rule.dept.name + "发布了新管理手册《" + rule.subject + "》,点击查阅", function () {
                            dialogs.create('templates/rule/show_dlg.html', 'RuleShowDlgCtrl', {
                                id: rule.id
                            }, {
                                size: 'lg'
                            });
                        });
                    }
                    if (rule.class == 2) {
                        $rootScope.$broadcast("rule.send", rule);
                        Dlg.msg('新管理手册', rule.dept.name + "发布了新管理手册《" + rule.subject + "》,点击查阅", function () {
                            dialogs.create('templates/rule/show_dlg.html', 'RuleShowDlgCtrl', {
                                id: rule.id
                            }, {
                                size: 'lg'
                            });
                        });
                    }
                    break;
                case C.STAGE6.DISABLE:
                    if (rule.class == 1 && ArrayHelper.inArray(account.id, rule.approvers) >= 0) {
                        $rootScope.$broadcast("rule.send", rule);
                        Dlg.msg('停用管理手册', rule.dept.name + "停用了管理手册《" + rule.subject + "》,点击查阅", function () {
                            dialogs.create('templates/rule/show_dlg.html', 'RuleShowDlgCtrl', {
                                id: rule.id
                            }, {
                                size: 'lg'
                            });
                        });
                    }
                    if (rule.class == 2) {
                        $rootScope.$broadcast("rule.send", rule);
                        Dlg.msg('停用管理手册', rule.dept.name + "停用了管理手册《" + rule.subject + "》,点击查阅", function () {
                            dialogs.create('templates/rule/show_dlg.html', 'RuleShowDlgCtrl', {
                                id: rule.id
                            }, {
                                size: 'lg'
                            });
                        });
                    }
                    break;
            }

            if ((rule.red_head == C.STAGE7.RED_HEAD_APPROVAL || rule.red_head == C.STAGE7.RED_HEAD_HOSPITAL_APPROVED)
                && ArrayHelper.inArray(account.id, rule.approvers) >= 0) {
                $rootScope.$broadcast("newTask", {task: rule.task});
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('TabCtrl', TabCtrl);

    /** @ngInject */
    function TabCtrl($scope, $stateParams, UIHelper) {
        UIHelper.loadTabs($scope, $stateParams);
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('WechatAuthCtrl', WechatAuthCtrl);

    /** @ngInject */
    function WechatAuthCtrl($state, $location, Api, C, Auth, WxHelper) {
        // 获取返回参数 code 和 state
        var qs = $location.search();
        var code = qs.code;
        var state = qs.state;

        WxHelper.getWechatToken(code, state).then(function (data) {
            switch (data.result) {
                case 0:
                    Auth.setAutoLogin(true);
                    Auth.setToken(data.token);
                    Auth.setAccount(data.account);
                    if (Boolean(data.account.is_swimming_role)) {
                        $state.go('swimming_businness');
                    } else {
                        if (qs.toState) {
                            if (qs.toParams) {
                                $state.go(qs.toState, JSON.parse(qs.toParams));
                            } else {
                                $state.go(qs.toState);
                            }
                        } else {
                            $state.go('app.home');
                        }
                    }
                    break;
                case 1:
                    Api.e(data.msg);
                    break;
                case 2:  //用户未绑定微信
                case 3:
                    $state.go('login', {data: {openid: data.openid}});
                    break;
            }
        });
    }

})();
angular.module('c.s')
    .factory('BloodStorage', function ($resource) {
        return $resource('/api/v1/blood_storage/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            exchange: {
                method: 'POST',
                params: {
                    action: 'exchange'
                }
            },
            query: {
                method: 'GET'
            }
        });
    });



angular.module('c.s')
    .factory('CommonPhone', ['$resource', function ($resource) {
        return $resource('/api/v1/common_phones/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);
angular.module('c.s')
    .factory('ContactGroup', ['$resource', function ($resource) {
        return $resource('/api/v1/contact_groups/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            attach_members: {
                method: 'POST',
                params: {
                    action: 'attach_members'
                }
            },
            detach_members: {
                method: 'POST',
                params: {
                    action: 'detach_members'
                }
            },
            index_members: {
                method: 'GET',
                params: {
                    action: 'index_members'
                }
            },
            set_member_stop: {
                method: 'POST',
                params: {
                    action: 'set_member_stop'
                }
            }
        });
    }]);


//angular.module('c.s')
//    .factory('Cookie', function($http, urls) {
//        return {
//            token: function (success, error) {
//                $http.get(C.URL.COOKIE).success(success).error(error);
//            }
//        };
//    });
//

(function () {
    'use strict';

    angular.module('c.s')
        .factory('Dept', Dept)
        .factory('NewDept', NewDept)
        .factory('DeptType', DeptType)
        .factory('DeptPhone', DeptPhone)
        .factory('AdminGroup', AdminGroup)
    ;

    /** @ngInject */
    function DeptType($resource, serviceConfObj) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/dept_types/:id',
            {}, {
                update: {
                    method: 'PUT'
                }
            }));
    }

    /** @ngInject */
    function DeptPhone($resource, serviceConfObj) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/dept_phones/:id',
            {}, serviceConfObj));
    }

    /** @ngInject */
    function AdminGroup($resource, serviceConfObj) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/dept/admin_groups/:id',
            {}, serviceConfObj));
    }

    /** @ngInject */
    function Dept($resource, $http, serviceConfObj) {
        var API = '/api/v1/dept/depts';
        var service = {
            urls: {
                API: API
            },

            ID: {
                NURSING_DEPT: 39,  // 护理部
                MEDICAL_DEPT: 38,  // 医务科

                HOSPITAL: 37,  // 综合办公室
                PERSONNEL: 40,  // 人事科
                PARTY: 136,  // 党办
                PUBLICITY: 90  // 宣传科
            },

            getMembers: getMembers,
            INDEX: {
                //所有科室选项
                DEPTS_OPTIONS: 4,
                //当前登录用户所属科室列表，用于下拉列表选项
                USER_DEPTS_OPTIONS: 5,
                //当前登录用户所负责科室列表，用于下拉列表选项
                DEPTS_LED_BY: 6,
                //当前登录用户所属科室列表，用于下拉列表选项,分管院领导可选所管科室
                USER_DEPTS_OPTIONS2: 12,
                //查询用户所属科室列表，用于下拉列表选项
                USER_DEPTS_OPTIONS3: 13,
                //分管院领导已审核制度的科室列表
                DEPTS_LED_BY2: 15,
                //科室物资管理员管理的科室列表
                DEPTS_CSMB_OPTIONS: 16
            }
        };

        return angular.extend(service, $resource('/api/v1/depts/:id',
            {}, serviceConfObj));

        function getMembers(deptId) {
            var api = API + '/' + deptId + '/members';
            return $http.get(api);
        }
    }

    /** @ngInject */
    function NewDept($resource, serviceConfObj) {
        var API = '/api/v1/dept/new/depts';
        var service = {
            urls: {
                API: API
            }
        };

        return angular.extend(service, $resource(API + '/:id', {}, serviceConfObj));

    }

})();

angular.module('c.s')
    .factory('Email', function ($resource) {
        return $resource('/api/v1/emails/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            withdraw: {
                method: 'POST',
                params: {
                    action: 'withdraw'
                }
            },
            rm_from_inbox: {
                method: 'POST',
                params: {
                    action: 'rm_from_inbox'
                }
            },
            rm_from_outbox: {
                method: 'POST',
                params: {
                    action: 'rm_from_outbox'
                }
            }
        });
    }
);


angular.module('c.s')
    .factory('HelpPage', ['$resource', function ($resource) {
        return $resource('/api/v1/help_pages/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }]);

angular.module('c.s')
    .factory('HelpContent', ['$resource', function ($resource) {
        return $resource('/api/v1/help_contents/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }]);


angular.module('c.s')
    .factory('IRSchedule', function ($resource) {
        return $resource('/api/v1/ir_schedules/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            exchange: {
                method: 'POST',
                params: {
                    action: 'exchange'
                }
            }
        });
    });



angular.module('c.s')
    .factory('MedicalInfo', function ($resource) {
        return $resource('/api/v1/medical_info/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            exchange: {
                method: 'POST',
                params: {
                    action: 'exchange'
                }
            },
            query: {
                method: 'GET'
            }
        });
    });



(function () {
    'use strict';

    angular.module('c.s')
        .factory('Meeting', Meeting)
        .factory('MeetingAsk4Leave', MeetingAsk4Leave)
        .factory('MeetingAttendance', MeetingAttendance)
        .factory('MeetingDevice', MeetingDevice)
        .factory('MeetingRoom', MeetingRoom)
        .factory('MeetingType', MeetingType)
    ;

    /** @ngInject */
    function MeetingType($resource, serviceConfObj) {
        return $resource('/api/v1/meeting_types/:id', {}, serviceConfObj);
    }

    /** @ngInject */
    function MeetingRoom($resource) {
        return $resource('/api/v1/meeting_rooms/:id/:action', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            ibeacons: {
                method: 'GET',
                params: {
                    action: 'ibeacons'
                }
            }
        });
    }

    /** @ngInject */
    function MeetingDevice($resource, serviceConfObj) {
        return $resource('/api/v1/meeting_devices/:id', {}, serviceConfObj);
    }

    /** @ngInject */
    function MeetingAttendance($resource, serviceConfObj) {
        return $resource('/api/v1/meeting_attendances/:id', {}, serviceConfObj);
    }

    /** @ngInject */
    function MeetingAsk4Leave($resource) {
        return $resource('/api/v1/meeting_ask_for_leaves/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            setAll: {
                method: 'POST',
                params: {
                    action: 'set_all'
                }
            }
        });
    }

    /** @ngInject */
    function Meeting($resource) {
        return $resource('/api/v1/meetings/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            leave: {
                method: 'POST',
                params: {
                    action: 'leave'
                }
            },
            setReminderTime: {
                method: 'POST',
                params: {
                    action: 'set_reminder_time'
                }
            },
            getQrcode: {
                method: 'POST',
                params: {
                    action: 'get_qrcode'
                }
            },
            getAttendance: {
                method: 'POST',
                params: {
                    action: 'get_attendance'
                }
            }
        });
    }

})();

angular.module('c.s')
    .factory('MessageRecipient', function ($resource) {
        return $resource('/api/v1/message_recipients/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    });



angular.module('c.s')
    .factory('NurseSeniority', ['$resource', seniorityService]);

function seniorityService($resource) {
    return $resource('/api/v1/nurse_seniorities/:id', {}, {
        update: {
            method: 'PUT'
        },
        query: {
            method: 'GET'
        }
    });
}
angular.module('c.s')
    .factory('SeniorityStandard', ['$resource', SeniorityStandardService]);

function SeniorityStandardService($resource) {
    return $resource('/api/v1/nurse_seniority_standards/:id', {}, {
        update: {
            method: 'PUT'
        }
    });
}
(function () {
    'use strict';

    angular.module('c.s')
        .factory('OfficeDeptPhone', OfficeDeptPhone)
    ;

    /** @ngInject */
    function OfficeDeptPhone($resource, serviceConfObj) {
        var service = {
        };
        return angular.extend(service, $resource('/api/v1/dept_phone/:id', {
            id: '@id',
            action: '@action'
        }, serviceConfObj,{
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
    }
})();
angular.module('c.s')
    .factory('OperationPermit', function ($resource) {
        return $resource('/api/v1/operation_permits/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    });


angular.module('c.s')
    .factory('ORRecipient', function ($resource) {
        return $resource('/api/v1/or_recipients/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    });



angular.module('c.s')
    .factory('ORSchedule', function ($resource) {
        return $resource('/api/v1/or_schedules/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            exchange: {
                method: 'POST',
                params: {
                    action: 'exchange'
                }
            }
        });
    });



angular.module('c.s')
    .factory('OutPSchedule', function ($resource) {
        return $resource('/api/v1/out_p_schedules/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            exchange: {
                method: 'POST',
                params: {
                    action: 'exchange'
                }
            }
        });
    });



angular.module('c.s')
    .factory('Practice', ['$resource', function ($resource) {
        return $resource('/api/v1/practices/:action/:id', {
            id: '@id',
            action: '@action'
        },{
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('PracticeFeedback', ['$resource', function ($resource) {
        return $resource('/api/v1/practice_feedback/:action/:id', {
            id: '@id',
            action: '@action'
        },{
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('QualificationChangeRemind', ['$resource', function ($resource) {
        return $resource('/api/v1/qualification_change_reminds/:action/:id', {
            id: '@id',
            action: '@action'
        },{
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


angular.module('c.s')
    .factory('RedHeadApprover', ['$resource', function ($resource) {
        return $resource('/api/v1/red_head_approvers/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


(function () {
    'use strict';

    angular.module('c.s')
        .factory('Role', Role)
        .factory('Permission', Permission)
    ;

    /** @ngInject */
    function Permission($resource) {
        return $resource('/api/v1/permissions/:id');
    }

    /** @ngInject */
    function Role($resource, serviceConfObj) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/roles/:id',
            {}, serviceConfObj));
    }

})();
angular.module('c.s')
    .factory('Round', ['$resource', function ($resource) {
        return $resource('/api/v1/rounds/:action/:id', {
            id: '@id',
            action: '@action'
        },{
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


(function () {
    'use strict';

    angular.module('c.s')
        .factory('Section', Section)
    ;

    /** @ngInject */
    function Section($resource, serviceConfObj) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/sections/:id',
            {}, serviceConfObj));
    }

})();

angular.module('c.s')
    .factory('SeniorityApproval', ['$resource', function ($resource) {
        return $resource('/api/v1/seniority_approval/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);





angular.module('c.s')
    .factory('Setting', ['$resource', SettingService]);

function SettingService($resource) {
    return $resource('/api/v1/settings/:id', {}, {
        update: {
            method: 'PUT'
        }
    });
}
angular.module('c.s')
    .factory('Sms', function($http, C) {
        return {
            send: function (data, success, error) {
                $http.post(C.URL.SMS_SEND, data).success(success).error(error);
            },
            remove: function (data, success, error) {
                $http.post(C.URL.SMS_RM, data).success(success).error(error);
            },
            history: function (data, success, error) {
                $http.get(C.URL.SMS_HISTORY, {params: data}).success(success).error(error);
            }
        };
    });


(function () {
    'use strict';


    angular.module('c.s')
        .factory('User', User)
        .factory('UserType', UserType)
        .factory('UserStatus', UserStatus)
        .factory('UserOnType', UserOnType)
        .factory('NewUser', NewUser)
        .factory('JobTitle', JobTitle)
        .factory('Major', Major)
        .factory('EntryType', EntryType)
        .factory('LeaveReason', LeaveReason)
    ;

    /** @ngInject */
    function NewUser($resource, serviceConfObj, ArrayHelper, $http) {
        var service = {
            urls: {
                API: '/api/v1/user/users',
                DOWNLOAD_PIC: '/api/v1/user/users/downloadPic',
                EXPORT_USER_INFO: '/api/v1/user/users/exportUsers'
            },
            getDegreeType: getDegreeType,
            getDegree: getDegree,
            getDegrees: getDegrees,
            getConfirms: getConfirms,
            getBadges: getBadges,
            getEduBgList: getEduBgList,
            getTitleLevel: getTitleLevel,
            getPoliticalStatus: getPoliticalStatus,
            getDept: getDept,
        };
        return angular.extend(service, $resource(service.urls.API + '/:action/:id',
            {}, angular.extend(serviceConfObj, {
                batchConfirm: {
                    method: 'POST',
                    params: {
                        action: 'batchConfirm'
                    }
                },
                batchBadge: {
                    method: 'POST',
                    params: {
                        action: 'batchBadge'
                    }
                }
            })));

        function getDept(params) {
            var api = service.urls.API + '/-/depts';
            return $http.get(api, params);
        }

        function getDegreeType(degree) {
            var degreeTypes = ArrayHelper.get('degree_types');
            if (degree) {
                for (var i = 0; i < degreeTypes.length; i++) {
                    var type = degreeTypes[i];
                    if (degree.indexOf(type.name) >= 0) {
                        return type;
                    }
                }
            }
            return degreeTypes[0];
        }

        function getDegree(degree, type) {
            var degrees = this.getDegrees(type);
            for (var i = 0; i < degrees.length; i++) {
                var d = degrees[i];
                if (degree == d.name) {
                    return d;
                }
            }
            return degrees[0];
        }

        function getDegrees(type) {
            var d = null;
            switch (type) {
                case 2:
                    d = ArrayHelper.get('doctor_degrees');
                    break;
                case 3:
                    d = ArrayHelper.get('master_degrees');
                    break;
                case 4:
                    d = ArrayHelper.get('bachelor_degrees');
                    break;
                case 0:
                    d = ArrayHelper.get('none_degree');
                    break;
            }
            return d;
        }

        function getEduBgList() {
            return [
                {id: 5, name: "本科"},
                {id: 6, name: "硕士研究生"},
                {id: 7, name: "博士研究生"},
                {id: 1, name: "高中"},
                {id: 2, name: "中专"},
                {id: 3, name: "大专"},
                {id: 4, name: "初中"},
                {id: 8, name: "职高"},
                {id: 9, name: "其他"}
            ];
        }

        function getConfirms() {
            return [
                {id: 0, name: '用户待确认'},
                {id: 1, name: '人事科待确认'},
                {id: 2, name: '人事科确认'},
                {id: 3, name: '科室待确认'},
                {id: 4, name: '用户待现场报到'},
                {id: 10, name: '退回'}
            ]
        }

        function getBadges() {
            return [
                {id: 1, name: '胸牌待制作'},
                {id: 2, name: '胸牌制作中'},
                {id: 3, name: '胸牌待领取'},
                {id: 4, name: '胸牌已领取'}
            ]
        }

        function getTitleLevel() {
            return [
                {id: 1, name: '无'},
                {id: 2, name: '初级'},
                {id: 3, name: '中级'},
                {id: 4, name: '副高'},
                {id: 5, name: '正高'}
            ]
        }

        function getPoliticalStatus() {
            return [
                {id:1,name: '中共党员'},
                {id:2,name: '中共预备党员'},
                {id:3,name: '共青团员'},
                {id:13,name: '群众'}
            ]
        }

    }

    /** @ngInject */
    function User($resource, ArrayHelper) {
        var service = {
            getDegreeType: getDegreeType,
            getDegree: getDegree,
            getDegrees: getDegrees,
            getConfirms: getConfirms
        };

        return angular.extend(service, $resource('/api/v1/users/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            setSeniority: {
                method: 'POST',
                params: {
                    action: 'set_seniority'
                }
            }
        }));


        function getDegreeType(degree) {
            var degreeTypes = ArrayHelper.get('degree_types');
            if (degree) {
                for (var i = 0; i < degreeTypes.length; i++) {
                    var type = degreeTypes[i];
                    if (degree.indexOf(type.name) >= 0) {
                        return type;
                    }
                }
            }
            return degreeTypes[0];
        }

        function getDegree(degree, type) {
            var degrees = this.getDegrees(type);
            for (var i = 0; i < degrees.length; i++) {
                var d = degrees[i];
                if (degree == d.name) {
                    return d;
                }
            }
            return degrees[0];
        }

        function getDegrees(type) {
            var d = null;
            switch (type) {
                case 2:
                    d = ArrayHelper.get('doctor_degrees');
                    break;
                case 3:
                    d = ArrayHelper.get('master_degrees');
                    break;
                case 4:
                    d = ArrayHelper.get('bachelor_degrees');
                    break;
                case 0:
                    d = ArrayHelper.get('none_degree');
                    break;
            }
            return d;
        }

        function getConfirms() {
            return [
                {id: 0, name: '用户待确认'},
                {id: 1, name: '人事科待确认'},
                {id: 2, name: '人事科确认'},
                {id: 3, name: '科室待确认'},
                {id: 4, name: '用户待现场报到'},
                {id: 10, name: '退回'}
            ]
        }
    }

    /** @ngInject */
    function UserOnType($resource, serviceConfObj) {
        return $resource('/api/v1/user_on_types/:id', {}, serviceConfObj);
    }

    /** @ngInject */
    function JobTitle($resource, serviceConfObj) {
        var service = {
            getTypes: getTypes
        };

        // 1医生 2医技 3护理 4工程技术 99其他
        function getTypes() {
            return [
                {id: 1, name: '医生'},
                {id: 2, name: '医技'},
                {id: 3, name: '护理'},
                {id: 4, name: '工程技术'},
                {id: 99, name: '其他'},
            ];
        }

        return angular.extend(service, $resource('/api/v1/job_titles/:id', {}, serviceConfObj));
    }

    /** @ngInject */
    function Major($resource, serviceConfObj) {
        return $resource('/api/v1/majors/:id', {}, serviceConfObj);
    }

    /** @ngInject */
    function UserType($resource) {
        return $resource('/api/v1/user_types/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }

    /** @ngInject */
    function UserStatus($resource) {
        return $resource('/api/v1/user_statuses/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }

    /** @ngInject */
    function EntryType($resource) {
        return $resource('/api/v1/entry_types/:id', {}, {
            update: {
                method: 'PUT'
            }
        });
    }

    /** @ngInject */
    function LeaveReason($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/leave_reasons/:id', {}, {
            update: {
                method: 'PUT'
            }
        }));
    }

})();

angular.module('c.s')
    .factory('UserDept', ['$resource', function ($resource) {
        return $resource('/api/v1/user_depts/:id', {}, {
            update: { method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        });
    }]);


(function(){
    var elif = angular.module('elif', []);

    var CONDITIONALS = 'elif.conditionals';

    // This is copied from AngularJS because it is not
    // part of the public interface.
    var getBlockElements = function(nodes){
        if(!nodes || !nodes.length){
            return angular.element();
        }

        var startNode = nodes[0];
        var endNode = nodes[nodes.length - 1];

        if(startNode === endNode){
            return angular.element(startNode);
        }

        var element = startNode;
        var elements = [element];

        do {
            element = element.nextSibling;
            if(!element){
                break;
            }
            elements.push(element);
        }
        while(element !== endNode);

        return angular.element(elements);
    };

    elif.factory('elif', [
        function(){
            // By requiring the scope have it's own copy of `elif.conditionals`
            // we avoid if/else-if/else structures that span AngularJS scopes.
            var getConditionals = function(scope){
                if(angular.hasOwnProperty.call(scope, CONDITIONALS)){
                    var conditionals = scope[CONDITIONALS];
                    return conditionals[conditionals.length - 1];
                }
            };

            return {
                create: function(scope, fn, callback){
                    var conditionals = [{
                        fn: fn,
                        callback: callback || angular.identity
                    }];
                    var conditionalValues = [];

                    scope.$watch(function(){
                        // Watch the boolean conditionals; we only need
                        // to run through the if/else-if/else chain if one
                        // of them changes.  We can also take the chance to
                        // short-circuit when we've found our first true
                        // condition.
                        var i;
                        var len = conditionals.length;
                        conditionalValues.length = len;
                        for(i = 0; i < len; i++){
                            if((conditionalValues[i] = !!conditionals[i].fn())){
                                i++;
                                break;
                            }
                        }
                        for(; i < len; i++){
                            conditionalValues[i] = false;
                        }
                        return conditionalValues;
                    }, function(conditionalValues){

                        // Update each block; also find first matching if/else-if.
                        var index = -1;
                        for(var i = 0, len = conditionals.length; i < len; i++){
                            if(conditionalValues[i]){
                                conditionals[i].callback(true);
                                index = i;
                            }
                            else {
                                conditionals[i].callback(false);
                            }
                        }

                        // Handle else, if there is one.
                        conditionals.fallthrough && conditionals.fallthrough(index === -1);

                    }, true); // Deep watch; we know that it is a simple list of booleans.

                    // Keep track of if/else-if/else structures per AngularJS scope.
                    if(!angular.hasOwnProperty.call(scope, CONDITIONALS)){
                        scope[CONDITIONALS] = [];
                    }
                    scope[CONDITIONALS].push(conditionals);
                },
                extend: function(scope, fn, callback){
                    var conditionals = getConditionals(scope);
                    if(!conditionals){
                        throw new Error('elif.extend: no if found at this level');
                    }
                    if(conditionals.fallthrough){
                        throw new Error('elif.extend: else-if after else');
                    }

                    conditionals.push({
                        fn: fn,
                        callback: callback
                    });
                },
                fallthrough: function(scope, fn, callback){
                    var conditionals = getConditionals(scope);
                    if(!conditionals){
                        throw new Error('elif.fallthrough: no if found at this level');
                    }
                    if(conditionals.fallthrough){
                        throw new Error('elif.fallthrough: else already found at this level');
                    }
                    conditionals.fallthrough = callback;
                }
            };
        }
    ]);

    // This implementation is basically the built-in `ng-if`, hooked into the `elif` service.
    var elifDirective = function(name, method, getter){
        elif.directive(name, [
            '$animate',
            '$document',
            '$injector',
            'elif',
            function($animate, $document, $injector, elif){
                var getterFn = getter && $injector.invoke(getter);

                return {
                    transclude: 'element',
                    restrict: 'A',
                    priority: 600,
                    terminal: true,
                    link: function(scope, element, attrs, ctrls, transcludeFn){
                        var watchFn = getterFn && getterFn(scope, element, attrs);
                        var childScope;
                        var childElement;
                        var previousElements;

                        elif[method](scope, watchFn, function(value){
                            if(value){
                                if(!childScope){
                                    childScope = scope.$new();
                                    transcludeFn(childScope, function(clone){
                                        clone[clone.length + 1] = $document[0].createComment(' end ' + name + ': ' + attrs[name] + ' ');
                                        childElement = clone;
                                        $animate.enter(clone, element.parent(), element);
                                    });
                                }
                            }
                            else {
                                if(childScope){
                                    childScope.$destroy();
                                    childScope = null;
                                }
                                if(previousElements){
                                    previousElements.remove();
                                    previousElements = null;
                                }
                                if(childElement){
                                    previousElements = getBlockElements(childElement);
                                    $animate.leave(previousElements, function(){
                                        previousElements = null;
                                    });
                                    childElement = null;
                                }
                            }
                        });
                    }
                };
            }
        ]);
    };

    // Reads the attribute given by `name` and converts it to a boolean.
    var getter = function(name){
        return [
            '$parse',
            function($parse){
                return function(scope, element, attrs){
                    var testFn = $parse(attrs[name]);
                    return function(){
                        return !!testFn(scope);
                    };
                };
            }
        ];
    };

    // We rely on the built-in `ng-if` directive to actually perform
    // the transclusion, and simply tie it in to the `elif` service.
    elif.directive('ngIf', [
        '$injector',
        'elif',
        function($injector, elif){
            var getterFn = $injector.invoke(getter('ngIf'));
            return {
                priority: 600,
                link: function(scope, element, attrs){
                    var watchFn = getterFn(scope, element, attrs);
                    elif.create(scope, watchFn);
                }
            }
        }
    ]);

    // Else-if and else perform their own transclusions.
    elifDirective('ngElseIf', 'extend', getter('ngElseIf'));
    elifDirective('ngElif', 'extend', getter('ngElif'));

    // Else doesn't take an argument.
    elifDirective('ngElse', 'fallthrough');
})();
angular.module('c.d')
    .directive('compareTo', function () {
        return {
            require: "ngModel",
            scope: {
                otherModelValue: "=compareTo"
            },
            link: function(scope, element, attributes, ngModel) {

                ngModel.$validators.compareTo = function(modelValue) {
                    return modelValue == scope.otherModelValue;
                };

                scope.$watch("otherModelValue", function() {
                    ngModel.$validate();
                });
            }
        };
    });
(function () {
    'use strict';

    angular.module('c.d')
        .directive('editor', editor);

    // https://github.com/wayou/wayou.github.io/issues/5
    var ckSimpleConfig = {
        height: 120,
        toolbarGroups: [
            {name: 'basicstyles', groups: ['basicstyles']},
            {name: 'paragraph', groups: ['list', 'align']},
            {name: 'styles', groups: ['styles', 'colors']},
            {name: 'insert', groups: ['insert']},
            // {name: 'tools', groups: ['tools']}
        ],
        removeButtons: 'Subscript,Superscript,Styles,Format,JustifyBlock,ShowBlocks,' +
        'Flash,HorizontalRule,Smiley,PageBreak,Iframe,Table'
    };

    /** @ngInject */
    function editor($compile, UIHelper) {
        return {
            restrict: 'E',
            scope: {
                model: '=ngModel',
                height: '=height'
            },
            require: ['^ngModel', '?^form'],
            compile: function () {
                return {
                    pre: function prelink(scope, iElement, iAttrs, r) {
                        var id = 'editor' + (new Date()).getTime() + (Math.floor(Math.random() * 100000));
                        var ngModelCtrl = r[0], formCtrl = r[1];
                        var vm = scope;
                        vm.onReady = UIHelper.onCKReady;


                        init();


                        function init() {
                            scope.$on('$destroy', function () {
                                var editor = CKEDITOR.instances[id];
                                if (editor) editor.destroy();
                            });

                            scope.$watch('model', function (newValue, oldValue) {
                                if (angular.isDefined(oldValue)) ngModelCtrl.$setTouched();
                            });

                            var elem;
                            if (angular.isDefined(iAttrs.simple)) {
                                vm.ckConfig = angular.copy(ckSimpleConfig);
                                if (vm.height) vm.ckConfig.height = vm.height;
                                elem = '<div ckeditor="ckConfig" ng-model="model" ready=onReady("' + id + '") id="' + id + '"></div>';
                            } else {
                                elem = '<div ckeditor ng-model="model" ready=onReady("' + id + '") id="' + id + '"></div>';
                            }
                            var layer = angular.element(elem);
                            iElement.append(layer);
                            $compile(iElement.contents())(scope);

                            checkValidity();

                            if (formCtrl) {
                                scope.$watch(function () {
                                    return formCtrl.$submitted;
                                }, function (submitted) {
                                    if (submitted) iElement.addClass('submitted')
                                });
                            }
                        }

                        function checkValidity() {
                            var valid = iAttrs.required ? (!!ngModelCtrl.$viewValue) : true;
                            ngModelCtrl.$setValidity('required', valid);
                        }
                    }
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .directive('requireMultiple', requireMultiple);

    /** @ngInject */
    function requireMultiple($parse) {
        return {
            require: 'ngModel',
            link: function postLink(scope, element, attrs, ngModel) {
                var require = $parse(attrs.requireMultiple)();
                if (require !== false) {
                    ngModel.$validators.required = function (value) {
                        return angular.isArray(value) && value.length > 0;
                    };
                }
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('c')
        .directive('scrollForm', scrollForm);

    /** @ngInject */
    function scrollForm($timeout, $anchorScroll, $location) {
        return {
            restrict: 'A',
            link: function (scope, elem) {
                elem.on('submit', function () {
                    $timeout(function(){
                        var firstInvalid = elem[0].querySelector('.ng-invalid');

                        if (firstInvalid) {
                            if ($location.hash() !== firstInvalid.id) {
                                $location.hash(firstInvalid.id);
                            }
                            $anchorScroll();
                            firstInvalid.focus();
                        }
                    });

                });
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('c.d')
        .directive('startDate', startDate);

    function startDate() {
        return {
            restrict: "A",
            require: "?ngModel",
            link: function (scope, element, attributes, ngModel) {
                function validateEndDate(endDate, startDate) {

                    if (endDate && startDate) {
                        startDate = new Date(startDate);
                        startDate.setHours(0, 0, 0, 0);
                        endDate = new Date(endDate);
                        endDate.setHours(0, 0, 0, 0);
                        return endDate >= startDate;
                    } else {
                        return true;
                    }
                }

                ngModel.$validators.startDate = function (modelValue) {
                    var startDate = Date.parse(attributes.startDate);
                    return validateEndDate(modelValue, startDate);
                };

                attributes.$observe('startDate', function (value) {
                    var startDate = Date.parse(value);
                    var endDate = Date.parse(ngModel.$viewValue);
                    ngModel.$setValidity("startDate", validateEndDate(endDate, startDate));
                });
            }
        };
    }
})();

// 因为点击选项造成的失去焦点，无法辨别
// (function () {
//     'use strict';
//
//     angular.module('c')
//         .directive('tagOnBlur', tagOnBlur);
//
//     /** @ngInject */
//     function tagOnBlur($timeout) {
//
//         var directive = {
//             require: 'uiSelect',
//             link: link
//         };
//
//         return directive;
//
//         function link(scope, elm, attrs, ctrl) {
//             scope.$on('uis:select', function (event, item) {
//                 ctrl.search = '';
//             });
//             ctrl.searchInput.on('blur', function (e) {
//                 if ((ctrl.items.length > 0 || ctrl.tagging.isActivated)) {
//                     $timeout(function () {
//                         ctrl.searchInput.triggerHandler('tagged');
//                         var newItem = ctrl.search;
//                         if (ctrl.tagging.fct) {
//                             newItem = ctrl.tagging.fct(newItem);
//                         }
//                         if (newItem) ctrl.select(newItem, true);
//                         ctrl.search = '';
//                     });
//                 }
//             });
//         }
//
//     }
//
// })();
angular.module('c.d')
    .directive('dateRange', function () {
        return {
            templateUrl: 'templates/date_range.html',
            restrict: 'E',
            replace: true,
            scope: {
                'name': '@',
                'dateRangeFilter': '=',
                'placeHolder': '@'
            }
            //, controller: function($scope) {}
        }
    });
angular.module('c.d')
    .directive('focusMe', function ($timeout) {
        return {
            link: function (scope, element, attrs) {
                scope.$watch(attrs.focusMe, function (value) {
                    if (value === true) {
                        $timeout(function () {
                            element[0].focus();
                        });
                    }
                });
            }
        };
    });
angular.module('c.d')
.directive('ngIndeterminate', function($compile) {
    return {
        restrict: 'A',
        link: function(scope, element, attributes) {
            scope.$watch(attributes['ngIndeterminate'], function (value) {
                element.prop('indeterminate', !!value);
            });
        }
    };
});
(function () {
    'use strict';

    angular.module('c.d')
        .directive('loadingContainer', function () {
            return {
                restrict: 'A',
                scope: false,
                link: function (scope, element, attrs) {
                    if (angular.isUndefined(attrs.loadingIcon)) attrs.loadingIcon = 'fa-spinner fa-2x fa-pulse';
                    if (angular.isUndefined(attrs.loadingTitle)) attrs.loadingTitle = '加载中，请稍后...';
                    var elem = '<div class="loading d-flex align-items-center justify-content-center">' +
                        '<div><i class="fa ' + attrs.loadingIcon + ' mr-2"></i>' +
                        (attrs.loadingTitle ? '<span>' + attrs.loadingTitle + '</span></div>' : '') +
                        '</div>';
                    var loadingLayer = angular.element(elem);
                    element.append(loadingLayer);
                    element.addClass('loading-container');
                    scope.$watch(attrs.loadingContainer, function (value) {
                        loadingLayer.toggleClass('ng-hide', !value);
                    });
                }
            };
        });

})();
angular.module('c.d').directive('modalDraggable', function ($document) {
    "use strict";
    return function (scope, element) {
        var startX = 0,
            startY = 0,
            x = 0,
            y = 0;
        element = angular.element(document.getElementsByClassName("modal-dialog"));
        if (element.length > 0) {
            element = element.last();


        }
        element.css({
            position: 'fixed',
            left: '50%',
            transform: 'translateX(-50%)'
        });

        var header = element.find('.modal-header');
        //var footer = element.find('.modal-footer');
        //var body = element.find('.modal-body');
        //
        //body.css({
        //    'min-width': '300px'
        //    //'max-height': '480px',
        //    //'overflow-y': 'scroll'
        //});

        header.on('mousedown', function (event) {
            // Prevent default dragging of selected content
            event.preventDefault();
            x = element.prop('offsetLeft');
            startX = event.screenX - x;
            startY = event.screenY - y;
            $document.on('mousemove', mousemove);
            $document.on('mouseup', mouseup);
        });


        function mousemove(event) {
            y = event.screenY - startY;
            x = event.screenX - startX;
            if (y + 60 <= 0 || y + 60 >= window.innerHeight ||
                x <= 0 || x >= window.innerWidth)
                return;

            element.css({
                top: y + 'px',
                left: x + 'px'
            });
        }

        function mouseup() {
            $document.unbind('mousemove', mousemove);
            $document.unbind('mouseup', mouseup);
        }
    };
});
angular.module('c.d')
    .directive('numberRange', function () {
        return {
            templateUrl: 'templates/number_range.html',
            restrict: 'E',
            replace: true,
            scope: {
                'name': '@',
                'numRangeFilter': '=',
                'placeHolder': '@'
            }
            //, controller: function($scope) {}
        }
    });
angular.module('c.d')
    .directive('selectOnClick', ['$window', function ($window) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.on('click', function () {
                if (!$window.getSelection().toString()) {
                    // Required for mobile Safari
                    this.setSelectionRange(0, this.value.length)
                }
            });
        }
    };
}]);
(function () {
    'use strict';

    angular
        .module('c.d')
        .directive('dragScroll', DragScroll);

    DragScroll.$inject = ['$document', '$window', '$parse'];

    /* @ngInject */
    function DragScroll($document, $window, $parse) {
        //Usage:
        //<div drag-scroll>Lorem ipsum dolor sit amet</div>
        var directive = {
            restrict: 'A',
            link: function ($scope, $element, $attributes) {
                var enabled = true;
                var allowedClickOffset = 5;
                var pushed = false;
                var onDragStart = $parse($attributes.onDragStart);
                var onDragEnd = $parse($attributes.onDragEnd);
                var axis = $attributes.axis || false;
                var excludedClasses = $attributes.dragScrollExcludedClasses ? $attributes.dragScrollExcludedClasses.split(',') : [];
                var startClientX;
                var startClientY;
                var lastClientX;
                var lastClientY;

                $scope.$watch($attributes.dragScroll, function (newValue) {
                    enabled = newValue !== undefined ? newValue : true;
                });

                // Set event listeners
                $element.on('mousedown', handleMouseDown);

                // Set destroy listener
                $scope.$on('$destroy', destroy);

                /**
                 * Sets the event listeners for the mouseup and mousedown events
                 */
                function setDragListeners() {
                    angular.element($window).on('mouseup', handleMouseUp);
                    angular.element($window).on('mousemove', handleMouseMove);
                }

                /**
                 * Removes the event listeners for the mouseup and mousedown events
                 */
                function removeDragListeners() {
                    angular.element($window).off('mouseup', handleMouseUp);
                    angular.element($window).off('mousemove', handleMouseMove);
                }

                /**
                 * Handles mousedown event
                 * @param {object} e MouseDown event
                 */
                function handleMouseDown(e) {
                    if (enabled) {
                        for (var i = 0; i < excludedClasses.length; i++) {
                            if (angular.element(e.target).hasClass(excludedClasses[i])) {
                                return false;
                            }
                        }

                        $scope.$apply(function () {
                            onDragStart($scope);
                        });

                        // Set mouse drag listeners
                        setDragListeners();

                        // Set 'pushed' state
                        pushed = true;
                        lastClientX = startClientX = e.clientX;
                        lastClientY = startClientY = e.clientY;

                        clearSelection();

                        e.preventDefault();
                        e.stopPropagation();
                    }

                }

                /**
                 * Handles mouseup event
                 * @param {object} e MouseUp event
                 */
                function handleMouseUp(e) {
                    if (enabled) {
                        var selectable = (e.target.attributes && 'drag-scroll-text' in e.target.attributes);
                        var withinXConstraints = (e.clientX >= (startClientX - allowedClickOffset) && e.clientX <= (startClientX + allowedClickOffset));
                        var withinYConstraints = (e.clientY >= (startClientY - allowedClickOffset) && e.clientY <= (startClientY + allowedClickOffset));

                        // Set 'pushed' state
                        pushed = false;

                        // Check if cursor falls within X and Y axis constraints
                        if (selectable && withinXConstraints && withinYConstraints) {
                            // If so, select the text inside the target element
                            selectText(e.target);
                        }

                        $scope.$apply(function () {
                            onDragEnd($scope);
                        });

                        removeDragListeners();
                    }

                }

                /**
                 * Handles mousemove event
                 * @param {object} e MouseMove event
                 */
                function handleMouseMove(e) {
                    if (enabled) {
                        if (pushed) {
                            if (!axis || axis === 'x') {
                                $element[0].scrollLeft -= (-lastClientX + (lastClientX = e.clientX));
                            }
                            if (!axis || axis === 'y') {
                                $element[0].scrollTop -= (-lastClientY + (lastClientY = e.clientY));
                            }
                        }

                        e.preventDefault();
                    }
                }

                /**
                 * Destroys all the event listeners
                 */
                function destroy() {
                    $element.off('mousedown', handleMouseDown);
                    angular.element($window).off('mouseup', handleMouseUp);
                    angular.element($window).off('mousemove', handleMouseMove);
                }

                /**
                 * Selects text for a specific element
                 * @param {object} element Selected element
                 */
                function selectText(element) {
                    var range;
                    if ($window.document.selection) {
                        range = $window.document.body.createTextRange();
                        range.moveToElementText(element);
                        range.select();
                    } else if ($window.getSelection) {
                        range = $window.document.createRange();
                        range.selectNode(element);
                        $window.getSelection().addRange(range);
                    }
                }

                /**
                 * Clears text selection
                 */
                function clearSelection() {
                    if ($window.getSelection) {
                        if ($window.getSelection().empty) {  // Chrome
                            $window.getSelection().empty();
                        } else if ($window.getSelection().removeAllRanges) {  // Firefox
                            $window.getSelection().removeAllRanges();
                        }
                    } else if ($document.selection) {  // IE?
                        $document.selection.empty();
                    }
                }


            }
        };
        return directive;

    }

})();
angular.module('c.c')
    .controller('MeetingApprovalCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, C, F, Meeting) {
        $scope.$on('meetingBack', function (event, data) {
            $scope.tableParams.reload();
        });
        $scope.cols = [
            {title: '名称', width: '20%', show: true},
            {title: '类型', width: '20%', show: true},
            //{title: '开会时间', width: '20%', show: true},
            //{title: '开会地点', width: '10%', show: true},
            {title: '申请人', show: true},
            {title: '申请时间', show: true}
        ];

        $scope.optColWidth = 53;
        $scope.hideFilter = true;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = $scope.opt; //科审3,院审4
                Meeting.query(url, function (data) {
                    params.total(data.total);
                    //angular.forEach(data.meetings, function (meeting) {
                    //    meeting.time_range = meeting.start_time.substr(0, 16) + ' - ' + meeting.end_time.substr(11, 5);
                    //});
                    $defer.resolve(data.meetings);
                });
            }
        });

        $scope.approval = function (meeting) {
            dialogs.create('templates/meeting/edit_dlg.html', 'MeetingEditDlgCtrl', {
                id: meeting.id, ForApproval: true, deptId: meeting.dept_id
            }, {
                 size: 'lg'
            }).result.then(function (params) {
                Meeting.update({id: meeting.id}, params).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('会议审批成功');
                                $scope.tableParams.reload();
                                break;
                            case 1:
                                toaster.warning('会议室冲突');
                                break;
                            case 2:
                                toaster.warning('设备冲突');
                                break;
                            case 3:
                                toaster.warning('该会议已发布');
                                break;
                        }
                    }, function () {
                        toaster.error('会议审批失败了!');
                    }
                );
            });
        };
    });


(function () {
    'use strict';

    angular.module('c.c')
        .controller('DeptMembersTabCtrl', DeptMembersTabCtrl)
        .controller('DeptMembersInCtrl', DeptMembersInCtrl)
        // .controller('DeptAgentCtrl', DeptAgentCtrl)
        .controller('DeptMembersOutCtrl', DeptMembersOutCtrl)
        .controller('DeptMembersRegCtrl', DeptMembersRegCtrl)
    ;

    /** @ngInject */
    function DeptMembersTabCtrl($scope, UIHelper, $stateParams, $rootScope) {
        var vm = $scope;
        UIHelper.loadTabs(vm, $stateParams, $rootScope);
    }


    function DeptMembersInCtrl($scope, toaster, NgTableParams, Dept, UserDept, F,
                               ArrayHelper, Table, Dlg) {
        var vm = $scope;
        vm.save = save;
        vm.edit = edit;
        vm.user_leave = user_leave;
        vm.transfer = transfer;
        // vm.setAgent = setAgent;
        vm.deptSelectedFn = deptSelectedFn;
        vm.clearFilters = clearFilters;
        var titles = ArrayHelper.get('titles');
        var posts = ArrayHelper.get('posts');
        var titleOpts = Table.getNgTableOpts(ArrayHelper.get('titles'));

            vm.cols = [
                {
                    title: '姓名',
                    filter: {name: 'text'},
                    field: 'name',
                    show: true
                },
                {title: '胸牌号', filter: {username: 'text'}, field: 'username', show: true},
                {
                    title: '入科时间',
                    //sortable: 'entry_time',
                    filter: {entry_time: 'date_range'},
                    field: 'entry_time',
                    show: true
                },
                {title: '专业', field: 'major_id', show: true},
                {title: '职称', filter: {title: 'select'}, field: 'title', data: titleOpts, show: true},
                {title: '岗位类型', filter: {type_id: 'select'}, field: 'type_id', show: true},
                {title: '编制类型', filter: {status_id: 'select'}, field: 'status_id', show: true},
                {title: '科室职务', filter: {post: 'text'}, field: 'post', show: true}
                // {title: '排序', field: 'sorting', show: true}
            ];

            vm.optColWidth = 70;
            vm.user_types_col = $scope.cols[5];
            vm.statuses_col = $scope.cols[6];

            vm.dateRangeFilter = {};
            vm.$watch(
                function () {
                    return $scope.dateRangeFilter;
                },
                function (newValue, oldValue) {
                    $scope.tableParams.reload();
                }, true
            );

            Dept.query({opt: 7}, function (resp) {
                $scope.depts = resp.depts;
                if (resp.depts && resp.depts.length > 0) {
                    $scope.dept = resp.depts[0];
                    $scope.tableParams.reload();
                }
            });

            vm.tableParams = new NgTableParams({page: 1, count: 30}, {
                counts: [30, 50, 100], total: 0,
                getData: function ($defer, params) {
                    if ($scope.dept) {
                        var url = params.url();
                        url['opt'] = 4;
                        if ($scope.dateRangeFilter['entry_time']) {
                            url['entry_time_start'] = $filter('date')(
                                $scope.dateRangeFilter['entry_time'].startDate, 'yyyy-MM-dd');
                            url['entry_time_end'] = $filter('date')(
                                $scope.dateRangeFilter['entry_time'].endDate, 'yyyy-MM-dd');
                        }
                        url['dept_id'] = $scope.dept.id;
                        UserDept.query(url, function (resp) {
                            params.total(resp.total);
                            $scope.statuses_col.data = F.getNgTableOpts(resp.statuses);
                            $scope.user_types_col.data = F.getNgTableOpts(resp.types);

                            angular.forEach(resp.users, function (u) {
                                u.title = F.getItem(u.title, titles);
                            });
                            $defer.resolve(resp.users);
                        });
                    } else {
                        $defer.resolve([]);
                    }
                }
            });
        // }

        // function setAgent(dept) {
        //     Dlg.show({name: 'DeptAgent', data: {id: dept.id}});
        // }

        function deptSelectedFn($index) {
            $scope.dept = $scope.depts[$index];
            $scope.tableParams.$params.page = 1;
            $scope.tableParams.reload();
        }

        function clearFilters() {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        }

        function edit(user) {
            user.$edit = true;
            user.$postChanged = user.post;
            user.$sortingChanged = user.sorting;
        }

        function save(user) {
            user.$edit = false;

            var data = {};
            data['post'] = user.$postChanged;
            data['sorting'] = user.$sortingChanged;
            UserDept.update({id: user.id}, data).$promise.then(function (resp) {
                toaster.success('修改成功!');
                $scope.tableParams.reload();
            }, function () {
                toaster.error('修改失败!');
            });
        }

        function user_leave(m) {
            Dlg.show({
                template: 'pages/dialogs/userLeaveDlg.html',
                ctrl: 'LeaveCtrl',
                data: {id: m.user_id}
            }).then(function () {
                $scope.tableParams.reload();
            });
        }

        function transfer(m) {
            Dlg.show({
                template: 'templates/transMemberDlg.html',
                ctrl: 'TransMemberCtrl',
                data: {
                    user: m, dept: $scope.dept
                }
            }).then(function (params) {
                params['opt'] = 3;
                UserDept.update({id: m.id}, params).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s('转科成功!');
                            $scope.tableParams.reload();
                            break;
                        case 1:
                            Dlg.w('该员工已经在目标科室了!');
                            break;
                    }
                }, function () {
                    Dlg.e('转科失败!');
                });
            });
        }
    }
    //
    // function DeptAgentCtrl($scope, $uibModalInstance, $q, toaster, F, Dept, User, data) {
    //     var vm = $scope;
    //     vm.cancel = $uibModalInstance.dismiss;
    //     vm.ok = ok;
    //
    //     init(data.id);
    //
    //
    //     function init(id) {
    //         Dept.get({id: id}, function (resp) {
    //             var dept = resp;
    //             vm.dept = dept;
    //             var edu_agents = [];
    //             angular.forEach(dept.edu_agent, function (edu) {
    //                 edu_agents.push(edu.user);
    //             });
    //             dept.edu_agents = edu_agents;
    //             User.query({opt: 3, dept_id: id}, function (resp) {
    //                 var users = resp.users;
    //                 vm.users = users;
    //                 users.splice(0, 0, {id: 0, name: '空缺'});
    //                 if (dept.mail_recipient == null) dept.mail_recipient = users[0];
    //                 if (dept.trainee_agent == null) dept.trainee_agent = users[0];
    //                 if (dept.csmb_agent == null) dept.csmb_agent = users[0];
    //             });
    //         });
    //     }
    //
    //     function ok(dept) {
    //         var defer = $q.defer();
    //         var pa = {
    //             trainee_agent_id: dept.trainee_agent.id,
    //             mail_recipient_id: dept.mail_recipient.id,
    //             csmb_agent_id: dept.csmb_agent.id
    //         };
    //         pa.edu_ids = F.listKey(dept.edu_agents);
    //         pa.adverse_agent_ids = F.listKey(dept.adverse_agents);
    //         Dept.update({id: dept.id, opt: 1}, pa).$promise.then(function (resp) {
    //             toaster.success(resp.msg);
    //             $uibModalInstance.close();
    //         }).finally(function () {
    //             defer.resolve();
    //         });
    //         return defer.promise;
    //     }
    // }

    function DeptMembersOutCtrl($scope, $filter, toaster, NgTableParams, Dept, UserDept, F) {

        $scope.cols = [
            {
                title: '姓名',
                filter: {name: 'text'},
                field: 'name',
                show: true
            },
            {title: '胸牌号', filter: {username: 'text'}, field: 'username', show: true},
            {
                title: '入科时间',
                sortable: 'entry_time',
                filter: {entry_time: 'date_range'},
                field: 'entry_time',
                width: '20%',
                show: true
            },
            {
                title: '离科时间',
                sortable: 'leave_time',
                filter: {leave_time: 'date_range'},
                field: 'leave_time',
                width: '20%',
                show: true
            },
            {title: '科室职务', filter: {post: 'text'}, field: 'post', show: true},
        ];

        $scope.hideOpt = true;

        $scope.dateRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.dateRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        Dept.query({opt: 6}, function (resp) {
            $scope.depts = resp.depts;
            if (resp.depts && resp.depts.length > 0) {
                $scope.dept = resp.depts[0];
                $scope.tableParams.reload();
            }
        });

        $scope.deptSelectedFn = function ($index) {
            $scope.dept = $scope.depts[$index];
            $scope.tableParams.$params.page = 1;
            $scope.tableParams.reload();
        };

        $scope.tableParams = new NgTableParams({page: 1, count: 30}, {
            counts: [30, 50, 100], total: 0,
            getData: function ($defer, params) {
                if ($scope.dept) {
                    var url = params.url();
                    url['opt'] = 5;
                    if ($scope.dateRangeFilter['entry_time']) {
                        url['entry_time_start'] = $filter('date')(
                            $scope.dateRangeFilter['entry_time'].startDate, 'yyyy-MM-dd');
                        url['entry_time_end'] = $filter('date')(
                            $scope.dateRangeFilter['entry_time'].endDate, 'yyyy-MM-dd');
                    }
                    if ($scope.dateRangeFilter['leave_time']) {
                        url['leave_time_start'] = $filter('date')(
                            $scope.dateRangeFilter['leave_time'].startDate, 'yyyy-MM-dd');
                        url['leave_time_end'] = $filter('date')(
                            $scope.dateRangeFilter['leave_time'].endDate, 'yyyy-MM-dd');
                    }
                    url['dept_id'] = $scope.dept.id;
                    UserDept.query(url, function (resp) {
                        params.total(resp.total);
                        $defer.resolve(resp.users);
                    });
                } else {
                    $defer.resolve([]);
                }
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };
    }

    /** @ngInject */
    function DeptMembersRegCtrl($scope, $q, NewUser, Dlg, Table, UIHelper, Dept) {
        var vm = $scope;
        vm.edit = edit;
        init();

        function init() {
            $q.all([
                NewUser.query({op: 'UserOptions'}).$promise,
                Dept.query({opt: 7}).$promise
            ]).then(function (respArray) {
                // vm.depts = respArray[1].depts;
                UIHelper.loadTab(vm, 'reg');

                var options = {
                    service: NewUser,
                    params: {op: 'DeptRegApproval'},
                    optColWidth: Table._2_BTN,
                    optInFront: true,
                    showSn: true,
                    cols: [
                        {field: "name", title: "姓名", filter: {name: "text"}},
                        {field: "username", title: "胸牌号", filter: {username: "text"}},
                        {field: "dept", title: "科室", filter: {dept: "text"}},
                        {
                            field: "type_id",
                            title: "岗位类型",
                            filter: {type_id: "select"},
                            data: Table.getNgTableOpts(respArray[0].items.types)
                        },
                        {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}}
                    ]
                };

                Table.load(vm, options);
            });
        }

        function edit(m) {
            var pa = {
                user_id: m.id,
                user_reg: true,
                title: '确认信息',
                op: 'DeptApproval'
            };
            Dlg.show({
                template: 'templates/user_reg_dlg.html',
                ctrl: 'UserRegApprovalCtrl',
                data: pa,
                size: 'lg'
            }).then(function () {
                vm.tableReload();
            });
        }
    }
})();

'use strict';

angular.module('c.c')
    .controller('NewsApprovalCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, C, F, Bulletin) {

    });

angular.module('c.c').controller('NewsBackDlgCtrl',
    function ($scope, $uibModalInstance, toaster, C, Bulletin, data) {

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.ok = function () {
            var params = {};
            var back_stage;
            if (data.stage == C.STAGE1.HOSPITAL_APPROVAL)
                back_stage = C.STAGE1.DEPT_BACK;
            if (data.stage == C.STAGE1.PUBLIC)
                back_stage = C.STAGE1.HOSPITAL_BACK;
            params['remark'] = $scope.remark;
            params['is_pass'] = back_stage;
            $uibModalInstance.close(params);
        }
    });

(function () {
    'use strict';

    angular.module('c.c')
        .controller('DeptPhonesCtrl', DeptPhonesCtrl)
        .controller('DeptPhoneDlgCtrl', DeptPhoneDlgCtrl)
    ;

    function DeptPhonesCtrl($scope, toaster, Api, Table, Dept, DeptPhone) {
        var vm = $scope;
        vm.deptSelectedFn = deptSelectedFn;
        vm.addEdit = addEdit;
        vm.remove = remove;

        init();


        function init() {
            var options = {
                service: DeptPhone,
                params: {opt: 1}, sorting: {sorting: 'asc'},
                primaryFilter: 'dept_id',
                hideFilter: true, optColWidth: Table._3_BTN,
                cols: [
                    {title: '名称', field: 'name'}, //0
                    {title: '电话', field: 'phone'}, //1
                    {title: '短号', field: 'cornet'}, //1
                    {title: '排序', sortable: 'sorting', field: 'sorting'} //6
                ]
            };
            Table.load(vm, options);

            Dept.query({opt: 6}, function (resp) {
                vm.depts = resp.depts;
                if (resp.depts && resp.depts.length > 0) {
                    deptSelectedFn(0);
                }
            });
        }

        function deptSelectedFn($index) {
            vm.dept = vm.depts[$index];
            vm.tableParams.filter({dept_id: vm.dept.id});
        }

        function addEdit(m) {
            if (vm.dept) {
                Api.addEdit(vm, 'DeptPhoneDlg.html', 'DeptPhoneDlgCtrl', m, {dept: vm.dept});
            } else {
                toaster.warning('没有相关科室');
            }
        }

        function remove(m) {
            Api.delTableItem(DeptPhone, m.id, vm, '科室电话', m.name);
        }
    }

    function DeptPhoneDlgCtrl($scope, $uibModalInstance, $q, DeptPhone, toaster, F, data) {
        var vm = $scope;
        vm.dept = data.dept;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);


        function init(id) {
            if (id) {
                DeptPhone.get({id: id}, function (resp) {
                    var phone = resp;
                    vm.m = phone;
                });
            } else {
                vm.m = {sorting: 100, dept_id: data.dept.id};
            }
        }

        function ok(m, Form) {
            var defer = $q.defer();
            var validFailed = true;
            if (Form.$valid) {
                validFailed = false;
                var promise;
                var pa = {
                    name: m.name, phone: m.phone, cornet: m.cornet, memo: m.memo, dept_id: m.dept_id,
                    sorting: m.sorting
                };
                if (m.id) { //修改
                    promise = DeptPhone.update({id: m.id, opt: 1/*EDIT_SAVE*/}, pa).$promise;
                } else { //添加
                    promise = DeptPhone.save(pa).$promise;
                }
                promise.then(function (resp) {
                    toaster.success(resp.msg);
                    $uibModalInstance.close();
                }).finally(function () {
                    defer.resolve();
                });
            } else {
                toaster.warning('表单中有错误!');
                Form.submitted = true;
            }
            if (validFailed) {
                defer.reject();
            }
            return defer.promise;
        }
    }


})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('DeptRoundsCtrl', DeptRoundsCtrl)


    ;
    /** @ngInject */
    function DeptRoundsCtrl($scope, UIHelper, $rootScope, $stateParams) {
        var vm = $scope;
        UIHelper.loadTabs(vm, $stateParams, $rootScope);
    }
})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('BulletinShowDlgCtrl', BulletinShowDlgCtrl);

    /** @ngInject */
    function BulletinShowDlgCtrl($rootScope, $scope, $sce, dialogs, $uibModalInstance, C, Auth, FileHelper, PrintHelper,
                                 SaveAs, toaster, $http, data) {
        function initData() {
            $scope.approval = data.approval;
            $http.get('/api/v1/bulletin/bulletins/' + data.id ).success(function (resp) {
                var bulletin = resp;
                $scope.article = {
                    id: bulletin.id,
                    sender: bulletin.sender,
                    release_time: bulletin.release_time,
                    title: bulletin.title,
                    dept: bulletin.dept,
                    body: bulletin.body,
                    attachment: bulletin.attachments,
                    recipient: bulletin.recipient,
                    created_at: bulletin.created_at
                };
                $scope.article.body_sce = $sce.trustAsHtml(bulletin.body);

                if (!bulletin.recipient) {
                    var params = {};
                    params['opt'] = 1;
                    params['bulletin_id'] = bulletin.id;
                    $http.post('/api/v1/bulletin/bulletins/collect', params).success(function () {
                        $rootScope.$broadcast('ReadBulletin', {id: bulletin.id});
                    });
                }
            });
        }

        if (data.id === 0) {
            var preview = data.preview;
            $scope.article = {
                title: preview.title,
                body_sce: $sce.trustAsHtml(preview.body),
                dept: preview.dept.name,
                sender: Auth.getAccount()
            }
        } else {
            initData();
        }

        $scope.collect = function (article) {
            var params = {};
            params['opt'] = 2;
            params['bulletin_id'] = article.id;
            $http.post('/api/v1/bulletin/bulletins/collect', params).success(function () {
                article.recipient = {};
                article.recipient['is_collect'] = 1;
                $rootScope.$broadcast('Collect');
                toaster.success('已收藏!');
            });
        };

        $scope.cancel_collect = function (article) {
            var params = {};
            params['opt'] = 3;
            params['bulletin_id'] = article.id;
            $http.post('/api/v1/bulletin/bulletins/collect', params).success(function () {
                article.recipient.is_collect = 0;
                $rootScope.$broadcast('CancelCollect');
                toaster.success('已取消收藏!');
            });
        };


        $scope.back = function (article) {
            dialogs.create('templates/article/back.html', 'BulletinBackDlgCtrl', {
                stage: 4
            }, {
                size: 'xs'
            }).result.then(function (params) {
                Bulletin.update({id: article.id, opt: 5}, params).$promise.then(function () {
                    toaster.success('退回成功!');
                    $rootScope.$broadcast('bulletinBack');
                    $uibModalInstance.dismiss('cancel');
                }, function () {
                    toaster.error('退回失败!');
                })
            })
        };

        $scope.download = function (attachment) {
            var params = {filename: attachment.filename, mime: attachment.mime};
            attachment.downloading = true;
            FileHelper.download(C.URL.BULLETIN_DOWNLOAD, params, function (resp) {
                attachment.downloading = false;
                var data = [resp];
                var options = {type: attachment.mime};
                SaveAs.download(data, attachment.name, options);
            }, function (error) {
                attachment.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };

        $scope.print = function (article) {

            PrintHelper.print(window.open('', '打印预览'), 'templates/print/ap_order.html', function () {
                var html = '<header class="clearfix"><h1>' + article.title + '</h1>' +
                    '<small style="margin-left: 120px">发布科室:' + article.dept.name + '&nbsp;&nbsp;&nbsp;' + '发布人：' + article.sender.name +
                    '&nbsp;&nbsp;&nbsp;发布时间：' + article.release_time + '</small></header><hr/>';

                html += article.body_sce;

                return html;
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();

angular.module('c.c').controller('ContactGroupMembersCtrl',
    function ($scope, $uibModalInstance, $filter, NgTableParams, dialogs, Table,
              toaster, F, ContactGroup, data) {
        $scope.yesNo = F.get('yesNo');
        var yesNoOpts = F.getNgTableOpts($scope.yesNo);

        $scope.group = data.group;

        $scope.cols = [
            {title: '姓名', filter: {'users.name': 'text'}, field: 'name', show: true}, //0
            {title: '胸牌号', filter: {'users.username': 'text'}, field: 'username', width: '30%', show: true}, //0
            {title: '是否停用', filter: {is_stop: 'select'}, data: yesNoOpts, field: 'is_stop', width: '10%', show: true}, //6
        ];
        $scope.optColWidth = 70;

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50],
            total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['id'] = data.group.id;
                ContactGroup.index_members(url, function (resp) {
                    params.total(resp.total);
                    var members = [];
                    angular.forEach(resp.members, function (m) {
                        members.push({id: m.member_id});
                    });
                    $scope.members_ids = members;
                    $defer.resolve(resp.members);
                    $scope.members = resp.members;
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };

        Table.loadMultiSelectedFn($scope);

        $scope.add = function () {
            dialogs.create('directives/form/user-selector/user_selector_dlg.html', 'UserSelectCtrl',
                {
                    title: '添加' + data.group.name + '成员', multiSelect: true, existMembers: $scope.members_ids
                }, {

                    size: 'md'
                }).result.then(function (params) {
                if (params.length > 0) {
                    var members_ids = [];
                    angular.forEach(params, function (m) {
                        members_ids.push(m.id)
                    });
                    ContactGroup.attach_members({id: data.group.id}, {members: members_ids}).$promise.then(function (resp) {
                        toaster.success('添加成功!');
                        $scope.tableParams.reload();
                    }, function () {
                        toaster.error('添加失败!');
                    });
                }
            });
        };

        $scope.delete = function (m) {
            dialogs.confirm('移除成员', '确定要移除成员吗?')
                .result.then(function () {
                var members = [];
                if (angular.isArray(m)) {
                    angular.forEach(m, function (member) {
                        if (member.is_checked) {
                            members.push(member.member_id);
                        }
                    });
                } else {
                    members.push(m.member_id);
                }
                ContactGroup.detach_members({id: data.group.id}, {members: members}).$promise.then(
                    function () {
                        toaster.success('移除成功!');
                        $scope.tableParams.reload();
                    },
                    function () {
                        toaster.error('移除失败!');
                    }
                );
            });
        };

        $scope.setStop = function (m, stop) {
            ContactGroup.set_member_stop({id: m.id, is_stop: stop}).$promise.then(function () {
                m.is_stop = stop ? '1' : '0';
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c')
    .controller('DeptRecordDlgCtrl', function ($scope, $uibModalInstance, dialogs, toaster, NgTableParams, F,
                                               UserDept, data) {

        $scope.user = data.user;
        $scope.cols = [
            {title: '科室名称', field: 'name', show: true}, //0
            {title: '科室内职务', field: 'post', show: true}, //6
            {title: '是否主科室', field: 'is_main', show: true}, //6
            {title: '进入时间', field: 'entry_time', sortable: 'entry_time', show: true}, //6
            {title: '离开时间', field: 'leave_time', sortable: 'leave_time', show: true}, //6
        ];
        $scope.hideFilter = true;
        if (data.hideOpt) {
            $scope.hideOpt = true;
        } else {
            $scope.optColWidth = 56;
        }

        $scope.tableParams = new NgTableParams({page: 1, count: 10, sorting: {entry_time: 'desc'}}, {
            counts: [10, 30, 50],
            total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 3;  //INDEX_DEPTS_IN_MEMBER
                url['user_id'] = $scope.user.id;
                UserDept.query(url, function (resp) {
                    params.total(resp.total);
                    angular.forEach(resp.depts, function (m) {
                        m.is_main = m.is_main == '1';
                    });
                    $defer.resolve(resp.depts);
                });
            }
        });

        $scope.delete = function (dept) {
            dialogs.confirm('删除科室记录', '确定要删除<strong>' + dept.name + '</strong>的科室记录吗?')
                .result.then(function () {
                    UserDept.delete({id: dept.id}).$promise.then(function (data) {
                        switch (data.result) {
                            case 0:
                                toaster.success('科室记录删除成功!');
                                break;
                            case 1:
                                toaster.warning('这是员工当前所在的主科室记录,无法直接删除');
                                break;
                        }
                        $scope.tableReload();
                        $scope.tableReload();
                    }, function (error) {
                        toaster.error('科室记录删除失败!');
                    });
                });
        };

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
(function () {
    'use strict';

    angular.module('c')
        .controller('eventReminderDlgCtrl', eventReminderDlgCtrl);

    /** @ngInject */
    function eventReminderDlgCtrl($uibModalInstance, $q, FormHelper, Dlg, data) {
        var noneVal = {name: '空缺'};
        var vm = this;
        var reminder = data.service;
        var event = data.event;

        vm.title = data.title;
        vm.users = angular.copy(data.users);

        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init();


        function init() {
            vm.m = {};
            reminder.get(event).then(function (resp) {
                var reminder = resp.data;
                if (!reminder) reminder = noneVal;
                vm.m = {reminder: reminder};
            });
            vm.users.splice(0, 0, noneVal);
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var userId = !m.reminder || !m.reminder.id ? null : m.reminder.id;
                reminder.set(event, userId).then(function (resp) {
                    Dlg.s(resp.data.msg);
                    vm.close();
                }).finally(function () {
                    defer.resolve();
                });
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('NewsShowDlgCtrl', NewsShowDlgCtrl)
    ;

    /** @ngInject */
    function NewsShowDlgCtrl($scope, $sce, $uibModalInstance, $http, C, FileHelper, Auth, SaveAs, data, PrintHelper) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.download = download;
        vm.print = print;
        vm.isNews = true;


        init(data.id);

        function init(id) {
            if (id === 0) {
                var preview = data.preview;
                vm.article = {
                    title: preview.title,
                    body_sce: $sce.trustAsHtml(preview.body),
                    dept: preview.dept,
                    sender: Auth.getAccount()
                }
            } else {
                $http.get('/api/v1/news/news/' + id ).success(function (resp) {
                    vm.article = resp;
                    vm.article.body_sce = $sce.trustAsHtml(resp.body);
                    vm.article.attachment = resp.attachments;
                });
            }
        }

        function download(attachment) {
            var params = {filename: attachment.filename, mime: attachment.mime};
            attachment.downloading = true;
            FileHelper.download(C.URL.NEWS_DOWNLOAD, params, function (resp) {
                attachment.downloading = false;
                var data = [resp];
                var options = {type: attachment.mime};
                SaveAs.download(data, attachment.name, options);
            }, function () {
                attachment.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        }

        function print(article) {
            PrintHelper.print(window.open('', '打印预览'), 'templates/print/ap_order.html', function () {
                var html = '<header class="clearfix"><h1>' + article.title + '</h1>' +
                    '<small style="margin-left: 120px">信息公开类型：' + article.type + '&nbsp;&nbsp;&nbsp;发布科室:'
                    + article.dept.name + '&nbsp;&nbsp;&nbsp;' + '发布人：' + article.sender.name +
                    '&nbsp;&nbsp;&nbsp;发布时间：' + article.release_time + '</small></header><hr/>';

                html += article.body_sce;

                return html;
            });
        }
    }
})();

angular.module('c.c').controller('RichEditDlgCtrl', function ($scope, $uibModalInstance, data) {
    $scope.body = data.body;
    $scope.ok = function (body) {
        $uibModalInstance.close(body);
    };
    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});
angular.module('c.c').controller('SimpleDlgCtrl', function ($scope, $uibModalInstance) {
    $scope.cancel = $uibModalInstance.dismiss;
});
angular.module('c.c').controller('SmsShowDlgCtrl',
    function ($scope, $uibModalInstance, data) {
        $scope.sms = data.sms;

        $scope.edit = function (sms) {
            var params = {opt: 5, sms: sms};
            $uibModalInstance.close(params);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
(function () {
    'use strict';

    angular.module('c.c')
        .controller('TransMemberCtrl', TransMemberCtrl)

    ;

    /** @ngInject */
    function TransMemberCtrl($scope, $uibModalInstance, Dlg, ArrayHelper, Dept, data, DateHelper) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;
        vm.m = {
            leave_time: new Date(),
            entry_time: new Date(),
            post: data.user.post
        };
        vm.user = data.user;
        vm.dept = data.dept;

        vm.dateOptions = {
            minDate: new Date(1920, 0, 1),
            initDate: new Date()
        };

        Dept.query({opt: 4}, function (resp) {
            vm.depts = ArrayHelper.except(data.dept.id, resp.depts);
            vm.m['dept'] = vm.depts[0];
        });


        function ok(m) {
            if (vm.u_form.$valid) {
                var p = {};
                p['leave_time'] = DateHelper.date2Str(m.leave_time, 'yyyy-MM-dd');
                p['user_id'] = data.user.user_id;
                p['dept_id'] = m.dept.id;
                p['post'] = m.post;
                p['entry_time'] = DateHelper.date2Str(m.entry_time, 'yyyy-MM-dd');
                p['is_main'] = data.user.is_main;
                $uibModalInstance.close(p);
            } else {
                Dlg.w('表单中有错误!');
                vm.u_form.submitted = true;
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('LeaveCtrl', LeaveCtrl);

    /** @ngInject */
    function LeaveCtrl(data, Dlg, User, $uibModalInstance, $q, LeaveReason, DateHelper, FormHelper) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;
        init(data.id);


        function init(id) {
            $q.all([
                LeaveReason.query().$promise,
                User.get({id : id}).$promise
            ]).then(function (respArray) {
                vm.reasons = respArray[0];
                vm.m = {
                    leave_reason: respArray[0][0],
                    name: respArray[1].name,
                    leave_time: new Date()
                }
            })
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {
                    opt: 2,
                    leave_time: DateHelper.date2Str(m.leave_time),
                    leave_reason_id: m.leave_reason.id
                };

                defer.resolve();
                User.update({id: data.id}, pa).$promise.then(function (resp) {
                    Dlg.s('提交成功');
                    $uibModalInstance.close();
                }, function (error) {
                    var resp = error.data;
                    Dlg.error(resp.msg);
                }).finally(function () {
                    defer.resolve();
                });
            });
        }
    }

})();



(function () {
    'use strict';
    
    angular.module('c.c')
        .controller('PhotoImgDlgCtrl', PhotoImgDlgCtrl)
    
    /** @ngInject */
    function PhotoImgDlgCtrl($uibModalInstance, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.m = {
            photo: data.photo
        }
    }
})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('UserEditCtrl', UserEditCtrl);

    /** @ngInject */
    function UserEditCtrl($scope, $uibModalInstance, ArrayHelper, User, data, $q, Dlg,
                          FormHelper, DateHelper, JobTitle, NewUser) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.title = data.title;
        if (data.sys_edit) {
            vm.reg_stage = true;
            vm.dept_disable = true;
            vm.on_type_disable = true;
        } else {
            vm.confirm_stage = true;
            vm.dept_disable = true;
        }
        if (data.user_reg) {
            vm.confirm_stage = true;
            vm.reg_stage = true;
        }
        vm.sexes = ArrayHelper.get('sexes');
        vm.edu_bgs = ArrayHelper.get('edu_bg_list');
        vm.degree_types = ArrayHelper.get('degree_types');
        vm.en_lvs = ArrayHelper.get('eg_lv_list');
        // vm.titles = ArrayHelper.get('titles');
        vm.posts = ArrayHelper.get('posts');
        vm.titleLeaves = NewUser.getTitleLevel();


        var username_regex_list = [
            /^\d{4,5}$/,  //正式员工
            /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/,  //试用实习均使用手机号注册
        ];
        vm.username_regex = username_regex_list[0];
        vm.dateOptions = {
            minDate: new Date(1920, 0, 1),
            maxDate: new Date(),
            initDate: new Date()
        };
        vm.dealDateOptions = {
            minDate: new Date(1920, 0, 1),
            maxDate: new Date(2050, 0, 1),
            initDate: new Date()
        };
        vm.plaits = [
            {id: 1, name: '上锦'},
            {id: 2, name: '华西派驻'},
            {id: 3, name: '附二院派驻'},
            {id: 4, name: '院外人员'}
        ];
        vm.census = [
            {id: 1, name: '城镇'},
            {id: 2, name: '农村'}
        ];
        vm.degreeTypeSelectedFn = degreeTypeSelectedFn;
        vm.statusSelectedFn = statusSelectedFn;
        vm.plaitSelectedFn = plaitSelectedFn;
        vm.deptTypeFn = deptTypeFn;
        vm.titleGroupFn = titleGroupFn;
        vm.onTypeSelectedFn = onTypeSelectedFn;
        vm.addUserPhoto = addUserPhoto;
        vm.dayNumChange = dayNumChange;
        vm.ok = ok;

        init();


        function init() {
            vm.m = {};
            $q.all([
                User.get({id: data.user_id, info_type: 0}).$promise
            ]).then(function (respArray) {
                var user = respArray[0].user;
                vm.types = respArray[0].types;
                vm.statuses = respArray[0].statuses;
                vm.standards = respArray[0].standards;

                vm.titles = respArray[0].titles;
                var jTypes = JobTitle.getTypes();
                angular.forEach(vm.titles, function (title) {
                    title.type = ArrayHelper.getItem(title.type, jTypes);
                });

                //暂时去掉 实习和试用
                //$scope.statuses.splice(2, 2);

                // vm.entry_types = respArray[0].entry_types;
                vm.nations = respArray[0].nations;
                vm.political_statuses = respArray[0].political_statuses;
                vm.depts = respArray[0].depts;

                user['is_cadre'] = user['is_cadre'] == '1';
                user['sex'] = ArrayHelper.getItem(user['sex'], vm.sexes);
                user['edu_bg'] = ArrayHelper.getItem(user['edu_bg'], vm.edu_bgs);
                user['degree_type'] = User.getDegreeType(user['degree']);
                vm.degrees = User.getDegrees(user['degree_type'].id);
                user['degree'] = User.getDegree(user['degree'], user['degree_type'].id);
                user['en_lv'] = ArrayHelper.getItem(user['en_lv'], vm.en_lvs);
                user['title'] = ArrayHelper.getItem(user['title_id'], vm.titles);
                user['post'] = ArrayHelper.getItem(user['post'], vm.posts);
                user['plait'] = ArrayHelper.getItem(user['plait'], vm.plaits);
                user['census'] = ArrayHelper.getItem(user['census'], vm.census);

                user['birthday'] = DateHelper.str2Date(user.birthday, 'yyyy-MM-dd');
                user['entry_time'] = DateHelper.str2Date(user.entry_time, 'yyyy-MM-dd');
                user['party_time'] = DateHelper.str2Date(user.party_time, 'yyyy-MM-dd');
                user['deal_sign_time'] = DateHelper.str2Date(user.deal_sign_time);
                user['deal_deadline'] = DateHelper.str2Date(user.deal_deadline);
                user['deal_change_time'] = DateHelper.str2Date(user.deal_change_time);
                user['started_work'] = DateHelper.str2Date(user.started_work);
                user['major'] = user.major;
                if (user.leave_year) user['num'] = user.leave_year.num;

                // 第一批用户确认后注销
                if (user.leave_year) user['total'] = user.leave_year.total;

                if (user['type_id'] == 2 && user['nurse_seniority']) {
                    user['standard'] = ArrayHelper.getItem(user['nurse_seniority'].seniority_id, vm.standards);
                } else {
                    user['standard'] = vm.standards[0];
                }

                user['dept'] = ArrayHelper.getItem(user['dept_id'], vm.depts);
                user['title_level'] = ArrayHelper.getItem(user['title_level'], vm.titleLeaves);
                // if (user.depts.length > 0) {
                //     user.dept = {id: user.depts[0].id, name: user.depts[0].name};
                // } else {
                //     user.dept = vm.depts[0];
                // }
                if (data.confirm_state) {
                    user['confirm_state'] = data.confirm_state;
                }
                vm.statusSelectedFn(user.status, user);
                // if (user.dept.name == '实习医生' || user.dept.name == '实习护士') {
                //     vm.practice_stage = true;
                // }
                vm.plaitSelectedFn(user.plait);
                vm.user = user;
                vm.m = user;
            });
        }

        $scope.$watch('vm.user.id_card', function (newVal, oldVal) {
            var id_card = newVal;
            if (id_card != oldVal && id_card != '' && id_card != null) {
                var native = id_card.substr(0, 6);
                var birthday = id_card.substr(6, 8);
                var sex = vm.sexes[(parseInt(id_card.substr(16, 1)) + 1) % 2];
                vm.user.birthday = DateHelper.str2Date(birthday, 'yyyyMMdd');
                vm.user.sex = sex;
                // if (id_card.length == 18 || id_card.length == 15) {
                //     $http.post('/api/open/user/reg/native_place',
                //         {id_native: native}).success(function (resp) {
                //         switch (resp.result) {
                //             case 0:
                //                 vm.user.native_place = resp.native_place;
                //                 break;
                //             case 1:
                //                 Dlg.w('没有找到和您输入的身份证号对应的籍贯信息，请手动填写籍贯!');
                //                 break;
                //         }
                //     });
                // }
            }
        });

        function degreeTypeSelectedFn(m) {
            vm.degrees = User.getDegrees(m.id);
            vm.user['degree'] = vm.degrees[0];
        }

        function plaitSelectedFn(plait) {
            vm.status = [];
            vm.defaultStatuses = angular.copy(vm.statuses);
            if (plait.id == 1) {
                angular.forEach(vm.defaultStatuses, function (item) {
                    if (ArrayHelper.inArray(item.id, [15, 16, 17]) !== -1) {
                        vm.status.push(item);
                    }
                });
            } else if (plait.id == 2) {
                angular.forEach(vm.defaultStatuses, function (item) {
                    if (ArrayHelper.inArray(item.id, [1, 2, 5, 6, 8, 9, 10, 12, 13, 14, 23]) !== -1) {
                        vm.status.push(item);
                    }
                });
            } else if (plait.id == 3) {
                angular.forEach(vm.defaultStatuses, function (item) {
                    if (ArrayHelper.inArray(item.id, [5, 6, 7, 8, 9, 10]) !== -1) {
                        item.name = '附二院' + item.name;
                        vm.status.push(item);
                    }
                });
            } else if (plait.id == 4) {
                angular.forEach(vm.defaultStatuses, function (item) {
                    if (ArrayHelper.inArray(item.id, [18]) !== -1) {
                        vm.status.push(item);
                    }
                });
            }
        }

        function statusSelectedFn(status, user) {
            if (status.id == 3 || status.id == 4 || status.id == 6) { //试用
                vm.username_regex = username_regex_list[1];
            } else {
                vm.username_regex = username_regex_list[0];
            }
        }

        function deptTypeFn(m) {
            if (m.type) {
                return m.type.name;
            } else {
                return '暂无科室类型';
            }
        }

        function titleGroupFn(t) {
            return t.type.name;
        }

        function onTypeSelectedFn(type, user) {

        }

        function dayNumChange() {
            var valid = isNaN(vm.user.num) ? true : Number.isInteger(vm.user.num * 2);
            vm.Form.num.$setValidity('num', valid);
            vm.Form.num.$setValidity('not_zero', vm.user.num >= 0);
        }

        function addUserPhoto(m) {
            Dlg.show({
                template: 'pages/user/profile/userPhotoDlg.html',
                ctrl: 'UserPhotoDlgCtrl',
                data: {id: m.id}
            }).then(function (resp) {
                m.photo = resp[0];
                m.work_photo = resp[1];
            });
        }

        function saveAndExit(user) {
            var pa = {};
            //账户信息
            pa['username'] = user.username;
            if (user.password && user.password.length > 0) {
                pa['password'] = user.password;
            }

            //基本信息
            pa['name'] = user.name;
            pa['id_card'] = user.id_card;
            pa['census'] = user.census.id;
            if(user.sex) pa['sex'] = user.sex.id;
            if(user.birthday) pa['birthday'] = DateHelper.date2Str(user.birthday);
            if(user.nation) pa['nation_id'] = user.nation.id;
            pa['native_place'] = user.native_place;
            pa['car_num1'] = user.car_num1;
            pa['car_num2'] = user.car_num2;
            if (user.political_status) pa['political_status_id'] = user.political_status.id;

            //工作相关
            if(user.photo) pa['photo'] = user.photo;
            if(user.work_photo) pa['work_photo'] = user.work_photo;
            pa['status_id'] = user.status.id;
            if(user.type) pa['type_id'] = user.type.id;
            if(user.plait) pa['plait'] = user.plait.id;
            pa['post_details'] = user.post_details;
            pa['num'] = user.num;

            // 第一批用户确认后注销
            pa['total'] = user.total;

            if (user.type.id === 2) pa['standard'] = user.standard.id;

            //  主要科室...
            //pa['dept_id'] = user.dept.id;
            pa['is_cadre'] = user.is_cadre;
            pa['entry_time'] = DateHelper.date2Str(user.entry_time);
            pa['party_time'] = DateHelper.date2Str(user.party_time);
            pa['started_work'] = user.started_work ?DateHelper.date2Str(user.started_work):null;
            if (user.deal_sign_time) pa['deal_sign_time'] = DateHelper.date2Str(user.deal_sign_time);
            if (user.deal_deadline) pa['deal_deadline'] = DateHelper.date2Str(user.deal_deadline);
            if (user.deal_change_time) pa['deal_change_time'] = DateHelper.date2Str(user.deal_change_time);

            //教育背景
            pa['graduate_school'] = user.graduate_school;
            pa['major'] = user.major;
            pa['edu_bg'] = user.edu_bg.id;
            pa['degree'] = user.degree.name;
            pa['en_lv'] = user.en_lv.id;
            //联系方式
            pa['phone'] = user.phone;
            pa['cornet'] = user.cornet;
            pa['phone2'] = user.phone2;
            pa['office_phone'] = user.office_phone;
            // pa['office_cornet'] = user.office_cornet;
            pa['email'] = user.email;
            pa['qq'] = user.qq;
            pa['address'] = user.address;

            pa['confirm_state'] = user.confirm_state;
            if (user.title) {
                pa['title_id'] = user.title.id;
            }
            if (user.title_level) pa['title_level'] = user.title_level.id;

            if (user.post) {
                pa['post'] = user.post.id;
            }

            pa['op'] = 'UserConfirm';

            NewUser.update({id: data.user_id}, pa).$promise.then(function (resp) {
                if (resp.msg) Dlg.s(resp.msg);
                $uibModalInstance.close();
            }, function (error) {
                var data = error.data;
                if (data.msg) Dlg.e(data.msg);
            });

            // User.update({id: data.user_id}, pa).$promise.then(function (resp) {
            //     if (resp.result == 0) {
            //         $uibModalInstance.close(pa);
            //     } else {
            //         if (resp.msg) {
            //             Dlg.e(resp.msg);
            //         } else {
            //             Dlg.e('出现错误');
            //         }
            //     }
            // }, function (error) {
            //     if (error.data.code == 23000) {
            //         var m = error.data.msg;
            //         if (m.indexOf('users_username_unique') > 0) {
            //             m = '用户名已被注册!';
            //         } else if (m.indexOf('users_phone_unique') > 0) {
            //             m = '手机号已被注册!';
            //         } else if (m.indexOf('users_email_unique') > 0) {
            //             m = '邮箱已被注册!';
            //         }
            //     } else {
            //         m = '员工记录修改失败!';
            //     }
            //     Dlg.e(m);
            // });
        }

        function ok(m) {
            var defer = $q.defer();
            if (!vm.Form.$valid) {
                FormHelper.handleError('#Form', vm.Form);
                defer.reject();
            } else if (!m.photo && !data.sys_edit) {
                Dlg.confirm('用户须添加工作头像!', function () {
                    vm.addUserPhoto(m);
                }, '提示');
            } else {
                saveAndExit(m);
            }
            defer.resolve();

            return defer.promise;
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('UserPersonnelApproveCtrl', UserPersonnelApproveCtrl);

    /** @ngInject */
    function UserPersonnelApproveCtrl($scope, $uibModalInstance, ArrayHelper, data, $q, Dlg,
                                      FormHelper, DateHelper, $http, NewUser) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;

        vm.title = data.title;
        vm.with_sms = false;
        vm.with_wx = true;

        if (data.user_reg) {
            vm.login_reg = true;
        }
        vm.sexes = ArrayHelper.get('sexes');
        vm.edu_bgs = ArrayHelper.get('edu_bg_list');
        vm.degree_types = ArrayHelper.get('degree_types');
        vm.en_lvs = ArrayHelper.get('eg_lv_list');
        // vm.titles = ArrayHelper.get('titles');
        vm.posts = ArrayHelper.get('posts');
        vm.titleLeaves = NewUser.getTitleLevel();

        var username_regex_list = [
            /^\d{4,5}$/,  //正式员工
            /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/  //试用实习均使用手机号注册
        ];
        vm.username_regex = username_regex_list[0];
        vm.dateOptions = {
            minDate: new Date(1920, 0, 1),
            maxDate: new Date(),
            initDate: new Date()
        };
        vm.dealDateOptions = {
            minDate: new Date(1920, 0, 1),
            maxDate: new Date(2050, 0, 1),
            initDate: new Date()
        };
        vm.plaits = [
            {id: 1, name: '上锦'},
            {id: 2, name: '华西派驻'},
            {id: 3, name: '附二院派驻'},
            {id: 4, name: '院外人员'}
        ];
        vm.census = [
            {id: 1, name: '城镇'},
            {id: 2, name: '农村'}
        ];
        vm.degreeTypeSelectedFn = degreeTypeSelectedFn;
        vm.plaitSelectedFn = plaitSelectedFn;
        vm.statusSelectedFn = statusSelectedFn;
        vm.deptTypeFn = deptTypeFn;
        vm.onTypeSelectedFn = onTypeSelectedFn;
        vm.addUserPhoto = addUserPhoto;
        vm.dayNumChange = dayNumChange;
        vm.ok = ok;

        init();


        function init() {
            vm.m = {};
            $q.all([
                NewUser.get({id: data.user_id, op: 'All'}).$promise,
                NewUser.query({op: 'UserOptions'}).$promise
            ]).then(function (respArray) {
                var user = respArray[0].item;
                vm.types = respArray[1].items.types;
                vm.statuses = respArray[1].items.statuses;
                vm.titles = respArray[1].items.titles;
                vm.standards = respArray[1].items.standards;
                //暂时去掉 实习和试用
                //$scope.statuses.splice(2, 2);

                // vm.entry_types = respArray[1].items.entry_types;
                vm.nations = respArray[1].items.nations;
                vm.political_statuses = respArray[1].items.political_statuses;
                vm.depts = respArray[1].items.depts;

                user['is_cadre'] = user['is_cadre'] == '1';
                user['sex'] = ArrayHelper.getItem(user['sex'], vm.sexes);
                user['edu_bg'] = ArrayHelper.getItem(user['edu_bg'], vm.edu_bgs);
                user['degree_type'] = NewUser.getDegreeType(user['degree']);
                vm.degrees = NewUser.getDegrees(user['degree_type'].id);
                user['degree'] = NewUser.getDegree(user['degree'], user['degree_type'].id);
                user['en_lv'] = ArrayHelper.getItem(user['en_lv'], vm.en_lvs);
                // user['title'] = ArrayHelper.getItem(user['title'], vm.titles);
                user['post'] = ArrayHelper.getItem(user['post'], vm.posts);
                user['plait'] = ArrayHelper.getItem(user['plait'], vm.plaits);
                user['census'] = ArrayHelper.getItem(user['census'], vm.census);
                user['title_level'] = ArrayHelper.getItem(user['title_level'], vm.titleLeaves);
                user['birthday'] = DateHelper.str2Date(user.birthday, 'yyyy-MM-dd');
                user['entry_time'] = DateHelper.str2Date(user.entry_time, 'yyyy-MM-dd');
                user['party_time'] = DateHelper.str2Date(user.party_time, 'yyyy-MM-dd');
                user['deal_sign_time'] = DateHelper.str2Date(user.deal_sign_time);
                user['deal_deadline'] = DateHelper.str2Date(user.deal_deadline);
                user['deal_change_time'] = DateHelper.str2Date(user.deal_change_time);
                user['started_work'] = DateHelper.str2Date(user.started_work);
                user['major'] = user.major;
                if (user.user_extend) user['num'] = user.user_extend.num;

                if (user['type_id'] == 2 && user['nurse_seniority']) {
                    user['standard'] = ArrayHelper.getItem(user['nurse_seniority'].seniority_id, vm.standards);
                } else {
                    user['standard'] = vm.standards[0];
                }

                user['dept'] = ArrayHelper.getItem(user['dept_id'], vm.depts);
                vm.statusSelectedFn(user.status, user);
                vm.plaitSelectedFn(user.plait);
                if (user.dept.name == '实习医生' || user.dept.name == '实习护士') {
                    vm.practice_stage = true;
                }
                vm.user = user;
                vm.m = user;
            });
        }

        $scope.$watch('vm.user.id_card', function (newVal, oldVal) {
            var id_card = newVal;
            if (id_card != oldVal && id_card != '' && id_card != null) {
                var native = id_card.substr(0, 6);
                var birthday = id_card.substr(6, 8);
                var sex = vm.sexes[(parseInt(id_card.substr(16, 1)) + 1) % 2];
                vm.user.birthday = DateHelper.str2Date(birthday, 'yyyyMMdd');
                vm.user.sex = sex;
            }
        });
        $scope.$watch('vm.user.status', annualLeaveChange, true);

        function annualLeaveChange() {
            //  规培8,进修9,研究10类型 年假天数默认为0天
            if (vm.user.status.id == 8 || vm.user.status.id == 9 || vm.user.status.id == 10) {
                vm.user.total = 0;
            } else if (vm.user.status.id != 15) {   //  其他非上锦聘用类型 年假天数默认为5天
                vm.user.total = 5;
            }
        }

        function degreeTypeSelectedFn(m) {
            vm.degrees = NewUser.getDegrees(m.id);
            vm.user['degree'] = vm.degrees[0];
        }

        function plaitSelectedFn(plait) {
            vm.status = [];
            vm.defaultStatuses = angular.copy(vm.statuses);
            if (plait.id == 1) {
                angular.forEach(vm.defaultStatuses, function (item) {
                    if (ArrayHelper.inArray(item.id, [15, 16, 17]) !== -1) {
                        vm.status.push(item);
                    }
                });
            } else if (plait.id == 2) {
                angular.forEach(vm.defaultStatuses, function (item) {
                    if (ArrayHelper.inArray(item.id, [1, 2, 5, 6, 8, 9, 10, 12, 13, 14, 23]) !== -1) {
                        vm.status.push(item);
                    }
                });
            } else if (plait.id == 3) {
                angular.forEach(vm.defaultStatuses, function (item) {
                    if (ArrayHelper.inArray(item.id, [5, 6, 7, 8, 9, 10]) !== -1) {
                        item.name = '附二院' + item.name;
                        vm.status.push(item);
                    }
                });
            } else if (plait.id == 4) {
                angular.forEach(vm.defaultStatuses, function (item) {
                    if (ArrayHelper.inArray(item.id, [18]) !== -1) {
                        vm.status.push(item);
                    }
                });
            }
        }

        function statusSelectedFn(status, user) {
            if (status.id == 3 || status.id == 4 || status.id == 6) { //试用
                vm.username_regex = username_regex_list[1];
            } else {
                vm.username_regex = username_regex_list[0];
            }
        }

        function deptTypeFn(m) {
            if (m.type) {
                return m.type.name;
            } else {
                return '暂无科室类型';
            }
        }

        function onTypeSelectedFn(type, user) {

        }

        function addUserPhoto(m) {
            Dlg.show({
                template: 'pages/user/profile/userPhotoDlg.html',
                ctrl: 'UserPhotoDlgCtrl',
                data: {id: m.id}
            }).then(function (resp) {
                m.photo = resp[0];
                m.work_photo = resp[1];
            });
        }

        function dayNumChange() {
            var valid = isNaN(vm.user.num) ? true : Number.isInteger(vm.user.num * 2);
            vm.Form.num.$setValidity('num', valid);
            vm.Form.num.$setValidity('not_zero', vm.user.num >= 0);
        }

        function saveAndExit(user, isPass) {
            var pa = {};
            //账户信息
            pa['username'] = user.username;
            if (user.password && user.password.length > 0) {
                pa['password'] = user.password;
            }

            //基本信息
            pa['name'] = user.name;
            pa['id_card'] = user.id_card;
            pa['census'] = user.census.id;
            pa['sex'] = user.sex.id;
            pa['birthday'] = DateHelper.date2Str(user.birthday);
            pa['nation_id'] = user.nation.id;
            pa['native_place'] = user.native_place;
            pa['car_num1'] = user.car_num1;
            pa['car_num2'] = user.car_num2;
            if (user.political_status) pa['political_status_id'] = user.political_status.id;

            //工作相关
            if (user.photo) pa['photo'] = user.photo;
            if (user.work_photo) pa['work_photo'] = user.work_photo;
            pa['status_id'] = user.status.id;
            pa['type_id'] = user.type.id;
            pa['plait'] = user.plait.id;
            pa['post_details'] = user.post_details;
            pa['num'] = user.num;
            if (user.status.id != 15) { //  非上锦聘用类型 年假天数
                pa['total'] = user.total;
            }
            if (user.type.id === 2) pa['standard'] = user.standard.id;

            //  主要科室...
            pa['dept_id'] = user.dept.id;
            pa['is_cadre'] = user.is_cadre;
            // pa['entry_type_id'] = user.entry_type.id;
            pa['entry_time'] = DateHelper.date2Str(user.entry_time);
            pa['party_time'] = DateHelper.date2Str(user.party_time);
            //pa['salary_card'] = user.salary_card;
            pa['started_work'] = DateHelper.date2Str(user.started_work);
            if (user.deal_sign_time) pa['deal_sign_time'] = DateHelper.date2Str(user.deal_sign_time);
            if (user.deal_deadline) pa['deal_deadline'] = DateHelper.date2Str(user.deal_deadline);
            if (user.deal_change_time) pa['deal_change_time'] = DateHelper.date2Str(user.deal_change_time);

            //教育背景
            pa['graduate_school'] = user.graduate_school;
            pa['major'] = user.major;
            pa['edu_bg'] = user.edu_bg.id;
            pa['degree'] = user.degree.name;
            pa['en_lv'] = user.en_lv.id;
            //联系方式
            pa['phone'] = user.phone;
            pa['cornet'] = user.cornet;
            pa['phone2'] = user.phone2;
            pa['office_phone'] = user.office_phone;
            // pa['office_cornet'] = user.office_cornet;
            pa['email'] = user.email;
            pa['qq'] = user.qq;
            pa['address'] = user.address;

            pa['isPass'] = isPass;
            if (!isPass) pa['refuse_reason'] = user.refuse_reason;
            // if (user.major_s) {
            //     pa['major_id'] = user.major_s.id;
            // }
            if (user.title) {
                pa['title_id'] = user.title.id;
            }
            if (user.title_level) pa['title_level'] = user.title_level.id;
            if (user.post) {
                pa['post'] = user.post.id;
            }
            pa['with_sms'] = vm.with_sms;
            pa['with_wx'] = vm.with_wx;
            NewUser.update({id: data.user_id, op: data.op}, pa).$promise.then(function (resp) {
                Dlg.s(resp.msg);
                $uibModalInstance.close();
            }, function (error) {
                var data = error.data;
                if (data.msg) Dlg.e(data.msg);
            });
        }

        function ok(m, isPass) {
            var defer = $q.defer();
            if (!isPass) {
                Dlg.comment({
                    title: '注册审批',
                    notRequired: false,
                    opinion: '信息不全'
                }, function (resp) {
                    m.refuse_reason = resp;
                    saveAndExit(m, isPass);
                });
            } else {
                if (!vm.Form.$valid) {
                    FormHelper.handleError('#Form', vm.Form);
                    defer.reject();
                } else {
                    if (isPass) {
                        saveAndExit(m, isPass);
                    }
                }
            }
            defer.resolve();

            return defer.promise;
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('UserRegApprovalCtrl', UserRegApprovalCtrl);

    /** @ngInject */
    function UserRegApprovalCtrl($scope, $uibModalInstance, ArrayHelper, data, $q, Dlg,
                                 FormHelper, DateHelper, $http, NewUser) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;

        vm.title = data.title;
        vm.with_sms = false;
        vm.with_wx = true;

        if (data.user_reg) {
            vm.login_reg = true;
        }
        vm.sexes = ArrayHelper.get('sexes');
        vm.edu_bgs = ArrayHelper.get('edu_bg_list');
        vm.degree_types = ArrayHelper.get('degree_types');
        vm.en_lvs = ArrayHelper.get('eg_lv_list');
        // vm.titles = ArrayHelper.get('titles');
        vm.posts = ArrayHelper.get('posts');
        vm.titleLeaves = NewUser.getTitleLevel();

        var username_regex_list = [
            /^\d{4,5}$/,  //正式员工
            /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/  //试用实习均使用手机号注册
        ];
        vm.username_regex = username_regex_list[0];
        vm.dateOptions = {
            minDate: new Date(1920, 0, 1),
            maxDate: new Date(),
            initDate: new Date()
        };
        vm.dealDateOptions = {
            minDate: new Date(1920, 0, 1),
            maxDate: new Date(2050, 0, 1),
            initDate: new Date()
        };
        vm.plaits = [
            {id: 1, name: '上锦'},
            {id: 2, name: '华西派驻'},
            {id: 3, name: '附二院派驻'},
            {id: 4, name: '院外人员'}
        ];
        vm.census = [
            {id: 1, name: '城镇'},
            {id: 2, name: '农村'}
        ];
        vm.degreeTypeSelectedFn = degreeTypeSelectedFn;
        vm.plaitSelectedFn = plaitSelectedFn;
        vm.statusSelectedFn = statusSelectedFn;
        vm.deptTypeFn = deptTypeFn;
        vm.onTypeSelectedFn = onTypeSelectedFn;
        vm.addUserPhoto = addUserPhoto;
        vm.dayNumChange = dayNumChange;
        vm.ok = ok;

        init();


        function init() {
            vm.m = {};
            $q.all([
                NewUser.get({id: data.user_id, op: 'All'}).$promise,
                NewUser.query({op: 'UserOptions'}).$promise
            ]).then(function (respArray) {
                var user = respArray[0].item;
                vm.types = respArray[1].items.types;
                vm.statuses = respArray[1].items.statuses;
                vm.titles = respArray[1].items.titles;
                vm.standards = respArray[1].items.standards;
                //暂时去掉 实习和试用
                //$scope.statuses.splice(2, 2);

                // vm.entry_types = respArray[1].items.entry_types;
                vm.nations = respArray[1].items.nations;
                vm.political_statuses = respArray[1].items.political_statuses;
                vm.depts = respArray[1].items.depts;

                user['is_cadre'] = user['is_cadre'] == '1';
                user['sex'] = ArrayHelper.getItem(user['sex'], vm.sexes);
                user['edu_bg'] = ArrayHelper.getItem(user['edu_bg'], vm.edu_bgs);
                user['degree_type'] = NewUser.getDegreeType(user['degree']);
                vm.degrees = NewUser.getDegrees(user['degree_type'].id);
                user['degree'] = NewUser.getDegree(user['degree'], user['degree_type'].id);
                user['en_lv'] = ArrayHelper.getItem(user['en_lv'], vm.en_lvs);
                // user['title'] = ArrayHelper.getItem(user['title'], vm.titles);
                user['post'] = ArrayHelper.getItem(user['post'], vm.posts);
                user['plait'] = ArrayHelper.getItem(user['plait'], vm.plaits);
                user['census'] = ArrayHelper.getItem(user['census'], vm.census);
                user['title_level'] = ArrayHelper.getItem(user['title_level'], vm.titleLeaves);
                user['birthday'] = DateHelper.str2Date(user.birthday, 'yyyy-MM-dd');
                user['entry_time'] = DateHelper.str2Date(user.entry_time, 'yyyy-MM-dd');
                user['party_time'] = DateHelper.str2Date(user.party_time, 'yyyy-MM-dd');
                user['deal_sign_time'] = DateHelper.str2Date(user.deal_sign_time);
                user['deal_deadline'] = DateHelper.str2Date(user.deal_deadline);
                user['deal_change_time'] = DateHelper.str2Date(user.deal_change_time);
                user['started_work'] = DateHelper.str2Date(user.started_work);
                user['major'] = user.major;
                if (user.user_extend) user['num'] = user.user_extend.num;

                if (user['type_id'] == 2 && user['nurse_seniority']) {
                    user['standard'] = ArrayHelper.getItem(user['nurse_seniority'].seniority_id, vm.standards);
                } else {
                    user['standard'] = vm.standards[0];
                }

                user['dept'] = ArrayHelper.getItem(user['dept_id'], vm.depts);
                // if (user.depts.length > 0) {
                //     user.dept = {id: user.depts[0].id, name: user.depts[0].name};
                // } else {
                //     user.dept = vm.depts[0];
                // }
                // if (data.confirm_state) {
                //     user['confirm_state'] = data.confirm_state;
                // }
                vm.statusSelectedFn(user.status, user);
                vm.plaitSelectedFn(user.plait);
                if (user.dept.name == '实习医生' || user.dept.name == '实习护士') {
                    vm.practice_stage = true;
                }
                vm.user = user;
                vm.m = user;
            });
        }

        $scope.$watch('vm.user.id_card', function (newVal, oldVal) {
            var id_card = newVal;
            if (id_card != oldVal && id_card != '' && id_card != null) {
                var native = id_card.substr(0, 6);
                var birthday = id_card.substr(6, 8);
                var sex = vm.sexes[(parseInt(id_card.substr(16, 1)) + 1) % 2];
                vm.user.birthday = DateHelper.str2Date(birthday, 'yyyyMMdd');
                vm.user.sex = sex;
                // if (id_card.length == 18 || id_card.length == 15) {
                //     $http.post('/api/open/user/reg/native_place',
                //         {id_native: native}).success(function (resp) {
                //         switch (resp.result) {
                //             case 0:
                //                 vm.user.native_place = resp.native_place;
                //                 break;
                //             case 1:
                //                 Dlg.w('没有找到和您输入的身份证号对应的籍贯信息，请手动填写籍贯!');
                //                 break;
                //         }
                //     });
                // }
            }
        });

        function degreeTypeSelectedFn(m) {
            vm.degrees = NewUser.getDegrees(m.id);
            vm.user['degree'] = vm.degrees[0];
        }

        function plaitSelectedFn(plait) {
            vm.status = [];
            vm.defaultStatuses = angular.copy(vm.statuses);
            if (plait.id == 1) {
                angular.forEach(vm.defaultStatuses, function (item) {
                    if (ArrayHelper.inArray(item.id, [15, 16, 17]) !== -1) {
                        vm.status.push(item);
                    }
                });
            } else if (plait.id == 2) {
                angular.forEach(vm.defaultStatuses, function (item) {
                    if (ArrayHelper.inArray(item.id, [1, 2, 5, 6, 8, 9, 10, 12, 13, 14, 23]) !== -1) {
                        vm.status.push(item);
                    }
                });
            } else if (plait.id == 3) {
                angular.forEach(vm.defaultStatuses, function (item) {
                    if (ArrayHelper.inArray(item.id, [5, 6, 7, 8, 9, 10]) !== -1) {
                        item.name = '附二院' + item.name;
                        vm.status.push(item);
                    }
                });
            } else if (plait.id == 4) {
                angular.forEach(vm.defaultStatuses, function (item) {
                    if (ArrayHelper.inArray(item.id, [18]) !== -1) {
                        vm.status.push(item);
                    }
                });
            }
        }

        function statusSelectedFn(status, user) {
            if (status.id == 3 || status.id == 4 || status.id == 6) { //试用
                vm.username_regex = username_regex_list[1];
            } else {
                vm.username_regex = username_regex_list[0];
            }
        }

        function deptTypeFn(m) {
            if (m.type) {
                return m.type.name;
            } else {
                return '暂无科室类型';
            }
        }

        function onTypeSelectedFn(type, user) {

        }

        function addUserPhoto(m) {
            Dlg.show({
                template: 'pages/user/profile/userPhotoDlg.html',
                ctrl: 'UserPhotoDlgCtrl',
                data: {id: m.id}
            }).then(function (resp) {
                m.photo = resp[0];
                m.work_photo = resp[1];
            });
        }

        function dayNumChange() {
            var valid = isNaN(vm.user.num) ? true : Number.isInteger(vm.user.num * 2);
            vm.Form.num.$setValidity('num', valid);
            vm.Form.num.$setValidity('not_zero', vm.user.num >= 0);
        }

        function saveAndExit(user, isPass) {
            var pa = {};
            //账户信息
            pa['username'] = user.username;
            if (user.password && user.password.length > 0) {
                pa['password'] = user.password;
            }

            //基本信息
            pa['name'] = user.name;
            pa['id_card'] = user.id_card;
            pa['census'] = user.census.id;
            pa['sex'] = user.sex.id;
            pa['birthday'] = DateHelper.date2Str(user.birthday);
            pa['nation_id'] = user.nation.id;
            pa['native_place'] = user.native_place;
            pa['car_num1'] = user.car_num1;
            pa['car_num2'] = user.car_num2;
            if (user.political_status) pa['political_status_id'] = user.political_status.id;

            //工作相关
            if (user.photo) pa['photo'] = user.photo;
            if (user.work_photo) pa['work_photo'] = user.work_photo;
            pa['status_id'] = user.status.id;
            pa['type_id'] = user.type.id;
            pa['plait'] = user.plait.id;
            pa['post_details'] = user.post_details;
            pa['num'] = user.num;
            if (user.type.id === 2) pa['standard'] = user.standard.id;

            //  主要科室...
            pa['dept_id'] = user.dept.id;
            pa['is_cadre'] = user.is_cadre;
            // pa['entry_type_id'] = user.entry_type.id;
            pa['entry_time'] = DateHelper.date2Str(user.entry_time);
            pa['party_time'] = DateHelper.date2Str(user.party_time);
            //pa['salary_card'] = user.salary_card;
            pa['started_work'] = DateHelper.date2Str(user.started_work);
            if (user.deal_sign_time) pa['deal_sign_time'] = DateHelper.date2Str(user.deal_sign_time);
            if (user.deal_deadline) pa['deal_deadline'] = DateHelper.date2Str(user.deal_deadline);
            if (user.deal_change_time) pa['deal_change_time'] = DateHelper.date2Str(user.deal_change_time);

            //教育背景
            pa['graduate_school'] = user.graduate_school;
            pa['major'] = user.major;
            pa['edu_bg'] = user.edu_bg.id;
            pa['degree'] = user.degree.name;
            pa['en_lv'] = user.en_lv.id;
            //联系方式
            pa['phone'] = user.phone;
            pa['cornet'] = user.cornet;
            pa['phone2'] = user.phone2;
            pa['office_phone'] = user.office_phone;
            // pa['office_cornet'] = user.office_cornet;
            pa['email'] = user.email;
            pa['qq'] = user.qq;
            pa['address'] = user.address;

            pa['isPass'] = isPass;
            if (!isPass) pa['refuse_reason'] = user.refuse_reason;
            // if (user.major_s) {
            //     pa['major_id'] = user.major_s.id;
            // }
            if (user.title) {
                pa['title_id'] = user.title.id;
            }
            if (user.title_level) pa['title_level'] = user.title_level.id;
            if (user.post) {
                pa['post'] = user.post.id;
            }
            pa['with_sms'] = vm.with_sms;
            pa['with_wx'] = vm.with_wx;
            NewUser.update({id: data.user_id, op: data.op}, pa).$promise.then(function (resp) {
                Dlg.s(resp.msg);
                $uibModalInstance.close();
            }, function (error) {
                var data = error.data;
                if (data.msg) Dlg.e(data.msg);
            });
        }

        function ok(m, isPass) {
            var defer = $q.defer();
            if (!isPass) {
                Dlg.comment({
                    title: '注册审批',
                    notRequired: false,
                    opinion: '信息不全'
                }, function (resp) {
                    m.refuse_reason = resp;
                    saveAndExit(m, isPass);
                });
            } else {
                if (!vm.Form.$valid) {
                    FormHelper.handleError('#Form', vm.Form);
                    defer.reject();
                } else {
                    if (isPass) {
                        saveAndExit(m, isPass);
                    }
                    // if (!isPass) {
                    //     Dlg.comment({
                    //         title: '注册审批',
                    //         notRequired: false,
                    //         opinion: '信息不全'
                    //     }, function (resp) {
                    //         m.refuse_reason = resp;
                    //         saveAndExit(m, isPass);
                    //     });
                    // } else {
                    //     saveAndExit(m, isPass);
                    // }
                }
            }
            defer.resolve();

            return defer.promise;
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('FinanceRoundSearchCtrl', FinanceRoundSearchCtrl)


    ;
    /** @ngInject */
    function FinanceRoundSearchCtrl($scope, ArrayHelper, Table, Round, C, Api, Dlg) {
        var vm = $scope;
        vm.downExport = downExport;

        var roundStateOpt = Table.getNgTableOpts(ArrayHelper.get('round_stages'));
        var yesOrNo = Table.getNgTableOpts(ArrayHelper.get('yesNo'));

        init();

        function init() {
            var options = {
                service: Round,
                params: {op: 'FinanceFlexRound'},
                optColWidth: Table._1_BTN,
                sorting: {user_id: 'asc'},
                optInFront: true,
                showSn: true,
                hideOpt: true,
                cols: [
                    {field: 'is_main', title: '主科室轮转', filter: {is_main: 'select'}, data: yesOrNo},
                    {field: 'is_flex', title: '是否机动', filter: {is_flex: 'select'}, data: yesOrNo},
                    {field: 'name', title: '姓名', filter: {name: 'text'}},
                    {field: 'username', title: '胸牌号', filter: {username: 'text'}},
                    {field: 'dept', title: '轮转科室', filter: {dept: 'text'}},
                    {field: 'round_time', title: '轮转日期', filter: {round_time: 'date_range'}},
                    {field: 'state', title: '当前状态', filter: {state: 'select'}, data: roundStateOpt}
                ]
            };
            Table.load(vm, options, function (data) {
                angular.forEach(data.items, function (item) {
                    if (angular.isDefined(item.leave_time) && item.leave_time != null) {
                        item.round_time = item.entry_time.substr(0, 16) + ' - ' + item.leave_time.substr(0, 16);
                    } else {
                        item.round_time = item.entry_time.substr(0, 16) + "之后";
                    }
                    if (item.state) {
                        if (item.state == 1 && item.is_confirm == 0) {
                            item.state = {id: '3', name: '科室未确认'};
                        } else {
                            item.state = ArrayHelper.getItem(item.state, ArrayHelper.get('test_stages'));
                        }
                    } else {
                        item.state.name = '状态为空';
                    }
                });
            });
        }

        function downExport() {
            Api.exportDR(C.URL.ROUND_DOWNLOAD, "轮转统计");
        }
    }
})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('HospitalRegApprovalCtrl', HospitalRegApprovalCtrl)


    ;
    /** @ngInject */
    function HospitalRegApprovalCtrl($scope, NewUser, Table, Dlg, $q, User, ArrayHelper) {
        var vm = $scope;
        vm.edit = edit;


        init();

        function init() {
            $q.all([
                NewUser.query({op: 'UserOptions'}).$promise,
                User.getConfirms()
            ]).then(function (respArray) {
                var options = {
                    service: NewUser,
                    params: {op: 'HospitalRegApproval'},
                    optColWidth: Table._2_BTN,
                    optInFront: true,
                    showSn: true,
                    cols: [
                        {field: "name", title: "姓名", filter: {name: "text"}, width: 130},
                        {field: "username", title: "胸牌号", filter: {username: "text"}, width: 130},
                        {field: "depts", title: "科室", filter: {dept: "text"}, width: 160},
                        {
                            field: "confirm_state",
                            title: "审批状态",
                            filter: {confirm_state: "select"},
                            data: Table.getNgTableOpts(respArray[1])
                        },
                        {
                            field: "type_id",
                            title: "岗位类型",
                            filter: {type_id: "select"},
                            data: Table.getNgTableOpts(respArray[0].items.types)
                        },
                        {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}}
                    ]
                };

                Table.load(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        item.confirm_state = ArrayHelper.getItem(item.confirm_state, respArray[1]);
                    })
                });
            });
        }

        function edit(m) {
            var pa = {
                user_id: m.id,
                user_reg: true,
                title: '确认信息',
                op: 'HospitalApproval'
            };

            Dlg.show({
                template: 'templates/user_reg_dlg.html',
                ctrl: 'UserRegApprovalCtrl',
                data: pa,
                size: 'lg'
            }).then(function () {
                vm.tableReload();
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('c.s')
        .controller('CommonPhoneCtrl', CommonPhoneCtrl)
        .controller('CommonPhoneDlgCtrl', CommonPhoneDlgCtrl);

    /** @ngInject */
    function CommonPhoneCtrl($scope, dialogs, toaster, Table, CommonPhone, F) {
        var vm = $scope;
        vm.add = add;
        vm.edit = edit;
        vm.remove = remove;

        init();

        function init() {
            var options = {
                service: CommonPhone,
                params: {opt: 1/*INDEX_ALL*/},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "phone", title: "电话", filter: {phone: "text"}},
                    {field: "cornet", title: "小号", filter: {cornet: "text"}},
                    {field: "sort", title: "排序"},
                    {
                        field: "is_stop",
                        title: "是否停用",
                        filter: {is_stop: "select"},
                        data: F.getNgTableOpts(F.get('yesNo'))
                    }
                ]
            };
            Table.load(vm, options);
        }


        function add() {
            dialogs.create('CommonPhoneDlg.html', 'CommonPhoneDlgCtrl', {}, {size: 'md'})
                .result.then(function (m) {
                CommonPhone.save(m).$promise.then(function () {
                    toaster.success('保存成功');
                    vm.tableReload();
                });
            });
        }

        function edit(m) {
            dialogs.create('CommonPhoneDlg.html', 'CommonPhoneDlgCtrl', {id: m.id}, {size: 'md'})
                .result.then(function (pa) {
                pa.opt = 1; //EDIT_SAVE
                CommonPhone.update({id: m.id}, pa).$promise.then(function () {
                    toaster.success('修改成功');
                    vm.tableReload();
                });
            });
        }

        function remove(m) {
            dialogs.confirm('删除条目', '确定要删除<strong>' + m.name + '</strong>条目吗?')
                .result.then(function () {
                CommonPhone.delete({id: m.id}).$promise.then(function (resp) {
                    toaster.success('删除成功');
                    vm.tableReload();
                });
            });
        }

    }

    /** @ngInject */
    function CommonPhoneDlgCtrl($scope, $uibModalInstance, toaster, F, CommonPhone, data) {
        var vm = $scope;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        loadModel(data.id);

        function loadModel(id) {
            if (id) {
                CommonPhone.get({id: id}, function (resp) {
                    var m = resp;
                    m.is_stop = m.is_stop == '1';
                    vm.m = m;
                });
            } else {
                vm.m = {is_stop: false};
            }
        }

        function ok(m) {
            if (vm.Form.$valid) {
                var pa = {
                    name: m.name,
                    phone: m.phone,
                    cornet: m.cornet,
                    sort: m.sort,
                    is_stop: m.is_stop ? '1' : '0'
                };
                $uibModalInstance.close(pa);
            } else {
                toaster.warning('表单中有错误!');
                vm.Form.submitted = true;
            }
        }
    }
})();


angular.module('c.c')
    .controller('PersonnelContactGroupCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, ContactGroup, F) {
        $scope.yesNo = F.get('yesNo');
        var yesNoOpts = F.getNgTableOpts($scope.yesNo);

        $scope.cols = [
            {title: '群名称', field: 'name', show: true}, //0
            {title: '成员数', field: 'members_count', width: '10%', show: true}, //1
            {
                title: '是否公开',
                filter: {is_public: 'select'},
                data: yesNoOpts,
                field: 'is_public',
                width: '10%',
                show: true
            }, //6
            {title: '是否停用', data: yesNoOpts, field: 'is_stop', width: '10%', show: true}, //6
            {title: '创建人', field: 'creator_id', width: '10%', show: true} //6
        ];
        $scope.hideFilter = true;
        $scope.optColWidth = 108;

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 5;
                ContactGroup.query(url, function (resp) {
                    params.total(resp.total);
                    $defer.resolve(resp.groups);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.add = function () {
            dialogs.create('ContactGroupDlg.html', 'ContactGroupDlgCtrl', {}, {
                 size: 'md'
            }).result.then(function (group) {
                    ContactGroup.save(group).$promise.then(function (data) {
                        toaster.success('群添加成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('群添加失败!');
                    });
                });
        };

        $scope.edit = function (group) {
            group.$edit = true;
            group.$nameChanged = group.name;
            group.$is_stopChanged = F.getItem(group.is_stop, $scope.yesNo);
            group.$is_publicChanged = F.getItem(group.is_public, $scope.yesNo);
            group.$creatorChanged = {id: group.creator_id, name: group.creator.name};
        };

        $scope.save = function (group) {
            group.$edit = false;
            if (group.$nameChanged == "") {
                toaster.warning('名称不能为空!');
            } else {
                var data = {};
                data['name'] = group.$nameChanged;
                data['is_stop'] = group.$is_stopChanged.id;
                data['is_public'] = group.$is_publicChanged.id;
                data['creator_id'] = group.$creatorChanged.id;
                ContactGroup.update({id: group.id}, data).$promise.then(function (resp) {
                    toaster.success('群信息修改成功!');
                    group.name = group.$nameChanged;
                    group.is_stop = group.$is_stopChanged.id;
                    group.is_public = group.$is_publicChanged.id;
                    group.creator = group.$creatorChanged;
                    group.creator_id = group.$creatorChanged.id;
                }, function (error) {
                    toaster.error('群信息修改失败!');
                });
            }
        };

        $scope.delete = function (group) {
            dialogs.confirm('删除群记录', '确定要删除<strong>' + group.name + '</strong>的群吗?')
                .result.then(function () {
                    ContactGroup.delete({id: group.id}).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('群记录删除成功!');
                                break;
                            case 1:
                                toaster.warning('存在属于该群的成员,因此无法删除该群!');
                                break;
                        }
                        $scope.tableReload();
                    }, function (error) {
                        toaster.error('群记录删除失败!');
                    });
                });

        };

        $scope.member = function (group) {
            dialogs.create('templates/contact_group_members_dlg.html', 'ContactGroupMembersCtrl',
                {group: group}, { size: 'md'}).result.then(function () {
                }, function () {
                    $scope.tableParams.reload();
                });
        };

    });

(function () {
    'use strict';

    angular.module('c.s')
        .controller('OfficeDeptPhoneDlgCtrl',OfficeDeptPhoneDlgCtrl)
        .controller('OfficeDeptPhoneCtrl', OfficeDeptPhoneCtrl);

    /** @ngInject */
    function OfficeDeptPhoneCtrl(DeptPhone, $scope, Dlg, dialogs, Dept, toaster, OfficeDeptPhone) {
        var vm = $scope;
        vm.remove = remove;
        vm.add = add;
        vm.edit = edit;
        vm.typeSelectedFn = typeSelectedFn;
        vm.selectDeptPhone = selectDeptPhone;
        vm.deptTypeVisible = deptTypeVisible;
        vm.deptVisible = deptVisible;
        vm.cancel = cancel;

        init();


        function init() {
            vm.selectTypes = [
                {id: 1, name: '科室', exAll: false, fresh: true},
            ];
            vm.curType = $scope.selectTypes[0];
            vm.pager = {total: 0, page: 1, count: 10};
            vm.showDetail = $(window).width() > 768;
            vm.search = {};

            vm.typeSelectedFn(0);
        }
        function cancel() {
            vm.selectedDept = false;

        }

        function typeSelectedFn($index) {
            var toType = $scope.selectTypes[$index];
            $(window).resize(function () {
                var width = $(window).width();
                if (width > 768) {
                    $scope.hideList = false;
                    $scope.showDetail = true;
                } else {
                    $scope.hideList = false;
                    $scope.showDetail = false;
                }
            });
            switch (toType.id) {
                case 1:
                    if (toType.fresh) {
                        initDeptSelector();
                        toType.fresh = false;
                    }
                    break;
            }
            $scope.curType = toType;
        }

        function selectDeptPhone(dept) {
            showDetailAccordingToScreenSize();

            vm.selected = dept;
            vm.selectedDept = true;
            DeptPhone.query({opt: 2, dept_id: dept.id}, function (resp) {
                vm.deptPhones = resp.items;
            });
        }

        function initDeptSelector() {
            vm.loading = true;
            Dept.query({opt: 9}, function (resp) {
                vm.loading = false;
                vm.types = resp.dept_types;
            }, function () {
                vm.loading = false;
            });
        }


        function showDetailAccordingToScreenSize() {
            if (!vm.showDetail) {
                vm.hideList = true;
                vm.showDetail = true;
            }
        }


        function deptTypeVisible(type) {
            var visible = !vm.search.dept || vm.search.dept.length === 0;
            if (!visible) {
                for (var i = 0; i < type.depts.length; i++) {
                    var dept = type.depts[i];
                    if (dept.name.indexOf(vm.search.dept) !== -1) {
                        visible = true;
                        break;
                    }
                }
            }
            return visible;
        }

        function deptVisible(dept) {
            return !(vm.search.dept && vm.search.dept.length > 0
                && dept.name.indexOf(vm.search.dept) === -1);
        }
        function remove(m) {
            Dlg.confirm('确定删除该记录吗？').then(function () {
                OfficeDeptPhone.delete({
                    id: m,
                }).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            });
        }

        function add(depts) {

            dialogs.create('OfficeDeptPhoneDlg.html', 'OfficeDeptPhoneDlgCtrl', {dept: depts}, { size: 'md'});

        }
        function edit(m) {
            dialogs.create('UpDeptPhoneDlg.html', 'OfficeDeptPhoneDlgCtrl', {id: m.id}, { size: 'md'})
                .result.then(function (pa) {
                OfficeDeptPhone.update({id: m.id}, pa).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            });
        }
    }
    function OfficeDeptPhoneDlgCtrl($scope, $uibModalInstance, toaster, Dlg, FormHelper,  OfficeDeptPhone, data) {
        var vm = $scope;
        vm.submit = submit;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        function submit(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {
                    name: m.name,
                    dept_id: data.dept.id,
                    phone : m.phone,
                    cornet : m.cornet,
                    // sorting: m.sorting,
                };

                OfficeDeptPhone.save(pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }).finally(function () {
                    defer.resolve();
                });
            });


        }

        if (data.id) {
            loadModel(data.id);
        }
        function loadModel(id) {
                OfficeDeptPhone.get({id: id}, function (resp) {
                    var m = resp;
                    vm.m = m;
                });
        }

        function ok(m) {
            if (vm.Form.$valid) {
                var pa = {
                    name: m.name,
                    phone: m.phone,
                    cornet: m.cornet,
                };
                $uibModalInstance.close(pa);
            } else {
                toaster.warning('表单中有错误!');
                vm.Form.submitted = true;
            }
        }
    }


})();



angular.module('c.c').controller('MeetingManageCtrl',
    function ($scope, $rootScope, $timeout, $filter, dialogs, toaster, NgTableParams, F, Meeting, MeetingType, Dept) {
        $scope.$on('meetingBack', function (event, data) {
            $scope.tableParams.reload();
        });
        var stages = F.getApprovalStages1();
        var stagesOpts = F.getNgTableOpts(stages);
        $scope.cols = [
            {title: '科室', sortable: 'dept_id', filter: {dept: 'text'}, width: '10%', show: true},
            {title: '名称', filter: {name: 'text'}, width: '20%', show: true},
            {title: '类型', sortable: 'type_id', filter: {type_id: 'select'}, width: '20%', show: true},
            {title: '申请人', filter: {applicant: 'text'}, width: '10%', show: true},
            {title: '申请时间', sortable: 'created_at', filter: {created_at: 'date_range'}, width: '20%', show: true},
            {title: '开会时间', sortable: 'start_time', filter: {start_time: 'date_range'}, width: '20%', show: true},
            {title: '会议地点', filter: {room: 'text'}, width: '15%', show: true},
            {title: '状态', filter: {stage: 'select'}, data: stagesOpts, width: '10%', show: true}
        ];

        var typeCol = $scope.cols[2];
        MeetingType.query({opt: 2}, function (resp) {
            $scope.types = resp.items;
            typeCol.data = F.getNgTableOpts($scope.types);
        });

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.optColWidth = 53;
        $scope.optInFront = true;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                created_at: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 5;
                url['date_range_filters'] = {};
                if ($scope.dateRangeFilter.created_at != null) {
                    url['date_range_filters'] = {
                        created_at: {
                            startDate: $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd'),
                            endDate: $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd')
                        }
                    };
                }
                if ($scope.dateRangeFilter.start_time != null) {
                    url['date_range_filters'] = {
                        start_time: {
                            startDate: $filter('date')($scope.dateRangeFilter.start_time.startDate, 'yyyy-MM-dd'),
                            endDate: $filter('date')($scope.dateRangeFilter.start_time.endDate, 'yyyy-MM-dd')
                        }
                    };
                }
                Meeting.query(url, function (resp) {
                    params.total(resp.total);
                    angular.forEach(resp.meetings, function (meeting) {
                        meeting.stage = F.getItem(meeting.stage, stages);
                        meeting.time_range = meeting.start_time.substr(0, 16) + ' - ' + meeting.end_time.substr(11, 5);
                    });
                    $defer.resolve(resp.meetings);
                    $scope.meetings = resp.meetings;
                });
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.exportMeeting = function () {
            dialogs.create('templates/export_meeting_dlg.html', 'ExportMeetingCtrl', {},
                {size: 'md'});
        };

        $scope.viaTypeExport = function () {
            dialogs.create('ViaMeetingTypeExportDlg.html', 'ViaMeetingTypeExportDlgCtrl', {},
                {size: 'md'});
        };

        $scope.showSignIn = function (meeting) {
            dialogs.create('templates/meeting/attendance_dlg.html', 'MeetingAttendanceDlgCtrl', {
                    id: meeting.id,
                    isManager: true
                },
                {size: 'lg'});
        };

        $scope.showLeave = function (meeting) {
            dialogs.create('templates/meeting/leave_dlg.html', 'MeetingLeaveDlgCtrl', {
                    id: meeting.id,
                    isManager: true
                },
                {size: 'lg'});
        };

        $scope.showAttendance = function (meeting) {
            dialogs.create('templates/meeting/attendance_detail.html', 'MeetingAttendanceDetailCtrl', {id: meeting.id},
                {size: 'lg'});
        };

        $scope.approval = function (meeting) {
            dialogs.create('templates/meeting/edit_dlg.html', 'MeetingEditDlgCtrl', {
                id: meeting.id, ForApproval: true, deptId: meeting.dept_id, isHospitalOffice: true
            }, {
                size: 'lg'
            }).result.then(function (params) {
                Meeting.update({id: meeting.id}, params).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('会议审批成功');
                                $scope.tableParams.reload();
                                break;
                            case 1:
                                toaster.warning('会议室冲突');
                                break;
                            case 2:
                                toaster.warning('设备冲突');
                                break;
                            case 3:
                                toaster.warning('该会议已发布');
                                break;
                        }
                    }, function () {
                        toaster.error('会议审批失败了!');
                    }
                );
            });
        };

        $scope.edit = function (meeting) {
            dialogs.create('templates/meeting/edit_dlg.html', 'MeetingEditDlgCtrl', {
                    id: meeting.id, ForEdit: true, deptId: meeting.dept_id
                },
                {size: 'lg'}).result.then(function (params) {
                Meeting.update({id: meeting.id}, params).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('会议修改成功');
                                $scope.tableParams.reload();
                                break;
                            case 1:
                                toaster.warning('会议室冲突,请重新修改');
                                break;
                            case 2:
                                toaster.warning('设备冲突,请重新修改');
                                break;
                        }
                    }, function () {
                        toaster.error('会议修改失败了!');
                    }
                );
            });
        };

        $scope.show = function (meeting) {
            dialogs.create('templates/meeting/show_dlg.html', 'MeetingShowDlgCtrl', {
                    id: meeting.id,
                    ForManage: true, SmsAgain: true,
                    ForApproval: meeting.stage.id != 4
                },
                {size: 'lg'}).result.then(function (params) {
                switch (params.opt) {
                    case 1:
                        $scope.edit(meeting);
                        break;
                    case 3:
                        $scope.approval(meeting);
                        break;
                }
            });
        };

        $scope.qrcode = function (meeting) {
            dialogs.create('templates/meeting/qrcode_dlg.html', 'MeetingQrcodeDlgCtrl', {meeting: meeting},
                {size: 'md'});
        };

        $scope.delete = function (meeting) {
            dialogs.confirm('删除会议', '确定要删除<strong>' + meeting.name + '</strong>吗?')
                .result.then(function () {
                Meeting.delete({id: meeting.id}).$promise.then(function (resp) {
                    toaster.success('删除成功!');
                    $scope.tableParams.reload();
                }, function () {
                    toaster.error('删除失败!');
                });
            });
        };

        $scope.cancel = function (meeting) {
            dialogs.confirm('取消会议', '确定要取消<strong>' + meeting.name + '</strong>吗?')
                .result.then(function () {
                Meeting.update({id: meeting.id}).$promise.then(function (resp) {
                    toaster.success('取消成功!');
                    $scope.tableParams.reload();
                }, function () {
                    toaster.error('取消失败!');
                });
            });
        }
    });

angular.module('c.c').controller('ViaMeetingTypeExportDlgCtrl',
    function ($scope, $uibModalInstance, FileHelper, Dlg, MeetingType, FormHelper, DateHelper) {
        var vm = $scope;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        var date = new Date(), y = date.getFullYear(), m = date.getMonth();

        init();


        function init() {
            MeetingType.query({opt: 2}, function (resp) {
                vm.types = resp.items;
            });
            vm.m = {start: new Date(y, m, 1), end: new Date(y, m + 1, 0)};
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                if (m.start > m.end) {
                    Dlg.w('开始日期不能大于结束日期!');
                    return;
                } else {
                    var start = DateHelper.date2Str(m.start);
                    var end = DateHelper.date2Str(m.end);
                    var fileName = start + '到' + end + '会议类型为' + m.type.name + '的会议出席统计表.xls';
                    FileHelper.dnExcel('/api/v1/meeting_types/via_type_export',
                        {type_id: m.type.id, start: start, end: end}, fileName, function () {
                            vm.close();
                        });
                }
            })
        }
    });

angular.module('c.c').controller('ExportMeetingCtrl',
    function ($scope, $uibModalInstance, $filter, toaster, C, F, SaveAs, FileHelper, data) {
        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        $scope.meeting = {
            start: new Date(y, m, 1),
            end: new Date(y, m + 1, 0)
        };

        $scope.ok = function (meeting) {
            if ($scope.m_form.$valid) {
                if (meeting.start > meeting.end) {
                    toaster.warning('开始日期不能大于结束日期!');
                    return;
                }
                var params = {};
                params['start'] = $filter('date')(meeting.start, 'yyyy-MM-dd');
                params['end'] = $filter('date')(meeting.end, 'yyyy-MM-dd');
                params['opt'] = 1;
                meeting.downloading = true;
                FileHelper.download(C.URL.MEETING_EXPORT, params, function (resp) {
                    meeting.downloading = false;
                    var data = [resp];
                    var options = {type: 'vnd.ms-excel'};
                    var filename = params['start'] + '到' + params['end'] + '会议考勤统计情况.xls';
                    SaveAs.download(data, filename, options);
                    $uibModalInstance.close();
                }, function () {
                    meeting.downloading = false;
                    toaster.error('导出失败!');
                });
            } else {
                toaster.warning('表单中有错误!');
                $scope.m_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });




(function () {
    'use strict';

    angular.module('c.c')
        .controller('HospitalUserInTabCtrl', HospitalUserInTabCtrl)


    ;
    /** @ngInject */
    function HospitalUserInTabCtrl($scope, UIHelper, $stateParams, $rootScope) {
        var vm = $scope;
        UIHelper.loadTabs(vm, $stateParams, $rootScope);
    }
})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('HospitalOfficeRegApprovalCtrl', HospitalOfficeRegApprovalCtrl)


    ;
    /** @ngInject */
    function HospitalOfficeRegApprovalCtrl($scope, NewUser, Table, Dlg, $q, Dept, User, ArrayHelper) {
        var vm = $scope;
        vm.edit = edit;


        init();

        function init() {
            $q.all([
                NewUser.query({op: 'UserOptions'}).$promise,
                User.getConfirms()
            ]).then(function (respArray) {
                var options = {
                    service: NewUser,
                    params: {op: 'HospitalOfficeRegApproval'},
                    optColWidth: Table._2_BTN,
                    optInFront: true,
                    showSn: true,
                    cols: [
                        {field: "name", title: "姓名", filter: {name: "text"}},
                        {field: "username", title: "胸牌号", filter: {username: "text"}},
                        {
                            field: "confirm_state",
                            title: "审批状态",
                            filter: {confirm_state: "select"},
                            data: Table.getNgTableOpts(respArray[1])
                        },
                        {
                            field: "type_id",
                            title: "岗位类型",
                            filter: {type_id: "select"},
                            data: Table.getNgTableOpts(respArray[0].items.types)
                        },
                        {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}}
                    ]
                };

                Table.load(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        item.confirm_state = ArrayHelper.getItem(item.confirm_state, respArray[1]);
                    })
                });
            });
        }

        function edit(m) {
            var pa = {
                user_id: m.id,
                user_reg: true,
                title: '确认信息',
                op: 'HospitalMainApproval'
            };

            Dlg.show({
                template: 'templates/user_reg_dlg.html',
                ctrl: 'UserRegApprovalCtrl',
                data: pa,
                size: 'lg'
            }).then(function () {
                vm.tableReload();
            });
        }
    }
})();
angular.module('c.c')
    .controller('IRShiftsCtrl', function ($scope, dialogs, toaster, C, F, Dlg,
                                          FileHelper, Upload, SaveAs, IRSchedule) {

        $scope.reload = function () {
            IRSchedule.query(function (resp) {
                var tomorrow, today;
                if (resp) {
                    tomorrow = F.getItem(1, resp);
                    today = F.getItem(2, resp);
                }
                if (!tomorrow) {
                    tomorrow = {id: 1};
                }
                if (!today) {
                    today = {id: 2};
                }
                $scope.tomorrow = tomorrow;
                $scope.today = today;
            });
        };

        $scope.moveDown = function () {
            IRSchedule.exchange(function () {
                reload();
            }, function (error) {
                var data = error.data;
                if (data.msg) Dlg.e(data.msg);
            });
        };

        $scope.upload = function (file, m, e) {
            if (e && e[0] && e[0].$error == 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }

            if (file == null) {
                return;
            }

            m.progress = 0;
            Upload.upload({
                url: C.URL.IR_SCHEDULE_UPLOAD, data: {file: file, id: m.id}
            }).progress(function (evt) {
                m.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        m.name = resp.name;
                        m.mime = resp.mime;
                        m.filename = resp.filename;
                        m.size = resp.size;
                        break;
                    case 1:
                        m.progress = 101;
                        m.errorInfo = '服务器空间不足!';
                        break;
                }
            }).error(function () {
                m.progress = 102;
                m.errorInfo = '服务器错误!';
            });
        };

        $scope.download = function (m) {
            var params = {name: m.name, filename: m.filename, mime: m.mime};
            m.downloading = true;
            FileHelper.download(C.URL.IR_SCHEDULE_DOWNLOAD, params, function (resp) {
                m.downloading = false;
                var data = [resp];
                var options = {type: m.mime};
                SaveAs.download(data, m.name, options);
            }, function (error) {
                m.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };

        $scope.reload();
    });
angular.module('c.c')
    .controller('SeniorityCtrl', function ($scope, dialogs, toaster, $filter, C, F, Table,
                                           SeniorityStandard, User, $http, $q) {

        $scope.init = function (type) {
            var options = {
                service: User,
                params: {opt: 12, type: type}, //INDEX_USER_SENIORITY
                optColWidth: 53,
                hideOpt: true,
                dateFilters: [{name: 'entry_time'}],
                items: 'users',
                cols: [
                    {title: '科室', filter: {dept_name: 'text'}, width: 220},
                    {title: '姓名', filter: {name: 'text'}, width: 140},
                    {title: '胸牌号', filter: {username: 'text'}, width: 140},
                    {title: '入院时间', filter: {entry_time: 'date_range'}, width: 160},
                    {title: '层级', filter: {seniority: 'select'}, width: 120},
                    {title: '职称', filter: {title: 'select'}},
                    {title: '岗位类型', filter: {type: 'select'}}
                ]
            };

            var options = Table.loadNgTable($scope, options, function (data) {
                $scope.users = data.users;
            }).options;

            $q.all([
                $http.get('api/open/user/reg', {params: {op: 'options'}}),
                SeniorityStandard.query({type: type}).$promise
            ]).then(function (respArray) {
                $scope.standards = respArray[1];
                $scope.standards.splice(0, 0, {id: 0, name: '暂无'});
                options().cols[4].data = Table.getNgTableOpts($scope.standards);
                options().cols[5].data = Table.getNgTableOpts(respArray[0].data.items.types);
                options().cols[6].data = Table.getNgTableOpts(respArray[0].data.items.titles);

            });
        };

        var checker = Table.loadMultiSelectedFn($scope);

        $scope.setSeniority = function (stdId, users) {
            if (!stdId) {
                toaster.warning('没有指定层级标准');
                return;
            }
            if (!checker.hasChecked()) {
                toaster.warning('请选择处理对象');
                return;
            }
            User.setSeniority({users: checker.getCheckedIds(users), std_id: stdId}, function () {
                toaster.success('设置成功');
                $scope.tableReload();
            });
        };
    });


(function () {
    'use strict';

    angular.module('c.c')
        .controller('MedicalRegApprovalCtrl', MedicalRegApprovalCtrl)


    ;
    /** @ngInject */
    function MedicalRegApprovalCtrl($scope, NewUser, Table, Dlg, $q, Dept, User, ArrayHelper) {
        var vm = $scope;
        vm.edit = edit;


        init();

        function init() {
            $q.all([
                NewUser.query({op: 'UserOptions'}).$promise,
                User.getConfirms()
            ]).then(function (respArray) {
                var options = {
                    service: NewUser,
                    params: {op: 'MedicalRegApproval'},
                    optColWidth: Table._2_BTN,
                    optInFront: true,
                    showSn: true,
                    cols: [
                        {field: "name", title: "姓名", filter: {name: "text"}},
                        {field: "username", title: "胸牌号", filter: {username: "text"}},
                        {
                            field: "confirm_state",
                            title: "审批状态",
                            filter: {confirm_state: "select"},
                            data: Table.getNgTableOpts(respArray[1])
                        },
                        {
                            field: "type_id",
                            title: "岗位类型",
                            filter: {type_id: "select"},
                            data: Table.getNgTableOpts(respArray[0].items.types)
                        },
                        {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}}
                    ]
                };

                Table.load(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        item.confirm_state = ArrayHelper.getItem(item.confirm_state, respArray[1]);
                    })
                });
            });
        }

        function edit(m) {
            var pa = {
                user_id: m.id,
                user_reg: true,
                title: '确认信息',
                op: 'MedicalApproval'
            };

            Dlg.show({
                template: 'templates/user_reg_dlg.html',
                ctrl: 'UserRegApprovalCtrl',
                data: pa,
                size: 'lg'
            }).then(function () {
                vm.tableReload();
            });
        }
    }
})();
angular.module('c.c')
    .controller('NurseSeniorityApprovalCtrl', function ($scope, dialogs, toaster, $filter
        , NgTableParams, SeniorityStandard, Dept, SeniorityApproval, NurseSeniority, User) {
        var nurses = [];
        $scope.std = [{id: 0, title: '全部标准'}];
        $scope.ap_states = [
            {id: 0, title: '护士长审'},
            {id: 1, title: '护理部审'},
            {id: 2, title: '通过'},
        ];
        $scope.init = function () {
            SeniorityStandard.query({type: 2}, function (resp) {
                $scope.standards = resp;
                angular.forEach($scope.standards, function (standard, index) {
                    $scope.std.push({id: index + 1, title: standard.name});
                });
            });
            User.query({'opt': 8}, function (data) {
                nurses = data.nurses;
            })
        };
        $scope.init();

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.cols = [
            {title: '科室', field: 'dept_id', show: true, width: "10%"},
            {title: '姓名', filter: {name: 'text'}, field: 'name', show: true, width: "10%"},
            {title: '胸牌号', filter: {numb: 'text'}, field: 'numb', show: true, width: "10%"},
            {title: '入院时间', filter: {updated_at: 'date_range'}, field: 'name', show: true, width: "20%"},
            {
                title: '层级标准',
                data: $scope.std,
                filter: {seniority_id: 'select'},
                field: 'seniority_id',
                show: true,
                width: "20%"
            },
            {title: '备注', field: 'memo', show: true, width: "20%"},
            {
                title: '状态',
                data: $scope.ap_states,
                filter: {ap_state: 'select'},
                field: 'ap_state',
                show: true,
                width: "20%"
            },
        ];

        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                updated_at: 'desc'
            }
        }, {
            counts: [5, 10, 15], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 4;
                if ($scope.dateRangeFilter.updated_at != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.updated_at.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.updated_at.endDate, 'yyyy-MM-dd');
                }
                SeniorityApproval.query(url, function (data) {
                    $scope.nurses = data.nurses;
                    params.total(data.total);
                    $defer.resolve(data.nurses);
                });

            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.add = function () {
            angular.forEach($scope.nurses, function (nurse) {
                nurses.push({id: nurse.id})
            });
            dialogs.create('NurseSeniorityDlg.html', 'NurseSeniorityDlgCtrl', {
                standards: $scope.standards,
                except_nurses: nurses
            }, {
                size: 'md'
            }).result.then(function (seniority) {
                seniority['ap_state'] = 1;
                NurseSeniority.save(seniority).$promise.then(function (data) {
                    toaster.success('护士层级添加添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('护士层级添加添加失败!');
                });
            });
        };
        $scope.edit = function (nurse) {
            nurse['standard'] = $scope.standards[nurse.seniority_id - 1];
            nurse['flag'] = true;
        };
        $scope.cancel = function (nurse) {
            nurse['flag'] = false;
        };
        $scope.examine = function (nurse) {
            var params = {};
            nurse['flag'] = false;
            if (nurse.standard)
                params['seniority_id'] = nurse.standard.id;
            params['ap_state'] = 1;
            params['examine'] = true;
            params['nurse_id'] = [nurse.id];
            params['memo'] = nurse.memo;
            NurseSeniority.update({id: 1}, params).$promise.then(function (data) {
                toaster.success('提交成功!');
                $scope.tableReload();
            }, function () {
                toaster.error('提交失败!');
            });

            $scope.tableReload();
        }
    });


(function () {
    'use strict';

    angular.module('c.c')
        .controller('nurseSeniorityShowCtrl', nurseSeniorityShowCtrl);

    /** @ngInject */
    function nurseSeniorityShowCtrl($uibModalInstance, $rootScope, $q, $sce, Dlg, ArrayHelper, FormHelper, Auth,
                         UIHelper, PrintHelper, DateHelper, Dept, DocType, NurseSeniority, data, $state) {
        var copy;
        var account = Auth.getAccount();
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;

        vm.specialPrint = [9, 10, 48, 49];

        init(data.id, data.editable);


        function init(id, editable) {
                NurseSeniority.get({id: id, for_archive: vm.forArchive}).$promise.then(function (resp) {
                // m load

                var m = resp.data[0];
                vm.m = m;
                    console.log(vm.m )
            }, function (err) {
                $uibModalInstance.close();
                if (err.data.msg) Dlg.error(err.data.msg);
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('NurseRoundsTabCtrl', NurseRoundsTabCtrl)


    ;
    /** @ngInject */
    function NurseRoundsTabCtrl($scope, UIHelper, $stateParams, $rootScope) {
        var vm = $scope;
        UIHelper.loadTabs(vm, $stateParams, $rootScope);
    }
})();

angular.module('c.c')
    .controller('NurseSeniorityCtrl', function ($scope) {

    });

(function () {
    'use strict';

    angular.module('c')
        .controller('NursingUserInfoCtrl', NursingUserInfoCtrl);

    /** @ngInject */
    function NursingUserInfoCtrl($scope, $q, Dlg, User, NewUser, FileHelper, ArrayHelper, JobTitle, Table) {
        var options, hideOpt = true;
        var vm = $scope;
        var eduBgs = ArrayHelper.get('edu_bg_list');
        var eduBgOpts = Table.getNgTableOpts(eduBgs);
        var enLvs = ArrayHelper.get('eg_lv_list');
        var posts = ArrayHelper.get('posts');
        var enLvOpts = Table.getNgTableOpts(enLvs);
        var yesNoOpts = Table.getNgTableOpts(ArrayHelper.get('yesNo'));
        var postOpts = Table.getNgTableOpts(ArrayHelper.get('posts'));
        var confirms = User.getConfirms();
        vm.visibleOptions = [
            {name: '基本信息', value: 0x01},
            {name: '账户信息', value: 0x02},
            {name: '教育背景', value: 0x04},
            {name: '联系方式', value: 0x08},
            {name: '工作相关', value: 0x10},
            //{divider: true},
            {name: '全部信息', value: 0xff}
        ];
        vm.optionSelectedFn = optionSelectedFn;

        vm.exportDn = exportDn;
        vm.option = {name: '基本信息', value: 1};
        vm.initOption = initOption;
        vm.clear = clear;

        init();


        function init() {
            $q.all([
                NewUser.query({op: 'UserOptions'}).$promise
            ]).then(function (respArray) {
                vm.titles = respArray[0].items.titles;
                vm.statuses = respArray[0].items.statuses;
                vm.types = respArray[0].items.types;
                vm.nations = respArray[0].items.nations;
                vm.political_statuses = respArray[0].items.political_statuses;
                setupOption();
                Table.load(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        item.edu_bg = ArrayHelper.getItem(item.edu_bg, eduBgs);
                        item.en_lv = ArrayHelper.getItem(item.en_lv, enLvs);
                        item.post = ArrayHelper.getItem(item.post, posts);
                        item.confirm_state = ArrayHelper.getItem(item.confirm_state, confirms);
                    });
                });

                optionSelectedFn(vm.option);
            })
        }

        function clear() {
            vm.tableParams.filter({type_id: '2'});
        }

        function initOption(hide) {
            hideOpt = hide;
        }

        function setupOption() {
            options = {
                service: NewUser,
                params: {op: 'nursingInfo'},
                filter: {type_id: '2'},
                showSn: true,
                sorting: {created_at: 'asc'},
                count: 15,
                counts: [15, 30, 50],
                hideOpt: hideOpt,
                cols: [
                    {
                        title: '姓名',
                        filter: {name: 'text'},
                        field: 'name',
                        width: 135,
                        type: 0xff
                    },
                    { //1
                        title: '主科室',
                        filter: {main_dept: 'text'},
                        field: 'main_dept',
                        type: 0x01
                    },
                    { //2
                        title: '是否有照片',
                        filter: {photo: 'select'},
                        data: yesNoOpts,
                        field: 'photo',
                        type: 0x01
                    },
                    { //2
                        title: '确认状态',
                        filter: {confirm_state: 'select'},
                        data: Table.getNgTableOpts(confirms),
                        field: 'confirm_state',
                        type: 0x01
                    },
                    { //5
                        title: '籍贯',
                        field: 'native_place',
                        filter: {native_place: 'text'},
                        type: 0x01
                    },
                    { //4
                        title: '民族',
                        field: 'nation_id',
                        filter: {nation_id: 'select'},
                        data: Table.getNgTableOpts(vm.nations),
                        type: 0x01
                    },
                    /*账户信息*/
                    { //7
                        title: '用户名',
                        filter: {username: 'text'},
                        field: 'username',
                        type: 0x02
                    },
                    {title: '邮箱', sortable: 'email', filter: {email: 'text'}, field: 'email', type: 0x02},//8

                    /*教育背景*/
                    { //9
                        title: '毕业学校',
                        filter: {graduate_school: 'text'},
                        field: 'graduate_school',
                        width: 200,
                        type: 0x04
                    },
                    {  //10
                        title: '政治面貌',
                        filter: {political_status_id: 'select'},
                        field: 'political_status_id',
                        width: 120,
                        data: Table.getNgTableOpts(vm.political_statuses),
                        type: 0x04
                    },
                    {  //12
                        title: '学历',
                        filter: {edu_bg: 'select'},
                        data: eduBgOpts,
                        field: 'edu_bg',
                        type: 0x04
                    },
                    {
                        title: '学位',
                        filter: {degree: 'text'},
                        field: 'degree',
                        width: 140,
                        type: 0x04
                    },//13
                    { //14
                        title: '英语等级',
                        filter: {en_lv: 'select'},
                        data: enLvOpts,
                        field: 'en_lv',
                        type: 0x04
                    },

                    /* 联系方式 */
                    {title: '手机', filter: {phone: 'text'}, field: 'phone', type: 0x08}, //15
                    {title: '手机集团小号', filter: {cornet: 'text'}, field: 'cornet', type: 0x08},//16
                    {title: '备用手机', filter: {phone2: 'text'}, field: 'phone2', type: 0x08},//17
                    {//18
                        title: '办公室电话',
                        filter: {office_phone: 'text'},
                        field: 'office_phone',
                        type: 0x08
                    },
                    {//19
                        title: '办公室小号',
                        filter: {office_cornet: 'text'},
                        field: 'office_cornet',
                        type: 0x08
                    },

                    {title: 'QQ', filter: {qq: 'text'}, field: 'qq', type: 0x08},//20
                    {title: '联系地址', filter: {address: 'text'}, field: 'address', type: 0x08},//21

                    /* 工作相关 */
                    { //22
                        title: '编制类型',
                        filter: {status_id: 'select'},
                        field: 'status_id',
                        data: Table.getNgTableOpts(vm.statuses),
                        type: 0x10
                    },
                    { //23
                        title: '类别',
                        // filter: {type_id: 'select'},
                        // data: Table.getNgTableOpts(vm.types),
                        field: 'type_id', type: 0x10
                    },
                    { //24
                        title: '参加工作时间',
                        filter: {started_work: 'date_range'},
                        field: 'started_work',
                        type: 0x10
                    },
                    { //25
                        title: '入职时间',
                        filter: {entry_time: 'date_range'},
                        field: 'entry_time',
                        type: 0x10
                    },
                    { //27
                        title: '中层以上干部',
                        filter: {is_cadre: 'select'},
                        data: yesNoOpts,
                        field: 'is_cadre', type: 0x10
                    },
                    { //27
                        title: '职称',
                        filter: {title_id: 'select'},
                        data: Table.getNgTableOpts(vm.titles),
                        field: 'title', type: 0x10
                    },
                    { //27
                        title: '职务',
                        filter: {post: 'select'},
                        data: postOpts,
                        field: 'post', type: 0x10
                    }
                ]
            };
        }

        function optionSelectedFn(option) {
            vm.option = option;
            angular.forEach(vm.cols, function (col) {
                if (col.type & option.value) {
                    col.show = true;
                } else {
                    col.show = false;
                }
            });
        }

        function exportDn() {
            FileHelper.dnExcel(NewUser.urls.EXPORT_USER_INFO,
                {types: [2]}, '护士信息表.xls', function () {
                    Dlg.s('护士信息导出成功!');
                });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('NurseRegApprovalCtrl', NurseRegApprovalCtrl)


    ;
    /** @ngInject */
    function NurseRegApprovalCtrl($scope, NewUser, Table, Dlg, $q, Dept, User, ArrayHelper) {
        var vm = $scope;
        vm.edit = edit;


        init();

        function init() {
            $q.all([
                NewUser.query({op: 'UserOptions'}).$promise,
                User.getConfirms()
            ]).then(function (respArray) {
                var options = {
                    service: NewUser,
                    params: {op: 'NurseRegApproval'},
                    optColWidth: Table._2_BTN,
                    optInFront: true,
                    showSn: true,
                    cols: [
                        {field: "name", title: "姓名", filter: {name: "text"}},
                        {field: "username", title: "胸牌号", filter: {username: "text"}},
                        {
                            field: "confirm_state",
                            title: "审批状态",
                            filter: {confirm_state: "select"},
                            data: Table.getNgTableOpts(respArray[1])
                        },
                        {
                            field: "type_id",
                            title: "岗位类型",
                            filter: {type_id: "select"},
                            data: Table.getNgTableOpts(respArray[0].items.types)
                        },
                        {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}}
                    ]
                };

                Table.load(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        item.confirm_state = ArrayHelper.getItem(item.confirm_state, respArray[1]);
                    })
                });
            });
        }

        function edit(m) {
            var pa = {
                user_id: m.id,
                user_reg: true,
                title: '确认信息',
                op: 'NursingApproval'
            };

            Dlg.show({
                template: 'templates/user_reg_dlg.html',
                ctrl: 'UserRegApprovalCtrl',
                data: pa,
                size: 'lg'
            }).then(function () {
                vm.tableReload();
            });
        }
    }
})();
angular.module('c.c')
    .controller('OPHandleCtrl', function ($rootScope, $scope, dialogs, F, ORRecipient) {
        var PendingNeedRefresh = false;
        var ProcessedNeedRefresh = false;
        $scope.$on('OPConfirmed', function () {
            ProcessedNeedRefresh = true;
        });
        $scope.$on('OPCancel', function () {
            PendingNeedRefresh = true;
        });
        $scope.select = function (opt) {
            if (opt == 'pending') {
                if (PendingNeedRefresh) {
                    $rootScope.$broadcast('OPPendingRefresh');
                    PendingNeedRefresh = false;
                }
            } else if (opt == 'processed') {
                if (ProcessedNeedRefresh) {
                    $rootScope.$broadcast('OPProcessedRefresh');
                    ProcessedNeedRefresh = false;
                }
            }
        };

        //ORRecipient.query(function (resp) {
        //    var is_r = false;
        //    if (resp) {
        //        var r = F.getItem(1, resp);
        //        if (r.user_id == $scope.account.id) {
        //            is_r = true;
        //        }
        //    }
        //    if (!is_r) {
        //        dialogs.notify('提示', '您不是指定的手术接单人，因此无法在此获取全院的手术单!');
        //    }
        //});
    });
angular.module('c.c')
    .controller('OPRecipientCtrl', function ($scope, Dlg, F, ORRecipient) {
        $scope.reload = function () {
            ORRecipient.query({type: 1}, function (resp) {
                var users = [];
                angular.forEach(resp.records, function (r) {
                    users.push(r.user);
                });
                $scope.users = users;
            });
        };

        $scope.submit = function (users) {
            var params = {'type': 1, 'user_ids': []};
            if (users) {
                angular.forEach(users, function (u) {
                    params['user_ids'].push(u.id);
                });
            }
            ORRecipient.update({id: 0}, params).$promise.then(function () {
                Dlg.s('设置成功');
            }, function () {
                Dlg.e('设置失败');
            });
        };

        $scope.reset = $scope.reload;
        $scope.reload();
    });
angular.module('c.c')
    .controller('OPShiftsCtrl', function ($scope, dialogs, toaster, C, F, Dlg,
                                          FileHelper, Upload, SaveAs, ORSchedule) {

        $scope.reload = function () {
            ORSchedule.query(function (resp) {
                var tomorrow, today;
                if (resp) {
                    tomorrow = F.getItem(1, resp);
                    today = F.getItem(2, resp);
                }
                if (!tomorrow) {
                    tomorrow = {id: 1};
                }
                if (!today) {
                    today = {id: 2};
                }
                $scope.tomorrow = tomorrow;
                $scope.today = today;
            });
        };

        $scope.moveDown = function () {
            ORSchedule.exchange(function () {
                reload();
            }, function (error) {
                var data = error.data;
                if (data.msg) Dlg.e(data.msg);
            });
        };

        $scope.upload = function (file, m, e) {
            FileHelper.upload1(C.URL.OR_SCHEDULE_UPLOAD, file, m, e, {name: 'name'});
        };

        $scope.download = function (m) {
            var params = {name: m.name, filename: m.filename, mime: m.mime};
            m.downloading = true;
            FileHelper.download(C.URL.OR_SCHEDULE_DOWNLOAD, params, function (resp) {
                m.downloading = false;
                var data = [resp];
                var options = {type: m.mime};
                SaveAs.download(data, m.name, options);
            }, function (error) {
                m.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };

        $scope.reload();
    });
angular.module('c.c')
    .controller('PendingOPCtrl', function ($rootScope, $scope, $filter, Dlg, NgTableParams, DateHelper,
                                           FileHelper, OperationPermit, SaveAs, C, F, Table, ArrayHelper) {
        $scope.$on('OPPendingRefresh', function () {
            $scope.tableParams.reload();
        });

        $scope.types = F.get('or_types');
        var typeOpts = Table.getNgTableOpts($scope.types);

        $scope.cols = [
            {title: '手术单', filter: {attach_name: 'text'}, field: 'attach_name', width: '20%', show: true}, //0
            {title: '接单手术室', filter: {type_id: 'select'}, data: typeOpts, field: 'type_id', show: true}, //1
            {title: '递交人', field: 'applicant', filter: {applicant: 'text'}, width: '10%', show: true}, //6
            {title: '递交科室', filter: {dept: 'text'}, field: 'dept', width: '15%', show: true}, //1
            {
                title: '递交时间',
                filter: {created_at: 'date_range'},
                sortable: 'created_at',
                field: 'created_at',
                width: '20%',
                show: true
            }, //6
            {title: '备注', field: 'remark', width: '10%', show: true} //1
        ];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.tableParams = new NgTableParams({page: 1, count: 30, sorting: {created_at: 'desc'}}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 2;
                if ($scope.dateRangeFilter.created_at != null) {
                    url['startDate'] = DateHelper.date2Str($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
                    url['endDate'] = DateHelper.date2Str($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
                }
                OperationPermit.query(url, function (resp) {
                    params.total(resp.total);
                    angular.forEach(resp.permits, function (m) {
                        m.type = ArrayHelper.getItem(m.type_id, $scope.types);
                    });
                    $defer.resolve(resp.permits);
                });
            }
        });

        $scope.optColWidth = 96;

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.confirm = function (m) {
            OperationPermit.update({id: m.id}, {stage: 2}).$promise.then(function () {
                Dlg.s('确认成功!');
                $scope.tableParams.reload();
                $rootScope.$broadcast('OPConfirmed');
            }, function (error) {
                Dlg.e('确认失败!');
            });
        };

        $scope.returnOP = function (m) {
            Dlg.confirm('确定要退回此手术通知单吗?', function (resp) {
                OperationPermit.update({id: m.id}, {stage: 3}).$promise.then(function (resp) {
                    Dlg.s('已退回!');
                    $scope.tableParams.reload();
                }, function (error) {
                    Dlg.e('操作失败!');
                });
            }, '退回手术通知单');
        };

        $scope.download = function (m) {
            var params = {filename: m.attach_filename, mime: m.attach_mime};
            m.downloading = true;
            FileHelper.download(C.URL.OP_DOWNLOAD, params, function (resp) {
                m.downloading = false;
                var data = [resp];
                var options = {type: m.attach_mime};
                SaveAs.download(data, m.attach_name, options);
            }, function () {
                m.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };

        //$scope.delete = function (m) {
        //    dialogs.confirm('删除物资申请', '确定要删除该物资申请记录吗?')
        //        .result.then(function () {
        //            OperationPermit.delete({id: m.id}).$promise.then(function (resp) {
        //                $scope.tableReload();
        //            }, function () {
        //                toaster.error('删除物资申请!');
        //            });
        //        });
        //};

    });
angular.module('c.c')
    .controller('ProcessedOPCtrl', function ($rootScope, $scope, $filter, dialogs, C, F, FileHelper,
                                             toaster, NgTableParams, SaveAs, OperationPermit) {
        $scope.$on('OPProcessedRefresh', function () {
            $scope.tableParams.reload();
        });

        $scope.types = F.get('or_types');
        var typeOpts = F.getNgTableOpts($scope.types);

        $scope.cols = [
            {title: '手术单', filter: {attach_name: 'text'}, field: 'attach_name', width: '20%', show: true}, //0
            {title: '接单手术室', filter: {type_id: 'select'}, data: typeOpts, width: '90', field: 'type_id', show: true}, //1
            {title: '递交人', field: 'applicant', filter: {applicant: 'text'}, width: '72', show: true}, //6
            {title: '递交科室', filter: {dept: 'text'}, field: 'dept', width: '72', show: true}, //1
            {
                title: '递交时间',
                filter: {created_at: 'date_range'},
                sortable: 'created_at',
                field: 'created_at',
                width: '15%',
                show: true
            }, //6
            {title: '确认时间', field: 'updated_at', width: '118', show: true}, //6
            {title: '备注', field: 'remark', width: '20%', show: true} //1
        ];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.tableParams = new NgTableParams({page: 1, count: 30, sorting: {created_at: 'desc'}}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 3;
                if ($scope.dateRangeFilter.created_at != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
                }
                OperationPermit.query(url, function (resp) {
                    params.total(resp.total);
                    angular.forEach(resp.permits, function (m) {
                        m.type = F.getItem(m.type_id, $scope.types);
                    });
                    $defer.resolve(resp.permits);
                });
            }
        });

        //$scope.hideFilter = true;
        $scope.optColWidth = 70;

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.cancel = function (m) {
            dialogs.confirm('撤销手术通知单', '确定要撤销对该手术通知单的确认吗?')
                .result.then(function () {
                    OperationPermit.update({id: m.id}, {stage: 1}).$promise.then(function () {
                        toaster.success('撤销成功!');
                        $scope.tableParams.reload();
                        $rootScope.$broadcast('OPCancel');
                    }, function (error) {
                        toaster.error('撤销失败!');
                    });
                });
        };

        //$scope.delete = function (m) {
        //    dialogs.confirm('删除手术通知单', '确定要删除该手术通知单记录吗?')
        //        .result.then(function () {
        //            OperationPermit.delete({id: m.id}).$promise.then(function (resp) {
        //                $scope.tableReload();
        //            }, function () {
        //                toaster.error('删除手术通知单!');
        //            });
        //        });
        //};

        $scope.download = function (m) {
            var params = {filename: m.attach_filename, mime: m.attach_mime};
            m.downloading = true;
            FileHelper.download(C.URL.OP_DOWNLOAD, params, function (resp) {
                m.downloading = false;
                var data = [resp];
                var options = {type: m.attach_mime};
                SaveAs.download(data, m.attach_name, options);
            }, function () {
                m.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };
    });
angular.module('c.c')
    .controller('OutPShiftsCtrl', function ($scope, dialogs, toaster, FileHelper, Dlg,
                                            C, F, Upload, SaveAs, OutPSchedule) {

        $scope.reload = function () {
            OutPSchedule.query(function (resp) {
                var tomorrow, today;
                if (resp) {
                    tomorrow = F.getItem(1, resp);
                    today = F.getItem(2, resp);
                }
                if (!tomorrow) {
                    tomorrow = {id: 1};
                }
                if (!today) {
                    today = {id: 2};
                }
                $scope.tomorrow = tomorrow;
                $scope.today = today;
            });
        };

        $scope.moveDown = function () {
            OutPSchedule.exchange(function () {
                reload();
            }, function (error) {
                var data = error.data;
                if (data.msg) Dlg.e(data.msg);
            });
        };

        $scope.upload = function (file, m, e) {
            if (e && e[0] && e[0].$error == 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }

            if (file == null) {
                return;
            }

            m.progress = 0;
            Upload.upload({
                url: C.URL.OUT_P_SCHEDULE_UPLOAD, data: {file: file, id: m.id}
            }).progress(function (evt) {
                m.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        m.name = resp.name;
                        m.mime = resp.mime;
                        m.filename = resp.filename;
                        m.size = resp.size;
                        break;
                    case 1:
                        m.progress = 101;
                        m.errorInfo = '服务器空间不足!';
                        break;
                }
            }).error(function () {
                m.progress = 102;
                m.errorInfo = '服务器错误!';
            });
        };

        $scope.download = function (m) {
            var params = {name: m.name, filename: m.filename, mime: m.mime};
            m.downloading = true;
            FileHelper.download(C.URL.OUT_P_SCHEDULE_DOWNLOAD, params, function (resp) {
                m.downloading = false;
                var data = [resp];
                var options = {type: m.mime};
                SaveAs.download(data, m.name, options);
            }, function (error) {
                m.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };

        $scope.reload();
    });
(function () {
    'use strict';

    angular.module('c.c')
        .controller('PartyMemberCtrl', PartyMemberCtrl);

    /** @ngInject */
    function PartyMemberCtrl($scope, Dlg, Dept, Table) {
        var vm = $scope;
        vm.leader = leader;
        vm.member = member;
        vm.type = {id: 0, name: '全部科室'};

        init();


        function init() {
            var options = {
                service: Dept,
                params: {opt: 19/*INDEX_PARTY_DEPT*/},
                optColWidth: Table._2_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {field: "name", title: "科室名称", filter: {name: "text"}},
                    {field: "leader", title: "科室负责人", filter: {leader: "text"}},
                    {
                        field: "hospital",
                        title: "分管院领导",
                        filter: {hospital: "text"}
                    },

                    {
                        field: 'members_count',
                        title: '成员数',
                        width: 100
                    }
                ]
            };
            Table.load(vm, options, function (resp) {
                vm.types = resp.types;
                vm.types.splice(0, 0, {id: 0, name: '全部科室'});
            });
        }

        function leader(m) {
            Dlg.show({
                template: 'templates/setLeaderDlg.html',
                ctrl: 'SelectLeaderCtrl',
                data: {dept: m}
            }).then(function (resp) {
                resp['opt'] = 1;
                Dept.update({id: m.id}, resp).$promise.then(function (resp) {
                    Dlg.s('设置成功!');
                    vm.tableReload();
                }, function () {
                    Dlg.e('设置失败!');
                });
            });
        }

        function member(m) {
            Dlg.show({
                template: 'templates/MemberRecordDlg.html',
                ctrl: 'MemberCtrl',
                data: {dept: m},
                size: 'lg'
            }).then(function () {
                vm.tableReload();
            });
        }
    }
})();



(function () {
    'use strict';

    angular.module('c.c')
        .controller('SignedTabCtrl', SignedTabCtrl)


    ;
    /** @ngInject */
    function SignedTabCtrl($scope, UIHelper, $stateParams, $rootScope) {
        var vm = $scope;
        UIHelper.loadTabs(vm, $stateParams, $rootScope);
    }
})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('TOZRTabCtrl', TOZRTabCtrl)


    ;
    /** @ngInject */
    function TOZRTabCtrl($scope, UIHelper, $stateParams, $rootScope) {
        var vm = $scope;
        UIHelper.loadTabs(vm, $stateParams, $rootScope);
    }
})();
(function () {
    'use strict';

    angular.module('c.d')
        .controller('PartyWorkUserInfoCtrl', PartyWorkUserInfoCtrl);

    /** @ngInject */
    function PartyWorkUserInfoCtrl($scope, $q, Dlg, User, UserOnType, ArrayHelper, Table, NewUser) {
        var vm = $scope;

        var options, hideOpt = false;
        var eduBgs = ArrayHelper.get('edu_bg_list');
        var eduBgOpts = Table.getNgTableOpts(eduBgs);
        var enLvs = ArrayHelper.get('eg_lv_list');
        var posts = ArrayHelper.get('posts');
        var enLvOpts = Table.getNgTableOpts(enLvs);
        var yesNoOpts = Table.getNgTableOpts(ArrayHelper.get('yesNo'));
        var postOpts = Table.getNgTableOpts(ArrayHelper.get('posts'));
        var confirms = User.getConfirms();
        // var checker = null;
        vm.visibleOptions = [
            {title: '基本信息', value: 0x01},
            {title: '账户信息', value: 0x02},
            {title: '教育背景', value: 0x04},
            {title: '联系方式', value: 0x08},
            {title: '工作相关', value: 0x10},
            //{divider: true},
            {title: '全部信息', value: 0xff}
        ];
        vm.optionSelectedFn = optionSelectedFn;
        vm.exportDn = exportDn;
        vm.edit = edit;
        vm.changeType = changeType;
        vm.changeRecord = changeRecord;
        vm.kpi = kpi;
        vm.changePwd = changePwd;
        vm.remove = remove;
        vm.transfer = transfer;
        vm.passChecked = passChecked;
        vm.clearWxBind = clearWxBind;
        vm.initOption = initOption;
        vm.option = {title: '基本信息', value: 1};


        init();

        function init() {
            $q.all([
                NewUser.query({op: 'UserOptions'}).$promise
            ]).then(function (respArray) {
                vm.titles = respArray[0].items.titles;
                vm.statuses = respArray[0].items.statuses;
                vm.types = respArray[0].items.types;
                vm.nations = respArray[0].items.nations;
                vm.political_statuses = respArray[0].items.political_statuses;
                setupOption();
                Table.load(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        item.edu_bg = ArrayHelper.getItem(item.edu_bg, eduBgs);
                        item.en_lv = ArrayHelper.getItem(item.en_lv, enLvs);
                        item.post = ArrayHelper.getItem(item.post, posts);
                        item.confirm_state = ArrayHelper.getItem(item.confirm_state, confirms);
                    });
                });
                optionSelectedFn(vm.option);

                // checker = Table.loadMultiSelectedFn(vm);
            })
        }

        function initOption(hide) {
            hideOpt = hide;
        }

        function setupOption() {
            options = {
                service: NewUser,
                params: {op: 'partyWorkInfo'},
                optInFront: true,
                optColWidth: Table._3_BTN,
                sorting: {created_at: 'asc'},
                count: 15,
                counts: [15, 30, 50],
                hideOpt: hideOpt,
                cols: [
                    {
                        title: '姓名',
                        filter: {name: 'text'},
                        field: 'name',
                        width: 135,
                        type: 0xff
                    },
                    { //1
                        title: '主科室',
                        filter: {main_dept: 'text'},
                        field: 'main_dept',
                        type: 0x01
                    },
                    { //2
                        title: '是否有照片',
                        filter: {photo: 'select'},
                        data: yesNoOpts,
                        field: 'photo',
                        type: 0x01
                    },
                    { //2
                        title: '确认状态',
                        filter: {confirm_state: 'select'},
                        data: Table.getNgTableOpts(confirms),
                        field: 'confirm_state',
                        type: 0x01
                    },
                    { //5
                        title: '籍贯',
                        field: 'native_place',
                        filter: {native_place: 'text'},
                        type: 0x01
                    },
                    { //4
                        title: '民族',
                        field: 'nation_id',
                        filter: {nation_id: 'select'},
                        data: Table.getNgTableOpts(vm.nations),
                        type: 0x01
                    },
                    /*账户信息*/
                    { //7
                        title: '用户名',
                        filter: {username: 'text'},
                        field: 'username',
                        type: 0x02
                    },
                    {title: '邮箱', sortable: 'email', filter: {email: 'text'}, field: 'email', type: 0x02},//8

                    /*教育背景*/
                    { //9
                        title: '毕业学校',
                        filter: {graduate_school: 'text'},
                        field: 'graduate_school',
                        width: 200,
                        type: 0x04
                    },
                    {  //10
                        title: '政治面貌',
                        filter: {political_status_id: 'select'},
                        field: 'political_status_id',
                        width: 120,
                        data: Table.getNgTableOpts(vm.political_statuses),
                        type: 0x04
                    },
                    {  //12
                        title: '学历',
                        filter: {edu_bg: 'select'},
                        data: eduBgOpts,
                        field: 'edu_bg',
                        type: 0x04
                    },
                    {
                        title: '学位',
                        filter: {degree: 'text'},
                        field: 'degree',
                        width: 140,
                        type: 0x04
                    },//13
                    { //14
                        title: '英语等级',
                        filter: {en_lv: 'select'},
                        data: enLvOpts,
                        field: 'en_lv',
                        type: 0x04
                    },

                    /* 联系方式 */
                    {title: '手机', filter: {phone: 'text'}, field: 'phone', type: 0x08}, //15
                    {title: '手机集团小号', filter: {cornet: 'text'}, field: 'cornet', type: 0x08},//16
                    {title: '备用手机', filter: {phone2: 'text'}, field: 'phone2', type: 0x08},//17
                    {//18
                        title: '办公室电话',
                        filter: {office_phone: 'text'},
                        field: 'office_phone',
                        type: 0x08
                    },
                    {//19
                        title: '办公室小号',
                        filter: {office_cornet: 'text'},
                        field: 'office_cornet',
                        type: 0x08
                    },

                    {title: 'QQ', filter: {qq: 'text'}, field: 'qq', type: 0x08},//20
                    {title: '联系地址', filter: {address: 'text'}, field: 'address', type: 0x08},//21

                    /* 工作相关 */
                    { //22
                        title: '编制类型',
                        filter: {status_id: 'select'},
                        field: 'status_id',
                        data: Table.getNgTableOpts(vm.statuses),
                        type: 0x10
                    },
                    { //23
                        title: '类别',
                        filter: {type_id: 'select'},
                        data: Table.getNgTableOpts(vm.types),
                        field: 'type_id', type: 0x10
                    },
                    { //24
                        title: '参加工作时间',
                        filter: {started_work: 'date_range'},
                        field: 'started_work',
                        type: 0x10
                    },
                    { //25
                        title: '入职时间',
                        filter: {entry_time: 'date_range'},
                        field: 'entry_time',
                        type: 0x10
                    },
                    { //27
                        title: '中层以上干部',
                        filter: {is_cadre: 'select'},
                        data: yesNoOpts,
                        field: 'is_cadre', type: 0x10
                    },
                    { //27
                        title: '职称',
                        filter: {title_id: 'select'},
                        data: Table.getNgTableOpts(vm.titles),
                        field: 'title', type: 0x10
                    },
                    { //27
                        title: '职务',
                        filter: {post: 'select'},
                        data: postOpts,
                        field: 'post', type: 0x10
                    }
                ]
            };
        }
        function optionSelectedFn(option) {
            vm.option = option;
            angular.forEach(vm.cols, function (col) {
                if (col.type & option.value) {
                    col.show = true;
                } else {
                    col.show = false;
                }
            });
        }

        function exportDn() {
            Dlg.show({
                template: 'templates/export/ExportUserInfoDlg.html',
                ctrl: 'ExportUserInfoDlgCtrl',
                data: {}
            }).then(function () {
                Dlg.s('用户信息导出成功!');
            })
        }

        function edit(user) {
            var pa = {
                user_id: user.id, sys_edit: true, confirm_state: '2',
                title: '修改用户信息'
            };
            if (user.confirm_state.id > 2) {
                pa.title = '查看注册用户信息';
                pa.confirm_state = user.confirm_state.id;
            }
            Dlg.show({
                template: 'templates/PersonnelUserDlg.html',
                ctrl: 'PersonnelUserEditCtrl',
                data: pa,
                size: 'lg'
            }).then(function () {
                if (user.id == $scope.account.id) {
                    $scope.account.confirm_state = 2; //2表示人事科已确认
                }
                vm.tableReload();
            });
        }

        //修改编制
        function changeType(user) {
            Dlg.show({
                template: 'templates/changeOnTypeDlg.html',
                ctrl: 'UserChangeTypeCtrl',
                data: {user: user, statuses: vm.statuses}
            }).then(function (resp) {
                UserOnType.save(resp).$promise.then(function () {
                    Dlg.s('用户编制信息修改成功!');
                    vm.tableReload();
                }, function () {
                    Dlg.e('用户编制信息修改失败!');
                });

            });
        }

        //查看编制修改记录
        function changeRecord(user) {
            Dlg.show({
                template: 'templates/changeTypeRecord.html',
                ctrl: 'ChangeTypeRecordCtrl',
                data: {user: user}
            });
        }

        //查看绩效系数记录
        function kpi(user) {
            Dlg.show({
                template: 'templates/kpiRecord.html',
                ctrl: 'KpiRecordCtrl',
                data: {user: user}
            });
        }

        function changePwd(user) {
            Dlg.show({
                template: 'templates/changePassword.html',
                ctrl: 'changePwdCtrl',
                data: {user: user}
            }).then(function () {
                vm.tableReload();
            });
        }

        function remove(user) {
            Dlg.confirm('确定要删除名为<strong>' + user.name + '</strong>的员工记录吗？', function (resp) {
                User.delete({id: user.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s('员工记录删除成功!');
                            break;
                        case 1:
                            Dlg.w('该员工属于科室成员,无法直接删除');
                            break;
                    }
                    vm.tableReload();
                }, function (error) {
                    Dlg.e('员工记录删除失败!');
                });
            }, '删除员工记录');
        }

        function transfer(user) {
            Dlg.show({
                template: 'templates/dept_record_dlg.html',
                ctrl: 'DeptRecordDlgCtrl',
                data: {user: user, hideOpt: false},
                size: 'lg'
            });
        }

        function clearWxBind(m) {
            NewUser.update({id: m.id}, {
                op: 'clear_wx_bind'
            }).$promise.then(function (resp) {
                Dlg.s(resp.msg);
                vm.tableReload();
            }, function (error) {
                Dlg.e(error.msg);
            });
        }

        function passChecked() {
            var items = checker.getChecked();
            var userIds = [];
            var count = items.length;
            if (count === 0) {
                checker.clearChecked();
                Dlg.w("请至少选中一个待处理申请");
                return;
            }
            var defer = $q.defer();
            vm.tableParams.settings().$loading = true;
            angular.forEach(items, function (item) {
                userIds.push(item.id);
            });
            var pa = {
                op: 'UserMsg',
                confirm_state: 2,
                userIds: userIds
            };
            NewUser.batchConfirm(pa).$promise.then(function (resp) {
                Dlg.s(resp.msg);
            }, function (error) {
                Dlg.s("信息确认失败");
            });
            defer.resolve();
            checker.clearChecked();
            vm.tableReload();
            return defer.promise;
        }
    }

})();
'use strict';
angular.module('c.c')
    .controller('AllUserCtrl', function ($rootScope, $scope, NgTableParams, F, User, Dlg) {
        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
        var eduBgs = F.get('edu_bg_list');
        var eduBgOpts = F.getNgTableOpts(eduBgs);
        var confirms = [{id: 0, title: '用户待确认'},
            {id: 1, title: '人事科待确认'},
            {id: 2, title: '人事科确认'},
            {id: 3, title: '科室待确认'},
            {id: 4, title: '用户待现场报到'},
            {id: 10, title: '退回'}]
        $scope.ed = ['', '高中', '中专', '大专', '成人本科', '本科', '硕士', '博士', '其他'];
        $scope.yes_no = yesNoOpts;
        $scope.optInFront = true;
        $scope.hideOpt = true;
        $scope.cols = [
            {
                title: '姓名',
                sortable: 'name',
                filter: {name: 'text'},
                field: 'name',
                type: 0xff,
                show: true,
                width: '10%'
            }, //1
            {
                title: '胸牌号',
                sortable: 'username',
                filter: {username: 'text'},
                field: 'username',
                type: 0xff,
                show: true,
                width: '10%'
            }, //1
            {title: '主科室', field: 'main_dept', type: 1, filter: {main_dept: 'text'}, show: true, width: '10%'},
            {
                title: '编制类型', sortable: 'status_id', filter: {status_id: 'select'}, field: 'status_id'
                , type: 8, show: true, width: '10%'
            },
            {
                title: '类别',
                sortable: 'type_id',
                filter: {type_id: 'select'},
                field: 'type_id',
                type: 8,
                show: true,
                width: '10%'
            },
            {
                title: '入职时间',
                sortable: 'entry_time',
                filter: {entry_time: 'date_range'},
                field: 'entry_time',
                type: 8,
                show: true,
                width: '10%'
            },
            {
                title: '入职类型',
                sortable: 'entry_type_id',
                filter: {entry_type_id: 'select'},
                field: 'entry_type_id',
                type: 8,
                show: true,
                width: '10%'
            },
            {
                title: '是否在职',
                sortable: 'leave_time',
                filter: {leave_time: 'select'},
                data: yesNoOpts,
                field: 'leave_time',
                type: 8,
                show: true,
                width: '10%'
            },
            { //2
                title: '确认状态',
                filter: {confirm_state: 'select'},
                field: 'confirm_state',
                data: confirms,
                type: 2,
                show: true,
                width: '10%'
            },
            {
                title: '所学专业',
                sortable: 'major',
                filter: {major: 'text'},
                field: 'major',
                type: 2,
                show: true,
                width: '10%'
            },//9
            {
                title: '学历',
                sortable: 'edu_bg',
                filter: {edu_bg: 'select'},
                data: eduBgOpts,
                field: 'edu_bg',
                type: 2,
                show: true,
                width: '10%'
            },
            {
                title: '中层以上干部',
                sortable: 'is_cadre',
                filter: {is_cadre: 'select'},
                data: yesNoOpts,
                field: 'is_cadre',
                type: 8,
                show: true,
                width: '10%'
            }
        ];
        $scope.statuses_col = $scope.cols[3];
        $scope.user_types_col = $scope.cols[4];
        $scope.entry_types_col = $scope.cols[6];
        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };
        $scope.$on('user_recover', function (event, data) {
            $scope.tableReload();
        });

        $scope.dateRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.dateRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );
        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };
        $scope.tableParams = new NgTableParams({
            page: 1, count: 30, sorting: {
                updated_at: 'desc'
            }
        }, {
            counts: [30, 50, 100], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 1;
                // url['is_leaved'] = 0;
                url['date_range_filters'] = $scope.dateRangeFilter;
                User.query(url, function (data) {
                    $scope.users = data.users;
                    $scope.statuses_col.data = F.getNgTableOpts(data.statuses);
                    $scope.user_types_col.data = F.getNgTableOpts(data.types);
                    $scope.entry_types_col.data = F.getNgTableOpts(data.entry_types);
                    angular.forEach(data.users, function (u) {
                        u.confirm_state = F.getItem(u.confirm_state, confirms);
                    });
                    params.total(data.total);
                    $defer.resolve($scope.users);
                });
            }
        });
        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };
        $scope.user_leave = function (user) {
            Dlg.show({
                template: 'pages/dialogs/userLeaveDlg.html',
                ctrl: 'LeaveCtrl',
                data: {id: user.id}
            }).then(function () {
                $scope.tableReload();
            });
        }
    });
angular.module('c.c')
    .controller('DeptMemberCtrl', DeptMemberCtrl);

function DeptMemberCtrl($scope, Dlg, Dept, Table) {
    var vm = $scope;
    vm.leader = leader;
    vm.member = member;
    // vm.typeSelectedFn = typeSelectedFn;
    vm.type = {id: 0, name: '全部科室'};

    init();

    function init() {
        var options = {
            service: Dept,
            params: {opt: 19/*INDEX_DEPT_NEWS*/},
            optColWidth: Table._2_BTN,
            optInFront: true,
            showSn: true,
            cols: [
                {field: "name", title: "科室名称", filter: {name: "text"}},
                {field: "leader", title: "科室负责人", filter: {leader: "text"}},
                {
                    field: "hospital",
                    title: "分管院领导",
                    filter: {hospital: "text"}
                },
                {
                    field: "attendanceReport",
                    title: "考勤上报人事员",
                    filter: {attendanceReport: "text"}
                },

                {
                    field: 'members_count',
                    title: '成员数',
                    width: 100
                }
            ]
        };
        Table.load(vm, options, function (resp) {
            // vm.types.push([{id: 0, name: '全部科室'}]);
            // // console.log('resp.types', resp.types);
            // angular.forEach(resp.types, function (type) {
            //     vm.types.push(type);
            // });
            vm.types = resp.types;
            vm.types.splice(0, 0, {id: 0, name: '全部科室'});
        });
    }

    function leader(m) {
        Dlg.show({
            template: 'templates/setLeaderDlg.html',
            ctrl: 'SelectLeaderCtrl',
            data: {dept: m}
        }).then(function (resp) {
            resp['opt'] = 1;
            Dept.update({id: m.id}, resp).$promise.then(function (resp) {
                Dlg.s('设置成功!');
                vm.tableReload();
            }, function () {
                Dlg.e('设置失败!');
            });
        });
    }

    function member(m) {
        Dlg.show({
            template: 'templates/MemberRecordDlg.html',
            ctrl: 'MemberCtrl',
            data: {dept: m},
            size: 'lg'
        }).then(function () {
            vm.tableReload();
        });
    }
}

angular.module('c.c').controller('MemberCtrl',
    function ($scope, $uibModalInstance, $filter, NgTableParams, dialogs, toaster, F, UserDept, data) {
        $scope.dept = data.dept;

        $scope.cols = [
            {title: '姓名', field: 'name', show: true}, //0
            {title: '胸牌号', field: 'username', show: true}, //0
            {title: '科室内职务', field: 'post', show: true}, //6
            {title: '是否主科室', field: 'is_main', show: true}, //6
            {title: '进入时间', field: 'entry_time', show: true}, //6
            {title: '排序', field: 'sorting', show: true} //6
        ];
        $scope.hideFilter = true;

        $scope.tableParams = new NgTableParams({page: 1, count: 30}, {
            counts: [30, 50, 100],
            total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 2;  //INDEX_MEMBERS_IN_DEPT
                url['dept_id'] = data.dept.id;
                url['need_users'] = true;
                UserDept.query(url, function (resp) {
                    params.total(resp.total);
                    var members = [];
                    angular.forEach(resp.users, function (m) {
                        m.is_main = m.is_main == '1';
                    });
                    angular.forEach(resp.members, function (m) {
                        members.push({id: m.user_id});
                    });
                    $scope.members = members;
                    $defer.resolve(resp.users);
                });
            }
        });

        $scope.add = function () {
            dialogs.create('templates/AddMemberDlg.html', 'AddMemberCtrl',
                {members: $scope.members}, { size: 'md'}).result.then(function (params) {
                    params['dept_id'] = data.dept.id;
                    UserDept.save(params).$promise.then(function (resp) {
                        toaster.success('添加成功!');
                        $scope.tableParams.reload();
                    }, function () {
                        toaster.error('添加失败!');
                    });
                });
        };

        $scope.edit = function (user) {
            dialogs.create('templates/AddMemberDlg.html', 'AddMemberCtrl',
                {user: user}, {size: 'md'}).result.then(function (params) {
                params['dept_id'] = data.dept.id;
                params['opt'] = 1;
                UserDept.update({id: user.id}, params).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('修改成功!');
                            $scope.tableParams.reload();
                            break;
                        case 1:
                            toaster.warning('员工必须拥有一个主科室!');
                            break;
                    }
                }, function () {
                    toaster.error('修改失败!');
                });
            });
        };

        $scope.leave = function (user) {
            dialogs.create('templates/LeaveMemberDlg.html', 'LeaveMemberCtrl',
                {user: user, dept: data.dept}, {size: 'md'}).result.then(function (params) {
                params['opt'] = 2;
                UserDept.update({id: user.id}, params).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('科室转出成功!');
                            $scope.tableParams.reload();
                            break;
                        case 1:
                            toaster.warning('员工必须拥有一个主科室!');
                            break;
                    }
                }, function () {
                    toaster.error('科室转出失败!');
                });
            });
        };

        $scope.transfer = function (user) {
            dialogs.create('templates/transMemberDlg.html', 'TransMemberCtrl',
                {user: user, dept: data.dept}, {size: 'md'}).result.then(function (params) {
                params['opt'] = 3;
                UserDept.update({id: user.id}, params).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('转科成功!');
                            $scope.tableParams.reload();
                            break;
                        case 1:
                            toaster.warning('该员工已经在目标科室了!');
                            break;
                    }
                }, function () {
                    toaster.error('转科失败!');
                });
            });
        };

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c').controller('LeaveMemberCtrl',
    function ($scope, $uibModalInstance, $filter, dialogs, toaster, F, data) {
        $scope.m = {leave_time: new Date()};
        $scope.user = data.user;
        $scope.dept = data.dept;

        $scope.dateOptions = {
            minDate: new Date(1920, 0, 1),
            //maxDate: new Date(),
            initDate: new Date()
        };

        $scope.ok = function (m) {
            if ($scope.u_form.$valid) {
                var p = {};
                p['leave_time'] = $filter('date')(m.leave_time, 'yyyy-MM-dd');
                $uibModalInstance.close(p);
            } else {
                toaster.warning('表单中有错误!');
                $scope.u_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c').controller('AddMemberCtrl',
    function ($scope, $uibModalInstance, $filter, dialogs, toaster, uibDateParser, F, data) {

        if (data.user) {
            $scope.$edit = true;
            var user = data.user;
            $scope.m = {
                user: {id: user.user_id, name: user.name}, is_main: user.is_main,
                entry_time: uibDateParser.parse(user.entry_time, 'yyyy-MM-dd'), post: user.post, sorting: user.sorting
            };
        } else {
            $scope.m = {is_main: false, entry_time: new Date(), sorting: 100};
            $scope.members = data.members;
        }

        $scope.dateOptions = {
            minDate: new Date(1920, 0, 1),
            maxDate: new Date(),
            initDate: new Date()
        };

        $scope.ok = function (m) {
            if (m.user == null) {
                toaster.warning('成员未选择!');
            } else if ($scope.u_form.$valid) {
                var p = {};
                p['user_id'] = m.user.id;
                p['post'] = m.post;
                p['entry_time'] = $filter('date')(m.entry_time, 'yyyy-MM-dd');
                p['is_main'] = m.is_main;
                p['sorting'] = m.sorting;
                $uibModalInstance.close(p);
            } else {
                toaster.warning('表单中有错误!');
                $scope.u_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c').controller('SelectLeaderCtrl',
    function ($scope, $uibModalInstance, $filter, dialogs, toaster, F, User, data) {
        $scope.dept = {
            name: data.dept.name,
            leader: data.dept.leader, /*nurse_leader: data.dept.nurse_leader,*/
            hospital_leader: data.dept.hospital_leader, mail_recipient: data.dept.mail_recipient,
            assistant: data.dept.assistant,
            attendance_reporter: data.dept.attendance_reporter
        };

        User.query({opt: 3, dept_id: data.dept.id}, function (resp) {
            $scope.users = resp.users;
            $scope.users.splice(0, 0, {id: 0, name: '空缺'});
            if ($scope.dept.leader == null) $scope.dept.leader = $scope.users[0];
            //if ($scope.dept.nurse_leader == null) $scope.dept.nurse_leader = $scope.users[0];
            if ($scope.dept.hospital_leader == null) $scope.dept.hospital_leader = $scope.users[0];
            if ($scope.dept.mail_recipient == null) $scope.dept.mail_recipient = $scope.users[0];
            if ($scope.dept.assistant == null) $scope.dept.assistant = $scope.users[0];
            if ($scope.dept.attendance_reporter == null) $scope.dept.attendance_reporter = $scope.users[0];
        });

        $scope.ok = function (dept) {
            if ($scope.u_form.$valid) {
                var params = {
                    mail_recipient_id: dept.mail_recipient.id,
                    assistant_id: dept.assistant.id
                };

                if (dept.leader == null || dept.leader.id == 0) {
                    params.leader_id = null;
                } else {
                    params.leader_id = dept.leader.id;
                }

                if (dept.attendance_reporter == null || dept.attendance_reporter.id == 0) {
                    params.attendance_reporter_id = null;
                } else {
                    params.attendance_reporter_id = dept.attendance_reporter.id;
                }

                if (dept.hospital_leader == null || dept.hospital_leader.id == 0) {
                    params.hospital_leader_id = null;
                } else {
                    params.hospital_leader_id = dept.hospital_leader.id;
                }

                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.u_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });


(function () {
    'use strict';

    angular.module('c.c')
        .controller('PersonnelRoundsCtrl', PersonnelRoundsCtrl)


    ;
    /** @ngInject */
    function PersonnelRoundsCtrl($scope, UIHelper, $rootScope, $stateParams) {
        var vm = $scope;
        UIHelper.loadTabs(vm, $stateParams, $rootScope);
    }
})();

(function () {
    'use strict';

    angular.module('c.d')
        .controller('UserInfoCtrl', UserInfoCtrl);

    /** @ngInject */
    function UserInfoCtrl($scope, $q, Dlg, User, UserOnType, ArrayHelper, Table, NewUser, FileHelper) {
        var vm = $scope;

        var options, hideOpt = false;
        var eduBgs = ArrayHelper.get('edu_bg_list');
        var eduBgOpts = Table.getNgTableOpts(eduBgs);
        var enLvs = ArrayHelper.get('eg_lv_list');
        var posts = ArrayHelper.get('posts');
        var enLvOpts = Table.getNgTableOpts(enLvs);
        var yesNoOpts = Table.getNgTableOpts(ArrayHelper.get('yesNo'));
        var postOpts = Table.getNgTableOpts(ArrayHelper.get('posts'));
        var confirms = User.getConfirms();
        var checker = null;
        vm.visibleOptions = [
            {title: '基本信息', value: 0x01},
            {title: '账户信息', value: 0x02},
            {title: '教育背景', value: 0x04},
            {title: '联系方式', value: 0x08},
            {title: '工作相关', value: 0x10},
            //{divider: true},
            {title: '全部信息', value: 0xff}
        ];
        vm.optionSelectedFn = optionSelectedFn;
        vm.exportDn = exportDn;
        vm.edit = edit;
        vm.changeType = changeType;
        vm.changeRecord = changeRecord;
        vm.kpi = kpi;
        vm.changePwd = changePwd;
        vm.changeUsername = changeUsername;
        vm.remove = remove;
        vm.transfer = transfer;
        vm.passChecked = passChecked;
        vm.clearWxBind = clearWxBind;
        vm.initOption = initOption;
        vm.option = {title: '基本信息', value: 1};
        vm.plaits = [
            {id: 1, name: '上锦'},
            {id: 2, name: '华西派驻'},
            {id: 3, name: '附二院派驻'},
            {id: 4, name: '院外人员'}
        ];
        vm.titleLeaves = NewUser.getTitleLevel();
        vm.exportNoBind = exportNoBind;


        init();

        function init() {
            $q.all([
                NewUser.query({op: 'UserOptions'}).$promise
            ]).then(function (respArray) {
                vm.titles = respArray[0].items.titles;
                vm.statuses = respArray[0].items.statuses;
                vm.types = respArray[0].items.types;
                vm.nations = respArray[0].items.nations;
                vm.political_statuses = respArray[0].items.political_statuses;
                setupOption();
                Table.load(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        item.edu_bg = ArrayHelper.getItem(item.edu_bg, eduBgs);
                        item.en_lv = ArrayHelper.getItem(item.en_lv, enLvs);
                        item.post = ArrayHelper.getItem(item.post, posts);
                        item.confirm_state = ArrayHelper.getItem(item.confirm_state, confirms);
                        item.plait = ArrayHelper.getItem(item.plait, vm.plaits);
                        item.title_level = ArrayHelper.getItem(item.title_level, vm.titleLeaves);
                    });
                });
                optionSelectedFn(vm.option);

                checker = Table.loadMultiSelectedFn(vm);
            })
        }

        function exportNoBind() {
            FileHelper.dnExcel('api/v1/user/users/exportNoBind', {}, '未绑定员工名单.xls', function () {
                Dlg.s('导出成功');
            })
        }

        function initOption(hide) {
            hideOpt = hide;
        }

        function setupOption() {
            options = {
                service: NewUser,
                params: {op: 'personnelInfo'},
                optInFront: true,
                optColWidth: Table._3_BTN,
                sorting: {created_at: 'asc'},
                count: 15,
                counts: [15, 30, 50],
                hideOpt: hideOpt,
                cols: [
                    {
                        title: '姓名',
                        filter: {name: 'text'},
                        field: 'name',
                        width: 135,
                        type: 0xff
                    },
                    { //1
                        title: '主科室',
                        filter: {main_dept: 'text'},
                        field: 'main_dept',
                        type: 0x01
                    },
                    // { //2
                    //     title: '是否有照片',
                    //     filter: {photo: 'select'},
                    //     data: yesNoOpts,
                    //     field: 'photo',
                    //     type: 0x01
                    // },
                    { //2
                        title: '胸牌号',
                        filter: {username: 'text'},
                        field: 'username',
                        type: 0x01
                    },
                    { //2
                        title: '确认状态',
                        filter: {confirm_state: 'select'},
                        data: Table.getNgTableOpts(confirms),
                        field: 'confirm_state',
                        type: 0x01
                    },
                    // { //5
                    //     title: '籍贯',
                    //     field: 'native_place',
                    //     filter: {native_place: 'text'},
                    //     type: 0x01
                    // },
                    // { //4
                    //     title: '民族',
                    //     field: 'nation_id',
                    //     filter: {nation_id: 'select'},
                    //     data: Table.getNgTableOpts(vm.nations),
                    //     type: 0x01
                    // },
                    { //23
                        title: '类别',
                        filter: {type_id: 'select'},
                        data: Table.getNgTableOpts(vm.types),
                        field: 'type_id', type: 0x01
                    },
                    /*账户信息*/
                    {title: '邮箱', sortable: 'email', filter: {email: 'text'}, field: 'email', type: 0x02},//8

                    /*教育背景*/
                    { //9
                        title: '毕业学校',
                        filter: {graduate_school: 'text'},
                        field: 'graduate_school',
                        width: 200,
                        type: 0x04
                    },
                    {  //10
                        title: '政治面貌',
                        filter: {political_status_id: 'select'},
                        field: 'political_status_id',
                        width: 120,
                        data: Table.getNgTableOpts(vm.political_statuses),
                        type: 0x04
                    },
                    {  //12
                        title: '学历',
                        filter: {edu_bg: 'select'},
                        data: eduBgOpts,
                        field: 'edu_bg',
                        type: 0x04
                    },
                    {
                        title: '学位',
                        filter: {degree: 'text'},
                        field: 'degree',
                        width: 140,
                        type: 0x04
                    },//13
                    { //14
                        title: '英语等级',
                        filter: {en_lv: 'select'},
                        data: enLvOpts,
                        field: 'en_lv',
                        type: 0x04
                    },

                    /* 联系方式 */
                    {title: '手机', filter: {phone: 'text'}, field: 'phone', type: 0x08}, //15
                    {title: '手机集团小号', filter: {cornet: 'text'}, field: 'cornet', type: 0x08},//16
                    {title: '备用手机', filter: {phone2: 'text'}, field: 'phone2', type: 0x08},//17
                    {//18
                        title: '办公室电话',
                        filter: {office_phone: 'text'},
                        field: 'office_phone',
                        type: 0x08
                    },
                    {//19
                        title: '办公室小号',
                        filter: {office_cornet: 'text'},
                        field: 'office_cornet',
                        type: 0x08
                    },

                    {title: 'QQ', filter: {qq: 'text'}, field: 'qq', type: 0x08},//20
                    {title: '联系地址', filter: {address: 'text'}, field: 'address', type: 0x08},//21

                    /* 工作相关 */
                    { //23
                        title: '编制大类',
                        filter: {plait: 'select'},
                        data: Table.getNgTableOpts(vm.plaits),
                        field: 'plait', type: 0x10
                    },
                    { //22
                        title: '编制类型',
                        filter: {status_id: 'select'},
                        field: 'status_id',
                        data: Table.getNgTableOpts(vm.statuses),
                        type: 0x10
                    },
                    // { //23
                    //     title: '类别',
                    //     filter: {type_id: 'select'},
                    //     data: Table.getNgTableOpts(vm.types),
                    //     field: 'type_id', type: 0x10
                    // },
                    { //24
                        title: '参加工作时间',
                        filter: {started_work: 'date_range'},
                        field: 'started_work',
                        type: 0x10
                    },
                    { //25
                        title: '入职时间',
                        filter: {entry_time: 'date_range'},
                        field: 'entry_time',
                        type: 0x10
                    },
                    { //27
                        title: '中层以上干部',
                        filter: {is_cadre: 'select'},
                        data: yesNoOpts,
                        field: 'is_cadre', type: 0x10
                    },
                    { //27
                        title: '职称等级',
                        filter: {title_level: 'select'},
                        data: Table.getNgTableOpts(vm.titleLeaves),
                        field: 'title_level', type: 0x10
                    },
                    { //27
                        title: '职称',
                        filter: {title_id: 'select'},
                        data: Table.getNgTableOpts(vm.titles),
                        field: 'title', type: 0x10
                    },
                    { //27
                        title: '职务',
                        filter: {post: 'select'},
                        data: postOpts,
                        field: 'post', type: 0x10
                    }
                ]
            };
        }

        function optionSelectedFn(option) {
            vm.option = option;
            angular.forEach(vm.cols, function (col) {
                if (col.type & option.value) {
                    col.show = true;
                } else {
                    col.show = false;
                }
            });
        }

        function exportDn() {
            Dlg.show({
                template: 'templates/export/ExportUserInfoDlg.html',
                ctrl: 'ExportUserInfoDlgCtrl',
                data: {}
            }).then(function () {
                Dlg.s('用户信息导出成功!');
            })
        }

        function edit(user) {
            var pa = {
                user_id: user.id, sys_edit: true, confirm_state: '2',
                title: '修改用户信息'
            };
            if (user.confirm_state.id > 2) {
                pa.title = '查看注册用户信息';
                pa.confirm_state = user.confirm_state.id;
            }
            Dlg.show({
                template: 'templates/PersonnelUserDlg.html',
                ctrl: 'PersonnelUserEditCtrl',
                data: pa,
                size: 'lg'
            }).then(function () {
                if (user.id == $scope.account.id) {
                    $scope.account.confirm_state = 2; //2表示人事科已确认
                }
                vm.tableReload();
            });
        }

        //修改编制
        function changeType(user) {
            Dlg.show({
                template: 'templates/changeOnTypeDlg.html',
                ctrl: 'UserChangeTypeCtrl',
                data: {user: user, statuses: vm.statuses}
            }).then(function (resp) {
                UserOnType.save(resp).$promise.then(function () {
                    Dlg.s('用户编制信息修改成功!');
                    vm.tableReload();
                }, function () {
                    Dlg.e('用户编制信息修改失败!');
                });

            });
        }

        //查看编制修改记录
        function changeRecord(user) {
            Dlg.show({
                template: 'templates/changeTypeRecord.html',
                ctrl: 'ChangeTypeRecordCtrl',
                data: {user: user}
            });
        }

        //查看绩效系数记录
        function kpi(user) {
            Dlg.show({
                template: 'templates/kpiRecord.html',
                ctrl: 'KpiRecordCtrl',
                data: {user: user}
            });
        }

        function changePwd(user) {
            Dlg.show({
                template: 'templates/changePassword.html',
                ctrl: 'changePwdCtrl',
                data: {user: user}
            }).then(function () {
                vm.tableReload();
            });
        }

        function changeUsername(user) {
            Dlg.show({
                template: 'templates/changeUsername.html',
                ctrl: 'changeUsernameCtrl',
                data: {user: user}
            }).then(function () {
                vm.tableReload();
            });
        }

        function remove(user) {
            Dlg.confirm('确定要删除名为<strong>' + user.name + '</strong>的员工记录吗？', function (resp) {
                User.delete({id: user.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s('员工记录删除成功!');
                            break;
                        case 1:
                            Dlg.w('该员工属于科室成员,无法直接删除');
                            break;
                    }
                    vm.tableReload();
                }, function (error) {
                    Dlg.e('员工记录删除失败!');
                });
            }, '删除员工记录');
        }

        function transfer(user) {
            Dlg.show({
                template: 'templates/dept_record_dlg.html',
                ctrl: 'DeptRecordDlgCtrl',
                data: {user: user, hideOpt: false},
                size: 'lg'
            });
        }

        function clearWxBind(m) {
            NewUser.update({id: m.id}, {
                op: 'clear_wx_bind'
            }).$promise.then(function (resp) {
                Dlg.s(resp.msg);
                vm.tableReload();
            }, function (error) {
                Dlg.e(error.msg);
            });
        }

        function passChecked() {
            var items = checker.getChecked();
            var userIds = [];
            var count = items.length;
            if (count === 0) {
                checker.clearChecked();
                Dlg.w("请至少选中一个待处理申请");
                return;
            }
            var defer = $q.defer();
            vm.tableParams.settings().$loading = true;
            angular.forEach(items, function (item) {
                userIds.push(item.id);
            });
            var pa = {
                op: 'UserMsg',
                confirm_state: 2,
                userIds: userIds
            };
            NewUser.batchConfirm(pa).$promise.then(function (resp) {
                Dlg.s(resp.msg);
            }, function (error) {
                Dlg.s("信息确认失败");
            });
            defer.resolve();
            checker.clearChecked();
            vm.tableReload();
            return defer.promise;
        }
    }

})();

angular.module('c.c')
    .controller('ExportUserInfoDlgCtrl', function ExportUserInfoDlgCtrl($uibModalInstance, ArrayHelper,
                                                                        User, FileHelper, NewUser) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.m = {is_cadre: 0};
        vm.plaits = [
            {id: 1, name: '上锦'},
            {id: 2, name: '华西派驻'},
            {id: 3, name: '附二院派驻'},
            {id: 4, name: '院外人员'}
        ];
        vm.political_status = NewUser.getPoliticalStatus();

        init();


        function init() {
            User.get({id: 0}).$promise.then(function (resp) {
                vm.depts = resp.depts;
                if (vm.depts && vm.depts.length > 0) {
                    vm.depts.splice(0, 0, {name: '全部科室'});
                    vm.m.dept = vm.depts[0];
                }
                vm.types = resp.types;
                vm.edu_bgs = NewUser.getEduBgList();
                vm.degree_types = ArrayHelper.get('degree_types');
            })
        }

        function ok(m) {
            var pa = {
                dept_id: m.dept ? m.dept.id : undefined,
                // plait: m.plait ? m.plait.id : undefined,
                // type_id: m.type ? m.type.id : undefined,
                is_cadre: m.is_cadre,
                phoneNull: m.phoneNull,
                not_confirm: m.not_confirm,
                plaits: [],
                types: [],
                edu_bgs: [],
                political_status: [],
                degrees: []
            };
            angular.forEach(m.plait, function (plait) {
                pa.plaits.push(plait.id)
            });
            angular.forEach(m.type, function (type) {
                pa.types.push(type.id)
            });
            angular.forEach(m.edu_bg, function (edu_bg) {
                pa.edu_bgs.push(edu_bg.id)
            });

            angular.forEach(m.political_status, function (ps) {
                pa.political_status.push(ps.id)
            });

            angular.forEach(m.degree_type, function (type) {
                angular.forEach(User.getDegrees(type.id), function (d) {
                    pa.degrees.push(d.name)
                });
            });

            FileHelper.dnExcel(NewUser.urls.EXPORT_USER_INFO,
                pa, '员工信息表.xls', function () {
                    vm.close();
                });
        }
    });

angular.module('c.c')
    .controller('UserChangeTypeCtrl', function ($scope, $uibModalInstance, toaster, User, data) {
        var user = data.user;
        $scope.statuses = data.statuses;
        $scope.user = {id: user.id, username: user.username, status: user.status, time: new Date()};
        $scope.ok = function (user) {
            if ($scope.otype_form.$valid) {
                var pa = {};
                pa['username'] = user.username;
                pa['status_id'] = user.status.id;
                pa['user_id'] = user.id;
                pa['time'] = user.time;
                $uibModalInstance.close(pa);
            } else {
                toaster.warning('表单中有错误!');
                $scope.otype_form.submitted = true;
            }
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c')
    .controller('ChangeTypeRecordCtrl', function ($scope, $uibModalInstance, toaster, NgTableParams, UserOnType, Table, F, $filter, data) {
        $scope.user = data.user;

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [5, 10], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['user_id'] = data.user.id;
                Table.query(UserOnType, url, $defer, params, 'onTypes');
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c')
    .controller('KpiRecordCtrl', function ($scope, $uibModalInstance, toaster, NgTableParams, UserKpi, dialogs, data) {
        $scope.user = data.user;

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [5, 10], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['user_id'] = data.user.id;
                url['opt'] = 2;
                UserKpi.query(url, function (data) {
                    params.total(data.total);
                    $defer.resolve(data.records);
                });
            }
        });

        $scope.add_kpi = function (user) {              //人事科对人员进行评估或直接输入绩效系数
            dialogs.create('add_kpi.html', 'AddKpiCtrl',
                {user: user}, {

                    size: 'md'
                }).result.then(function (pa) {
                if (pa) {
                    UserKpi.save(pa).$promise.then(function () {
                        toaster.success('用户绩效系数添加成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('用户绩效系数添加失败!');
                    });
                } else {
                    $scope.tableReload();
                }
            });
        };

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c')
    .controller('changePwdCtrl', function ($scope, $uibModalInstance, Dlg, data, NewUser,
                                           FormHelper, $q) {
        var vm = this;
        vm.m = data.user;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        function ok(m) {
            var defer = $q.defer();
            if (!vm.password_form.$valid) {
                FormHelper.handleError('#password_form', vm.password_form);
                defer.reject();
            } else {
                var pa = {
                    password: m.password,
                    op: 'password'
                };
                NewUser.update({id: m.id}, pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function (error) {
                    Dlg.e(error.msg);
                });
            }
            defer.resolve();

            return defer.promise;
        }
    });

angular.module('c.c')
    .controller('changeUsernameCtrl', function ($scope, $uibModalInstance, Dlg, data, NewUser,
                                                FormHelper, $q) {
        var vm = this;
        vm.m = data.user;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;


        $scope.$watch('vm.m.username', checkIsPhone);

        function checkIsPhone() {
            var invalid, user = vm.m;
            vm.username_form.username.$setValidity('isPhone', true);

            if (!user.username) return;

            invalid = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[389])\d{8}$/.test(user.username);
            vm.username_form.username.$setValidity('isPhone', !invalid);
            if (invalid) return;
        }

        function ok(m) {
            var defer = $q.defer();
            if (!vm.username_form.$valid) {
                FormHelper.handleError('#username_form', vm.username_form);
                defer.reject();
            } else {
                var pa = {
                    username: m.username,
                    op: 'username'
                };
                NewUser.update({id: m.id}, pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function (error) {
                    Dlg.e(error.data.msg);
                });
            }
            defer.resolve();

            return defer.promise;
        }
    });

angular.module('c.c')
    .controller('AddKpiCtrl', function ($scope, $uibModalInstance, toaster, User, dialogs, UserKpi, data) {
        var user = data.user;

        $scope.user_kpi = {direct: '1'};
        $scope.ok = function (user_kpi) {
            if (user_kpi.direct == 1) {
                if (!user_kpi.real_kpi) {
                    toaster.warning('请输入员工绩效系数!');
                } else {
                    var pa = {};
                    pa['user_id'] = user.id;
                    pa['real_kpi'] = user_kpi.real_kpi;
                    $uibModalInstance.close(pa);
                }
            } else {
                $scope.cancel();
            }
        };

        $scope.kpi = function () {
            dialogs.create('templates/kpi/user_kpi.html', 'UserKpiCtrl', {
                record: {user_id: user.id}
            }, {
                size: 'md'
            }).result.then(function (kpi) {
                UserKpi.save(kpi).$promise.then(function () {
                    toaster.success('员工绩效系数添加成功!');
                    $uibModalInstance.close();
                }, function () {
                    toaster.error('员工绩效系数添加失败!');
                });
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

angular.module('c.c')
    .controller('PersonnelUserEditCtrl',
        function ($scope, $uibModalInstance, ArrayHelper, NewUser, UserDept,
                  User, data, $q, Dlg, FormHelper, JobTitle, DateHelper, $http) {
            var vm = this;
            vm.cancel = $uibModalInstance.dismiss;
            vm.title = data.title;
            if (data.sys_edit) {
                vm.reg_stage = true;
            }

            vm.confirm_state = data.confirm_state;

            vm.annualTip = false;
            vm.leaveRule = false;
            vm.resetItem = [];
            vm.watchCount = 0;

            // vm.sexes = ArrayHelper.get('sexes');
            vm.sexes = [
                {id: 1, name: '男'},
                {id: 0, name: '女'}
            ];
            vm.edu_bgs = ArrayHelper.get('edu_bg_list');
            vm.degree_types = ArrayHelper.get('degree_types');
            vm.en_lvs = ArrayHelper.get('eg_lv_list');
            // vm.titles = ArrayHelper.get('titles');
            vm.posts = ArrayHelper.get('posts');
            vm.titleLeaves = NewUser.getTitleLevel();

            var username_regex_list = [
                /^\d{4,5}$/,  //正式员工
                /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/,  //试用实习均使用手机号注册
            ];
            vm.username_regex = username_regex_list[0];
            vm.dateOptions = {
                minDate: new Date(1920, 0, 1),
                maxDate: new Date(),
                initDate: new Date()
            };
            vm.dealDateOptions = {
                minDate: new Date(1920, 0, 1),
                maxDate: new Date(2050, 0, 1),
                initDate: new Date()
            };
            vm.plaits = [
                {id: 1, name: '上锦'},
                {id: 2, name: '华西派驻'},
                {id: 3, name: '附二院派驻'},
                {id: 4, name: '院外人员'}
            ];
            vm.census = [
                {id: 1, name: '城镇'},
                {id: 2, name: '农村'}
            ];
            vm.degreeTypeSelectedFn = degreeTypeSelectedFn;
            vm.statusSelectedFn = statusSelectedFn;
            vm.plaitSelectedFn = plaitSelectedFn;
            vm.deptTypeFn = deptTypeFn;
            vm.titleGroupFn = titleGroupFn;
            vm.onTypeSelectedFn = onTypeSelectedFn;
            vm.addUserPhoto = addUserPhoto;
            vm.transfer = transfer;
            vm.makeLeaveDay = makeLeaveDay;
            vm.resetLeaveDay = resetLeaveDay;
            vm.leaveRuleShow = leaveRuleShow;
            vm.leaveTipShow = leaveTipShow;
            // vm.dayNumChange = dayNumChange;
            vm.ok = ok;

            init();


            function init() {
                vm.m = {};
                $q.all([
                    NewUser.get({id: data.user_id, op: 'all'}).$promise,
                    NewUser.query({op: 'UserOptions'}).$promise,
                    $http.get('/api/v1/leave/leaves/' + data.user_id, {params: {op: 'userAnnualLeave'}})
                ]).then(function (respArray) {
                    var user = respArray[0].item;
                    vm.types = respArray[1].items.types;
                    vm.statuses = respArray[1].items.statuses;
                    vm.standards = respArray[1].items.standards;

                    vm.nations = respArray[1].items.nations;
                    vm.political_statuses = respArray[1].items.political_statuses;
                    vm.depts = respArray[1].items.depts;

                    vm.titles = respArray[1].items.titles;
                    var jTypes = JobTitle.getTypes();
                    angular.forEach(vm.titles, function (title) {
                        title.type = ArrayHelper.getItem(title.type, jTypes);
                    });


                    user['is_cadre'] = user['is_cadre'] == '1';
                    user['sex'] = ArrayHelper.getItem(user['sex'], vm.sexes);
                    user['edu_bg'] = ArrayHelper.getItem(user['edu_bg'], vm.edu_bgs);
                    user['degree_type'] = User.getDegreeType(user['degree']);
                    vm.degrees = User.getDegrees(user['degree_type'].id);
                    user['degree'] = User.getDegree(user['degree'], user['degree_type'].id);
                    user['en_lv'] = ArrayHelper.getItem(user['en_lv'], vm.en_lvs);
                    // user['title'] = ArrayHelper.getItem(user['title_id'], vm.titles);
                    user['post'] = ArrayHelper.getItem(user['post'], vm.posts);
                    user['plait'] = ArrayHelper.getItem(user['plait'], vm.plaits);
                    user['census'] = ArrayHelper.getItem(user['census'], vm.census);
                    user['title_level'] = ArrayHelper.getItem(user['title_level'], vm.titleLeaves);
                    user['birthday'] = DateHelper.str2Date(user.birthday, 'yyyy-MM-dd');
                    user['entry_time'] = DateHelper.str2Date(user.entry_time, 'yyyy-MM-dd');
                    user['party_time'] = DateHelper.str2Date(user.party_time, 'yyyy-MM-dd');
                    user['deal_sign_time'] = DateHelper.str2Date(user.deal_sign_time);
                    user['deal_deadline'] = DateHelper.str2Date(user.deal_deadline);
                    user['deal_change_time'] = DateHelper.str2Date(user.deal_change_time);
                    user['started_work'] = DateHelper.str2Date(user.started_work);
                    user['major'] = user.major;
                    // if (user.leave_year) user['num'] = user.leave_year.num;
                    if (respArray[2].data.items[0]) {
                        user['annual_days'] = respArray[2].data.items[0].total;
                        user['num'] = respArray[2].data.items[0].num;
                        // user['teaching_num'] = respArray[2].data.items[0].teaching_num;
                    }
                    if (respArray[2].data.items[1]) user['next_year_day'] = respArray[2].data.items[1].total;
                    if (respArray[2].data.items) vm.resetItem = respArray[2].data.items;

                    if (user['type_id'] == 2 && user['nurse_seniority']) {
                        user['standard'] = ArrayHelper.getItem(user['nurse_seniority'].seniority_id, vm.standards);
                    } else {
                        user['standard'] = vm.standards[0];
                    }

                    if (user.plait.id == 1) {
                        user['seniority'] = user.seniority ? user.seniority : 0;
                    }

                    user['dept'] = ArrayHelper.getItem(user['dept_id'], vm.depts);
                    if (data.confirm_state) {
                        user['confirm_state'] = data.confirm_state;
                    }
                    vm.statusSelectedFn(user.status, user);
                    if (user.dept.name == '实习医生' || user.dept.name == '实习护士') {
                        vm.practice_stage = true;
                    }
                    vm.plaitSelectedFn(user.plait);
                    vm.user = user;
                    vm.m = user;

                    // $scope.$watch('vm.m.teaching_num', statTotalDay);
                    // $scope.$watch('vm.m.annual_days', statTotalDay);
                    $scope.$watch('vm.user.username', checkIsPhone);
                });
            }

            function statTotalDay() {
                var m = vm.m;
                if (!m.teaching_num || !m.annual_days) return;
                if (m.teaching_num > m.annual_days) {
                    m.annual_days = m.teaching_num;
                }
            }

            function leaveRuleShow() {
                vm.leaveRule = !vm.leaveRule;
            }

            function leaveTipShow() {
                vm.annualTip = false;
            }

            // $scope.$watch('vm.user.plait', leaveTimeChanged);
            // $scope.$watch('vm.user.status', leaveTimeChanged);
            // $scope.$watch('vm.user.title_level', leaveTimeChanged);
            // $scope.$watch('vm.user.entry_time', leaveTimeChanged);
            // $scope.$watch('vm.user.started_work', leaveTimeChanged);

            function checkIsPhone() {
                var invalid, user = vm.user;
                vm.Form.username.$setValidity('isPhone', true);

                if (!user.username) return;

                invalid = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[389])\d{8}$/.test(user.username);
                vm.Form.username.$setValidity('isPhone', !invalid);
                if (invalid) return;
            }

            function makeLeaveDay() {
                var m = vm.m;
                if (!m.plait) {
                    Dlg.w('请选择编制大类');
                } else if (!m.status) {
                    Dlg.w('请选择编制类型');
                } else if (!m.title_level) {
                    Dlg.w('请选择职称等级');
                } else if (!m.entry_time && m.plait.id == 1) { //上锦聘用必填进入上锦时间
                    Dlg.w('上锦聘用必填进入上锦时间！');
                } else if (!m.started_work && m.plait.id != 1 && m.plait.id != 4) { //派驻员工必填进入华西时间
                    Dlg.w('派驻员工必填进入华西时间！');
                } else if (m.plait.id == 1 && m.seniority == null) { //上锦聘用必填进入上锦时间
                    Dlg.w('上锦聘用必填社会工龄！');
                } else {
                    var pa = {
                        plait: m.plait.id,
                        status_id: m.status.id,
                        title_level: m.title_level.id,
                        entry_time: m.entry_time,
                        started_work: m.started_work,
                        is_cadre: m.is_cadre,
                        user_id: m.id,
                        seniority: m.seniority ? m.seniority : 0
                    };
                    $http.post('/api/v1/leave/leaves/makeLeaveDay', pa).success(function (resp) {
                        m.annual_days = resp.total_toYear;
                        m.next_year_day = resp.total_nextYear;
                        // if (resp.teaching_num > m.teaching_num) {
                        //     m.teaching_num = resp.teaching_num;
                        // }
                        vm.annualTip = true;
                        vm.entry_time = DateHelper.date2Str(m.entry_time);
                        vm.started_work = DateHelper.date2Str(m.started_work);
                    })
                }
            }

            function resetLeaveDay() {
                var m = vm.m;
                m.annual_days = vm.resetItem[0].total;
                m.next_year_day = vm.resetItem[1].total;
            }

            function leaveTimeChanged() {
                var m = vm.m;
                // console.log('m.status', m.status);
                // console.log('m.is_cadre', m.is_cadre);
                // console.log('m.title_level', m.title_level);
                // console.log('m.entry_time', m.entry_time);
                // console.log('m.started_work', m.started_work);
            }

            $scope.$watch('vm.user.id_card', function (newVal, oldVal) {
                var id_card = newVal;
                if (id_card != oldVal && id_card != '' && id_card != null) {
                    var native = id_card.substr(0, 6);
                    var birthday = id_card.substr(6, 8);
                    var sex = vm.sexes[(parseInt(id_card.substr(16, 1)) + 1) % 2];
                    vm.user.birthday = DateHelper.str2Date(birthday, 'yyyyMMdd');
                    vm.user.sex = sex;
                }
            });

            function transfer(m) {
                Dlg.show({
                    template: 'templates/transMemberDlg.html',
                    ctrl: 'PersonnelTransMemberCtrl',
                    data: {
                        id: m.id,
                        dept: m.depts[0]
                    }
                }).then(function (resp) {
                    resp['opt'] = 3;
                    UserDept.update({id: m.depts[0].user_depts_id}, resp).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                Dlg.s('转科成功!');
                                init();
                                break;
                            case 1:
                                Dlg.w('该员工已经在目标科室了!');
                                break;
                        }
                    }, function () {
                        Dlg.e('转科失败!');
                    });
                });
            }

            function degreeTypeSelectedFn(m) {
                vm.degrees = User.getDegrees(m.id);
                vm.user['degree'] = vm.degrees[0];
            }

            function plaitSelectedFn(plait) {
                vm.status = [];
                vm.defaultStatuses = angular.copy(vm.statuses);
                if (plait.id == 1) {
                    angular.forEach(vm.defaultStatuses, function (item) {
                        if (ArrayHelper.inArray(item.id, [15, 16, 17]) !== -1) {
                            vm.status.push(item);
                        }
                    });
                } else if (plait.id == 2) {
                    angular.forEach(vm.defaultStatuses, function (item) {
                        if (ArrayHelper.inArray(item.id, [1, 2, 5, 6, 8, 9, 10, 12, 13, 14, 23]) !== -1) {
                            vm.status.push(item);
                        }
                    });
                } else if (plait.id == 3) {
                    angular.forEach(vm.defaultStatuses, function (item) {
                        if (ArrayHelper.inArray(item.id, [5, 6, 7, 8, 9, 10]) !== -1) {
                            item.name = '附二院' + item.name;
                            vm.status.push(item);
                        }
                    });
                } else if (plait.id == 4) {
                    angular.forEach(vm.defaultStatuses, function (item) {
                        if (ArrayHelper.inArray(item.id, [18]) !== -1) {
                            vm.status.push(item);
                        }
                    });
                }
            }

            function statusSelectedFn(status, user) {
                if (status.id == 3 || status.id == 4 || status.id == 6) { //试用
                    vm.username_regex = username_regex_list[1];
                } else {
                    vm.username_regex = username_regex_list[0];
                }
            }

            function deptTypeFn(m) {
                if (m.type) {
                    return m.type.name;
                } else {
                    return '暂无科室类型';
                }
            }

            function titleGroupFn(t) {
                return t.type.name;
            }

            function onTypeSelectedFn(type, user) {

            }

            // function dayNumChange() {
            //     var valid = isNaN(vm.user.num) ? true : Number.isInteger(vm.user.num * 2);
            //     vm.Form.num.$setValidity('num', valid);
            //     vm.Form.num.$setValidity('not_zero', vm.user.num >= 0);
            // }

            function addUserPhoto(m) {
                Dlg.show({
                    template: 'pages/user/profile/userPhotoDlg.html',
                    ctrl: 'UserPhotoDlgCtrl',
                    data: {id: m.id}
                }).then(function (resp) {
                    m.photo = resp[0];
                    m.work_photo = resp[1];
                });
            }

            function saveAndExit(user) {
                var pa = {};
                //账户信息
                pa['username'] = user.username;

                //基本信息
                pa['name'] = user.name;
                if (user.id_card) pa['id_card'] = user.id_card;
                pa['census'] = user.census.id;
                if (user.sex) pa['sex'] = user.sex.id;
                if (user.birthday) pa['birthday'] = DateHelper.date2Str(user.birthday);
                if (user.nation) pa['nation_id'] = user.nation.id;
                if (user.native_place) pa['native_place'] = user.native_place;
                if (user.car_num1) pa['car_num1'] = user.car_num1;
                if (user.car_num2) pa['car_num2'] = user.car_num2;
                if (user.political_status) pa['political_status_id'] = user.political_status.id;

                //工作相关
                if (user.photo) pa['photo'] = user.photo;
                if (user.work_photo) pa['work_photo'] = user.work_photo;
                if (user.status) pa['status_id'] = user.status.id;
                if (user.type) pa['type_id'] = user.type.id;
                if (user.plait) pa['plait'] = user.plait.id;
                if (user.post_details) pa['post_details'] = user.post_details;
                // if(user.num) pa['num'] = user.num;
                // if (user.plait.id !== 1) {
                //     pa['annual_days'] = user.annual_days; //年假天数
                // } else {
                //     pa['annual_days'] = null; //年假天数
                // }
                if (user.type.id === 2) pa['standard'] = user.standard.id;

                //  主要科室...
                pa['is_cadre'] = user.is_cadre;
                if (user.entry_time) pa['entry_time'] = DateHelper.date2Str(user.entry_time);
                if (user.party_time) pa['party_time'] = DateHelper.date2Str(user.party_time);
                if (user.started_work) {
                    pa['started_work'] = DateHelper.date2Str(user.started_work);
                } else {
                    pa['started_work'] = null
                }
                if (user.deal_sign_time) pa['deal_sign_time'] = DateHelper.date2Str(user.deal_sign_time);
                if (user.deal_deadline) pa['deal_deadline'] = DateHelper.date2Str(user.deal_deadline);
                if (user.deal_change_time) pa['deal_change_time'] = DateHelper.date2Str(user.deal_change_time);
                if (user.renewal_num) pa['renewal_num'] = user.renewal_num;

                //教育背景
                if (user.graduate_school) pa['graduate_school'] = user.graduate_school;
                if (user.major) pa['major'] = user.major;
                if (user.edu_bg) pa['edu_bg'] = user.edu_bg.id;
                if (user.degree) pa['degree'] = user.degree.name;
                if (user.en_lv) pa['en_lv'] = user.en_lv.id;
                //联系方式
                if (user.phone) pa['phone'] = user.phone;
                if (user.cornet) pa['cornet'] = user.cornet;
                if (user.phone2) pa['phone2'] = user.phone2;
                if (user.office_phone) pa['office_phone'] = user.office_phone;
                if (user.email) pa['email'] = user.email;
                if (user.qq) pa['qq'] = user.qq;
                if (user.address) pa['address'] = user.address;

                pa['confirm_state'] = user.confirm_state;
                if (user.title) {
                    pa['title_id'] = user.title.id;
                }
                if (user.title_level) pa['title_level'] = user.title_level.id;
                if (user.post) {
                    pa['post'] = user.post.id;
                }

                pa['annual_days'] = user.annual_days;
                pa['next_year_day'] = user.next_year_day;
                // pa['teaching_num'] = user.teaching_num;
                //社会工龄
                if (user.plait.id == 1) {
                    pa['seniority'] = user.seniority;
                }
                //教学假
                // if (user.plait.id == 2 && (user.status.id == 1 || user.status.id == 2 || user.status.id == 6 || user.status.id == 13)) {
                //     pa['teaching_num'] = user.teaching_num;
                // }
                pa['op'] = 'UserMsg';

                NewUser.update({id: data.user_id}, pa).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }

            function ok(m) {
                var defer = $q.defer();
                if (!vm.Form.$valid) {
                    FormHelper.handleError('#Form', vm.Form);
                    defer.reject();
                } else if (!m.photo && !data.sys_edit) {
                    Dlg.confirm('用户须添加工作头像!', function () {
                        vm.addUserPhoto(m);
                    }, '提示');
                } else {
                    saveAndExit(m);
                }
                defer.resolve();

                return defer.promise;
            }
        });

angular.module('c.c')
    .controller('PersonnelTransMemberCtrl', function ($scope, $uibModalInstance, Dlg, $q, NewUser,
                                                      ArrayHelper, Dept, data, DateHelper) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;
        vm.dept = data.dept;

        vm.dateOptions = {
            minDate: new Date(1920, 0, 1),
            initDate: new Date()
        };

        init(data.id);

        function init(id) {
            $q.all([
                NewUser.get({id: id, op: 'all'}).$promise,
                Dept.query({opt: 4}).$promise
            ]).then(function (respArray) {
                vm.user = respArray[0].item;
                vm.depts = ArrayHelper.except(data.dept.id, respArray[1].depts);
                vm.m = {
                    leave_time: new Date(),
                    entry_time: new Date(),
                    post: respArray[0].item.post
                };
                vm.m['dept'] = vm.depts[0];
            });
        }

        function ok(m) {
            if (vm.u_form.$valid) {
                var p = {};
                p['leave_time'] = DateHelper.date2Str(m.leave_time, 'yyyy-MM-dd');
                p['user_id'] = vm.user.id;
                p['dept_id'] = m.dept.id;
                p['post'] = m.post;
                p['entry_time'] = DateHelper.date2Str(m.entry_time, 'yyyy-MM-dd');
                p['is_main'] = true;
                $uibModalInstance.close(p);
            } else {
                Dlg.w('表单中有错误!');
                vm.u_form.submitted = true;
            }
        }
    });
angular.module('c.c')
    .controller('UserLeaveCtrl', ['$scope', UserLeaveCtrl]);

function UserLeaveCtrl($scope) {

}


(function () {
    'use strict';

    angular.module('c.c')
        .controller('PersonnelUserRegTabCtrl', PersonnelUserRegTabCtrl)


    ;
    /** @ngInject */
    function PersonnelUserRegTabCtrl($scope, UIHelper, $stateParams, $rootScope) {
        var vm = $scope;
        UIHelper.loadTabs(vm, $stateParams, $rootScope);
    }
})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('ArticleCtrl', ArticleCtrl);

    /** @ngInject */
    function ArticleCtrl($stateParams, $http, $sce, C, FileHelper, WxHelper, deviceDetector, OS, Dlg) {
        var isNews = $stateParams.type === 'news';
        var vm = this;
        vm.download = download;


        init($stateParams.id);


        function init(id) {
            vm.ios = deviceDetector.os === OS.IOS;
            var path = isNews ? 'news/news' : 'bulletin/bulletins';
            $http.get('/api/v1/' + path + '/' + id).then(function (resp) {
                var article = resp.data;
                article.body = $sce.trustAsHtml(article.body);
                vm.article = article;
            });
        }

        function download(attachment) {
            if (WxHelper.isWechatBrowser()) {
                Dlg.show({
                    template: 'pages/attachmentDownloadDlg.html',
                    ctrl: 'attachmentDownloadDlgCtrl', data: {attachment: attachment}, size: 'sm'
                });
            } else {
                FileHelper.download1(C.URL.BULLETIN_DOWNLOAD, attachment);
            }
        }
    }

})();



(function () {
    'use strict';

    angular.module('c.c')
        .controller('CovidCtrl', CovidCtrl);

    /** @ngInject */
    function CovidCtrl(Api, $stateParams, $http, $sce, C, Auth, FileHelper, WxHelper, deviceDetector, OS) {
        var vm = this;

        init($stateParams.id);


        function init(id) {
            vm.ios = deviceDetector.os === OS.IOS;
            $http.get('api/v1/covid/covids', {
                params: {
                    op: 'preview',
                    id: id
                }
            }).then(function (resp) {
                vm.covid = resp.data.items[0];
                if (vm.covid) {
                    vm.covid.body = $sce.trustAsHtml(vm.covid.body);
                } else {
                    vm.error = '没有找到该疫情防控通知';
                }

            }, function (e) {
                vm.error = '没有找到该疫情防控通知';
            });
        }
    }

})();



(function () {
    'use strict';

    angular.module('c.c')
        .controller('EmailShowCtrl', EmailShowCtrl);

    /** @ngInject */
    function EmailShowCtrl($stateParams, $http, $sce, C, WxHelper, FileHelper, deviceDetector, OS, Dlg) {
        var vm = this;
        vm.download = download;


        init($stateParams.id);


        function init(id) {
            vm.ios = deviceDetector.os === OS.IOS;
            $http.get('/api/v1/emails/' + id).then(function (resp) {
                var m = resp.data.mail;
                m.body = $sce.trustAsHtml(m.body);
                vm.m = m;
            }, function (e) {
                vm.error = e.data.msg ? e.data.msg : '该邮件不存在或已被删除';
                Dlg.e(vm.error);
            });
        }

        function download(attachment) {
            if (WxHelper.isWechatBrowser()) {
                Dlg.show({
                    template: 'pages/attachmentDownloadDlg.html',
                    ctrl: 'attachmentDownloadDlgCtrl', data: {attachment: attachment}, size: 'sm'
                });
            } else {
                FileHelper.download1(C.URL.MAIL_DOWNLOAD, attachment);
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
    .controller('MeetingPreviewCtrl', MeetingPreviewCtrl);

    /** @ngInject */
    function MeetingPreviewCtrl($stateParams, $http, $sce, C, F, FileHelper, WxHelper, deviceDetector, OS, Dlg) {
        var vm = this;
        vm.download = download;


        init($stateParams.id);


        function init(id) {
            vm.ios = deviceDetector.os === OS.IOS;
            $http.get('/api/v1/meetings/' + id).then(function (resp) {
                var meeting = resp.data.meeting;
                meeting.content = $sce.trustAsHtml(meeting.content);
                meeting.time_range = meeting.start_time.substr(0, 16) + ' - ' + meeting.end_time.substr(11, 5);
                vm.meeting = meeting;
                if (vm.meeting.moderator != null) {
                    var index = F.indexOfKey(vm.meeting.moderator.id, vm.meeting.attendees);
                    if (index >= 0) {
                        vm.meeting.attendees.splice(index, 1);
                    }
                }
            }, function (e) {
                vm.error = e.data.msg ? e.data.msg : '该会议不存在或者已删除';
                //vm.error = e.data.msg ? e.data.msg : '该会议相关信息已被修改，请重新登录OA会议模块查看';

                Dlg.e(vm.error);
            });
        }

        function download(attachment) {
            if (WxHelper.isWechatBrowser()) {
                Dlg.show({
                    template: 'pages/attachmentDownloadDlg.html',
                    ctrl: 'attachmentDownloadDlgCtrl', data: {attachment: attachment}, size: 'sm'
                });
            } else {
                FileHelper.download1(C.URL.MEETING_DOWNLOAD, attachment);
            }
        }
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .controller('MissionPreviewCtrl', MissionPreviewCtrl);

    /** @ngInject */
    function MissionPreviewCtrl($stateParams, $http, $sce, C, FileHelper, WxHelper, deviceDetector, OS, Dlg) {

        var vm = this;
        vm.download = download;

        init($stateParams.id);

        function init(id) {
            vm.ios = deviceDetector.os === OS.IOS;
            $http.get('/api/v1/mission/missions/' + id).then(function (resp) {
                var mission = resp.data.mission;
                mission.content = $sce.trustAsHtml(mission.content);
                mission.time_range = mission.start_time.substr(0, 16) + ' - ' + mission.end_time.substr(0, 16);
                vm.mission = mission;
            }, function (e) {
                vm.error = e.data.msg ? e.data.msg : '该任务不存在或者已删除';
                Dlg.e(vm.error);
            });
        }

        function download(attachment) {
            if (WxHelper.isWechatBrowser()) {
                Dlg.show({
                    template: 'pages/attachmentDownloadDlg.html',
                    ctrl: 'attachmentDownloadDlgCtrl', data: {attachment: attachment}, size: 'sm'
                });
            } else {
                FileHelper.download1(C.URL.MISSION_DOWNLOAD, attachment);
            }
        }
    }

})();



(function () {
    'use strict';

    angular.module('c.c')
        .controller('ReportCtrl', ReportCtrl);

    /** @ngInject */
    function ReportCtrl($stateParams, $http, $sce, C, Dlg) {
        var vm = this;

        init($stateParams.id);


        function init(id) {
            $http.get('/api/v1/report/reports' + '/' + id).then(function (resp) {
                var m = resp.data;
                vm.m = m;
                Dlg.s(resp);
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('PreviewShowDlgCtrl', PreviewShowDlgCtrl);

    /** @ngInject */
    function PreviewShowDlgCtrl($uibModalInstance, $sce, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.url, data.name);


        function init(url, name) {
            vm.name = name;
            vm.url = $sce.trustAsResourceUrl(url);
        }
    }

})();

angular.module('c.c')
    .controller('appCfgCtrl', function ($scope, toaster, Setting, $filter, uibDateParser, F, dialogs, $ocLazyLoad) {
        $scope.dataSettings = ['reg_deadline_am', 'reg_deadline_pm', 'reg_deadline_night', 'reg_begin_am', 'reg_begin_pm',
            'reg_begin_nt'];
        $scope.reload = function () {
            Setting.query(function (resp) {
                var setting = {};
                angular.forEach(resp, function (s) {
                    setting[s.name] = s.value;
                    if (s.name == 'duty_count_disable') {
                        setting[s.name] = s.value == '1';
                    }
                    if (F.findItem(s.name, $scope.dataSettings) >= 0) {
                        setting[s.name] = uibDateParser.parse(s.value, "HH:mm");
                    }
                });
                $scope.setting = setting;
                $scope.backup = angular.copy(setting);
                $scope.params_diff = false;
            });
            $scope.tab = 1;
        };

        $scope.qrcode = function (m, type) {
            m.type = type;
            $ocLazyLoad.load(['qrCode']).then(function () {
                dialogs.create('templates/emergency/ea_qrcode.html', 'EAqrcodeCtrl', {m: m}, {
                    size: 'sm'
                });
            });
        };

        $scope.submit = function (setting) {
            var params = {};
            var params_check = $scope.params_check;
            for (var k in params_check) {
                params[k] = setting[k];
                if (F.findItem(k, $scope.dataSettings) >= 0) {
                    params[k] = $filter('date')(setting[k], "HH:mm");
                }
            }

            Setting.update({id: 0}, params).$promise.then(function (resp) {
                switch (resp.result) {
                    case 0:
                        toaster.success('应用配置修改成功!');
                        $scope.reload();
                        break;
                    case 1:
                        toaster.warning('应用配置修改失败,因为参数格式错误!');
                        break;
                }
            }, function () {
                toaster.error('应用配置修改失败!');
            });
        };

        $scope.reset = $scope.reload;
        $scope.reload();

        $scope.params_check = {};
        $scope.$watch('setting', function (newVal, oldVal, scope) {
            scope.params_diff = false;
            for (var k in newVal) {
                if (!angular.equals(newVal[k], scope.backup[k])) {
                    scope.params_check[k] = true;
                    scope.params_diff = true;
                } else {
                    delete scope.params_check[k];
                }
            }
        }, true);
    });





(function () {
    'use strict';

    angular.module('c.c')
        .controller('AuthorityCtrl', AuthorityCtrl)
        .controller('RoleUsersCtrl', RoleUsersCtrl)
        .controller('PermSetDlgCtrl', PermSetDlgCtrl)
        .controller('RoleAddDlgCtrl', RoleAddDlgCtrl)
    ;

    /** @ngInject */
    function AuthorityCtrl($scope, Dlg, Table, Role) {
        var vm = $scope;
        vm.maxProtectId = 2;
        vm.addEdit = addEdit;
        // vm.edit = edit;
        vm.roleUsers = roleUsers;
        vm.setPerms = setPerms;
        vm.remove = remove;

        init();

        function init() {
            var options = {
                service: Role,
                params: {op: 'sys'/*INDEX_ALL*/},
                optColWidth: Table._4_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {field: "name", title: "角色名称", filter: {name: "text"}},
                    {field: "description", title: "备注"}
                ]
            };

            Table.load(vm, options, function (resp) {
                vm.roles = [];
                angular.forEach(resp.items, function (i) {
                    vm.roles.push(i.name);
                })
            });
        }

        function addEdit(m) {
            var pa = {roles: vm.roles};
            if (m) {
                pa.id = m.id;
                pa.name = m.name;
            }
            Dlg.show({
                template: 'RoleAddDlg.html',
                ctrl: 'RoleAddDlgCtrl',
                data: pa
            }).then(function () {
                vm.tableReload();
            });
        }

        function remove(m) {
            Dlg.confirm('确定要删除名为<strong>' + m.name + '</strong>的角色吗？', function (resp) {
                Role.delete({id: m.id, op: 'sys'}).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '删除角色');
        }

        function setPerms(m) {
            Dlg.show({
                template: 'PermSetDlg.html',
                ctrl: 'PermSetDlgCtrl',
                data: {
                    role: m
                }
            }).then(function (params) {
                params['op'] = 'setPerms';
                Role.update({id: m.id}, params).$promise.then(function (success) {
                    Dlg.s(m.display_name + '权限设置成功!');
                }, function (error) {
                    Dlg.e(m.display_name + '权限设置失败!');
                });
            });
        }


        function roleUsers(m) {
            Dlg.show({
                template: 'RoleUsersDlg.html',
                ctrl: 'RoleUsersCtrl',
                data: {
                    role: m
                },
                size: 'lg'
            });
        }
    }

    /** @ngInject */
    function RoleUsersCtrl($scope, $uibModalInstance, Table, Dlg, User, Role, data) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.role = data.role;
        vm.add = add;
        vm.remove = remove;
        vm.members = [];


        init(data.role.id);

        function init(id) {
            var options = {
                service: User,
                params: {opt: 4/*INDEX_ALL*/, role_id: id},
                optColWidth: Table._1_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {field: "name", title: "姓名", filter: {name: "text"}},
                    {field: "username", title: "胸牌号", filter: {username: "text"}},
                    {field: "roles", title: "角色"}
                ]
            };

            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    vm.members.push(item.id);
                })
            });
        }

        function add() {
            Dlg.show({
                template: 'directives/form/user-selector/user_selector_dlg.html',
                ctrl: 'UserSelectCtrl',
                data: {
                    title: '添加' + data.role.name + '用户', multiSelect: true, existMembers: vm.members
                }
            }).then(function (members) {
                if (members.length > 0) {
                    var params = {};
                    params['op'] = 'attachUsers';
                    params['members'] = members;
                    //为角色添加用户
                    Role.update({id: data.role.id}, params).$promise.then(function (resp) {
                        Dlg.s('添加成功!');
                        vm.tableReload();
                    }, function (error) {
                        if (error.data) Dlg.e(error.data.msg);
                        else console.log('error', error);
                    });
                }
            });
        }

        function remove(user) {
            Dlg.confirm('确定要删除名为<strong>' + user.name + '</strong>的<strong>' + data.role.name + '</strong>角色吗？', function (resp) {
                var params = {};
                params['op'] = 'detachUsers';
                params['members'] = [{id: user.id}];
                Role.update({id: data.role.id}, params).$promise.then(function () {
                    Dlg.s('角色移除成功!');
                    vm.tableReload();
                }, function (error) {
                    if (error.data) Dlg.e(error.data.msg);
                    else console.log('error', error);
                });
            }, '去掉员工角色');
        }
    }

    /** @ngInject */
    function PermSetDlgCtrl($uibModalInstance, Permission, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.role = data.role;
        vm.setCheckedAll = setCheckedAll;
        vm.onChange = onChange;
        vm.ok = ok;
        vm.loading = true;

        var setParentOfChildren = function (node) {
            angular.forEach(node.children, function (child) {
                child.parent = node;
                if (child.children != null && child.children.length > 0) {
                    setParentOfChildren(child);
                }
            });
        };

        Permission.get({id: data.role.id}).$promise.then(function (data) {
            setParentOfChildren(data[1]);
            vm.data = data[1];
        }, function (error) {
        }).finally(function () {
            vm.loading = false;
        });

        function setCheckedAll(node, checked) {
            node.is_checked = checked;
            setCheckedChildren(node);
        }

        function setCheckedChildren(node) {
            if (node.children != null && node.children.length > 0) {
                angular.forEach(node.children, function (child) {
                    child.is_checked = node.is_checked;
                    setCheckedChildren(child);
                });
            }
        }

        function setCheckedAncestors(node) {
            if (node.parent) {
                if (node.is_checked) {
                    if (!node.parent.is_checked) {
                        node.parent.is_checked = node.is_checked;
                        setCheckedAncestors(node.parent);
                    }
                } else {
                    if (node.parent.is_checked) {
                        var allUnchecked = true;
                        var children = node.parent.children;
                        for (var i = 0; i < children.length; i++) {
                            if (children[i].is_checked) {
                                allUnchecked = false;
                                break;
                            }
                        }
                        if (allUnchecked) {
                            node.parent.is_checked = node.is_checked;
                            setCheckedAncestors(node.parent);
                        }
                    }
                }
            }
        }

        function onChange(node) {
            setCheckedChildren(node);
            setCheckedAncestors(node);
        }

        function ok(data) {
            var perms = [];
            function setPerms(node) {
                if (node.is_checked) {
                    perms.push({id: node.permission.id});
                }
                if (node.children != null && node.children.length > 0) {
                    angular.forEach(node.children, function (child) {
                        setPerms(child);
                    });
                }
            }
            setPerms(data);
            $uibModalInstance.close({permissions: perms});
        }
    }

    /** @ngInject */
    function RoleAddDlgCtrl($uibModalInstance, data, Dlg, Role, $q, FormHelper) {
        var vm = this;
        vm.roles = data.roles;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);

        function init(id) {
            if (id) {
                Role.get({id: id, op: 'sys'}, function (resp) {
                    vm.role = resp;
                });
            } else {
                vm.role = {};
            }
        }

        function ok(m) {
            var defer = $q.defer();
            if (!vm.Form.$valid) {
                FormHelper.handleError('#Form', vm.Form);
                defer.reject();
            } else {
                var pa = {
                    name: m.name,
                    display_name: m.name,
                    description: m.description
                };
                var promise;
                if (m.id) {
                    pa.op = 'edit';
                    promise = Role.update({id: m.id}, pa).$promise;
                } else {
                    pa.op = 'sys';
                    promise = Role.save(pa).$promise;
                }
                promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function (error) {
                    if (error.data) Dlg.e(error.data.msg);
                    else console.log('error', error);
                }).finally(function () {
                    defer.resolve();
                });
            }

            return defer.promise;
        }
    }


})();
angular.module('c.c')
    .controller('BasicCtrl', ['$scope', BasicCtrl]);

function BasicCtrl($scope) {

}


(function () {
    'use strict';

    angular.module('c.c')
        .controller('SysDeptCtrl', SysDeptCtrl);

    /** @ngInject */
    function SysDeptCtrl($scope, $stateParams, UIHelper) {
        UIHelper.loadTabs($scope, $stateParams);
    }

})();

angular.module('c.c')
    .controller('HelpCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams,
                                      HelpPage, HelpContent, Table) {
        $scope.cols = [
            {title: '标题', filter: {title: 'text'}, show: true}, //0
            {title: '链接', width: '55%', show: true}
        ];

        $scope.optColWidth = 73;
        $scope.tableParams = new NgTableParams({page: 1, count: 30, sorting: {sorting: 'asc'}}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                if (!$scope.pages) {
                    HelpPage.query(function (data) {
                        angular.forEach(data, function (page) {
                            page.items = [];
                        });
                        $scope.pages = data;
                        Table.getTableData(data, $defer, params, $filter);
                    });
                } else {
                    var data = $scope.pages;
                    Table.getTableData(data, $defer, params, $filter);
                }
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };

        $scope.tableReload = function () {
            $scope.pages = null;
            $scope.tableParams.reload();
        };

        $scope.add = function () {
            dialogs.create('PageDlg.html', 'PageDlgCtrl', {}, {
                size: 'lg'
            }).result.then(function (page) {
                HelpPage.save(page).$promise.then(function (data) {
                    toaster.success('添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('添加失败!');
                });
            });
        };

        $scope.edit = function (page) {
            dialogs.create('PageDlg.html', 'PageDlgCtrl', {page: page}, {
                size: 'lg'
            }).result.then(function (page) {
                HelpPage.update({id: page.id}, page).$promise.then(function (data) {
                    toaster.success('添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('添加失败!');
                });
            });
        };

        $scope.delete = function (page) {
            dialogs.confirm('删除页面', '确定要删除页面<strong>' + page.title + '</strong>吗?')
                .result.then(function () {
                HelpPage.delete({id: page.id}).$promise.then(function (resp) {
                    toaster.success('删除成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('删除失败!');
                });
            });
        };

        $scope.visible = function (item, query) {
            return !(query && query.length > 0
            && item.title.indexOf(query) == -1);
        };

        function convert2MenuItem(items, menu) {
            angular.forEach(items, function (item) {
                var menuItem = {page_id: item.id, subject: item.title};
                menu.children.push(menuItem);
                if (item.items && item.items.length > 0) {
                    menuItem.children = [];
                    convert2MenuItem(item.items, menuItem);
                }
            });
        }

        $scope.save = function (content) {
            var menu = {children: []};
            convert2MenuItem(content, menu);
            HelpContent.save({menu: menu}, function (content) {
                toaster.success('保存成功');
            });
        };

        function convert2Item(menus, content) {
            angular.forEach(menus, function (menu) {
                var item = {id: menu.page.id, title: menu.page.title, items: []};
                content.push(item);
                if (menu.children && menu.children.length > 0) {
                    convert2Item(menu.children, item.items);
                }
            });
        }

        $scope.contentReload = function () {
            HelpContent.get({id: 1}).$promise.then(function (resp) {
                var content = [];
                if (resp.root && resp.root['1']) {
                    var children = resp.root['1'].children;
                    convert2Item(children, content);
                }
                $scope.content = content;
            });
        };

        $scope.contentReload();
    });


angular.module('c.c').controller('PageDlgCtrl',
    function ($scope, $uibModalInstance, $sce, $http, toaster, data) {
        if (data.page) {
            $scope.page = data.page;
            var url = $sce.getTrustedResourceUrl(data.page.url);
            $http.get(url + "?" + new Date().toString()).success(function (resp) {
                $scope.page.body = resp;
            });
            $scope.$edit = true;
        } else {
            $scope.page = {title: ''};
        }

        $scope.ok = function (page) {
            if (page.title == '') {
                toaster.warning('标题不能为空');
            } else if (page.body == '') {
                toaster.warning('内容不能为空');
            } else {
                $uibModalInstance.close(page);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
(function () {
    'use strict';

    angular.module('c.c')
        .controller('MajorCtrl', MajorCtrl)

    ;


    function MajorCtrl($scope, $q, Api, dialogs, Major) {
        var vm = $scope;
        vm.add = add;
        vm.ok = ok;
        vm.save = save;
        vm.rmItem = rmItem;
        vm.reload = reload;
        //vm.remove = remove;

        init();


        function init() {
            vm.types = [];
            vm.op = {};
            reload();
        }

        function add(parent) {
            var nItem = {name: '新专业', children: []};
            nItem.nameChange = nItem.name;
            vm.op.eItem = nItem;
            if (angular.isDefined(parent)) {
                parent.children.push(nItem);
            } else {
                vm.types.push(nItem);
            }
        }

        function ok(item) {
            if (item.nameChange) {
                item.name = item.nameChange;
                vm.op.eItem = null;
            }
        }

        function convert(types) {
            angular.forEach(types, function (type) {
                delete type.nameChange;
                if (type.children && type.children.length > 0) {
                    convert(type.children);
                }
            });
        }

        function save(types) {
            var defer = $q.defer();
            vm.op.eItem = null;
            convert(types);
            Major.save(types, function (resp) {
                var types = [];
                angular.forEach(resp.items, function (type) {
                    types.push(type);
                });
                vm.types = types;

                Api.s(resp.msg);

                defer.resolve();
            });
            return defer.promise;
        }

        function rmItem(item, rmFn, self) {
            if (item.id) {
                dialogs.confirm('删除专业类型', '确定要删除<strong>' + item.name + '</strong>类型吗？')
                    .result.then(function () {
                    Major.delete({id: item.id}, function (resp) {
                        if (resp.result != 0) {
                            Api.w(resp.msg);
                        } else {
                            rmFn(self);
                        }
                    });
                });
            }
            else {
                rmFn(self);
            }
        }

        function reload() {
            var defer = $q.defer();
            Major.query({opt: 1}, function (resp) {
                var types = [];
                angular.forEach(resp.items, function (type) {
                    types.push(type);
                });
                vm.types = types;
                defer.resolve();
            });
            return defer.promise;
        }


    }


})();


angular.module('c.c')
    .controller('MeetingCtrl', function () {
    });

angular.module('c.c')
    .controller('SeniorityStandardCtrl', function ($rootScope, $scope, $filter, dialogs, Table,
                                                   toaster, NgTableParams, SeniorityStandard, F) {
        $scope.types = F.get('seniorityTypes');
        $scope.yesNo = F.get('yesNo');
        var yesNoOpts = F.getNgTableOpts($scope.yesNo);
        $scope.cols = [
            {title: '名称', show: true},
            {title: '类型', show: true, width: '60'},
            {title: '描述', show: true},
            {title: '值班费', sortable: 'duty_fee', show: true, width: '80'},
            {title: '是否停用', sortable: 'is_stop', show: true, width: '100'}
        ];

        $scope.$watch('type', function (type, old, scope) {
            var params = scope.tableParams;
            var filter = params.filter();
            if (type) {
                filter['type'] = F.getItem(type, $scope.types);
            } else {
                delete filter['type'];
            }
            params.filter(filter);
        });

        $scope.hideFilter = true;
        $scope.tableParams = new NgTableParams({
            page: 1,
            count: 10,
            filter: {}
        }, {
            counts: [10, 30],
            total: 0,
            getData: function ($defer, params) {
                if (!$scope.cachedData) {
                    SeniorityStandard.query(function (data) {
                        angular.forEach(data, function (item) {
                            if (item.description == null) {
                                item.description = "";
                            }
                            item.type = F.getItem(item.type, $scope.types);
                        });
                        $scope.cachedData = data;
                        Table.getTableData(data, $defer, params, $filter);
                    });
                } else {
                    var data = $scope.cachedData;
                    Table.getTableData(data, $defer, params, $filter);
                }
            }
        });

        $scope.tableReload = function () {
            $scope.cachedData = null;
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };

        $scope.add = function () {
            dialogs.create('SeniorityStandardDlg.html', 'SeniorityStandardDlgCtrl',
                {}, {size: 'md'})
                .result.then(function (std) {
                SeniorityStandard.save(std).$promise.then(function (resp) {
                    toaster.success('层级标准添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('层级标准添加失败!');
                })
            });
        };

        $scope.edit = function (std) {
            std.$edit = true;
            std.$nameChanged = std.name;
            std.$typeChanged = F.getItem(std.type.id, $scope.types);
            std.$descriptionChanged = std.description;
            std.$dutyFeeChanged = std.duty_fee;
            std.$is_stopChanged = F.getItem(std.is_stop, $scope.yesNo);
        };

        $scope.save = function (std) {
            std.$edit = false;
            if (std.$nameChanged == "") {
                toaster.error('名称不能为空!');
            } else if (std.$dutyFeeChanged >= 1000) {
                toaster.error('值班费应该小于1000元!');
            } else {
                var data = {};
                data['name'] = std.$nameChanged;
                data['type'] = std.$typeChanged.id;
                data['description'] = std.$descriptionChanged;
                data['duty_fee'] = std.$dutyFeeChanged;
                data['is_stop'] = std.$is_stopChanged.id;
                SeniorityStandard.update({id: std.id}, data).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('层级标准修改成功!');
                            break;
                        case 1:
                            toaster.warning('存在属于该层级标准的护士,因此无法停用该标准!');
                            break;
                    }
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('层级标准修改失败!');
                });

            }
        };

        $scope.delete = function (std) {

            dialogs.confirm('删除层级标准', '确定要删除<strong>' + std.name + '</strong>的护士层级标准吗?')
                .result.then(function () {
                SeniorityStandard.delete({id: std.id}).$promise.then(function (data) {
                    switch (data.result) {
                        case 0:
                            toaster.success('层级标准删除成功!');
                            break;
                        case 1:
                            toaster.warning('存在属于该层级标准的护士,因此无法删除该层级标准!');
                            break;
                    }
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('层级标准删除失败!');
                });
            });
        };

    });


angular.module('c.c').controller('SeniorityStandardDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, data) {

        $scope.yesNo = F.get('yesNo');
        $scope.types = F.get('seniorityTypes');
        $scope.std = {is_stop: false, type: $scope.types[1]};

        $scope.ok = function (std) {
            if ($scope.s_form.$valid) {
                var params = {};
                params['name'] = std.name;
                params['type'] = std.type.id;
                params['description'] = std.description;
                if (std.type.id == '2') {
                    params['duty_fee'] = std.duty_fee;
                }
                params['is_stop'] = std.is_stop;
                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.s_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module('c.c')
    .controller('SignCtrl', function ($scope, $filter, dialogs, toaster, $sce, $templateRequest,
                                      $timeout, User, F, Table) {
        var vm = $scope;

        init();
        function init() {
            var options = {
                service: User,
                params: {opt: 11/*INDEX_USER_SIGN*/},
                optColWidth: Table._2_BTN,
                showSn: true,
                cols: [
                    {field: "name", title: "姓名", filter: {name: "text"}},
                    {field: "username", title: "胸牌号", filter: {username: "text"}},
                    {field: "type", title: "类别", filter: {type: "text"}},
                    {field: "dept", title: "主科室", filter: {dept: "text"}},
                    {field: "sign", title: "签名", filter: {no_sign: "checkbox"}, data: "未传签名"},
                    {field: "seal", title: "印鉴", filter: {no_seal: "checkbox"}, data: "未传印鉴"}
                ]
            };

            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    if (item.signature) {
                        item.sign = item.signature.sign;
                    }
                    if (item.seal) {
                        item.seal = item.seal.seal;
                    }
                });
            });
        }

        $scope.edit = function (user) {
            dialogs.create('SignDlg.html', 'SignDlgCtrl', {user: user}, {
                size: 'md'
            }).result.then(function (params) {
                params['opt'] = 5;
                User.update({id: user.id}, params).$promise.then(function () {
                    toaster.success('签名设置成功!');
                    user.sign = params['sign'];
                }, function () {
                    toaster.error('签名设置失败!');
                });
            });
        };

        $scope.seal = function (user) {
            dialogs.create('SealDlg.html', 'SealDlgCtrl', {user: user}, {
                size: 'md'
            }).result.then(function (params) {
                params['opt'] = 7/*OPT_SEAL*/;
                User.update({id: user.id}, params).$promise.then(function () {
                    toaster.success('印鉴设置成功!');
                    user.seal = params['seal'];
                }, function () {
                    toaster.error('印鉴设置失败!');
                });
            });
        };

        //$scope.delete = function (user) {
        //    dialogs.confirm('删除数字签名', '确定要删除<strong>' + user.name + '</strong>的数字签名吗?')
        //        .result.then(function () {
        //            User.delete({id: dept.id}).$promise.then(function (resp) {
        //                toaster.success('签名删除成功!');
        //            });
        //            user.sign = null;
        //        }, function (error) {
        //            toaster.error('科室记录删除失败!');
        //        });
        //};

        var templateUrl = $sce.getTrustedResourceUrl('templates/print/table2.html');
        var printStyle;
        $templateRequest(templateUrl).then(function (resp) {
            printStyle = resp;
        });

        $scope.print = function () {

            var w = window.open("", "打印预览");

            var html = '<html><body><table><tbody>';
            html += '<tr><td>胸牌号</td>';
            html += '<td>姓名</td>';
            html += '<td>签名</td>';
            html += '</tr>';
            angular.forEach($scope.users, function (user) {
                html += '<tr>';
                html += '<td>' + user.username + '</td>';
                html += '<td>' + user.name + '</td>';
                html += '<td><img height="50" width="160" src="' + user.sign + '"/></td>';
                html += '</tr>';
            });
            html += '</tbody></table></body></html>';

            w.document.write(html + printStyle);
            w.document.close();
            w.focus();
            $timeout(function () {
                w.print();
                w.close();
            }, 24);
        };

    });


angular.module('c.c').controller('SignDlgCtrl', function ($scope, $uibModalInstance, toaster, data) {
    $scope.image = {croppedDataUrl: ''};
    $scope.user = data.user;

    $scope.ok = function (image) {
        if (image.croppedDataUrl == '') {
            toaster.warning('请先选择签名图片!');
        } else {
            var params = {};
            params['user_id'] = data.user.id;
            params['sign'] = image.croppedDataUrl;
            $uibModalInstance.close(params);
        }
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});

angular.module('c.c').controller('SealDlgCtrl', function ($scope, $uibModalInstance, toaster, data) {
    $scope.image = {croppedDataUrl: ''};
    $scope.user = data.user;

    $scope.ok = function (image) {
        if (image.croppedDataUrl == '') {
            toaster.warning('请先选择印鉴图片!');
        } else {
            var params = {};
            params['user_id'] = data.user.id;
            params['seal'] = image.croppedDataUrl;
            $uibModalInstance.close(params);
        }
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});
angular.module('c.c')
    .controller('ContactGroupCtrl',function ($scope, $filter, dialogs, toaster, NgTableParams, ContactGroup, F) {
        $scope.yesNo = F.get('yesNo');
        var yesNoOpts = F.getNgTableOpts($scope.yesNo);

        $scope.cols = [
            {title: '群名称', field: 'name', show: true}, //0
            {title: '成员数', field: 'members_count', width: '10%', show: true}, //1
            {title: '是否公开', filter: {is_public: 'select'}, data: yesNoOpts, field: 'is_public', width: '10%', show: true}, //6
            {title: '是否停用', filter: {is_stop: 'select'}, data: yesNoOpts, field: 'is_stop', width: '10%', show: true} //6
        ];
        $scope.hideFilter = true;
        $scope.optColWidth = 108;

        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 3;
                ContactGroup.query(url, function (resp) {
                    params.total(resp.total);
                    $defer.resolve(resp.groups);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.add = function () {
            dialogs.create('ContactGroupDlg.html', 'ContactGroupDlgCtrl', {}, {
                 size: 'md'
            }).result.then(function (group) {
                    ContactGroup.save(group).$promise.then(function (data) {
                        toaster.success('群添加成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('群添加失败!');
                    });
                });
        };

        $scope.edit = function (group) {
            group.$edit = true;
            group.$nameChanged = group.name;
            group.$is_stopChanged = F.getItem(group.is_stop, $scope.yesNo);
            group.$is_publicChanged = F.getItem(group.is_public, $scope.yesNo);
        };

        $scope.save = function (group) {
            group.$edit = false;
            if (group.$nameChanged == "") {
                toaster.warning('名称不能为空!');
            } else {
                var data = {};
                data['name'] = group.$nameChanged;
                data['is_stop'] = group.$is_stopChanged.id;
                data['is_public'] = group.$is_publicChanged.id;
                ContactGroup.update({id: group.id}, data).$promise.then(function (resp) {
                    toaster.success('群信息修改成功!');
                    group.name = group.$nameChanged;
                    group.is_stop = group.$is_stopChanged.id;
                    group.is_public = group.$is_publicChanged.id;
                }, function (error) {
                    toaster.error('群信息修改失败!');
                });
            }
        };

        $scope.delete = function (group) {
            dialogs.confirm('删除群记录', '确定要删除<strong>' + group.name + '</strong>的群吗?')
                .result.then(function () {
                    ContactGroup.delete({id: group.id}).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('群记录删除成功!');
                                break;
                            case 1:
                                toaster.warning('存在属于该群的成员,因此无法删除该群!');
                                break;
                        }
                        $scope.tableReload();
                    }, function (error) {
                        toaster.error('群记录删除失败!');
                    });
                });

        };

        $scope.member = function (group) {
            dialogs.create('templates/contact_group_members_dlg.html', 'ContactGroupMembersCtrl',
                {group: group}, { size: 'md'}).result.then(function () {
                }, function () {
                    $scope.tableParams.reload();
                });
        };

    });

angular.module('c.c').controller('ContactGroupDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, data) {
        $scope.yesNo = F.get('yesNo');

        $scope.group = {is_public: false, is_stop: false};

        $scope.ok = function (group) {
            if ($scope.g_form.$valid) {
                var params = {};
                params['name'] = group.name;
                params['is_public'] = group.is_public;
                params['is_stop'] = group.is_stop;
                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.g_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

(function () {
    'use strict';

    angular.module('c')
        .controller('ContactsCtrl', ContactsCtrl);

    /** @ngInject */
    function ContactsCtrl($scope, $q, ContactGroup, ArrayHelper, Api, Dept, DeptPhone,
                          WxHelper, deviceDetector, OS, AdminGroup, User, SeniorityStandard,
                          CommonPhone, JobTitle, NewUser, FileHelper, SaveAs) {
        var isWx = WxHelper.isWechatBrowser();
        var cacheGroup;
        var vm = $scope;
        vm.query = {};

        vm.typeSelectedFn = typeSelectedFn;
        vm.clearQuery = clearQuery;
        vm.clearQueryPhone = clearQueryPhone;

        vm.toggleSectionNode = toggleSectionNode;
        vm.toggleDeptNode = toggleDeptNode;
        vm.toggleNurseLevelNode = toggleNurseLevelNode;
        vm.toggleContactGroupNode = toggleContactGroupNode;

        vm.selectContactGroupMembers = selectContactGroupMembers;
        vm.selectDeptMembers = selectDeptMembers;

        vm.selectDeptPhone = selectDeptPhone;
        vm.pageChanged = pageChanged;
        vm.selectUser = selectUser;
        vm.queryUser = queryUser;
        vm.queryNurseLevel = queryNurseLevel;

        vm.deptGroupVisible = deptGroupVisible;
        vm.contactGroupVisible = contactGroupVisible;
        vm.deptTypeVisible = deptTypeVisible;
        vm.sectionVisible = sectionVisible;
        vm.deptVisible = deptVisible;

        vm.getCallUrl = getCallUrl;
        vm.hasCallUrl = hasCallUrl;

        vm.initCommonPhoneSelector = initCommonPhoneSelector;

        vm.userStatusSelectFn = userStatusSelectFn;
        vm.userTypeSelectFn = userTypeSelectFn;
        vm.userTitleSelectFn = userTitleSelectFn;
        vm.getUserDataes = getUserDataes;
        vm.groupByTitle = groupByTitle;
        vm.download = download;

        init();


        function init() {
            vm.selectTypes = [
                {id: 1, name: '科室', exAll: false, fresh: true},
                // {id: 2, name: '角色', exAll: false, fresh: true},
                {id: 3, name: '姓名/胸牌号', fresh: true},
                {id: 4, name: '科管组', fresh: true},
                {id: 5, name: '群', fresh: true},
                {id: 6, name: '层级', fresh: true},
                {id: 7, name: '常用电话', fresh: true},
                {id: 8, name: '组合查询', fresh: true},
                {id: 9, name: '年级', fresh: true}
            ];
            vm.curType = $scope.selectTypes[0];
            vm.selected = null; //所有选中的人
            vm.pager = {total: 0, page: 1, count: 10};
            vm.showDetail = $(window).width() > 768;
            vm.search = {};

            vm.typeSelectedFn(0);
        }

        function getCallUrl(phone) {
            var index = phone.indexOf('转');
            if (index !== -1) phone = phone.slice(0, index);
            var url = 'tel:' + phone;
            if (isWx && deviceDetector.os !== OS.IOS) return url + '#weixin.qq.com';
            return url;
        }

        function hasCallUrl(phone) {
            return !deviceDetector.isDesktop() && phone
        }

        function typeSelectedFn($index) {
            var toType = $scope.selectTypes[$index];
            // $(window).resize(function () {
            //     var width = $(window).width();
            //     if (width > 768) {
            //         $scope.hideList = false;
            //         $scope.showDetail = true;
            //     } else {
            //         $scope.hideList = false;
            //         $scope.showDetail = false;
            //     }
            // });
            vm.pager = {total: 0, page: 1, count: 10};
            var width = $(window).width();
            if (width > 768) {
                $scope.hideList = false;
                $scope.showDetail = true;
            } else {
                $scope.hideList = false;
                $scope.showDetail = false;
            }

            switch (toType.id) {
                case 1:
                    if (toType.fresh) {
                        initDeptSelector();
                        toType.fresh = false;
                    }
                    break;
                // case 2:
                //     if (toType.fresh) {
                //         initRoleSelector();
                //         toType.fresh = false;
                //     }
                //     break;
                case 3:
                    if (toType.fresh) {
                        initNameSelector();
                        toType.fresh = false;
                    }
                    break;
                case 4:
                    if (toType.fresh) {
                        initDeptAdminGroupSelector();
                        toType.fresh = false;
                    }
                    break;
                case 5:
                    if (toType.fresh) {
                        initContactGroupMembersSelector();
                        toType.fresh = false;
                    }
                    break;
                case 6:
                    if (toType.fresh) {
                        initSenioritySelector();
                        toType.fresh = false;
                    }
                    break;
                case 7:
                    initCommonPhoneSelector();
                    break;
                case 8:
                    initMixSearchSelector();
                    break;
                case 9:
                    if (toType.fresh) {
                        queryNurseLevel();
                        toType.fresh = false;
                    }
            }
            $scope.curType = toType;
        }

        function clearQuery() {
            vm.users = [];
            vm.query.str = '';
            vm.pager.total = 0;
        }

        function clearQueryPhone() {
            vm.query.phone = undefined;
            initCommonPhoneSelector(vm.query.phone);
        }

        function initMixSearchSelector() {
            vm.loading = true;
            $q.all([
                NewUser.query({op: 'searchFilter'}).$promise
            ]).then(function (respArray) {
                vm.loading = false;
                vm.userTypes = respArray[0].types;
                vm.userStatuses = respArray[0].statuses;
                vm.userTitles = respArray[0].titles;
                vm.getUserDataes(vm.pager.page, vm.pager.count);
            });
        }

        function getUserDataes(page, count) {
            var pa = {
                op: 'searchUsers',
                page: page,
                count: count,
                type: vm.userType ? vm.userType.id : undefined,
                title: vm.userTitle ? vm.userTitle.id : undefined,
                status: vm.userStatus ? vm.userStatus.id : undefined
            };
            NewUser.query(pa, function (resp) {
                vm.pager.total = resp.total;
                vm.mixUsers = resp.items;
            });
        }

        function userTitleSelectFn(item) {
            vm.userTitle = item;
            vm.getUserDataes(vm.pager.page, vm.pager.count);
        }

        function userTypeSelectFn(item) {
            vm.userType = item;
            vm.getUserDataes(vm.pager.page, vm.pager.count);
        }

        function userStatusSelectFn(item) {
            vm.userStatus = item;
            vm.getUserDataes(vm.pager.page, vm.pager.count);
        }

        function groupByTitle(item) {
            var titleTypes = JobTitle.getTypes();
            return titleTypes[item.type - 1].name;
        }

        function initCommonPhoneSelector(qStr) {
            vm.showDetail = false;
            vm.loading = true;
            vm.query.phone = qStr;
            CommonPhone.query({
                opt: 2,
                queryStr: qStr,
                page: vm.pager.page,
                count: vm.pager.count
            }, function (resp) {
                vm.loading = false;
                vm.pager.total = resp.total;
                vm.commonPhones = resp.items;
            }, function () {
                vm.loading = false;
            })
        }

        function queryUser(qStr) {
            if (qStr) {
                vm.query.str = qStr;
                var urlParams = Api.param2Url({
                    opt: 5/*INDEX_USER_INFO_OPTIONS*/,
                    page: vm.pager.page,
                    count: vm.pager.count
                });
                urlParams.name = qStr;
                vm.loading = true;
                User.query(urlParams).$promise.then(function (resp) {
                    vm.users = resp.items;
                    vm.pager.total = resp.total;
                }).finally(function () {
                    vm.loading = false;
                });
            } else {
                clearQuery();
            }
        }

        function queryNurseLevel() {
            // if (qStr) {
            //     vm.query.str = qStr;
            //     var urlParams = Api.param2Url({
            //         opt: 20/*INDEX_NURSE_LEVEL*/,
            //         page: vm.pager.page,
            //         count: vm.pager.count
            //         // exclude: data.existMembers
            //     });
            //     urlParams.name = qStr;
            //     vm.loading = true;
            //     User.query(urlParams).$promise.then(function (resp) {
            //         vm.users = resp.items;
            //         vm.pager.total = resp.total;
            //     }).finally(function () {
            //         vm.loading = false;
            //     });
            // } else {
            //     clearQuery();
            // }

            vm.loading = true;
            vm.NLS = [
                {id: 1, name: '1-2年级'},
                {id: 2, name: '3-5年级'},
                {id: 3, name: '6-9年级'},
                {id: 4, name: '10年级及以上'},
            ];
            vm.loading = false;
        }

        function pageChanged() {
            queryUser(vm.query.str);
        }

        function selectDeptPhone(dept) {
            showDetailAccordingToScreenSize();

            vm.selected = dept;
            vm.selectedDept = true;
            DeptPhone.query({opt: 2, dept_id: dept.id}, function (resp) {
                vm.deptPhones = resp.items;
            });
        }

        function selectUser(user) {
            showDetailAccordingToScreenSize();

            vm.selected = user;
            vm.selectedDept = false;
            User.get({id: user.id, info_type: 3}, function (resp) {
                vm.contact = resp.user;
            });
        }


        function initDeptSelector() {
            vm.loading = true;
            Dept.query({opt: 9}, function (resp) {
                vm.loading = false;
                //加入部门，先按部门分类
                angular.forEach(resp.dept_types, function (type) {
                    var sections = [];
                    var otherDepts = [];
                    angular.forEach(type.depts, function (dept) {
                        if (dept.section) {
                            if (!sections[dept.section_id]) {
                                sections[dept.section_id] = {name: dept.section.name, depts: [], sorting: dept.sorting};
                                sections[dept.section_id].depts.push(dept);
                            } else {
                                if (sections[dept.section_id].sorting > dept.sorting) {
                                    sections[dept.section_id].sorting = dept.sorting;
                                }
                                sections[dept.section_id].depts.push(dept);
                            }
                        } else {
                            otherDepts.push(dept);
                        }
                    });
                    type.sections = otherDepts.concat(sections);
                    type.sections = type.sections.filter(function (section) {
                        return section;
                    });
                    type.sections = type.sections.sort(compare('sorting'));
                });
                vm.types = resp.dept_types;
            }, function () {
                vm.loading = false;
            });
        }

        function compare(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            }
        }

        function showDetailAccordingToScreenSize() {
            if (!vm.showDetail) {
                vm.hideList = true;
                vm.showDetail = true;
            }
        }

        // function initRoleSelector() {
        //     vm.loading = true;
        //     User.query({opt: 6}, function (resp) {
        //         vm.loading = false;
        //         vm.roles = resp.roles;
        //     }, function () {
        //         vm.loading = false;
        //     });
        // }

        function initNameSelector() {

        }

        function initContactGroupMembersSelector() {
            vm.loading = true;
            ContactGroup.query({opt: 2}, function (resp) {
                vm.loading = false;
                cacheGroup = resp.groups;

                vm.groups = ArrayHelper.map(cacheGroup, function (g) {
                    return {id: g.id, name: g.name, memberCount: g.members.length};
                });
            }, function () {
                vm.loading = false;
            });
        }

        function initDeptAdminGroupSelector() {
            vm.loading = true;
            vm.adminGroups = [];
            AdminGroup.query({op: 'with_members'}, function (resp) {
                vm.loading = false;
                angular.forEach(resp.items, function (item) {
                    if (item.group !== null && item.group.members.length > 0) {
                        vm.adminGroups.push(item);
                    }
                });
            }, function () {
                vm.loading = false;
            });
        }

        function initSenioritySelector() {
            vm.loading = true;

            SeniorityStandard.query({opt: 1}, function (resp) {
                vm.loading = false;
                vm.standards = resp;
            }, function () {
                vm.loading = false;
            });
        }

        function tagDeptLeader(dept) {
            var index, item;
            if (dept.mail_recipient_id) {
                index = ArrayHelper.indexOfKey(dept.mail_recipient_id, dept.members);
                if (index > 0) {
                    item = ArrayHelper.getItem(dept.mail_recipient_id, dept.members);
                    dept.members.splice(index, 1);
                    dept.members.splice(0, 0, item);
                }
            }

            if (dept.leader_id) {
                index = ArrayHelper.indexOfKey(dept.leader_id, dept.members);
                if (index > 0) {
                    item = ArrayHelper.getItem(dept.leader_id, dept.members);
                    dept.members.splice(index, 1);
                    dept.members.splice(0, 0, item);
                }
            }
        }

        function toggleSectionNode(section, toggle, node) {
            if (!section.id) {
                toggle(node);
            } else {
                if (section.members) {
                    toggle(node);
                } else {
                    Dept.query({opt: 3, dept_id: section.id}, function (resp) {
                        if (resp.depts && resp.depts.length > 0) {
                            section.members = resp.depts[0].members;
                            tagDeptLeader(section);
                            toggle(node);
                        }
                    });
                }
            }
        }

        function toggleDeptNode(dept, toggle, node) {
            if (dept.members) {
                toggle(node);
            } else {
                Dept.query({opt: 3, dept_id: dept.id}, function (resp) {
                    if (resp.depts && resp.depts.length > 0) {
                        dept.members = resp.depts[0].members;
                        tagDeptLeader(dept);
                        toggle(node);
                    }
                });
            }
        }

        function toggleNurseLevelNode(nl, toggle, node) {
            if (nl.nurses) {
                toggle(node);
            } else {
                User.query({opt: 20, level: nl.id}, function (resp) {
                    if (resp.items && resp.items.length > 0) {
                        nl.nurses = resp.items;
                        tagDeptLeader(nl);
                        toggle(node);
                    }
                });
            }
        }

        function toggleContactGroupNode(group, toggle, node) {
            if (!group.members) {
                group.members = ArrayHelper.getItem(group.id, cacheGroup).members;
            }
            toggle(node);
        }

        function selectDeptMembers(dept, $event) {
            $event.stopPropagation();
            if (dept.members) {
                vm.selectUsers(dept.members);
            } else {
                Dept.query({opt: 3, dept_id: dept.id, user_type: data.userType}, function (resp) {
                    if (resp.depts && resp.depts.length > 0) {
                        dept.members = resp.depts[0].members;
                        tagDeptLeader(dept);
                        vm.selectUsers(dept.members);
                    }
                });
            }
        }

        function selectContactGroupMembers(group, $event) {
            $event.stopPropagation();
            if (!group.members) {
                var members = ArrayHelper.getItem(group.id, cacheGroup).members;
                angular.forEach(members, function (m) {
                    if (ArrayHelper.indexOfKey(m.id, data.existMembers) !== -1 ||
                        (vm.multiSelect && ArrayHelper.indexOfKey(m.id, data.model) !== -1)) {
                        m.hide = true;
                    }
                });
                group.members = members;
            }
            vm.selectUsers(group.members);
        }

        function deptGroupVisible(group) {
            return !(vm.search.deptGroup && vm.search.deptGroup.length > 0
                && group.name.indexOf(vm.search.deptGroup) === -1);
        }

        function contactGroupVisible(group) {
            return !(vm.search.contactGroup && vm.search.contactGroup.length > 0
                && group.name.indexOf(vm.search.contactGroup) === -1);
        }

        function deptTypeVisible(type) {
            var visible = !vm.search.dept || vm.search.dept.length === 0;
            if (!visible) {
                for (var i = 0; i < type.sections.length; i++) {
                    var section = type.sections[i];
                    if (!section.depts) {
                        if (ArrayHelper.indexOfKey(vm.search.dept, section.dept_phone, 'phone') > -1 || section.name.indexOf(vm.search.dept) !== -1) {
                            visible = true;
                            break;
                        }
                    } else {
                        for (var j = 0; j < section.depts.length; j++) {
                            var dept = section.depts[j];
                            if (ArrayHelper.indexOfKey(vm.search.dept, dept.dept_phone, 'phone') > -1 || dept.name.indexOf(vm.search.dept) !== -1) {
                                visible = true;
                                break;
                            }
                        }
                    }
                }
            }
            return visible;
        }

        function sectionVisible(section) {
            var visible = !vm.search.dept || vm.search.dept.length === 0;
            if (!visible) {
                if (!section.depts) {
                    if (ArrayHelper.indexOfKey(vm.search.dept, section.dept_phone, 'phone') > -1 || section.name.indexOf(vm.search.dept) !== -1) {
                        visible = true;
                    }
                } else {
                    for (var j = 0; j < section.depts.length; j++) {
                        var dept = section.depts[j];
                        if (ArrayHelper.indexOfKey(vm.search.dept, dept.dept_phone, 'phone') > -1 || dept.name.indexOf(vm.search.dept) !== -1) {
                            visible = true;
                            break;
                        }
                    }
                }
            }
            return visible;
        }

        function deptVisible(dept) {
            if (!vm.search.dept || vm.search.dept.length == 0) {
                return true;
            } else return (ArrayHelper.indexOfKey(vm.search.dept, dept.dept_phone, 'phone') !== -1 || dept.name.indexOf(vm.search.dept) !== -1);
            // return !(vm.search.dept && vm.search.dept.length > 0
            //     && (ArrayHelper.indexOfKey(vm.search.dept, dept.dept_phone, 'phone') === -1 || dept.name.indexOf(vm.search.dept) === -1));
        }

        //
        // function nurseLevelVisible(nl) {
        //     return !(nl.nurses && nl.nurses.length > 0);
        // }

        function download(type) {
            var defer = $q.defer();
            var url, title;
            if (type == 1) {
                url = '/api/v1/dept_phones/download';
                title = '科室电话明细.xls';

                FileHelper.download(url, {
                    filename: "/dept_phone.xlsx",
                    mime: 'application/wps-office.xlsx'
                }, function (resp) {
                    var data = [resp];
                    var options = {type: "application/wps-office.xlsx"};
                    SaveAs.download(data, title, options);
                }, function () {
                    Dlg.e('服务端文件丢失，请联系管理员!');
                });
            } else {
                // url = '/api/v1/common_phones/download';
                // title = '值班电话明细.xls';
                //
                // FileHelper.dnExcel(url, {}, title)
                //     .finally(function () {
                //         defer.resolve();
                //     });
            }
            return defer.promise;
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('DataServiceCtrl', DataServiceCtrl);

    /** @ngInject */
    function DataServiceCtrl($scope, $http, $timeout) {
        var vm = $scope;
        vm.hx_token = '';

        init();

        function init() {
            var form = document.getElementById("myForm");

            $http.get('/api/v1/hxoa_token', {params: {opt: 1}}).success(function (resp) {
                vm.hx_token = resp.val;
                $timeout(function () {
                    form.submit();
                }, 200);
            }).error(function (err) {
                Dlg.w('读取用户信息失败，请重新登录后尝试');
            }).finally(function () {
            });
        }
    }

})();



angular.module('c.c')
    .controller('DeptRecordCtrl', function ($scope, dialogs, toaster, NgTableParams, F,
                                            UserDept) {

        $scope.cols = [
            {title: '科室名称', field: 'name', show: true}, //0
            {title: '科室内职务', field: 'post', show: true}, //6
            {title: '是否主科室', field: 'is_main', show: true}, //6
            {title: '进入时间', field: 'entry_time', sortable: 'entry_time', show: true}, //6
            {title: '离开时间', field: 'leave_time', sortable: 'leave_time', show: true} //6
        ];
        $scope.hideFilter = true;
        $scope.hideOpt = true;

        $scope.tableParams = new NgTableParams({page: 1, count: 10, sorting: {entry_time: 'desc'}}, {
            counts: [10, 30, 50],
            total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 3;  //INDEX_DEPTS_IN_MEMBER
                url['user_id'] = $scope.account.id;
                UserDept.query(url, function (resp) {
                    params.total(resp.total);
                    angular.forEach(resp.depts, function (m) {
                        m.is_main = m.is_main == '1';
                    });
                    $defer.resolve(resp.depts);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };
    });
angular.module('c.c')
    .controller('UserHelpCtrl', function ($scope, $sce, $http,
                                          HelpPage, HelpContent, DateHelper, F) {

        HelpPage.query(function (data) {
            $scope.pages = data;
            if (data.length > 0) {
                var page = data[0];
                $scope.selectPage(page);
            }
        });

        HelpContent.get({id: 1}).$promise.then(function (resp) {
            if (resp.root && resp.root['1']) {
                $scope.content = resp.root['1'].children;
            }
        });

        $scope.selectPage = function (page) {
            var time = DateHelper.datetime2Str(new Date(), 'yyMMddHHmmss');
            var url = $sce.getTrustedResourceUrl(page.url + "?" + time);
            $http.get(url).success(function (resp) {
                $scope.curPage.body = $sce.trustAsHtml(resp);
            });
            $scope.curPage = page;
        }

    });


(function () {
    'use strict';

    angular.module('c.c')
        .controller('UserMeetingCtrl', UserMeetingCtrl);

    /** @ngInject */
    function UserMeetingCtrl($scope, $stateParams, UIHelper) {
        UIHelper.loadTabs($scope, $stateParams);
    }

})();





(function () {
    'use strict';
    
    angular.module('c.c')
        .controller('UserMissionTabCtrl', UserMissionTabCtrl);
    
    /** @ngInject */
    function UserMissionTabCtrl($scope, $stateParams, UIHelper) {
        UIHelper.loadTabs($scope, $stateParams);
    }
})();

// angular.module('c.c')
//     .controller('UserMissionCtrl', function ($scope, $stateParams, $rootScope, $timeout) {
//         if($stateParams.data.tab){
//             $scope.tabs = [];
//             data = $stateParams.data;
//             $scope.tabs[data.tab] = true;
//             $timeout(function () {
//                 $rootScope.$broadcast(data.event , data.content);
//             }, 200);
//         }
//     });
angular.module('c.c')
    .controller('UserOPNoticeCtrl', function ($scope, $filter, NgTableParams, dialogs, toaster, Sms, FileHelper,
                                              C, F, SaveAs, Dept, ORRecipient, OperationPermit) {
        $scope.types = F.get('or_types');
        var typeOpts = F.getNgTableOpts($scope.types);
        var stages = F.get('stage_list');
        var stageOpts = F.getNgTableOpts(stages);

        $scope.cols = [
            {title: '手术单', filter: {attach_name: 'text'}, field: 'attach_name', width: '20%', show: true}, //0
            {title: '接单手术室', filter: {type_id: 'select'}, data: typeOpts, field: 'type_id', show: true}, //1
            {title: '递交人', field: 'applicant', filter: {applicant: 'text'}, width: '10%', show: true}, //6
            {
                title: '递交时间',
                filter: {created_at: 'date_range'},
                sortable: 'created_at',
                field: 'created_at',
                width: '15%',
                show: true
            }, //6
            {title: '状态', filter: {stage: 'select'}, data: stageOpts, field: 'stage', width: '10%', show: true},//1
            {title: '备注', field: 'remark', width: '20%', show: true} //1
        ];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        ORRecipient.query({type: 1}, function (resp) {
            $scope.recipients = resp.records;
        });

        Dept.query({opt: 10}, function (resp) {
            $scope.depts = resp.depts;
            if (resp.depts && resp.depts.length > 0) {
                $scope.dept = resp.depts[0];
                $scope.tableParams.reload();
            }
        });

        $scope.deptSelectedFn = function ($index) {
            $scope.dept = $scope.depts[$index];
            $scope.tableParams.$params.page = 1;
            $scope.tableParams.reload();
        };

        $scope.changeJustMe = function () {
            $scope.tableParams.reload();
        };

        $scope.optColWidth = 76;
        $scope.tableParams = new NgTableParams({page: 1, count: 30, sorting: {created_at: 'desc'}}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                if ($scope.dept) {
                    var url = params.url();
                    url['opt'] = 1;
                    url['dept_id'] = $scope.dept.id;
                    url['just_me'] = $scope.just_me;
                    if ($scope.dateRangeFilter.created_at != null) {
                        url['startDate'] = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
                        url['endDate'] = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
                    }
                    OperationPermit.query(url, function (resp) {
                        params.total(resp.total);
                        angular.forEach(resp.permits, function (m) {
                            m.type = F.getItem(m.type_id, $scope.types);
                        });
                        $defer.resolve(resp.permits);
                    });
                } else {
                    $defer.resolve([]);
                }
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.add = function () {
            dialogs.create('OPDlg.html', 'OPDlgCtrl', {dept: $scope.dept}, {
                size: 'md'
            }).result.then(function (permit) {
                OperationPermit.save(permit).$promise.then(function (data) {
                    toaster.success('手术通知单递交成功!');
                    $scope.tableReload();
                    if ($scope.recipients.length > 0) {
                        var pa = {};
                        pa['sign'] = '【成办医院】';
                        pa['content'] = '请处理手术通知单' + permit.attach_name;
                        pa['content'] += '(' + $scope.account.name + $scope.account.phone + ')';
                        var recipient_ids = [];
                        angular.forEach($scope.recipients, function (r) {
                            recipient_ids.push(r.user_id);
                        });
                        pa['recipients'] = recipient_ids;
                        Sms.send(pa, function (success) {
                            toaster.success('短信请求成功!');
                        }, function (resp) {
                            toaster.error('短信请求失败!');
                        });
                    }
                }, function () {
                    toaster.error('手术通知单递交失败!');
                });
            });
        };

        $scope.canEdit = function (m) {
            return $scope.account.id == m.applicant_id && m.stage == 1;
        };

        $scope.canRm = function (m) {
            return $scope.account.id == m.applicant_id && m.stage != 2;
        };

        $scope.edit = function (m) {
            dialogs.create('OPDlg.html', 'OPDlgCtrl', {dept: $scope.dept, permit: m}, {
                size: 'md'
            }).result.then(function (permit) {
                OperationPermit.update({id: m.id}, permit).$promise.then(function (data) {
                    toaster.success('手术通知单修改成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('手术通知单修改失败!');
                });
            });
        };

        $scope.delete = function (m) {
            dialogs.confirm('删除手术通知单申请', '确定要删除该手术通知单申请吗?')
                .result.then(function () {
                OperationPermit.delete({id: m.id}).$promise.then(function (resp) {
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('删除手术通知单申请!');
                });
            });
        };

        $scope.download = function (m) {
            var params = {filename: m.attach_filename, mime: m.attach_mime};
            m.downloading = true;
            FileHelper.download(C.URL.OP_DOWNLOAD, params, function (resp) {
                m.downloading = false;
                var data = [resp];
                var options = {type: m.attach_mime};
                SaveAs.download(data, m.attach_name, options);
            }, function () {
                m.downloading = false;
                //toaster.error('服务端文件丢失,请联系管理员!');
            });
        };
    });

angular.module('c.c').controller('OPDlgCtrl',
    function ($scope, $uibModalInstance, toaster, dialogs, C, F, Upload, data) {
        $scope.types = F.get('or_types');
        $scope.dept = data.dept;
        if (data.permit) {
            var m = data.permit;
            $scope.$edit = true;
            $scope.m = {
                remark: m.remark, dept_id: data.dept.id, type: m.type,
                attach_name: m.attach_name, attach_mime: m.attach_mime,
                attach_filename: m.attach_filename, attach_size: m.attach_size
            };
        } else {
            $scope.m = {type: $scope.types[0], dept_id: data.dept.id};
        }

        $scope.progress = 0;
        $scope.upload = function (file, m, e) {
            if (e && e[0] && e[0].$error == 'maxSize') {
                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
                return;
            }

            if (file == null) {
                return;
            }

            Upload.upload({
                url: C.URL.OP_UPLOAD, file: file
            }).progress(function (evt) {
                $scope.progress = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (resp) {
                switch (resp.result) {
                    case 0:
                        m.attach_name = resp.attach_name;
                        m.attach_mime = resp.attach_mime;
                        m.attach_filename = resp.attach_filename;
                        m.attach_size = resp.attach_size;
                        break;
                    case 1:
                        $scope.progress = 101;
                        $scope.errorInfo = '服务器空间不足!';
                        break;
                }
            }).error(function () {
                $scope.progress = 102;
                $scope.errorInfo = '服务器错误!';
            });
        };

        $scope.ok = function (m) {
            if (m.attach_name == null) {
                toaster.warning('必须上传手术通知单作为附件!');
            } else if ($scope.m_form.$valid) {
                var params = {};
                params['remark'] = m.remark;
                params['dept_id'] = m.dept_id;
                params['type_id'] = m.type.id;

                params['attach_name'] = m.attach_name;
                params['attach_mime'] = m.attach_mime;
                params['attach_filename'] = m.attach_filename;
                params['attach_size'] = m.attach_size;

                $uibModalInstance.close(params);
            } else {
                toaster.warning('备注长度不能超过255字符!');
                $scope.m_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
(function () {
    'use strict';

    angular.module('c')
        .controller('ProfileCtrl', ProfileCtrl)
        .controller('ContactInfoCtrl', ContactInfoCtrl)
        .controller('PasswordDlgCtrl', PasswordDlgCtrl);

    /** @ngInject */
    function ProfileCtrl($scope, User, ArrayHelper, Auth, Dlg, NewUser,$stateParams) {
        var vm = $scope;
        vm.reload = reload;
        vm.addUserPhoto = addUserPhoto;
        vm.edit = edit;
        vm.confirm = confirm;
        vm.editContact = editContact;

        vm.plaits = [
            {id: 1, name: '上锦'},
            {id: 2, name: '华西派驻'},
            {id: 3, name: '附二院派驻'},
            {id: 4, name: '院外人员'}
        ];

        init($stateParams.data.requireChangePasswd);


        function init(requireChangePasswd) {
            reload(requireChangePasswd);
        }

        function reload(requireChangePasswd) {
            var id = null;
            $scope.account = Auth.getAccount();
            if (!$scope.account) {
                id = $stateParams.data.id;
            } else {
                id = $scope.account.id;
            }
            User.get({id: id, info_type: 0, only_show: 1}, function (data) {
                var user = data.user;
                user.edu_bg = ArrayHelper.getItem(user.edu_bg, ArrayHelper.get('edu_bg_list'));
                user.en_lv = ArrayHelper.getItem(user.en_lv, ArrayHelper.get('eg_lv_list'));
                user.plait = ArrayHelper.getItem(user.plait, vm.plaits);
                if (user.post) {
                    user.post = ArrayHelper.getItem(user.post, ArrayHelper.get('posts'));
                }
                if (user.signature) {
                    user.sign = user.signature.sign;
                }
                if (user.user_extend) {
                    user.work_photo = user.user_extend.work_photo;
                }
                vm.user = user;

                if (requireChangePasswd) {
                    Dlg.show({
                        template: 'password_dlg.html',
                        ctrl: 'PasswordDlgCtrl',
                        data: {user: user, requireChangePasswd: requireChangePasswd}
                    });
                }
            });
        }

        function addUserPhoto(user) {
            Dlg.show({
                template: 'pages/user/profile/userPhotoDlg.html',
                ctrl: 'UserPhotoDlgCtrl',
                data: {id: user.id}
            }).then(function (resp) {
                user.photo = resp[0];
                vm.account.photo = resp[0];
                Auth.setAccount(vm.account);
                vm.reload();
            });
        }

        function edit(user) {
            Dlg.show({
                template: 'password_dlg.html',
                ctrl: 'PasswordDlgCtrl',
                data: {user: user}
            });
            vm.account.more_contact_info = false;
            Auth.setAccount(vm.account);
        }

        function confirm(user) {
            Dlg.show({
                template: 'templates/user_edit_dlg.html',
                ctrl: 'UserEditCtrl',
                data: {
                    user_id: user.id, confirm_state: '1',
                    title: '确认信息'
                },
                size: 'lg'
            }).then(function (pa) {
                // Dlg.s('用户信息确认成功!');
                vm.account.confirm_state = 1; //1表示用户已确认
                vm.account.phone = pa['phone'];
                vm.account.email = pa['email'];
                vm.account.username = pa['email'];
                vm.account.photo = pa['photo'];
                Auth.setAccount(vm.account);
                vm.reload();
            });
        }

        function editContact(user) {
            Dlg.show({
                template: 'templates/contact_info_dlg.html',
                ctrl: 'ContactInfoCtrl',
                data: {user_id: user.id}
            });
            vm.account.more_contact_info = false;
            Auth.setAccount(vm.account);
        }
    }

    /** @ngInject */
    function PasswordDlgCtrl($uibModalInstance, Dlg, data, $q, FormHelper, NewUser) {

        var vm = this;
        vm.m = data.user;
        vm.requireChangePasswd = data.requireChangePasswd;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        function ok(m) {
            var defer = $q.defer();
            if (!vm.password_form.$valid) {
                FormHelper.handleError('#password_form', vm.password_form);
                defer.reject();
            } else {
                var pa = {
                    password: m.password,
                    op: 'password'
                };
                NewUser.update({id: m.id}, pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function (error) {
                    Dlg.e(error.msg);
                });
            }
            defer.resolve();

            return defer.promise;
        }
    }

    /** @ngInject */
    function ContactInfoCtrl($scope, $uibModalInstance, Dlg, User, data, NewUser) {
        var vm = $scope;
        vm.submit = submit;
        vm.cancel = $uibModalInstance.dismiss;

        init();


        function init() {
            vm.first_login = true;
            User.get({id: data.user_id, info_type: 3}, function (resp) {
                vm.user = resp.user;
            });
        }

        function submit(user) {
            if (vm.u_form.$valid) {
                var pa = {};
                pa['phone'] = user.phone;
                pa['phone2'] = user.phone2;
                pa['office_phone'] = user.office_phone;
                pa['office_cornet'] = user.office_cornet;
                pa['email'] = user.email;
                pa['address'] = user.address;
                pa['is_cadre'] = user.is_cadre;
                pa['op'] = 'userMsg';

                NewUser.update({id: data.user_id}, pa).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            } else {
                Dlg.w('表单中有错误!');
                vm.u_form.submitted = true;
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('SmsCtrl', SmsCtrl);

    /** @ngInject */
    function SmsCtrl($scope, $stateParams, UIHelper) {
        UIHelper.loadTabs($scope, $stateParams);
    }

})();



(function () {
    'use strict';


    angular.module('c')
        .factory('EventReminder', EventReminder);

    /** @ngInject */
    function EventReminder($http) {
        var API = '/api/v1/shared/event_reminders';
        return {
            getInstance: function (mod, events) {
                return angular.extend(events, {
                    get: function (event) {
                        return $http.get(API + '/' + mod, {params: {event: event}});
                    },
                    set: function (event, reminder) {
                        return $http.put(API + '/' + mod, {event: event, user_id: reminder});
                    },
                    mod: mod
                })
            }
        };
    }

})();

(function () {
    'use strict';


    angular.module('c')
        .factory('PdfDoc', PdfDoc);

    /** @ngInject */
    function PdfDoc($resource, serviceConfObj) {
        var API = 'api/v1/shared/pdf_docs';
        return {
            getInstance: function (mod, extend) {
                var r = $resource(API + '/' + mod + '/:id', {}, serviceConfObj);
                if (extend) r = angular.extend(extend, r);
                return r;
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('c.d')
        .directive('adminGroupSelector', adminGroupSelector);

    /** @ngInject */
    function adminGroupSelector(AdminGroup) {
        return {
            templateUrl: 'directives/form/admin-group-selector/groupSelector.html',
            restrict: 'E',
            // replace: true,
            scope: {
                onSelect: '&',
                model: '=ngModel'
            },
            require: ['^ngModel', '?^form'],
            link: function (scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.touch = touch;
                vm.onSelectItem = onSelectItem;

                init();


                function init() {
                    checkValidity();

                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) iElement.addClass('submitted')
                        });
                    }

                    AdminGroup.query({op: 'option'}).$promise.then(function (resp) {
                        vm.groups = resp.items;
                    });
                }

                function touch() {
                    ngModelCtrl.$setTouched();
                }

                function onSelectItem(model, clear) {
                    ngModelCtrl.$setViewValue(model);
                    checkValidity();
                    if (scope.onSelect()) {
                        scope.onSelect()(model)
                    }
                }

                function checkValidity() {
                    var valid = iAttrs.required ? (!!ngModelCtrl.$viewValue) : true;
                    ngModelCtrl.$setValidity('required', valid);
                }
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('c')
        .directive('deptSelector', deptSelector)
        .controller('DeptSelectCtrl', DeptSelectCtrl);

    /** @ngInject */
    function deptSelector(Dlg) {
        return {
            templateUrl: 'directives/form/dept-selector/dept-selector.html',
            restrict: 'E',
            replace: true,
            scope: {
                model: '=ngModel',
                updateMod: '=?', // 是否修改模式，否则是追加模式
                multiSelect: '=?',
                existDepts: '=?',
                placeHolder: '@',
                disabled: '=?'
            },
            require: ['^ngModel', '?^form'],
            link: function link(scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.selectDeptFn = selectDeptFn;
                vm.selectTag = selectTag;
                vm.removeChoice = removeChoice;

                init();


                function init() {
                    vm.multiSelect = angular.isDefined(iAttrs.multiSelect);
                    vm.updateMod = angular.isDefined(iAttrs.updateMod);

                    ngModelCtrl.$isEmpty = vm.multiSelect ? function () {
                        return !vm.model || vm.model.length === 0;
                    } : ngModelCtrl.$isEmpty;
                    if (angular.isUndefined(vm.updateMod)) vm.updateMod = false;
                    if (angular.isUndefined(vm.multiSelect)) vm.multiSelect = false;
                    if (angular.isUndefined(vm.existDepts)) vm.existDepts = [];
                    if (angular.isUndefined(vm.model)) {
                        if (vm.multiSelect) {
                            vm.model = [];
                        }
                    }
                    if (angular.isUndefined(vm.placeHolder)) {
                        vm.placeHolder = '选择科室';
                    }
                    if (angular.isUndefined(vm.disabled)) {
                        vm.disabled = false;
                    }

                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) {
                                checkValidity();
                                iElement.addClass('submitted')
                            }
                        });
                    }
                }

                function checkValidity() {
                    var valid;
                    if (vm.multiSelect) {
                        valid = (!!iAttrs.required) ? (!!ngModelCtrl.$viewValue && ngModelCtrl.$viewValue.length > 0) : true;
                    } else {
                        valid = iAttrs.required ? !!ngModelCtrl.$viewValue : true;
                    }
                    ngModelCtrl.$setValidity('required', valid);
                }

                function selectDeptFn(multiSelect, existDepts) {
                    vm.activeMatchIndex = -1;
                    Dlg.show({
                        template: 'directives/form/dept-selector/dept_selector_dlg.html',
                        ctrl: 'DeptSelectCtrl',
                        data: {multiSelect: multiSelect, model: vm.model, existDepts: existDepts, updateMod: vm.updateMod}
                    }).then(function (params) {
                        if (params.length > 0) {
                            if (!multiSelect) {
                                vm.model = params[0];
                            } else {
                                if (vm.updateMod) {
                                    vm.model = params;
                                } else {
                                    angular.forEach(params, function (dept) {
                                        vm.model.push(dept);
                                    });
                                }
                            }
                        } else {
                            if (!multiSelect) {
                                vm.model = null;
                            } else {
                                vm.model = [];
                            }
                        }
                        ngModelCtrl.$setViewValue(vm.model);
                        checkValidity();
                    }).finally(function () {
                        ngModelCtrl.$setTouched();
                    });
                }

                function selectTag($event, $index) {
                    $event.stopPropagation();
                    vm.activeMatchIndex = $index;
                }

                function removeChoice($event, $index) {
                    vm.activeMatchIndex = -1;
                    $event.stopPropagation();
                    vm.model.splice($index, 1);
                    ngModelCtrl.$setTouched();
                    checkValidity();
                }
            }
        }
    }

    /** @ngInject */
    function DeptSelectCtrl($scope, $uibModalInstance, F, Dept, data) {
        var vm = $scope;
        var updateMod;
        vm.selectTypes = [
            {id: 1, name: '按类型选择', exAll: false, fresh: true},
            {id: 3, name: '按名称选择', fresh: true}
        ];
        vm.curType = vm.selectTypes[0];
        vm.selected = []; //所有选中的人
        vm.loading = false;

        vm.typeSelectedFn = typeSelectedFn;
        vm.selectTypeDepts = selectTypeDepts;
        vm.selectDepts = selectDepts;
        vm.removeSelected = removeSelected;
        vm.clearQuery = clearQuery;
        vm.queryDept = queryDept;
        vm.selectDept = selectDept;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init();


        function init() {
            if (angular.isUndefined(data.title)) {
                vm.title = '科室选择';
            } else {
                vm.title = data.title;
            }
            if (angular.isUndefined(data.multiSelect)) {
                vm.multiSelect = false;
            } else {
                vm.multiSelect = data.multiSelect;
            }
            if (angular.isUndefined(data.updateMod)) {
                updateMod = false;
            } else {
                updateMod = data.updateMod;
            }
            if (angular.isUndefined(data.existDepts)) {
                data.existDepts = [];
            }
            if (angular.isUndefined(data.model)) {
                if (data.multiSelect) data.model = [];
            }
            if (vm.multiSelect && updateMod) {
                vm.selected = angular.copy(data.model);
            }
            vm.typeSelectedFn(0);
        }

        function typeSelectedFn($index) {
            var toType = vm.selectTypes[$index];
            switch (toType.id) {
                case 1:
                    if (toType.fresh) {
                        initDeptSelector();
                        toType.fresh = false;
                    }
                    break;
            }
            vm.curType = toType;
        }

        //
        function selectDept(dept) {
            if (vm.multiSelect) {
                var index = F.indexOfKey(dept.id, vm.selected);
                if (index === -1) {
                    vm.selected.push(dept);
                }
            } else {
                if (vm.selected.length > 0) {
                    vm.selected.splice(0, 1, dept);
                } else {
                    vm.selected.push(dept);
                }
            }
        }


        function initDeptSelector() {
            vm.loading = true;
            Dept.query({opt: 9}, function (resp) {
                vm.loading = false;
                vm.types = resp.dept_types;
                angular.forEach(vm.types, function (type) {
                    angular.forEach(type.depts, function (dept) {
                        if (F.indexOfKey(dept.id, data.existDepts) !== -1 ||
                            (!updateMod && vm.multiSelect && F.indexOfKey(dept.id, data.model) !== -1)) {
                            dept.hide = true;
                        }
                    });
                });
            }, function () {
                vm.loading = false;
            });
        }

        function selectTypeDepts(type) {
            vm.selectDepts(type.depts);
        }

        function selectDepts(depts) {
            angular.forEach(depts, function (d) {
                if (!d.hide) {
                    selectDept(d);
                }
            });
        }

        function removeSelected($index) {
            vm.selected.splice($index, 1);
        }

        function clearQuery() {
            vm.depts = [];
            vm.filterName = '';
        }

        function queryDept(name) {
            if (name != null && name.length > 0) {
                vm.filterName = name;
                vm.loading = true;
                Dept.query({opt: 4, name: name}, function (resp) {
                    var depts = resp.depts;
                    angular.forEach(depts, function (dept) {
                        if (F.indexOfKey(dept.id, data.existDepts) !== -1 ||
                            (!updateMod && vm.multiSelect && F.indexOfKey(dept.id, data.model) !== -1)) {
                            dept.hide = true;
                        }
                    });
                    vm.depts = depts;
                }).$promise.then(function () {

                }).finally(function () {
                    vm.loading = false;
                });
            } else {
                // toaster.warning('请输入科室名称');
                clearQuery();
            }
        }

        function ok(selected) {
            $uibModalInstance.close(selected);
        }
    }
})();
angular.module('c.d')
    .directive('formInputDate', function () {
        return {
            templateUrl: 'directives/form/form-input-date/form-input-date.html',
            restrict: 'E',
            replace: true,
            scope: {
                'model': '=',
                'disabled': '=',
                'notRequired': '=',
                'minDate': '=',
                'maxDate': '=',
                'dateOptions': '=',
                'label': '@',
                'name': '@',
                'dForm': '=',
                'tip': '@',
                'minMode':'@',
                'mode':'@',
                'format':'@'
            },

            controller: function ($scope) {
                if (angular.isUndefined($scope.minMode)) {
                    $scope.minMode = 'day';
                }

                if (angular.isUndefined($scope.mode)) {
                    $scope.mode = 'year';
                }

                if (angular.isUndefined($scope.format)) {
                    $scope.format = 'yyyy-MM-dd';
                }

            }

        }
    });
angular.module('c.d')
    .directive('formInputDatetime', function () {
        return {
            templateUrl: 'directives/form/form-input-datetime/form-input-datetime.html',
            restrict: 'E',
            replace: true,
            scope: {
                'model': '=',
                'disabled': '=',
                'notRequired': '=',
                'minDate': '=',
                'maxDate': '=',
                'dateOptions': '=',
                'label': '@',
                'name': '@',
                'dForm': '=',
                'tip': '@',
                'format':'@'
            },

            controller: function ($scope) {
                if (angular.isUndefined($scope.format)) {
                    $scope.format = 'yyyy-MM-dd';
                }

            }

        }
    });
angular.module('c.d')
    .directive('formInputFloat', function () {
        return {
            templateUrl: 'directives/form/form-input-float/form-input-float.html',
            restrict: 'E',
            replace: true,
            scope: {
                'model': '=',
                'disabled': '=',
                'notRequired': '=',
                'label': '@',
                'decimal': '@',
                'name': '@',
                'minLen': '@',
                'maxLen': '@',
                'pattern': '@',
                'dForm': '=',
                'labelTip': '@',
                'tip': '@'
            },
            controller: function ($scope) {
                if ($scope.minLen == null) {
                    $scope.minLen = 0;
                }
                if ($scope.maxLen == null) {
                    $scope.maxLen = 9999;
                }
            }
        }
    });
angular.module('c.d')
    .directive('formInputNumber', function () {
        return {
            templateUrl: 'directives/form/form-input-number/form-input-number.html',
            restrict: 'E',
            replace: true,
            scope: {
                'model': '=',
                'disabled': '=',
                'notRequired': '=',
                'label': '@',
                'name': '@',
                'minLen': '@',
                'maxLen': '@',
                'pattern': '@',
                'dForm': '=',
                'tip': '@',
                'labelTip': '@',
                'labelCol': '@',
                'formCol': '@'
            },
            controller: function ($scope) {
                if ($scope.minLen == null) {
                    $scope.minLen = 0;
                }
                if ($scope.maxLen == null) {
                    $scope.maxLen = 9999;
                }

                if ($scope.labelCol == undefined || $scope.labelCol == null) {
                    $scope.labelCol = "col-md-4 control-label";
                }

                if ($scope.formCol == undefined || $scope.formCol == null) {
                    $scope.formCol = "col-md-6";
                }
            }
        }
    });
angular.module('c.d')
    .directive('formInputText', function () {
        return {
            templateUrl: 'directives/form/form-input-text/form-input-text.html',
            restrict: 'E',
            replace: true,
            scope: {
                'model': '=',
                'disabled': '=',
                'notRequired': '=',
                'label': '@',
                'name': '@',
                'maxLen': '@',
                'minLen': '@',
                'pattern': '@',
                'dForm': '=',
                'tip': '@',
                'labelTip': '@'
            }

        }
    });
// function inputTableItemPaste(e) {
//     var scope = angular.element(e.srcElement).scope();
//     scope.itemsPaste(e, scope.$parent.$index, scope.$index);
//     e.preventDefault = true;
//     return false;
// }

(function () {
    'use strict';

    angular.module('c.d')
        .directive('inputTable', inputTable);

    function inputTable() {
        return {
            templateUrl: 'directives/form/inputTable/inputTable.html',
            // replace: true,
            restrict: 'EA',
            scope: {
                cols: '=',
                rows: '=',
                $data: '=ngModel',
                changed: '&',
                params: '='
            },
            require: ['^ngModel', '?^form'],
            link: link
        }
    }


    function link(scope, iElement, iAttrs, r) {
        var ngModelCtrl = r[0], formCtrl = r[1];
        var vm = scope;
        var rowCnt = vm.rows;
        var colCnt = vm.cols.length;
        vm.rowCnt = new Array(rowCnt);

        // vm.itemsPaste = itemsPaste;

        init();


        function init() {
            if (angular.isUndefined(vm.$data)) {
                vm.$data = {};
            } else {
                for (var key in vm.$data) {
                    if (isNaN(parseInt(key))) {
                        delete vm.$data[key];
                    }
                }
            }

            if (formCtrl) {
                scope.$watch(function () {
                    return formCtrl.$submitted;
                }, function (submitted) {
                    if (submitted) {
                        checkValidity(vm.$data);
                        iElement.addClass('submitted')
                    }
                });
            }
        }

        // function updateData(row, col, data) {
        //     for (var nr in data) {
        //         for (var nc in data[nr]) {
        //             var r = parseInt(row) + parseInt(nr);
        //             var c = parseInt(col) + parseInt(nc);
        //             if (c < colCnt && r < rowCnt) {
        //                 if (!vm.$data[r]) vm.$data[r] = {};
        //                 vm.$data[r][c] = data[nr][nc];
        //             }
        //         }
        //     }
        // }
        //
        // function itemsPaste(e, row, col) {
        //     if (e && e.clipboardData && e.clipboardData.getData) {
        //         var text = e.clipboardData.getData('text/plain');
        //         var data = [];
        //         var rows = text.split("\n");
        //         for (var r in rows) {
        //             data.push(rows[r].split("\t"));
        //         }
        //         updateData(row, col, data);
        //     }
        //     return false;
        // }

        function checkValidity($data) {
            var valid = true;
            if (!!iAttrs.required) {
                valid = !angular.equals($data, {});
            }
            ngModelCtrl.$setValidity('required', valid);
        }


        scope.$watch('$data', function ($data) {
            for (var i = 0; i < rowCnt; i++) {
                if ($data[i]) {
                    for (var j = 0; j < colCnt; j++) {
                        if ($data[i][j] === "") {
                            delete $data[i][j];
                        }
                    }
                    if (angular.equals($data[i], {})) {
                        delete $data[i];
                    }
                }
            }

            checkValidity($data);
            ngModelCtrl.$setTouched();
            if (vm.changed) {
                vm.changed({params: vm.params});
            }

        }, true);

    }

})();
(function () {
    'use strict';

    angular.module('c')
        .directive('selectAddress', selectAddress)

    /** @ngInject */
    function selectAddress($http, $q, $compile) {
        var cityURL, delay, templateURL;
        delay = $q.defer();
        templateURL = '/directives/form/selectAddress/selectAddress.html';
        cityURL = '/js/city.min.js';
        $http.get(cityURL).success(function (data) {
            return delay.resolve(data);
        });
        return {
            restrict: 'A',
            scope: {
                p: '=',
                a: '=',
                c: '=',
                d: '=',
                ngModel: '='
            },
            link: function (scope, element, attrs) {
                var popup;
                popup = {
                    element: null,
                    backdrop: null,
                    show: function () {
                        return this.element.addClass('active');
                    },
                    hide: function () {
                        this.element.removeClass('active');
                        return false;
                    },
                    resize: function () {
                        if (!this.element) {
                            return;
                        }
                        this.element.css({
                            top: -this.element.height() - 30,
                            'margin-left': -this.element.width() / 2
                        });
                        return false;
                    },
                    focus: function () {
                        $('[ng-model="d"]').focus();
                        return false;
                    },
                    init: function () {
                        element.on('click keydown', function () {
                            popup.show();
                            event.stopPropagation();
                            return false;
                        });
                        $(window).on('click', (function (_this) {
                            return function () {
                                return _this.hide();
                            };
                        })(this));
                        this.element.on('click', function () {
                            return event.stopPropagation();
                        });
                        return setTimeout((function (_this) {
                            return function () {
                                _this.element.show();
                                return _this.resize();
                            };
                        })(this), 500);
                    },
                    test: function () {
                        scope.ngModel = '';
                        if (scope.p) {
                            scope.ngModel += scope.p;
                        }
                        if (scope.c) {
                            scope.ngModel += scope.c;
                        }
                        if (scope.a) {
                            scope.ngModel += scope.a;
                        }
                        if (scope.d) {
                            scope.ngModel += scope.d;
                        }
                        return popup.resize();
                    }
                };
                return delay.promise.then(function (data) {
                    $http.get(templateURL).success(function (template) {
                        var $template;
                        $template = $compile(template)(scope);
                        $('body').append($template);
                        popup.element = $($template[1]);
                        scope.provinces = data;
                        return popup.init();
                    });
                    scope.aSet = {
                        p: function (p) {
                            scope.p = p;
                            scope.c = null;
                            scope.a = null;
                            return scope.d = null;
                        },
                        c: function (c) {
                            scope.c = c;
                            scope.a = null;
                            return scope.d = null;
                        },
                        a: function (a) {
                            scope.a = a;
                            scope.d = null;
                            return popup.focus();
                        }
                    };
                    scope.clear = function () {
                        scope.p = null;
                        scope.c = null;
                        scope.a = null;
                        return scope.d = null;
                    };
                    scope.submit = function () {
                        return popup.hide();
                    };
                    scope.$watch('p', function (newV) {
                        var v, _i, _len, _results;
                        popup.test();
                        if (newV) {
                            _results = [];
                            for (_i = 0, _len = data.length; _i < _len; _i++) {
                                v = data[_i];
                                if (v.p === newV) {
                                    _results.push(scope.cities = v.c);
                                }
                            }
                            return _results;
                        } else {
                            return scope.cities = [];
                        }
                    });
                    scope.$watch('c', function (newV) {
                        var v, _i, _len, _ref, _results;
                        popup.test();
                        if (newV) {
                            _ref = scope.cities;
                            _results = [];
                            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                                v = _ref[_i];
                                if (v.n === newV) {
                                    _results.push(scope.dists = v.a);
                                }
                            }
                            return _results;
                        } else {
                            return scope.dists = [];
                        }
                    });
                    scope.$watch('a', function (newV) {
                        popup.test();
                    });
                    scope.$watch('d', function (newV) {
                        popup.test();
                    });
                });
            }
        };
    }
})();
angular.module('c.d')
    .directive('advice', function () {
        return {
            templateUrl: 'directives/main/advice/advice.html',
            restrict: 'E',
            replace: true,
            scope: {
                'warning': '@',
                'danger': '@'
            }
        }
    });
(function () {
    'use strict';

    angular.module('c')
        .directive('userSelector', userSelector)
        .controller('UserSelectCtrl', UserSelectCtrl);

    /** @ngInject */
    function userSelector(Dlg) {
        return {
            templateUrl: 'directives/form/user-selector/user-selector.html',
            restrict: 'E',
            scope: {
                model: '=ngModel',
                multiSelect: '=?',
                min: "=?",
                onSelect: '&',
                existMembers: '=?',
                placeHolder: '@',
                userType: '=?',
                disabled: '=?',
                showDutyGroupMember: '=?',
                dutyGroupId: '=?',
                showMeetingAbsentUser: '=?',
                meetingId: '=?',
                isSpot: '=?'
            },
            require: ['^ngModel', '?^form'],
            link: function link(scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.selectUserFn = selectUserFn;
                vm.selectTag = selectTag;
                vm.removeChoice = removeChoice;

                init();


                function init() {
                    vm.multiSelect = angular.isDefined(iAttrs.multiSelect);
                    ngModelCtrl.$isEmpty = vm.multiSelect ? function () {
                        return !vm.model || vm.model.length === 0;
                    } : ngModelCtrl.$isEmpty;
                    if (angular.isUndefined(vm.existMembers)) {
                        vm.existMembers = [];
                    }
                    if (angular.isUndefined(vm.model)) {
                        if (vm.multiSelect) vm.model = [];
                    }
                    if (angular.isUndefined(vm.placeHolder)) {
                        vm.placeHolder = '选择成员';
                    }
                    if (angular.isUndefined(vm.disabled)) {
                        vm.disabled = false;
                    }
                    if (angular.isUndefined(vm.showDutyGroupMember)) {
                        vm.showDutyGroupMember = false;
                    }
                    if (angular.isUndefined(vm.showMeetingAbsentUser)) {
                        vm.showMeetingAbsentUser = false;
                    }
                    if (angular.isUndefined(vm.isSpot)) {
                        vm.isSpot = false;
                    }
                    if (angular.isUndefined(vm.userType)) {
                        vm.userType = null;
                    }
                    //if (angular.isUndefined(vm.dutyGroupId)) {
                    //    vm.dutyGroupId = null;
                    //}

                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) {
                                checkValidity();
                                iElement.addClass('submitted')
                            }
                        });
                    }
                }

                function checkValidity() {
                    var valid;
                    if (vm.multiSelect) {
                        var min = vm.min > 1 ? vm.min - 1 : 0;
                        valid = (!!iAttrs.required) ? (!!ngModelCtrl.$viewValue && ngModelCtrl.$viewValue.length > min) : true;
                        if (min > 0) ngModelCtrl.$setValidity('min', valid);
                    } else {
                        valid = iAttrs.required ? !!ngModelCtrl.$viewValue : true;
                    }
                    ngModelCtrl.$setValidity('required', valid);
                }

                function selectUserFn(multiSelect, existMembers, userType) {
                    vm.activeMatchIndex = -1;
                    Dlg.show({
                        template: 'directives/form/user-selector/user_selector_dlg.html',
                        ctrl: 'UserSelectCtrl',
                        data: {
                            multiSelect: multiSelect,
                            model: vm.model,
                            existMembers: existMembers,
                            userType: userType,
                            showDutyGroupMember: vm.showDutyGroupMember,
                            dutyGroupId: vm.dutyGroupId,
                            showMeetingAbsentUser: vm.showMeetingAbsentUser,
                            meetingId: vm.meetingId,
                            isSpot: vm.isSpot
                        }
                    }).then(function (params) {
                        if (params.length > 0) {
                            if (!multiSelect) {
                                vm.model = params[0];
                            } else {
                                vm.model = angular.copy(params);
                            }
                        } else {
                            if (!multiSelect) {
                                vm.model = null;
                            } else {
                                vm.model = [];
                            }
                        }
                        ngModelCtrl.$setViewValue(vm.model);
                        checkValidity();
                        if (vm.onSelect) {
                            vm.onSelect({selectedUser: vm.model});
                        }

                    }).finally(function () {
                        ngModelCtrl.$setTouched();
                    });
                }

                function selectTag($event, $index) {
                    $event.stopPropagation();
                    vm.activeMatchIndex = $index;
                }

                function removeChoice($event, $index) {
                    vm.activeMatchIndex = -1;
                    $event.stopPropagation();
                    vm.model.splice($index, 1);
                    ngModelCtrl.$setTouched();
                    checkValidity();
                }
            }
        }
    }

    /** @ngInject */
    function UserSelectCtrl($scope, $uibModalInstance, ArrayHelper, Api, Dept, User, AdminGroup, Auth,
                            ContactGroup, Meeting, SeniorityStandard, data, JobTitle, $q, NewUser) {
        var cacheGroup;
        var vm = $scope;
        var userId = Auth.getAccount().id;
        vm.query = {};

        vm.selectTypes = [
            {id: 1, name: '科室', exAll: false, fresh: true},
            // {id: 2, name: '按角色选择', exAll: false, fresh: true},
            {id: 3, name: '姓名/胸牌号', fresh: true},
            {id: 4, name: '科管组', fresh: true},
            {id: 5, name: '群', fresh: true},
            {id: 7, name: '层级', fresh: true},
            {id: 8, name: '组合查询', fresh: true},
            {id: 9, name: '年级', fresh: true}
        ];
        vm.curType = vm.selectTypes[0];
        vm.selected = []; //所有选中的人
        vm.pager = {total: 0, page: 1, count: 5};
        vm.loading = false;
        vm.search = {};

        vm.clearQuery = clearQuery;
        vm.queryUser = queryUser;
        vm.queryNurseLevel = queryNurseLevel;
        vm.typeSelectedFn = typeSelectedFn;
        vm.pageChanged = pageChanged;

        vm.toggleSectionNode = toggleSectionNode;
        vm.toggleDeptNode = toggleDeptNode;
        vm.toggleNurseLevelNode = toggleNurseLevelNode;

        vm.toggleContactGroupNode = toggleContactGroupNode;

        vm.selectSectionMembers = selectSectionMembers;
        vm.selectDeptMembers = selectDeptMembers;
        vm.selectDeptTypeMembers = selectDeptTypeMembers;
        vm.selectNurseLevelMembers = selectNurseLevelMembers;
        vm.selectContactGroupMembers = selectContactGroupMembers;

        vm.selectUsers = selectUsers;
        vm.selectUser = selectUser;
        vm.removeSelected = removeSelected;
        vm.removeAll = removeAll;

        vm.deptGroupVisible = deptGroupVisible;
        vm.contactGroupVisible = contactGroupVisible;
        vm.deptTypeVisible = deptTypeVisible;
        vm.sectionVisible = sectionVisible;
        vm.deptVisible = deptVisible;

        vm.userStatusSelectFn = userStatusSelectFn;
        vm.userTypeSelectFn = userTypeSelectFn;
        vm.userTitleSelectFn = userTitleSelectFn;
        vm.getUserDataes = getUserDataes;
        vm.groupByTitle = groupByTitle;

        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;


        init();


        function init() {
            if (angular.isUndefined(data.title)) {
                vm.title = '员工选择';
            } else {
                vm.title = data.title;
            }
            if (angular.isUndefined(data.multiSelect)) {
                vm.multiSelect = false;
            } else {
                vm.multiSelect = data.multiSelect;
            }
            if (angular.isUndefined(data.existMembers)) {
                data.existMembers = [];
            }
            if (angular.isUndefined(data.model)) {
                if (data.multiSelect) {
                    data.model = [];
                }
            }

            vm.selected = vm.multiSelect ? angular.copy(data.model) : data.model ? [data.model] : [];
            if (angular.isUndefined(data.showDutyGroupMember)) {
                vm.showDutyGroupMember = false;
            } else {
                vm.showDutyGroupMember = data.showDutyGroupMember;
            }
            if (angular.isUndefined(data.showMeetingAbsentUser)) {
                vm.showMeetingAbsentUser = false;
            } else {
                vm.showMeetingAbsentUser = data.showMeetingAbsentUser;
            }
            if (angular.isUndefined(data.isSpot)) {
                vm.isSpot = false;
            } else {
                vm.isSpot = data.isSpot;
            }

            if (data.showDutyGroupMember) {
                vm.selectTypes.splice(0, 0, {id: 4, name: '值班组成员', fresh: true});
            }
            if (data.showMeetingAbsentUser) {
                vm.selectTypes.splice(0, 0, {id: 6, name: '会议缺席员工', fresh: true});
            }
            vm.typeSelectedFn(0);
        }

        function typeSelectedFn($index) {
            vm.pager = {total: 0, page: 1, count: 5};
            var toType = vm.selectTypes[$index];
            switch (toType.id) {
                case 1:
                    if (toType.fresh) {
                        initDeptSelector();
                        toType.fresh = false;
                    }
                    break;
                // case 2:
                //     if (toType.fresh) {
                //         initRoleSelector();
                //         toType.fresh = false;
                //     }
                //     break;
                case 3:
                    if (toType.fresh) {
                        initNameSelector();
                        toType.fresh = false;
                    }
                    break;
                case 4:
                    if (toType.fresh) {
                        initDeptAdminGroupSelector();
                        toType.fresh = false;
                    }
                    break;
                case 5:
                    if (toType.fresh) {
                        initContactGroupMembersSelector();
                        toType.fresh = false;
                    }
                    break;
                case 6:
                    if (toType.fresh) {
                        initMeetingAbsentUsersSelector();
                        toType.fresh = false;
                    }
                    break;
                case 7:
                    if (toType.fresh) {
                        initSenioritySelector();
                        toType.fresh = false;
                    }
                    break;
                case 8:
                    initMixSearchSelector();
                    break;
                case 9:
                    if (toType.fresh) {
                        queryNurseLevel();
                        toType.fresh = false;
                    }
            }
            vm.curType = toType;
        }

        function initMixSearchSelector() {
            vm.loading = true;
            $q.all([
                NewUser.query({op: 'searchFilter'}).$promise
            ]).then(function (respArray) {
                vm.loading = false;
                vm.userTypes = respArray[0].types;
                vm.userStatuses = respArray[0].statuses;
                vm.userTitles = respArray[0].titles;
                vm.getUserDataes(vm.pager.page, vm.pager.count);
            });
        }

        function getUserDataes(page, count) {
            var pa = {
                op: 'searchUsers',
                page: page,
                count: count,
                type: vm.userType ? vm.userType.id : undefined,
                title: vm.userTitle ? vm.userTitle.id : undefined,
                status: vm.userStatus ? vm.userStatus.id : undefined
            };
            NewUser.query(pa, function (resp) {
                vm.pager.total = resp.total;
                vm.mixUsers = resp.items;
            });
        }

        function userTitleSelectFn(item) {
            vm.userTitle = item;
            vm.getUserDataes(vm.pager.page, vm.pager.count);
        }

        function userTypeSelectFn(item) {
            vm.userType = item;
            vm.getUserDataes(vm.pager.page, vm.pager.count);
        }

        function userStatusSelectFn(item) {
            vm.userStatus = item;
            vm.getUserDataes(vm.pager.page, vm.pager.count);
        }

        function groupByTitle(item) {
            var titleTypes = JobTitle.getTypes();
            return titleTypes[item.type - 1].name;
        }

        function clearQuery() {
            vm.users = [];
            vm.query.str = '';
            vm.pager.total = 0;
        }

        function queryUser(qStr) {
            if (qStr) {
                vm.query.str = qStr;
                var urlParams = Api.param2Url({
                    opt: 5/*INDEX_USER_INFO_OPTIONS*/,
                    page: vm.pager.page,
                    count: vm.pager.count
                    // exclude: data.existMembers
                });
                urlParams.name = qStr;
                urlParams.user_type = data.userType;
                urlParams.isSpot = vm.isSpot ? '1' : '0';
                vm.loading = true;
                User.query(urlParams).$promise.then(function (resp) {
                    vm.users = resp.items;
                    vm.pager.total = resp.total;
                }).finally(function () {
                    vm.loading = false;
                });
            } else {
                clearQuery();
            }
        }

        function queryNurseLevel() {
            vm.loading = true;
            vm.NLS = [
                {id: 1, name: '1-2年级'},
                {id: 2, name: '3-5年级'},
                {id: 3, name: '6-9年级'},
                {id: 4, name: '10年级及以上'},
            ];
            vm.loading = false;
        }

        function pageChanged() {
            queryUser(vm.query.str);
        }

        function selectUser(user) {
            if (vm.multiSelect) {
                var index = ArrayHelper.indexOfKey(user.id, vm.selected);
                if (index === -1) {
                    vm.selected.push(user);
                }
            } else {
                if (vm.selected.length > 0) {
                    vm.selected.splice(0, 1, user);
                } else {
                    vm.selected.push(user);
                }
            }
        }

        function initMeetingAbsentUsersSelector() {
            vm.loading = true;
            Meeting.getAttendance({opt: 2, id: data.meetingId}, function (resp) {
                vm.loading = false;
                vm.meeting_absent_users = resp.absent_users;
                angular.forEach(resp.absent_users, function (m) {
                    if (ArrayHelper.indexOfKey(m.id, data.existMembers) !== -1) {
                        m.hide = true;
                    }
                });
            }, function () {
                vm.loading = false;
            });
        }

        function initDeptSelector() {
            vm.loading = true;
            Dept.query({opt: 9}, function (resp) {
                vm.loading = false;
                //加入部门，先按部门分类
                angular.forEach(resp.dept_types, function (type) {
                    var sections = [];
                    var otherDepts = [];
                    angular.forEach(type.depts, function (dept) {
                        if (dept.section) {
                            if (!sections[dept.section_id]) {
                                sections[dept.section_id] = {name: dept.section.name, depts: [], sorting: dept.sorting};
                                sections[dept.section_id].depts.push(dept);
                            } else {
                                if (sections[dept.section_id].sorting > dept.sorting) {
                                    sections[dept.section_id].sorting = dept.sorting;
                                }
                                sections[dept.section_id].depts.push(dept);
                            }
                        } else {
                            otherDepts.push(dept);
                        }
                    });
                    type.sections = otherDepts.concat(sections);
                    type.sections = type.sections.filter(function (section) {
                        return section;
                    });
                    type.sections = type.sections.sort(compare('sorting'));
                });
                vm.types = resp.dept_types;
            }, function () {
                vm.loading = false;
            });
        }

        function compare(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            }
        }

        function initDeptAdminGroupSelector() {
            vm.loading = true;
            vm.adminGroups = [];
            AdminGroup.query({op: 'with_members'}, function (resp) {
                vm.loading = false;
                angular.forEach(resp.items, function (item) {
                    if (item.group !== null && item.group.members.length > 0) {
                        vm.adminGroups.push(item);
                        angular.forEach(item.group.members, function (m) {
                            if (ArrayHelper.indexOfKey(m.id, data.existMembers) !== -1) {
                                m.hide = true;
                            }
                        });
                    }
                });

                // vm.adminGroups = resp.items;
                // angular.forEach(resp.items, function (group) {
                //     angular.forEach(group.members, function (m) {
                //         if (ArrayHelper.indexOfKey(m.id, data.existMembers) !== -1 ||
                //             (vm.multiSelect && ArrayHelper.indexOfKey(m.id, data.model) !== -1)) {
                //             m.hide = true;
                //         }
                //     });
                // });
            }, function () {
                vm.loading = false;
            });
        }

        function initNameSelector() {

        }

        // function initDutyGroupMembersSelector() {
        //     vm.loading = true;
        //     DutyGroup.index_members({opt: 1, id: data.dutyGroupId}, function (resp) {
        //         vm.loading = false;
        //         vm.duty_group_members = resp.members;
        //         angular.forEach(resp.members, function (m) {
        //             if (ArrayHelper.indexOfKey(m.id, data.existMembers) !== -1 ||
        //                 (vm.multiSelect && ArrayHelper.indexOfKey(m.id, data.model) !== -1)) {
        //                 m.hide = true;
        //             }
        //         });
        //     }, function () {
        //         vm.loading = false;
        //     });
        // }

        function initContactGroupMembersSelector() {
            vm.loading = true;
            ContactGroup.query({opt: 2}, function (resp) {
                vm.loading = false;
                cacheGroup = resp.groups;

                vm.groups = ArrayHelper.map(cacheGroup, function (g) {
                    return {id: g.id, name: g.name, memberCount: g.members.length};
                });
            }, function () {
                vm.loading = false;
            });
        }


        function initSenioritySelector() {
            vm.loading = true;
            SeniorityStandard.query({opt: 1}, function (resp) {
                vm.loading = false;
                vm.standards = resp;
                angular.forEach(resp, function (standard) {
                    angular.forEach(standard.nurses, function (m) {
                        if (ArrayHelper.indexOfKey(m.id, data.existMembers) !== -1) {
                            m.hide = true;
                        }
                    });
                });
            }, function () {
                vm.loading = false;
            });
        }

        function tagDeptLeader(dept) {
            var index, item;
            if (dept.mail_recipient_id) {
                index = ArrayHelper.indexOfKey(dept.mail_recipient_id, dept.members);
                if (index > 0) {
                    item = ArrayHelper.getItem(dept.mail_recipient_id, dept.members);
                    dept.members.splice(index, 1);
                    dept.members.splice(0, 0, item);
                }
            }

            if (dept.leader_id) {
                index = ArrayHelper.indexOfKey(dept.leader_id, dept.members);
                if (index > 0) {
                    item = ArrayHelper.getItem(dept.leader_id, dept.members);
                    dept.members.splice(index, 1);
                    dept.members.splice(0, 0, item);
                }
            }

            angular.forEach(dept.members, function (m) {
                if (ArrayHelper.indexOfKey(m.id, data.existMembers) !== -1 ||
                    (vm.multiSelect && ArrayHelper.indexOfKey(m.id, data.model) !== -1)) {
                    m.hide = true;
                }
            });
        }

        function toggleSectionNode(section, toggle, node) {
            if (!section.id) {
                toggle(node);
            } else {
                if (section.members) {
                    toggle(node);
                } else {
                    Dept.query({opt: 3, dept_id: section.id}, function (resp) {
                        if (resp.depts && resp.depts.length > 0) {
                            section.members = resp.depts[0].members;
                            tagDeptLeader(section);
                            toggle(node);
                        }
                    });
                }
            }
        }

        function toggleDeptNode(dept, toggle, node) {
            if (dept.members) {
                toggle(node);
            } else {
                Dept.query({opt: 3, dept_id: dept.id, user_type: data.userType}, function (resp) {
                    if (resp.depts && resp.depts.length > 0) {
                        dept.members = resp.depts[0].members;
                        tagDeptLeader(dept);
                        toggle(node);
                    }
                });
            }
        }

        function toggleNurseLevelNode(nl, toggle, node) {
            if (nl.nurses) {
                toggle(node);
            } else {
                User.query({opt: 20, level: nl.id}, function (resp) {
                    if (resp.items && resp.items.length > 0) {
                        nl.nurses = resp.items;
                        tagDeptLeader(nl);
                        toggle(node);
                    }
                });
            }
        }

        function toggleContactGroupNode(group, toggle, node) {
            if (!group.members) {
                var members = ArrayHelper.getItem(group.id, cacheGroup).members;
                angular.forEach(members, function (m) {
                    if (ArrayHelper.indexOfKey(m.id, data.existMembers) !== -1 ||
                        (vm.multiSelect && ArrayHelper.indexOfKey(m.id, data.model) !== -1)) {
                        m.hide = true;
                    }
                });
                group.members = members;
            }
            toggle(node);
        }


        function selectSectionMembers(section, $event) {
            $event.stopPropagation();
            if (section.id) {
                if (section.members) {
                    vm.selectUsers(section.members);
                } else {
                    Dept.query({opt: 3, dept_id: section.id, user_type: data.userType}, function (resp) {
                        if (resp.depts && resp.depts.length > 0) {
                            section.members = resp.depts[0].members;
                            tagDeptLeader(section);
                            vm.selectUsers(section.members);
                        }
                    });
                }
            } else {
                angular.forEach(section.depts, function (dept) {
                    Dept.query({opt: 3, dept_id: dept.id, user_type: data.userType}, function (resp) {
                        if (resp.depts && resp.depts.length > 0) {
                            dept.members = resp.depts[0].members;
                            tagDeptLeader(dept);
                            vm.selectUsers(dept.members);
                        }
                    });
                });
            }
        }


        function selectDeptMembers(dept, $event) {
            $event.stopPropagation();
            if (dept.members) {
                vm.selectUsers(dept.members);
            } else {
                Dept.query({opt: 3, dept_id: dept.id, user_type: data.userType}, function (resp) {
                    if (resp.depts && resp.depts.length > 0) {
                        dept.members = resp.depts[0].members;
                        tagDeptLeader(dept);
                        vm.selectUsers(dept.members);
                    }
                });
            }
        }

        function selectDeptTypeMembers(type, $event) {
            $event.stopPropagation();
            Dept.query({opt: 20, type_id: type.id}, function (resp) {
                var items = resp.items;
                if (items.length > 0) {
                    vm.selectUsers(items);
                }
            });
        }

        function selectNurseLevelMembers(nl, $event) {
            $event.stopPropagation();

            User.query({opt: 20, level: nl.id}, function (resp) {
                var items = resp.items;
                if (items.length > 0) {
                    vm.selectUsers(items);
                }
            });
        }

        function selectContactGroupMembers(group, $event) {
            $event.stopPropagation();
            if (!group.members) {
                var members = ArrayHelper.getItem(group.id, cacheGroup).members;
                angular.forEach(members, function (m) {
                    if (ArrayHelper.indexOfKey(m.id, data.existMembers) !== -1 ||
                        (vm.multiSelect && ArrayHelper.indexOfKey(m.id, data.model) !== -1)) {
                        m.hide = true;
                    }
                });
                group.members = members;
            }
            vm.selectUsers(group.members);
        }

        function selectUsers(members) {
            angular.forEach(members, function (m) {
                if (!m.hide) {
                    selectUser(m);
                }
            });
        }

        function deptGroupVisible(group) {
            return !(vm.search.deptGroup && vm.search.deptGroup.length > 0
                && group.name.indexOf(vm.search.deptGroup) === -1);
        }

        function contactGroupVisible(group) {
            return !(vm.search.contactGroup && vm.search.contactGroup.length > 0
                && group.name.indexOf(vm.search.contactGroup) === -1);
        }

        function deptTypeVisible(type) {
            var visible = !vm.search.dept || vm.search.dept.length === 0;
            if (!visible) {
                for (var i = 0; i < type.sections.length; i++) {
                    var section = type.sections[i];
                    if (!section.depts) {
                        if (section.name.indexOf(vm.search.dept) !== -1) {
                            visible = true;
                            break;
                        }
                    } else {
                        for (var j = 0; j < section.depts.length; j++) {
                            var dept = section.depts[j];
                            if (dept.name.indexOf(vm.search.dept) !== -1) {
                                visible = true;
                                break;
                            }
                        }
                    }
                }
            }
            return visible;
        }

        function sectionVisible(section) {
            var visible = !vm.search.dept || vm.search.dept.length === 0;
            if (!visible) {
                if (!section.depts) {
                    if (section.name.indexOf(vm.search.dept) !== -1) {
                        visible = true;
                    }
                } else {
                    for (var j = 0; j < section.depts.length; j++) {
                        var dept = section.depts[j];
                        if (dept.name.indexOf(vm.search.dept) !== -1) {
                            visible = true;
                            break;
                        }
                    }
                }
            }
            return visible;
        }

        function deptVisible(dept) {
            return !(vm.search.dept && vm.search.dept.length > 0
                && dept.name.indexOf(vm.search.dept) === -1);
        }

        function removeAll() {
            vm.selected = ArrayHelper.filter(vm.selected, function (item) {
                return item._fixed;
            });
        }

        function removeSelected($index) {
            vm.selected.splice($index, 1);
        }

        function ok(selected) {
            $uibModalInstance.close(selected);
        }
    }

})();
(function () {
    'use strict';

    angular.module('c.d')
        .directive('baseData', baseData)
        .controller('BaseDataDlgCtrl', BaseDataDlgCtrl);


    function baseData() {
        return {
            templateUrl: 'directives/main/base-data/base-data.html',
            restrict: 'E',
            replace: true,
            scope: {
                'title': '@',
                'service': '@',
                'maxProtectId': '@'
            },
            controller: baseDataCtrl
        };
    }


    /** @ngInject */
    function baseDataCtrl($scope, $injector, Api, Table) {
        var vm = $scope;
        var service = $injector.get(vm.service);
        vm.addEdit = addEdit;
        vm.setStop = setStop;
        vm.remove = remove;

        init();

        function init() {
            if (angular.isUndefined(vm.maxProtectId)) {
                vm.maxProtectId = 0;
            } else {
                vm.maxProtectId = parseInt(vm.maxProtectId);
            }

            Table.load(vm, {
                service: service,
                params: {opt: 1/*INDEX_ALL*/},
                sorting: {sorting: 'asc'},
                optColWidth: Table._3_BTN,
                hideFilter: true,
                optInFront: true,
                cols: [
                    {field: "name", title: "名称"},
                    {field: "sorting", title: "排序"}
                ]
            });
        }

        function remove(m) {
            Api.delTableItem(service, m.id, vm, vm.title, m.name);
        }

        function setStop(m) {
            Api.setStop(service, m);
        }

        function addEdit(m) {
            Api.addEdit(vm, 'BaseDataDlg', 'BaseDataDlgCtrl', m, {service: service, title: vm.title});
        }
    }

    function BaseDataDlgCtrl($scope, $uibModalInstance, $q, Dlg, data) {
        var vm = $scope;
        var service = data.service;
        vm.title = data.title;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        loadModel(data.id);


        function loadModel(id) {
            if (id) {
                vm.m = service.get({id: id});
            } else {
                vm.m = {sorting: 1}
            }
        }

        function ok(m) {
            var defer = $q.defer();
            if (vm.Form.$valid) {
                var promise;
                var pa = {
                    name: m.name,
                    sorting: m.sorting
                };
                if (m.id) { //修改
                    promise = service.update({id: m.id, opt: 1/*EDIT_SAVE*/}, pa).$promise;
                } else { //添加
                    promise = service.save(pa).$promise;
                }
                promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }).finally(function () {
                    defer.resolve();
                });
            } else {
                Dlg.w('表单中有错误!');
                vm.Form.submitted = true;
                defer.reject();
            }
            return defer.promise;
        }
    }
})();

angular.module('c.d')
    .directive('basicDataTable', function () {
        var controller = function ($rootScope, $scope, $filter, $injector, dialogs, toaster, NgTableParams, Table) {
            var Data = $injector.get($scope.serverName);
            if (angular.isUndefined($scope.maxProtectId)) {
                $scope.maxProtectId = 0;
            } else {
                $scope.maxProtectId = parseInt($scope.maxProtectId);
            }
            var item = $scope.title;

            $scope.optColWidth = 56;

            $scope.tableParams = new NgTableParams({
                page: 1,
                count: 10,
                sorting: {
                    sorting: 'asc'
                }
            }, {
                counts: [5, 10, 15],
                total: 0,
                getData: function ($defer, params) {
                    if (!$scope.cachedData) {
                        Data.query(function (data) {
                            $scope.cachedData = data;
                            angular.forEach(data, function (data) {
                                data.sorting = parseInt(data.sorting);
                                data.id = parseInt(data.id)
                            });
                            if (data.length > 0 && typeof data[0]['is_stop'] != 'undefined') {
                                $scope.has_stop = true;
                            }
                            Table.getTableData(data, $defer, params, $filter);
                        });
                    } else {
                        Table.getTableData($scope.cachedData, $defer, params, $filter);
                    }
                }
            });

            $scope.tableReload = function () {
                $scope.cachedData = null;
                $scope.tableParams.reload();
            };

            $scope.add = function () {
                dialogs.create('templates/basic/data_dlg.html', 'BasicDataDlgCtrl', {title: $scope.title}, {
                    size: 'md'
                }).result.then(function (data) {
                    Data.save(data).$promise.then(function (data) {
                        toaster.success(item + '添加成功!');
                        $scope.tableReload();
                        $rootScope.$broadcast('basicDataChange');
                    }, function () {
                        toaster.error(item + '添加失败!');
                    })
                });
            };

            $scope.edit = function (data) {
                data.$edit = true;
                data.$nameChanged = data.name;
                data.$sortingChanged = data.sorting;
            };

            $scope.save = function (data) {
                data.$edit = false;
                if (data.$nameChanged == "") {
                    toaster.error(item + '名称不能为空!');
                } else if (data.name != data.$nameChanged || data.sorting != data.$sortingChanged) {
                    var params = {};
                    params['name'] = data.$nameChanged;
                    params['sorting'] = data.$sortingChanged;
                    Data.update({id: data.id}, params).$promise.then(function () {
                        toaster.success(item + '修改成功!');
                        data.name = data.$nameChanged;
                        data.sorting = parseInt(data.$sortingChanged);
                        $scope.tableParams.reload();
                        $rootScope.$broadcast('basicDataChange');
                    }, function (error) {
                        toaster.error(item + '修改失败!');
                    });
                }
            };

            $scope.delete = function (data) {
                dialogs.confirm('删除' + item, '确定要删除<strong>' + data.name + '</strong>' + item + '吗?')
                    .result.then(function () {
                    Data.delete({id: data.id}).$promise.then(function (data) {
                        switch (data.result) {
                            case 0:
                                toaster.success(item + '删除成功!');
                                break;
                            case 1:
                                toaster.warning('存在属于该' + item + '的员工记录,因此无法删除该分类!');
                                break;
                        }
                        $scope.tableReload();
                        $rootScope.$broadcast('basicDataChange');
                    }, function () {
                        toaster.error(item + '删除失败!');
                    });
                });
            };
        };

        return {
            templateUrl: 'directives/main/basic-data-table/basic-data-table.html',
            restrict: 'E',
            replace: true,
            scope: {
                'title': '@',
                'serverName': '@',
                'maxProtectId': '@'
            },
            controller: controller
        }
    });
angular.module('c.d')
    .directive('breadcrumb', function () {
        return {
            templateUrl: 'templates/cache/breadcrumb.html',
            restrict: 'E',
            replace: true,
            scope: {
                'current': '@',
                'parent': '@',
                'note': '@'
            },
            controller: function($scope) {
                $scope.mobileMode = false;
                if ($scope.note){
                    var lastWidth = 0;
                    onWindowWidthChange(window.innerWidth);
                }
                function onWindowWidthChange(newWidth) {
                    if (lastWidth > 0) {
                        if (lastWidth < 768 && newWidth >= 768) {
                            $scope.mobileMode = false;

                        } else if (lastWidth > 768 && newWidth <= 768) {
                            $scope.mobileMode = true;
                        }
                    } else {
                        $scope.mobileMode = newWidth < 768;
                    }
                    lastWidth = newWidth;
                }

            }
        }
    });
(function () {
    'use strict';

    angular.module('c.d')
        .directive('footer', footer);

    /** @ngInject */
    function footer(Auth) {
        return {
            templateUrl: 'templates/cache/footer.html',
            restrict: 'E',
            replace: true,
            link: function (scope) {
                scope.vc = Auth.getVisitCnt();
            }
        }
    }
})();
/*
angular.module('c.d')
    .directive('footer', function () {
        return {
            templateUrl: 'templates/cache/footer.html',
            restrict: 'E',
            replace: true
        }
    });*/

(function () {
    'use strict';
    angular.module('c.d')
        .directive('header', function () {
            return {
                templateUrl: 'templates/cache/header.html',
                restrict: 'E',
                controller: ctrl,
                controllerAs: 'header'
            }
        });

    /** @ngInject */
    function ctrl($rootScope, $scope, $state, $stateParams, $timeout, $http, $q, dialogs, C,
                  ArrayHelper, Auth, Email, Sidebar, Dlg) {
        var vm = $rootScope.header = this;
        vm.toggleSidebar = Sidebar.toggle;

        //header-notification
        vm.mails = [];
        vm.tasks = [];
        vm.account = Auth.getAccount();
        var taskFnList = {
            23001: meetingLeaveFn,
            17001: carFillFn
        };
        var firstToggle = true;

        vm.toggleTaskD = toggleTaskD;
        vm.reloadTask = reloadTask;
        vm.reloadMail = reloadMail;
        vm.toTask = toTask;
        vm.readMail = readMail;
        vm.logout = logout;
        vm.blankAccount = blankAccount;

        init();


        function init() {
            $scope.$on(C.P + 'mail.withdraw', function (event, data) {
                var mail = data.data.mail;

                var i = ArrayHelper.indexOfKey(mail.id, vm.mails);
                if (i >= 0) {
                    vm.mails.splice(i, 1);
                }
            });

            $scope.$on('mail.send', function (event, data) {
                var mail = data;
                vm.mails.splice(0, 0, {id: mail.id, subject: mail.subject, created_at: mail.created_at});
            });

            $scope.$on('mailRead', function (event, data) {
                vm.mails = ArrayHelper.except(data, vm.mails);
            });

            $scope.$on('mailDel', function (event, data) {
                if (data) {
                    var id = data;
                    var i = ArrayHelper.indexOfKey(id, vm.mails);
                    if (i >= 0) {
                        vm.mails.splice(i, 1);
                    }
                } else {
                    loadUnreadMail();
                }
            });

            // $scope.$on('openTaskD', function () {
            //     vm.showArrow = true;
            // });

            $scope.$on('newTask', function (evt, data) {
                var task = data.task;

                if (firstToggle) {
                    firstToggle = false;
                    $http.post(C.URL.TASK_ALL, {}).success(function (tasks) {
                        vm.tasks = tasks;
                        vm.hasTask = tasks.length > 0;
                        addTask(task);
                    });
                } else {
                    addTask(task);
                }

                function addTask(task) {
                    var index = ArrayHelper.indexOfKey(task.type, vm.tasks, 'type');
                    if (index === -1) {
                        task.isNew = true;
                        vm.tasks.unshift(task);
                    } else {
                        vm.tasks[index].isNew = true;
                        var tmp = vm.tasks[index];
                        vm.tasks[index] = vm.tasks[0];
                        vm.tasks[0] = tmp;
                    }
                    vm.hasTask = vm.tasks.length > 0;

                    document.getElementById('msgTone2').play();
                    vm.shakePoint = true;
                    $timeout(function () {
                        vm.shakePoint = false;
                    }, 2000);
                }

            });

            // 到main.js中统一加载
            $rootScope.$broadcast('headerLoaded');

            if ($stateParams.pendingDlgOpen === 'true') {
                vm.openTaskD = true;
                toggleTaskD();
            }
        }

        function meetingLeaveFn() {
            dialogs.create(C.T + 'meeting/leave.html', 'MeetingLeaveCtrl', {},
                {size: 'lg'});
        }

        function carFillFn() {
            dialogs.create('pages/dlg/car_manage/carFillDlg.html', 'CarFillCtrl', {},
                {size: 'lg'});
        }

        ////////////////////////////////////////////////////////////////////////
        ////////////////////////header-notification

        function toggleTaskD() {
            if (firstToggle) {
                reloadTask();
                firstToggle = false;
            }
        }

        function reloadMail() {
            var defer = $q.defer();
            vm.mailLoading = true;
            $http.get('/api/v1/emails', {params: {opt: 1}}).success(function (resp) {
                vm.mails = resp.mails;
                defer.resolve();
            }).finally(function () {
                vm.mailLoading = false;
                defer.reject();
            });
            return defer.promise;
        }

        function reloadTask() {
            var defer = $q.defer();
            vm.taskLoading = true;
            $http.post(C.URL.TASK_ALL, {}).success(function (tasks) {
                vm.tasks = tasks;
                vm.hasTask = tasks.length > 0;
                defer.resolve();
            }).finally(function () {
                vm.taskLoading = false;
                defer.reject();
            });
            return defer.promise;
        }

        function loadUnreadMail() {
            // 只会拿最多10个
            Email.query({opt: 1}, function (resp) {
                vm.mails = resp.mails;
            });
        }

        function toTask(task, index) {
            //
            var pa = {tab: task.tag};
            vm.tasks.splice(index, 1);
            vm.hasTask = vm.tasks.length > 0;
            if (task.state) {
                if ($state.current.name === task.state) {
                    $rootScope.$broadcast("tabChange", pa);
                } else {
                    $state.go(task.state, pa);
                }
            } else {
                //function list
                var fn = taskFnList[task.type];
                if (fn) fn();
                else alert("该事件没有处理方法");
            }
        }

        function readMail(mail, $index) {
            dialogs.create(C.V + 'email/show_dlg.html', 'MailShowDlgCtrl', {mail: mail},
                {size: 'lg'}).result.then(function (params) {
                switch (params.opt) {
                    case 1:
                        $state.go('app.coop_email', {
                            tab: 'write',
                            data: {
                                op: 'mailReply',
                                mail: params.mail
                            }
                        });
                        break;
                    case 2:
                        $state.go('app.coop_email', {
                            tab: 'write',
                            data: {
                                op: 'mailForward',
                                mail: params.mail
                            }
                        });
                        break;
                    case 3:
                        Email.rm_from_inbox({mails: [mail.id]}).$promise.then(
                            function () {
                                vm.mails.splice($index, 1);
                                $rootScope.$broadcast('mailDel', mail.id);
                            });
                        break;
                }
            });
        }


        function logout() {
            Auth.logout(function () {
                $state.go('login');
            });
        }

        function blankAccount() {
            Dlg.show({
                template: 'templates/article/show_dlg.html',
                ctrl: 'BulletinShowDlgCtrl',
                data: {
                    //开票信息的通知ID
                    id: 35
                },
                size: 'lg'
            });
        }

    }
})();

angular.module('c.d').directive('inputFloat', function ($filter) {
    var FLOAT_REGEXP_1 = /^\$?\d+.(\d{3})*(\,\d*)$/; //Numbers like: 1.123,56
    var FLOAT_REGEXP_2 = /^\$?\d+,(\d{3})*(\.\d*)$/; //Numbers like: 1,123.56
    var FLOAT_REGEXP_3 = /^\$?\d+(\.\d*)?$/; //Numbers like: 1123.56
    var FLOAT_REGEXP_4 = /^\$?\d+(\,\d*)?$/; //Numbers like: 1123,56

    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ngModelCtrl) {
            if (!ngModelCtrl) {
                return;
            }
            var decimal_digit = scope.$eval(attrs.inputFloat);
            ngModelCtrl.$parsers.push(function (val) {
                if (angular.isUndefined(val) || !val) {
                    var val = '';
                }
                var minus = val[0] == '-';
                var clean = String(val).replace(/[^0-9\.]/g, '');
                var decimalCheck = clean.split('.');
                var positive = scope.$eval(attrs.positive);

                if (!angular.isUndefined(decimalCheck[1])) {
                    decimalCheck[1] = decimalCheck[1].slice(0, decimal_digit);
                    clean = decimalCheck[0] + '.' + decimalCheck[1];
                }

                if (minus && !positive)
                    clean = '-' + clean;

                if (val !== clean) {
                    ngModelCtrl.$setViewValue(clean);
                    ngModelCtrl.$render();
                }
                return clean;
            });

            element.bind('keypress', function (event) {
                if (event.keyCode === 32) {
                    event.preventDefault();
                }
            });
        }
    }
});
angular.module('c.d').
    directive('inputNumber', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attr, ngModelCtrl) {
                function fromUser(text) {
                    var minus = text[0] == '-';
                    var allow_minus = scope.$eval(attr.inputNumber);
                    var transformedInput = text.replace(/[^0-9]/g, '');
                    if (minus && allow_minus)
                        transformedInput = '-' + transformedInput;
                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;  // or return Number(transformedInput)
                }

                ngModelCtrl.$parsers.push(fromUser);
            }
        };
    });
(function () {
    'use strict';

    angular.module('c.d')
        .directive('messageRecipient', messageRecipient);

    function messageRecipient() {
        return {
            templateUrl: 'directives/main/message-recipient/message-recipient.html',
            restrict: 'E',
            scope: {
                // 表明是哪个科室的短信提醒人
                'type': '@',
                'title': '@',
                'desc': '@'
            },
            controller: controller
        }
    }

    /** @ngInject */
    function controller($scope, $q, toaster, MessageRecipient) {
        $scope.title = $scope.title ? $scope.title : '请假提醒人';
        $scope.desc = $scope.desc ? $scope.desc : '设置相应的短信提醒人';

        $scope.reload = function () {
            MessageRecipient.get({id: $scope.type}, function (resp) {
                var r = resp.item;
                if (!r) r = {id: $scope.type};
                $scope.r = r;
            });
        };

        $scope.submit = function (r) {
            var defer = $q.defer();
            if (r.id) {
                var params = {user_id: r.user ? r.user.id : null};
                MessageRecipient.update({id: r.id}, params).$promise.then(function () {
                    toaster.success('设置成功');
                }).finally(function () {
                    defer.resolve();
                });
            } else {
                defer.reject();
            }
            return defer.promise;
        };

        $scope.reset = $scope.reload;
        $scope.reload();
    }

})();









(function () {
    'use strict';

    angular.module('c.d')
        .directive('sidebar', function () {
            return {
                templateUrl: 'templates/cache/sidebar.html',
                restrict: 'E',
                controller: ctrl,
                controllerAs: 'sidebar'
            }
        });

    /** @ngInject */
    function ctrl($scope, $rootScope, Sidebar, Dlg, $state) {
        var STATE = Sidebar.STATE;
        var lastWidth = window.innerWidth;
        var vm = this;
        vm.menuHeight = window.innerHeight - 50;
        vm.firstLvVisible = firstLvVisible;
        vm.secondLvVisible = secondLvVisible;
        vm.check = check;
        vm.subItemCollapse = subItemCollapse;

        init();


        function init() {
            $scope.$on('$destroy', function () {
                $(window).off('resize', _onWindowResize);
            });

            Sidebar.initState();

            Sidebar.bindState($scope);

            Sidebar.getMenuItems(function (menuItems) {
                vm.menuItems = menuItems;
            }, function (err) {
                var data = err.data;
                Dlg.error(data.msg).then(function () {
                    $state.go('login');
                });
            });

            $(window).on('resize', _onWindowResize);
        }

        function subItemCollapse(index) {
            return $rootScope.collapseVar !== index
        }

        function _onWindowResize() {
            var newMenuHeight = window.innerHeight - 50;
            if (vm.menuHeight !== newMenuHeight) vm.menuHeight = newMenuHeight;

            var width = window.innerWidth;
            if (lastWidth < 1200 && width >= 1200) {
                Sidebar.updateState(STATE.VISIBLE);
            } else if (
                (lastWidth >= 1200 && width < 1200) ||
                (lastWidth < 992 && width >= 992)) {
                Sidebar.updateState(STATE.ICON_ONLY);
            } else if (lastWidth >= 568 && width < 568) {
                Sidebar.updateState(STATE.HIDDEN);
            }
            lastWidth = width;
        }

        function check(x) {
            if (x === $rootScope.collapseVar) {
                $rootScope.collapseVar = 0;
            } else {
                $rootScope.collapseVar = x;
            }
        }

        function firstLvVisible(item) {
            var search = vm.search;
            if (!search) return true;
            var secondLv = search.charAt(0) !== '-';
            if (!secondLv) search = search.substr(1, search.length - 1);
            var visible = !search || search.length === 0;
            if (!visible) {
                if (secondLv) {  // 二级菜单检索
                    for (var i = 0; i < item.children.length; i++) {
                        var subItem = item.children[i];
                        if (subItem.display_name.indexOf(search) !== -1) {
                            visible = true;
                            break;
                        }
                    }
                } else {
                    visible = item.display_name.indexOf(search) !== -1
                }
            }
            return visible;
        }

        function secondLvVisible(item) {
            var search = vm.search;
            if (!search) return item.state;
            var secondLv = search.charAt(0) !== '-';
            if (!secondLv) search = search.substr(1, search.length - 1);
            var visible = !search || search.length === 0;
            if (!visible) { // 有输入
                visible = secondLv ? item.display_name.indexOf(search) !== -1 : true;
            }
            return visible && item.state;
        }

    }

})();
(function () {
    'use strict';

    angular.module('c').factory('Sidebar', Sidebar);

    function Sidebar($rootScope, $state, $timeout, $http, $q, ArrayHelper, Dlg) {
        var curState, cachedMenuItems, menuItemRequesting, menuReqDefers = [];
        var STATE = {
            HIDDEN: 0,
            ICON_ONLY: 1,
            VISIBLE: 2
        };

        return {
            STATE: STATE,
            updateState: updateState,
            toggle: toggle,
            bindState: bindState,
            initState: initState,
            getState: function () {
                return curState;
            },
            setupMenuItems: setupMenuItems,
            getMenuItems: getMenuItems,
            hasMenuItems: function () {
                return cachedMenuItems;
            }
        };

        function getMenuItems(successFn, failedFn) {
            if (cachedMenuItems) {
                if (successFn) successFn(cachedMenuItems);
            } else if (menuItemRequesting) {
                var defer = $q.defer();
                menuReqDefers.push(defer);
                defer.promise.then(function () {
                    if (successFn) successFn(cachedMenuItems);
                }, function (err) {
                    if (failedFn) failedFn(err);
                });
            } else {
                menuItemRequesting = true;
                $http.get('/api/v1/menu_items')
                    .success(function (menuItems) {
                        setupMenuItems(menuItems);
                        if (successFn) successFn(menuItems);
                        angular.forEach(menuReqDefers, function (defer) {
                            defer.resolve(menuItems);
                        });
                    })
                    .error(function (err) {
                        if (err.data.msg) Dlg.error(err.data.msg);
                        if (failedFn) failedFn(err);
                        angular.forEach(menuReqDefers, function (defer) {
                            defer.reject(err);
                        });
                    })
                    .finally(function () {
                        menuItemRequesting = false;
                        menuReqDefers = [];
                    });
            }
        }

        function setupMenuItems(menuItems) {
            var states = $state.get();
            angular.forEach(states, function (s) {
                s.can = angular.isUndefined(s.params);
            });

            var index = 0;
            angular.forEach(menuItems, function (item) {
                index++;
                angular.forEach(item.children, function (m) {
                    m.state = ArrayHelper.getItem(m.id, states, 'perm');
                    if (m.state) {
                        m.state.can = true;
                        m.state.index = index;
                    } else {
                        console.error('未注册菜单:', m.id);
                    }
                });
            });

            cachedMenuItems = menuItems;
        }

        function bindState(scope) {
            scope.$on('sidebarState', function (event, state) {
                $timeout(function () {
                    scope.sidebarState = state;
                });
            });
        }

        function toggle() {
            var width = window.innerWidth;
            if (width > 768) {
                if (curState === STATE.VISIBLE) {
                    updateState(STATE.ICON_ONLY);
                } else {
                    updateState(STATE.VISIBLE);
                }
            } else {
                if (curState === STATE.HIDDEN) {
                    updateState(STATE.VISIBLE);
                } else {
                    updateState(STATE.HIDDEN);
                }
            }
        }

        function updateState(state, force) {
            if (force || curState !== state) {
                curState = state;
                $rootScope.$broadcast('sidebarState', curState);
            }
        }

        function initState() {
            var state;
            var width = window.innerWidth;
            if (width > 768 && width <= 1200) {
                state = STATE.ICON_ONLY;
            } else if (width > 1200) {
                state = STATE.VISIBLE;
            } else {
                state = STATE.HIDDEN;
            }
            updateState(state, true);
        }
    }
})();

angular.module('c.d')
    .directive('tabInclude', [function ($parse) {
        var selfIndex = function (element) {
            var arr = element.parent().children();
            var val = element[0];
            var i = arr.length;
            while (i--) {
                if (val == arr[i]) return i;
            }
            return -1
        };

        return {
            require: ['^uibTab', '^uibTabset'],
            restrict: 'A',
            priority: 100,
            compile: function (element, attrs, transclude) {

                var elem = angular.element('<div></div>');
                elem.attr('ng-include', '$include[' + (attrs.ngRepeat ? '$index' : selfIndex(element)) + ']');
                element.append(elem);

                return function postLink(scope, element, attrs) {
                    if (scope.$include == null) {
                        scope.$include = [];
                    }
                    scope.$include.push('');
                    var isolatedScope = scope.$$childTail;
                    // element.isolateScope().$watch('active',
                    isolatedScope.$watch('active',
                        function (newValue) {

                            if (newValue) {
                                scope.$include[scope.$index ? scope.$index : selfIndex(element)] = attrs.tabInclude;
                            }
                        }
                    );
                };
            }
        };
    }]);
(function () {
    'use strict';

    angular.module('c')
        .directive('attachmentDownload', attachmentDownload);

    /** @ngInject */
    function attachmentDownload($compile, Dlg, WxHelper, FileHelper, deviceDetector) {
        return {
            restrict: 'EA',
            scope: {
                attachmentDownload: '=attachmentDownload', // 作为属性时用这个，作为元素时用下面的model
                model: '=ngModel',
                customClass: '@customClass',
                name: '@attachFieldName',
                url: '@',   // 下载访问连接
                // 若未指定url，将由 type + mod 构成： /api/v1/{mod}/{type}/download
                type: '@',  // 附件类型
                mod: '@'    // 模块名称
            },
            compile: function () {
                return {
                    pre: function prelink(scope, iElement, iAttrs, r) {

                        var vm = scope;
                        var att = scope.model ? scope.model : scope.attachmentDownload;
                        var url;

                        vm.download = download;

                        init();
                        

                        function init() {
                            if (scope.attachmentDownload) {
                                $(iElement).click(function () {
                                    download();
                                });
                            } else {
                                var original = iElement.html().trim();
                                if (!original) original = '下载';
                                var elem = '<span>' +
                                    '<a ng-class="customClass" ng-click="download()">' + original;
                                if (angular.isUndefined(iAttrs.hideLoading)) {
                                    elem += '<span ng-show="model.downloading" class="fa fa-circle-o-notch fa-spin text-muted"></span>';
                                }
                                elem += '</a></span>';

                                var layer = angular.element(elem);
                                var el = $compile(layer.contents())(scope);
                                iElement.replaceWith(el);
                            }


                            if (scope.url) {
                                url = scope.url;
                            } else {
                                url = "/api/v1/";
                                if (scope.mod) url += scope.mod + "/";
                                if (scope.type) url += scope.type + "/";
                                url += "download";
                            }
                        }

                        function download() {
                            if (WxHelper.isWechatBrowser() || deviceDetector.isMobile()) {
                                Dlg.show({
                                    template: 'directives/ui/attachmentDownload/attachmentDownloadDlg.html',
                                    ctrl: 'attachmentDownloadDlgCtrl',
                                    data: {attachment: att, name: scope.name},
                                    size: 'sm'
                                });
                            } else {
                                var rename = scope.name ? {name: scope.name} : {};
                                FileHelper.download1(url, att, rename);
                            }
                        }
                    }
                }
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('attachmentDownloadDlgCtrl', attachmentDownloadDlgCtrl);

    /** @ngInject */
    function attachmentDownloadDlgCtrl($scope, $uibModalInstance, UIHelper, $http, data) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;


        init(data.attachment, data.name);


        function init(att, name) {
            var attachment = {
                name: name ? name : att.name,
                filename: att.filename,
                mime: att.mime,
                size: att.size,
            };

            attachment.ico = UIHelper.getIconFromMime(attachment.mime);
            attachment.size = parseInt(attachment.size);

            vm.attachment = attachment;

            $http.post('api/v1/file/download/mk_pub_link', {filename: attachment.filename})
                .success(function (resp) {
                    vm.url = resp;
                });
        }
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .directive('attachmentPreview', attachmentPreview);

    /** @ngInject */
    function attachmentPreview($compile, $http, $timeout, ArrayHelper, Dlg, deviceDetector, OS) {
        var office = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
        var pdf = ['pdf'];
        var img = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];


        return {
            restrict: 'E',
            scope: {
                model: '=ngModel',
                name: '@attachFieldName',
                customClass: '@customClass'
            },
            compile: function () {
                return {
                    pre: function prelink(scope, iElement, iAttrs, r) {
                        var vm = scope;
                        vm.op = {};
                        vm.preview = preview;
                        var type = null;
                        var att = scope.model;
                        var name = scope.name ? att[scope.name] : att.name;

                        init();


                        function init() {
                            var original = iElement.html().trim();
                            if (!original) original = '预览';
                            var elem =
                                '<span>' +
                                '<a class="attachment-preview" ng-class="customClass" ' +
                                'ng-if="type" ng-click="preview(op)"' + 'popover-trigger="outsideClick">' + original + '</a></span>';


                            var layer = angular.element(elem);
                            var el = $compile(layer.contents())(scope);
                            iElement.replaceWith(el);


                            vm.ios = deviceDetector.os === OS.IOS;
                            vm.os = deviceDetector.os;
                            if (!att.filename) return;
                            var extension = att.filename.split('.').pop().toLowerCase();
                            if (ArrayHelper.inArray(extension, office) !== -1) {
                                type = 1;  // office
                            } else if (ArrayHelper.inArray(extension, pdf) !== -1) {
                                type = 2;  // pdf
                            } else if (ArrayHelper.inArray(extension, img) !== -1) {
                                type = 3;  // img
                            }
                            vm.type = type;
                        }

                        function preview() {
                            $http.post('api/v1/file/preview/mk_pub_link', {filename: att.filename})
                                .success(function (resp) {
                                    var docFullUrl = location.protocol + "//" + location.host + resp;
                                    var url = type === 1 ? 'https://view.officeapps.live.com/op/embed.aspx?src=' + docFullUrl :
                                        "/api/v1/file/preview?type=" + type + "&filename=" + resp + "&name=" + name;
                                    if (deviceDetector.isDesktop()) {
                                        var win = window.open(url);
                                        $timeout(function () {
                                            win.document.title = name;
                                        });
                                    } else {
                                        Dlg.show({
                                            template: 'pages/preview/showDlg.html',
                                            ctrl: 'PreviewShowDlgCtrl',
                                            data: {url: url, name: name},
                                            pos: 'right', backdrop: false, size: 'full'
                                        });
                                    }
                                }).error(function (err) {
                                if (err.msg) Dlg.e(err.msg);
                            });
                        }
                    }
                }
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .directive('backTop', backTop)
        .directive('contentBackTop', contentBackTop)
    ;

    /** @ngInject */
    function contentBackTop(UIHelper) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                var e = element[0];

                var backTopIcon = '<i class="fa fa-angle-up back-top" id="backTop" title="回到顶部"></i>';
                backTopIcon = angular.element(backTopIcon);
                backTopIcon.css('position', 'fixed');
                backTopIcon.css('bottom', '80px');
                element.append(backTopIcon);
                backTopIcon.bind('click', function () {
                    UIHelper.scrollTo(undefined, e.id === '' ? undefined : e.id);
                });

                element.bind('scroll', function () {
                    var top = e.scrollTop;
                    if (top > 200) {
                        backTopIcon.fadeIn();
                    } else {
                        backTopIcon.fadeOut();
                    }
                });
            }
        };
    }

    /** @ngInject */
    function backTop() {
        return {
            restrict: 'E',
            template: '<i class="fa fa-angle-up back-top" id="backTop" title="回到顶部"></i>',
            controller: function () {
                $('#backTop').backTop({
                    'position': 200,
                    'speed': 100
                });
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('c')
        .directive('dateSpinner', dateSpinner);

    /** @ngInject */
    function dateSpinner($compile, DateHelper) {
        return {
            restrict: 'E',
            scope: {
                model: '=ngModel'
            },
            require: "^ngModel",
            compile: function () {
                return {
                    pre: function prelink(scope, iElement, iAttrs, ngModelCtrl) {
                        var mode = iAttrs.mode;
                        var vm = scope;
                        vm.prev = prev;
                        vm.next = next;
                        vm.dateChanged = dateChanged;


                        init();


                        function init() {
                            switch (mode) {
                                case 'day':
                                case 'month':
                                case 'year':
                                    vm.dateOptions = {datepickerMode: mode, minMode: mode};
                                    break;
                                default:
                                    vm.dateOptions = {datepickerMode: 'day'};
                                    if (mode !== 'week') mode = 'day';
                            }

                            if (!vm.model) vm.model = new Date();

                            var elem =
                                '<span><div class="btn-group mr-2">' +
                                '<button ng-click="prev(model)" class="btn btn-default btn-sm btn-narrow">' +
                                '<i class="fa fa-angle-left text-muted"></i>' +
                                '</button>' +
                                '<button ng-click="opened=true" class="btn btn-default btn-sm"' +
                                ' uib-datepicker-popup datepicker-popup-template-url="directives/ui/dateSpinner/temp.html"' +
                                ' datepicker-options="dateOptions" ng-change="dateChanged(model)"' +
                                ' ng-model="model" is-open="opened">' +
                                '<i class="fa fa-calendar text-muted"></i>' +
                                '</button>' +
                                '<button ng-click="next(model)" class="btn btn-default btn-sm btn-narrow" ' +
                                'style="margin-left:-1px">' +
                                '<i class="fa fa-angle-right text-muted"></i>' +
                                '</button>' +
                                '</div><span class="text-muted">{{dateText}}</span></span>';
                            var layer = angular.element(elem);
                            iElement.append(layer);
                            $compile(iElement.contents())(scope);
                            dateChanged(vm.model);
                        }

                        function dateChanged(newDate) {
                            if (newDate) {
                                if (mode === 'month' && newDate.getDate() !== 1) {
                                    newDate = new Date(newDate.getFullYear(), newDate.getMonth(), 1);
                                } else if (mode === 'year' && (newDate.getDate() !== 1 || newDate.getMonth() !== 1)) {
                                    newDate = new Date(newDate.getFullYear(), 1, 1);
                                }
                                ngModelCtrl.$setViewValue(newDate);
                                vm.dateText = getDateText(newDate, mode);
                            }
                        }

                        function getDateText(d, mode) {
                            switch (mode) {
                                case 'day':
                                    return DateHelper.date2Str(d);
                                case 'week':
                                    var day = d.getDay();
                                    var dd = new Date();
                                    var monday = new Date(dd.setDate(d.getDate() - day + (day === 0 ? -6 : 1)));
                                    var sunday = new Date(dd.setDate(d.getDate() - day + (day === 0 ? 0 : 7)));
                                    return DateHelper.date2Str(monday) + ' - ' + DateHelper.date2Str(sunday);
                                case 'month':
                                    return DateHelper.date2Str(d, 'yyyy年M月');
                                case 'year':
                                    return DateHelper.date2Str(d, 'yyyy') + '年';
                            }
                        }

                        function prev(curr) {
                            var tmp, newDate;
                            switch (mode) {
                                case 'day':
                                    tmp = curr.getDate() - 1;
                                    newDate = new Date(curr.setDate(tmp));
                                    break;
                                case 'week':
                                    tmp = curr.getDate() - curr.getDay() - 6;
                                    newDate = new Date(curr.setDate(tmp));
                                    break;
                                case 'month':
                                    tmp = curr.getMonth() - 1;
                                    curr.setMonth(tmp);
                                    newDate = new Date(curr.getFullYear(), curr.getMonth(), 1);
                                    break;
                                case 'year':
                                    tmp = curr.getFullYear() - 1;
                                    curr.setFullYear(tmp);
                                    newDate = new Date(curr.getFullYear(), 1, 1);
                                    break;
                            }
                            vm.model = newDate;
                            dateChanged(newDate);
                        }

                        function next(curr) {
                            var tmp, newDate;
                            switch (mode) {
                                case 'day':
                                    tmp = curr.getDate() + 1;
                                    newDate = new Date(curr.setDate(tmp));
                                    break;
                                case 'week':
                                    tmp = curr.getDate() - curr.getDay() + 8;
                                    newDate = new Date(curr.setDate(tmp));
                                    break;
                                case 'month':
                                    tmp = curr.getMonth() + 1;
                                    curr.setMonth(tmp);
                                    newDate = new Date(curr.getFullYear(), curr.getMonth(), 1);
                                    break;
                                case 'year':
                                    tmp = curr.getFullYear() + 1;
                                    curr.setFullYear(tmp);
                                    newDate = new Date(curr.getFullYear(), 1, 1);
                                    break;
                            }
                            vm.model = newDate;
                            dateChanged(newDate);
                        }
                    }
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('c')
        .directive('integerSpinner', integerSpinner);

    /** @ngInject */
    function integerSpinner() {
        return {
            templateUrl: 'directives/ui/integerSpinner/integerSpinner.html',
            restrict: 'E',
            replace: true,
            scope: {
                model: '=ngModel',
                disabled: '=?',
                onChange: '&'
            },
            require: ['^ngModel', '?^form'],
            link: function link(scope, iElement, iAttrs, r) {
                var min = angular.isDefined(iAttrs.min) ? parseInt(iAttrs.min) : 0;
                var max = angular.isDefined(iAttrs.max) ? parseInt(iAttrs.max) : 99999;
                var vm = scope;
                vm.increase = increase;
                vm.decrease = decrease;
                vm.numChanged = numChanged;

                init();


                function init() {
                }

                function numChanged(num) {
                    if (typeof num !== 'number') {
                        num = typeof num === 'undefined' ? min
                            : parseInt(num.replace(/[^0-9]/g, ''));
                    }

                    if (isNaN(num)) {
                        num = min;
                    } else {
                        if (num < min) {
                            num = min;
                        } else if (num > max) {
                            num = max;
                        }
                    }
                    vm.model = num;

                    if (vm.onChange) vm.onChange({num: num});
                }

                function increase() {
                    numChanged(vm.model + 1);
                }

                function decrease() {
                    numChanged(vm.model - 1);
                }


            }
        }
    }

})();
(function () {
    'use strict';

    angular.module('c')
        .directive('pdfPreviewer', pdfPreviewer);

    /** @ngInject */
    function pdfPreviewer($compile, UIHelper) {
        return {
            restrict: 'E',
            scope: {
                pdfUrl: '=url'
                // height: '=height'
            },
            require: [],
            compile: function () {
                return {
                    pre: function prelink(scope, iElement, iAttrs, r) {
                        var id = 'pdf';// + (new Date()).getTime() + (Math.floor(Math.random() * 100000));

                        init();


                        function init() {
                            var elem = '<div class="pdf-wrapper" fullscreen="isFullscreen" loading-container="loading">' +
                                '<ng-pdf template-url="directives/ui/pdfPreviewer/temp.html" canvasid="' + id + '" scale="page-fit">' +
                                '</ng-pdf></div>';
                            var layer = angular.element(elem);
                            iElement.append(layer);
                            $compile(iElement.contents())(scope);
                            scope.loading = true;
                            scope.onLoad = function () {
                                scope.loading = false;
                            }
                        }
                    }
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('c.d')
        .directive('tableOptionTab', tableOptionTab);

    function tableOptionTab() {
        return {
            templateUrl: 'directives/table/tableOptionTab/tableOptionTab.html',
            restrict: 'E',
            scope: {
                options: '=',
                curOptionId: '=ngModel',
                filterName: '@',
                tagTitle: '@',
                redDot: '@',
                // redDotBoolean: '@',
                optionSelect: '&',
                noDataDesc: '@'
            },
            require: ['^ngModel'],
            link: link
        }
    }


    function link(scope, element, attr) {
        var parentCtrl = scope.$parent;
        scope.optionSelected = optionSelected;
        scope.redDotBoolean = angular.isDefined(attr.redDotBoolean);

        function optionSelected(option) {
            // todo: 应该记录 选项变化情况,只有选择改变了才回调
            if (scope.optionSelect()) {
                scope.optionSelect()(option);
            } else {
                var filter = parentCtrl.tableParams.filter();
                scope.curOptionId = filter[scope.filterName] = option.id;
                if (!option.id) delete filter[scope.filterName];
                parentCtrl.tableParams.filter(filter);
            }
        }
    }

})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('DeptRoundLeaveController', DeptRoundLeaveController)


    ;
    /** @ngInject */
    function DeptRoundLeaveController($scope, UIHelper, ArrayHelper, $q, Dept, Round, Table, Dlg) {
        var vm = $scope;
        var roundStates = Table.getNgTableOpts(ArrayHelper.get('round_stages'));
        var yesOrNoOpt = Table.getNgTableOpts(ArrayHelper.get('yesNo'));


        init();

        function init() {
            UIHelper.loadTab(vm, 'leave');

            $q.all([
                Dept.query({opt: 6}).$promise
            ]).then(function(respArray) {
                vm.depts = respArray[0].depts;
                var options = {
                    service: Round,
                    params: {op: 'deptRound', is_work: 0},
                    optColWidth: Table._1_BTN,
                    dateFilters: [{name: 'practice_time'}],
                    optInFront: true,
                    showSn: true,
                    cols: [
                        {field: "name", title: '姓名', filter: {name: 'text'}},
                        {field: "username", title: '胸牌号', filter: {username: 'text'}},
                        {field: "dept", title: '主科室', filter: {dept: 'text'}},
                        {field: "state", title: '轮转状态', filter: {state: 'select'}, data: roundStates}
                    ]
                };

                Table.load(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        if (item.state) {
                            if (item.state == 1 && item.is_confirm == 0) {
                                item.state = {id: '3', name: '科室未确认'};
                            } else {
                                item.state = ArrayHelper.getItem(item.state, ArrayHelper.get('test_stages'));
                            }
                        } else {
                            item.state.name = '状态为空';
                        }
                        if (angular.isDefined(item.leave_time) && item.leave_time != null) {
                            item.time_range = item.entry_time.substr(0, 16) + ' - ' + item.leave_time.substr(0, 16);
                        } else {
                            item.time_range = item.entry_time.substr(0, 16) + "之后";
                        }
                    });
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('DeptRoundWorkforceController', DeptRoundWorkforceController)


    ;
    /** @ngInject */
    function DeptRoundWorkforceController($scope, UIHelper, ArrayHelper, $q, Dept, Round, Table, Dlg) {
        var vm = $scope;
        vm.edit = edit;
        var roundStates = Table.getNgTableOpts(ArrayHelper.get('round_stages'));
        var yesOrNoOpt = Table.getNgTableOpts(ArrayHelper.get('yesNo'));


        init();

        function init() {
            UIHelper.loadTab(vm, 'workforce');

            $q.all([
                Dept.query({opt: 6}).$promise
            ]).then(function(respArray) {
                vm.depts = respArray[0].depts;
                var options = {
                    service: Round,
                    params: {op: 'deptRound', is_work: 1},
                    optColWidth: Table._2_BTN,
                    dateFilters: [{name: 'practice_time'}],
                    optInFront: true,
                    showSn: true,
                    cols: [
                        {field: "is_confirm", title: '科室确认', filter: {is_confirm: 'select'}, data: yesOrNoOpt},
                        {field: "name", title: '姓名', filter: {name: 'text'}},
                        {field: "username", title: '胸牌号', filter: {username: 'text'}},
                        {field: "dept", title: '主科室', filter: {dept: 'text'}},
                        {field: "work_time", title: '科室工作时间', filter: {work_time: 'date_range'}, width: 200},
                        {field: "state", title: '轮转状态', filter: {state: 'select'}, data: roundStates}
                    ]
                };

                Table.load(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        if (item.state) {
                            if (item.state == 1 && item.is_confirm == 0) {
                                item.state = {id: '3', name: '科室未确认'};
                            } else {
                                item.state = ArrayHelper.getItem(item.state, ArrayHelper.get('test_stages'));
                            }
                        } else {
                            item.state.name = '状态为空';
                        }
                        if (angular.isDefined(item.leave_time) && item.leave_time != null) {
                            item.time_range = item.entry_time.substr(0, 16) + ' - ' + item.leave_time.substr(0, 16);
                        } else {
                            item.time_range = item.entry_time.substr(0, 16) + "之后";
                        }
                    });
                });
            });
        }

        function edit(m) {
            Dlg.show({
                template: 'templates/round/dept_edit.html',
                ctrl: 'RoundDeptStateCtrl',
                data: {is_confirm: m.is_confirm, user_dept: m.user_dept}
            }).then(function (params) {
                params.old_round = m;
                params.op = 'deptConfirm';
                Round.update({id: m.id}, params).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.tableReload();
                }, function () {
                    Dlg.e('轮转确认失败');
                })
            });
        }
    }
})();

angular.module('c.c').controller('BasicDataDlgCtrl', function ($scope, $uibModalInstance, toaster, data) {
    $scope.data = {title: data.title};
    $scope.ok = function (data) {
        if ($scope.data_form.$valid) {
            $uibModalInstance.close(data);
        } else {
            $scope.data_form.submitted = true;
            toaster.warning('表单中有错误!');
        }
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});
angular.module('c.c').controller('FloatDlgCtrl', function ($scope, $uibModalInstance, toaster, data) {
    $scope.pa = {title: data.title, label: data.label, icon: data.icon, label_time: data.label_time};

    $scope.put_int = data.put_int;
    $scope.ok = function (pa) {
        if ($scope.c_form.$valid) {
            $uibModalInstance.close(pa);
        } else {
            toaster.warning('请填写数值!');
        }
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});
(function () {
    'use strict';

    angular.module('c.c')
        .controller('CommentDlgCtrl', CommentDlgCtrl);

    /** @ngInject */
    function CommentDlgCtrl($scope, $uibModalInstance, FormHelper, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.ok = ok;

        init();


        function init() {
            vm.m = {};
            vm.params = {
                title: data.title,
                label: data.label ? data.label : '理由',
                icon: data.icon ? data.icon : 'edit',
                withRate: data.withRate,
                notRequired: data.notRequired
            };
            if (data.withRate) {
                vm.satLvs = [
                    {id: 1, name: '非常不满意'},
                    {id: 2, name: '不满意'},
                    {id: 3, name: '较满意'},
                    {id: 4, name: '满意'},
                    {id: 5, name: '非常满意'}
                ];
            }
            if (data.text) {
                vm.m.opinion = data.text;
            }
        }

        function ok(m) {
            FormHelper.handleSubmit(vm, function () {
                if (data.withRate) {
                    vm.close(m);
                } else {
                    vm.close(m.opinion);
                }
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c').controller('EDRCtrl', EDRCtrl);

    /** @ngInject */
    function EDRCtrl($uibModalInstance, FormHelper, FileHelper, DateHelper, data) {
        var vm = this;
        vm.title = data.title;
        vm.icon = data.icon ? data.icon : 'fa-bar-chart';
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init();


        function init() {
            if (data.start) {
                vm.m = {start: data.start, end: data.end};
            } else {
                var date = new Date(), y = date.getFullYear(), m = date.getMonth();
                vm.m = {start: new Date(y, m, 1), end: new Date(y, m + 1, 0)};
            }
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function (defer) {
                var pa = {start: DateHelper.date2Str(m.start), end: DateHelper.date2Str(m.end)};
                if (data.params) {
                    pa = angular.extend(pa, data.params);
                }
                FileHelper.dnExcel(data.url, pa, pa.start + '到' + pa.end + data.title + '.xls', function () {
                    $uibModalInstance.close();
                }).finally(function () {
                    defer.resolve();
                });
            });
        }
    }
})();

angular.module('c.c').controller('MeetingAddAttendanceDlgCtrl',
    function ($scope, $uibModalInstance, toaster, data) {
        $scope.meetingId = data.meetingId;
        $scope.meeting = {
            state: true,
            attendances: []
        };

        $scope.ok = function (meeting) {
            if (meeting.attendances.length == 0) {
                toaster.warning('出席人不能为空!');
            } else {
                var params = {};
                params['state'] = meeting.state ? '1' : '0';
                params['meetingId'] = $scope.meetingId;
                params['attendances'] = [];
                angular.forEach(meeting.attendances, function (attendance) {
                    params['attendances'].push(attendance.id);
                });
                $uibModalInstance.close(params);
            }
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });



angular.module('c.c').controller('MeetingAddLeaveDlgCtrl',
    function ($scope, $uibModalInstance, toaster, data) {
        $scope.meetingId = data.meetingId;
        $scope.meeting = {
            state: true,
            leavers: []
        };

        $scope.ok = function (meeting) {
            if (meeting.leavers.length == 0) {
                toaster.warning('请假人不能为空!');
            } else {
                var params = {};
                params['meetingId'] = $scope.meetingId;
                params['leavers'] = [];
                params['reason'] = meeting.reason;
                angular.forEach(meeting.leavers, function (leaver) {
                    params['leavers'].push(leaver.id);
                });
                $uibModalInstance.close(params);
            }
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });



angular.module('c.c').controller('MeetingAttendanceDetailCtrl',
    function ($scope, $uibModalInstance, $sce, $templateRequest, $timeout, uibDateParser,
              data, toaster, Meeting) {
        Meeting.getAttendance({opt: 1, id: data.id}).$promise.then(
            function (resp) {
                $scope.record = resp;
                $scope.showMore = false;
                var start = new Date(),
                    end = uibDateParser.parse($scope.record.meeting.start_time, 'yyyy-MM-dd HH:mm:ss');
                if (start >= end) {
                    $scope.showMore = true;
                }
            }, function () {
                toaster.pop({
                    type: 'warning', title: '记录不存在', body: '该会议可能已被删除!', onHideCallback: function () {
                        $uibModalInstance.dismiss('cancel');
                    }
                });
            }
        );

        function getDetail(array1, array2) {
            angular.forEach(array1, function (u) {
                array2.push(u.user_name + '<' + u.dept_name + '>');
            });
            return array2;
        }

        var templateUrl = $sce.getTrustedResourceUrl('templates/print/meeting_attendance.html');
        var printStyle;
        $templateRequest(templateUrl).then(function (resp) {
            printStyle = resp;
        });
        $scope.print = function (record) {
            var meeting = record.meeting,
                attendance_users = [],
                late_users = [],
                leavers = [],
                absent_users = [];

            attendance_users = getDetail(record.attendance_users, attendance_users);
            late_users = getDetail(record.late_users, late_users);
            leavers = getDetail(record.leavers, leavers);
            absent_users = getDetail(record.absent_users, absent_users);

            meeting.time_range = meeting.start_time.substr(0, 16) + ' - ' + meeting.end_time.substr(11, 5);
            var w = window.open("", "打印预览");
            var html = '<html><body>';
            html += '<h1 class="title">会议考勤统计情况</h1>';
            html += '<p>会议名称：' + meeting.name + '</p>';
            html += '<p>会议时间：' + meeting.time_range + '</p>';
            if (meeting.room_id) {
                html += '<p>会议地点：' + meeting.room.name + '</p>';
            } else {
                html += '<p>会议地点：' + meeting.place + '</p>';
            }
            if (meeting.moderator_id) {
                html += '<p>申请人：' + meeting.applicant.name + '&emsp;&emsp;&emsp;' + '主持人：' + meeting.moderator.name + '</p>';
            } else {
                html += '<p>申请人：' + meeting.applicant.name + '</p>';
            }
            if ($scope.showMore) {
                html += '<p>出席人次：' + record.attendance_total + '</p>';
                if (record.attendance_users.length > 0) {
                    html += '<p>出席具体情况：' + attendance_users.join('、') + '</p>';
                }
            }
            if ($scope.showMore) {
                html += '<p>迟到人次：' + record.late_total + '</p>';
                if (record.late_users.length > 0) {
                    html += '<p>迟到具体情况：' + late_users.join('、') + '</p>';
                }
            }
            html += '<p>请假人次：' + record.leaver_total + '</p>';
            if (record.leavers.length > 0) {
                html += '<p>请假具体情况：' + leavers.join('、') + '</p>';
            }
            if (meeting.all_attend == '0' && $scope.showMore) {
                html += '<p>缺席人次：' + record.absent_total + '</p>';
                if (record.absent_users.length > 0) {
                    html += '<p>缺席具体情况：' + absent_users.join('、') + '</p>';
                }
            }
            html += '</body></html>';

            w.document.write(html + printStyle);
            w.document.close();
            w.focus();
            $timeout(function () {
                w.print();
                w.close();
            }, 24);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }
)
;
angular.module('c').controller('MeetingAttendanceDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, dialogs, toaster, F, Api, UIHelper, $state, Meeting, PrintHelper, Table, data, MeetingAttendance) {
        $scope.isApplicant = data.isApplicant ? true : false;
        $scope.ForManage = data.ForManage ? true : false;
        $scope.isModerator = data.isModerator ? true : false;
        $scope.isManager = data.isManager ? true : false;

        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
        var options = {
            service: MeetingAttendance,
            params: {meeting_id: data.id, opt: 1},
            hideOpt: (!$scope.isApplicant && !$scope.ForManage && !$scope.isModerator) || $scope.isManager,
            items: 'records',
            cols: [
                {title: '签到员工', filter: {name: 'text'}},
                {title: '签到时间'},
                {title: '是否迟到', filter: {is_late: 'select'}, data: yesNoOpts}
            ]
        };

        Table.loadNgTable($scope, options);

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.add = function () {
            dialogs.create('pages/dlg/meeting/add_attendance_dlg.html', 'MeetingAddAttendanceDlgCtrl', {meetingId: data.id},
                {size: 'lg'}).result.then(function (params) {
                MeetingAttendance.save(params).$promise.then(function () {
                    toaster.success('添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('添加失败!');
                });
            });
        };

        $scope.newBulletin = function () {
            $scope.cancel();
            var absent;
            Meeting.getAttendance({opt: 2, id: data.id}, function (resp) {
                absent = resp;
                Api.loadMod('bulletin', function () {
                    console.log(absent);
                    $state.go('app.coop_bulletin', {
                        tab: 'release',
                        data: {attendance: $scope.tableParams.data, absent: resp}
                    });
                });

            });

        };

        $scope.print = function () {
            if ($scope.tableParams.data.length === 0) {
                toaster.warning('暂无签到数据无法打印!');
            }
            else {

                var i = 0;
                var k;
                PrintHelper.print(window.open('', '打印预览'), '/templates/print/table2.html', function () {
                    var html = '<html><body>';

                    html += '<table class="print">' +
                        '<caption>上锦医院会议签到人员详情</caption>' +
                        '<tbody><tr>';
                    html += '<caption>会议名称：' + $scope.tableParams.data[0].meetings.name
                        + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + '时间:' + $scope.tableParams.data[0].meetings.start_time + '</caption>';

                    html += '<td width="40">序号</td>';
                    html += '<td width="120">姓名</td>';
                    html += '<td width="120">科室</td>';
                    html += '<td width="40">序号</td>';
                    html += '<td width="120">姓名</td>';
                    html += '<td width="120">科室</td>';
                    html += '</tr>';
                    if ($scope.tableParams.data.length % 2 === 0) {
                        k = $scope.tableParams.data.length / 2
                    } else {
                        k = parseInt($scope.tableParams.data.length / 2) + 1;
                    }
                    for (i = 0; i < $scope.tableParams.data.length / 2; i++) {
                        html += '<tr>';
                        html += '<td width="40">' + (i + 1) + '</td>';
                        if ($scope.tableParams.data[i].user.signature) {
                            html += '<td width="120"><img src="' + $scope.tableParams.data[i].user.signature.sign + '" width="120" height="20"/></td>';
                        } else {
                            html += '<td width="120">' + $scope.tableParams.data[i].user.name + '</td>';
                        }
                        html += '<td width="120">' + $scope.tableParams.data[i].user.main_dept.name + '</td>';

                        if (i + k < $scope.tableParams.data.length) {
                            html += '<td width="40">' + (i + 1 + k) + '</td>';
                            if ($scope.tableParams.data[i + k].user.signature) {
                                html += '<td width="120"><img src="' + $scope.tableParams.data[i + k].user.signature.sign + '" width="120" height="20"/></td>';
                            } else {
                                html += '<td width="120">' + $scope.tableParams.data[i + k].user.name + '</td>';
                            }
                            html += '<td width="120">' + $scope.tableParams.data[i + k].user.main_dept.name + '</td></tr>';
                        }
                        else {
                            html += '<td width="40"></td>';
                            html += '<td width="120"></td>';
                            html += '<td width="120"></td></tr>';
                        }
                    }


                    html += '</tbody></table></body></html>';
                    return html;
                });
            }
        };

        $scope.delete = function (record) {
            dialogs.confirm('删除签到信息', '删除<strong>' + record.user.name + '</strong>的签到信息吗?')
                .result.then(function () {
                MeetingAttendance.delete({id: record.id}).$promise.then(function (resp) {
                    toaster.success('删除成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('删除失败!');
                });
            });
        };

    });
angular.module('c.c').controller('DevDetailCtrl',
    function ($rootScope, $scope, $uibModalInstance, dialogs, toaster, $filter, C, F, data, MeetingRoom, Meeting) {
        $scope.date = data.date;

        $scope.$watch('date',
            function () {
                $scope.reload();
            });

        $scope.reload = function () {
            var date = $filter('date')($scope.date, 'yyyy-MM-dd'),
                start = date + ' ' + '00:00:00',
                end = date + ' ' + '23:59:59';
            Meeting.query({opt: 8, start: start, end: end}, function (resp) {
                var meetings = resp.meetings;
                angular.forEach(meetings, function (meeting) {
                    meeting.time_range = meeting.start_time.substr(11, 5) + ' - ' + meeting.end_time.substr(11, 5);
                });
                $scope.meetings = meetings;
            });
        };

        $scope.showDevs = function () {
            dialogs.create('templates/meeting/dev_dlg.html', 'DevDlgCtrl', {},
                { size: 'lg'});
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module('c.c').controller('DevDlgCtrl',
    function ($scope, $filter, $uibModalInstance, dialogs, toaster, NgTableParams, MeetingDevice, F) {
        $scope.dev_types = F.get('device_types');
        var dev_typesOpts = F.getNgTableOpts( $scope.dev_types);


        $scope.cols = [
            {title: '设备名称', filter: {name: 'text'}, field: 'name', show: true},
            {title: '设备类型',  filter: {type: 'select'},  data: dev_typesOpts, field: 'type', show: true}, //6
            {title: '管理科室', filter: {dept_name: 'text'}, field: 'dept_name', show: true}, //6
            {title: '管理员', filter: {admin_name: 'text'}, field: 'admin_name',  show: true}, //6
            {title: '备注', field: 'remark',  width: '30%',show: true} //6
        ];

        $scope.hideOpt = true;
        $scope.optColWidth = 67;
        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 1;
                MeetingDevice.query(url, function (resp) {
                    angular.forEach(resp.devices, function (d) {
                        d.type = F.getItem(d.type, $scope.dev_types);
                    });
                    params.total(resp.total);
                    $defer.resolve(resp.devices);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module('c.c').controller('MeetingEditDlgCtrl',
    function ($rootScope, $scope, $filter, $uibModalInstance, $timeout, toaster, dialogs, Upload, FileHelper,
              SaveAs, C, F, Meeting, MeetingRoom, MeetingDevice, MeetingType, uibDateParser, data, Dlg) {
        $scope.ForApproval = data.ForApproval;
        $scope.ForEdit = data.ForEdit;
        $scope.isHospitalOffice = data.isHospitalOffice;

        function time2SliderVal(time) {
            var hour = parseInt(time.substr(0, 2));
            var minute = parseInt(time.substr(3, 2));
            return hour * 12 + minute / 5;
        }

        Meeting.get({id: data.id}).$promise.then(function (resp) {
            var meeting = resp.meeting;
            meeting['all_attend'] = meeting.all_attend == '1';
            meeting['all_medical'] = meeting.all_medical == '1';
            meeting['all_nurse'] = meeting.all_nurse == '1';
            meeting['all_doctor'] = meeting.all_doctor == '1';
            meeting['is_public'] = meeting.is_public == '1';
            meeting['is_dept'] = meeting.is_dept == '1';
            meeting['with_sms'] = meeting.with_sms == '1';
            meeting['with_sms2'] = meeting.with_sms2 == '1';
            meeting['with_wx'] = meeting.with_wx == '1';

            if (meeting.reminder_time != null) {
                meeting['is_remind'] = true;
            } else {
                meeting['is_remind'] = false;
            }
            if (meeting.wx_reminder_time != null) {
                meeting['is_wx_remind'] = true;
            } else {
                meeting['is_wx_remind'] = false;
            }
            meeting['date'] = uibDateParser.parse(meeting.start_time.substr(0, 10), 'yyyy-MM-dd');
            meeting.s = {
                min: time2SliderVal(meeting.start_time.substr(11, 5)),
                max: time2SliderVal(meeting.end_time.substr(11, 5)),
                options: {
                    floor: 96,
                    ceil: 276,
                    translate: function (val) {
                        var h = Math.floor(val / 12);
                        var m = (val % 12) * 5;
                        return h + ':' + (m >= 10 ? '' : '0') + m;
                    }
                }
            };
            if (meeting.moderator != null) {
                var index = F.indexOfKey(meeting.moderator.id, meeting.attendees);
                if (index >= 0) {
                    meeting.attendees.splice(index, 1);
                }
            }
            $scope.meeting = meeting;
            $scope.searchIdle($scope.meeting);
        }, function () {
            toaster.pop({
                type: 'warning', title: '会议不存在', body: '该会议可能已被删除!', onHideCallback: function () {
                    $uibModalInstance.dismiss('cancel');
                }
            });
        });

        $scope.$watch('meeting.all_attend',
            function (newValue, oldValue) {
                if (newValue) {
                    $scope.meeting.is_public = true;
                    $scope.meeting.is_dept = false;
                    $scope.meeting.attendees = []
                }
            }, true);

        $scope.today = new Date();
        MeetingType.query({opt: 2}, function (resp) {
            $scope.types = resp.items;
        });

        $scope.deleteAttachment = function ($index, meeting) {
            meeting.attachments.splice($index, 1);
        };

        $scope.upload = function (file, meeting, e) {
            FileHelper.upload(C.URL.MEETING_UPLOAD, file, meeting, e);
        };

        $scope.download = function (attachment) {
            FileHelper.download1(C.URL.MEETING_DOWNLOAD, attachment);
        };

        $scope.searchIdle = function (meeting) {
            if (!meeting.date) {
                toaster.warning('会议日期不能为空');
            } else if (meeting.s.min == meeting.s.max) {
                toaster.warning('会议开始和结束时间不能相等');
            } else {
                var date = $filter('date')(meeting.date, 'yyyy-MM-dd');
                var start = date + ' ' + meeting.s.options.translate(meeting.s.min);
                var end = date + ' ' + meeting.s.options.translate(meeting.s.max);
                MeetingRoom.query({opt: 2, start: start, end: end, excludeMeeting: meeting.id}, function (resp) {
                    $scope.rooms = resp.rooms;
                    $scope.rooms.splice(0, 0, {name: '无'});
                    if (meeting.room == null) {
                        meeting.room = $scope.rooms[0];
                    } else {
                        meeting.room = F.getItem(meeting.room.id, $scope.rooms);
                    }
                });

                MeetingDevice.query({opt: 2, start: start, end: end, excludeMeeting: meeting.id}, function (resp) {
                    $scope.devices = resp.devices;
                    var backup = meeting.devices;
                    meeting.devices = [];
                    $timeout(function () {
                        var devices = [];
                        angular.forEach(backup, function (dev) {
                            var device = F.getItem(dev.id, resp.devices);
                            if (device) {
                                devices.push(device);
                            }
                        });
                        meeting.devices = devices;
                    });
                });
            }
        };

        $scope.pass = function (meeting) {
            dialogs.confirm('会议审批', '确定该会议通过审批吗?')
                .result.then(function () {
                    if (meeting.name == null || meeting.name == "") {
                        toaster.warning('名称不能为空!');
                    } else if (!meeting.date) {
                        toaster.warning('会议日期不能为空');
                    } else if (meeting.s.min == meeting.s.max) {
                        toaster.warning('会议开始和结束时间不能相等');
                    } else if (meeting.place == null && meeting.room == null) {
                        toaster.warning('请备注会议地点!');
                    } else if (meeting.place == null && meeting.room.id == null) {
                        toaster.warning('请备注会议地点!');
                    } else if (!meeting.all_attend && !meeting.all_nurse && !meeting.all_medical
                        && !meeting.all_doctor && meeting.attendees.length == 0) {
                        toaster.warning('请填写参会人!');
                    } else if (meeting.content == "") {
                        toaster.warning('内容不能为空!');
                    } else if (!FileHelper.isAttachmentsUploaded(meeting)) {
                        toaster.warning('请等一小会儿,部分附件还在路上');
                    } else {
                        var params = {};
                        params['name'] = meeting.name;
                        var date = $filter('date')(meeting.date, 'yyyy-MM-dd');
                        var start = date + ' ' + meeting.s.options.translate(meeting.s.min);
                        var end = date + ' ' + meeting.s.options.translate(meeting.s.max);
                        params['start_time'] = start;
                        params['end_time'] = end;
                        params['content'] = meeting.content;
                        params['all_attend'] = meeting.all_attend ? '1' : '0';
                        params['all_doctor'] = meeting.all_doctor ? '1' : '0';
                        params['all_medical'] = meeting.all_medical ? '1' : '0';
                        params['all_nurse'] = meeting.all_nurse ? '1' : '0';
                        params['is_public'] = meeting.is_public ? '1' : '0';
                        params['is_dept'] = meeting.is_dept ? '1' : '0';
                        params['type_id'] = meeting.type.id;
                        if (meeting.room == null) {
                            params['room_id'] = null;
                        } else {
                            if (meeting.room.id == null) {
                                params['room_id'] = null;
                            } else {
                                params['room_id'] = meeting.room.id;
                            }
                        }
                        params['place'] = meeting.place;
                        params['dept_id'] = data.deptId;
                        params['attendees'] = [];
                        // if (meeting.all_attend || meeting.all_nurse || meeting.all_medical || meeting.all_doctor) {
                        //     params['with_sms'] = 0;
                        //     params['is_remind'] = 0;
                        // } else {
                        params['with_sms'] = meeting.with_sms ? '1' : '0';
                        params['is_remind'] = meeting.is_remind ? '1' : '0';
                        params['with_wx'] = meeting.with_wx ? '1' : '0';
                        params['is_wx_remind'] = meeting.is_wx_remind ? '1' : '0';
                        // }
                        params['with_sms2'] = meeting.with_sms2 ? '1' : '0';
                        angular.forEach(meeting.attendees, function (attendee) {
                            params['attendees'].push(attendee.id);
                        });
                        if (meeting.moderator != null) {
                            params['moderator_id'] = meeting.moderator.id;
                            var index = F.indexOf(meeting.moderator.id, params['attendees']);
                            if (index >= 0) {
                                params['attendees'].splice(index, 1);
                            }
                        }
                        params['devices'] = [];
                        angular.forEach(meeting.devices, function (dev) {
                            params['devices'].push(dev.id);
                        });
                        params['attachments'] = [];
                        angular.forEach(meeting.attachments, function (attachment) {
                            params['attachments'].push({
                                name: attachment.name, mime: attachment.mime,
                                filename: attachment.filename, size: attachment.size
                            });
                        });
                        params['opt'] = 1;
                        params['isHospitalOffice'] = data.isHospitalOffice;

                        if ((meeting.all_attend || meeting.all_nurse || meeting.all_medical || meeting.all_doctor ||
                            meeting.attendees.length > 30) && (meeting.with_sms || meeting.is_remind)) {
                            Dlg.confirm('该会议因人员较多，短信通知会产生<span class="text-danger">' + '较多的短信费用' + '</span>，确定吗？', function (resp) {
                                $uibModalInstance.close(params);
                            }, '短信费用提示');
                        } else {
                            $uibModalInstance.close(params);
                        }
                    }
                }
            )
        };

        $scope.back = function (meeting) {
            Dlg.comment({title: '退回会议', label: '理由'}, function (opinion) {
                var pa = {
                    remark: opinion,
                    dept_id: data.deptId,
                    opt: 2
                };
                Meeting.update({id: meeting.id}, pa).$promise.then(function () {
                    Dlg.s('退回成功!');
                    $rootScope.$broadcast('meetingBack');
                    $uibModalInstance.close();
                }, function () {
                    Dlg.e('退回失败!');
                })
            });
        };

        $scope.ok = function (meeting) {
            if (meeting.name == null || meeting.name == "") {
                toaster.warning('名称不能为空!');
            } else if (!meeting.date) {
                toaster.warning('会议日期不能为空');
            } else if (meeting.s.min == meeting.s.max) {
                toaster.warning('会议开始和结束时间不能相等');
            } else if (meeting.place == null && meeting.room == null) {
                toaster.warning('请备注会议地点!');
            } else if (meeting.place == null && meeting.room.id == null) {
                toaster.warning('请备注会议地点!');
            } else if (!meeting.all_attend && !meeting.all_nurse && !meeting.all_medical
                && !meeting.all_doctor && meeting.attendees.length == 0) {
                toaster.warning('请填写参会人!');
            } else if (meeting.content == "") {
                toaster.warning('内容不能为空!');
            } else {
                for (var i = 0; i < meeting.attachments.length; i++) {
                    if (meeting.attachments[i].filename == null) {
                        toaster.warning('请等一小会儿,部分附件还在路上');
                        return;
                    }
                }
                var params = {};
                params['name'] = meeting.name;
                var date = $filter('date')(meeting.date, 'yyyy-MM-dd');
                var start = date + ' ' + meeting.s.options.translate(meeting.s.min);
                var end = date + ' ' + meeting.s.options.translate(meeting.s.max);
                params['start_time'] = start;
                params['end_time'] = end;
                params['content'] = meeting.content;
                params['all_attend'] = meeting.all_attend ? '1' : '0';
                params['all_doctor'] = meeting.all_doctor ? '1' : '0';
                params['all_medical'] = meeting.all_medical ? '1' : '0';
                params['all_nurse'] = meeting.all_nurse ? '1' : '0';
                params['is_public'] = meeting.is_public ? '1' : '0';
                params['is_dept'] = meeting.is_dept ? '1' : '0';
                params['type_id'] = meeting.type.id;
                if (meeting.room == null) {
                    params['room_id'] = null;
                } else {
                    if (meeting.room.id == null) {
                        params['room_id'] = null;
                    } else {
                        params['room_id'] = meeting.room.id;
                    }
                }
                params['place'] = meeting.place;
                params['dept_id'] = data.deptId;
                params['attendees'] = [];
                params['with_sms'] = meeting.with_sms ? '1' : '0';
                params['is_remind'] = meeting.is_remind ? '1' : '0';
                params['with_wx'] = meeting.with_wx ? '1' : '0';
                params['is_wx_remind'] = meeting.is_wx_remind ? '1' : '0';
                params['with_sms2'] = meeting.with_sms2 ? '1' : '0';
                angular.forEach(meeting.attendees, function (attendee) {
                    params['attendees'].push(attendee.id);
                });
                if (meeting.moderator != null) {
                    params['moderator_id'] = meeting.moderator.id;
                    var index = F.indexOf(meeting.moderator.id, params['attendees']);
                    if (index >= 0) {
                        params['attendees'].splice(index, 1);
                    }
                }
                params['devices'] = [];
                angular.forEach(meeting.devices, function (dev) {
                    params['devices'].push(dev.id);
                });
                params['attachments'] = [];
                angular.forEach(meeting.attachments, function (attachment) {
                    params['attachments'].push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                });
                params['opt'] = 3;
                if ((meeting.all_attend || meeting.all_nurse || meeting.all_medical || meeting.all_doctor ||
                    meeting.attendees.length > 30) && (meeting.with_sms || meeting.is_remind)) {
                    Dlg.confirm('该会议因人员较多，短信通知会产生<span class="text-danger">' + '较多的短信费用' + '</span>，确定吗？', function (resp) {
                        $uibModalInstance.close(params);
                    }, '短信费用提示');
                } else {
                    $uibModalInstance.close(params);
                }
            }

        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.roomDetail = function () {
            dialogs.create('templates/meeting/room_detail.html', 'RoomDetailCtrl', {
                date: $scope.meeting.date
            }, {size: 'lg'})
        };

        $scope.devDetail = function () {
            dialogs.create('templates/meeting/dev_detail.html', 'DevDetailCtrl', {
                date: $scope.meeting.date
            }, {size: 'lg'})
        };
    });



angular.module('c.c').controller('MeetingLeaveCtrl',
    function ($scope, $uibModalInstance, dialogs, toaster, C, F, Table, Meeting) {
        var vm = $scope;
        vm.approval = approval;
        vm.cancel = $uibModalInstance.dismiss;

        init();
        function init() {
            var options = {
                service: Meeting, params: {opt: 11}, optColWidth: 68, items: 'meetings', hideFilter: true,
                cols: [{title: '会议名称'}, {title: '类型'}, {title: '开会时间'}, {title: '开会地点'}]
            };

            Table.loadNgTable(vm, options, function (data) {
                angular.forEach(data.meetings, function (meeting) {
                    meeting.time_range = meeting.start_time.substr(0, 16) + ' - ' + meeting.end_time.substr(11, 5);
                });
            });
        }

        function approval(meeting) {
            dialogs.create('templates/meeting/leave_dlg.html', 'MeetingLeaveDlgCtrl'
                , {id: meeting.id, isApprovalList: true, isApplicant: true}, {
                     size: 'lg'
                }).result.then(function (params) {
                Meeting.update({id: meeting.id}, params).$promise.then(function () {
                    toaster.success('确认成功!');
                    vm.tableReload();
                });
            });
        }
    });
angular.module('c.c').controller('MeetingLeaveDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce, $timeout, dialogs, toaster, SaveAs, C, F, Table,
              data, MeetingAsk4Leave) {
        $scope.isApplicant = data.isApplicant ? true : false;
        $scope.ForManage = data.ForManage ? true : false;
        $scope.isModerator = data.isModerator ? true : false;
        $scope.isApprovalList = data.isApprovalList;
        $scope.isManager = data.isManager ? true : false;
        $scope.meeting_id = data.id;

        var options = {
            service: MeetingAsk4Leave,
            params: {meeting_id: $scope.meeting_id, opt: 1},
            optColWidth: 68,
            hideFilter: true,
            hideOpt: (!$scope.isApplicant && !$scope.ForManage && !$scope.isModerator) || $scope.isManager,
            items: 'records',
            cols: [
                {title: '请假员工'},
                {title: '请假时间'},
                {title: '请假原因', show: $scope.isApplicant || $scope.ForManage || $scope.isModerator || $scope.isManager},
                {title: '状态'}
            ]
        };

        Table.loadNgTable($scope, options, function (data) {
            $scope.users = data.records;
        });

        $scope.set = function (u) {
            dialogs.confirm('确认请假信息', '确认<strong>' + u.name + '</strong>的请假信息吗?')
                .result.then(function () {
                MeetingAsk4Leave.update({id: u.id}, {opt: 1}).$promise.then(function (resp) {
                    toaster.success('设置成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('设置失败!');
                });
            });
        };

        $scope.unset = function (u) {
            dialogs.confirm('取消请假信息', '取消<strong>' + u.name + '</strong>的请假信息吗?')
                .result.then(function () {
                MeetingAsk4Leave.update({id: u.id}, {opt: 2}).$promise.then(function (resp) {
                    toaster.success('设置成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('设置失败!');
                });
            });
        };

        $scope.delete = function (u) {
            dialogs.confirm('删除请假信息', '删除<strong>' + u.name + '</strong>的请假信息吗?')
                .result.then(function () {
                MeetingAsk4Leave.delete({id: u.id}).$promise.then(function (resp) {
                    toaster.success('删除成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('删除失败!');
                });
            });
        };

        var checker = Table.loadMultiSelectedFn($scope);

        function batch(users, opt) {
            if (!checker.hasChecked()) {
                toaster.warning('请选择处理对象');
                return;
            }
            MeetingAsk4Leave.setAll({leaveIds: checker.getCheckedIds(users), opt: opt}, function () {
                toaster.success('设置成功');
                $scope.tableReload();
            });
        }

        $scope.setAll = function (users) {
            batch(users, 1)
        };

        $scope.unsetAll = function (users) {
            batch(users, 2)
        };

        $scope.deleteAll = function (users) {
            batch(users, 3)
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.ok = function () {
            dialogs.confirm('会议请假信息确认', '确认后不会在首页集中审批提醒,但仍可在请假详情中修改,是否确认?')
                .result.then(function () {
                    var params = {};
                    params['opt'] = 5;
                    $uibModalInstance.close(params);
                }
            )
        };
    })
angular.module('c.c')
    .controller('M2CDlgCtrl', function ($scope, $uibModalInstance, $filter, $sce, C, F, dialogs, toaster,
                                        uibDateParser, ECourse, ESubject, EProject, Meeting, data, FileHelper) {

        $scope.meeting = data.meeting;

        ESubject.query({opt: 4 /*INDEX_ALL_WITH_PROJECT_OPTIONS*/, with_pj: true}, function (resp) {
            $scope.subjects = resp.subjects;
            $scope.grpSubject = function (s) {
                if (s.is_nurse == '1') {
                    return '护理';
                } else {
                    return '非护理';
                }
            };

            angular.forEach(resp.subjects, function (subject) {
                subject.projects.splice(0, 0, {name: '无'})
            });
        });

        function arrayUnique(array) {
            var a = array.concat();
            for (var i = 0; i < a.length; ++i) {
                for (var j = i + 1; j < a.length; ++j) {
                    if (a[i].id === a[j].id)
                        a.splice(j--, 1);
                }
            }
            return a;
        }

        Meeting.getAttendance({opt: 1, id: $scope.meeting.id}).$promise.then(
            function (resp) {
                var attendance_users = resp.attendance_users,
                    leavers = resp.leavers,
                    absent_users = resp.absent_users;
                angular.forEach(attendance_users, function (u) {
                    u.type = '出席';
                });
                angular.forEach(leavers, function (u) {
                    u.type = '请假';
                });
                angular.forEach(absent_users, function (u) {
                    u.type = '缺席';
                });
                $scope.pass_users = attendance_users;
                var continue_users = arrayUnique(leavers.concat(absent_users));
                $scope.users = arrayUnique(continue_users.concat(attendance_users));
                $scope.c = {
                    pass_score: 60,
                    is_retry_allowed: false,
                    for: 1,
                    dept: $scope.meeting.dept,
                    course_ware: {},
                    limit_time: uibDateParser.parse('00:30', 'HH:mm'),
                    title: $scope.meeting.name,
                    pass_users: $scope.pass_users,
                    users: continue_users
                };
            }
        );


        function prompt(c, type) {
            if (c.paper) {
                dialogs.notify('提示', '修改课程' + type + '并不会改变配套测试题中的题目的' + type + ', ' +
                    '若需改变题目' + type + ',请进入测试题中编辑相应题目');
            }
        }

        $scope.subSelectedFn = function (subject, c) {
            $scope.projects = subject.projects;
            c.project = subject.projects[0];
            prompt(c, '学科');
        };

        $scope.pjSelectedFn = function (project, c) {
            prompt(c, '专题');
        };

        $scope.addPaper = function (c) {
            dialogs.create('templates/edu/p/edit_dlg.html', 'EPaperEditDlgCtrl',
                {
                    hideRelease: true,
                    defTitle: (c.title ? c.title : '') + '测试卷',
                    defSubject: c.subject,
                    defProject: c.project
                }, {

                    size: 'lg'
                }).result.then(function (pa) {
                c.paper = pa;
            });
        };

        $scope.editPaper = function (c) {
            dialogs.create('templates/edu/p/edit_dlg.html', 'EPaperEditDlgCtrl',
                {
                    hideRelease: true,
                    paper: c.paper,
                    defSubject: c.subject,
                    defProject: c.project
                }, {

                    size: 'lg'
                }).result.then(function (pa) {
                c.paper = pa;
            });
        };

        $scope.removePaper = function (c) {
            dialogs.confirm('提示', '确定要删除测试题吗?').result.then(function () {
                delete c.paper;
                delete c.pass_score;
                delete c.is_retry_allowed;
            });
        };


        $scope.upload = function (file, courseWare, e) {
            $scope.courseWare = courseWare;
            if (file) {
                courseWare.name = file.name;
                delete courseWare.filename;
            }
            FileHelper.upload1(C.URL.E_COURSE_UPLOAD, file, courseWare, e, {name: 'tmp_dir'}, {tmp_dir: courseWare.tmp_dir});
        };

        function existsSameValues(array1, array2) {
            var array3 = [];
            for (var s in array1) {
                for (var x in array2) {
                    if (array1[s] == array2[x]) {
                        array3.push(array1[s]);
                    }
                }
            }
            return array3;
        }

        $scope.ok = function (c) {
            if (c.users && c.pass_users) {
                var same = existsSameValues(c.users, c.pass_users),
                    sameName = [];
                angular.forEach(same, function (s) {
                    sameName.push(s.user_name)
                });
            }
            if (!c.course_ware.filename) {
                toaster.warning('课件还未上传或正在上传中!');
            } else if (c.subject == null) {
                toaster.warning('请选择所属学科');
            } else if (c.limit_time == '' || c.limit_time == null) {
                toaster.warning('请设置学习时间限制');
            } else if (c.pass_users && c.users && same.length > 0) {
                toaster.warning('获得学分和继续学习存在相同学员' + sameName);
            } else {
                if ($scope.c_form.$valid) {
                    var params = {
                        title: c.title,
                        intro: c.intro,
                        dept_id: c.dept.id,
                        for: c.for,
                        paper: c.paper,
                        pass_score: c.pass_score,
                        credit: c.credit,
                        is_retry_allowed: c.is_retry_allowed,
                        mime: c.course_ware.mime,
                        size: c.course_ware.size,
                        filename: c.course_ware.filename,
                        tmp_dir: c.course_ware.tmp_dir,
                        subject_id: c.subject.id,
                        project_id: c.project.id,
                        limit_time: $filter('date')(c.limit_time, 'HH:mm'),
                        users: F.listKey(c.users),
                        pass_users: F.listKey(c.pass_users)
                    };
                    $uibModalInstance.close(params);
                } else {
                    toaster.warning('表单中有错误!');
                    $scope.c_form.submitted = true;
                }
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module('c.c').controller('MeetingQrcodeDlgCtrl',
    function ($scope, $uibModalInstance, $sce, $templateRequest, $timeout, toaster, C, F, data, Meeting) {
        $scope.meeting = data.meeting;

        Meeting.getQrcode({id: $scope.meeting.id}).$promise.then(
            function (resp) {
                switch (resp.result) {
                    case 0:
                        $scope.url = resp.url;
                        break;
                    case 1:
                        break;
                }
            }, function () {
                toaster.error('生成失败了!');
            }
        );

        var templateUrl = $sce.getTrustedResourceUrl('templates/print/meeting_qrcode.html');
        var printStyle;
        $templateRequest(templateUrl).then(function (resp) {
            printStyle = resp;
        });
        $scope.print = function (meeting) {
            meeting.time_range = meeting.start_time.substr(0, 16) + ' - ' + meeting.end_time.substr(11, 5);
            var w = window.open("", "打印预览");
            var html = '<html><body>';
            html += '<h1 class="title">会议微信扫码签到</h1>';
            html += '<div class="qrcode"><img height="200" width="200" src="' + $scope.url + '"/></div>';
            html += '<p>会议名称：' + meeting.name + '</p>';
            html += '<p>会议时间：' + meeting.time_range + '</p>';
            if (meeting.moderator_id) {
                html += '<p>申请人：' + meeting.applicant.name + '&emsp;&emsp;&emsp;' + '主持人:' + meeting.moderator.name + '</p>';
            } else {
                html += '<p>申请人：' + meeting.applicant.name + '</p>';
            }
            html += '<p>操作步骤说明：</p>';
            html += '<ol><li>打开微信,使用扫一扫功能,扫描二维码签到</li>';
            html += '<li>若未关注公众号,请先关注公众号</li>';
            html += '<li>进入公众号后,若提示未绑定OA账号信息,请点击职工中心绑定到OA</li>';
            html += '<li>完成绑定后点击职工中心,使用会议签到</li>';
            html += '<li>如签到有问题,请联系管理员代为签到</li>';
            html += '<li>请勿拍照,抽查发现未到现场签到者将按重度缺陷处理</li></ol>';
            html += '</body></html>';

            w.document.write(html + printStyle);
            w.document.close();
            w.focus();
            $timeout(function () {
                w.print();
                w.close();
            }, 24);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };


    });
angular.module('c.c').controller('RoomDetailCtrl',
    function ($rootScope, $scope, $uibModalInstance, dialogs, toaster, $filter, C, F, data, MeetingRoom, Meeting) {
        $scope.date = data.date;

        $scope.$watch('date',
            function () {
                $scope.reload();
            });

        $scope.reload = function () {
            var date = $filter('date')($scope.date, 'yyyy-MM-dd'),
                start = date + ' ' + '00:00:00',
                end = date + ' ' + '23:59:59';
            Meeting.query({opt: 7, start: start, end: end}, function (resp) {
                var meetings = resp.meetings;
                angular.forEach(meetings, function (meeting) {
                    meeting.time_range = meeting.start_time.substr(11, 5) + ' - ' + meeting.end_time.substr(11, 5);
                });
                $scope.meetings = meetings;
            });
        };

        $scope.showRooms = function () {
            dialogs.create('templates/meeting/room_dlg.html', 'RoomDlg2Ctrl', {},
                { size: 'lg'});
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module('c.c').controller('RoomDlg2Ctrl',
    function ($scope, $filter, $uibModalInstance, dialogs, toaster, NgTableParams, MeetingRoom, F) {
        var yesNoOpts = F.getNgTableOpts(F.get('yesOrNo2'));
        $scope.yesNo = F.get('yesOrNo2');

        $scope.cols = [
            {title: '会议室名称', filter: {name: 'text'}, field: 'name', show: true},
            {title: '容纳人数', sortable: 'capacity', filter: {capacity: 'number_range'}, field: 'capacity', show: true}, //6
            {title: '管理科室', filter: {dept_name: 'text'}, field: 'dept_name', show: true}, //6
            {title: '投影仪', filter: {has_projector: 'select'}, data: yesNoOpts, field: 'has_projector', show: true}, //6
            {title: '音响', filter: {has_audio: 'select'}, data: yesNoOpts, field: 'has_audio', show: true}, //6
            {title: '电脑', filter: {has_computer: 'select'}, data: yesNoOpts, field: 'has_computer', show: true}, //6
            {title: '管理员', filter: {admin_name: 'text'}, field: 'admin_name', show: true}, //6
            {title: '备注', field: 'remark', width: '61', show: true} //6
        ];

        $scope.numRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.numRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.hideOpt = true;
        $scope.optColWidth = 67;
        $scope.tableParams = new NgTableParams({page: 1, count: 10, sorting: {sorting: 'asc'}}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 1;
                if ($scope.numRangeFilter.capacity != null) {
                    url['startCap'] = $scope.numRangeFilter.capacity.start;
                    url['endCap'] = $scope.numRangeFilter.capacity.end;
                }
                MeetingRoom.query(url, function (resp) {
                    params.total(resp.total);
                    $defer.resolve(resp.rooms);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.numRangeFilter = {};
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module('c.c').controller('MeetingShowDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce, $timeout, dialogs, toaster, SaveAs, C, F, data, Meeting,
              MeetingAttendance, MeetingAsk4Leave, Sms, FileHelper) {
        $scope.ForApplied = data.ForApplied;
        $scope.ForManage = data.ForManage;
        $scope.ForApproval = data.ForApproval;
        $scope.ForLeave = data.ForLeave;
        $scope.ForRemind = data.ForRemind;
        $scope.ForDayRemind = data.ForDayRemind;
        $scope.ForRCancel = data.ForRCancel;
        $scope.isApplicant = data.isApplicant;
        $scope.isModerator = data.isModerator;
        $scope.SmsAgain = data.SmsAgain;
        Meeting.get({id: data.id}).$promise.then(function (resp) {
            var meeting = resp.meeting;
            angular.forEach(meeting.attachments, function (attachment) {
                attachment.ico = F.getIconFromMime(attachment.mime);
                attachment.size = parseInt(attachment.size);
            });
            $scope.meetingContent = $sce.trustAsHtml(meeting.content);
            meeting.time_range = meeting.start_time.substr(0, 16) + ' - ' + meeting.end_time.substr(11, 5);
            if (meeting.moderator != null) {
                var index = F.indexOfKey(meeting.moderator.id, meeting.attendees);
                if (index >= 0) {
                    meeting.attendees.splice(index, 1);
                }
            }
            $scope.meeting = meeting;
            if (!meeting.recipient) {
                $rootScope.$broadcast('MeetingRead', data.id);
            }
        }, function () {
            toaster.pop({
                type: 'warning', title: '会议不存在', body: '该会议可能已被删除!', onHideCallback: function () {
                    $uibModalInstance.dismiss('cancel');
                }
            });
        });

        $scope.download = function (attachment) {
            FileHelper.download1(C.URL.MEETING_DOWNLOAD, attachment);
        };

        //再次短信通知
        $scope.send = function (meeting) {
            dialogs.confirm('发送短信', '确定要通知主持及参会人吗?')
                .result.then(function () {
                    var attendees = [];
                    angular.forEach(meeting.attendees, function (attendee) {
                        attendees.push(attendee.id);
                    });

                    function sendSms(content, recipients) {
                        var pa = {};
                        pa['sign'] = '【成都上锦南府医院】';
                        pa['content'] = content;
                        pa['recipients'] = recipients;
                        Sms.send(pa, function () {
                            toaster.success('短信请求成功!');
                        }, function () {
                            toaster.error('短信请求失败!');
                        });
                    }

                    var content = '请于' + meeting.start_time.substr(0, 16);
                    if (meeting.room != null) {
                        content += '到' + meeting.room.name;
                    } else {
                        content += '到' + meeting.place;
                    }
                    content += '参加《' + meeting.name + '》会议,详情见通知!('
                    + meeting.applicant.name + meeting.applicant.phone + ')';
                    sendSms(content, attendees);

                    content = '请于' + meeting.start_time.substr(0, 16);
                    if (meeting.room != null) {
                        content += '到' + meeting.room.name;
                    } else {
                        content += '到' + meeting.place;
                    }
                    content += '主持《' + meeting.name + '》会议,详情见通知!('
                    + meeting.applicant.name + meeting.applicant.phone + ')';
                    sendSms(content, [meeting.moderator.id]);
                });
        };

        //审批
        $scope.approval = function (meeting) {
            var params = {opt: 3, meeting: meeting};
            $uibModalInstance.close(params);
        };

        //修改
        $scope.edit1 = function (meeting) {
            var params = {opt: 1, meeting: meeting};
            $uibModalInstance.close(params);
        };

        //重新编辑
        $scope.edit2 = function (meeting) {
            var params = {opt: 2, meeting: meeting};
            $uibModalInstance.close(params);
        };

        //请假
        $scope.leave = function (meeting) {
            var params = {opt: 4, meeting: meeting};
            $uibModalInstance.close(params);
        };

        //会前提醒
        $scope.remind1 = function (meeting, op) {
            var params = {opt: 5, meeting: meeting, op: op};
            $uibModalInstance.close(params);
        };

        //取消会前提醒
        $scope.remind2 = function (meeting) {
            var params = {opt: 6, meeting: meeting};
            $uibModalInstance.close(params);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.detail = function (meeting) {
            dialogs.create('templates/meeting/leave_dlg.html', 'MeetingLeaveDlgCtrl', {
                    id: meeting.id,
                    isApplicant: data.isApplicant,
                    isModerator: data.isModerator,
                    ForManage: data.ForManage
                },
                {size: 'lg'});
        };

        $scope.qrcode = function (meeting) {
            dialogs.create('templates/meeting/qrcode_dlg.html', 'MeetingQrcodeDlgCtrl', {meeting: meeting},
                {size: 'md'});
        };

        $scope.attendance = function (meeting) {
            dialogs.create('templates/meeting/attendance_dlg.html', 'MeetingAttendanceDlgCtrl', {
                    id: meeting.id,
                    isApplicant: data.isApplicant,
                    isModerator: data.isModerator,
                    ForManage: data.ForManage
                },
                {size: 'lg'});
        };

        $scope.statistic = function (meeting) {
            dialogs.create('templates/meeting/attendance_detail.html', 'MeetingAttendanceDetailCtrl', {id: meeting.id},
                {size: 'lg'});
        };

        $scope.add = function () {
            dialogs.create('templates/meeting/add_attendance_dlg.html', 'MeetingAddAttendanceDlgCtrl', {meetingId: data.id},
                {size: 'lg'}).result.then(function (params) {
                    MeetingAttendance.save(params).$promise.then(function () {
                        toaster.success('添加成功!');
                    }, function () {
                        toaster.error('添加失败!');
                    });
                });
        };

        $scope.addLeave = function () {
            dialogs.create('templates/meeting/add_leave_dlg.html', 'MeetingAddLeaveDlgCtrl', {meetingId: data.id},
                {size: 'lg'}).result.then(function (params) {
                    MeetingAsk4Leave.save(params).$promise.then(function () {
                        toaster.success('添加成功!');
                    }, function () {
                        toaster.error('添加失败!');
                    });
                });
        };
    });
angular.module('c.c').controller('MissionHistoryDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce, $timeout, dialogs, toaster, SaveAs, C, F, Table,
              data, MissionReport, FileHelper, Mission, Auth) {

        $scope.publish_id = data.publish_id;
        $scope.applicant_id = data.applicant_id;
        $scope.has_new = data.has_new;
        $scope.uid = Auth.getAccount().id;


        var options = {
            service: MissionReport,
            params: {opt: 1, mission_id: data.id, mission_publish_id: data.publish_id},
            optColWidth: 53,
            items: 'reports',
            hideFilter: true,
            hideOpt: true,
            cols: [
                {title: '提交人'},
                {title: '提交时间', sortable: 'created_at', filter: {created_at: 'select'}, field: 'created_at'},
                {title: '查看', width: '10%'}
            ]
        };

        Table.loadNgTable($scope, options, function (resp) {
            angular.forEach(resp.reports, function (report) {
                if (report.publisher_id == resp.userId ||
                    $scope.publish_id == resp.userId ||
                    $scope.applicant_id == resp.userid) {
                    report.forDelete = true;
                    report.showDetail = true;
                }
                angular.forEach(report.attachments, function (attachment) {
                    attachment.ico = F.getIconFromMime(attachment.mime);
                    attachment.size = parseInt(attachment.size);
                });
            });
        });

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.delete_report = function (report) {
            dialogs.confirm('删除提交内容', '确定要删除提交吗?')
                .result.then(function () {
                MissionReport.delete({id: report.id}).$promise.then(function () {
                    $scope.tableReload();
                }, function () {
                    toaster.error('删除失败!');
                })
            })
        };

        $scope.confirm = function () {
            dialogs.confirm('确认提交内容', '确定要确认提交内容吗?')
                .result.then(function () {
                Mission.update({id: data.id}, {op: 'confirm'}).$promise.then(function () {
                    toaster.success('操作成功!');
                    $uibModalInstance.close();
                }, function () {
                    toaster.error('操作失败!');
                })
            })
        };

        $scope.download = function (attachment) {
            FileHelper.download1(C.URL.MISSION_REPORT_DOWNLOAD, attachment);
        };
    });
angular.module('c.c').controller('RegularMissionEditDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce, $timeout, dialogs, toaster, SaveAs, C, F,
              data, RegularMission, Sms) {
        var vm = $scope;
        vm.cancel = cancel;
        vm.submit = submit;

        init();
        function init() {
            RegularMission.get({id: data.id}, function (resp) {
                var mission = resp.item;
                mission.publishers = [];
                mission.coworkers = [];
                angular.forEach(mission.participants, function (participant) {
                    if (participant.is_publish == 1) {
                        mission.publishers.push(participant.user);
                    } else {
                        mission.coworkers.push(participant.user);
                    }
                });
                mission.source = F.getItem(mission.source, F.get('mission_sources'));
                mission.start_time = parseInt(mission.start_time);
                if (mission.is_month_end == 1) {
                    mission.end_time = 28;
                } else {
                    mission.end_time = parseInt(mission.end_time);
                }
                vm.mission = resp.item;
            });
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        //提交操作
        function submit(mission) {
            if (mission.is_delay) {
                params = {opt: 5, mission: mission};
            } else if (mission.is_manage) {
                params = {opt: 12};
                params['publish_id'] = mission.publish.id;
                params['coworkers'] = [];
                angular.forEach(mission.coworkers, function (coworker) {
                    params['coworkers'].push(coworker.id);
                });
                var index = F.indexOf(mission.publish.id, params['coworkers']);
                if (index >= 0) {
                    params['coworkers'].splice(index, 1);
                }
            } else {
                params = {opt: 4, mission: mission};
            }
            $uibModalInstance.close(params);
        }
    });
angular.module('c.c').controller('RegularManageDlgCtrl',
    function ($scope, $uibModalInstance, $sce, $templateRequest, $timeout, dialogs, toaster, C, ArrayHelper, Table,
              Mission, SaveAs, data, MissionReport) {
        var vm = $scope;
        vm.show = show;
        vm.submit = submit;
        vm.edit = edit;
        vm.cancel = cancel;
        var states = Table.getNgTableOpts(ArrayHelper.get('handle_states'));

        init();


        function init() {
            var options = {
                service: Mission,
                showSn: true,
                params: {op: 'regular'/*MISSION.INDEX_MISSION_REGULAR*/, regular_mission_id: data.regular_mission_id},
                sorting: {created_at: 'desc'},
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "state", title: '状态', filter: {state: 'select'}, data: states},
                    {field: "name", title: '名称', filter: {name: 'text'}},
                    {field: "time", title: '任务时间', width: '25%'},
                    {field: "publish", title: '负责人', filter: {publish: 'text'}},
                    {field: "created_at", title: '申请时间', sortable: 'created_at', width: '12%', filter: {created_at: 'date_range'}}
                ]
            };
            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.created_at = item.created_at.substr(0, 10);
                    item.time = item.start_time.substr(0, 10) + '~' + item.end_time.substr(0, 10);
                    item.state = ArrayHelper.getItem(item.state, ArrayHelper.get('handle_states'));
                });
            });
        }

        function show(mission) {
            dialogs.create('pages/dlg/mission/temp/show_dlg.html', 'MissionShowDlgCtrl', {
                    id: mission.id,
                    ForSubmit: true,
                    ForHistory: true
                },
                { size: 'lg'}).result.then(function (params) {
                switch (params.opt) {
                    case 4:
                        vm.submit(mission);
                        break;
                }
            });
        }

        function submit(mission) {
            dialogs.create('templates/mission/submit_dlg.html', 'MissionSubmitDlgCtrl', {},
                { size: 'md'}).result.then(function (pa) {
                params = pa;
                params['mission_id'] = mission.id;
                params['state_id'] = mission.state.id;
                MissionReport.save(params).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('任务进度提交成功');
                                break;
                            case 1:
                                toaster.warning('任务状态错误!');
                                break;
                        }
                    }, function () {
                        toaster.error('任务进度提交失败!');
                    }
                );
            });
        }
        
        function edit(mission) {
            dialogs.create('templates/mission/state_dlg.html', 'MissionStateDlgCtrl', {
                    stateId: mission.state.id,
                    missionId: mission.id,
                    forApplicant: true
                },
                { size: 'md'}).result.then(function (pa) {
                switch (pa.opt){
                    case 1 :
                        dialogs.confirm('删除任务', '确定要删除<strong>' + mission.name + '</strong>吗?')
                            .result.then(function () {
                            Mission.delete({id: mission.id}).$promise.then(function (resp) {
                                toaster.success('删除成功')
                                $scope.tableParams.reload();
                            }, function () {
                                toaster.error('删除失败!');
                            });
                        });
                        break;
                    case 4 :
                        Mission.update({id: mission.id}, {
                            op: 'state_change',
                            state_id : pa.mission.state.id
                        }).$promise.then(function (resp) {
                            switch (resp.result){
                                case 0 :
                                    toaster.success('任务状态修改成功');
                                    $scope.tableParams.reload();
                                    $rootScope.$broadcast('missionStateChange');
                                    break;
                                case 1 :
                                    toaster.error('任务已到期,请为任务延期');
                                    break;
                            }
                        },function () {
                            toaster.error('任务状态修改出错');
                        });
                        break;
                    case 5 :
                        Mission.update({id: mission.id}, {
                            op: 'delay',
                            delay : pa.mission.delay
                        }).$promise.then(function (resp) {
                            switch (resp.result){
                                case 0 :
                                    toaster.success('任务延期成功');
                                    $scope.tableParams.reload();
                                    $rootScope.$broadcast('missionStateChange');
                                    break;
                            }
                        },function () {
                            toaster.error('任务延期失败');
                        });
                        break;
                    case 12 :
                        Mission.update({id: mission.id}, {
                            op: 'participants',
                            publish_id : pa.publish_id,
                            coworkers : pa.coworkers
                        }).$promise.then(function (resp) {
                            switch (resp.result){
                                case 0 :
                                    toaster.success('任务参与人修改成功');
                                    $scope.tableParams.reload();
                                    $rootScope.$broadcast('missionStateChange');
                                    break;
                            }
                        },function () {
                            toaster.error('任务参与人修改出错!');
                        });
                        break;
                }
            });
        }

        function cancel() {
            $uibModalInstance.close();
        }
    });
angular.module('c.c').controller('RegularMissionShowDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce, $timeout, dialogs, toaster,
              SaveAs, C, F, data, RegularMission, $state, FileHelper) {

        var vm = $scope;
        vm.cancel = cancel;
        vm.download = download;
        vm.sms = sms;

        RegularMission.get({id: data.id}).$promise.then(function (resp) {
            var mission = resp.item;
            angular.forEach(mission.attachments, function (attachment) {
                attachment.ico = F.getIconFromMime(attachment.mime);
                attachment.size = parseInt(attachment.size);
            });
            $scope.missionContent = $sce.trustAsHtml(mission.content);
            mission.source = F.getItem(mission.source, F.get('mission_sources'));
            mission.time_range = '每月' + mission.start_time + '号 到 每月';
            if (mission.is_month_end == 1) {
                mission.time_range += "月底";
            } else {
                mission.time_range += mission.end_time + '号';
            }
            mission.publishers = [];
            mission.coworkers = [];
            angular.forEach(mission.participants, function (participant) {
                if (participant.is_publish == 1) {
                    mission.publishers.push(participant.user);
                } else {
                    mission.coworkers.push(participant.user);
                }
            });
            vm.mission = mission;
        }, function () {
            toaster.pop({
                type: 'warning', title: '任务不存在', body: '该任务可能已被删除!', onHideCallback: function () {
                    $uibModalInstance.dismiss('cancel');
                }
            });
        });

        function download(attachment) {
            FileHelper.download1(C.URL.REGULAR_MISSION_DOWNLOAD, attachment);
        }


        //提交操作
        $scope.submit = function (mission) {
            var params = {opt: 4, mission: mission};
            $uibModalInstance.close(params);
        };

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function sms(mission) {
            participants = mission.participants;
            $state.go('app.coop_sms', {
                data: {
                    tab: 'send',
                    event: 'missionSms',
                    mail: participants
                }
            });
        }
    });
// angular.module('c.c').controller('MissionShowDlgCtrl',
//     function ($rootScope, $scope, $uibModalInstance, $sce, $timeout, dialogs, toaster, SaveAs,
//               Auth, C, F, data, Mission, MissionNew, $state, FileHelper) {
//         $scope.user = Auth.getAccount();
//         $scope.ForSubmit = data.ForSubmit;
//         $scope.ForHistory = data.ForHistory;
//         $scope.ForState = data.ForState;
//         Mission.get({id: data.id}).$promise.then(function (resp) {
//                 var mission = resp.mission;
//                 var mission_new = resp.mission_new;
//                 if (mission_new && mission_new.new == '1') {
//                     MissionNew.update({id: mission_new.id}, {'new': '0'});
//                     $rootScope.$broadcast('missionRead');
//                 }
//                 if (mission.is_read == '1') {
//                     Mission.update({id: mission.id}, {'is_read': '0'});
//                     $rootScope.$broadcast('missionRead');
//                 }
//
//                 angular.forEach(mission.attachments, function (attachment) {
//                     attachment.ico = F.getIconFromMime(attachment.mime);
//                     attachment.size = parseInt(attachment.size);
//                 });
//                 $scope.missionContent = $sce.trustAsHtml(mission.content);
//                 mission.state = F.getItem(mission.state, F.get('handle_states'));
//                 mission.source = F.getItem(mission.source, F.get('mission_sources'));
//                 mission.time_range = mission.start_time.substr(0, 16) + ' - ' + mission.end_time.substr(0, 16);
//                 $scope.mission = mission;
//                 $rootScope.$broadcast('MissionRead');
//             },
//             function () {
//                 toaster.pop({
//                     type: 'warning', title: '任务不存在', body: '该任务可能已被删除!', onHideCallback: function () {
//                         $uibModalInstance.dismiss('cancel');
//                     }
//                 });
//             }
//         )
//         ;
//
//         $scope.download = function (attachment) {
//             FileHelper.download1(C.URL.MISSION_DOWNLOAD, attachment);
//         };
//
//
// //提交操作
//         $scope.submit = function (mission) {
//             var params = {opt: 4, mission: mission};
//             $uibModalInstance.close(params);
//         };
//
//         $scope.finish = function (mission) {
//             Mission.update({id: mission.id}, {
//                 opt: 14
//             }).$promise.then(function (resp) {
//                     toaster.success('任务状态修改成功，任务结束提醒');
//                 }, function () {
//                     toaster.error('任务状态修改出错');
//                 });
//         };
//
//
// //$scope.state = function (mission) {
// //    var params = {opt: 5, mission: mission};
// //    $uibModalInstance.close(params);
// //};
//
//         $scope.state = function (mission) {
//             dialogs.create('templates/mission/state_dlg.html', 'MissionStateDlgCtrl', {
//                     stateId: mission.state.id,
//                     missionId: mission.id,
//                     forApplicant: true
//                 },
//                 {size: 'md'}).result.then(function (pa) {
//                     switch (pa.opt) {
//                         case 1 :
//                             $scope.delete(mission);
//                             break;
//                         case 4 :
//                             Mission.update({id: mission.id}, {
//                                 opt: 4,
//                                 state_id: pa.mission.state.id
//                             }).$promise.then(function (resp) {
//                                     switch (resp.result) {
//                                         case 0 :
//                                             toaster.success('任务状态修改成功');
//                                             $rootScope.$broadcast('missionStateChange');
//                                             break;
//                                         case 1 :
//                                             toaster.error('任务已到期,请为任务延期');
//                                             break;
//                                     }
//                                 }, function () {
//                                     toaster.error('任务状态修改出错');
//                                 });
//                             break;
//                         case 5 :
//                             Mission.update({id: mission.id}, {
//                                 opt: 5,
//                                 delay: pa.mission.delay
//                             }).$promise.then(function (resp) {
//                                     switch (resp.result) {
//                                         case 0 :
//                                             toaster.success('任务延期成功');
//                                             $rootScope.$broadcast('missionStateChange');
//                                             break;
//                                     }
//                                 }, function () {
//                                     toaster.error('任务延期失败');
//                                 });
//                             break;
//                         case 12 :
//                             Mission.update({id: mission.id}, {
//                                 opt: 12,
//                                 publish_id: pa.publish_id,
//                                 coworkers: pa.coworkers
//                             }).$promise.then(function (resp) {
//                                     switch (resp.result) {
//                                         case 0 :
//                                             toaster.success('任务参与人修改成功');
//                                             $rootScope.$broadcast('missionStateChange');
//                                             break;
//                                     }
//                                 }, function () {
//                                     toaster.error('任务参与人修改出错!');
//                                 });
//                             break;
//                     }
//                     $uibModalInstance.close(params);
//                 });
//         };
//
//         $scope.history = function (mission) {
//             dialogs.create('templates/mission/history_dlg.html', 'MissionHistoryDlgCtrl', {
//                     id: mission.id,
//                     publish_id: mission.publish.id,
//                     applicant_id: mission.applicant.id
//                 },
//                 {size: 'lg'});
//         };
//
//         $scope.cancel = function () {
//             $uibModalInstance.dismiss('cancel');
//         };
//
//         $scope.sms = function (mission) {
//             participant = mission.coworkers;
//             participant.unshift(mission.publish);
//             if (mission.publish.id != mission.applicant.id)
//                 participant.unshift(mission.applicant);
//             $state.go('app.coop_sms', {
//                 data: {
//                     tab: 'send',
//                     event: 'missionSms',
//                     mail: participant
//                 }
//             });
//         };
//     })
// ;
angular.module('c.c').controller('MissionStateDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce, $timeout, dialogs, toaster, SaveAs, C, F, data, Mission, Sms) {
        
        $scope.states = F.get('handle_states');
        $scope.state_id = data.stateId;
        $scope.forApplicant = data.forApplicant;

        //提交操作
        $scope.submit = function (mission) {
            if(mission.is_delay){
                params = {opt: 5,mission: mission};
            }else if(mission.is_manage){
                params = {opt: 12};
                params['publish_id'] = mission.publish.id;
                params['coworkers'] = [];
                angular.forEach(mission.coworkers, function (coworker) {
                    params['coworkers'].push(coworker.id);
                });
                var index = F.indexOf(mission.publish.id, params['coworkers']);
                if (index >= 0) {
                    params['coworkers'].splice(index, 1);
                }
            }else{
                params = {opt: 4, mission: mission};
            }
            $uibModalInstance.close(params);
        };

        $scope.getPerson = function () {
            Mission.get({id: data.missionId}).$promise.then(function (resp) {
                var mission = resp.mission;
                $scope.mission['publish'] = mission.publish;
                $scope.mission['coworkers'] = mission.coworkers;
            },function () {
                toaster.pop({
                    type: 'warning', title: '任务不存在', body: '该任务可能已被删除!', onHideCallback: function () {
                        $uibModalInstance.dismiss('cancel');
                    }
                });
            });
        };
        $scope.reset =function () {
            var params = [];
            if($scope.state_id == 1){
                params = [2, 4];
            }else if($scope.state_id == 2){
                params = [3, 4];
            }else if($scope.state_id == 4){
                params = [2, 3];
            }
            var states = [];
            angular.forEach(params, function (item) {
                states.push($scope.states[item-1]);
            });
            $scope.mission_states = states;
            $scope.mission = {
                is_delay : false ,
                delay : 0
            };
        };
        $scope.reset();

        // $scope.delete = function () {
        //     var params = {opt: 1};
        //     $uibModalInstance.close(params);
        // };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module('c.c').controller('MissionSubmitDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce, $timeout, dialogs, toaster, SaveAs, C, FileHelper) {
        $scope.submit=function (report) {
            if (report.note == null || report.note == "") {
                toaster.warning('提交内容不能为空!');
            }else {
                var params = {};
                for (var i = 0; i < report.attachments.length; i++) {
                    if (report.attachments[i].filename == null) {
                        toaster.warning('请等一小会儿,部分附件还在路上');
                        return;
                    }
                }
                params['note'] = report.note;
                params['attachments'] = [];
                angular.forEach(report.attachments, function (attachment) {
                    params['attachments'].push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                });
                $uibModalInstance.close(params);
            }
        };
        $scope.reset = function () {
            $scope.report = {
                note : '',
                attachments : []
            };
        };
        $scope.reset();
        $scope.cancel=function () {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.deleteAttachment = function ($index, report) {
            report.attachments.splice($index, 1);
        };

        $scope.upload = function (file, mission, e) {
            FileHelper.upload(C.URL.MISSION_REPORT_UPLOAD, file, mission, e);
        };
    });
angular.module('c.c').controller('RoundDeptStateCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce, $timeout, toaster, SaveAs, C, F, data, User) {

        //提交操作
        $scope.submit = function (round) {
            if(round.is_confirm == false){
                toaster.warning('请确认员工的轮转!');
            }else{
                var params = {};
                params['is_confirm'] = round.is_confirm? 1:0;
                params['post'] = round.post;
                $uibModalInstance.close(params);
            }
        };

        $scope.reset =function () {
            $scope.round = {};
            $scope.round.is_confirm = data.is_confirm == 1;
            if(data.user_dept != null){
                $scope.round.post = data.user_dept.post;
            }else{
                $scope.round.post = '轮转员工';
            }
        };
        $scope.reset();

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
(function () {
    'use strict';

    angular.module('c.c')
        .controller('EditRoundDlgCtrl', EditRoundDlgCtrl)


    ;
    /** @ngInject */
    function EditRoundDlgCtrl($scope, data, $uibModalInstance, dialogs, Round, DateHelper) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.submit = submit;
        vm.save = save;
        var change_round = false;
        var haved_rounds = null;
        var add_info = null;

        reset();

        function reset() {
            if (data.round) {
                vm.depts = data.depts;
                add_info = data.round;
                vm.round = {
                    id: data.round.id,
                    dept: data.round.dept,
                    entry_time: new Date(data.round.entry_time),
                    leave_time: data.round.leave_time == null ? '' : new Date(data.round.leave_time),
                    remark: data.round.remark,
                    is_main: data.round.is_main == 1,
                    is_flex: data.round.is_flex == 1
                };
                haved_rounds = data.haved_rounds.slice();
                haved_rounds.splice(data.index, 1);
                change_round = true;
            } else if (data.round_id) {
                Round.get({id: data.round_id, op: 'editRound', user_id: data.user_id}).$promise.then(function (resp) {
                    vm.depts = resp.items.depts;
                    add_info = resp.items.round;
                    vm.round = {
                        dept: resp.items.round.dept,
                        entry_time: new Date(resp.items.round.entry_time),
                        leave_time: resp.items.round.leave_time == null ? '' : new Date(resp.items.round.leave_time),
                        remark: resp.items.round.remark,
                        is_main: resp.items.round.is_main == 1,
                        is_flex: resp.items.round.is_flex == 1
                    };
                    haved_rounds = resp.items.haved_rounds;
                }, function () {
                    // toaster.pop({
                    //     type: 'warning', title: '轮转信息不存在', body: '无法找到此条轮转信息!', onHideCallback: function () {
                    //         $uibModalInstance.dismiss('cancel');
                    //     }
                    // });
                    Dlg.msg('轮转信息不存在', '无法找到此条轮转信息!', function () {
                        $uibModalInstance.dismiss('cancel');
                    })
                });
                change_round = true;
            } else {
                vm.depts = data.depts;
                vm.round = {
                    dept: vm.depts[0],
                    entry_time: new Date(),
                    leave_time: new Date(new Date().valueOf() + 1 * 24 * 60 * 60 * 1000),   //自动加一天
                    remark: '',
                    is_main: true,
                    is_flex: false
                };
                haved_rounds = data.haved_rounds;
            }
        }

        function submit(round) {
            var repeat = false, repeat_round = null;
            if (round.is_main) {
                angular.isObject(round.entry_time) ? round.entry_time.setHours(8, 0, 0, 0)
                    : round.entry_time = null;
                angular.isObject(round.leave_time) ? round.leave_time.setHours(8, 0, 0, 0)
                    : round.leave_time = null;
                if (haved_rounds != null) {
                    var round_entry = null, round_leave = null;
                    angular.forEach(haved_rounds, function (haved_round) {
                        round_entry = new Date(haved_round.entry_time);
                        if (haved_round.leave_time == null) {
                            if (round.leave_time == null || round.leave_time > round_entry) {
                                repeat = true;
                                repeat_round = haved_round;
                            }
                        } else {
                            round_leave = new Date(haved_round.leave_time);
                            if (!(round_leave < round.entry_time || round_entry > round.leave_time)) {
                                repeat = true;
                                repeat_round = haved_round;
                            }
                        }
                    })
                }
            }
            if (round.dept == null) {
                Dlg.w('请填入轮转科室');
            } else if (round.entry_time == round.leave_time) {
                Dlg.w('开始时间不能等于结束时间');
            } else if (round.leave_time != null && round.entry_time > round.leave_time) {
                Dlg.w('开始时间不能大于结束时间');
            } else if (repeat && repeat_round.is_main == 1) {
                Dlg.w('添加轮转与' + repeat_round.dept.name + '轮转冲突');
            } else {
                if (repeat) {
                    Dlg.confirm('要添加的轮转与<strong>' + repeat_round.dept.name + '</strong>轮转时间上冲突,是否确认添加?', function (resp) {
                        save(round);
                    }, '轮转冲突');
                } else {
                    save(round);
                }
            }
        }

        function save(round) {
            var params = {};
            params['is_confirm'] = 0;
            if (add_info != null) {
                params['user_dept_id'] = add_info.user_dept_id;
                params['is_confirm'] = add_info.is_confirm;
                params['user_dept'] = add_info.user_dept;
            }
            params['dept'] = round.dept;
            params['dept_id'] = round.dept.id;
            params['user_id'] = data.user_id;
            params['entry_time'] = DateHelper.date2Str(round.entry_time);
            params['leave_time'] = DateHelper.date2Str(round.leave_time);
            params['remark'] = round.remark;
            params['is_main'] = round.is_main ? 1 : 0;
            params['is_flex'] = round.is_flex ? 1 : 0;
            if (change_round) {
                params['id'] = round.id;
            }
            $uibModalInstance.close(params);
        }
    }
})();

angular.module('c.c').controller('UserRoundDlgCtrl',
    function ($scope, $rootScope, $timeout, $filter, dialogs, toaster,
              NgTableParams, F, Round, data, $uibModalInstance) {

        $scope.depts = data.depts;
        $scope.rounds = [];
        var firstTime = true;
        var change_rounds = {
            edit_rounds: [],
            del_rounds: []
        };

        function init() {
            Round.get({id: data.user_id, op: 'userRound'}).$promise.then(function (resp) {
                if (resp.items != null && resp.items.length != 0) {
                    $scope.rounds = resp.items;
                        firstTime = false;
                    }
            },function () {
                toaster.pop({
                    type: 'warning', title: '轮转信息不存在', body: '无法找到这个人的轮转信息!', onHideCallback: function () {
                        $uibModalInstance.dismiss('cancel');
                    }
                });
            });
        };
        init();
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.addRound = function () {
            dialogs.create('templates/round/edit_round_dlg.html', 'EditRoundDlgCtrl',
                {depts: $scope.depts, user_id: data.user_id, haved_rounds: $scope.rounds}, {
                 size: 'md'
            }).result.then(function (round) {
                if(!firstTime){
                    change_rounds.edit_rounds.push(round);
                }
                $scope.rounds.push(round);
            });
        };

        $scope.editRound = function (index) {
            dialogs.create('templates/round/edit_round_dlg.html', 'EditRoundDlgCtrl',
                {depts: $scope.depts, user_id: data.user_id, round: $scope.rounds[index],
                    haved_rounds: $scope.rounds, index:index}, {
                 size: 'md'
            }).result.then(function (round) {
                if(!firstTime){
                    change_rounds.edit_rounds.push(round);
                }
                $scope.rounds[index] = round;
            });
        };

        $scope.deleteRound = function (index) {
            var getRounds = $scope.rounds.splice(index, 1);
            if(!firstTime && getRounds[0].id != null){
                change_rounds.del_rounds.push(getRounds[0]);
            }
        };

        $scope.ok = function () {
            var params = {};
            params.user_id = data.user_id;
            params.change_rounds = change_rounds;
            params.rounds = $scope.rounds;
            params.op = firstTime ? 'first' : 'default';
            $uibModalInstance.close(params);
        };
    });

(function () {
    'use strict';

    angular.module('c.c').controller('imageCroppedUploadCtrl', imageCroppedUploadCtrl);

    /** @ngInject */
    function imageCroppedUploadCtrl($scope, $uibModalInstance, toaster, FileHelper, C, data) {
        var vm = $scope;
        vm.title = data.title;
        vm.width = data.width;
        vm.height = data.height;
        vm.m = {toUrl: C.URL.UPLOAD_ATTACHMENT, croppedDataUrl: ''};
        vm.upload = upload;
        vm.cancel = $uibModalInstance.dismiss;

        function upload(m) {
            FileHelper.uploadCroppedImage(m).then(function (resp) {
                $uibModalInstance.close(resp.filename);
            }, function (errMsg) {
                toaster.error(errMsg);
            });
        }
    }

})();

//angular.module('c.c').controller('UploadImageDlg',
//    function ($scope, $uibModalInstance, Upload, C, dialogs) {
//        $scope.image = {progress: 0, height: 240};
//
//        $scope.upload = function (file, image, e) {
//            if (e && e[0] && e[0].$error == 'maxSize') {
//                dialogs.notify('确认', '<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
//                return;
//            }
//
//            if (file == null) {
//                return;
//            }
//
//            Upload.upload({
//                url: C.URL.IMG_UPLOAD, file: file
//            }).progress(function (evt) {
//                image.progress = parseInt(100.0 * evt.loaded / evt.total);
//            }).success(function (resp) {
//                switch (resp.result) {
//                    case 0:
//                        image.progress = 0;
//                        image.link = resp.link;
//                        image.height = resp.height * 320 / resp.width;
//                        break;
//                    case 1:
//                        image.progress = 101;
//                        image.errorInfo = '服务器空间不足!';
//                        break;
//                }
//            }).error(function () {
//                image.progress = 102;
//                image.errorInfo = '服务器错误!';
//            });
//        };
//
//        $scope.insert = function (image) {
//            $uibModalInstance.close(image.link);
//        };
//
//        $scope.cancel = function () {
//            $uibModalInstance.dismiss('cancel');
//        };
//    });
angular.module('c.c').controller('UploadUserpicDlg',
    function ($scope, $uibModalInstance, Upload, C, data) {
        $scope.image = {progress: 0, croppedDataUrl: ''};

        $scope.upload = function (image) {
            var file = Upload.dataUrltoBlob(image.croppedDataUrl);

            if (!file.$error) {
                Upload.upload({
                    url: C.URL.IMG_UPLOAD, data: {file: file, is_user_photo: true, user_id: data.user_id}
                }).progress(function (evt) {
                    image.progress = parseInt(100.0 * evt.loaded / evt.total);
                }).success(function (resp) {
                    switch (resp.result) {
                        case 0:
                            image.progress = 0;
                            image.url = resp.url;
                            $uibModalInstance.close(image.url);
                            break;
                        case 1:
                            image.progress = 101;
                            image.errorInfo = '服务器空间不足!';
                            break;
                    }
                }).error(function () {
                    image.progress = 102;
                    image.errorInfo = '服务器错误!';
                });
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
(function () {
    'use strict';

    angular.module('c.c')
        .controller('HospitalBadgeFinishCtrl', HospitalBadgeFinishCtrl)


    ;
    /** @ngInject */
    function HospitalBadgeFinishCtrl($scope, Table, NewUser, UIHelper, Dlg, FileHelper, SaveAs) {
        var vm = $scope;
        vm.zoomIn = zoomIn;
        vm.downloadPic = downloadPic;

        init();

        function init() {
            UIHelper.loadTab(vm, 'finish');

            var options = {
                service: NewUser,
                params: {op: 'Badge', badge: '4'},
                optColWidth: Table._2_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {field: 'name', title: '姓名', filter: {name: 'text'}},
                    {field: 'username', title: '胸牌号', filter: {username: 'text'}},
                    {field: 'phone', title: '手机', filter: {phone: 'text'}},
                    {field: 'dept', title: '科室', filter: {dept: 'text'}}
                ]
            };

            Table.load(vm, options);
        }

        function downloadPic(m) {
            var pa = {
                name: m.name,
                filename: m.work_photo,
                mime: 'image/png',
                size: '1024'
            };
            FileHelper.download(NewUser.urls.DOWNLOAD_PIC, pa, function (resp) {
                SaveAs.download([resp], m.name + m.username + m.main_dept.name + '的照片', {type: 'image/jpg'});
            }, function (error) {
                Dlg.e('照片丢失，请重新上传')
            });
        }

        function zoomIn(m) {
            if (m.work_photo!=null) {
                Dlg.show({
                    template: 'templates/userPhotoImg.html',
                    ctrl: 'PhotoImgDlgCtrl',
                    data: {photo: m.work_photo}
                });
            } else {
                Dlg.w('用户没有上传工作照,请通知用户上传工作照');
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('HospitalBadgeMakingCtrl', HospitalBadgeMakingCtrl)


    ;
    /** @ngInject */
    function HospitalBadgeMakingCtrl($scope, Table, NewUser, UIHelper, Dlg, FileHelper, SaveAs, $q) {
        var vm = $scope;
        var checker = null;
        vm.made = made;
        vm.downloadPic = downloadPic;
        vm.zoomIn = zoomIn;
        vm.passChecked = passChecked;

        init();

        function init() {
            UIHelper.loadTab(vm, 'making');

            var options = {
                service: NewUser,
                params: {op: 'Badge', badge: '2'},
                optColWidth: Table._3_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {field: 'name', title: '姓名', filter: {name: 'text'}},
                    {field: 'username', title: '胸牌号', filter: {username: 'text'}},
                    {field: 'phone', title: '手机', filter: {phone: 'text'}},
                    {field: 'dept', title: '科室', filter: {dept: 'text'}}
                ]
            };

            Table.load(vm, options);
            checker = Table.loadMultiSelectedFn(vm);
        }

        function made(m) {
            var pa = {
                op: 'badge',
                badge: 3
            };
            Dlg.confirm('确认<strong>' + m.name + '</strong>的胸牌制作完成了吗？', function (resp) {
                NewUser.update({id: m.id}, pa).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    Dlg.e('照片丢失，请重新上传')
                });
            }, '胸牌制作');

        }

        function downloadPic(m) {
            var pa = {
                name: m.name,
                filename: m.work_photo,
                mime: 'image/png',
                size: '1024'
            };
            FileHelper.download(NewUser.urls.DOWNLOAD_PIC, pa, function (resp) {
                SaveAs.download([resp], m.name + m.username + m.main_dept.name + '的照片', {type: 'image/jpg'});
            }, function (error) {
                var data = error.data;
                if (data.msg) Dlg.e(data.msg);
            });
        }

        function zoomIn(m) {
            if (m.work_photo!=null) {
                Dlg.show({
                    template: 'templates/userPhotoImg.html',
                    ctrl: 'PhotoImgDlgCtrl',
                    data: {photo: m.work_photo}
                });
            } else {
                Dlg.w('用户没有上传工作照,请通知用户上传工作照');
            }
        }

        function passChecked() {
            var items = checker.getChecked();
            var userIds = [];
            var count = items.length;
            if (count === 0) {
                checker.clearChecked();
                Dlg.w("请至少选中一个待处理申请");
                return;
            }
            var defer = $q.defer();
            vm.tableParams.settings().$loading = true;
            angular.forEach(items, function (item) {
                userIds.push(item.id);
            });
            var pa = {
                userIds: userIds,
                badge: 3
            };
            NewUser.batchBadge(pa).$promise.then(function (resp) {
                Dlg.s(resp.msg);
            }, function (error) {
                var data = error.data;
                if (data.msg) Dlg.e(data.msg);
            });
            defer.resolve();
            checker.clearChecked();
            vm.tableReload();
            return defer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('HospitalBadgePendingCtrl', HospitalBadgePendingCtrl)


    ;
    /** @ngInject */
    function HospitalBadgePendingCtrl($scope, Table, NewUser, UIHelper, Dlg, SaveAs,
                                      FileHelper, $q) {
        var vm = $scope;
        var checker = null;
        vm.making = making;
        vm.zoomIn = zoomIn;
        vm.downloadPic = downloadPic;
        vm.passChecked = passChecked;

        init();

        function init() {
            UIHelper.loadTab(vm, 'pending');

            var options = {
                service: NewUser,
                params: {op: 'Badge', badge: '1'},
                optColWidth: Table._3_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {field: 'name', title: '姓名', filter: {name: 'text'}},
                    {field: 'username', title: '胸牌号', filter: {username: 'text'}},
                    {field: 'phone', title: '手机', filter: {phone: 'text'}},
                    {field: 'dept', title: '科室', filter: {dept: 'text'}}
                ]
            };

            Table.load(vm, options);
            checker = Table.loadMultiSelectedFn(vm);
        }

        function downloadPic(m) {
            var pa = {
                name: m.name,
                filename: m.work_photo,
                mime: 'image/png',
                size: '1024'
            };
            FileHelper.download(NewUser.urls.DOWNLOAD_PIC, pa, function (resp) {
                SaveAs.download([resp], m.name + m.username + m.main_dept.name + '的照片', {type: 'image/jpg'});
            }, function (error) {
                Dlg.e('照片丢失，请重新上传')
            });
        }

        function making(m) {
            var pa = {
                op: 'badge',
                badge: 2
            };
            if (m.work_photo!=null) {
                Dlg.confirm('开始制作<strong>' + m.name + '</strong>的胸牌了吗？', function (resp) {
                    NewUser.update({id: m.id}, pa).$promise.then(function (resp) {
                        if (resp.msg) Dlg.s(resp.msg);
                        vm.tableReload();
                    }, function (error) {
                        var data = error.data;
                        if (data.msg) Dlg.e(data.msg);
                    });
                }, '制作胸牌');
            } else {
                Dlg.w('用户没有上传工作照,请通知用户上传工作照');
            }
        }

        function zoomIn(m) {
            if (m.work_photo!=null) {
                Dlg.show({
                    template: 'templates/userPhotoImg.html',
                    ctrl: 'PhotoImgDlgCtrl',
                    data: {photo: m.work_photo}
                });
            } else {
                Dlg.w('用户没有上传工作照,请通知用户上传工作照');
            }
        }
        
        function passChecked() {
            var items = checker.getChecked();
            var userIds = [];
            var count = items.length;
            if (count === 0) {
                checker.clearChecked();
                Dlg.w("请至少选中一个待处理申请");
                return;
            }
            var defer = $q.defer();
            vm.tableParams.settings().$loading = true;
            angular.forEach(items, function (item) {
                userIds.push(item.id);
            });
            var pa = {
                userIds: userIds,
                badge: 2
            };
            NewUser.batchBadge(pa).$promise.then(function (resp) {
                Dlg.s(resp.msg);
            }, function (error) {
                var data = error.data;
                if (data.msg) Dlg.e(data.msg);
            });
            defer.resolve();
            checker.clearChecked();
            vm.tableReload();
            return defer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('HospitalBadgeReceiveCtrl', HospitalBadgeReceiveCtrl)


    ;
    /** @ngInject */
    function HospitalBadgeReceiveCtrl($scope, Table, NewUser, UIHelper, Dlg, SaveAs, FileHelper, $q) {
        var vm = $scope;
        var checker = null;
        vm.finish = finish;
        vm.zoomIn = zoomIn;
        vm.downloadPic = downloadPic;
        vm.passChecked = passChecked;

        init();

        function init() {
            UIHelper.loadTab(vm, 'receive');

            var options = {
                service: NewUser,
                params: {op: 'Badge', badge: '3'},
                optColWidth: Table._3_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {field: 'name', title: '姓名', filter: {name: 'text'}},
                    {field: 'username', title: '胸牌号', filter: {username: 'text'}},
                    {field: 'phone', title: '手机', filter: {phone: 'text'}},
                    {field: 'dept', title: '科室', filter: {dept: 'text'}}
                ]
            };

            Table.load(vm, options);
            checker = Table.loadMultiSelectedFn(vm);
        }

        function finish(m) {
            var pa = {
                op: 'badge',
                badge: 4
            };
            Dlg.confirm('确认<strong>' + m.name + '</strong>的胸牌已经领取了吗？', function (resp) {
                NewUser.update({id: m.id}, pa).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '胸牌领取');

        }

        function zoomIn(m) {
            if (m.work_photo!=null) {
                Dlg.show({
                    template: 'templates/userPhotoImg.html',
                    ctrl: 'PhotoImgDlgCtrl',
                    data: {photo: m.work_photo}
                });
            } else {
                Dlg.w('用户没有上传工作照,请通知用户上传工作照');
            }
        }

        function downloadPic(m) {
            var pa = {
                name: m.name,
                filename: m.work_photo,
                mime: 'image/png',
                size: '1024'
            };
            FileHelper.download(NewUser.urls.DOWNLOAD_PIC, pa, function (resp) {
                SaveAs.download([resp], m.name + m.username + m.main_dept.name + '的照片', {type: 'image/jpg'});
            }, function (error) {
                Dlg.e('照片丢失，请重新上传')
            });
        }

        function passChecked() {
            var items = checker.getChecked();
            var userIds = [];
            var count = items.length;
            if (count === 0) {
                checker.clearChecked();
                Dlg.w("请至少选中一个待处理申请");
                return;
            }
            var defer = $q.defer();
            vm.tableParams.settings().$loading = true;
            angular.forEach(items, function (item) {
                userIds.push(item.id);
            });
            var pa = {
                userIds: userIds,
                badge: 4
            };
            NewUser.batchBadge(pa).$promise.then(function (resp) {
                Dlg.s(resp.msg);
            }, function (error) {
                var data = error.data;
                if (data.msg) Dlg.e(data.msg);
            });
            defer.resolve();
            checker.clearChecked();
            vm.tableReload();
            return defer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('NursingArrangeCtrl', NursingArrangeCtrl)


    ;
    /** @ngInject */
    function NursingArrangeCtrl($scope, Dlg, ArrayHelper, Table, User, Round, NewUser, $q, Dept, UIHelper) {
        var vm = $scope;
        vm.manage = manage;
        vm.remove = remove;
        vm.change = change;

        var yesOrNo = Table.getNgTableOpts(ArrayHelper.get('yesOrNo2'));


        init();

        function init() {
            UIHelper.loadTab(vm, 'arrange');

            $q.all([
                Dept.query({opt: 4}).$promise
            ]).then(function (respArray) {
                vm.depts = respArray[0].depts;
                var options = {
                    service: NewUser,
                    params: {op: 'NursingRound'},
                    optColWidth: Table._1_BTN,
                    sorting: {id: 'asc'},
                    optInFront: true,
                    showSn: true,
                    cols: [
                        {field: 'name', title: '姓名', filter: {name: 'text'}},
                        {field: 'username', title: '胸牌号', filter: {username: 'text'}},
                        {field: 'entry_time', title: '来院工作时间', filter: {entry_time: 'date_range'}},
                        {field: 'dept', title: '科室', filter: {dept: 'text'}},
                        {field: 'is_arrange', title: '有无轮转', filter: {is_arrange: 'select'}, data: yesOrNo}
                    ]
                };

                Table.load(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        item.is_arrange = false;
                        if (item.user_round.length != 0) {
                            item.is_arrange = true;
                        }
                    });
                });

                vm.$watch('fresh', function (fresh, old, scope) {
                    options.params.fresh = fresh;
                    options.params.is_nurse = 1;
                    vm.tableReload();
                });
            });
        }

        function manage(m) {
            Dlg.show({
                template: 'templates/round/manage_dlg.html',
                ctrl: 'UserRoundDlgCtrl',
                data: {
                    user_id: m.id,
                    depts: vm.depts
                }
            }).then(function (resp) {
                Round.save(resp).$promise.then(function (resp) {
                    Dlg.s('轮转修改成功!');
                    vm.tableReload();
                }, function () {
                    Dlg.e('轮转修改失败了!');
                });
            });
        }

        function remove(m) {
            Dlg.confirm('确定要删除名为<strong>' + m.name + '</strong>的所有轮转吗？', function (resp) {
                Round.delete({id: m.id, opt: 0}).$promise.then(function (resp) {
                    Dlg.s('轮转删除成功!');
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '删除所有轮转');
        }

        function change(m) {
            Dlg.confirm('确定要删除名为<strong>' + m.name + '</strong>转换属性吗？', function (resp) {
                User.update({id: m.id, fresh: m.fresh == true ? '0' : '1'}).$promise.then(function (resp) {
                    Dlg.s('属性转换成功!');
                    vm.tableReload();
                }, function () {
                    Dlg.e('属性转换失败!');
                });
            }, '应届《=》在职');
        }
    }
})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('NursingUserMangeRoundsCtrl', NursingUserMangeRoundsCtrl)


    ;
    /** @ngInject */
    function NursingUserMangeRoundsCtrl($scope, ArrayHelper, Table, Round, C, Api, Dlg, UIHelper) {
        var vm = $scope;
        vm.edit = edit;
        vm.remove = remove;
        vm.downExport = downExport;

        var roundStateOpt = Table.getNgTableOpts(ArrayHelper.get('round_stages'));
        var yesOrNo = Table.getNgTableOpts(ArrayHelper.get('yesNo'));

        init();

        function init() {
            UIHelper.loadTab(vm, 'manage');

            var options = {
                service: Round,
                params: {op: 'NursingRound'},
                optColWidth: Table._1_BTN,
                sorting: {user_id: 'asc'},
                optInFront: true,
                showSn: true,
                cols: [
                    {field: 'is_main', title: '主科室轮转', filter: {is_main: 'select'}, data: yesOrNo},
                    {field: 'is_flex', title: '是否机动', filter: {is_flex: 'select'}, data: yesOrNo},
                    {field: 'name', title: '姓名', filter: {name: 'text'}},
                    {field: 'username', title: '胸牌号', filter: {username: 'text'}},
                    {field: 'dept', title: '轮转科室', filter: {dept: 'text'}},
                    {field: 'round_time', title: '轮转日期', filter: {round_time: 'date_range'}},
                    {field: 'state', title: '当前状态', filter: {state: 'select'}, data: roundStateOpt}
                ]
            };
            Table.load(vm, options, function (data) {
                angular.forEach(data.items, function (item) {
                    if (angular.isDefined(item.leave_time) && item.leave_time != null) {
                        item.round_time = item.entry_time.substr(0, 16) + ' - ' + item.leave_time.substr(0, 16);
                    } else {
                        item.round_time = item.entry_time.substr(0, 16) + "之后";
                    }
                    if (item.state) {
                        if (item.state == 1 && item.is_confirm == 0) {
                            item.state = {id: '3', name: '科室未确认'};
                        } else {
                            item.state = ArrayHelper.getItem(item.state, ArrayHelper.get('test_stages'));
                        }
                    } else {
                        item.state.name = '状态为空';
                    }
                });
            });
        }

        function edit(m) {
            Dlg.show({
                template: 'templates/round/edit_round_dlg.html',
                ctrl: 'EditRoundDlgCtrl',
                data: {round_id: m.id, user_id: m.user_id}
            }).then(function (resp) {
                resp.user_dept = m.user_dept;
                resp.op = 'Round';
                Round.update({id: m.id}, resp).$promise.then(function (resp) {
                    Dlg.s('轮转修改成功!');
                    vm.tableReload();
                }, function () {
                    Dlg.e('轮转修改失败!');
                })
            });
        }

        function remove(m) {
            Dlg.confirm('确定要删除<strong>' + m.user.name + '</strong>在<strong>' + m.dept.name + '</strong>的轮转吗?',
                function (resp) {
                    Round.delete({
                        id: m.id,
                        opt: 1,
                        user_dept_id: m.user_dept_id
                    }).$promise.then(function (resp) {
                        if (resp.msg) Dlg.s(resp.msg);
                        vm.tableReload();
                    }, function (error) {
                        var data = error.data;
                        if (data.msg) Dlg.e(data.msg);
                    });
                }, '删除轮转');
        }

        function downExport() {
            Api.exportDR(C.URL.ROUND_DOWNLOAD, "轮转统计");
        }
    }
})();

angular.module('c.c')
    .controller('NursingNurseSeniorityApprovalCtrl', function ($scope, dialogs, toaster, $filter
        , NgTableParams, SeniorityStandard, Dept, SeniorityApproval, NurseSeniority, User) {
        var nurses = [];
        $scope.std = [{id: 0, title: '全部标准'}];
        $scope.ap_states = [
            {id: 0, title: '护士长审'},
            {id: 1, title: '护理部审'},
            {id: 2, title: '通过'},
        ];
        $scope.init = function () {
            SeniorityStandard.query({type: 2}, function (resp) {
                $scope.standards = resp;
                angular.forEach($scope.standards, function (standard, index) {
                    $scope.std.push({id: index + 1, title: standard.name});
                });
            });
            User.query({'opt': 8}, function (data) {
                nurses = data.nurses;
            })
        };

        $scope.init();

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        $scope.cols = [
            {title: '科室', filter: {dept: 'text'}, field: 'dept', show: true, width: "10%"},
            {title: '姓名', filter: {name: 'text'}, field: 'name', show: true, width: "10%"},
            {title: '胸牌号', filter: {numb: 'text'}, field: 'numb', show: true, width: "10%"},
            {title: '入院时间', filter: {updated_at: 'date_range'}, field: 'name', show: true, width: "20%"},
            {
                title: '层级标准',
                data: $scope.std,
                filter: {seniority_id: 'select'},
                field: 'seniority_id',
                show: true,
                width: "20%"
            },
            {title: '备注', field: 'memo', show: true, width: "20%"},
            {
                title: '状态',
                data: $scope.ap_states,
                filter: {ap_state: 'select'},
                field: 'ap_state',
                show: true,
                width: "20%"
            },

        ];

        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                updated_at: 'desc'
            }
        }, {
            counts: [5, 10, 15], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 4;
                url['approval'] = true;
                if ($scope.dateRangeFilter.updated_at != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.updated_at.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.updated_at.endDate, 'yyyy-MM-dd');
                }
                SeniorityApproval.query(url, function (data) {
                    $scope.nurses = data.nurses;
                    params.total(data.total);
                    $defer.resolve(data.nurses);
                });

            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.pass = function (nurse) {
            var params = {};
            params['seniority_id'] = nurse.seniority_id;
            params['ap_state'] = 2;
            params['examine'] = true;
            params['nurse_id'] = [nurse.id];
            NurseSeniority.update({id: 1}, params).$promise.then(function (data) {
                toaster.success('提交成功!');
                $scope.tableReload();
            }, function () {
                toaster.error('提交失败!');
            });
            $scope.tableReload();
        };

        $scope.add = function () {

            angular.forEach($scope.nurses, function (nurse) {
                nurses.push({id: nurse.id})
            });
            dialogs.create('NurseSeniorityDlg.html', 'NurseSeniorityDlgCtrl', {
                standards: $scope.standards,
                except_nurses: nurses
            }, {
                size: 'md'
            }).result.then(function (seniority) {
                seniority['ap_state'] = 1;
                NurseSeniority.save(seniority).$promise.then(function (data) {
                    toaster.success('护士层级添加添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('护士层级添加添加失败!');
                });
            });
        };
        $scope.edit = function (nurse) {
            nurse['standard'] = $scope.standards[nurse.seniority_id - 1];
            nurse['flag'] = true;
        };
        $scope.cancel = function (nurse) {
            nurse['flag'] = false;
        };
        $scope.examine = function (nurse) {
            var params = {};
            nurse['flag'] = false;
            if (nurse.standard)
                params['seniority_id'] = nurse.standard.id;
            params['ap_state'] = 2;
            params['examine'] = true;
            params['nurse_id'] = [nurse.id];
            params['memo'] = nurse.memo;
            NurseSeniority.update({id: 1}, params).$promise.then(function (data) {
                toaster.success('提交成功!');
                $scope.tableReload();
            }, function () {
                toaster.error('提交失败!');
            });
            $scope.tableReload();
        }
    });

(function () {
    'use strict';

    angular.module('c.c')
        .controller('NurseSeniorityLevelManageCtrl', NurseSeniorityLevelManageCtrl);

    /** @ngInject */
    function NurseSeniorityLevelManageCtrl($scope, NewUser, Dlg, Table, UIHelper) {
        var vm = $scope;

        init();


        function init() {
            UIHelper.loadTab(vm, 'level_manage');

            var options = {
                service: NewUser,
                params: {op: 'NursingInfo'},
                hideOpt: true,
                cols: [
                    {field: "name", title: "姓名", filter: {name: "text"}},
                    {field: "entry_time", title: "入职时间", filter: {entry_time: "date_range"}},
                    {field: "level", title: "年级", filter: {level: "num_range"}},
                ]
            };
            Table.load(vm, options);
        }
    }

})();

angular.module('c.c')
    .controller('NurseSeniorityManageCtrl', function ($scope, $filter, Dlg, toaster,
                                                      NgTableParams, F, SeniorityStandard, NurseSeniority, Dept) {
        var dep = [{id: 0, title: '全部科室'}];
        $scope.std = [{id: 0, title: '全部标准'}];
        var nurses = [];
        $scope.init = function () {
            Dept.query({'opt': '4'}, function (resp) {
                $scope.depts = resp.depts;
                angular.forEach($scope.depts, function (dept, index) {
                    dep.push({id: index + 1, title: dept.name});
                });
            });
            SeniorityStandard.query({type: 2}, function (resp) {
                $scope.standards = resp;
                angular.forEach($scope.standards, function (standard, index) {
                    $scope.std.push({id: index + 1, title: standard.name});
                });
            });
            var url = {};
            url['id'] = 1;
            url['all_nurse'] = true;
            NurseSeniority.get(url, function (resp) {
                angular.forEach(resp.all_nurse, function (nurse) {
                    nurses.push({id: nurse.nurse_id})
                })
            })
        };
        $scope.init();
        $scope.cols = [
            {title: '科室', filter: {dept: 'text'}, field: 'dept', show: true, width: "20%"},
            {title: '姓名', filter: {'name': 'text'}, field: 'name', show: true}, //0
            {title: '工牌号', filter: {'numb': 'text'}, field: 'numb', show: true}, //0
            {
                title: '层级标准',
                data: $scope.std,
                filter: {seniority_id: 'select'},
                field: 'seniority_id',
                show: true,
                width: "20%"
            },
            {title: '备注', field: 'memo', show: true, width: "30%"},

        ];
        $scope.tableParams = new NgTableParams({page: 1, count: 30}, {
            counts: [30, 50, 100], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                NurseSeniority.query(url, function (data) {
                    $scope.nurses = data.nurses;
                    params.total(data.total);
                    $defer.resolve(data.nurses);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };

        $scope.add = function () {
            Dlg.show({
                template: 'NurseSeniorityDlg.html',
                ctrl: 'NurseSeniorityDlgCtrl',
                data: {
                    standards: $scope.standards,
                    except_nurses: nurses
                }
            }).then(function (seniority) {
                seniority['ap_state'] = 2;
                NurseSeniority.save(seniority).$promise.then(function (data) {
                    Dlg.s('护士层级添加添加成功!');
                    $scope.tableReload();
                }, function () {
                    Dlg.e('护士层级添加添加失败!');
                });
            });
        };

        $scope.edit = function (nurse) {
            nurse['standard_name'] = {id: '', name: nurse.standard_name};
            nurse['$edit'] = true;
        };
        $scope.show = function (nurse) {
            Dlg.show({
                template: 'pages/nursing/nurseSeniorityShow.html',
                ctrl: 'nurseSeniorityShowCtrl', size: 'lg', data: {id: nurse.id}
            }).then(function () {
                vm.tableReload();
            });
        };
        $scope.cancel = function (nurse) {
            nurse['standard_name'] = nurse.standard_name.name;
            nurse['$edit'] = false;
        };

        $scope.remove = function (nurse) {
            Dlg.confirm('确定要删除该层级记录吗?', function () {
                NurseSeniority.delete({id: nurse.id}).$promise.then(function (resp) {
                    Dlg.s('删除成功!');
                    $scope.tableReload();
                }, function (error) {
                    Dlg.error('删除失败!');
                });
            }, '删除层级记录');
        };

        $scope.examine = function (nurse) {
            var params = {};
            nurse['$edit'] = false;
            if (nurse.standard_name)
                params['seniority_id'] = nurse.standard_name.id;
            params['ap_state'] = 2;
            params['examine'] = true;
            params['nurse_id'] = [nurse.id];
            params['memo'] = nurse.memo;
            NurseSeniority.update({id: 1}, params).$promise.then(function (data) {
                Dlg.s('提交成功!');
                $scope.tableReload();
            }, function () {
                Dlg.e('提交失败!');
            });
            $scope.tableReload();
        };
    });

angular.module('c.c').controller('NurseSeniorityDlgCtrl',
    function ($scope, $uibModalInstance, toaster, F, data) {
        $scope.except_nurses = data.except_nurses;
        $scope.standards = data.standards;

        $scope.seniority = {standard: $scope.standards[0]};

        $scope.ok = function (seniority) {
            if ($scope.s_form.$valid) {
                if (seniority.nurse.length == 0) {
                    toaster.warning('表单中有错误!');
                    $scope.g_form.submitted = true;
                }
                var params = {};
                var nurse_ids = [];
                angular.forEach(seniority.nurse, function (nu) {
                    nurse_ids.push(nu.id);
                });
                params['nurse_id'] = nurse_ids;
                if (seniority.standard.id != null)
                    params['seniority_id'] = seniority.standard.id;
                params['memo'] = seniority.memo;
                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.g_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });

(function () {
    'use strict';

    angular.module('c.c')
        .controller('PartyWorkSignedCtrl', PartyWorkSignedCtrl)


    ;
    /** @ngInject */
    function PartyWorkSignedCtrl($scope, $q, NewUser, Table, UIHelper) {
        var vm = $scope;
        init();

        function init() {
            $q.all([
                NewUser.query({op: 'UserOptions'}).$promise
            ]).then(function (respArray) {
                UIHelper.loadTab(vm, 'signed');

                var options = {
                    service: NewUser,
                    params: {op: 'PartyWorkSigned'},
                    optColWidth: Table._1_BTN,
                    optInFront: true,
                    showSn: true,
                    cols: [
                        {field: "name", title: "姓名", filter: {name: "text"}, width: 140},
                        {field: "username", title: "胸牌号", filter: {username: "text"}, width: 140},
                        {field: "dept", title: "科室", filter: {dept: "text"}},
                        {
                            field: "type_id",
                            title: "岗位类型",
                            filter: {type_id: "select"},
                            data: Table.getNgTableOpts(respArray[0].items.types)
                        },
                        {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}, width: 200}
                    ]
                };

                Table.load(vm, options);
            });
        }

    }
})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('PartyWorkSigningCtrl', PartyWorkSigningCtrl)


    ;
    /** @ngInject */
    /** @ngInject */
    function PartyWorkSigningCtrl($scope, $q, NewUser, Dlg, Table, UIHelper) {
        var vm = $scope;
        vm.sign = sign;
        init();

        function init() {
            $q.all([
                NewUser.query({op: 'UserOptions'}).$promise
            ]).then(function (respArray) {
                UIHelper.loadTab(vm, 'signing');

                var options = {
                    service: NewUser,
                    params: {op: 'PartyWorkSigning'},
                    optColWidth: Table._2_BTN,
                    optInFront: true,
                    showSn: true,
                    cols: [
                        {field: "name", title: "姓名", filter: {name: "text"}, width: 140},
                        {field: "username", title: "胸牌号", filter: {username: "text"}, width: 140},
                        {field: "dept", title: "科室", filter: {dept: "text"}},
                        {
                            field: "type_id",
                            title: "岗位类型",
                            filter: {type_id: "select"},
                            data: Table.getNgTableOpts(respArray[0].items.types)
                        },
                        {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}, width: 200}
                    ]
                };

                Table.load(vm, options);
            });
        }

        function sign(m) {
            var pa = {
                signed: true
            };
            Dlg.confirm('确认<strong>' + m.name + '</strong>的承诺书已签订？', function (resp) {
                NewUser.update({id: m.id, op: 'sign'}, pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    Dlg.e(error.msg);
                });
            }, '确认承诺书已签订');
        }
    }
})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('PartyWorkTurnedCtrl', PartyWorkTurnedCtrl)


    ;
    /** @ngInject */
    function PartyWorkTurnedCtrl($scope, $q, NewUser, Table, UIHelper) {
        var vm = $scope;
        init();

        function init() {
            $q.all([
                NewUser.query({op: 'UserOptions'}).$promise
            ]).then(function (respArray) {
                UIHelper.loadTab(vm, 'turned');

                var options = {
                    service: NewUser,
                    params: {op: 'PartyWorkTurned'},
                    optColWidth: Table._1_BTN,
                    optInFront: true,
                    showSn: true,
                    cols: [
                        {field: "name", title: "姓名", filter: {name: "text"}, width: 140},
                        {field: "username", title: "胸牌号", filter: {username: "text"}, width: 140},
                        {field: "dept", title: "科室", filter: {dept: "text"}},
                        {
                            field: "type_id",
                            title: "岗位类型",
                            filter: {type_id: "select"},
                            data: Table.getNgTableOpts(respArray[0].items.types)
                        },
                        {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}, width: 200}
                    ]
                };

                Table.load(vm, options);
            });
        }

    }
})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('PartyWorkTurningCtrl', PartyWorkTurningCtrl)


    ;
    /** @ngInject */
    function PartyWorkTurningCtrl($scope, $q, NewUser, Table, UIHelper, Dlg) {
        var vm = $scope;
        vm.turn = turn;
        init();

        function init() {
            $q.all([
                NewUser.query({op: 'UserOptions'}).$promise
            ]).then(function (respArray) {
                UIHelper.loadTab(vm, 'turning');

                var options = {
                    service: NewUser,
                    params: {op: 'PartyWorkTurning'},
                    optColWidth: Table._2_BTN,
                    optInFront: true,
                    showSn: true,
                    cols: [
                        {field: "name", title: "姓名", filter: {name: "text"}, width: 140},
                        {field: "username", title: "胸牌号", filter: {username: "text"}, width: 140},
                        {field: "dept", title: "科室", filter: {dept: "text"}},
                        {
                            field: "type_id",
                            title: "岗位类型",
                            filter: {type_id: "select"},
                            data: Table.getNgTableOpts(respArray[0].items.types)
                        },
                        {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}, width: 200}
                    ]
                };

                Table.load(vm, options);
            });
        }

        function turn(m) {
            var pa = {
                turned: true
            };
            Dlg.confirm('确认<strong>' + m.name + '</strong>的党组织关系已转？', function (resp) {
                NewUser.update({id: m.id, op: 'turn'}, pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    Dlg.e(error.msg);
                });
            }, '确认党组织关系已转');
        }
    }
})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('UserArrangeRoundsCtrl', UserArrangeRoundsCtrl)


    ;
    /** @ngInject */
    function UserArrangeRoundsCtrl($scope, Dlg, ArrayHelper, Table, User, Round, NewUser, $q, Dept) {
        var vm = $scope;
        vm.manage = manage;
        vm.remove = remove;
        vm.change = change;

        var yesOrNo = Table.getNgTableOpts(ArrayHelper.get('yesOrNo2'));
        var sexOpt = Table.getNgTableOpts(ArrayHelper.get('sexes'));


        init();

        function init() {
            $q.all([
                Dept.query({opt: 4}).$promise
            ]).then(function (respArray) {
                vm.depts = respArray[0].depts;
                var options = {
                    service: NewUser,
                    params: {op: 'PersonnelRound', is_nurse: 0},
                    optColWidth: Table._1_BTN,
                    sorting: {id: 'asc'},
                    optInFront: true,
                    showSn: true,
                    cols: [
                        {field: 'name', title: '姓名', filter: {name: 'text'}},
                        {field: 'username', title: '胸牌号', filter: {username: 'text'}},
                        {field: 'entry_time', title: '来院工作时间', filter: {entry_time: 'date_range'}},
                        {field: 'dept', title: '科室', filter: {dept: 'text'}},
                        {field: 'is_arrange', title: '有无轮转', filter: {is_arrange: 'select'}, data: yesOrNo},
                        {field: 'sex', title: '性别', filter: {sex: 'select'}, data: sexOpt}
                    ]
                };

                Table.load(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        item.is_arrange = false;
                        if (item.user_round.length != 0) {
                            item.is_arrange = true;
                        }
                    });
                });
            });
        }

        function manage(m) {
            Dlg.show({
                template: 'templates/round/manage_dlg.html',
                ctrl: 'UserRoundDlgCtrl',
                data: {
                    user_id: m.id,
                    depts: vm.depts
                }
            }).then(function (resp) {
                Round.save(resp).$promise.then(function (resp) {
                    Dlg.s('轮转修改成功!');
                    vm.tableReload();
                }, function () {
                    Dlg.e('轮转修改失败了!');
                });
            });
        }

        function remove(m) {
            Dlg.confirm('确定要删除名为<strong>' + m.name + '</strong>的所有轮转吗？', function (resp) {
                Round.delete({id: m.id, opt: 0}).$promise.then(function (resp) {
                    Dlg.s('轮转删除成功!');
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '删除所有轮转');
        }

        function change(m) {
            Dlg.confirm('确定要删除名为<strong>' + m.name + '</strong>转换属性吗？', function (resp) {
                User.update({id: m.id, fresh: m.fresh == true ? '0' : '1'}).$promise.then(function (resp) {
                    Dlg.s('属性转换成功!');
                    vm.tableReload();
                }, function () {
                    Dlg.e('属性转换失败!');
                });
            }, '应届《=》在职');
        }
    }
})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('UserMangeRoundsCtrl', UserMangeRoundsCtrl)


    ;
    /** @ngInject */
    function UserMangeRoundsCtrl($scope, ArrayHelper, Table, Round, C, Api, Dlg) {
        var vm = $scope;
        vm.edit = edit;
        vm.remove = remove;

        var roundStateOpt = Table.getNgTableOpts(ArrayHelper.get('round_stages'));
        var yesOrNo = Table.getNgTableOpts(ArrayHelper.get('yesNo'));

        init();

        function init() {
            var options = {
                service: Round,
                params: {op: 'PersonnelRound', is_nurse: 0},
                optColWidth: Table._1_BTN,
                sorting: {user_id: 'asc'},
                optInFront: true,
                showSn: true,
                cols: [
                    {field: 'is_main', title: '主科室轮转', filter: {is_main: 'select'}, data: yesOrNo},
                    {field: 'is_flex', title: '是否机动', filter: {is_flex: 'select'}, data: yesOrNo},
                    {field: 'name', title: '姓名', filter: {name: 'text'}},
                    {field: 'username', title: '胸牌号', filter: {username: 'text'}},
                    {field: 'dept', title: '轮转科室', filter: {dept: 'text'}},
                    {field: 'round_time', title: '轮转日期', filter: {round_time: 'date_range'}},
                    {field: 'state', title: '当前状态', filter: {state: 'select'}, data: roundStateOpt}
                ]
            };
            Table.load(vm, options, function (data) {
                angular.forEach(data.items, function (item) {
                    if (angular.isDefined(item.leave_time) && item.leave_time != null) {
                        item.round_time = item.entry_time.substr(0, 16) + ' - ' + item.leave_time.substr(0, 16);
                    } else {
                        item.round_time = item.entry_time.substr(0, 16) + "之后";
                    }
                    if (item.state) {
                        if (item.state == 1 && item.is_confirm == 0) {
                            item.state = {id: '3', name: '科室未确认'};
                        } else {
                            item.state = ArrayHelper.getItem(item.state, ArrayHelper.get('test_stages'));
                        }
                    } else {
                        item.state.name = '状态为空';
                    }
                });
            });
        }

        function edit(m) {
            Dlg.show({
                template: 'templates/round/edit_round_dlg.html',
                ctrl: 'EditRoundDlgCtrl',
                data: {round_id: m.id, user_id: m.user_id}
            }).then(function (resp) {
                resp.user_dept = m.user_dept;
                resp.op = 'round';
                Round.update({id: m.id}, resp).$promise.then(function (resp) {
                    Dlg.s('轮转修改成功!');
                    vm.tableReload();
                }, function () {
                    Dlg.e('轮转修改失败!');
                })
            });
        }

        function remove(m) {
            Dlg.confirm('确定要删除<strong>' + m.user.name + '</strong>在<strong>' + m.dept.name + '</strong>的轮转吗?',
                function (resp) {
                    Round.delete({
                        id: m.id,
                        opt: 1,
                        user_dept_id: m.user_dept_id
                    }).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '删除轮转');
        }
    }
})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('PersonnelAllUserRegApprovalCtrl', PersonnelAllUserRegApprovalCtrl)


    ;
    /** @ngInject */
    function PersonnelAllUserRegApprovalCtrl($scope, UIHelper, NewUser, Table, Dlg, $q, ArrayHelper) {
        var vm = $scope;
        vm.edit = edit;
        var confirms = NewUser.getConfirms();

        init();

        function init() {
            $q.all([
                NewUser.query({op: 'UserOptions'}).$promise
            ]).then(function (respArray) {
                UIHelper.loadTab(vm, 'approval');

                var options = {
                    service: NewUser,
                    params: {op: 'PersonnelAllRegApproval'},
                    optColWidth: Table._2_BTN,
                    optInFront: true,
                    showSn: true,
                    cols: [
                        {field: "name", title: "姓名", filter: {name: "text"}},
                        {field: "username", title: "胸牌号", filter: {username: "text"}},
                        {field: "dept", title: "科室", filter: {dept: "text"}},
                        {
                            field: "type_id",
                            title: "岗位类型",
                            filter: {type_id: "select"},
                            data: Table.getNgTableOpts(respArray[0].items.types)
                        },
                        { //2
                            title: '确认状态',
                            filter: {confirm_state: 'select'},
                            data: Table.getNgTableOpts(confirms),
                            field: 'confirm_state'
                        },
                        {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}}
                    ]
                };

                Table.load(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        item.confirm_state = ArrayHelper.getItem(item.confirm_state, confirms);
                    })
                });
            });
        }


        function edit(m) {
            var pa = {
                user_id: m.id,
                user_reg: true,
                title: '确认信息',
                op: 'PersonnelApproval'
            };

            Dlg.show({
                template: 'templates/user_personnel_approve.html',
                ctrl: 'UserPersonnelApproveCtrl',
                data: pa,
                size: 'lg'
            }).then(function () {
                vm.tableReload();
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('PersonnelUserRegApprovalCtrl', PersonnelUserRegApprovalCtrl)


    ;
    /** @ngInject */
    function PersonnelUserRegApprovalCtrl($scope, UIHelper, NewUser, Table, Dlg, $q) {
        var vm = $scope;
        vm.edit = edit;

        init();

        function init() {
            $q.all([
                NewUser.query({op: 'UserOptions'}).$promise
            ]).then(function (respArray) {
                UIHelper.loadTab(vm, 'approval');

                var options = {
                    service: NewUser,
                    params: {op: 'PersonnelRegApproval'},
                    optColWidth: Table._2_BTN,
                    optInFront: true,
                    showSn: true,
                    cols: [
                        {field: "name", title: "姓名", filter: {name: "text"}},
                        {field: "username", title: "胸牌号", filter: {username: "text"}},
                        {
                            field: "type_id",
                            title: "岗位类型",
                            filter: {type_id: "select"},
                            data: Table.getNgTableOpts(respArray[0].items.types)
                        },
                        {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}}
                    ]
                };

                Table.load(vm, options);
            });
        }


        function edit(m) {
            var pa = {
                user_id: m.id,
                user_reg: true,
                title: '确认信息',
                op: 'PersonnelApproval'
            };

            Dlg.show({
                template: 'templates/user_personnel_approve.html',
                ctrl: 'UserPersonnelApproveCtrl',
                data: pa,
                size: 'lg'
            }).then(function () {
                vm.tableReload();
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('UserRegCtrl', UserRegCtrl);

    /** @ngInject */
    function UserRegCtrl($scope, Dlg, ArrayHelper, $http, DateHelper, $q, FormHelper, JobTitle, NewUser) {
        var vm = this;
        vm.reload = reload;
        vm.submit = submit;
        vm.degreeTypeSelectedFn = degreeTypeSelectedFn;
        vm.plaitSelectedFn = plaitSelectedFn;
        vm.statusSelectedFn = statusSelectedFn;
        vm.deptTypeFn = deptTypeFn;
        vm.titleGroupFn = titleGroupFn;
        vm.onTypeSelectedFn = onTypeSelectedFn;
        vm.addUserPhoto = addUserPhoto;
        vm.dayNumChange = dayNumChange;

        vm.sexes = ArrayHelper.get('sexes');
        vm.edu_bgs = ArrayHelper.get('edu_bg_list');
        vm.degree_types = ArrayHelper.get('degree_types');
        vm.en_lvs = ArrayHelper.get('eg_lv_list');
        vm.posts = ArrayHelper.get('posts');
        vm.titleLeaves = NewUser.getTitleLevel();

        vm.reg_stage = true;
        vm.hide_photo = true;

        var username_regex_list = [
            /^\d{4,5}$/,  //正式员工
            /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/  //试用实习均使用手机号注册
        ];
        vm.username_regex = username_regex_list[0];

        vm.dateOptions = {
            minDate: new Date(1920, 0, 1),
            maxDate: new Date(),
            initDate: new Date()
        };

        vm.plaits = [
            {id: 1, name: '上锦'},
            {id: 2, name: '华西派驻'},
            {id: 3, name: '附二院派驻'},
            {id: 4, name: '院外人员'}
        ];

        vm.census = [
            {id: 1, name: '城镇'},
            {id: 2, name: '农村'}
        ];

        function reload() {
            vm.Form.$setUntouched();
            vm.Form.$setPristine();
            init();
        }

        init();

        function init() {
            $q.all([
                $http.get('api/open/user/reg', {params: {op: 'options'}})
            ]).then(function (respArray) {
                vm.depts = respArray[0].data.items.depts;
                vm.types = respArray[0].data.items.types;
                vm.statuses = respArray[0].data.items.statuses;
                vm.standards = respArray[0].data.items.standards;
                vm.nations = respArray[0].data.items.nations;
                vm.political_statuses = respArray[0].data.items.political_statuses;

                vm.titles = respArray[0].data.items.titles;
                var jTypes = JobTitle.getTypes();
                angular.forEach(vm.titles, function (title) {
                    title.type = ArrayHelper.getItem(title.type, jTypes);
                });

                vm.user['type'] = vm.types[0];
                // vm.user['nation'] = vm.nations[0];
                // vm.user['political_status'] = vm.political_statuses[0];
                vm.user['dept'] = vm.depts[0];
                vm.user['standard'] = vm.standards[0];
                vm.user['password'] = 'Sj@123456';
                vm.user['password_ag'] = 'Sj@123456';
            });
            vm.user = {is_cadre: false};
            vm.user['sex'] = vm.sexes[0];
            // vm.user['edu_bg'] = vm.edu_bgs[0];
            // vm.user['degree_type'] = vm.degree_types[0];
            // vm.degrees = NewUser.getDegrees(vm.user['degree_type'].id);
            // vm.user['degree'] = vm.degrees[0];
            // vm.user['en_lv'] = vm.en_lvs[0];
            // vm.user['plait'] = vm.plaits[0];
            // vm.user['census'] = vm.census[0];
            vm.user['annual_days'] = 5;
        }

        $scope.$watch('vm.user.id_card', function (newVal, oldVal) {
            var id_card = newVal;
            if (id_card != oldVal && id_card != '' && id_card != null) {
                var native = id_card.substr(0, 6);
                var birthday = id_card.substr(6, 8);
                var sex = vm.sexes[(parseInt(id_card.substr(16, 1)) + 1) % 2];
                vm.user.birthday = DateHelper.str2Date(birthday, 'yyyyMMdd');
                vm.user.sex = sex;
                // $http.post('/api/v1/native_place',
                //     {id_native: native}).success(function (resp) {
                //     switch (resp.result) {
                //         case 0:
                //             vm.user.native_place = resp.native_place;
                //             break;
                //         case 1:
                //             Dlg.w('没有找到和您输入的身份证号对应的籍贯信息，请手动填写籍贯!');
                //             break;
                //     }
                // });
            }
        });

        $scope.$watch('vm.user.username', checkIsPhone);

        function checkIsPhone() {
            var invalid, user = vm.user;
            vm.Form.username.$setValidity('isPhone', true);

            if (!user.username) return;

            invalid = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[389])\d{8}$/.test(user.username);
            vm.Form.username.$setValidity('isPhone', !invalid);
            if (invalid) return;
        }

        function degreeTypeSelectedFn(type) {
            vm.degrees = NewUser.getDegrees(type.id);
            vm.user['degree'] = vm.degrees[0];
        }

        function plaitSelectedFn(plait) {
            vm.status = [];
            vm.defaultStatuses = angular.copy(vm.statuses);
            if (plait.id == 1) {
                angular.forEach(vm.defaultStatuses, function (item) {
                    if (ArrayHelper.inArray(item.id, [15, 16, 17]) !== -1) {
                        vm.status.push(item);
                    }
                });
            } else if (plait.id == 2) {
                angular.forEach(vm.defaultStatuses, function (item) {
                    if (ArrayHelper.inArray(item.id, [1, 2, 5, 6, 8, 9, 10, 12, 13, 14, 23]) !== -1) {
                        vm.status.push(item);
                    }
                });
            } else if (plait.id == 3) {
                angular.forEach(vm.defaultStatuses, function (item) {
                    if (ArrayHelper.inArray(item.id, [5, 6, 7, 8, 9, 10]) !== -1) {
                        item.name = '附二院' + item.name;
                        vm.status.push(item);
                    }
                });
            } else if (plait.id == 4) {
                angular.forEach(vm.defaultStatuses, function (item) {
                    if (ArrayHelper.inArray(item.id, [18]) !== -1) {
                        vm.status.push(item);
                    }
                });
            }
        }

        function statusSelectedFn(status, user) {
            if (status.id == 3 || status.id == 4 || status.id == 6) { //试用
                vm.username_regex = username_regex_list[1];
            } else {
                vm.username_regex = username_regex_list[0];
            }
        }

        function deptTypeFn(d) {
            return d.type.name;
        }

        function titleGroupFn(t) {
            return t.type.name;
        }

        function onTypeSelectedFn(type, user) {
            if (type.id == 2) {
                user.standard = vm.standards[0];
            }
        }

        function addUserPhoto(user) {
            Dlg.show({
                template: 'templates/upload/userpic_dlg.html',
                ctrl: 'UploadUserpicDlg'
            }).then(function (resp) {
                user.photo = resp;
            });
        }

        function dayNumChange() {
            var valid = isNaN(vm.user.num) ? true : Number.isInteger(vm.user.num * 2);
            vm.Form.num.$setValidity('num', valid);
            vm.Form.num.$setValidity('not_zero', vm.user.num >= 0);
        }

        function submit(user) {
            var defer = $q.defer();
            if (!vm.Form.$valid) {
                FormHelper.handleError('#Form', vm.Form);
                defer.reject();
            } else {
                var pa = {};
                //账户信息
                pa['username'] = user.username;
                pa['password'] = user.password;

                //基本信息
                pa['name'] = user.name;
                pa['id_card'] = user.id_card;
                pa['census'] = user.census.id;
                pa['sex'] = user.sex.id;
                pa['birthday'] = DateHelper.date2Str(user.birthday, 'yyyy-MM-dd');
                pa['nation_id'] = user.nation.id;
                pa['native_place'] = user.native_place;
                pa['political_status_id'] = user.political_status.id;
                pa['car_num1'] = user.car_num1;
                pa['car_num2'] = user.car_num2;

                //工作相关
                pa['photo'] = user.photo;
                pa['status_id'] = user.status.id;
                pa['type_id'] = user.type.id;
                pa['plait'] = user.plait.id;
                pa['post_details'] = user.post_details;
                pa['num'] = user.num;
                if (user.plait.id !== 1) {
                    pa['annual_days'] = user.annual_days; //年假天数
                } else {
                    pa['annual_days'] = null; //年假天数
                }
                if (user.type.id == 2) {
                    pa['standard'] = user.standard.id;
                }

                //社会工龄
                if (user.plait.id == 1) {
                    pa['seniority'] = user.seniority;
                }

                // //教学假
                // if (user.plait.id == 2 && (user.status.id == 1 || user.status.id == 2 || user.status.id == 6 || user.status.id == 13)) {
                //     pa['teaching_num'] = user.teaching_num;
                // }


                if (user.title) {
                    pa['title_id'] = user.title.id;
                }
                if (user.title_level) pa['title_level'] = user.title_level.id;
                //  主要科室...
                pa['dept_id'] = user.dept.id;
                pa['is_cadre'] = user.is_cadre;
                pa['entry_time'] = DateHelper.date2Str(user.entry_time, 'yyyy-MM-dd');
                pa['party_time'] = DateHelper.date2Str(user.party_time, 'yyyy-MM-dd');
                pa['started_work'] = DateHelper.date2Str(user.started_work, 'yyyy-MM-dd');

                //教育背景
                pa['graduate_school'] = user.graduate_school;
                pa['major'] = user.major;
                pa['edu_bg'] = user.edu_bg.id;
                pa['degree'] = user.degree.name;
                pa['en_lv'] = user.en_lv.id;

                //联系方式
                pa['phone'] = user.phone;
                pa['cornet'] = user.cornet;
                pa['phone2'] = user.phone2;
                pa['office_phone'] = user.office_phone;
                pa['office_cornet'] = user.office_cornet;
                if (user.email) pa['email'] = user.email;
                pa['address'] = user.address;
                pa['op'] = 'Reg';

                NewUser.save(pa).$promise.then(function (resp) {
                    if (resp.result == '1') {
                        Dlg.e(resp.msg);
                    } else {
                        Dlg.s('员工记录添加成功!');
                        vm.Form.$setUntouched();
                        vm.Form.$setPristine();
                        init();
                    }

                }, function (error) {
                    Dlg.e(error.data.msg);
                });
            }
            defer.resolve();

            return defer.promise;
        }
    }

})();

'use strict';
angular.module('c.c')
    .controller('IncumbencyUserCtrl', function ($rootScope, $scope, NgTableParams, F, User, Dlg) {
        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
        var eduBgs = F.get('edu_bg_list');
        var eduBgOpts = F.getNgTableOpts(eduBgs);
        $scope.ed = ['', '高中', '中专', '大专', '成人本科', '本科', '硕士', '博士', '其他'];
        $scope.yes_no = yesNoOpts;
        $scope.optInFront = true;
        $scope.cols = [
            {
                title: '姓名',
                sortable: 'name',
                filter: {name: 'text'},
                field: 'name',
                type: 0xff,
                show: true,
                width: '10%'
            }, //1
            {
                title: '胸牌号',
                sortable: 'username',
                filter: {username: 'text'},
                field: 'username',
                type: 0xff,
                show: true,
                width: '10%'
            }, //1
            {title: '主科室', field: 'main_dept', type: 1, filter: {main_dept: 'text'}, show: true, width: '10%'},
            {
                title: '编制类型', sortable: 'status_id', filter: {status_id: 'select'}, field: 'status_id'
                , type: 8, show: true, width: '10%'
            },
            {
                title: '类别',
                sortable: 'type_id',
                filter: {type_id: 'select'},
                field: 'type_id',
                type: 8,
                show: true,
                width: '10%'
            },
            {
                title: '入职时间',
                sortable: 'entry_time',
                filter: {entry_time: 'date_range'},
                field: 'entry_time',
                type: 8,
                show: true,
                width: '10%'
            },
            {
                title: '入职类型',
                sortable: 'entry_type_id',
                filter: {entry_type_id: 'select'},
                field: 'entry_type_id',
                type: 8,
                show: true,
                width: '10%'
            },
            {
                title: '所学专业',
                sortable: 'major',
                filter: {major: 'text'},
                field: 'major',
                type: 2,
                show: true,
                width: '10%'
            },//9
            {
                title: '学历',
                sortable: 'edu_bg',
                filter: {edu_bg: 'select'},
                data: eduBgOpts,
                field: 'edu_bg',
                type: 2,
                show: true,
                width: '10%'
            },
            {
                title: '中层以上干部',
                sortable: 'is_cadre',
                filter: {is_cadre: 'select'},
                data: yesNoOpts,
                field: 'is_cadre',
                type: 8,
                show: true,
                width: '10%'
            }
        ];
        $scope.statuses_col = $scope.cols[3];
        $scope.user_types_col = $scope.cols[4];
        $scope.entry_types_col = $scope.cols[6];
        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };
        $scope.$on('user_recover', function (event, data) {
            $scope.tableReload();
        });

        $scope.dateRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.dateRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );
        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };
        $scope.tableParams = new NgTableParams({
            page: 1, count: 30, sorting: {
                updated_at: 'desc'
            }
        }, {
            counts: [30, 50, 100], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 1;
                url['is_leaved'] = 0;
                url['date_range_filters'] = $scope.dateRangeFilter;
                User.query(url, function (data) {
                    $scope.users = data.users;
                    $scope.leave_reason = data.leave_reasons;
                    $scope.statuses_col.data = F.getNgTableOpts(data.statuses);
                    $scope.user_types_col.data = F.getNgTableOpts(data.types);
                    $scope.entry_types_col.data = F.getNgTableOpts(data.entry_types);
                    params.total(data.total);
                    $defer.resolve($scope.users);
                });
            }
        });
        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };
        $scope.user_leave = function (user) {
            Dlg.show({
                template: 'pages/dialogs/userLeaveDlg.html',
                ctrl: 'LeaveCtrl',
                data: {id: user.id}
            }).then(function () {
                $scope.tableReload();
            });
        }
    });
(function () {
    'use strict';

    angular.module('c.c')
        .controller('LeavedUserCtrl', LeavedUserCtrl)
        .controller('LeavedUserRecoverDlgCtrl', LeavedUserRecoverDlgCtrl)
    ;

    /** @ngInject */
    function LeavedUserCtrl($scope, Dlg, F, NgTableParams, User, FileHelper) {
        $scope.cols = [
            {
                title: '姓名',
                sortable: 'name',
                filter: {name: 'text'},
                field: 'name',
                type: 0xff,
                show: true,
                width: '15%'
            }, //1
            {
                title: '胸牌号',
                sortable: 'username',
                filter: {username: 'text'},
                field: 'username',
                type: 0xff,
                show: true,
                width: '15%'
            }, //1
            // {title: '原主科室', field: 'main_dept', type: 1, show: true, width: '15%'},
            {title: '原主科室', field: 'main_dept', type: 1, filter: {main_dept: 'text'}, show: true, width: '15%'},
            {
                title: '类别',
                sortable: 'type_id',
                filter: {type_id: 'select'},
                field: 'type_id',
                type: 8,
                show: true,
                width: '15%'
            },
            {
                title: '入职时间',
                sortable: 'entry_time',
                filter: {entry_time: 'date_range'},
                field: 'entry_time',
                type: 8,
                show: true,
                width: '15%'
            },
            {
                title: '入职类型',
                sortable: 'entry_type_id',
                filter: {entry_type_id: 'select'},
                field: 'entry_type_id',
                type: 8,
                show: true,
                width: '15%'
            },
            {
                title: '离职时间',
                sortable: 'leave_time',
                filter: {leave_time: 'date_range'},
                field: 'leave_time',
                type: 8,
                show: true,
                width: '15%'
            },
            {
                title: '离职原因',
                sortable: 'leave_reason_id',
                filter: {leave_reason_id: 'select'},
                field: 'leave_reason_id',
                type: 8,
                show: true,
                width: '10%'
            }
        ];

        $scope.$on('userLeave', function (event, data) {
            $scope.tableParams.reload();
        });
        $scope.user_types_col = $scope.cols[3];
        $scope.entry_types_col = $scope.cols[5];
        $scope.leave_reasons_col = $scope.cols[7];

        $scope.dateRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.dateRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );
        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };
        $scope.tableParams = new NgTableParams({
            page: 1, count: 30, sorting: {
                updated_at: 'desc'
            }
        }, {
            counts: [30, 50, 100], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 1;
                url['is_leaved'] = 1;
                url['date_range_filters'] = $scope.dateRangeFilter;
                User.query(url, function (data) {
                    $scope.users = data.users;
                    $scope.user_types_col.data = F.getNgTableOpts(data.types);
                    $scope.entry_types_col.data = F.getNgTableOpts(data.entry_types);
                    $scope.leave_reasons_col.data = F.getNgTableOpts(data.leave_reasons);
                    params.total(data.total);
                    $defer.resolve($scope.users);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.edit = function (m) {
            var pa = {
                user_id: m.id,
                sys_edit: true,
                title : '查看注册用户信息',
                confirm_state : m.confirm_state.id
            };

            Dlg.show({
                template: 'pages/personnel/userOnlyQuery.html',
                ctrl: 'PersonnelUserEditCtrl',
                data: pa,
                size: 'lg'
            }).then(function () {
                $scope.tableParams.reload();
            });
        };

        $scope.recover = function (user) {
            Dlg.show({
                template: 'LeavedUserRecoverDlg',
                ctrl: 'LeavedUserRecoverDlgCtrl',
                data: {
                    id: user.id
                }
            }).then(function () {
                $scope.tableParams.reload();
            });
        };

        $scope.exportLeaveUser = function () {
            $scope.exportLeaveUserLoading = true;
            FileHelper.dnExcel('/api/v1/user/users/export_leave_user', {}, '离职员工信息表.xls', function () {
                $scope.exportLeaveUserLoading = false;
                Dlg.s('导出成功');
            })
        };


    }

    /** @ngInject */
    function LeavedUserRecoverDlgCtrl($rootScope, User, $uibModalInstance, data, Dlg, FormHelper, $q) {
        var vm = this;
        vm.close = $uibModalInstance.close;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        init(data.id);


        function init(id) {
            User.get({id: id}, function (resp) {
                vm.m = resp.user;
            })
        }

        function ok(m) {
            var defer = $q.defer();
            if (!vm.Form.$valid) {
                FormHelper.handleError('#Form', vm.Form);
                defer.reject();
            } else {
                var pa = {
                    opt: 6,
                    dept_id: m.dept.id,
                    leave_time: null,
                    leave_reason_id: null
                };
                User.update({id: m.id}, pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s('员工恢复成功!');
                            break;
                        case 1:
                            Dlg.w('!');
                            break;
                    }
                    $rootScope.$broadcast('user_recover');
                    $uibModalInstance.close();
                }, function (error) {
                    Dlg.e('员工恢复失败!');
                }).finally(function () {
                    defer.resolve();
                });

            }

            return defer.promise;
        }
    }

})();



(function () {
    'use strict';

    angular.module('c')
        .controller('BulletinTypeCtrl', BulletinTypeCtrl)
    ;

    /** @ngInject */
    function BulletinTypeCtrl($scope, Table, ArrayHelper, Dlg, Api, BulletinType) {
        var vm = $scope;
        vm.addEdit = addEdit;
        vm.setStop = setStop;
        vm.remove = remove;

        init();


        function init() {
            var options = {
                service: BulletinType,
                params: {op: 'sys'},
                optInFront: true,
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "sorting", title: "序号", width: '72'},
                    {field: "name", title: "名称", filter: {name: "text"}},
                ]
            };

            Table.load(vm, options);
        }

        function addEdit(m) {
            Dlg.addEdit(vm, 'pages/sys/basic/bulletinTypeDlg.html', 'BulletinTypeDlgCtrl', m);
        }

        function setStop(m) {
            Api.setDisable(BulletinType, m)
        }

        function remove(m) {
            Dlg.confirm('确定要删除名为<strong>' + m.name + '</strong>的职称吗？', function () {
                BulletinType.delete({id: m.id}).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '删除请假类型');
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('BulletinTypeDlgCtrl', BulletinTypeDlgCtrl);

    /** @ngInject */
    function BulletinTypeDlgCtrl($uibModalInstance, ArrayHelper, Dlg, BulletinType, data) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;


        init(data.id);


        function init(id) {
            if (id) {
                BulletinType.get({id: id}).$promise.then(function (resp) {
                    var m = resp;
                    vm.m = m;
                });
            } else {
                vm.m = {
                    sorting: 1
                };
            }
        }

        function ok(m) {
            return Dlg.addEditOk(vm, BulletinType, function () {
                return {
                    name: m.name,
                    sorting: m.sorting,
                };
            });
        }
    }

})();

(function () {
    'use strict';
    
    angular.module('c.c')
        .controller('SysHospitalLeaderCtrl', SysHospitalLeaderCtrl)
        .controller('SysHospitalLeaderDlgCtrl', SysHospitalLeaderDlgCtrl)
    ;
    
    /** @ngInject */
    function SysHospitalLeaderCtrl($scope, Role, Table, Dlg) {
        var vm = $scope;
        vm.add = add;

        init();

        function init() {
            var options = {
                service: Role,
                params: {op: 'SysDean'},
                optInFront: true,
                hideOpt: true,
                cols: [
                    {field: "user", title: "姓名", filter: {user: "text"}},
                    {field: "start", title: "开始时间"},
                    {field: "end", title: "结束时间"}
                ]
            };
            Table.load(vm, options);
        }

        function add() {
            Dlg.show({
                template: 'SysHospitalLeaderDlg',
                ctrl: 'SysHospitalLeaderDlgCtrl'
            }).then(function () {
                vm.tableReload();
            });
        }
    }

    /** @ngInject */
    function SysHospitalLeaderDlgCtrl($uibModalInstance, Dlg, $q, FormHelper, Role) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        function ok(m) {
            var defer = $q.defer();
            if (!vm.Form.$valid) {
                FormHelper.handleError('#Form', vm.Form);
                defer.reject();
            } else {
                var pa = {
                    user_id: m.user.id,
                    op: 'SysDean'
                };
                Role.save(pa).$promise.then(function (resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function (error) {
                    Dlg.e(error.msg);
                });
            }
            defer.resolve();

            return defer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular.module('c')
        .controller('FileCabinetType', FileCabinetType)
    ;

    /** @ngInject */
    function FileCabinetType($scope, Table, ArrayHelper, Dlg, Api, FileCabinetType) {
        var vm = $scope;
        vm.addEdit = addEdit;
        vm.setStop = setStop;
        vm.remove = remove;

        init();


        function init() {
            var options = {
                service: FileCabinetType,
                params: {op: 'sys'},
                optInFront: true,
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "sorting", title: "序号", width: '72'},
                    {field: "name", title: "名称", filter: {name: "text"}},
                ]
            };

            Table.load(vm, options);
        }

        function addEdit(m) {
            Dlg.addEdit(vm, 'pages/sys/basic/fileCabinetTypeDlg.html', 'FileCabinetTypeDlgCtrl', m);
        }

        function setStop(m) {
            Api.setDisable(FileCabinetType, m)
        }

        function remove(m) {
            Dlg.confirm('确定要删除名为<strong>' + m.name + '</strong>的职称吗？', function () {
                FileCabinetType.delete({id: m.id}).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '删除请假类型');
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('FileCabinetTypeDlgCtrl', FileCabinetTypeDlgCtrl);

    /** @ngInject */
    function FileCabinetTypeDlgCtrl($uibModalInstance, ArrayHelper, Dlg, FileCabinetType, data) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;


        init(data.id);


        function init(id) {
            if (id) {
                FileCabinetType.get({id: id}).$promise.then(function (resp) {
                    var m = resp;
                    vm.m = m;
                });
            } else {
                vm.m = {
                    sorting: 1
                };
            }
        }

        function ok(m) {
            return Dlg.addEditOk(vm, FileCabinetType, function () {
                return {
                    name: m.name,
                    sorting: m.sorting,
                };
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('JobTitleCtrl', JobTitleCtrl)
    ;

    /** @ngInject */
    function JobTitleCtrl($scope, Table, ArrayHelper, Dlg, Api, JobTitle) {
        var vm = $scope;
        vm.addEdit = addEdit;
        vm.setStop = setStop;
        vm.remove = remove;

        init();


        function init() {
            var types = JobTitle.getTypes();
            var options = {
                service: JobTitle,
                params: {op: 'sys'},
                optInFront: true,
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "sorting", title: "序号", width: '72'},
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {
                        field: "type", title: '类型', filter: {type: 'select'},
                        data: Table.getNgTableOpts(types)
                    },
                ]
            };

            Table.load(vm, options, function (data) {
                angular.forEach(data.items, function (item) {
                    item.type = ArrayHelper.getItem(item.type, types);
                });
            });
        }

        function addEdit(m) {
            Dlg.addEdit(vm, 'pages/sys/basic/jobTitleDlg.html', 'JobTitleDlgCtrl', m);
        }

        function setStop(m) {
            Api.setDisable(JobTitle, m)
        }

        function remove(m) {
            Dlg.confirm('确定要删除名为<strong>' + m.name + '</strong>的职称吗？', function () {
                JobTitle.delete({id: m.id}).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '删除请假类型');
        }
    }

})();

(function () {
    'use strict';

    angular.module('c')
        .controller('JobTitleDlgCtrl', JobTitleDlgCtrl);

    /** @ngInject */
    function JobTitleDlgCtrl($uibModalInstance, ArrayHelper, Dlg, JobTitle, data) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.types = JobTitle.getTypes();


        init(data.id);


        function init(id) {
            if (id) {
                JobTitle.get({id: id}).$promise.then(function (resp) {
                    var m = resp;
                    m.type = ArrayHelper.getItem(m.type, vm.types);
                    vm.m = m;
                });
            } else {
                vm.m = {
                    sorting: 1
                };
            }
        }

        function ok(m) {
            return Dlg.addEditOk(vm, JobTitle, function () {
                return {
                    name: m.name,
                    sorting: m.sorting,
                    type: m.type.id,
                };
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('MeetingTypeCtrl', MeetingTypeCtrl)
        .controller('MeetingTypeDlgCtrl', MeetingTypeDlgCtrl)
    ;

    /** @ngInject */
    function MeetingTypeCtrl($scope, Dlg, Table, MeetingType, Api, F, ArrayHelper) {
        var vm = $scope;
        vm.addEdit = addEdit;
        // vm.save = save;
        vm.remove = remove;
        vm.disable = disable;
        vm.yesNo = ArrayHelper.get('yesNo');
        var yesNoOpts = Table.getNgTableOpts(vm.yesNo);

        init();


        function init() {
            var options = {
                service: MeetingType,
                params: {opt: 1/*SEARCH NEWS*/},
                optColWidth: Table._3_BTN,
                optInFront: true,
                showSn: true,
                cols: [
                    {field: 'name', title: '名称', filter: {'name': 'text'}}, //0
                    {field: 'sorting', title: '排序'} //0
                ]
            };

            Table.load(vm, options);
        }

        function addEdit(m) {
            var pa = {};
            if (m) {
                pa.id = m.id
            }
            Dlg.show({
                template: 'MeetingTypeDlg',
                ctrl: 'MeetingTypeDlgCtrl',
                data: pa
            }).then(function () {
                vm.tableReload();
            });
        }

        function remove(m) {
            Dlg.confirm('确定要删除名为<strong>' + m.name + '</strong>的会议类型吗？', function (resp) {
                MeetingType.delete({id: m.id}).$promise.then(function (resp) {
                    if (resp.result === 0) {
                        Dlg.s(resp.msg);
                    } else {
                        Dlg.e(resp.msg);
                    }
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '删除会议类型');
        }

        function disable(m) {
            Api.setStop(MeetingType, m);
        }
    }

    /** @ngInject */
    function MeetingTypeDlgCtrl($uibModalInstance, Dlg, data, MeetingType, $q, FormHelper) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);

        function init(id) {
            if (id) {
                MeetingType.get({id: id}, function (resp) {
                    vm.m = resp;
                })
            } else {
                vm.m = {
                    sorting: 100
                };
            }
        }

        function ok(m) {
            var defer = $q.defer();
            if (!vm.Form.$valid) {
                FormHelper.handleError('#Form', vm.Form);
                defer.reject();
            } else {
                var pa = {
                    name: m.name,
                    sorting: m.sorting
                };
                var promise;
                if (m.id) {
                    promise = MeetingType.update({id: m.id, opt: 1}, pa).$promise;
                } else {
                    promise = MeetingType.save(pa).$promise;
                }
                promise.then(function (resp) {
                    if (resp.msg) Dlg.s('添加成功!');
                    $uibModalInstance.close();
                }, function () {
                    Dlg.e('未知错误');
                }).finally(function () {
                    defer.resolve();
                });
            }
            return defer.promise;
        }
    }

})();

angular.module('c.c')
    .controller('RedHeadApproverCtrl', function ($scope, toaster, RedHeadApprover) {
        $scope.reload = function () {
            RedHeadApprover.get({id: 1}).$promise.then(function (resp) {
                $scope.setting = {
                    first_approver: resp.first_approver,
                    second_approver: resp.second_approver
                }
            });
        };
        $scope.reload();

        $scope.submit = function (setting) {
            if (setting.first_approver == null || setting.second_approver == null) {
                toaster.warning('审批人不能为空!');
            } else if (setting.first_approver.id == setting.second_approver.id) {
                toaster.warning('审批人不能相同!');
            }
            else {
                var params = {};
                params['first_approver_id'] = setting.first_approver.id;
                params['second_approver_id'] = setting.second_approver.id;

                RedHeadApprover.update({id: 1}, params).$promise.then(function (resp) {
                    toaster.success('审批人设置成功!');
                    $scope.reload();
                }, function () {
                    toaster.error('审批人设置失败!');
                });
            }
        }
    });

(function () {
    'use strict';

    angular.module('c.c')
        .controller('DeptManageCtrl', DeptManageCtrl)
        .controller('DeptDlgCtrl', DeptDlgCtrl);

    function DeptManageCtrl($scope, $filter, dialogs, toaster, NgTableParams, Dept, DeptType, F) {
        var needRefresh = true;
        $scope.$on('basicDataChange', function () {
            needRefresh = true;
        });

        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
        $scope.yesNo = F.get('yesNo');

        $scope.cols = [
            {title: '科室名称', filter: {name: 'text'}, field: 'name', show: true}, //0
            {title: '类别', filter: {type_id: 'select'}, field: 'type_id', show: true}, //1
            {title: '是否核算科室', filter: {can_account: 'select'}, data: yesNoOpts, field: 'can_account', show: true}, //6
            {title: '排列顺序', sortable: 'sorting', filter: {sorting: 'number_range'}, field: 'sorting', show: true} //6
        ];
        var types_col = $scope.cols[1];

        $scope.deptTabSelected = function () {
            if (needRefresh) {
                DeptType.query(function (resp) {
                    $scope.types = resp;
                    types_col.data = F.getNgTableOpts(resp);
                });
                needRefresh = false;
            }
        };

        $scope.numRangeFilter = {};
        $scope.$watch(
            function () {
                return $scope.numRangeFilter;
            },
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true
        );

        function getTableData(data, $defer, params, $filter) {
            if (params.filter()) {
                var filters = params.filter();
                if (filters['type_id']) {
                    data = $filter('filter')(data, {type_id: filters['type_id']}, function (actual, expected) {
                        return angular.equals(actual, +expected);
                    });
                }
                if (filters['can_account']) {
                    data = $filter('filter')(data, {can_account: filters['can_account']}, function (actual, expected) {
                        return angular.equals(actual, +expected);
                    });
                }
                if (filters['name']) {
                    data = $filter('filter')(data, {name: filters['name']});
                }
            }
            data = params.sorting() ?
                $filter('orderBy')(data, params.orderBy()) : data;
            params.total(data.length);
            if (params.page() > Math.ceil(data.length / params.count())) {
                params.$params.page = params.page() - 1;
            }
            if (params.page() == 0) {
                params.$params.page = 1;
            }
            $defer.resolve(data.slice((params.page() - 1) * params.count(),
                params.page() * params.count()));
        }

        $scope.tableParams = new NgTableParams({page: 1, count: 30}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                if (!$scope.cachedData) {
                    Dept.query(function (data) {
                        $scope.depts = data.depts;
                        $scope.types = data.types;
                        types_col.data = F.getNgTableOpts(data.types);
                        angular.forEach(data.depts, function (dept) {
                            dept.sorting = parseInt(dept.sorting);
                            dept.type_id = parseInt(dept.type_id);
                        });
                        $scope.cachedData = data.depts;
                        data = $filter('numInRange')(data.depts, $scope.numRangeFilter);
                        getTableData(data, $defer, params, $filter);
                    });
                } else {
                    var data = $scope.cachedData;
                    data = $filter('numInRange')(data, $scope.numRangeFilter);
                    getTableData(data, $defer, params, $filter);
                }
            }
        });

        $scope.tableReload = function () {
            $scope.cachedData = null;
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.numRangeFilter = {};
        };

        $scope.add = function () {
            dialogs.create('DeptDlg.html', 'DeptDlgCtrl', {types: $scope.types}, {
                size: 'md'
            }).result.then(function (dept) {
                    Dept.save(dept).$promise.then(function (data) {
                        toaster.success('科室添加成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('科室添加失败!');
                    });
                });
        };

        $scope.edit = function (dept) {
            dept.$edit = true;
            dept.$nameChanged = dept.name;
            dept.$typeChanged = dept.type;
            dept.$canAccountChanged = F.getItem(dept.can_account, $scope.yesNo);
            dept.$sortingChanged = dept.sorting;
        };

        $scope.save = function (dept) {
            dept.$edit = false;
            if (dept.$nameChanged == "") {
                toaster.warning('科室名称不能为空!', '');
            } else if (dept.name != dept.$nameChanged || dept.can_account != dept.$canAccountChanged.id
                || dept.type_id != dept.$typeChanged.id || dept.sorting != dept.$sortingChanged) {
                var data = {};
                data['name'] = dept.$nameChanged;
                data['type_id'] = dept.$typeChanged.id;
                data['can_account'] = dept.$canAccountChanged.id;
                data['sorting'] = dept.$sortingChanged;
                data['opt'] = 2;
                Dept.update({id: dept.id}, data).$promise.then(function (resp) {
                    toaster.success('科室修改成功!');
                    dept.name = dept.$nameChanged;
                    dept.type_id = dept.$typeChanged.id;
                    dept.type = dept.$typeChanged;
                    dept.can_account = dept.$canAccountChanged.id;
                    dept.sorting = parseInt(dept.$sortingChanged);
                    $scope.tableParams.reload();
                }, function (error) {
                    toaster.error('科室信息修改失败!');
                });
            }
        };

        $scope.delete = function (dept) {
            dialogs.confirm('删除科室记录', '确定要删除<strong>' + dept.name + '</strong>的科室吗?')
                .result.then(function () {
                    Dept.delete({id: dept.id}).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('科室记录删除成功!');
                                break;
                            case 1:
                                toaster.warning('存在属于该科室的成员,因此无法删除该科室!');
                                break;
                        }
                        $scope.tableReload();
                    }, function () {
                        toaster.error('科室记录删除失败!');
                    });
                });
        };

        $scope.setStop = function (m) {
            Dept.update({id: m.id}, {opt: 2, is_stop: !(m.is_stop == '1')})
                .$promise.then(function () {
                    m.is_stop = !(m.is_stop == '1');
                });
        }
    }

    function DeptDlgCtrl($scope, $uibModalInstance, toaster, data) {

        $scope.types = data.types;
        $scope.dept = {type: data.types[0], can_account: false, sorting: 100};

        $scope.ok = function (dept) {
            if ($scope.dept_form.$valid) {
                var params = {};
                params['name'] = dept.name;
                params['type_id'] = dept.type.id;
                params['can_account'] = dept.can_account;
                params['sorting'] = dept.sorting;
                $uibModalInstance.close(params);
            } else {
                toaster.warning('表单中有错误!');
                $scope.dept_form.submitted = true;
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();
(function () {
    'use strict';

    angular.module('c.c').controller('SectionCtrl', SectionCtrl);

    /** @ngInject */
    function SectionCtrl($scope, UIHelper, Section, Table, Dlg, Api) {
        var vm = $scope;
        vm.addEdit = addEdit;
        vm.dept = dept;
        vm.remove = remove;
        vm.setStop = setStop;

        init();


        function init() {
            UIHelper.loadTab(vm, 'section');

            var options = {
                service: Section,
                params: {op: 'sys'},
                optInFront: true,
                optColWidth: Table._4_BTN,
                cols: [
                    {field: "name", title: "部门名称", filter: {name: "text"}},
                    {field: "leader", title: "部长", filter: {leader: "text"}, width: Table._4_CHAR},
                    {field: "sorting", title: "排列顺序", filter: {sorting: "num_range"}, width: Table._4_CHAR}
                ]
            };
            Table.load(vm, options);
        }


        function addEdit(m) {
            Dlg.addEdit(vm, 'pages/sys/dept/sectionDlg.html', 'SectionDlgCtrl', m);
        }

        function dept(m) {
            Dlg.show({
                template: 'pages/sys/dept/sectionDeptDlg.html',
                ctrl: 'SectionDeptCtrl',
                size: 'lg',
                data: {m: m}
            });
        }

        function setStop(m) {
            Api.setDisable(Section, m)
        }

        function remove(m) {
            Dlg.confirm('确定要删除名为<strong>' + m.name + '</strong>的部门吗？', function () {
                Section.delete({id: m.id}).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '删除部门');
        }
    }
})();
(function () {
    'use strict';

    angular.module('c.c')
        .controller('SectionDeptCtrl', SectionDeptCtrl);

    /** @ngInject */
    function SectionDeptCtrl($scope, $uibModalInstance, Table, Dlg, Section, DeptType, data) {
        var vm = $scope;
        vm.add = add;
        vm.remove = remove;
        vm.cancel = $uibModalInstance.dismiss;


        init(data.m);


        function init(m) {
            vm.section = m.name;

            var options = {
                service: Section,
                params: {op: 'sys_dept', section_id: m.id},
                optInFront: true,
                optColWidth: Table._1_BTN,
                cols: [
                    {field: "name", title: "科室名称", filter: {name: "text"}},
                    {field: "type", title: "类别", filter: {type_id: "select"}}
                ]
            };

            DeptType.query(function (resp) {
                options.cols[1].data = Table.getNgTableOpts(resp);
            });

            Table.load(vm, options);
        }

        function add() {
            Dlg.show({
                template: 'directives/form/dept-selector/dept_selector_dlg.html',
                ctrl: 'DeptSelectCtrl',
                data: {
                    multiSelect: true
                }
            }).then(function (depts) {
                if (depts.length > 0) {
                    var pa = {depts: [], op: 'add_dept'};
                    angular.forEach(depts, function (dept) {
                        pa.depts.push(dept.id)
                    });
                    Section.update({id: data.m.id}, pa).$promise.then(function (resp) {
                        Dlg.s(resp.msg);
                        vm.tableReload();
                    }, function (error) {
                        if (error.data) Dlg.e(error.data.msg);
                    });
                }
            });
        }

        function remove(m) {
            Dlg.confirm('确定要删除部门<strong>' + vm.section + '</strong>下的' + m.name + '吗？', function () {
                Section.update({id: data.m.id, op: 'del_dept'}, {deptId: m.id}).$promise.then(function (resp) {
                    if (resp.msg) Dlg.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                });
            }, '删除科室');
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('SectionDlgCtrl', SectionDlgCtrl);

    /** @ngInject */
    function SectionDlgCtrl($uibModalInstance, Dlg, Section, data) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;


        init(data.id);


        function init(id) {
            if (id) {
                vm.m = Section.get({id: id}).$promise.then(function (resp) {
                    vm.m = resp;
                });
            } else {
                vm.m = {
                    sorting: 1
                };
            }
        }

        function ok(m) {
            return Dlg.addEditOk(vm, Section, function () {
                return {
                    name: m.name,
                    sorting: m.sorting,
                    leader_id: m.leader.id
                };
            });
        }
    }

})();

angular.module('c.c')
    .controller('MeetingDeviceCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams,
                                             MeetingDevice,F) {

        $scope.dev_types = F.get('device_types');
        var dev_typesOpts = F.getNgTableOpts( $scope.dev_types);


        $scope.cols = [
            {title: '设备名称', filter: {name: 'text'}, field: 'name', show: true},
            {title: '设备类型',  filter: {type: 'select'},  data: dev_typesOpts, field: 'type', show: true}, //6
            {title: '管理科室', filter: {dept_name: 'text'}, field: 'dept_name', show: true}, //6
            {title: '管理员', filter: {admin_name: 'text'}, field: 'admin_name',  show: true, width: '140'}, //6
            {title: '备注', field: 'remark',  width: '25%',show: true} //6
        ];

        $scope.optColWidth = 67;
        $scope.optInFront = true;
        $scope.showSn = true;
        $scope.tableParams = new NgTableParams({page: 1, count: 10}, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 1;
                MeetingDevice.query(url, function (resp) {
                    angular.forEach(resp.devices, function (d) {
                        d.type = F.getItem(d.type, $scope.dev_types);
                    });
                    params.total(resp.total);
                    $defer.resolve(resp.devices);
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
        };
        $scope.add = function () {
            dialogs.create('MeetingDeviceDlg.html', 'MeetingDeviceDlgCtrl', {}, {
                 size: 'md'
            }).result.then(function (d) {
                MeetingDevice.save(d).$promise.then(function (data) {
                    toaster.success('设备信息添加成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('设备信息添加失败!');
                });
            });
        };

        $scope.edit = function (d) {
            dialogs.create('MeetingDeviceDlg.html', 'MeetingDeviceDlgCtrl', {device: d}, {
                 size: 'md'
            }).result.then(function (pa) {
                MeetingDevice.update({id: d.id}, pa).$promise.then(function (data) {
                    toaster.success('设备信息修改成功!');
                    $scope.tableReload();
                }, function () {
                    toaster.error('设备信息修改失败!');
                });
            });
        };

        $scope.delete = function (d) {
            dialogs.confirm('删除设备信息', '确定要删除<strong>' + d.name + '</strong>相关信息吗?')
                .result.then(function () {
                MeetingDevice.delete({id: d.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('设备信息删除成功!');
                            break;
                        case 1:
                            toaster.warning('存在引用该设备信息的内容,因此无法删除该信息!');
                            break;
                    }
                    $scope.tableReload();
                }, function (error) {
                    toaster.error('设备信息删除失败!');
                });
            });
        };
    });

angular.module('c.c').controller('MeetingDeviceDlgCtrl', function ($scope, $uibModalInstance,
                                                                                 toaster, Dept, F, data) {

    $scope.dev_types = F.get('device_types');
    if (data.device) {
        $scope.$edit = true;
        var d = data.device;
        $scope.d = {
            name: d.name,
            type: d.type,
            remark: d.remark,
            admin: {id: d.admin_id, name: d.admin_name},
            dept: {id: d.dept_id, name: d.dept_name}
        };

    } else {
        $scope.d = {type:  $scope.dev_types[0]};
    }

    Dept.query({opt: 4}, function (resp) {
        $scope.depts = resp.depts;
        if (!$scope.d.dept && $scope.depts && $scope.depts.length > 0) {
            $scope.d.dept = $scope.depts[0];
        }
    });

    $scope.ok = function (d) {
        if (!d.admin) {
            toaster.warning('管理员不能为空!');
        } else if ($scope.d_form.$valid) {
            var pa = {};
            pa['name'] = d.name;
            pa['type'] = d.type.id;
            pa['admin_id'] = d.admin.id;
            pa['remark'] = d.remark;
            pa['dept_id'] = d.dept.id;
            $uibModalInstance.close(pa);
        } else {
            toaster.warning('表单中有错误!');
            $scope.d_form.submitted = true;
        }
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});



angular.module('c.c')
    .controller('MeetingRoomCtrl', function ($scope, $filter, dialogs, toaster, NgTableParams, Api,
                                             MeetingRoom, F) {
            var yesNoOpts = F.getNgTableOpts(F.get('yesOrNo2'));
            $scope.yesNo = F.get('yesOrNo2');
            $scope.yesNo2 = F.get('yesNo');

            $scope.cols = [
                {title: '会议室名称', filter: {name: 'text'}, field: 'name', show: true},
                {title: '容纳人数', sortable: 'capacity', filter: {capacity: 'num_range'}, field: 'capacity', show: true}, //6
                {title: '管理科室', filter: {dept_name: 'text'}, field: 'dept_name', show: true, width: '100'}, //6
                {title: '投影仪', filter: {has_projector: 'select'}, data: yesNoOpts, field: 'has_projector', show: true}, //6
                {title: '音响', filter: {has_audio: 'select'}, data: yesNoOpts, field: 'has_audio', show: true}, //6
                {title: '电脑', filter: {has_computer: 'select'}, data: yesNoOpts, field: 'has_computer', show: true}, //6
                {title: '信标', filter: {ibeacon_name: 'text'}, field: 'ibeacon_name', show: true}, //6
                {title: '管理员', filter: {admin_name: 'text'}, field: 'admin_name', show: true}, //6
                {title: '备注', field: 'remark', width: '61', show: true} //6
            ];

            $scope.numRangeFilter = {};
            $scope.$watch(
                function () {
                    return $scope.numRangeFilter;
                },
                function (newValue, oldValue) {
                    $scope.tableParams.reload();
                }, true
            );

            $scope.optColWidth = 108;
            $scope.optInFront = true;
            $scope.showSn = true;
            $scope.tableParams = new NgTableParams({page: 1, count: 10, sorting: {sorting: 'asc'}}, {
                counts: [10, 30, 50], total: 0,
                getData: function ($defer, params) {
                    var url = params.url();
                    url['opt'] = 1;
                    if ($scope.numRangeFilter.capacity != null) {
                        url['startCap'] = $scope.numRangeFilter.capacity.start;
                        url['endCap'] = $scope.numRangeFilter.capacity.end;
                    }
                    MeetingRoom.query(url, function (resp) {
                        params.total(resp.total);
                        $defer.resolve(resp.rooms);
                    });
                }
            });

            $scope.tableReload = function () {
                $scope.tableParams.reload();
            };

            $scope.clearFilters = function () {
                $scope.tableParams.filter({});
                $scope.numRangeFilter = {};
            };
            $scope.add = function () {
                dialogs.create('MeetingRoomDlg.html', 'MeetingRoomDlgCtrl', {}, {
                    size: 'md'
                }).result.then(function (r) {
                    MeetingRoom.save(r).$promise.then(function (data) {
                        toaster.success('会议室信息添加成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('会议室信息添加失败!');
                    });
                });
            };
            $scope.setStop = function (r) {
                Api.setStop(MeetingRoom, r);
            };

            $scope.edit = function (r) {
                dialogs.create('MeetingRoomDlg.html', 'MeetingRoomDlgCtrl', {room: r}, {
                    size: 'md'
                }).result.then(function (pa) {
                    MeetingRoom.update({id: r.id}, pa).$promise.then(function (data) {
                        toaster.success('会议室信息修改成功!');
                        $scope.tableReload();
                    }, function () {
                        toaster.error('会议室信息修改失败!');
                    });
                });
            };

            $scope.remove = function (r) {
                dialogs.confirm('删除会议室信息', '确定要删除<strong>' + r.name + '</strong>相关信息吗?')
                    .result.then(function () {
                    MeetingRoom.delete({id: r.id}).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('会议室信息删除成功!');
                                break;
                            case 1:
                                toaster.warning('存在引用该会议室信息的内容,因此无法删除该信息!');
                                break;
                        }
                        $scope.tableReload();
                    }, function (error) {
                        toaster.error('会议室信息删除失败!');
                    });
                });
            };
            $scope.editRemarks = function (r) {
                r.$edit = true;
                r.$remarkChanged = r.remark;
            };

            $scope.saveRemarks = function (r) {
                if (r.$remarkChanged.length > 255) {
                    toaster.warning('备注应该在255字以内!');
                    return;
                }

                r.$edit = false;
                if (r.$remarkChanged != r.remark) {
                    MeetingRoom.update({id: r.id}, {remark: r.$remarkChanged}).$promise.then(function () {
                        r.remark = r.$remarkChanged;
                        toaster.success('备注保存成功!');
                    }, function () {
                        toaster.error('备注保存失败!');
                    });
                }
            };
        }
    )
;

angular.module('c.c').controller('MeetingRoomDlgCtrl', function ($scope, $uibModalInstance,
                                                                 toaster, Dept, data, MeetingRoom) {
    if (data.room) {
        $scope.$edit = true;
        var r = data.room;
        $scope.r = {
            name: r.name,
            capacity: r.capacity,
            remark: r.remark,
            has_projector: r.has_projector == '1',
            has_audio: r.has_audio == '1',
            has_computer: r.has_computer == '1',
            admin: {id: r.admin_id, name: r.admin_name},
            dept: {id: r.dept_id, name: r.dept_name}
        };

    } else {
        $scope.r = {
            has_projector: true, has_audio: true, has_computer: true
        };
    }

    Dept.query({opt: 4}, function (resp) {
        $scope.depts = resp.depts;
        if (!$scope.r.dept && $scope.depts && $scope.depts.length > 0) {
            $scope.r.dept = $scope.depts[0];
        }
    });

    MeetingRoom.ibeacons({}, function (resp) {
        $scope.ibeacons = resp.items;
    });

    $scope.ok = function (r) {
        if (!r.admin) {
            toaster.warning('管理员不能为空!');
        } else if ($scope.r_form.$valid) {
            var pa = {};
            pa['name'] = r.name;
            pa['capacity'] = r.capacity;
            pa['has_projector'] = r.has_projector ? '1' : '0';
            pa['has_audio'] = r.has_audio ? '1' : '0';
            pa['has_computer'] = r.has_computer ? '1' : '0';
            pa['admin_id'] = r.admin.id;
            pa['ibeacon_id'] = r.ibeacon ? r.ibeacon.id : null;
            pa['remark'] = r.remark;
            pa['dept_id'] = r.dept.id;
            $uibModalInstance.close(pa);
        } else {
            toaster.warning('表单中有错误!');
            $scope.r_form.submitted = true;
        }
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});

(function () {
    'use strict';

    angular.module('c.c')
        .controller('MeetingAppliedController', MeetingAppliedController)
        .controller('AttendeesTipsCtrl', AttendeesTipsCtrl)
    ;

    /** @ngInject */
    function MeetingAppliedController($scope, $rootScope, $timeout, $filter, Dlg, NgTableParams,
                                      UIHelper, C, F, Meeting, Dept, MeetingType, Table) {
        $scope.$on(C.P + 'meeting.read', function (event, data) {
            var meeting = data.data.meeting;
            if ($scope.account.id == meeting.applicant_id) {
                var meetings = $scope.meetings;
                for (var i = 0; i < meetings.length; i++) {
                    if (meetings[i].id == meeting.id) {
                        var attendees = meetings[i].attendees;
                        for (var j = 0; j < attendees.length; j++) {
                            if (attendees[j].id == meeting.reader_id) {
                                attendees[j].is_read = true;
                            }
                        }
                    }
                }
            }
        });
        $scope.$on('meetingSubmit', function () {
            $scope.tableParams.reload();
        });

        $scope.$on(C.P + 'meeting.send', function (event, data) {
            $scope.tableParams.reload();
        });

        var yesNoOpts = Table.getNgTableOpts(F.get('yesNo'));
        var stages = F.getApprovalStages1();
        var stagesOpts = Table.getNgTableOpts(stages);

        $scope.cols = [
            {title: '全院可见', filter: {is_public: 'select'}, data: yesNoOpts, width: '100', show: true},
            {title: '名称', filter: {name: 'text'}, field: 'name', show: true},
            {title: '类型', sortable: 'type_id', filter: {type_id: 'select'}, width: '10%', show: true},
            {title: '申请科室', sortable: 'dept_id', filter: {dept_id: 'select'}, width: '10%', show: true},
            {title: '申请时间', /*filter: {created_at: 'date_range'},*/ width: '15%', show: true},
            {title: '开会时间', /*filter: {start_time: 'date_range'},*/ width: '20%', show: true},
            {title: '状态', filter: {stage: 'select'}, data: stagesOpts, width: '100', show: true}
        ];

        var typeCol = $scope.cols[2];
        MeetingType.query({opt: 2}, function (resp) {
            $scope.types = resp.items;
            typeCol.data = F.getNgTableOpts($scope.types);
        });

        var deptCol = $scope.cols[3];
        Dept.query({opt: 12}, function (resp) {
            var depts = resp.depts;
            deptCol.data = F.getNgTableOpts(depts);
            $scope.depts = depts;
        });

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.optColWidth = 130;
        $scope.optInFront = true;
        $scope.showSn = true;
        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                created_at: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 1;
                url['date_range_filters'] = {};
                if ($scope.dateRangeFilter.created_at != null) {
                    url['date_range_filters'] = {
                        created_at: {
                            startDate: $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd'),
                            endDate: $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd')
                        }
                    };
                }
                if ($scope.dateRangeFilter.start_time != null) {
                    url['date_range_filters'] = {
                        start_time: {
                            startDate: $filter('date')($scope.dateRangeFilter.start_time.startDate, 'yyyy-MM-dd'),
                            endDate: $filter('date')($scope.dateRangeFilter.start_time.endDate, 'yyyy-MM-dd')
                        }
                    };
                }
                Meeting.query(url, function (resp) {
                    params.total(resp.total);
                    angular.forEach(resp.meetings, function (meeting) {
                        meeting.stage = F.getItem(meeting.stage, stages);
                        meeting.time_range = meeting.start_time.substr(0, 16) + ' - ' + meeting.end_time.substr(11, 5);
                    });
                    $defer.resolve(resp.meetings);
                    $scope.meetings = resp.meetings;
                });
            }
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.show = function (meeting) {
            Dlg.show({
                template: 'templates/meeting/show_dlg.html',
                ctrl: 'MeetingShowDlgCtrl',
                data: {
                    id: meeting.id,
                    ForApplied: true, SmsAgain: true, isApplicant: true
                },
                size: 'lg'
            }).then(function (params) {
                switch (params.opt) {
                    case 2:
                        UIHelper.tabTo('apply', {op: 'meetingEdit', meeting: params.meeting});
                        break;
                }
            });
        };

        $scope.detail = function (meeting) {
            Dlg.show({
                template: 'templates/meeting/leave_dlg.html',
                ctrl: 'MeetingLeaveDlgCtrl',
                data: {
                    id: meeting.id,
                    isApplicant: true
                },
                size: 'lg'
            });
        };

        $scope.qrcode = function (meeting) {
            Dlg.show({
                template: 'templates/meeting/qrcode_dlg.html',
                ctrl: 'MeetingQrcodeDlgCtrl',
                data: {
                    meeting: meeting
                }
            });
        };

        //$scope.m2c = function (meeting) {
        //    dialogs.create('templates/meeting/m2c_dlg.html', 'M2CDlgCtrl', {meeting: meeting}, {
        //
        //        size: 'md'
        //    }).result.then(function (pa) {
        //            if (pa.paper) {
        //                var paper = pa.paper;
        //                paper.release_type = 4; //RELEASE_BY_COURSE
        //                paper.type = C.EDU.P.TYPE.NORMAL;
        //                paper.intro = paper.intro ? paper.intro : '';
        //                pa.paper = paper;
        //            }
        //            ECourse.save(pa).$promise.then(function (resp) {
        //                toaster.success('提交成功');
        //            }, function () {
        //                toaster.error('已存在相同课程题目,提交失败!');
        //            });
        //        });
        //};

        $scope.delete = function (meeting) {
            Dlg.confirm('确定要删除名为<strong>' + meeting.name + '</strong>的会议吗？', function (resp) {
                Meeting.delete({id: meeting.id}).$promise.then(function (resp) {
                    $scope.tableParams.reload();
                }, function (error) {
                    Dlg.e('删除失败!');
                });
            }, '删除会议');
        }
    }

    /** @ngInject */
    function AttendeesTipsCtrl($scope, $interval) {
        var attendees = $scope.meeting.attendees;
        var n = Math.ceil(attendees.length / 20);
        var i = 0;

        $scope.attendees = attendees.slice(i * 20, (i + 1) * 20);

        if (n > 1) {
            $scope.count = n;
            $scope.page = 1;
            var intervalPromise = $interval(function () {
                i++;
                if (i >= n) {
                    i = 0;
                }
                $scope.page = i + 1;
                $scope.attendees = attendees.slice(i * 20, (i + 1) * 20);
                if ($scope.attendees.length < 20) {
                    var k = 20 - $scope.attendees.length;
                    for (var j = 0; j < k; j++) {
                        $scope.attendees.push({name: '?'});
                    }
                }

            }, 3000);

            $scope.$on('$destroy', function () {
                $interval.cancel(intervalPromise);
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('MeetingApplyController', MeetingApplyController);

    /** @ngInject */
    function MeetingApplyController($scope, $q, dialogs, $filter, $timeout, toaster, C, F,
                                    Meeting, MeetingRoom, MeetingType, MeetingDevice,
                                    Dept, uibDateParser, FileHelper, UIHelper) {
        var vm = $scope;
        vm.searchIdle = searchIdle;
        vm.submit = submit;
        vm.reset = reset;
        vm.deleteAttachment = deleteAttachment;
        vm.upload = upload;
        vm.roomDetail = roomDetail;
        vm.devDetail = devDetail;

        init();


        function init() {
            vm.has_conflict = false;   //参会人是否有冲突
            $scope.$watch('meeting.all_attend',
                function (newValue, oldValue) {
                    if (newValue) {
                        $scope.meeting.is_public = true;
                        $scope.meeting.is_dept = false;
                        $scope.meeting.attendees = []
                    }
                }, true);

            UIHelper.loadTab($scope, 'apply', loadMeeting);
            if (UIHelper.hasTabExtra()) {
                loadMeeting(UIHelper.getTabExtra());
            } else {
                reset();
            }
        }


        function time2SliderVal(time) {
            var hour = parseInt(time.substr(0, 2));
            var minute = parseInt(time.substr(3, 2));
            return hour * 12 + minute / 5;
        }

        function loadMeeting(data) {
            if (!data || !data.meeting) return;
            var meeting = data.meeting;

            $scope.firstSearch = true;
            $scope.meeting['devices'] = [];
            $scope.meeting['room'] = null;
            $scope.meeting['place'] = null;
            $scope.meeting['name'] = meeting.name;
            $scope.meeting['type'] = meeting.type;
            $scope.meeting['dept'] = meeting.dept;
            $scope.meeting['all_attend'] = meeting.all_attend == '1';
            $scope.meeting['all_doctor'] = meeting.all_doctor == '1';
            $scope.meeting['all_nurse'] = meeting.all_nurse == '1';
            $scope.meeting['all_medical'] = meeting.all_medical == '1';
            $scope.meeting['is_public'] = meeting.is_public == '1';
            $scope.meeting['is_dept'] = meeting.is_dept == '1';
            $scope.meeting['with_sms'] = meeting.with_sms == '1';
            $scope.meeting['with_sms2'] = meeting.with_sms2 == '1';
            $scope.meeting['with_wx'] = meeting.with_wx == '1';
            $scope.meeting['is_wx_remind'] = meeting.is_wx_remind == '1';
            if (meeting.reminder_time != null) {
                $scope.meeting['is_remind'] = true;
            } else {
                $scope.meeting['is_remind'] = false;
            }
            $scope.meeting['date'] = uibDateParser.parse(meeting.start_time.substr(0, 10), 'yyyy-MM-dd');
            $scope.meeting.s.min = time2SliderVal(meeting.start_time.substr(11, 5));
            $scope.meeting.s.max = time2SliderVal(meeting.end_time.substr(11, 5));
            $scope.meeting['moderator'] = meeting.moderator;
            $scope.meeting['attendees'] = meeting.attendees;
            $scope.meeting['attachments'] = meeting.attachments;
            $scope.meeting['content'] = meeting.content;
        }

        function searchIdle(meeting) {
            if ($scope.firstSearch) {
                roomDetail();
            }
            if (!meeting.date) {
                toaster.warning('会议日期不能为空');
            } else if (meeting.s.min == meeting.s.max) {
                toaster.warning('会议开始和结束时间不能相等');
            } else {
                var date = $filter('date')(meeting.date, 'yyyy-MM-dd');
                var start = date + ' ' + meeting.s.options.translate(meeting.s.min);
                var end = date + ' ' + meeting.s.options.translate(meeting.s.max);
                MeetingRoom.query({opt: 2, start: start, end: end}, function (resp) {
                    $scope.rooms = resp.rooms;
                    $scope.rooms.splice(0, 0, {name: '无'});
                    if (meeting.room == null) {
                        meeting.room = $scope.rooms[0];
                    } else {
                        meeting.room = F.getItem(meeting.room.id, $scope.rooms);
                    }
                });
                MeetingDevice.query({opt: 2, start: start, end: end}, function (resp) {
                    $scope.devices = resp.devices;
                    var backup = meeting.devices;
                    meeting.devices = [];
                    $timeout(function () {
                        var devices = [];
                        angular.forEach(backup, function (dev) {
                            var device = F.getItem(dev.id, resp.devices);
                            if (device) {
                                devices.push(device);
                            }
                        });
                        meeting.devices = devices;
                    });
                });

                Meeting.query({opt: 12, start: start, end: end}, function (resp) {
                    if (resp.conflicts.length > 0) {
                        $scope.has_conflict = true;
                        $scope.conflicts = resp.conflicts.toString();
                    }
                });
                $scope.firstSearch = false;
            }
        }

        function submit(meeting) {
            if (meeting.name == null || meeting.name == "") {
                toaster.warning('名称不能为空!');
            } else if (!meeting.date) {
                toaster.warning('会议日期不能为空');
            } else if (meeting.s.min == meeting.s.max) {
                toaster.warning('会议开始和结束时间不能相等');
            } else if (meeting.place == null && meeting.room == null) {
                toaster.warning('请选择会议室或备注地点!');
            } else if (meeting.place == null && meeting.room.id == null) {
                toaster.warning('请选择会议室或备注地点!');
            } else if (!meeting.all_attend && !meeting.all_medical && !meeting.all_doctor && !meeting.all_nurse && meeting.attendees.length == 0) {
                toaster.warning('请填写参会人!');
            } else if (meeting.content == "") {
                toaster.warning('内容不能为空!');
            } else if (!FileHelper.isAttachmentsUploaded(meeting)) {
                toaster.warning('请等一小会儿,部分附件还在路上');
            } else {
                var defer = $q.defer();
                var params = {};
                params['name'] = meeting.name;
                var date = $filter('date')(meeting.date, 'yyyy-MM-dd');
                var start = date + ' ' + meeting.s.options.translate(meeting.s.min);
                var end = date + ' ' + meeting.s.options.translate(meeting.s.max);
                params['start_time'] = start;
                params['end_time'] = end;
                //将参会人id放入参会人组
                params['attendees'] = [];
                angular.forEach(meeting.attendees, function (attendee) {
                    params['attendees'].push(attendee.id);
                });
                if (meeting.moderator != null) {
                    params['moderator_id'] = meeting.moderator.id;
                    var index = F.indexOf(meeting.moderator.id, params['attendees']);
                    if (index >= 0) {
                        params['attendees'].splice(index, 1);
                    }
                }
                params['content'] = meeting.content;
                params['all_attend'] = meeting.all_attend ? '1' : '0';
                params['all_medical'] = meeting.all_medical ? '1' : '0';
                params['all_nurse'] = meeting.all_nurse ? '1' : '0';
                params['all_doctor'] = meeting.all_doctor ? '1' : '0';
                params['is_dept'] = meeting.is_dept ? '1' : '0';
                params['is_public'] = meeting.is_public ? '1' : '0';
                params['with_wx'] = meeting.with_wx ? '1' : '0';
                params['is_wx_remind'] = meeting.is_wx_remind ? '1' : '0';
                if (meeting.is_dept) {
                    params['is_public'] = '0'
                }
                params['type_id'] = meeting.type.id;
                if (meeting.room == null) {
                    params['room_id'] = null;
                } else {
                    if (meeting.room.id == null) {
                        params['room_id'] = null;
                    } else {
                        params['room_id'] = meeting.room.id;
                    }
                }
                params['dept_id'] = meeting.dept.id;
                params['place'] = meeting.place;
                params['devices'] = [];
                angular.forEach(meeting.devices, function (dev) {
                    params['devices'].push(dev.id);
                });
                if (meeting.all_attend || meeting.all_doctor || meeting.all_nurse || meeting.all_medical) {
                    params['with_sms'] = 0;
                    params['is_remind'] = 0;
                    params['is_import'] = 1;
                } else {
                    params['with_sms'] = meeting.with_sms ? '1' : '0';
                    params['is_remind'] = meeting.is_remind ? '1' : '0';
                    params['is_import'] = meeting.is_import ? '1' : '0';
                }
                params['with_sms2'] = meeting.with_sms2 ? '1' : '0';
                params['attachments'] = [];
                angular.forEach(meeting.attachments, function (attachment) {
                    params['attachments'].push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                });
                Meeting.save(params).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            defer.resolve();
                            toaster.success('会议申请成功!');
                            $scope.reset();
                            UIHelper.tabTo('applied');
                            break;
                        case 1:
                            defer.reject();
                            toaster.warning('会议室冲突,请重新申请');
                            break;
                        case 2:
                            defer.reject();
                            toaster.warning('设备冲突,请重新申请');
                            break;
                    }
                }, function () {
                    defer.reject();
                    toaster.error('会议申请失败了!');
                });
                return defer.promise;
            }
        }

        function reset() {
            $scope.today = new Date();
            $scope.firstSearch = true;
            $scope.meeting = {
                all_attend: false,
                all_doctor: false,
                all_nurse: false,
                all_medical: false,
                is_public: true,
                is_import: false,
                attachments: [],
                is_dept: false,
                devices: [],
                attendees: [],
                date: $scope.today,
                content: '',
                public: true,
                with_wx: true,
                is_wx_remind: true,
                s: {
                    min: 144, max: 168, options: {
                        floor: 84,
                        ceil: 276,
                        translate: function (val) {
                            var h = Math.floor(val / 12);
                            var m = (val % 12) * 5;
                            return h + ':' + (m >= 10 ? '' : '0') + m;
                        }
                    }
                }
            };
            MeetingType.query({opt: 2}, function (resp) {
                $scope.types = resp.items;
                Dept.query({opt: 12}, function (resp) {
                    $scope.depts = resp.depts;
                    $scope.meeting['dept'] = $scope.depts[0];
                    $scope.meeting['type'] = $scope.types[0];
                });
            });
        }

        function deleteAttachment($index, meeting) {
            meeting.attachments.splice($index, 1);
        }

        function upload(file, meeting, e) {
            FileHelper.upload(C.URL.MEETING_UPLOAD, file, meeting, e);
        }

        function roomDetail() {
            dialogs.create('templates/meeting/room_detail.html', 'RoomDetailCtrl', {
                date: $scope.meeting.date
            }, {size: 'lg'})
        }

        function devDetail() {
            dialogs.create('templates/meeting/dev_detail.html', 'DevDetailCtrl', {
                date: $scope.meeting.date
            }, {size: 'lg'})
        }
    }

})();


(function () {
    'use strict';

    angular.module('c.c').controller('MeetingSearchController', MeetingSearchController);

    /** @ngInject */
    function MeetingSearchController($scope, $filter, dialogs, toaster, NgTableParams, F, DateHelper,
                                     Meeting, MeetingType, uibDateParser, Dlg) {
        $scope.$on('MeetingRead', function (event, data) {
            var id = data;
            var index = F.indexOfKey(id, $scope.tableParams.data);
            if (index >= 0 && $scope.tableParams.data[index].recipient == null) {
                $scope.tableParams.data[index].recipient = 1;
            }
        });

        $scope.init = function (op) {
            var readStatusOpts = F.getNgTableOpts(F.get('readOrUnread'));

            $scope.cols = [
                {title: '状态', filter: {is_read: 'select'}, data: readStatusOpts, width: '100', show: true},
                {title: '名称', filter: {name: 'text'}, show: true, width: '160'},
                {title: '类型', filter: {type_id: 'select'}, show: true},
                {title: '开会时间', filter: {start_time: 'date_range'}, show: true},
                {title: '开会地点', show: true},
                {title: '科室', filter: {dept: 'text'}, show: true, width: '130'},
                {title: '申请人', filter: {applicant: 'text'}, show: true, width: '120'}
            ];

            var typeCol = $scope.cols[2];
            MeetingType.query({opt: 2}, function (resp) {
                $scope.types = resp.items;
                typeCol.data = F.getNgTableOpts($scope.types);
            });

            $scope.dateRangeFilter = {};
            $scope.$watch('dateRangeFilter',
                function (newValue, oldValue) {
                    $scope.tableParams.reload();
                }, true);

            $scope.optColWidth = 172;
            $scope.optInFront = true;
            $scope.showSn = true;
            $scope.tableParams = new NgTableParams({
                page: 1, count: 10
            }, {
                counts: [10, 30, 50], total: 0,
                getData: function ($defer, params) {
                    var url = params.url();
                    url['opt'] = op;//2 查找会议 9 我的会议
                    if ($scope.dateRangeFilter.start_time != null) {
                        url['startDate'] = $filter('date')($scope.dateRangeFilter.start_time.startDate, 'yyyy-MM-dd');
                        url['endDate'] = $filter('date')($scope.dateRangeFilter.start_time.endDate, 'yyyy-MM-dd');
                    }
                    Meeting.query(url, function (resp) {
                        params.total(resp.total);
                        angular.forEach(resp.meetings, function (meeting) {
                            meeting.forLeave = false;
                            meeting.forRemind = false;
                            meeting.isLeaver = false;
                            meeting.forRCancel = false;
                            meeting.forDayRemind = false;
                            meeting.isModerator = false;
                            meeting.isApplicant = false;
                            meeting.time_range = meeting.start_time.substr(0, 16) + ' - ' + meeting.end_time.substr(11, 5);
                            var start = new Date(),
                                end = uibDateParser.parse(meeting.start_time, 'yyyy-MM-dd HH:mm:ss');

                            var yesterday = new Date(end - 24 * 60 * 60 * 1000),
                                time = $filter('date')(yesterday, 'yyyy-MM-dd') + ' ' + '08:30:00',
                                y_start = uibDateParser.parse(time, 'yyyy-MM-dd HH:mm:ss');

                            if (DateHelper.diffInHours(start, y_start) >= 1) {
                                if (op == 9) {
                                    if (meeting.attendees.length > 0) {
                                        if (meeting.attendees[0].reminder_time) {
                                            meeting.forRCancel = true;
                                        } else {
                                            meeting.forDayRemind = true;
                                        }
                                    }
                                }
                            }

                            if (DateHelper.diffInHours(start, end) >= 1) {
                                if (op == 9) {
                                    if (meeting.attendees.length > 0) {
                                        if (meeting.attendees[0].reminder_time) {
                                            meeting.forRCancel = true;
                                        } else {
                                            meeting.forRemind = true;
                                        }
                                    }
                                }
                            }

                            if (DateHelper.diffInMinutes(start, end) >= 30) {
                                if (meeting.attendees.length > 0) {
                                    meeting.forLeave = true;
                                }
                            }

                            if (meeting.leavers.length > 0) {
                                meeting.isLeaver = true;
                                meeting.forLeave = false;
                            }

                            if (meeting.moderator_id && meeting.moderator_id == $scope.account.id) {
                                meeting.isModerator = true;
                            }

                            if (meeting.applicant_id == $scope.account.id) {
                                meeting.isApplicant = true;
                            }
                        });
                        $defer.resolve(resp.meetings);
                        $scope.meetings = resp.meetings;
                    });
                }
            });

            $scope.clearFilters = function () {
                $scope.tableParams.filter({});
                $scope.dateRangeFilter = {};
            };
        };

        $scope.show = function (meeting) {
            dialogs.create('templates/meeting/show_dlg.html', 'MeetingShowDlgCtrl', {
                    id: meeting.id,
                    ForLeave: meeting.forLeave,
                    ForRemind: meeting.forRemind,
                    ForDayRemind: meeting.forDayRemind,
                    ForRCancel: meeting.forRCancel,
                    isApplicant: meeting.isApplicant,
                    isModerator: meeting.isModerator
                },
                {size: 'lg'}).result.then(function (params) {
                switch (params.opt) {
                    case 4:
                        $scope.leave(meeting);
                        break;
                    case 5:
                        $scope.remind(meeting, params.op);
                        break;
                    case 6:
                        $scope.cancel(meeting);
                        break;
                }
            });
        };

        $scope.leave = function (meeting) {
            // dialogs.create('templates/basic/comment_dlg.html', 'CommentDlgCtrl', {
            //     title: '会议请假',
            //     icon: 'sign-out',
            //     label: '原因'
            // }, {
            //
            //     size: 'sm'
            // }).result.then(function (pa) {
            Dlg.comment({title: '会议请假', icon: 'sign-out', label: '原因'}, function (pa) {
                var params = {};
                params['reason'] = pa;
                params['start_time'] = meeting.start_time;
                Meeting.leave({id: meeting.id}, params).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('请假成功');
                                $scope.tableParams.reload();
                                break;
                            case 1:
                                toaster.warning('请在开会前半小时请假!');
                                break;
                        }
                    }, function () {
                        toaster.error('请假失败了!');
                    }
                )
            });
        };

        $scope.remind = function (meeting, op) {
            dialogs.confirm('会前提醒', '确定要会前' + (op == 1 ? '半小时' : '一天08:30') + '短信提醒吗?').result.then(function () {
                Meeting.setReminderTime({id: meeting.id}, {opt: op}).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('设置成功!');
                                $scope.tableParams.reload();
                                break;
                            case 1:
                                toaster.warning('请在开会前一小时设置!');
                                break;
                            case 2:
                                toaster.warning('该会议已统一设置会前半小时提醒!');
                                break;
                            case 3:
                                toaster.warning('请在开会前一天08:30之前设置!');
                                break;
                        }
                    }, function () {
                        toaster.error('设置失败了!');
                    }
                )
            });
        };

        $scope.cancel = function (meeting) {
            dialogs.confirm('取消会前提醒', '确定要取消会前短信提醒吗?').result.then(function () {
                Meeting.setReminderTime({id: meeting.id}, {opt: 3}).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('取消成功!');
                                $scope.tableParams.reload();
                                break;
                            case 1:
                                toaster.warning('请在开会前一小时取消!');
                                break;
                        }
                    }, function () {
                        toaster.error('取消失败了!');
                    }
                )
            });
        };

        $scope.qrcode = function (meeting) {
            dialogs.create('templates/meeting/qrcode_dlg.html', 'MeetingQrcodeDlgCtrl', {meeting: meeting},
                {size: 'md'});
        };

        $scope.exportMeeting = function () {
            dialogs.create('templates/export_meeting_dlg.html', 'ExportMeetingCtrl', {},
                {size: 'md'});
        };

    }
})();

angular.module('c.c').controller('MissionApplyController',
    function ($scope, $rootScope, dialogs, $filter, $timeout, toaster, Upload
        , C, F, Auth, Mission, Dept, FileHelper) {

        var today = new Date();

        $scope.$on('missionApply', function (ev, doc) {
            var getData = $scope.mission;
            getData['name'] = doc.subject;
            getData['publish'] = Auth.getAccount();
            getData['coworkers'] = [];
            coworker_id = [];
            if (getData['publish']['id'] != doc.applicant.id) {
                getData['coworkers'].push(doc.applicant);
                coworker_id.push(doc.applicant.id);
            }
            angular.forEach(doc.steps, function (step) {
                if (step.handler.id != null && coworker_id.indexOf(step.handler.id) == -1
                    && getData['publish']['id'] != step.handler.id) {
                    getData['coworkers'].push(step.handler);
                    coworker_id.push(step.handler.id);
                }
            });
            getData['content'] = doc.body;
            getData['attachments'] = doc.attachments;
            $scope.mission = getData;
        });

        $scope.submit = function (mission) {
            if (mission.name == null || mission.name == "") {
                toaster.warning('任务名称不能为空!');
            } else if (mission.publishers.length == 0) {
                toaster.warning('请填写任务负责人');
            } else if (!mission.start) {
                toaster.warning('任务开始日期不能为空');
            } else if (!mission.end) {
                toaster.warning('任务结束日期不能为空');
            } else if (mission.start == mission.end) {
                toaster.warning('任务开始与结束日期不能相等');
            } else if (mission.end < today) {
                toaster.warning('任务结束日期不能小于当前日期');
            } else if (mission.start > mission.end) {
                toaster.warning('任务开始不能大于结束日期');
            } else if (mission.content == "") {
                toaster.warning('内容不能为空!');
            } else {
                for (var i = 0; i < mission.attachments.length; i++) {
                    if (mission.attachments[i].filename == null) {
                        toaster.warning('请等一小会儿,部分附件还在路上');
                        return;
                    }
                }
                var params = {};
                params['name'] = mission.name;
                params['start_time'] = $filter('date')(mission.start, 'yyyy-MM-dd HH:mm');
                params['end_time'] = $filter('date')(mission.end, 'yyyy-MM-dd HH:mm');

                params['dept_id'] = mission.dept.id;
                params['publishers'] = mission.publishers;
                //angular.forEach(mission.publishers, function (publisher) {
                //    params['publishers'].push(publisher.id);
                //    params['publishers'][publisher.id]['coworkers'] = [];
                //    angular.forEach(publisher.workers, function (worker) {
                //        params['publishers'][publisher.id]['coworkers'].push(worker.id);
                //    });
                //});

                params['source'] = mission.source.id;


                params['content'] = mission.content;
                params['with_sms'] = mission.with_sms ? '1' : '0';
                params['is_public'] = mission.is_public ? '1' : '0';
                params['is_remind'] = mission.is_remind ? '1' : '0';


                params['attachments'] = [];
                angular.forEach(mission.attachments, function (attachment) {
                    params['attachments'].push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                });
                Mission.save(params).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success('任务申请成功!');
                            $scope.reset();
                            $scope.tabs['personal'] = true;
                            $rootScope.$broadcast('missionSubmit');
                            break;
                        case 1:
                            toaster.warning('非工作日不允许申请任务!');
                    }
                }, function () {
                    toaster.error('任务申请失败了!');
                });
            }
        };

        $scope.reset = function () {
            $scope.mission = {
                is_public: true,
                attachments: [],
                publishers: [],
                start: new Date(),
                end: new Date(new Date().valueOf() + 1 * 24 * 60 * 60 * 1000),   //自动加一天
                content: ''
            };
            Dept.query({opt: 12}, function (resp) {
                $scope.depts = resp.depts;
                var keep_going = true;
                angular.forEach(resp.depts, function (dept) {
                    if (keep_going) {
                        if (dept.is_main) {
                            $scope.mission['dept'] = dept;
                            keep_going = false;
                        }
                    }
                });
                $scope.sourceSelectFn();
            });
        };
        $scope.reset();

        $scope.sourceSelectFn = function () {
            Mission.query({
                dept_id: $scope.mission['dept'].id,
                op: 'source'
            }, function (resp) {
                var sources = F.get('mission_sources');
                var params = [];
                angular.forEach(resp.limit, function (source) {
                    params.push(sources[source]);
                });
                $scope.mission_sources = params;
                $scope.mission['source'] = $scope.mission_sources[0];
            });
        };
        $scope.timeOptions = {
            readonlyInput: false,
            showMeridian: false
        };
        $scope.deleteAttachment = function ($index, mission) {
            mission.attachments.splice($index, 1);
        };

        $scope.upload = function (file, mission, e) {
            FileHelper.upload(C.URL.MEETING_UPLOAD, file, mission, e);
        };
    })
;

angular.module('c.c').controller('MissionArrangeController',
    function ($scope, $timeout, $rootScope, $filter, dialogs, toaster, Mission,MissionReport, F, Table) {
        $scope.$on('missionSubmit', function () {
            $scope.tableParams.reload();
        });
        $scope.$on('missionStateChange', function () {
            $scope.tableParams.reload();
        });
        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
        var statusOpts = F.getNgTableOpts(F.get('handle_states'));
        var sourcesOpts = F.getNgTableOpts(F.get('mission_sources'));

        var options = {
            service: Mission,
            params: {opt : 10},
            optColWidth: 53,
            dateFilters: [{name: 'created_at'}],
            items: 'missions',
            cols: [
                {title: '全院可见', filter: {is_public: 'select'}, data: yesNoOpts, width: '5%'},
                {title: '名称', filter: {name: 'text'}, width: '15%'},
                {title: '来源', sortable: 'source', filter: {source: 'select'},data: sourcesOpts, width: '10%'},
                {title: '负责人', filter: {publish: 'text'}, width: '10%'},
                {title: '协助人', width: '10%'},
                {title: '任务时间', sortable: 'start_time', filter: {start_time: 'date_range'}, width: '25%'},
                {title: '状态', filter: {state: 'select'}, data: statusOpts, width: '10%'}
            ]
        };

        Table.loadNgTable($scope, options, function (data) {
            userid = data.userid;
            angular.forEach(data.missions, function (mission) {
                mission.time_range = mission.start_time.substr(0, 16) + ' - ' + mission.end_time.substr(0,16);
                if (mission.state && mission.state.length > 0) {
                    mission.state = F.getItem(mission.state, F.get('handle_states'));
                } else {
                    mission.state = {name: '任务错误'};
                }
                if (mission.source && mission.source.length > 0) {
                    mission.source = F.getItem(mission.source, F.get('mission_sources'));
                } else {
                    mission.source = {name: '错误来源'};
                }
                mission.ForSubmit = (mission.state.id == 2);
                mission.ForState = (mission.state.id != 3);
            })
        });

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.show = function (mission) {
            dialogs.create('pages/dlg/mission/temp/show_dlg.html', 'MissionShowDlgCtrl', {
                    id: mission.id,
                    ForSubmit: mission.ForSubmit ,
                    ForHistory: true,
                    ForState: mission.ForState
                },
                { size: 'lg'}).result.then(function (params) {
                switch (params.opt) {
                    case 4:
                        $scope.submit(mission);
                        break;
                    case 5:
                        $scope.state(mission);
                }
            });
        };
        $scope.state = function (mission) {
            dialogs.create('templates/mission/state_dlg.html', 'MissionStateDlgCtrl', {
                    stateId: mission.state.id,
                    missionId: mission.id,
                    forApplicant: true
                },
                { size: 'md'}).result.then(function (pa) {
                switch (pa.opt){
                    case 1 :
                        $scope.delete(mission);
                        break;
                    case 4 :
                        Mission.update({id: mission.id}, {
                            opt : 4,
                            state_id : pa.mission.state.id
                        }).$promise.then(function (resp) {
                            switch (resp.result){
                                case 0 :
                                    toaster.success('任务状态修改成功');
                                    $scope.tableParams.reload();
                                    $rootScope.$broadcast('missionStateChange');
                                    break;
                                case 1 :
                                    toaster.error('任务已到期,请为任务延期');
                                    break;
                            }
                        },function () {
                            toaster.error('任务状态修改出错');
                        });
                        break;
                    case 5 :
                        Mission.update({id: mission.id}, {
                            opt : 5 ,
                            delay : pa.mission.delay
                        }).$promise.then(function (resp) {
                            switch (resp.result){
                                case 0 :
                                    toaster.success('任务延期成功');
                                    $scope.tableParams.reload();
                                    $rootScope.$broadcast('missionStateChange');
                                    break;
                            }
                        },function () {
                            toaster.error('任务延期失败');
                        });
                        break;
                    case 12 :
                        Mission.update({id: mission.id}, {
                            opt : 12 ,
                            publish_id : pa.publish_id,
                            coworkers : pa.coworkers
                        }).$promise.then(function (resp) {
                            switch (resp.result){
                                case 0 :
                                    toaster.success('任务参与人修改成功');
                                    $scope.tableParams.reload();
                                    $rootScope.$broadcast('missionStateChange');
                                    break;
                            }
                        },function () {
                            toaster.error('任务参与人修改出错!');
                        });
                        break;
                }
            });
        };
        $scope.delete = function (mission) {
            dialogs.confirm('删除任务', '确定要删除<strong>' + mission.name + '</strong>吗?')
                .result.then(function () {
                Mission.delete({id: mission.id}).$promise.then(function (resp) {
                    $scope.tableParams.reload();
                }, function () {
                    toaster.error('删除失败!');
                });
            });
        };
        $scope.submit = function (mission) {
            dialogs.create('templates/mission/submit_dlg.html', 'MissionSubmitDlgCtrl', {},
                { size: 'md'}).result.then(function (pa) {
                var params=pa;
                params['mission_id']=mission.id;
                params['state_id'] = mission.state.id;
                MissionReport.save(params).$promise.then(
                    function (resp) {
                        switch (resp.result){
                            case 0:
                                toaster.success('任务进度提交成功');
                                $scope.tableParams.reload();
                                break;
                            case 1:
                                toaster.warning('任务状态错误!');
                        }
                    },function () {
                        toaster.error('任务进度提交失败!');
                    }
                )
            });
        };

    });
(function () {
    'use strict';

    angular.module('c.c')
        .controller('MissionCalendarController', MissionCalendarController);

    /** @ngInject */
    function MissionCalendarController($scope, dialogs, toaster, DateHelper, Mission, MissionReport) {
        $scope.$on('missionSubmit', function () {
            $scope.init();
        });
        $scope.$on('missionStateChange', function () {
            $scope.init();
        });

        $scope.vm = {};
        $scope.vm.calendarView = 'month';
        $scope.vm.viewDate = new Date();
        $scope.vm.isCellOpen = true;

        $scope.vm.eventClicked = function (event) {
            dialogs.create('pages/dlg/mission/temp/show_dlg.html', 'MissionShowDlgCtrl', {
                    id: event.mission_id,
                    ForSubmit: true,
                    ForHistory: true
                },
                {size: 'lg'}).result.then(function (params) {
                switch (params.opt) {
                    case 4:
                        $scope.submit(event);
                        break;
                }
            });
        };
        $scope.init = function () {
            Mission.query({opt: 7}, function (resp) {
                var missions = resp['missions'];
                $scope.vm.events = [];
                $scope.vm.calendarView = 'year';
                angular.forEach(missions, function (mission) {
                    var title = mission.name;
                    var now = new Date();
                    var startTime = DateHelper.str2Datetime(mission.start_time);
                    var endTime = DateHelper.str2Datetime(mission.end_time);
                    if (now > endTime) {
                        var dayCount = Math.ceil((Math.abs(now - endTime)) / 1000 / 60 / 60 / 24);
                        title += ' [过期' + dayCount + '天]'
                    }
                    $scope.vm.events.push({
                        title: title,
                        type: mission.mission_type,
                        startsAt: startTime,
                        endsAt: endTime,
                        mission_id: mission.id,
                        state: mission.state
                    });
                })
            });
        };
        $scope.init();
        //作为任务的负责人或者是协助人一定有查看提交的权限
        $scope.submit = function (event) {
            dialogs.create('templates/mission/submit_dlg.html', 'MissionSubmitDlgCtrl', {},
                {size: 'md'}).result.then(function (pa) {
                var params = pa;
                params['mission_id'] = event.mission_id;
                params['state_id'] = event.state;
                MissionReport.save(params).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('任务进度提交成功');
                                break;
                            case 1:
                                toaster.warning('任务状态错误!');
                        }
                    }, function () {
                        toaster.error('任务进度提交失败!');
                    }
                );
            });
        };
    }

})();

angular.module('c.c').controller('MissionManageController',
    function ($scope, $rootScope, $timeout, $filter, dialogs, toaster, F, Table, Mission,
              MissionReport, Dept, Api, Auth, C) {
        $scope.$on('missionSubmit', function () {
            $scope.tableReload();
        });
        $scope.$on('missionStateChange', function () {
            $scope.tableReload();
        });
        $scope.$on('missionRead', function () {
            $scope.tableReload();
        });

        $scope.user = Auth.getAccount();

        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));
        var statusOpts = F.getNgTableOpts(F.get('handle_states'));
        var readStatusOpts = F.getNgTableOpts(F.get('newOrNot'));

        function init(opt, options) {
            options.primaryParam = 'dept_id';
            options.params.opt = opt;
            options = Table.loadNgTable($scope, options, function (data) {
                userid = data.userid;
                angular.forEach(data.missions, function (mission) {
                    mission.forApplicant = mission.applicant_id == userid;
                    if (mission.state && mission.state > 0) {
                        mission.state = F.getItem(mission.state, F.get('handle_states'));
                    } else {
                        mission.state = {name: '任务错误'};
                    }
                    if (mission.publish_id == userid || mission.applicant_id == userid) {
                        mission.forSubmit = true;
                        mission.forChange = true;
                    }
                    angular.forEach(mission.coworkers, function (coworker) {
                        if (coworker != null && coworker.id == userid) {
                            mission.forSubmit = true;
                        }
                    });
                    if (mission.state.id != 2) {
                        mission.forSubmit = false;
                    }
                    if (mission.state.id == 3) {
                        mission.forChange = false;
                    }
                })
            }).options;
            $scope.deptSelectedFn = function ($index) {
                $scope.dept = $scope.depts[$index];
                $scope.tableParams.$params.page = 1;
                options().params.dept_id = $scope.dept.id;
                $scope.tableReload();
            };
        }

        $scope.select = function (opt) {
            var options = {
                service: Mission,
                params: {opt: 1, dept_id: 1},
                optColWidth: 53,
                dateFilters: [{name: 'created_at'}],
                items: 'missions',
                cols: [
                    {
                        title: '状态',
                        filter: {is_read: 'select'},
                        data: readStatusOpts,
                        width: '8%',
                        show: true
                    },
                    {title: '全院可见', filter: {is_public: 'select'}, data: yesNoOpts, width: '5%'},
                    {title: '名称', filter: {name: 'text'}, field: 'name'},
                    {title: '申请人', filter: {applicant: 'text'}, width: '10%'},
                    {title: '负责人', filter: {publish: 'text'}, width: '10%'},
                    {title: '协助人', width: '10%'},
                    {title: '申请时间', sortable: 'created_at', filter: {created_at: 'date_range'}, width: '20%'},
                    {title: '状态', filter: {state: 'select'}, data: statusOpts, width: '10%'}
                ]
            };
            if (opt == 6) {
                Dept.query({opt: 12}, function (resp) {
                    $scope.depts = resp.depts;
                    if (resp.depts.length > 0) {
                        $scope.dept = resp.depts[0];
                        options.params.dept_id = $scope.dept.id;
                        $scope.tableReload();
                    }
                });
            }
            init(opt, options);
        };

        $scope.show = function (mission) {
            dialogs.create('pages/dlg/mission/temp/show_dlg.html', 'MissionShowDlgCtrl', {
                    id: mission.id,
                    ForSubmit: mission.forSubmit,
                    ForHistory: true
                },
                {size: 'lg'}).result.then(function (params) {
                switch (params.opt) {
                    case 4:
                        $scope.submit(mission);
                        break;
                }
            });
        };

        $scope.clearFilters = function () {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        };

        $scope.submit = function (mission) {
            dialogs.create('templates/mission/submit_dlg.html', 'MissionSubmitDlgCtrl', {},
                {size: 'md'}).result.then(function (pa) {
                params = pa;
                params['mission_id'] = mission.id;
                params['state_id'] = mission.state.id;
                MissionReport.save(params).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success('任务进度提交成功');
                                $scope.tableParams.reload();
                                break;
                            case 1:
                                toaster.warning('任务状态错误!');
                        }
                    }, function () {
                        toaster.error('任务进度提交失败!');
                    }
                )
            });
        };
        $scope.delete = function (mission) {
            dialogs.confirm('删除任务', '确定要删除<strong>' + mission.name + '</strong>吗?')
                .result.then(function () {
                Mission.delete({id: mission.id}).$promise.then(function (resp) {
                    $scope.tableParams.reload();
                }, function () {
                    toaster.error('删除失败!');
                });
            });
        };
        $scope.state = function (mission) {
            dialogs.create('templates/mission/state_dlg.html', 'MissionStateDlgCtrl', {
                    stateId: mission.state.id,
                    missionId: mission.id,
                    forApplicant: mission.forApplicant
                },
                {size: 'md'}).result.then(function (pa) {
                switch (pa.opt) {
                    case 1 :
                        $scope.delete(mission);
                        break;
                    case 4 :
                        Mission.update({id: mission.id}, {
                            opt: 4,
                            state_id: pa.mission.state.id
                        }).$promise.then(function (resp) {
                            switch (resp.result) {
                                case 0 :
                                    toaster.success('任务状态修改成功');
                                    $scope.tableParams.reload();
                                    $rootScope.$broadcast('missionStateChange');
                                    break;
                                case 1 :
                                    toaster.error('任务已到期,请为任务延期');
                                    break;
                            }
                        }, function () {
                            toaster.error('任务状态修改出错');
                        });
                        break;
                    case 5 :
                        Mission.update({id: mission.id}, {
                            opt: 5,
                            delay: pa.mission.delay
                        }).$promise.then(function (resp) {
                            switch (resp.result) {
                                case 0 :
                                    toaster.success('任务延期成功');
                                    $scope.tableParams.reload();
                                    $rootScope.$broadcast('missionStateChange');
                                    break;
                            }
                        }, function () {
                            toaster.error('任务延期失败');
                        });
                        break;
                    case 12 :
                        Mission.update({id: mission.id}, {
                            opt: 12,
                            publish_id: pa.publish_id,
                            coworkers: pa.coworkers
                        }).$promise.then(function (resp) {
                            switch (resp.result) {
                                case 0 :
                                    toaster.success('任务参与人修改成功');
                                    $scope.tableParams.reload();
                                    $rootScope.$broadcast('missionStateChange');
                                    break;
                            }
                        }, function () {
                            toaster.error('任务参与人修改出错!');
                        });
                        break;
                }
            });
        };
        $scope.history = function (mission) {
            dialogs.create('templates/mission/history_dlg.html', 'MissionHistoryDlgCtrl', {
                    id: mission.id,
                    publish_id: mission.publish.id,
                    applicant_id: mission.applicant_id
                },
                {size: 'lg'});
        };
        $scope.deptSelectedFn = function ($index) {
            $scope.dept = $scope.depts[$index];
            $scope.tableParams.$params.page = 1;
            $scope.tableParams.reload();
        };

        $scope.export = function () {
            Api.exportDR(C.URL.MISSION_EXPORT, "任务统计");
        };

    });

angular.module('c.c').controller('ParticipantTipsCtrl',
    function ($scope, $interval) {
        var coworkers = $scope.mission.coworkers;
        var n = Math.ceil(coworkers.length / 20);
        var i = 0;

        $scope.coworkers = coworkers.slice(i * 20, (i + 1) * 20);

        if (n > 1) {
            $scope.count = n;
            $scope.page = 1;
            var intervalPromise = $interval(function () {
                i++;
                if (i >= n) {
                    i = 0;
                }
                $scope.page = i + 1;
                $scope.coworkers = coworkers.slice(i * 20, (i + 1) * 20);
                if ($scope.coworkers.length < 20) {
                    var k = 20 - $scope.coworkers.length;
                    for (var j = 0; j < k; j++) {
                        $scope.coworkers.push({name: '?'});
                    }
                }

            }, 3000);

            $scope.$on('$destroy', function () {
                $interval.cancel(intervalPromise);
            });
        }
    });

angular.module('c.c').controller('RegularMissionApplyController',
    function ($scope, $rootScope, dialogs, $filter, $timeout, toaster, Upload
        , C, F, RegularMission, Mission, Dept, FileHelper) {

        var vm = $scope;
        vm.submit = submit;
        vm.reset = reset;
        vm.sourceSelectFn = sourceSelectFn;
        vm.deleteAttachment = deleteAttachment;
        vm.upload = upload;

        vm.$on('missionEdit', function (ev, regularMission) {
            RegularMission.get({id: regularMission.id}, function (resp) {
                var mission = resp.item;
                mission.publishers = [];
                mission.coworkers = [];
                angular.forEach(mission.participants, function (participant) {
                    if (participant.is_publish == 1) {
                        mission.publishers.push(participant.user);
                    } else {
                        mission.coworkers.push(participant.user);
                    }
                });
                mission.source = F.getItem(mission.source, F.get('mission_sources'));
                mission.start_time = parseInt(mission.start_time);
                if (mission.is_month_end == 1) {
                    mission.end_time = null;
                } else {
                    mission.end_time = parseInt(mission.end_time);
                }
                mission.is_public = mission.is_public == 1;
                mission.is_month_end = mission.is_month_end == 1;
                mission.is_start_reminded = mission.is_start_reminded == 1;
                mission.is_end_reminded = mission.is_end_reminded == 1;

                mission.id = regularMission.id;

                vm.is_edit = true;
                vm.mission = mission;
            });
        });

        function submit(form, mission) {
            if (form.$valid) {
                if (mission.publishers.length == 0) {
                    toaster.warning('请填写任务负责人');
                } else if (!mission.is_month_end && parseInt(mission.start_time) >= parseInt(mission.end_time)) {
                    toaster.warning('任务开始不能大于等于结束日期');
                } else if (mission.content == "") {
                    toaster.warning('内容不能为空!');
                } else {
                    for (var i = 0; i < mission.attachments.length; i++) {
                        if (mission.attachments[i].filename == null) {
                            toaster.warning('请等一小会儿,部分附件还在路上');
                            return;
                        }
                    }
                    var params = {};
                    params['name'] = mission.name;
                    params['source'] = mission.source.id;
                    params['content'] = mission.content;
                    params['dept_id'] = mission.dept.id;

                    params['start_time'] = parseInt(mission.start_time);
                    params['end_time'] = parseInt(mission.end_time);

                    params['publishers'] = [];
                    angular.forEach(mission.publishers, function (publisher) {
                        params['publishers'].push(publisher.id);
                    });
                    params['coworkers'] = [];
                    angular.forEach(mission.coworkers, function (coworker) {
                        params['coworkers'].push(coworker.id);
                    });
                    angular.forEach(params['publishers'], function (publisher_id) {
                        var index = F.indexOf(publisher_id, params['coworkers']);
                        if (index >= 0) {
                            params['coworkers'].splice(index, 1);
                        }
                    });

                    params['is_public'] = mission.is_public ? '1' : '0';
                    params['is_month_end'] = mission.is_month_end ? '1' : '0';
                    params['is_start_reminded'] = mission.is_start_reminded ? '1' : '0';
                    params['is_end_reminded'] = mission.is_end_reminded ? '1' : '0';

                    params['attachments'] = [];
                    angular.forEach(mission.attachments, function (attachment) {
                        params['attachments'].push({
                            name: attachment.name, mime: attachment.mime,
                            filename: attachment.filename, size: attachment.size
                        });
                    });
                    if(vm.is_edit){
                        params.opt = 2/* REGULAR_MISSION.EDIT_REGULAR_MISSION */;
                        RegularMission.update({id: mission.id}, params).$promise.then(function (resp) {
                            toaster.success('任务修改成功!');
                            vm.reset();
                            vm.tabs['regular_manage'] = true;
                        }, function () {
                            toaster.error('任务修改失败了!');
                        });
                    }else{
                        RegularMission.save(params).$promise.then(function (resp) {
                            toaster.success('任务申请成功!');
                            vm.reset();
                            vm.tabs['regular_manage'] = true;
                        }, function () {
                            toaster.error('任务申请失败了!');
                        });
                    }
                }
            } else {
                toaster.warning('请确认表单无误!');
                vm.mission.submitted = true;
            }
        }

        function reset() {
            vm.is_edit = false;
            vm.mission = {
                is_public: true,
                attachments: [],
                coworkers: [],
                publishers: [],
                start_time: 1,
                end_time: 15,
                content: '',
                is_month_end: false,
                is_end_remind: false,
                is_start_remind: false,
                submitted: false
            };
            Dept.query({opt: 12}, function (resp) {
                vm.depts = resp.depts;
                var keep_going = true;
                angular.forEach(resp.depts, function (dept) {
                    if (keep_going) {
                        if (dept.is_main) {
                            vm.mission['dept'] = dept;
                            keep_going = false;
                        }
                    }
                });
                vm.sourceSelectFn();
            });
        }

        vm.reset();

        function sourceSelectFn() {
            Mission.query({
                dept_id: vm.mission['dept'].id,
                op: 'source'
            }, function (resp) {
                var sources = F.get('mission_sources');
                var params = [];
                angular.forEach(resp.limit, function (source) {
                    params.push(sources[source]);
                });
                vm.mission_sources = params;
                vm.mission['source'] = vm.mission_sources[0];
            });
        }

        function deleteAttachment($index, mission) {
            mission.attachments.splice($index, 1);
        }

        function upload(file, mission, e) {
            FileHelper.upload(C.URL.REGULAR_MISSION_UPLOAD, file, mission, e);
        }
    })
;

angular.module('c.c').controller('RegularMissionManageController',
    function ($scope, $timeout, $rootScope, $filter, dialogs, toaster, RegularMission, Table, F) {
        var vm = $scope;
        vm.clearFilters = clearFilters;
        vm.show = show;
        vm.edit = edit;
        vm.setStop = setStop;
        vm.remove = remove;
        vm.manageMission = manageMission;
        var sourcesOpts = F.getNgTableOpts(F.get('mission_sources'));
        var yesNoOpts = F.getNgTableOpts(F.get('yesNo'));

        vm.$on('missionSubmit', function () {
            $scope.tableParams.reload();
        });

        init();


        function init() {
            var options = {
                service: RegularMission,
                params: {opt: 1/*REGULARMISSION.INDEX_OWN_REGULAR_MISSION*/},
                sorting: {created_at: 'desc'},
                optColWidth: Table._4_BTN,
                cols: [
                    {field: "is_public", title: "是否公开", filter: {is_public: "select"}, data: yesNoOpts},
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "source", title: "来源", filter: {source: 'select'}, data: sourcesOpts},
                    {field: "dept", title: "申请科室", filter: {dept: "text"}},
                    {field: 'created_at', title: '申请时间', filter: {created_at: 'date_range'}},
                    {
                        field: "time",
                        title: "任务时间"
                    }
                ]
            };
            Table.load(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.created_at = item.created_at.substr(0, 10);
                    item.time = item.start_time + '号~';
                    if (item.is_month_end == 1) {
                        item.time += '月底';
                    } else {
                        item.time += item.end_time + '号';
                    }
                    item.source = F.getItems(item.source, F.get('mission_sources'));
                });
            });
        }

        function clearFilters() {
            $scope.tableParams.filter({});
            $scope.dateRangeFilter = {};
        }

        function show(mission) {
            dialogs.create('templates/mission/regular_show_dlg.html', 'RegularMissionShowDlgCtrl', {
                    id: mission.id
                },
                {size: 'lg'});
        }

        function remove(mission) {
            dialogs.confirm('删除规律任务', '确定要删除<strong>' + mission.name + '</strong>吗?')
                .result.then(function () {
                RegularMission.delete({id: mission.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            $scope.tableParams.reload();
                            break;
                        case 1:
                            toaster.error('已生成任务，无法删除');
                            break;
                    }
                }, function () {
                    toaster.error('删除失败!');
                });
            });
        }

        function setStop(m) {
            RegularMission.update({id: m.id}, {opt: 1, is_stop: !(m.is_stop == '1')})
                .$promise.then(function (resp) {
                m.is_stop = resp.is_stop;
            });
        }

        function edit(mission) {
            $scope.tabs['regular_apply'] = true;
            $timeout(function () {
                $rootScope.$broadcast('missionEdit', {id: mission.id});
            }, 200);
        }

        function manageMission(mission) {
            dialogs.create('templates/mission/regular_manage_dlg.html', 'RegularManageDlgCtrl', {
                regular_mission_id: mission.id
            }, {size: 'lg'});
        }
    });
(function () {
    'use strict';

    angular.module('c.c')
        .controller('MissionSearchController', MissionSearchController);

    /** @ngInject */
    function MissionSearchController($scope, $rootScope, ArrayHelper, Dlg, Table, Mission,
                                     MissionReport) {
        var vm = $scope;
        vm.show = show;
        vm.submit = submit;
        vm.statusOpts = [
            {"id": "1", "name": "未处理"},
            {"id": "2", "name": "进行中"},
            {"id": "3", "name": "正常结束"},
            {"id": "4", "name": "异常中止"}
        ];

        vm.sourcesOpts = [
            {"id": "1", "name": "主管院长"},
            {"id": "2", "name": "分管院长"},
            {"id": "3", "name": "科室任务"},
            {"id": "4", "name": "个人任务"}
        ];

        $scope.$on('missionSubmit', function () {
            vm.tableReload();
        });
        $scope.$on('missionStateChange', function () {
            vm.tableReload();
        });

        init();


        function init() {
            var options = {
                service: Mission,
                params: {op: 'Search'},
                optInFront: true,
                optColWidth: Table._3_BTN,
                cols: [
                    {
                        field: "state",
                        title: "状态",
                        filter: {state: "select"},
                        data: Table.getNgTableOpts(vm.statusOpts)
                    },
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {
                        field: "source",
                        title: "来源",
                        filter: {source: "select"},
                        data: Table.getNgTableOpts(vm.sourcesOpts)
                    },
                    {
                        field: "start_time",
                        title: "任务时间",
                        filter: {start_time: "date_range"},
                        width: Table._5_CHAR
                    },
                    {field: "dept", title: "申请科室", filter: {dept: "text"}, width: Table._4_CHAR},
                    {field: "applicant", title: "申请人", filter: {applicant: "text"}, width: Table._3_CHAR},
                    {field: "publish", title: "负责人", filter: {publish: "text"}, width: Table._3_CHAR}
                ]
            };
            Table.load(vm, options, function (resp) {
                var userId = resp.userid;
                angular.forEach(resp.items, function (item) {
                    item.forSubmit = false;
                    item.time_range = item.start_time.substr(0, 10) + ' - ' + item.end_time.substr(0, 10);
                    if (item.state) {
                        item.state = ArrayHelper.getItem(item.state, vm.statusOpts);
                    } else {
                        item.state = {name: '错误任务'};
                    }
                    if (item.source) {
                        item.source = ArrayHelper.getItem(item.source, vm.sourcesOpts);
                    } else {
                        item.source = {name: '错误来源'};
                    }
                    if (item.publish_id == userId || item.applicant_id == userId) {
                        item.forSubmit = true;
                    }
                    angular.forEach(item.coworkers, function (coworker) {
                        if (coworker != null && coworker.id == userId) {
                            item.forSubmit = true;
                        }
                    });
                    item.forHistory = item.forSubmit;
                    if (item.applicant_id != null && item.applicant_id == userId) {
                        item.forHistory = true;
                    }
                    if (item.state.id != 2) {
                        item.forSubmit = false;
                    }
                });
            });
        }

        function show(m) {
            Dlg.show({
                template: 'pages/dlg/mission/temp/show_dlg.html',
                ctrl: 'MissionShowDlgCtrl',
                data: {
                    id: m.id,
                    ForSubmit: m.forSubmit,
                    ForHistory: m.forHistory
                },
                size: 'lg'
            }).then(function (resp) {
                switch (resp.opt) {
                    case 4:
                        vm.submit(m);
                        break;
                }
            });
        }

        function submit(m) {
            Dlg.show({
                template: 'templates/mission/submit_dlg.html',
                ctrl: 'MissionSubmitDlgCtrl'
            }).then(function (resp) {
                vm.tableReload();
                // params = pa;
                // params['mission_id'] = mission.id;
                // params['state_id'] = mission.state.id;
                // MissionReport.save(params).$promise.then(
                //     function (resp) {
                //         switch (resp.result) {
                //             case 0:
                //                 toaster.success('任务进度提交成功');
                //                 $scope.tableParams.reload();
                //                 break;
                //             case 1:
                //                 toaster.warning('任务状态错误!');
                //         }
                //     }, function () {
                //         toaster.error('任务进度提交失败!');
                //     }
                // )
            });
        }
    }

})();


// angular.module('c.c').controller('MissionSearchController',
//     function ($scope, $timeout, $rootScope, $filter, dialogs, toaster, Mission, NgTableParams, F, MissionReport) {
//         $scope.$on('missionSubmit', function () {
//             $scope.tableParams.reload();
//         });
//         $scope.$on('missionStateChange', function () {
//             $scope.tableParams.reload();
//         });
//         var statusOpts = F.getNgTableOpts(F.get('handle_states'));
//         var sourcesOpts = F.getNgTableOpts(F.get('mission_sources'));
//         $scope.cols = [
//             {title: '状态', filter: {state: 'select'}, data: statusOpts, width: '10%', show: true},
//             {title: '名称', filter: {name: 'text'}, width: '15%', show: true},
//             {title: '来源', sortable: 'source', filter: {source: 'select'}, data: sourcesOpts, width: '10%', show: true},
//             {title: '任务时间', sortable: 'start_time', filter: {start_time: 'date_range'}, width: '25%', show: true},
//             {title: '申请科室', sortable: 'dept_id', filter: {dept: 'text'}, width: '10%', show: true},
//             {title: '申请人', filter: {applicant: 'text'}, show: true, width: '10%'},
//             {title: '负责人', filter: {publish: 'text'}, show: true, width: '10%'}
//         ];
//
//         $scope.dateRangeFilter = {};
//         $scope.$watch('dateRangeFilter',
//             function (newValue, oldValue) {
//                 $scope.tableParams.reload();
//             }, true);
//
//         $scope.optColWidth = 53;
//         $scope.tableParams = new NgTableParams({
//             page: 1, count: 10, sorting: {
//                 start_time: 'desc'
//             }
//         }, {
//             counts: [10, 30, 50], total: 0,
//             getData: function ($defer, params) {
//                 var url = params.url();
//                 url['opt'] = 2;
//                 if ($scope.dateRangeFilter.start_time != null) {
//                     url['startDate'] = $filter('date')($scope.dateRangeFilter.start_time.startDate, 'yyyy-MM-dd');
//                     url['endDate'] = $filter('date')($scope.dateRangeFilter.start_time.endDate, 'yyyy-MM-dd');
//                 }
//                 Mission.query(url, function (resp) {
//                     params.total(resp.total);
//                     userid = resp.userid;
//                     angular.forEach(resp.missions, function (mission) {
//                         mission.forSubmit = false;
//                         mission.time_range = mission.start_time.substr(0, 10) + ' - ' + mission.end_time.substr(0, 10);
//                         console.log('m',mission);
//                         if (mission.state) {
//                             mission.state = F.getItem(mission.state, F.get('handle_states'));
//                         } else {
//                             mission.state = {name: '错误任务'};
//                         }
//                         if (mission.source) {
//                             mission.source = F.getItem(mission.source, F.get('mission_sources'));
//                         } else {
//                             mission.source = {name: '错误来源'};
//                         }
//                         if (mission.publish_id == userid || mission.applicant_id == userid) {
//                             mission.forSubmit = true;
//                         }
//                         angular.forEach(mission.coworkers, function (coworker) {
//                             if (coworker != null && coworker.id == userid) {
//                                 mission.forSubmit = true;
//                             }
//                         });
//                         mission.forHistory = mission.forSubmit;
//                         if (mission.applicant_id != null && mission.applicant_id == userid) {
//                             mission.forHistory = true;
//                         }
//                         if (mission.state.id != 2) {
//                             mission.forSubmit = false;
//                         }
//                     });
//                     $defer.resolve(resp.missions);
//                     $scope.missions = resp.missions;
//                 });
//             }
//         });
//
//         $scope.clearFilters = function () {
//             $scope.tableParams.filter({});
//             $scope.dateRangeFilter = {};
//         };
//
//         $scope.show = function (mission) {
//             dialogs.create('templates/mission/show_dlg.html', 'MissionShowDlgCtrl', {
//                     id: mission.id,
//                     ForSubmit: mission.forSubmit,
//                     ForHistory: mission.forHistory
//                 },
//                 { size: 'lg'}).result.then(function (params) {
//                 switch (params.opt) {
//                     case 4:
//                         $scope.submit(mission);
//                         break;
//                 }
//             });
//         };
//
//         $scope.submit = function (mission) {
//             dialogs.create('templates/mission/submit_dlg.html', 'MissionSubmitDlgCtrl', {},
//                 { size: 'md'}).result.then(function (pa) {
//                 params = pa;
//                 params['mission_id'] = mission.id;
//                 params['state_id'] = mission.state.id;
//                 MissionReport.save(params).$promise.then(
//                     function (resp) {
//                         switch (resp.result) {
//                             case 0:
//                                 toaster.success('任务进度提交成功');
//                                 $scope.tableParams.reload();
//                                 break;
//                             case 1:
//                                 toaster.warning('任务状态错误!');
//                         }
//                     }, function () {
//                         toaster.error('任务进度提交失败!');
//                     }
//                 )
//             });
//         };
//
//     });
(function () {
    'use strict';

    angular.module('c').controller('UserPhotoDlgCtrl', UserPhotoDlgCtrl);

    /** @ngInject */
    function UserPhotoDlgCtrl($uibModalInstance, $q, Upload, NewUser, data, Dlg) {
        var vm = this;
        vm.m = {croppedDataUrl: ''};
        vm.upload = upload;
        vm.cancel = $uibModalInstance.dismiss;

        function upload(m) {
            var defer = $q.defer();

            var croppedFile = Upload.dataUrltoBlob(m.croppedDataUrl);
            croppedFile.name = "avatar.png";

            $q.all([
                Upload.upload({url: NewUser.urls.API + '/' + data.id + '/photo', data: {file: croppedFile}}),
                Upload.upload({url: NewUser.urls.API + '/' + data.id + '/work_photo', data: {file: m.imgFile}})
            ]).then(function (respArr) {
                Dlg.s('头像及工作照保存成功');
                $uibModalInstance.close([respArr[0].data.item.photo, respArr[1].data.item.work_photo]);
            }, function (error) {
                Dlg.e(error.data.msg)
            }).finally(function () {
                defer.resolve();
            });

            return defer.promise;
        }
    }

})();

(function () {
    'use strict';

    angular.module('c.c')
        .controller('SmsHistoryController', SmsHistoryController);

    /** @ngInject */
    function SmsHistoryController($scope, $rootScope, $timeout, $filter, dialogs, toaster,
                                  UIHelper, NgTableParams, F, Sms) {
        var successOrNotOpts = F.getNgTableOpts(F.get('successOrNot'));

        UIHelper.loadTab($scope, 'history');

        $scope.cols = [

            {title: '收件人', filter: {recipient: 'text'}, field: 'recipients', width: '15%', show: true},
            {title: '内容', filter: {content: 'text'}, field: 'content', show: true},
            {
                title: '状态',
                field: 'result_info',
                width: '10%',
                filter: {result_info: 'select'},
                data: successOrNotOpts,
                show: true
            },
            {
                title: '时间', sortable: 'updated_at', filter: {updated_at: 'date_range'}, field: 'updated_at',
                width: '20%', show: true
            },
        ];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                updated_at: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                if ($scope.dateRangeFilter.updated_at != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.updated_at.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.updated_at.endDate, 'yyyy-MM-dd');
                }
                Sms.history(url, function (resp) {
                    params.total(resp.total);
                    $defer.resolve(resp.sms);
                    $scope.sms = resp.sms;
                }, function () {

                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.header = {checkAll: false};
        $scope.checkOneFn = function (sm, sms) {
            if (sm.is_checked) {
                $scope.header.checkAll = true;
            } else {
                var allUnchecked = true;
                for (var i = 0; i < sms.length; i++) {
                    if (sms[i].is_checked) {
                        allUnchecked = false;
                        break;
                    }
                }
                if (allUnchecked) {
                    $scope.header.checkAll = false;
                }
            }
        };

        $scope.checkAllFn = function (checkAll, sms) {
            if (checkAll) {
                angular.forEach(sms, function (sm) {
                    sm.is_checked = true;
                })
            } else {
                angular.forEach(sms, function (sm) {
                    sm.is_checked = false;
                })
            }
        };

        $scope.show = function (sm) {
            dialogs.create('templates/sms/show_dlg.html', 'SmsShowDlgCtrl', {sms: sm, is_outbox: true},
                {size: 'md'}).result.then(function (params) {
                switch (params.opt) {
                    case 5:     //再次编辑
                        UIHelper.tabTo('send', params.sms);
                        break;
                }
            });
        };

        $scope.delete = function (data) {
            dialogs.confirm('删除短信记录', '确定要删除短信记录吗?')
                .result.then(function () {
                var sms = [];
                if (angular.isArray(data)) {
                    angular.forEach(data, function (sm) {
                        if (sm.is_checked) {
                            sms.push(sm.id);
                        }
                    });
                } else {
                    sms.push(data.id);
                }
                Sms.remove({sms: sms},
                    function () {
                        toaster.success('短信记录删除成功!');
                        $scope.tableReload();
                    },
                    function () {
                        toaster.error('短信记录删除失败!');
                    }
                );
            });
        }
    }

})();

angular.module('c.c').controller('SmsSendController',
    function ($rootScope, $scope, UIHelper, Auth, dialogs, toaster, F, User, Sms) {
        $scope.$on('missionSms', function (ev, sms) {
            $scope.sms['recipients'] = sms;
        });

        UIHelper.loadTab($scope, 'send', function (sms) {
            var content = sms.content.substr(sms.sign.length, sms.content.length - sms.sign.length);
            var sign = sms.sign.substr(1, sms.sign.length - 2);
            $scope.sms = {sign: sign, content: content, recipients: sms.recipients};
        });

        User.query({opt: 7}, function (resp) {
            $scope.existMembers = resp.users;
        });

        var account = Auth.getAccount();

        $scope.mustKnow = function () {
            dialogs.create('templates/sms/must_know_dlg.html', 'SimpleDlgCtrl', {},
                { size: 'lg'});
        };

        $scope.send = function (sms) {
            if (sms.sign == null || sms.sign == "") {
                toaster.warning('短信签名不能为空!');
            } else if (sms.recipients == null || sms.recipients.length == 0) {
                toaster.warning('请填写收件人!');
            } else if (sms.content == null || sms.content.length == 0) {
                toaster.warning('短信内容不能为空!');
            } else {
                var params = {};
                params['sign'] = '【成都上锦南府医院】';
                params['content'] = sms.content;
                // params['content'] += '(' + account.name + account.phone + ')';
                params['recipients'] = [];
                angular.forEach(sms.recipients, function (recipient) {
                    params['recipients'].push(recipient.id);
                });

                Sms.send(params, function (success) {
                    toaster.success('短信请求成功!');
                    //F.setSmsSign(sms.sign);
                    $scope.reset();
                    $rootScope.$broadcast('smsSend');
                }, function (resp) {
                    toaster.error('短信请求失败!');
                });
            }
        };

        $scope.reset = function () {
            $scope.sms = {recipients: [], sign: account.name};
        };

        $scope.reset();
    });
/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
(function () {
    'use strict';

    angular.module('email', []);
    angular.module('c').requires.push('email');
})();

(function () {
    'use strict';

    angular.module('email')
        .controller('EmailCtrl', EmailCtrl)
        .controller('InboxController', InboxController)
        .controller('OutboxController', OutboxController)
        .controller('RecipientsTipsCtrl', RecipientsTipsCtrl)
        .controller('WritEmailCtrl', WritEmailCtrl);

    function EmailCtrl($scope, $stateParams, $timeout, UIHelper, Dlg, Email) {
        UIHelper.loadTabs($scope, $stateParams);

        $timeout(function () {
            Email.query({opt: 5}, function (resp) {
                if (resp.overflow) {
                    Dlg.notify('邮箱快被撑爆了,请清理邮箱内有附件的邮件!');
                }
            });
        }, 300);
    }

    function InboxController($rootScope, $scope, $timeout, $filter, dialogs, toaster,
                             NgTableParams, C, F, UIHelper, Table, Email) {
        $scope.$on('mail.send', function (event, data) {
            $scope.tableParams.reload();
        });

        $scope.$on(C.P + 'mail.withdraw', function (event, data) {
            var mail = data.data.mail;

            var mail = F.getItem(mail.id, $scope.mails);
            if (mail) {
                mail.withdraw = '1';
            }
        });

        $scope.$on('mailRead', function (event, data) {
            var mail = F.getItem(data, $scope.mails);
            if (mail) {
                mail.is_read = '1';
            }
        });

        $scope.$on('mailDel', function (event, data) {
            $scope.tableParams.reload();
        });

        Table.loadMultiSelectedFn($scope);

        var readStatusOpts = F.getNgTableOpts(F.get('readOrUnread'));
        var emailLvs = F.get('email_lvs');
        var emailLvOpts = F.getNgTableOpts(emailLvs);

        $scope.cols = [
            {
                title: '状态',
                filter: {is_read: 'select'},
                data: readStatusOpts,
                field: 'is_read',
                width: '10%',
                show: true
            },
            {title: '发件人', filter: {sender: 'text'}, field: 'sender_id', width: '15%', show: true},
            {title: '主题', filter: {subject: 'text'}, field: 'subject', show: true},
            {
                title: '重要性',
                sortable: 'level',
                filter: {level: 'select'},
                data: emailLvOpts,
                field: 'level',
                width: '10%',
                show: true
            },
            {
                title: '时间',
                sortable: 'created_at',
                filter: {created_at: 'date_range'},
                field: 'created_at',
                width: '20%',
                show: true
            }
        ];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                created_at: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 3;
                if ($scope.dateRangeFilter.created_at != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
                }
                Table.query(Email, url, $defer, params, 'mails', function (resp) {
                    angular.forEach(resp.mails, function (mail) {
                        mail.level = F.getItem(mail.level, emailLvs);
                    });
                    $scope.mails = resp.mails;
                });
            }
        });

        $scope.sortByAttachmentSize = function () {
            $scope.tableParams.sorting({size: 'desc'});
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        $scope.show = function (mail) {
            if (mail.withdraw == 1) {
                dialogs.notify('确认', '该邮件已经被发送者撤回');
                return;
            }

            dialogs.create(C.V + 'email/show_dlg.html', 'MailShowDlgCtrl', {mail: mail},
                {size: 'lg'}).result.then(function (params) {
                switch (params.opt) {
                    case 1:
                        UIHelper.tabTo('write', {op: 'mailReply', mail: params.mail});
                        break;
                    case 2:
                        UIHelper.tabTo('write', {op: 'mailForward', mail: params.mail});
                        break;
                    case 3:
                        Email.rm_from_inbox({mails: [params.mail.id]}).$promise.then(
                            function () {
                                $rootScope.$broadcast('mailDel', params.mail.id);
                            },
                            function () {
                                toaster.error('邮件删除失败!');
                            });
                        break;
                }
            });
        };

        $scope.delete = function (data) {
            dialogs.confirm('删除邮件', '确定要删除邮件吗?')
                .result.then(function () {
                var mails = [];
                if (angular.isArray(data)) {
                    angular.forEach(data, function (mail) {
                        if (mail.is_checked) {
                            mails.push(mail.id);
                        }
                    });
                } else {
                    mails.push(data.id);
                }
                Email.rm_from_inbox({mails: mails}).$promise.then(
                    function () {
                        toaster.success('邮件删除成功!');
                        $rootScope.$broadcast('mailDel');
                    },
                    function () {
                        toaster.error('邮件删除失败!');
                    }
                );
            });
        }
    }

    /** @ngInject */
    function OutboxController($scope, UIHelper, $filter, dialogs, toaster, NgTableParams, C, F, Table, Email) {
        $scope.$on(C.P + 'mail.read', function (event, data) {
            var mail = data.data.mail;
            if ($scope.account.id == mail.sender_id) {
                var mails = $scope.mails;
                for (var i = 0; i < mails.length; i++) {
                    if (mails[i].id == mail.id) {
                        var recipients = mails[i].recipients;
                        for (var j = 0; j < recipients.length; j++) {
                            if (recipients[j].id == mail.reader_id) {
                                recipients[j].is_read = true;
                            }
                        }
                    }
                }
            }
        });

        $scope.$on('mailSend', function (event, data) {
            $scope.tableParams.reload();
        });

        var undoOrNotOpts = F.getNgTableOpts(F.get('undoOrNot'));
        var emailLvs = F.get('email_lvs');
        var emailLvOpts = F.getNgTableOpts(emailLvs);
        $scope.cols = [
            {
                title: '状态',
                filter: {withdraw: 'select'},
                data: undoOrNotOpts,
                field: 'withdraw',
                width: '10%',
                show: true
            },
            {title: '收件人', filter: {recipient: 'text'}, field: 'recipients', width: '15%', show: true},
            {title: '主题', filter: {subject: 'text'}, field: 'subject', show: true},
            {
                title: '重要性', sortable: 'level', filter: {level: 'select'}, data: emailLvOpts, field: 'level',
                width: '10%', show: true
            },
            {
                title: '时间', sortable: 'created_at', filter: {created_at: 'date_range'}, field: 'created_at',
                width: '20%', show: true
            }
        ];

        $scope.dateRangeFilter = {};
        $scope.$watch('dateRangeFilter',
            function (newValue, oldValue) {
                $scope.tableParams.reload();
            }, true);

        $scope.tableParams = new NgTableParams({
            page: 1, count: 10, sorting: {
                created_at: 'desc'
            }
        }, {
            counts: [10, 30, 50], total: 0,
            getData: function ($defer, params) {
                var url = params.url();
                url['opt'] = 2;
                if ($scope.dateRangeFilter.created_at != null) {
                    url['startDate'] = $filter('date')($scope.dateRangeFilter.created_at.startDate, 'yyyy-MM-dd');
                    url['endDate'] = $filter('date')($scope.dateRangeFilter.created_at.endDate, 'yyyy-MM-dd');
                }
                Table.query(Email, url, $defer, params, 'mails', function (resp) {
                    $scope.users = resp.users;
                    angular.forEach(resp.mails, function (mail) {
                        mail.level = F.getItem(mail.level, emailLvs);
                    });
                    $scope.mails = resp.mails;
                });
            }
        });

        $scope.tableReload = function () {
            $scope.tableParams.reload();
        };

        $scope.sortByAttachmentSize = function () {
            $scope.tableParams.sorting({size: 'desc'});
            $scope.tableParams.reload();
        };

        $scope.clearFilters = function () {
            $scope.dateRangeFilter = {};
            $scope.tableParams.filter({});
        };

        Table.loadMultiSelectedFn($scope);

        $scope.show = function (mail) {
            dialogs.create(C.V + 'email/show_dlg.html', 'MailShowDlgCtrl', {mail: mail, is_outbox: true},
                {size: 'lg'}).result.then(function (params) {
                switch (params.opt) {
                    case 2:     //转发
                        UIHelper.tabTo('write', {op: 'mailForward', mail: params.mail});
                        break;
                    case 3:     //删除
                        Email.rm_from_outbox({mails: [params.mail.id]});
                        $scope.tableParams.reload();
                        break;
                    case 4:     //撤回
                        $scope.tableParams.reload();
                        break;
                    case 5:     //再次编辑
                        UIHelper.tabTo('write', {op: 'mailEdit', mail: params.mail});
                        break;
                }
            });
        };

        $scope.delete = function (data) {
            dialogs.confirm('删除邮件', '确定要删除邮件吗?')
                .result.then(function () {
                var mails = [];
                if (angular.isArray(data)) {
                    angular.forEach(data, function (mail) {
                        if (mail.is_checked) {
                            mails.push(mail.id);
                        }
                    });
                } else {
                    mails.push(data.id);
                }
                Email.rm_from_outbox({mails: mails}).$promise.then(
                    function () {
                        toaster.success('邮件删除成功!');
                        $scope.tableParams.reload();
                    },
                    function () {
                        toaster.error('邮件删除失败!');
                    }
                );
            });
        }
    }

    function RecipientsTipsCtrl($scope, $interval) {
        var recipients = $scope.mail.recipients;
        var n = Math.ceil(recipients.length / 20);
        var i = 0;

        $scope.recipients = recipients.slice(i * 20, (i + 1) * 20);

        if (n > 1) {
            $scope.count = n;
            $scope.page = 1;
            var intervalPromise = $interval(function () {
                i++;
                if (i >= n) {
                    i = 0;
                }
                $scope.page = i + 1;
                $scope.recipients = recipients.slice(i * 20, (i + 1) * 20);
                if ($scope.recipients.length < 20) {
                    var k = 20 - $scope.recipients.length;
                    for (var j = 0; j < k; j++) {
                        $scope.recipients.push({name: '?'});
                    }
                }

            }, 3000);

            $scope.$on('$destroy', function () {
                $interval.cancel(intervalPromise);
            });
        }
    }

    /** @ngInject */
    function WritEmailCtrl(UIHelper, $scope, Dlg, C, ArrayHelper, Sms, Email, FileHelper) {
        var vm = $scope;

        vm.levels = ArrayHelper.get('email_lvs');
        vm.reset = reset;
        vm.deleteAttachment = deleteAttachment;
        vm.upload = upload;
        vm.send = send;

        init();


        function init() {
            UIHelper.loadTab($scope, 'write', loadMailAccordingToOp);

            if (UIHelper.hasTabExtra()) {
                loadMailAccordingToOp(UIHelper.getTabExtra());
            } else {
                reset();
            }
        }

        function loadMailAccordingToOp(data) {
            if (!data || !data.mail) return;
            var op = data.op;
            var mail = data.mail;
            mail.with_wx = true;
            switch (op) {
                case 'mailReply':
                    loadMail(mail, true);
                    break;
                case 'mailForward':
                    loadMail(mail, false);
                    break;
                case 'mailEdit':
                    $scope.mail = mail;
                    break;
            }
            return true;
        }


        function deleteAttachment($index, mail) {
            mail.attachments.splice($index, 1);
        }

        function upload(file, mail, e) {
            FileHelper.upload(C.URL.MAIL_UPLOAD, file, mail, e);
        }

        function send(mail) {
            if (!mail.subject) {
                Dlg.w('邮件主题不能为空!');
            } else if (!mail.recipients || mail.recipients.length === 0) {
                Dlg.w('请填写收件人!');
            } else if (!FileHelper.isAttachmentsUploaded(mail)) {
                Dlg.w('请等一小会儿,部分附件还在路上');
            } else {
                var params = {with_wx: mail.with_wx};
                params['subject'] = mail.subject;
                params['level'] = mail.level.id;
                params['body'] = mail.body;
                params['attachments'] = [];
                params['size'] = 0;
                angular.forEach(mail.attachments, function (attachment) {
                    params['attachments'].push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                    params['size'] += attachment.size;
                });

                params['recipients'] = [];
                angular.forEach(mail.recipients, function (recipient) {
                    params['recipients'].push(recipient.id);
                });

                Email.save(params).$promise.then(function () {
                    Dlg.s('邮件发送成功!');
                    $scope.reset();
                    UIHelper.tabTo('outbox');

                    if (mail.with_sms) {
                        var pa = {};
                        pa['sign'] = '【成都上锦南府医院】';
                        pa['content'] = '请查收邮件《' + params['subject'] + '》';
                        pa['content'] += '(' + $scope.account.name + $scope.account.phone + ')';
                        pa['recipients'] = params['recipients'];
                        Sms.send(pa, function () {
                            Dlg.s('短信请求成功!');
                        }, function () {
                            Dlg.e('短信请求失败!');
                        });
                    }

                    if (mail.attachments.length > 0) {
                        Email.query({opt: 5}, function (resp) {
                            if (resp.overflow) {
                                Dlg.notify('邮箱快被撑爆了,请前往站内邮箱清理邮件!');
                            }
                        });
                    }
                }, function () {
                    Dlg.e('邮件发送失败了!');
                });
            }
        }

        function reset() {
            $scope.mail = {level: $scope.levels[0], attachments: [], recipients: [], content: '', with_wx: true};
        }

        function loadMail(mail, is_reply) {
            var header = '<br><br><br><p><i>------------------ 原始邮件 ------------------<br>';
            header += '<strong>发件人：</strong>' + mail.sender.name + '<' + mail.sender.username + '>;<br>';
            header += '<strong>发送时间：</strong>' + mail.created_at + ';<br>';
            header += '<strong>收件人：</strong>';
            angular.forEach(mail.recipients, function (recipient) {
                header += recipient.name + '<' + recipient.username + '>;';
            });
            header += '<br>';
            header += '<strong>主题：</strong>' + mail.subject + ';<br></i></p>';

            mail.body = header + mail.body;

            if (is_reply) {  //回复
                mail.subject = "回复：" + mail.subject;
                mail.recipients = [{
                    id: mail.sender.id, name: mail.sender.name,
                    username: mail.sender.username
                }];
                mail.attachments = [];
                mail.level = $scope.levels[0];
            } else { //转发
                mail.subject = "转发：" + mail.subject;
                mail.recipients = [];
            }
            $scope.mail = mail;
        }
    }


})();
angular.module('email').controller('MailShowDlgCtrl',
    function ($rootScope, $scope, $uibModalInstance, $sce, dialogs, toaster, SaveAs, FileHelper, C, F, Email, data) {
        $scope.is_outbox = data.is_outbox;

        //$scope.mail = {subject: data.mail.subject, level: data.mail.level};
        var emailLvs = F.get('email_lvs');
        Email.get({id: data.mail.id}).$promise.then(function (resp) {
            if (data.mail.is_read != '1') {
                data.mail.is_read = '1';
                $rootScope.$broadcast('mailRead', data.mail.id);
            }
            var mail = resp.mail;
            mail.level = F.getItem(mail.level, emailLvs);
            angular.forEach(mail.attachments, function (attachment) {
                attachment.ico = F.getIconFromMime(attachment.mime);
                attachment.size = parseInt(attachment.size);
            });

            $scope.mailContent = $sce.trustAsHtml(mail.body);
            $scope.mail = mail;
        }, function () {
            toaster.pop({
                type: 'warning', title: '邮件不存在', body: '该邮件可能已被删除!', onHideCallback: function () {
                    $uibModalInstance.dismiss('cancel');
                }
            });
        });

        $scope.download = function (mail, attachment) {
            var params = {filename: attachment.filename, mime: attachment.mime};
            attachment.downloading = true;
            FileHelper.download(C.URL.MAIL_DOWNLOAD, params, function (resp) {
                attachment.downloading = false;
                var data = [resp];
                var options = {type: attachment.mime};
                SaveAs.download(data, attachment.name, options);
            }, function (error) {
                attachment.downloading = false;
                //toaster.error('服务端文件丢失，请联系管理员!');
            });
        };

        /**
         * opt: 1--reply/回复; 2--forward/转发; 3--delete/删除; 4--withdraw/撤回
         *      5--edit/再次编辑
         */

        $scope.delete = function (mail) {
            var params = {opt: 3, mail: mail};
            dialogs.confirm('删除邮件', '确定要删除邮件吗?')
                .result.then(function () {
                $uibModalInstance.close(params);
            });
        };

        $scope.withdraw = function (mail) {
            var params = {opt: 4, mail: mail};
            dialogs.confirm('撤回邮件', '确定要撤回邮件吗?')
                .result.then(function () {
                Email.withdraw({id: mail.id}).$promise.then(
                    function (resp) {
                        switch (resp.result) {
                            case 2:
                                toaster.warning('邮件已被阅读,无法撤回!');
                                break;
                            case 1:
                                toaster.warning('邮件发送已超过15天,无法撤回!');
                                break;
                            case 0:
                                toaster.success('邮件撤回成功!');
                                $uibModalInstance.close(params);
                                break;
                        }
                    },
                    function () {
                        toaster.error('邮件撤回失败!');
                    }
                );
            });
        };

        $scope.forward = function (mail) {
            var params = {opt: 2, mail: mail};
            $uibModalInstance.close(params);
        };

        $scope.reply = function (mail) {
            var params = {opt: 1, mail: mail};
            $uibModalInstance.close(params);
        };

        $scope.edit = function (mail) {
            var params = {opt: 5, mail: mail};
            $uibModalInstance.close(params);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
angular.module("c").run(["$templateCache", function($templateCache) {$templateCache.put("templates/cache/breadcrumb.html","<div class=\"col-lg-12\"><ul class=\"breadcrumb\"><li><a ui-sref=\"app.home\" ng-click=\"$root.collapseVar=0\">快捷入口</a></li><li ng-if=\"parent\"><a href=\"\">{{parent}}</a></li><li ng-if=\"current\" class=\"active\">{{current}}</li><span ng-if=\"note && !mobileMode\" class=\"active\">&ensp;&ensp;{{note}}</span><div ng-if=\"note && mobileMode\" ng-bind=\"note\" class=\"active\"></div></ul></div>");
$templateCache.put("templates/cache/footer.html","<div class=\"col-xs-12 footer\"><div>上锦南府医院©www.hxsjcd120.com</div><div>成都云慈康祥医疗科技有限公司 微信/电话：18001703558</div><a href=\"http://www.beian.miit.gov.cn\">©蜀ICP备19004947号-1</a><div ng-if=\"vc\" class=\"mt-2 font-sm text-muted font-italic\">登录次数：<strong>{{vc.loginCnt}}</strong>，访问次数：<strong>{{vc.apiCnt}}</strong>.</div></div>");
$templateCache.put("templates/cache/header.html","+<nav class=\"navbar navbar-default navbar-fixed-top\" role=\"navigation\" style=\"margin-bottom:0\"><div class=\"navbar-header\"><a class=\"navbar-toggle\" ng-click=\"header.toggleSidebar()\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></a><ul class=\"nav navbar-top-links navbar-right\"><li uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"header.openTaskD\" on-toggle=\"header.toggleTaskD()\"><a id=\"task-dropdown\" uib-dropdown-toggle=\"\"><i class=\"fa fa-tasks fa-fw\"></i> <span class=\"notify-tag bg-red\" ng-show=\"header.hasTask\" ng-class=\"{\'notify-animated\':shakePoint}\">！</span></a><div class=\"dropdown-menu header-dp dp-task\" uib-dropdown-menu=\"\" aria-labelledby=\"task-dropdown\"><i class=\"dropdown-arr\"></i><div class=\"dp-header\"><div class=\"dp-header-title\">待处理事务</div><div class=\"dp-btn-group\"><div class=\"dp-header-btn\" ng-click=\"header.reloadTask()\" promise-btn=\"\"><i class=\"fa fa-refresh fa-fw\"></i></div><div class=\"dp-header-btn\" ng-click=\"header.openTaskD=false\"><i class=\"fa fa-times fa-fw\"></i></div></div></div><div class=\"dp-list\" ng-if=\"header.taskLoading||header.tasks.length>0\" loading-container=\"header.taskLoading\" loading-icon=\"fa-cog fa-2x fa-spin\"><a ng-repeat=\"task in header.tasks track by task.type\" class=\"task-item clearfix\" ng-click=\"header.openTaskD=false;header.toTask(task,$index)\"><i class=\"fa fa-bookmark fa-fw\"></i>{{::task.name}} <span ng-if=\"task.subName\" class=\"text-muted\">[{{::task.subName}}]</span> <span ng-if=\"task.isNew\" class=\"order-tag tag-danger\">新</span> <span class=\"pull-right text-muted small\" style=\"padding-top:3px\">进入处理..</span></a></div><div class=\"dp-list\" ng-else=\"\"><div class=\"no-data\"><div><i class=\"fa fa-smile-o fa-fw\"></i>最近没有待处理事务</div></div></div></div></li><li uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"openMailD\"><a id=\"mail-dropdown\" uib-dropdown-toggle=\"\"><i class=\"fa fa-envelope-o fa-fw\"></i> <span ng-show=\"header.mails.length > 0\" class=\"notify-tag bg-orange\" ng-bind=\"header.mails.length\"></span></a><div class=\"dropdown-menu header-dp dp-mail\" uib-dropdown-menu=\"\" aria-labelledby=\"mail-dropdown\"><i class=\"dropdown-arr\"></i><div class=\"dp-header\"><div class=\"dp-header-title\">未读邮件</div><div class=\"dp-btn-group\"><div class=\"dp-header-btn\" ng-click=\"header.reloadMail()\" promise-btn=\"\"><i class=\"fa fa-refresh fa-fw\"></i></div><div class=\"dp-header-btn\" ui-sref=\"app.coop_email\" uib-tooltip=\"进入邮箱\"><i class=\"fa fa-arrow-right fa-fw\"></i></div></div></div><div class=\"dp-list\" ng-if=\"header.mailLoading||header.mails.length>0\" loading-container=\"header.mailLoading\" loading-icon=\"fa-cog fa-2x fa-spin\"><a ng-repeat=\"mail in header.mails track by mail.id\" ng-show=\"header.mails.length>0\" class=\"mail-item\" ng-click=\"header.readMail(mail,$index)\"><div class=\"mail-title\"><i class=\"fa fa-envelope-o fa-fw\"></i>{{mail.subject}}</div><div class=\"text-muted small mail-date\" am-time-ago=\"mail.created_at\"></div></a></div><div class=\"dp-list\" ng-else=\"\"><div class=\"no-data\"><div><i class=\"fa fa-smile-o fa-fw\"></i>最近没有未读邮件</div></div></div></div></li><li uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"openUserD\"><a id=\"user-dropdown\" uib-dropdown-toggle=\"\"><i class=\"fa fa-user fa-fw\"></i></a><ul class=\"dropdown-menu dp-user\" uib-dropdown-menu=\"\" aria-labelledby=\"user-dropdown\"><i class=\"dropdown-arr\"></i><li><a ui-sref=\"app.user_profile\"><i class=\"fa fa-user fa-fw\"></i>用户资料</a></li><li><a ui-sref=\"app.user_contacts\"><i class=\"fa fa-phone-square fa-fw\"></i>通讯录</a></li><li><a ng-click=\"header.blankAccount()\"><i class=\"fa fa-bank fa-fw\"></i>开票信息</a></li><li><a ui-sref=\"app.user_help\"><i class=\"fa fa-book fa-fw\"></i>帮助</a></li><li class=\"divider\"></li><li><a ng-click=\"header.logout()\"><i class=\"fa fa-sign-out fa-fw\"></i>注销</a></li></ul></li><img class=\"img-circle\" ng-if=\"header.account.photo\" style=\"margin-left:6px;margin-right:8px;cursor:pointer\" ui-sref=\"app.user_profile\" ng-src=\"{{header.account.photo}}\" width=\"36\" height=\"36\"><li class=\"dropdown hidden-sm hidden-xs\"><a class=\"dropdown-toggle\" style=\"padding-left:2px;padding-right:2px\" ui-sref=\"app.user_profile\"><span ng-bind=\"header.account.name\"></span></a></li></ul></div></nav>");
$templateCache.put("templates/cache/home.html","<div class=\"row\"><breadcrumb></breadcrumb><div class=\"col-lg-3 col-md-3 col-sm-12\"><div class=\"\"><div class=\"info-box-number\">用户中心</div><div class=\"info-box-content2\"><span class=\"info-box-text\" style=\"flex-basis: 25%\"><a href=\"/#/app/coop/email\">站内邮箱</a></span> <span class=\"info-box-text\" style=\"flex-basis: 25%\"><a href=\"/#/app/coop/sms\">短信箱</a></span> <span class=\"info-box-text\" style=\"flex-basis: 25%\"><a href=\"/#/app/user/edu\">继续教育</a></span> <span class=\"info-box-text\" style=\"flex-basis: 25%\"><a href=\"/#/app/user/help\">系统帮助</a></span></div></div><hr style=\"margin-top:12px\"></div><div class=\"col-md-3 col-lg-3 col-sm-12\"><div class=\"info-box-number\">上锦知道</div><div class=\"info-box-content2\"><span class=\"info-box-text\" style=\"flex-basis: 25%\"><a href=\"/#/app/know/work\">办事流程查询</a></span> <span class=\"info-box-text\" style=\"flex-basis: 25%\"><a href=\"/#/app/know/park\">交通服务保障</a></span> <span class=\"info-box-text\" style=\"flex-basis: 25%\"><a href=\"/#/app/know/map\">上锦地图查询</a></span> <span class=\"info-box-text\" style=\"flex-basis: 25%\"><a href=\"/#/app/know/user_info\">电话及职工信息查询</a></span></div><hr style=\"margin-top:12px\"></div><div class=\"col-md-3 col-lg-3 col-sm-12\"><div><div class=\"info-box-number\">资料查询</div><div class=\"info-box-content2\"><div class=\"info-box-text\" style=\"flex-basis: 25%\"><a href=\"/#/app/coop/contract\">合同管理</a></div><div class=\"info-box-text\" style=\"flex-basis: 25%\"><a href=\"/#/app/coop/qualification\">证书管理</a></div><div class=\"info-box-text\" style=\"flex-basis: 25%\"><a href=\"/#/app/query/equipment_doc\">设备资料</a></div><div class=\"info-box-text\" style=\"flex-basis: 25%\"><a href=\"/#/app/coop/rule\">管理手册</a></div></div></div><hr style=\"margin-top:12px\"></div><div class=\"col-md-3 col-lg-3 col-sm-12\"><div class=\"\"><div class=\"info-box-number\">协同办公</div><div class=\"info-box-content2\"><span class=\"info-box-text\" style=\"flex-basis: 25%\"><a href=\"/#/app/coop/doc\">公务文书</a></span> <span class=\"info-box-text\" style=\"flex-basis: 25%\"><a href=\"/#/app/coop/file\">文件传阅</a></span> <span class=\"info-box-text\" style=\"flex-basis: 25%\"><a href=\"/#/app/coop/mission\">任务计划</a></span> <span class=\"info-box-text\" style=\"flex-basis: 25%\"><a href=\"/#/app/coop/q\">问卷调查</a></span></div></div><hr style=\"margin-top:12px\"></div></div><div class=\"row\"><div class=\"col-md-6\"><div ng-controller=\"BulletinListCtrl\"><div class=\"home-blk-title\"><i class=\"fa fa-bullhorn fa-fw\"></i><a href=\"/#/app/coop/bulletin\">通知</a></div><a href=\"/#/app/coop/bulletin\" class=\"home-more\">更多>></a><div class=\"table-responsive home-blk-table\" style=\"min-height:563px\"><table class=\"table table-nowrap table-hover table-row-clicked no-selection\"><tr ng-repeat=\"bulletin in home.bulletins track by bulletin.id\" ng-click=\"read(bulletin)\"><td><span class=\"text-red\" ng-if=\"bulletin.recipient==null\">[new]</span> <span class=\"bulletin-subject-col\" ng-bind=\"bulletin.title\" style=\"vertical-align:top\"></span> <span ng-if=\"bulletin.attachments.length>0\" class=\"fa fa-paperclip\" style=\"vertical-align:middle\"></span> <span style=\"color:red;font-weight:bold\" ng-if=\"bulletin.top_time>bulletin.release_time&&bulletin.top_time>=home.today\">顶</span></td><td width=\"15%\"><span ng-bind=\"bulletin.updated_at|date2:\'yyyy-MM-dd\'\"></span></td><td width=\"10%\"><span ng-bind=\"bulletin.dept.name\"></span></td></tr><tr ng-if=\"home.bulletins.length==0\" height=\"160px\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ng-controller=\"NewsListCtrl\"><div class=\"home-blk-title\"><i class=\"fa fa-newspaper-o fa-fw\"></i> <a href=\"/#/app/coop/news\">信息公开</a></div><a href=\"/#/app/coop/news\" class=\"home-more\">更多>></a><div class=\"table-responsive home-blk-table\" style=\"min-height:263px\"><table class=\"table table-nowrap table-hover table-row-clicked no-selection\"><tr ng-repeat=\"n in home.ns track by n.id\" ng-click=\"read(n)\"><td><span class=\"news-subject-col\" ng-bind=\"n.title\" style=\"vertical-align:top\"></span> <span ng-if=\"n.attachments.length>0\" class=\"fa fa-paperclip\" style=\"vertical-align:middle\"></span> <span style=\"color:red;font-weight:bold\" ng-if=\"n.top_time>n.release_time&&n.top_time>=home.today\">顶</span>&nbsp;</td><td><span ng-bind=\"n.updated_at|date2:\'yyyy-MM-dd\'\"></span></td><td><span ng-bind=\"n.dept.name\"></span></td></tr><tr ng-if=\"home.ns.length==0\" height=\"160px\"><td colsps-aan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div><div class=\"col-md-6\"><div ng-controller=\"MeetingListCtrl\"><div class=\"home-blk-title\"><i class=\"fa fa-users fa-fw\"></i> <a href=\"/#/app/coop/meeting\">会议列表</a></div><a href=\"/#/app/coop/meeting\" class=\"home-more\">更多>></a><div class=\"table-responsive home-blk-table\" style=\"min-height:244px\"><table class=\"table table-nowrap table-hover table-row-clicked no-selection\"><tr ng-repeat=\"meeting in home.meetings track by meeting.id\" ng-click=\"read(meeting)\"><td><span class=\"text-red\" ng-if=\"meeting.recipient==null\">[new]</span> <span class=\"bulletin-subject-col\" ng-bind=\"meeting.name\" style=\"vertical-align:top\"></span> <span ng-if=\"meeting.attachments.length>0\" class=\"fa fa-paperclip\" style=\"vertical-align:middle\"></span></td><td><span ng-bind=\"meeting.start_time|amCalendar\"></span></td><td><span ng-bind=\"meeting.room_id!=null?meeting.room.name:meeting.place\"></span></td></tr><tr ng-if=\"home.meetings.length==0\" height=\"143px\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ng-controller=\"FileListCtrl\"><div class=\"home-blk-title\"><i class=\"fa fa-file-o fa-fw\"></i> <a href=\"/#/app/coop/file_cabinet\">下载专区</a></div><a href=\"/#/app/coop/file_cabinet\" class=\"home-more\">更多>></a><div class=\"table-responsive home-blk-table\" style=\"min-height:263px\"><table class=\"table table-nowrap table-hover table-row-clicked no-selection\"><tr ng-repeat=\"file in home.files track by file.id\" ng-click=\"download(file)\"><td><span class=\"bulletin-subject-col\" style=\"vertical-align:top\" ng-bind=\"file.name\"></span> <span class=\"text-muted\"><small>{{file.size | bytes}}</small></span></td><td><span ng-bind=\"file.updated_at|date2:\'yyyy-MM-dd\'\"></span></td><td><span ng-bind=\"file.dept.name\"></span></td></tr><tr ng-if=\"home.files.length==0\" height=\"160px\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div><div class=\"col-md-6\"><div ng-controller=\"PartySpecialListCtrl\"><div class=\"home-blk-title\"><i class=\"fa fa-users fa-fw\"></i> <a href=\"/#/app/coop/party_special?tab=search\">党建E家</a></div><a href=\"/#/app/coop/party_special?tab=search\" class=\"home-more\">更多>></a><div class=\"table-responsive home-blk-table\" style=\"min-height:263px\"><table class=\"table table-nowrap table-hover table-row-clicked no-selection\"><tr ng-repeat=\"item in home.party_specials track by item.id\" ng-click=\"read(item)\"><td><span class=\"bulletin-subject-col\" ng-bind=\"item.title\" style=\"vertical-align:top\"></span> <span ng-if=\"item.attachments.length>0\" class=\"fa fa-paperclip\" style=\"vertical-align:middle\"></span> <span style=\"color:red;font-weight:bold\" ng-if=\"item.top_time>item.release_time&&item.top_time>=home.today\">顶</span></td><td width=\"15%\"><span ng-bind=\"item.updated_at|date2:\'yyyy-MM-dd\'\"></span></td><td width=\"10%\"><span ng-bind=\"item.dept.name\"></span></td></tr><tr ng-if=\"home.party_specials.length==0\" height=\"160px\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div></div>");
$templateCache.put("templates/cache/main.html","<div id=\"wrapper\"><sidebar></sidebar><header></header><div id=\"page-wrapper\" ng-class=\"{\'page-wrapper-offset\':sidebarState===2,\'page-wrapper-offset-sm\':sidebarState===1}\"><div ui-view=\"\"><div class=\"no-data\"><div class=\"font-lg\">你好！不小心让你发现我在这里了<i class=\"fa fa-smile-o text-yellow\"></i>,这里啥也米有～请到<a ui-sref=\"app.home\">首页逛逛</a> 或 出门<a ui-sref=\"login\">左拐</a>!</div></div></div></div><footer></footer><back-top></back-top></div><div id=\"preloader\" ng-if=\"!$finishedLoading\"><div></div></div>");
$templateCache.put("templates/cache/sidebar.html","<div class=\"navbar-default sidebar\" role=\"navigation\" ng-show=\"sidebarState>0\" ng-class=\"{\'icon-only\':sidebarState===1}\"><div id=\"sidebar-nav\"><ul class=\"nav in\" slimscroll=\"{height: \'{{sidebar.menuHeight}}px\',touchScrollStep:100, position:\'left\'}\" slimscroll-watch=\"sidebar.menuHeight\"><div class=\"p-1 sidebar-search hidden-xs\" ng-if=\"sidebarState===2\"><i class=\"fa fa-search fw text-muted\"></i> <input type=\"text\" class=\"form-control input-xs\" placeholder=\"请输入菜单检索\" ng-model=\"sidebar.search\" ng-model-options=\"{ debounce: 200 }\"> <button ng-if=\"sidebar.search\" class=\"close\" ng-click=\"sidebar.search=null\">&times;</button></div><li ui-sref-active=\"active\" ng-click=\"sidebar.check(0)\" class=\"home-link\"><a ui-sref=\"app.home\"><i class=\"fa fa-home fa-fw\"></i> 首页</a></li><li ng-repeat=\"item in sidebar.menuItems\" ng-if=\"sidebar.firstLvVisible(item)\" ng-class=\"{active: collapseVar===$index+1}\"><a ng-click=\"sidebar.check($index+1)\"><i ng-class=\"[\'fa\', \'fa-\' + item.icon, \'fa-fw\']\"></i> {{::item.display_name}} <span class=\"fa arrow\"></span></a><div class=\"sub-item-wrapper\"><ul class=\"nav nav-second-level\" uib-collapse=\"sidebar.subItemCollapse($index+1)\"><li ng-repeat=\"subItem in item.children\" ui-sref-active=\"active\" ng-if=\"sidebar.secondLvVisible(subItem)\"><a ui-sref=\"{{::subItem.state.name}}\">{{::subItem.display_name}}</a></li></ul></div></li></ul></div></div>");}]);